(function(){
  'use strict';

  angular.module('wml.portal.waterhardheid', []);

})();

(function(){
  'use strict';

  angular.module('wml.portal.water-estafette', []);

})();

(function() {
  'use strict';

  angular.module('wml.portal.videoList', []);

})();

(function() {
  'use strict';

  angular.module('wml.portal.vacancy', []);

})();

(function() {
  'use strict';

  angular.module('wml.portal.usage', []);

})();

(function() {
  'use strict';

  angular.module('wml.portal.generic', []);

})();

(function() {
  'use strict';

  unavailable.$inject = ["$rootScope"];
  function unavailable($rootScope) {

    return {
      restrict  : 'EA',
      templateUrl : 'app/components/generic/directives/unavailable/views/overlay.html',
      replace     : false,
      link: function(scope, iElem, iAttrs) {
        $rootScope.unavailable = false;

        scope.$on('wml.unavailable.start', function() {
          $rootScope.unavailable = true;
        });

        scope.$on('wml.unavailable.stop', function() {
          $rootScope.unavailable = false;
        });
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('unavailable', unavailable)
})();

(function () {
  'use strict';

  angular
    .module('wml.portal', [
      'ngCookies',
      'ngSanitize',
      'restangular',
      'ui.router',
      'pascalprecht.translate',
      'ui.bootstrap',
      'ui.mask',
      'tmh.dynamicLocale',
      'iv.authentication',
      'iv.iform',
      'mm.iban',
      // 'ngAria',
      '720kb.socialshare',
      'ngAnimate',
      'duScroll',
      'ngFileUpload',
      'videosharing-embed',
      'highcharts-ng',
      'vcRecaptcha',
      'wml.portal.app-info',
      'wml.portal.authentication',
      'wml.portal.calendars',
      'wml.portal.registry',
      'wml.portal.storage',
      'wml.portal.header',
      'wml.portal.footer',
      'wml.portal.home',
      'wml.portal.listPage',
      'wml.portal.detailPage',
      'wml.portal.sideMenu',
      'wml.portal.contact',
      'wml.portal.login',
      'wml.portal.register',
      'wml.portal.signup',
      'wml.portal.customer',
      'wml.portal.profile',
      'wml.portal.message',
      'wml.portal.enum',
      'wml.portal.generic',
      'wml.portal.invoices',
      'wml.portal.faq',
      'wml.portal.usage',
      'wml.portal.paymentMethod',
      'wml.portal.correspondence',
      'wml.portal.address',
      'wml.portal.dashboard',
      'wml.portal.appointment',
      'wml.portal.meterReading',
      'wml.portal.restangular',
      'wml.portal.restBackend',
      'wml.portal.cms',
      'wml.portal.navigation',
      'wml.portal.premises',
      'wml.portal.premisesRegister',
      'wml.portal.premisesUnregister',
      'wml.portal.banners',
      'wml.portal.incidents',
      'wml.portal.contactperson',
      'wml.portal.breadcrumbs',
      'wml.portal.404',
      'wml.portal.standpipe',
      'wml.portal.vacancy',
      'wml.portal.videoList',
      'wml.portal.waterhardheid',
      'wml.portal.damage-form',
      'wml.portal.billingInformation',
      'wml.portal.account',
      'wml.portal.search',
      // 'wml.portal.routes',
      'wml.portal.news',
      'wml.portal.corporation',
      'wml.portal.carafe',
      'wml.portal.water-estafette'
    ]);
})();

(function () {
  'use strict';
  /* eslint key-spacing: 0 */
  /* eslint camelcase: 0 */
  /* eslint quote-props: 0 */
  /* eslint no-useless-escape: 0 */
  /* eslint comma-dangle: error */

  angular.module('wml.portal')
    .constant('translations_nl_NL', {
      message              : {
        http      : {
          '401': 'U heeft geen toegang tot onderdeel',
          '403': 'U heeft geen toegang tot onderdeel',
          '404': 'Dit onderdeel bestaat niet (meer)',
          '429': 'U zoekt te snel. Probeer het opnieuw over 1 seconde',
          '500': 'Er is iets misgegaan, probeer opnieuw.',
          '-1' : 'Er is iets misgegaan, probeer het later opnieuw.',
          xxx  : 'Er is iets misgegaan, probeer het later opnieuw.'
        },
        backoffice: {
          'null' : 'Er is iets misgegaan. Neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> op met de klantenservice',
          '0'    : 'Er is iets misgegaan, probeer opnieuw.',
          '1000' : 'Niet alle benodigde informatie is ingevuld.',
          '1001' : 'Niet alle ingevulde gegevens zijn geldig',
          '1002' : 'Er is iets misgegaan, uw activatie link is onjuist.',
          '1003' : 'Er is iets misgegaan, uw activatie link is onjuist.',
          '1004' : 'Deze activatielink is verlopen. Registreer opnieuw.',
          '1005' : 'Er is iets misgegaan, probeer het later opnieuw.',
          '1006' : 'Uw account is succesvol geactiveerd. Gebruik uw e-mailadres en wachtwoord om in te loggen.',
          '1007' : 'Het e-mailadres is onjuist.',
          '1008' : 'Uw e-mailadres komt niet overeen.',
          '1009' : 'Uw wachtwoord voldoet niet aan de minimale vereisten.',
          '1010' : 'Uw wachtwoord komt niet overeen.',
          '1011' : 'Er is iets misgegaan, registreer opnieuw.',
          '1012' : 'Er is iets misgegaan, registreer opnieuw.',
          '1013' : 'Binnen enkele minuten ontvangt u een e-mail met een activatielink. Klik op de activatielink in deze e-mail om uw mijnWML account te activeren. Deze activatielink is maar 24 uur geldig. <br/><br/> Let op: mocht u de e-mail niet ontvangen, controleer dan de map met ongewenste e-mail (spam).',
          '1014' : 'U kunt het wachtwoord slechts een keer per dag wijzigen.',
          '1015' : 'Uw nieuwe wachtwoord wijkt niet genoeg af van het oude wachtwoord',
          '1016' : 'Uw wachtwoord is verlopen. Vraag een nieuw wachtwoord aan.',
          '1017' : 'Kies een ander wachtwoord dit wachtwoord is niet toegestaan.',
          '1018' : 'De wachtwoorden komen niet overeen.',
          '1019' : 'Er zijn invalide tekens gebruikt in uw wachtwoord.',
          '1020' : 'Uw wachtwoord mag niet beginnen met ? of !',
          '1021' : 'Uw wachtwoord dient minimaal uit 8 tekens te bestaan.',
          '1022' : 'De eerste 3 tekens van het wachtwoord moeten verschillend zijn.',
          '1023' : 'Uw wachtwoord mag niet beginnen met uw naam.',
          '1024' : 'Uw wachtwoord mag niet gelijk zijn aan wachtwoorden die u in het verleden heeft gebruikt.',
          '1025' : 'Uw wachtwoord komt voor in de lijst van niet toegestane wachtwoorden.',
          '1026' : 'Aanmelden niet meer mogelijk. Er zijn teveel mislukte pogingen.',
          '1027' : 'Klantnummer en adres komen niet overeen.',
          '1028' : 'Er is al een mijnWML account aanwezig voor dit klantnummer.',
          '1029' : 'Uw klantnummer is al gekoppeld aan een ander mijnWML account.',
          '1030' : 'Er is al een mijnWML account aanwezig voor e-mailadres.',
          '1031' : 'Gebruiker bestaat al.',
          '1032' : 'Geen gebruiker(s) gevonden voor opgegeven e-mailadres.',
          '1033' : 'Gebruiker wordt al geactiveerd.',
          '1034' : 'Gebruikersnaam bevat ongeldige tekens.',
          '1035' : 'Gebruikersaanvraag bestaat al.',
          '1036' : 'Vul een geldige activeringscode in.',
          '1037' : 'Telefoonnummer wijzigen mislukt. Wijzigingen niet opgeslagen.',
          '1038' : 'Het wachtwoord moet uit minimaal 8 tekens bestaan.',
          '1039' : 'Het wachtwoord moet ten minste 1 cijfer (0-9) bevatten.',
          '1040' : 'Het wachtwoord moet ten minste 1 letter (A-Z, a-z) bevatten.',
          '1041' : 'Het wachtwoord moet ten minste 1 speciaal teken bevatten.',
          '1042' : 'Het wachtwoord moet ten minste 1 kleine letter (a-z) bevatten.',
          '1043' : 'Het wachtwoord moet ten minste 1 hoofdletter (A-Z) bevatten.',
          '1044' : 'Het is niet gelukt om uw account op te halen',
          '1045' : 'Deze activatielink is al eens gebruikt. Het is niet mogelijk om deze nogmaals te gebruiken.',
          '1046' : 'Helaas kunt u zich nog niet registeren voor een mijnWML account. Neem voor vragen <a href=\"/contact\" title=\"Klantenservice\">contact</a> op met onze klantenservice.',
          '2000' : 'De verplichte velden zijn niet juist ingevuld.',
          '2001' : 'Inloggen mislukt! De gebruikte combinatie van e-mailadres en wachtwoord is onjuist.',
          '2002' : 'Uw wachtwoord is hersteld. U ontvangt een e-mail met een activatielink. Klik op de activatielink om uw wachtwoord te wijzigen.',
          '2003' : 'Uw wachtwoord aanpassen is mislukt.',
          '2004' : 'Uw wachtwoord aanpassen is mislukt.',
          '2005' : 'Uw wachtwoord is gewijzigd.',
          '2006' : 'Het is niet gelukt om uw wachtwoord te resetten. Welllicht heeft u nog geen mijnWML account. Maak direct een mijnWML account aan door linksboven in het scherm op \"Registeren\" te klikken.',
          '2007' : 'Door meerdere ongeldige inlogpogingen binnen een korte periode is uw account tijdelijk geblokkeerd. Probeer het opnieuw vanaf {{time}}',
          '2008' : 'Door verdacht verkeer vanaf uw internetverbinding is deze tijdelijk geblokkeerd. Probeer het opnieuw vanaf {{time}}',
          '2009' : 'Er is iets fout gegaan bij het aanpassen van het e-mailadres. Probeer het later opnieuw.',
          '2010' : 'Er is iets fout gegaan bij het aanpassen van het e-mailadres. Probeer het later opnieuw.',
          '2011' : 'Uw account e-mailadres is succesvol bijgewerkt.',
          '2012' : 'Door meerdere ongeldige inlogpogingen binnen een korte periode is uw account tijdelijk geblokkeerd. Probeer het opnieuw vanaf {{time}}',
          '2013' : 'Dit adres kan helaas niet via mijnWML afgemeld worden. Wij vragen u <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met onze klantenservice. Wij verwerken dan uw afmelding voor dit adres.',
          '2014' : 'De gebruikte combinatie van klantnummer en adresgegevens is onjuist.',
          '2015' : 'Uw account e-mailadres en uw correspondentie e-mailadres zijn succesvol bijgewerkt. ',
          '2016' : 'Het door u ingevulde e-mailadres is ongeldig',
          '3000' : 'Momenteel kunnen er geen facturen worden opgehaald, probeer het later opnieuw.',
          '3001' : 'Momenteel kunnen er geen details van deze factuur worden opgehaald, probeer het later opnieuw.',
          '3002' : 'De verplichte velden zijn niet juist ingevuld.',
          '3003' : 'Één of meer facturen zijn al betaald.',
          '3004' : 'Één of meer invalide factuurnummers.',
          '3005' : 'Één of meer facturen niet gevonden.',
          '3006' : 'Het is niet mogelijk om meer dan 12 facturen tegelijkertijd af te rekenen.',
          '3007' : 'Het te betalen bedrag is te laag om via iDEAL af te rekenen.',
          '3008' : 'Er is iets misgegaan, het starten van de betaling is mislukt.',
          '3009' : 'Er is iets misgegaan, uw openstaand saldo kan niet worden opgehaald.',
          '4000' : 'Momenteel kunnen er geen adressen worden opgehaald, probeer het later opnieuw.',
          '5000' : 'Niet alle benodigde informatie is ingevuld.',
          '5001' : 'Er is geen adres gevonden voor de ingevulde gegevens.',
          '5002' : 'Uw postcode lijkt onjuist. Controleer of de postcode juist is ingevuld voordat u verder gaat.',
          '5003' : 'Het adres is onjuist.',
          '5004' : 'Uw adres is succesvol aangepast.',
          '5005' : 'Uw correspondentieadres mag niet gelijk zijn aan het af te melden leveringsadres.',
          '6000' : 'Er is iets misgegaan, probeer het later opnieuw.',
          '6001' : 'Niet alle benodigde informatie is ingevuld.',
          '6002' : 'Het wachtwoord mag niet langer zijn dan {{maxlength}} karakters',
          '7000' : 'Er is iets misgegaan. Probeer het opnieuw of neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> met ons op.',
          '7001' : 'Er is iets misgegaan. Probeer het opnieuw of neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> met ons op.',
          '7002' : 'Er is iets misgegaan. Probeer het opnieuw of neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> met ons op.',
          '7003' : 'Er is iets misgegaan. Probeer het opnieuw of neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> met ons op.',
          '7004' : 'Betalingsgegevens succesvol opgeslagen.',
          '8000' : 'Er is iets misgegaan. Probeer het opnieuw of neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> met ons op.',
          '8001' : 'Niet alle benodigde informatie is ingevuld.',
          '8002' : 'Er is iets misgegaan. Probeer het opnieuw of neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> met ons op.',
          '8003' : 'Er is iets misgegaan. Probeer het opnieuw of neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> met ons op.',
          '8004' : 'Termijnbedrag succesvol opgeslagen.',
          '8005' : 'Het geadviseerde termijnbedrag kan niet worden opgehaald.',
          '8006' : 'Het maximale aantal verlagingen van het termijnbedrag per jaar is bereikt.',
          '8007' : 'Het gewenste termijnbedrag valt niet binnen de gestelde grenzen.',
          '8008' : 'Pas op, uw meterstand wijkt erg veel af van de vorige opname. Controleer of u uw meterstand juist heeft ingevuld.',
          '8009' : 'Helaas kunt u uw termijnbedrag op dit moment niet wijzigen. Dit kan pas weer nadat u de jaarafrekening ontvangen heeft.',
          '9000' : 'We hebben momenteel geen data voor een afspraak beschikbaar.',
          '9001' : 'We hebben momenteel geen tijden voor een afspraak beschikbaar.',
          '9002' : 'Niet alle benodigde informatie is ingevuld.',
          '9003' : 'Ongeldige postcode.',
          '9004' : 'Er is iets misgegaan, probeer opnieuw.',
          '9005' : 'Het is niet gelukt om een afspraak te maken. Probeer het later opnieuw.',
          '9006' : 'We hebben een afspraak voor u gemaakt, hiervoor ontvangt u een e-mail met informatie.',
          '9007' : 'De capaciteit van de door u gekozen watermeter is incorrect.',
          '9008' : 'Het is niet mogelijk om afspraken binnen 24 uur in te plannen',
          '9009' : 'Er kunnen geen tijdstippen opgehaald worden omdat het metertype niet bekend is.',
          '9010' : 'Het is niet gelukt om uw afspraak te annuleren. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '10000': 'Niet alle benodigde informatie is ingevuld.',
          '10001': 'Het e-mailadres is onjuist.',
          '10002': 'Het onderwerp is onjuist.',
          '10003': 'Geen geldige klantgegevens ingevuld.',
          '10004': 'Niet alle velden zijn correct ingevuld.',
          '10005': 'Het contactformulier is succesvol verstuurd.',
          '11000': 'Niet alle benodigde informatie is ingvuld.',
          '11001': 'Ongeldige postcode.',
          '11002': 'Pas op, uw meterstand wijkt erg veel af van de vorige opname. Controleer uw meterstand, en indien juist, geef de reden van afwijking op.',
          '11003': 'De door u doorgegeven meterstand wijkt erg veel af. Controleer uw meterstand, en indien juist, geef dan de reden van afwijking op. (U kunt ook een foto toevoegen).',
          '11004': 'De door u doorgegeven meterstand wijkt erg veel af. Controleer uw meterstand, en indien juist, geef dan de reden van afwijking op. (U kunt ook een foto toevoegen).',
          '11005': 'Uw meterstand is succesvol opgeslagen.',
          '11006': 'Er is iets misgegaan met opslaan van uw meterstand.',
          '11007': 'Het door u ingevulde opnamenummer en postcode is geen geldige combinatie',
          '11008': 'Er is al een meterstand doorgegeven voor deze opnameorder.',
          '11009': 'Het opgegeven e-mailadres kon niet worden opgeslagen.',
          '11010': 'Het is niet mogelijk de meterstand door te geven. Wij vragen u vriendelijk <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met onze klantenservice.',
          '11011': 'Het is niet mogelijk de meterstand door te geven. Wij vragen u vriendelijk <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met onze klantenservice.',
          '11013': 'De toegevoegde foto is er niet meer. Dit is waarschijnlijk veroorzaakt door een pagina verversing. Voeg dit opnieuw toe indien nodig.',
          '12000': 'Niet alle verplichte velden zijn ingevuld',
          '12001': 'De ingevulde postcode is ongeldig',
          '12002': 'Niet gelukt om aanpasing aan woning door te voeren',
          '12003': 'De wijziging is succesvol doorgevoerd',
          '12004': 'Pas op, de meterstand wijkt erg veel af van de bij ons laatst bekende meterstand. Controleer uw meterstand, en indien juist, klik op volgende. (U kunt ook een foto toevoegen).',
          '12005': 'Uw correspondentieadres mag niet gelijk zijn aan het af te melden leveringsadres.',
          '12006': 'Er is iets misgegaan. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '12007': 'De door u ingevulde postcode en huisnummer komen niet overeen met de bij ons bekende gegevens.',
          '12008': 'De door u opgegeven meterstand is lager dan verwacht. Controleer uw meterstand, en indien juist, geef de reden van afwijking op.',
          '12100': 'Er is iets misgegaan. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '12101': 'Er is iets misgegaan. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '12102': 'Het bestand dat u wilt toevoegen is te groot. Dit mag maar maximaal 20MB zijn.',
          '12103': 'Er heeft zich al eerder iemand aangemeld op dit adres. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '12104': 'Er is iets misgegaan. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '12105': 'Er is iets misgegaan. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '12106': 'Er is iets misgegaan. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '12107': 'Er heeft zich al eerder iemand afgemeld op dit adres. Gelieve <a href=\"/contact\" title=\"Klantenservice\">contact</a> op te nemen met de klantenservice.',
          '13000': 'Niet alle velden zijn correct ingevuld.',
          '13001': 'De door u ingevulde postcode is ongeldig.',
          '13002': 'U dient de voorwaarden te accepteren om verder te kunnen gaan.',
          '13003': 'Ongeldig correspondentieadres type. Uw adres mag alleen een huisadres of een postbus zijn.',
          '13004': 'Selecteer het aantal personen in uw huishouden.',
          '13005': 'De door u ingevulde e-mailadressen komen niet overeen.',
          '13006': 'De door u ingevulde wachtwoorden komen niet overeen.',
          '13007': 'De door u ingevuld combinatie van betaalmethode/-termijn is ongeldig.',
          '13008': 'Er is iets misgegaan bij het verwerken van uw aanvraag. Probeer het later nog eens.',
          '13009': 'Uw aanvraag is succesvol ontvangen. Het verwerken hiervan kan tot 8 werkdagen duren.',
          '13010': 'Het is alleen mogelijk u in te schrijven als huishouden of bedrijf.',
          '13011': 'De door u ingevulde postcode en huisnummer komen niet overeen met de bij ons bekende gegevens.',
          '14000': 'Niet alle velden zijn correct ingevuld',
          '14001': 'Er is iets misgegaan bij het opslaan van de contact persoon. Probeer het later nog eens.',
          '14002': 'De contactpersoon is succesvol toegevoegd.',
          '14003': 'De contactpersoon is succesvol verwijderd.',
          '14004': 'Het is niet gelukt om de contactpersoon te verwijderen.',
          '15000': 'Niet alle benodigde informatie is ingevuld.',
          '15004': 'Niet alle verplichte informatie is ingevuld.',
          '15005': 'Bedankt voor het insturen van uw sollicitatie.',
          '16000': 'Niet alle benodigde informatie is ingevuld.',
          '16004': 'Niet alle benodigde informatie is juist ingevuld.',
          '16005': 'Bedankt voor het insturen van uw aanvraag.',
          '17000': 'Niet alle benodigde informatie is juist ingevuld.',
          '17001': 'Ongeldige postcode ingevuld.',
          '18000': 'Niet alle benodigde informatie is juist ingevuld.',
          '18001': 'Schadeformulier is succesvol verzonden.',
          '19000': 'Wij werken hard aan het verbeteren van onze diensten. Op dit moment verrichten wij onderhoudswerkzaamheden. Excuses voor het ongemak.',
          '20000': 'Niet alle benodigde informatie is ingevuld',
          '20001': 'Niet alle velden zijn correct ingevuld',
          '20002': 'Zakelijk contactformulier is succesvol verzonden.',
          '21000': 'Niet alle benodigde informatie is juist ingevuld.',
          '21001': 'Ongeldige facturatiemethode ingegeven.',
          '21002': 'Niet gelukt om de facturatiemethode aan te passen.',
          '21003': 'Niet gelukt om de facturatiemethode aan te passen.',
          '21004': 'Facturatiemethode is succesvol bijgewerkt',
          '22000': 'Ongeldig export formaat',
          '23000': 'Niet alle velden zijn correct ingevuld',
          '23001': 'Er is iets misgegaan met het opslaan van uw reactie.',
          '23002': 'Uw reactie is succesvol opgeslagen.',
          '24000': 'Niet alle velden zijn correct ingevuld',
          '24001': 'Er is iets misgegaan. Probeer het later nog eens.',
          '24002': 'Uw aanvraag is succesvol verzonden',
          '25000': 'De betaling is niet gelukt of is door U afgebroken. Probeer het nogmaals.',
          '25001': 'Bedankt voor uw betaling. Het kan enkele dagen duren tot de betaling volledig verwerkt is door WML.',
          '25002': 'Door een fout kunnen we helaas niet vaststellen wat de actuele status van uw betaling is. Neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> op met de klantenservice voor meer informatie.',
          '26000': 'Niet alle benodigde informatie is ingevuld.',
          '26001': 'Er is iets misgegaan. Probeer het later opnieuw.',
          '26002': 'Er is iets misgegaan. Probeer het later opnieuw.',
          '26003': 'Bedankt voor uw inschrijving, u bent succesvol ingeschreven.',
          '26004': 'Bedankt voor uw stem.',
          '26005': 'Er is iets misgegaan. Probeer het later opnieuw.',
          '27000': 'Deze afbeelding is helaas te groot. De maximale grootte is 20MB.',
          '27001': 'Er ging iets mis probeer het later opnieuw',
          '28000': 'Niet alle benodigde informatie is juist ingevuld.',
          '28001': 'Er is iets misgegaan. Probeer het later opnieuw.',
          '28002': 'Betalingsregeling succesvol verzonden.'
        },
        custom    : {
          '1000': 'Uw gegevens zijn succesvol aangepast.',
          '1001': 'De verplichte velden zijn niet juist ingevuld.',
          '1002': 'Inloggen mislukt! De gebruikte combinatie van e-mailadres en wachtwoord is onjuist.',
          '1003': 'Er is iets misgegaan, de afspraak kan niet worden opgehaald. Probeer het opnieuw.',
          '1004': 'Het adres kan niet worden gevonden. Neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> op met de klantenservice.',
          '1005': 'Dit adres kan helaas (nog) niet online worden aangemeld. Neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> op met de klantenservice.',
          '1006': 'Het gebruik van cookies of andere opslag mogelijkheden is door uw browser niet toegestaan. Hierdoor zijn niet alle functionaliteiten beschikbaar.'
        }
      },
      gender               : {
        male  : 'Man',
        female: 'Vrouw'
      },
      country              : {
        nl: 'Nederland',
        de: 'Duitsland',
        be: 'Belgi\u00eb'
      },
      language             : {
        nl_NL: 'Nederlands',
        en_GB: 'English'
      },
      general              : {
        or       : 'of',
        remaining: 'Overige'
      },
      footer               : {
        nav: {
          direct              : 'Direct regelen',
          meter_readings      : 'Meterstanden doorgeven',
          pay_open_account    : 'Openstaande rekening betalen',
          forward_relocation  : 'Verhuizing doorgeven',
          edit_personal_info  : 'Persoonlijke gegevens wijzigen',
          price_checker       : 'Termijnbedrag checker',
          compare_use         : 'Verbruik vergelijken',
          download_annual_bill: 'Jaarafrekening downloaden',
          questions           : 'Vragen?',
          faq                 : 'Veel gestelde vragen',
          question            : 'Stel een vraag',
          contact_form        : 'Contactformulier',
          contact             : 'Contact',
          customer_service    : 'Klantenservice',
          report_complaint    : 'Klacht melden',
          report_damage       : 'Schade melden'
        }
      },
      header               : {
        customer_number         : 'Klantnummer',
        nav                     : {
          home                      : 'Home',
          about                     : 'Over WML',
          news                      : 'Nieuws',
          private                   : 'Particulieren',
          business                  : 'Zakelijk',
          sign_up                   : 'Registreren',
          login                     : 'Inloggen mijnWML',
          logout                    : 'Uitloggen',
          dashboard                 : 'Mijn overzicht',
          customer_dashboard        : 'Mijn persoonlijke gegevens',
          my_account                : 'Mijn account',
          customer_dashboard_company: 'Mijn bedrijfsgegevens',
          customer_invoices         : 'Mijn financiële gegevens',
          customer_usage            : 'Mijn verbruik',
          account_options           : 'Wisselen van klantnummer',
          choose_address            : 'Wisselen van leveringsadres',
          change_password           : 'Wachtwoord wijzigen',
          profile                   : 'Mijn account'
        },
        actions_title           : 'Direct regelen',
        myWML_actions_title     : 'Regelen via mijnWML',
        submit_meter_reading    : 'Jaarlijkse meterstand',
        submit_meter_reading_btn: 'Volgende',
        incidents               : {
          there_are                  : 'Er zijn',
          incidents_malfunctions     : 'Er {{malfunctions_prefix}} <span class=\"dot\">{{malfunctions}}</span> <u>storing{{malfunctions_plural}}</u>. Op <span class=\"dot\">{{planned_incidents}}</span> <u> plekken zijn er werkzaamheden.</u></span>',
          malfunctions_plural        : 'en',
          incidents_planned_incidents: 'werkzaamheden',
          malfunctions_prefix_single : 'is',
          malfunctions_prefix_plural : 'zijn',
          report: 'Storing melden'
        },
        video_modal                  : {
          view_video : 'Bekijk video'
        },
        button_register         : 'Registreren mijnWML',
        button_dashboard        : 'Naar mijnWML'
      },
      home                 : {
        malfunction_title: 'Actuele storingen',
        latest_news_title: 'Ons laatste nieuws',
        responses        : 'reactie(s)',
        more             : 'Lees meer'
      },
      incidents            : {
        modal_title    : 'Meest recente storingen',
        all_incidents  : 'Bekijk alle storingen & werkzaamheden',
        no_malfunctions: 'Momenteel zijn er geen ongeplande storingen. Klik op onderstaande button om alle geplande werkzaamheden in te zien',
        no_incidents   : 'Momenteel zijn er geen bekende storingen of werkzaamheden'
      },
      login                : {
        register_text  : 'Nog geen mijnWML account? <br/> Eerst registreren, dan inloggen!',
        page_title     : 'Inloggen bij mijnWML',
        email          : 'E-mailadres',
        password       : 'Wachtwoord',
        forgot_password: 'Wachtwoord vergeten?',
        login_btn      : 'Inloggen',
        signup_btn     : 'Registreren mijnWML',
        become_customer: 'Klant worden?',
        hints          : {
          email   : 'Neem hier het e-mailadres dat u aangemaakt heeft bij uw mijnWML account',
          password: 'Het wachtwoord van uw mijnWML account'
        }
      },
      signUp               : {
        page_title                       : 'Registreren mijnWML',
        customernumber                   : 'Klantnummer',
        customernumber_placeholder       : '12345678',
        postal_code                      : 'Postcode',
        postal_code_placeholder          : '0000 AB',
        house_number                     : 'Huisnummer',
        house_number_placeholder         : '12',
        house_number_addition            : 'toevoeging',
        house_number_addition_placeholder: 'A',
        email                            : 'E-mailadres',
        repeat_email                     : 'Herhaal e-mailadres',
        password                         : 'Wachtwoord',
        repeat_password                  : 'Herhaal wachtwoord',
        signup_btn                       : 'Registreren',
        login_btn                        : 'Inloggen mijnWML',
        become_customer                  : 'Klant worden bij WML?',
        hints                            : {
          customernumber : 'Dit vindt u terug op uw jaarafrekening of uw bankafschrift. Op uw afschrift begint het nummer met een K. Vul hier alleen het nummerieke gedeelte in. Bijvoorbeeld: 10999999',
          postal_code    : 'Hier dient u de postcode in te vullen die bij uw klantnummer hoort, dit kan een leverings of postadres zijn',
          house_number   : 'Uw huisnummer met een eventuele toevoeging',
          email          : 'Uw e-mailadres waarmee wij contact met u op kunnen nemen',
          repeat_email   : 'Ter verificatie van het bovenstaande e-mailadres',
          password       : 'Dit dient 8 karakters te zijn, 1 hoofdletter, kleine letter, cijfer en een speciaal teken.',
          repeat_password: 'Herhaal bovenstaand wachtwoord'
        },
        thank_you                        : {
          page_title: 'Bedankt voor uw registratie voor mijnWML',
          login     : 'Ga naar inloggen'
        }
      },
      account              : {
        page_title     : 'Selecteer klantnummer',
        intro_text     : 'U bent ingelogd als {{email}}. Bij dit e-mailadres horen meerdere klantnummers.<br />Van welke klant wilt u de drinkwater zaken regelen?',
        customer_number: 'Klantnummer',
        search         : 'Klantnummer zoeken',
        select_btn     : 'Selecteer klantnummer'
      },
      register             : {
        page_title                       : 'Klant worden bij WML',
        form_title                       : 'Leveringsadres',
        customer_type                    : 'Ik ben..',
        residence                        : 'Een huishouden',
        company                          : 'Een bedrijf',
        number_of_persons                : 'Aantal personen',
        street                           : 'Straatnaam',
        postal_code                      : 'Postcode',
        postal_code_placeholder          : '0000 AB',
        houseno_and_addtion              : 'Huisnummer & toevoeging',
        house_number_placeholder         : '12',
        house_number_addition_placeholder: 'A',
        place                            : 'Woonplaats',
        different_correspondence_address : 'Ik heb een afwijkend correspondentieadres',
        cancel                           : 'Annuleren',
        previous                         : 'Vorige',
        save                             : 'Volgende',
        hints                            : {
          customer_type    : 'Voor een huishouden en een bedrijf gelden andere invulvelden',
          number_of_persons: 'Hoeveel personen wonen er op het leveringsadres?',
          street           : '',
          postal_code      : 'Uw postcode van het adres waarmee u klant wilt worden',
          house_number     : 'Uw huisnummer met eventuele toevoeging',
          place            : ''
        },
        login: {
          hints: {
            postal_code: 'Uw postcode van het adres waarmee u klant wilt worden',
            house_number: 'Het huisnummer met eventuele toevoeging van het adres waarmee u klant wilt worden'
          }
        },
        correspondence                   : {
          form_title                        : 'Correspondentieadres',
          country                           : 'Land',
          select_a_country                  : 'Selecteer een land',
          option_NL                         : 'Nederland',
          option_BE                         : 'Belgie',
          option_DE                         : 'Duitsland',
          houseno_postal_code               : 'Postcode & Huisnr.',
          houseno_po_box                    : 'Postcode & Postbus',
          postal_code                       : 'Postcode',
          postal_code_placeholder           : '0000 AB',
          postal_code_placeholder_be        : '0000',
          postal_code_placeholder_de        : '00000',
          houseno_and_addtion               : 'Huisnummer & toevoeging',
          street                            : 'Straat',
          city                              : 'Plaats',
          po_box                            : 'Postbus',
          cancel                            : 'Vorige',
          save                              : 'Volgende',
          hints              : {
            select_a_country   : '',
            postal_code        : '',
            houseno_and_addtion: '',
            street             : 'Dit wordt automatisch gevuld als u de postcode en huisnummer ingevuld heeft',
            city               : 'De plaats wordt automatisch gevuld na invullen postcode en huisnummer',
            po_box             : ''
          }
        },
        personal_information             : {
          form_title            : 'Persoonsgegevens',
          salutation            : 'Aanhef',
          select                : 'Selecteer',
          initials              : 'Voorletters',
          insertion             : 'Tussenvoegsel',
          last_name             : 'Achternaam',
          birthday              : 'Geboortedatum',
          company_name          : 'Bedrijfsnaam',
          phonenumber           : 'Telefoonnummer',
          mobile_phonenumber    : 'Mobiele telefoonnummer',
          email                 : 'E-mailadres',
          invoice_email_checkbox: 'Ja, ik wil mijn factuur via e-mail ontvangen',
          customer_survey       : 'WML mag mij per e-mail vragen om deel te nemen aan een klantonderzoek',
          cancel                : 'Vorige',
          save                  : 'Volgende',
          hints                 : {
            salutation        : '',
            initials          : '',
            insertion         : '',
            last_name         : '',
            birthday          : '',
            company_name      : '',
            phonenumber       : '',
            mobile_phonenumber: '',
            email             : ''
          }
        },
        meter_reading                    : {
          form_title       : 'Meterstand',
          date_key_transfer: 'Datum sleuteloverdracht',
          meter_reading    : 'Meterstand',
          meter_number     : 'Meternummer',
          file_upload_description   : 'Afbeeldingen moeten kleiner zijn dan 20 MB. Toegestane bestandstypen gif, jpg, png.​',
          file_upload               : 'Foto van de watermeter toevoegen',
          file_upload_btn           : 'Bladeren',
          next             : 'Volgende',
          previous         : 'Vorige',
          hints            : {
            meter_reading: '',
            meter_number : 'Het meternummer vindt u op de watermeter en begint met 003 of 005, VIK of VI.'
          }
        },
        payment_method                   : {
          form_title          : 'Betaalwijze',
          payment_method      : 'Betaalwijze',
          automatic_collection: 'Automatische incasso',
          bank_transfer       : 'Overschrijving',
          payment_frequency   : 'Frequentie termijnbedrag',
          frequency_01        : 'Per maand',
          frequency_02        : 'Per 2 maanden',
          frequency_03        : 'Per 3 maanden',
          frequency_04        : 'Per 4 maanden',
          pay_date            : 'Datum afschrijving',
          date_16             : '16e van de maand',
          date_25             : '25e van de maand',
          iban                : 'IBAN nummer',
          save_btn            : 'Volgende',
          cancel_btn          : 'vorige',
          hints               : {
            payment_method   : '',
            payment_frequency: '',
            pay_date         : '',
            iban             : ''
          }
        },
        portal                           : {
          form_title     : 'mijnWML account',
          intro          : 'Als klant van WML kunt u gebruik maken van onze mijnWML omgeving. Hieronder kunt u een account aanmaken. Heeft u geen interesse, klik dan op stap overslaan.',
          email          : 'E-mailadres mijnWML account',
          repeat_email   : 'Herhaal e-mailadres mijnWML account',
          password       : 'Wachtwoord mijnWML account',
          repeat_password: 'Herhaal wachtwoord mijnWML account',
          next           : 'Volgende',
          previous       : 'Vorige',
          skip_step      : 'Stap overslaan',
          hints          : {
            email          : '',
            repeat_email   : '',
            password       : '',
            repeat_password: ''
          }
        },
        summary                          : {
          connection_address         : 'Leveringsadres',
          connection_address_edit    : 'Leveringsadres wijzigen',
          number_of_persons          : 'Aantal personen',
          address                    : 'Adres',
          meter_number               : 'Meternummer',
          correspondence_address     : 'Correspondentieadres',
          correspondence_address_edit: 'Correspondentieadres wijzigen',
          move_in_date_edit : 'Datum sleuteloverdracht wijzigen',
          future_connection_address : 'Toekomstige leveringsadres',
          future_address_edit      : 'Toekomstige leveringsadres wijzigen',
          po_box                     : 'Postbus',
          personal_information       : 'Persoonsgegevens',
          personal_information_edit  : 'Persoonsgegevens wijzigen',
          company_information        : 'Bedrijfsgegevens',
          company_information_edit   : 'Bedrijfsgegevens wijzigen',
          name                       : 'Naam',
          birthday                   : 'Geboortedatum',
          phone_number               : 'Telefoonnummer',
          mobile_phone_number        : 'Mobiel telefoonnummer',
          email                      : 'E-mailadres',
          emailInvoice               : 'Factuur via e-mail ontvangen',
          customerSurvey             : 'Deelnemen aan klantonderzoek',
          yes                        : 'ja',
          no                         : 'nee',
          meter_reading              : 'Meterstand',
          meter_reading_edit         : 'Meterstand wijzigen',
          date                       : 'Datum',
          payment_method             : 'Betaalwijze',
          payment_method_edit        : 'Betaalwijze wijzigen',
          frequency                  : 'Frequentie',
          pay_date                   : 'Datum afschrijving',
          iban                       : 'IBAN nummer',
          portal_account             : 'mijnWML account',
          portal_account_edit        : 'mijnWML account wijzigen',
          password                   : 'Wachtwoord',
          conditions                 : 'Ik ga akkoord met de <a href=\"/footer/algemene-voorwaarden\" title=\"algemene voorwaarden\" target=\"_blank\">algemene voorwaarden</a>',
          confirm                    : 'Bevestigen'
        },
        confirmation                     : {
          page_title        : 'Bedankt voor uw aanmelding als klant bij WML',
          confirmation_email: 'Uw aanvraag is succesvol ontvangen. Binnen enkele minuten ontvangt u een bevestiging van deze aanvraag per e-mail. Het verwerken hiervan kan tot 8 werkdagen duren. Aansluitend ontvangt u de overeenkomst.',
          page_future_title        : 'Bedankt voor uw aanmelding als toekomstige klant bij WML. ',
          confirmation_future_email: 'U ontvangt op {{date}} een herinnering per e-mail. Hierin vragen wij u de watermeterstand door te geven. Wij maken dan uw aanmelding compleet.'
        }
      },
      contact: {
        page_title: {
          main    : 'Heeft u een vraag, klacht of melding?',
          step1   :  'Stap 1 van 3 – Jouw vraag',
          step2   :  'Stap 2 van 3 – Leveradres',
          step3   :  'Stap 3 van 3 – Contactgegevens'
        },
        subject_choice                   : 'Kies het onderwerp',
        choose_option                    : 'maak een keuze',
        choose_address                   : 'Kies het adres',
        choose_premises                  : 'Uw leveradres',
        customernumber                   : 'Klantnummer',
        customernumber_description       : 'Om uw vraag sneller te kunnen beantwoorden vul hier uw klantnummer in, dit vindt u links bovenaan op uw factuur.',
        customernumber_placeholder       : '12345678',
        postal_code                      : 'Postcode',
        postal_code_placeholder          : '0000 AB',
        house_number                     : 'Huisnummer',
        house_number_placeholder         : '12',
        house_number_addition            : 'toevoeging',
        house_number_addition_placeholder: 'A',
        no_customer_number               : 'Geen klantnummer / klantnummer onbekend',
        email                            : 'E-mailadres',
        repeat_email                     : 'Herhaal e-mailadres',
        name                             : 'Naam',
        street                           : 'Straat',
        place                            : 'Plaats',
        phone                            : 'Telefoonnummer',
        mobile_phone                     : 'Mobiel telefoonnummer',
        question                         : 'Uw vraag / opmerking',
        research                         : 'WML mag mij per e-mail vragen om deel te nemen aan een klantonderzoek.',
        next_btn                         : 'Volgende',
        previous_btn                     : 'Vorige',
        cancel_btn                       : 'Annuleren',
        send_btn                         : 'Versturen',
        file_upload                      : 'Bijlage(n) toevoegen (optioneel)',
        file_upload_btn                  : 'Bladeren',
        file_upload_description          : 'Je kan een bestand toevoegen om je probleem of je vraag te verduidelijken. Je kan maximaal 20 MB opladen. Dit type document of beeld kan je zonder problemen opladen: gif, jpg, png, pdf, doc, docx, xls, xlsx, odt, ods.​',
        other_address: {
          check: {
            label: 'Heeft uw vraag betrekking op bovenstaand adres?',
            yes: 'Ja',
            no: 'Nee'
          },
          postal_code: 'Postcode',
          house_number: 'Huisnummer',
          house_number_addition: 'toevoeging',
          street: 'Straat',
          place: 'Plaats'
        },
        time_bracket                     : {
          label: 'Wanneer bent u overdag het best bereikbaar?',
          morning: 'In de ochtend',
          afternoon: 'In de middag',
          no_preference: 'Geen voorkeur'
        },
        subject                          : {
          moving     : 'verhuizen',
          complaint  : 'klacht',
          meter      : 'meter',
          malfunction: 'storing',
          water      : 'water',
          shutoff    : 'afsluiting',
          other      : 'overig',
          damage     : 'schade',
          content: 'Naar aanleiding van uw vraag nemen we telefonisch of per e-mail contact met u op. Vul uw gegevens alsjeblieft zo volledig mogelijk in. Zo kunnen we u beter helpen.​'
        },
        business_subject                 : {
          connection          : 'Aansluiting',
          irrigation          : 'Beregening',
          smartmeter          : 'Slimme Meter',
          groundwatermanagment: 'Grondwaterbeheer',
          firesafety          : 'Brandveiligheid',
          sourcemanagement    : 'Bronnenbeheer',
          temporarywater      : 'Tijdelijk water',
          waterwall           : 'Waterwand',
          watertap            : 'Watertap',
          privateproperty     : 'Eigen terrein',
          other               : 'Overig'
        },
        hints                            : {
          customernumber: 'Dit vindt u terug op uw jaarafrekening of uw bankafschrift. Op uw afschrift begint het nummer met een K. Vul hier alleen het nummerieke gedeelte in. Bijvoorbeeld: 10999999',
          postal_code   : '',
          house_number  : '',
          email         : 'Het e-mailadres waarmee wij voor deze vraag, klacht of melding contact met u kunnen opnemen',
          repeat_email  : '',
          phone         : 'Vul hier alleen de cijfers van uw telefoonnummer in. Zonder streepjes, spaties, punten e.d.',
          mobile_phone  : 'Vul hier alleen de cijfers van uw telefoonnummer in. Zonder streepjes, spaties, punten e.d.'
        },
        thank_you                        : {
          page_title: 'Bericht verzonden',
          text      : 'Bedankt voor het plaatsen van uw vraag of opmerking. U ontvangt hiervan een bevestiging per e-mail. Wij streven ernaar om uw vraag, klacht of doorgifte binnen 8 werkdagen te beantwoorden. Op storingsmeldingen reageren wij binnen één werkdag.',
          btn       : 'Terug naar mijnWML'
        }
      },
      business_contact     : {
        page_title    : 'Contactformulier zakelijk',
        company       : 'Bedrijfsnaam',
        contact_person: 'Contactpersoon',
        phone_number  : 'Telefoonnummer',
        email         : 'E-mailadres',
        subject       : 'Onderwerp',
        option_choice : 'Maak een keuze',
        message       : 'Vraag of opmerking',
        btn           : 'Verstuur contact formulier'
      },
      customer             : {
        dashboard_title                : 'Mijn persoonlijke gegevens',
        dashboard_title_company        : 'Mijn bedrijfsgegevens',
        block_title                    : 'Persoonsgegevens',
        block_title_company            : 'Bedrijfsgegevens',
        customernumber                 : 'Klantnummer',
        name                           : 'Naam',
        birthday                       : 'Geboortedatum',
        phonenumber                    : 'Telefoonnummer',
        mobile_phonenumber             : 'Mobiel telefoonnummer',
        correspondence_email           : 'Correspondentie e-mailadres',
        customer_surveys               : 'Deelnemen aan klantonderzoeken',
        newsletter                     : 'Digitale nieuwsbrief ontvangen',
        change_customer                : 'Persoonsgegevens wijzigen',
        change_customer_company        : 'Bedrijfsgegevens wijzigen',
        my_correspondence              : 'Correspondentiegegevens',
        correspondence_address         : 'Correspondentieadres',
        po_box                         : 'Postbus',
        change_correspondence_address  : 'Correspondentieadres wijzigen',
        yes                            : 'Ja',
        no                             : 'Nee',
        billing_information_block_title: 'Factuurgegevens',
        invoice_email                  : 'E-mailadres voor facturen',
        billing_information_edit       : 'Factuurgegevens wijzigen',
        invoice_sendcontrol            : 'Verzendwijze facturen',
        sendcontrol                    : {
          option_0: 'post',
          option_3: 'digitaal'
        },
        billing_information            : {
          page_title       : 'Factuurgegevens wijzigen',
          save             : 'Opslaan',
          cancel           : 'Annuleren',
          email            : 'E-mailadres voor facturen',
          sendcontrol_label: 'Factuur digitaal ontvangen?',
          sendcontrol      : {
            option_0: 'Nee',
            option_3: 'Ja'
          },
          hints            : {
            email      : 'Dit e-mailadres zal gebruikt worden voor het versturen van facturen',
            sendcontrol: ''
          }
        },
        connection_addresses           : 'Leveringsadres(sen)',
        download_csv                   : 'Download overzicht als csv',
        connection_meter_number        : 'Meternr.',
        smart_meter_link               : 'Bekijk gegevens van slimme meter',
        connection_address             : 'Adres',
        my_invoice                     : 'Factuurgegevens',
        email_invoice                  : 'E-mailadres voor facturen',
        change_invoice_information     : 'Factuur gegevens wijzigen',
        contact_persons                : {
          title: 'Contactgegevens',
          type : {
            general       : 'Correspondentie',
            administration: 'Facturatie',
            incidents     : 'Storing',
            newsletter    : 'Nieuwsbrief',
            hints: {
              general       : 'Correspondentie contact',
              administration: 'Administratie contact',
              incidents     : 'Storing contact',
              newsletter    : 'Nieuwsbrief contact'
            }
          },
          name : 'Naam',
          phone: 'Telefoon',
          mobile_phone: 'Mobiel',
          email: 'E-mail'
        },
        moving_away                    : 'Gaat u verhuizen?',
        moving_away_text               : 'Gaat u verhuizen, geef dan hier uw adreswijziging door. U kunt uw nieuwe woning aanmelden of uw oude woning afmelden. Dit gaat alleen als de sleuteloverdracht is geweest.',
        moving_away_corporation        : 'Verhuizing doorgeven?',
        moving_away_text_corporation   : 'Geef dan hier de adreswijziging door. U kunt een nieuwe woning aanmelden of een oude woning afmelden. Dit gaat alleen als de sleuteloverdracht is geweest.',
        submit_moving_away             : 'Verhuizing doorgeven',
        sign_up_residence              : 'Nieuwe woning aanmelden',
        sign_out_residence             : 'Oude woning afmelden',
        edit                           : {
          page_title          : 'Persoonsgegevens wijzigen',
          page_title_company  : 'Bedrijfsgegevens wijzigen',
          salutation          : 'Aanhef',
          birthday            : 'Geboortedatum',
          phonenumber         : 'Telefoonnummer',
          mobile_phonenumber  : 'Mobiel telefoonnummer',
          correspondence_email: 'Correspondentie e-mailadres',
          update_account_email: 'Dit e-mailadres is ook mijnWML account e-mailadres.',
          customer_surveys    : 'WML mag mij per e-mail vragen om deel te nemen aan een klantonderzoek.',
          newsletter          : 'WML mag mij per e-mail de digitale nieuwsbrief toesturen.',
          yes                 : 'Ja',
          no                  : 'Nee',
          cancel              : 'Annuleren',
          save                : 'Opslaan',
          hints               : {
            salutation          : '',
            birthday            : '',
            phonenumber         : 'Vul hier alleen de cijfers van uw telefoonnummer in. Zonder streepjes, spaties, punten e.d.',
            mobile_phonenumber  : 'Vul hier alleen de cijfers van uw telefoonnummer in. Zonder streepjes, spaties, punten e.d.',
            correspondence_email: 'Via dit e-mailadres ontvangt u alle post van WML',
            customer_surveys    : '',
            newsletter          : ''
          }
        },
        correspondence              : {
          page_title                : 'Correspondentieadres wijzigen',
          current_correspondence    : 'Huidige correspondentieadres',
          new_correspondence        : 'Nieuw correspondentieadres',
          other                     : 'Anders,',
          country                   : 'Land',
          select_a_country          : 'Selecteer een land',
          option_NL                 : 'Nederland',
          option_BE                 : 'Belgie',
          option_DE                 : 'Duitsland',
          houseno_postal_code       : 'Postcode & Huisnr.',
          houseno_po_box            : 'Postcode & Postbus',
          postal_code               : 'Postcode',
          postal_code_placeholder   : '0000 AB',
          postal_code_placeholder_be: '0000',
          postal_code_placeholder_de: '00000',
          houseno_and_addtion       : 'Huisnummer & toevoeging',
          street                    : 'Straat',
          city                      : 'Plaats',
          po_box                    : 'Postbus',
          cancel                    : 'Annuleren',
          save                      : 'Opslaan',
          hints                     : {
            select_a_country   : '',
            postal_code        : '',
            houseno_and_addtion: '',
            street             : 'Dit wordt automatisch gevuld als u de postcode en huisnummer ingevuld heeft',
            city               : 'De plaats wordt automatisch gevuld na invullen postcode en huisnummer',
            po_box             : ''
          }
        },
        wfl: {
          text: 'Namens Water for Life hartelijk dank voor uw donatie. Hiermee helpt u mee om schoon drinkwater en sanitaire voorzieningen wereldwijd toegankelijk te maken voor iedereen.',
          amount_text: 'Bedrag dat u jaarlijks doneert',
          donation: {
            edit: "Opslaan",
            stop: "Stopzetten donatie",
            acknowledge:  "Bevestig het stopzetten van uw donatie.",
            yes:  "Ja",
            no:  "Nee"
          }
        }
      },
      contact_persons      : {
        page_title     : 'Contactpersoon toevoegen',
        page_title_edit: 'Contactpersoon wijzigen',
        firstName      : 'Voornaam',
        insertion      : 'Tussenvoegsel',
        lastName       : 'Achternaam',
        email          : 'E-mailadres',
        phone          : 'Telefoonnummer',
        mobile_phone   : 'Mobiel telefoonnummer',
        hints          : {
          firstName: '',
          insertion: '',
          lastName : '',
          email    : '',
          phone    : '',
          mobile_phone: ''
        },
        save           : 'Opslaan',
        cancel         : 'Annuleren'
      },
      paymentmethods       : {
        bank_transfer       : 'Overschrijving',
        automatic_collection: 'Automatische incasso',
        refund              : 'Terug betaling',
        clearing            : 'Verrekening'
      },
      invoices             : {
        dashboard            : {
          dashboard_title           : 'Mijn financiële gegevens',
          title_connection_addresses: 'Mijn Leveringsadres(sen)',
          connection_meter_number   : 'Meternr.',
          connection_address        : 'Adres',
          connection_paymentmethod  : 'Betaalwijze',
          connection_installment    : 'Termijnbedrag',
          title_invoices            : 'Mijn laatste facturen',
          date_invoices             : 'Datum',
          description_invoices      : 'Omschrijving',
          amount_invoices           : 'Bedrag',
          view_invoices             : 'Bekijk alle betalingen',
          no_invoices               : 'Er zijn geen facturen',
          no_remaining_invoices     : 'Er zijn geen openstaande facturen',
          title_remaining_amount    : 'Mijn openstaand saldo',
          view_remaining_amount     : 'Bekijk alle openstaande facturen',
          view_payment_arrangement  : 'Betalingsregeling',
          postal_filter             : 'Zoeken op postcode',
          change_payment_method     : 'Betaalwijze wijzigen',
          change_installment_amount : 'Termijnbedrag wijzigen',
          iban: "IBAN nummer"
        },
        filters              : {
          year              : 'Jaar',
          connection_address: 'Alle leveringsadressen',
          invoice_number    : 'Factuurnummer',
          mobile_filter_txt : 'Filter uw facturen'
        },
        page_title           : 'Mijn betalingen',
        page_title_remaining : 'Mijn openstaand saldo',
        no_remaining_invoices: 'Er zijn geen openstaande facturen',
        no_invoices          : 'Er zijn geen facturen',
        download_csv         : 'Download overzicht als csv',
        payment_message      : 'Wilt u niet het hele openstaand saldo betalen? Vink de posten uit die u op dit moment niet wilt betalen.',
        pay_btn              : 'Nu betalen',
        pay_total            : 'Totaal',
        table                : {
          date                 : 'Datum',
          invoice_number       : 'Factuurnummer',
          description          : 'Omschrijving',
          amount               : 'Bedrag',
          status               : 'Status',
          payment_method       : 'Betaalwijze',
          state                : 'Status',
          due_date             : 'Vervaldatum',
          paid                 : 'Betaald',
          refunded             : 'Gestorneerd',
          payment_in_process   : 'In behandeling',
          standard_pay_method  : 'iDEAL',
          popover_without_costs: 'Factuur:',
          popover_total_costs  : 'Kosten:',
          popover_pay_in_order : 'Facturen dienen betaald te worden op volgorde van datum',
          details_without_costs: 'Factuur',
          details_total_costs  : 'Kosten'

        },
        pagination           : {
          page_counter: '<strong>{{range}}</strong> van <strong>{{total}}</strong> facturen',
          previous    : 'Vorige',
          next        : 'Volgende'
        },
        descriptions         : {
          PA     : 'Afrekening',
          TA     : 'Tussentijdse afrekening',
          SA     : 'Eindafrekening',
          HA     : 'Handmatige factuur',
          FA     : 'Jaarafrekening',
          VS     : 'Termijnbedrag',
          VA     : 'Verzamelfactuur',
          NW     : 'Niet water factuur',
          AK     : 'Aanmaankosten',
          BR     : 'Betalingsregeling',
          AG     : 'Betaling',
          UNKNOWN: 'Onbekend'
        },
        paymentResult: {
          success: "Bedankt voor uw betaling",
          failed: "Er is iets misgegaan"
        },
        payment_arrangement: {
          page_title: 'Betalingsregeling',
          total_amount_remaining: 'Totaal bedrag',
          payment_frequency: 'Termijnen',
          payment_frequency_amount: 'Bedrag per termijn',
          iban_number: 'IBAN Nummer',
          pay_with_ai: 'Betaal deze termijnen en uw toekomstige vorderingen via automatische incasso.',
          save_btn: 'Opslaan',
          cancel_btn: 'Annuleren',
          choose_option: 'Maak een keuze'
        }
      },
      change_payment_method: {
        page_title          : 'Betaalwijze wijzigen',
        payment_method      : 'Betaalwijze',
        automatic_collection: 'Automatische incasso',
        bank_transfer       : 'Overschrijving',
        payment_frequency   : 'Frequentie termijnbedrag',
        frequency_01        : 'Per maand',
        frequency_02        : 'Per 2 maanden',
        frequency_03        : 'Per 3 maanden',
        frequency_04        : 'Per 4 maanden',
        pay_date            : 'Datum afschrijving',
        date_16             : '16e van de maand',
        date_25             : '25e van de maand',
        iban                : 'IBAN nummer',
        change_iban         : 'IBAN/Banknummer wijzigen',
        save_btn            : 'Opslaan',
        cancel_btn          : 'Annuleren',
        hints               : {
          payment_method   : '',
          payment_frequency: '',
          pay_date         : '',
          iban             : ''

        }
      },
      usage                : {
        dashboard          : {
          dashboard_title           : 'Mijn verbruik',
          title_usage_scan          : 'Verbruiksscan',
          usage_scan_intro          : 'Vul uw meterstanden in en bekijk of uw termijnbedrag nog voldoet! Makkelijk uw termijnbedrag bijstellen en nooit meer teveel betalen!',
          usage_scan_btn            : 'Verbruiksscan',
          usage_scan_popup_title    : 'Voor welk leveringsadres wilt u de verbruiksscan invullen?',
          title_water_save_check    : 'Waterbespaarcheck',
          water_save_check_intro    : 'Doe de Waterbespaarcheck en kijk hoe bewust u met Limburgs drinkwater bent',
          water_save_check_btn      : 'Waterbepsaarcheck',
          connection_meter_number   : 'Meternr.',
          connection_address        : 'Adres',
          title_meter_reading       : 'Een meteropname kaart ontvangen?',
          meter_reading_intro       : 'Dan kunt u hier online uw meterstand doorgeven',
          meter_reading_popup_title : 'Voor welk leveringsadres wilt u de meterstand invullen?',
          meter_reading_address     : 'Adres',
          meter_reading_meter_number: 'Meternr.',
          meter_reading_btn         : 'Meterstanden doorgeven'
        },
        meter_readings     : {
          page_title    : 'Meterstand invullen',
          btn_next      : 'Volgende',
          recording_date: 'Opnamedatum',
          meter_reading : 'Meterstand',
          meter_number  : 'Meternummer',
          optional_email: 'Stuur mij hierover een bevestiging',
          cancel        : 'Annuleren',
          old_meter_vik : '\"Oude\" standaard meter',
          meter_vik     : 'Standaard meter',
          old_meter_vi  : '\"Oude\" grote meter',
          meter_vi      : 'Grote meter',
          hints         : {
            recording_date: '',
            meter_reading : 'Vul uw meterstand in (alleen de getallen vóór de komma).',
            meter_number : 'Het meternummer vindt u op de watermeter en begint met 003 of 005, VIK of VI.'
          }
        },
        compare            : {
          page_title         : 'Verbruik vergelijken',
          recording_date     : 'Opnamedatum',
          meter_reading      : 'Meterstand',
          usage              : 'Verbruik',
          year_usage         : 'Jaarverbruik',
          current_installment: 'Huidig termijnbedrag',
          advised_installment: 'Geadviseerd termijnbedrag',
          effective_date     : 'Ingangsdatum',
          compare_text       : 'Op basis van de door u doorgevoerde meterstanden zal uw<br/> jaarverbruik uitkomen op <strong>{{usage}} m3 per jaar</strong>.',
          checkbox           : 'Het geadviseerde termijnbedrag gebruiken',
          cancel             : 'Vorige',
          save               : 'Termijnbedrag wijzigen',
          hints              : {
            advised_installment: 'Uw geadviseerde termijn bedrag',
            checkbox           : 'Het geadviseerde termijn bedrag gebruiken'
          }
        },
        installment_change : {
          page_title         : 'Termijnbedrag wijzigen',
          frequency_01       : 'per maand',
          frequency_02       : 'per 2 maanden',
          frequency_03       : 'per 3 maanden',
          frequency_04       : 'per 4 maanden',
          frequency_12       : 'jaarlijksvoorschot',
          limits             : 'Het termijnbedrag mag niet minder dan {{lower}} en niet hoger dan {{upper}} zijn.',
          current_installment: 'Uw huidige termijnbedrag is',
          new_installment    : 'Gewenst termijnbedrag',
          meter_readings     : 'Hulp door meterstanden invullen',
          cancel             : 'Annuleren',
          save               : 'Opslaan',
          hints              : {
            new_installment: 'Geef uw gewenste termijn bedrag op',
            meter_readings : 'Bereken termijn bedrag aan de hand van verbruik'
          }
        },
        installment_changed: {
          page_title       : 'U heeft uw termijnbedrag gewijzigd',
          personalized_text: 'Het termijnbedrag voor het leveringsadres <strong>{{address}}</strong> is aangepast naar <strong>{{installment}}</strong>',
          btn_finish       : 'Naar overzicht'
        },
        chart              : {
          title           : 'Uw waterverbruik per periode',
          compare_title   : 'Vergelijk uw verbruik met het gemiddelde verbruik van een huishouden met:',
          text            : 'In Nederland verbruikt een 1-persoons huishouden gemiddeld 128 liter water per dag. Doe de <a href=\"https://limburgsdrinkwater.nl/waterbespaarcheck\" title=\"Waterbespaarcheck\">Waterbespaarcheck</a> en kijk hoe bewust u met Limburgs drinkwater bent.',
          options         : {
            option1: '7 personen',
            option2: '6 personen',
            option3: '5 personen',
            option4: '4 personen',
            option5: '3 personen',
            option6: '2 personen',
            option7: '1 persoon'
          },
          smart_meter_text: 'Dit leveringsadres maakt gebruik van een slimme meter.',
          smart_meter_link: 'Bekijk hier de gegevens van de slimme meter',
          table           : {
            recording_period: 'Periode',
            meter_reading   : 'Meterstand',
            usage           : 'Verbruik',
            reading_type    : 'Opnamesoort'
          },
          graph_labels: {
            customer: '<span><i class=\"fa fa-user-circle-o\" title=\"Eigen opname\"></i> Eigen opname</span>',
            wml: '<span><i class=\"fa fa-wrench\" title=\"Monteur\"></i> Monteur</span>',
            estimated: '<span><i class=\"fa fa-magic\" title=\"Schatting\"></i> Schatting</span>'
          },
          button          : 'Bekijk alles',
          no_history      : 'Uw verbruikshistorie kan op dit moment nog niet getoond worden. Hiervoor hebben we tenminste één meterstand nodig.',
          no_history_alt  : 'Op uw adres is de watermeter onlangs vervangen. Wij kunnen u op dit moment helaas dan ook geen historie in waterverbruik laten zien. U kunt op uw jaarfacturen het verbruik van het betreffende jaar zien. De jaarfacturen vindt u onder ‘<a href=\"/mijn-financiele-gegevens\" title=\"Mijn financiële gegevens\">Mijn financiële gegevens</a>’.'
        }
      },
      meter_readings       : {
        page_title                : 'Meterstand doorgeven',
        last_reading              : 'Uw laatste meterstand was <span class=\"customer-label\">{{lastReading}} m<small>3</small></span> en is doorgegeven op {{readingDate}}',
        btn_next                  : 'Volgende',
        yes                       : 'Ja',
        no                        : 'Nee',
        recording_date            : 'Opnamedatum',
        deviation_code            : 'Reden van afwijking',
        deviation_reason          : 'Toelichting',
        file_upload_description   : 'Afbeeldingen moeten kleiner zijn dan 20 MB. Toegestane bestandstypen gif, jpg, png.​',
        file_upload               : 'Foto van de watermeter toevoegen',
        file_upload_btn           : 'Bladeren',
        meter_reading             : 'Meterstand',
        meter_number              : 'Meternummer',
        keep_installment_amount   : 'Ja, ik wil graag hetzelfde termijnbedrag blijven betalen als afgelopen jaar.',
        optional_email            : 'Wilt u een bevestiging van de door u doorgegeven meterstand ontvangen?',
        cancel                    : 'Annuleren',
        email_address_confirmation: 'E-mailadres voor bevestiging',
        hints                     : {
          recording_date: '',
          meter_reading : 'Vul uw meterstand in (alleen de getallen vóór de komma).',
          meter_number : 'Het meternummer vindt u op de watermeter en begint met 003 of 005, VIK of VI.',
          keep_installment_amount: 'Uw termijnbedrag wordt na de jaarafrekening niet aangepast.',
          deviation_code: '',
          deviation_reason: ''
        },
        deviations                : {
          deviation_8 : 'Lekkage',
          deviation_9 : 'Pand onbewoond geweest',
          deviation_10: 'Meer bewoners',
          deviation_13: 'Eigen bron/minder productie',
          deviation_18: 'Meer gesproeid',
          deviation_19: 'Vijver/zwembad gevuld',
          deviation_20: 'Meermalig geschat geweest',
          deviation_21: 'Meer productie',
          deviation_22: 'Lekkage gehad meer dan een jaar geleden',
          deviation_23: 'Minder bewoners',
          deviation_24: 'Minder gesproeid',
          deviation_25: 'Vijver/zwembad verwijderd/niet gevuld',
          deviation_26: 'Minder productie',
          deviation_27: 'Meter verwisseld',
          deviation_28: 'Meter defect',
          deviation_99: 'Andere reden, vul toelichting in'
        },
        recording_number          : {
          page_title              : 'Meterstand doorgeven',
          number                  : 'Opnamenummer',
          postal_code             : 'Postcode',
          placeholder_postal_code : '0000 AB',
          cancel                  : 'Annuleren',
          btn_next                : 'Volgende'
        },
        email: {
          page_title: 'Meterstand doorgeven',
          content: 'Wilt u een bevestiging van uw doorgegeven meterstand, vul dan hier uw e-mailadres in.',
          email_address_confirmation: 'E-mailadres',
          cancel: 'Vorige',
          save: 'Bevestigen'
        },
        summary: {
          page_title: 'Meterstand doorgeven',
          personal_data_title: 'Uw gegevens',
          recording_number: 'Opnamenummer',
          postal_code: 'Postcode',
          address: 'Leveringsadres',
          meter_number: 'Meternummer',
          email: {
            title: 'Bevestiging',
            edit: 'E-mail adres wijzigen',
            none: 'U heeft gekozen om geen bevestiging e-mail te ontvangen van uw doorgegeven stand',
            emailadress: 'U ontvangt een bevestiging op'
          },
          meter_reading: {
            title: 'Meterstand',
            date: 'Datum',
            reading: 'Meterstand',
            edit: 'Meterstand wijzigen'
          },
          cancel: 'Vorige',
          save: 'Bevestigen'
        },
        thank_you                 : {
          page_title: 'Bedankt voor het doorgeven van uw meterstand',
          btn       : 'Afronden',
          text      : 'U krijgt een bevestiging hiervan per e-mail wanneer u een e-mailadres heeft ingevuld.<br/><br/> Let op: mocht u de e-mail niet ontvangen, controleer dan de map met ongewenste e-mail (spam).',
          no_email_text: 'U krijgt geen bevestiging hiervan.',
          wfl: {
            title: 'Doneren aan Water for Life',
            p1: 'Samen met andere Nederlandse drinkwaterbedriven ondersteunt WML Stichting Water for Life in haar missie om schoon drinkwater en sanitaire voorzieningen wereldwijd voor iedereen toegankelijk te maken. Met veel enthousiasme zetten wij ons in om fondsen te werven voor het goede werk van Water for Life. Maar dat kunnen we natuurlijk niet alleen. Helpt u ook mee?',
            p2: 'Met uw donatie, hoe groot of klein ook, draagt u bij aan toegang tot schoon en betrouwbaar drinkwater en een toilet voor iedereen ter wereld. Voorbeeld: voor 18 Euro help je al 1 persoon aan schoon drinkwater.',
            p3: 'Welk bedrag wilt u jaarlijks doneren?',
            p4: 'U betaalt de donatie op dezelfde manier en van hetzelfde rekeningnummer als de waterrekening.',
            p5: 'Maakt u gebruik van automatische incasso? Dan wordt ook deze donatie automatisch afgeschreven.',
            amount: {
              a5: "5",
              a20: "20",
              a50: "50",
              other: "anders"
            },
            buttons: {
              donate_now: "Ja, ik doneer",
              home: "Home",
              overview: "Mijn overzicht",
              skip: "Doorgaan zonder te doneren"
            },
            conditions: "Ik ga akkoord met de <a href=\"/footer/algemene-voorwaarden\" title=\"algemene voorwaarden\" target=\"_blank\">algemene voorwaarden</a>"
          }
        }
      },
      my_dashboard         : {
        dashboard_title         : 'Mijn overzicht',
        meter_reading_title     : 'Jaarlijkse meterstand doorgeven',
        meter_reading_text      : 'Heeft u een meternopname kaart ontvangen? Dan kunt u hier makkelijk en snel uw meterstand doorgeven.',
        meter_reading_button    : 'Meterstanden doorgeven',
        account                 : {
          active_customer: 'Actief klantnummer',
          customer_number: 'Klantnummer',
          name           : 'Naam',
          switch_customer: 'Wisselen van klantnummer'
        },
        corporation     : {
          dashboard_title: 'Gekozen Leveringsadres wisselen',
          switch_address : 'Ander leveringsadres kiezen',
          csv_overview   : 'Leveringsadressen overzicht',
          csv_text       : 'Download hier een overzicht van alle leveringsadressen.',
          csv_btn        : 'Download CSV'
        },
        msa_make_appointment    : {
          title : 'Afspraak meterwisseling maken',
          text  : 'Heeft u een oproep ontvangen om uw watermeter te laten wisselen? Maak dan hier een afspraak.',
          button: 'Afspraak maken'
        },
        msa_planned_appointments: {
          title: 'Mijn geplande afspraken',
          label: 'afspraak wijzigen',
          empty: 'Geen omschrijving schadebeeld meegegeven.',
          delete: 'afspraak verwijderen'
        },
        customer_invoices       : {
          title    : 'Mijn financiële gegevens',
          remaining: 'Totaal openstaand saldo',
          button   : 'Bekijk alles',
          view_remaining_amount: 'Betaal via IDEAL'
        },
        correspondence          : {
          address: 'Correspondentieadres',
          button : 'Bekijk alles'
        },
        usage                   : {
          title: 'Mijn verbruik'
        },

        popup: {
          msa_popup_title   : 'Voor welk leveringsadres wilt u de meterwissel inplannen?',
          notify_no         : 'Servicemeldingnummer',
          connection_address: 'Adres'
        }
      },
      forgot_password      : {
        page_title : 'Wachtwoord vergeten',
        email      : 'E-mailadres',
        forgot_btn : 'Verstuur e-mail',
        please_wait: 'Een momentje terwijl we je wachtwoord herstellen. U wordt binnen enkele ogenblikken automatisch doorgestuurd.',
        text       : '<p>Vul hieronder uw e-mailadres in en klik op de knop \"Verstuur e-mail\".</p><p>U ontvangt binnen enkele minuten een e-mail waarmee u een nieuw wachtwoord kunt instellen.</p>',
        emailSent  : 'Uw wachtwoord is hersteld. U ontvangt een e-mail met een activatielink. Klik op de activatielink om uw wachtwoord te wijzigen.',
        hints      : {
          email: 'Vul het e-mailadres in van uw mijnWML account'
        }
      },
      profile              : {
        dashboard      : {
          page_title         : 'mijnWML account informatie',
          email              : 'Account e-mail',
          password           : 'Wachtwoord',
          btn_change_password: 'Wachtwoord wijzigen',
          btn_change_email   : 'E-mail wijzigen'
        },
        change_password: {
          page_title      : 'Wachtwoord wijzigen',
          current_password: 'Huidig Wachtwoord',
          new_password    : 'Nieuw Wachtwoord',
          repeat_password : 'Herhaal nieuw wachtwoord',
          save_btn        : 'Opslaan',
          cancel_btn      : 'Annuleren',
          hints           : {
            current_password   : 'Vul hier uw huidige wachtwoord in',
            new_password       : 'Dit dient 8 karakters te zijn, 1 hoofdletter, kleine letter, cijfer en een speciaal teken.',
            new_password_repeat: 'Herhaal uw nieuw wachtwoord'
          }
        },
        change_email   : {
          page_title  : 'Account e-mailadres wijzigen',
          new_email   : 'Nieuwe account e-mailadres',
          repeat_email: 'Herhaal nieuw account e-mailadres',
          save_btn    : 'Opslaan',
          cancel_btn  : 'Annuleren',
          update_correspondence_email: 'Dit e-mailadres is ook mijn correspondentie e-mailadres.',
          hints       : {
            new_email       : 'Uw account e-mailadres is waarmee u kunt inloggen op mijnWML. Let op: Dit is niet uw correspondentieadres.',
            new_email_repeat: ''
          }
        }
      },
      msa                  : {
        choose_meter       : {
          title : {
            create: 'Afspraak meterwisseling maken',
            update: 'Afspraak {{issue}} wijzigen',
            delete: 'Afspraak {{issue}} annuleren'
          },
          email_address_confirmation: 'E-mailadres bevestiging',
          water_meter_selection     : 'Welke watermeter wilt u?',
          next                      : 'Volgende',
          cancel                    : 'Annuleren',
          meter_default             : 'Standaard',
          meter_large               : 'Groot',
          hints                     : {
            information_view_meter_default: 'Dit is ruim voldoende voor normaal huishoudelijk gebruik.',
            information_view_meter_large  : 'Deze meter is geschikt voor het leveren van een grotere capaciteit. Deze is bijvoorbeeld benodigd bij het gebruik van een brandslanghaspel.'
          }
        },
        summary            : {
          title: {
            create: 'Afspraak meterwisseling maken',
            update: 'Afspraak {{issue}} wijzigen',
            delete: 'Afspraak {{issue}} annuleren'
          },
          your_information          : 'Uw gegevens',
          edit_your_information     : 'Uw gegevens bewerken',
          connection_address        : 'Leveringsadres',
          email_address_confirmation: 'E-mailadres bevestiging',
          preferred_meter           : 'Gewenste watermeter',
          edit_preferred_meter      : 'Gewenste watermeter wijzigen',
          date_and_time             : 'Datum & tijd',
          edit_date_and_time        : 'Datum & tijd wijzigen',
          agree                     : 'Ik ga akkoord met bovenstaande gegevens',
          create_appointment        : 'Afspraak inplannen',
          update_appointment        : 'Afspraak wijzigen',
          delete_appointment        : 'Afspraak annuleren',
          cancel                    : 'Annuleren',
          meter_default             : 'Standaard',
          meter_large               : 'Groot',
          text_meter_default        : 'Dit is ruim voldoende voor normaal huishoudelijk gebruik.',
          text_meter_large          : 'Deze meter is geschikt voor het leveren van een grotere capaciteit. Deze is bijvoorbeeld benodigd bij het gebruik van een brandslanghaspel.'
        },
        confirmation       : {
          title: {
            create: 'Uw afspraak is gemaakt',
            update: 'Uw afspraak is gewijzigd',
            delete: 'Uw afspraak is geannuleerd'
          },
          page_title   : 'Uw afspraak is gemaakt',
          page_text    : 'U ontvangt binnen enkele minuten een bevestiging per e-mail.',
          page_text_addendum : 'U kunt de gemaakte afspraken nog tot 24 uur van te voren wijzigen.',
          btn_home     : 'Naar de homepagina',
          btn_dashboard: 'Naar het overzicht'
        },
        time_table         : {
          title : {
            create: 'Afspraak meterwisseling maken',
            update: 'Afspraak {{issue}} wijzigen',
            delete: 'Afspraak {{issue}} annuleren'
          },
          loading_choices: 'Keuze mogelijkheden laden',
          next_btn       : 'Volgende',
          cancel_btn     : 'Annuleren'
        },
        service_number_form: {
          title                     : 'Meter verwisselen',
          service_number            : 'Servicemeldingnummer',
          postal_code               : 'Postcode',
          placeholder_postal_code   : '0000 AB',
          next                      : 'Volgende'
        }
      },
      premise_register     : {
        page_title                       : 'Woning aanmelden',
        street                           : 'Straat',
        postal_code                      : 'Postcode',
        postal_code_placeholder          : '0000 AB',
        houseno_and_addtion              : 'Huisnummer & toevoeging',
        house_number_placeholder         : '12',
        house_number_addition_placeholder: 'A',
        city                             : 'Woonplaats',
        customernumber                   : 'Klantnummer',
        customernumber_placeholder       : '12345678',
        cancel                           : 'Annuleren',
        previous                         : 'Vorige',
        save                             : 'Volgende',
        hints                            : {
          street      : '',
          postal_code : 'De postcode van het adres dat u wilt aanmelden.',
          house_number: 'Het huisnummer met eventuele toevoeging van het adres dat u wilt aanmelden.',
          city        : ''
        },
        login: {
          hints: {
            postal_code: 'Uw postcode van het adres waarmee u klant wilt worden',
            house_number: 'Het huisnummer met eventuele toevoeging van het adres waarmee u klant wilt worden',
            customer_number: 'Klantnummer'
          }
        },
        meter_reading                    : {
          page_title       : 'Woning aanmelden',
          date_key_transfer: 'Datum sleuteloverdracht',
          meter_reading    : 'Meterstand',
          meter_number  : 'Meternummer',
          file_upload_description   : 'Afbeeldingen moeten kleiner zijn dan 20 MB. Toegestane bestandstypen gif, jpg, png.​',
          file_upload               : 'Foto van de watermeter toevoegen',
          file_upload_btn           : 'Bladeren',
          cancel           : 'Vorige',
          save             : 'Volgende',
          hints            : {
            meter_reading: '',
            meter_number : 'Het meternummer vindt u op de watermeter en begint met 003 of 005, VIK of VI.'
          }
        },
        new_premises: {
          text1   : 'De woning die u wilt aanmelden wordt ook uw nieuw correspondentieadres.',
          text2   : 'Indien u een ander correspondentieadres wilt opgeven kunt u dit hieronder doorgeven.',
          current_correspondence: 'Huidige correspondentieadres',
          different_correspondence_address: 'Ik heb een afwijkend correspondentieadres',
          cancel  : 'Vorige',
          save    : 'Volgende'
        },
        correspondence            : {
          page_title                        : 'Woning aanmelden',
          new_correspondence                : 'Nieuw correspondentieadres',
          current_correspondence            : 'Huidige correspondentieadres',
          other                             : 'Nieuw adres toevoegen',
          country                           : 'Land',
          select_a_country                  : 'Selecteer een land',
          option_NL                         : 'Nederland',
          option_BE                         : 'Belgie',
          option_DE                         : 'Duitsland',
          houseno_postal_code               : 'Postcode & Huisnummer',
          houseno_po_box                    : 'Postcode & Postbus',
          postal_code                       : 'Postcode',
          postal_code_placeholder           : '0000 AB',
          postal_code_placeholder_be        : '0000',
          postal_code_placeholder_de        : '00000',
          houseno_and_addtion               : 'Huisnummer & toevoeging',
          street                            : 'Straat',
          city                              : 'Plaats',
          po_box                            : 'Postbus',
          cancel                            : 'Vorige',
          save                              : 'Volgende',
          hints                             : {
            select_a_country   : '',
            postal_code        : '',
            houseno_and_addtion: '',
            street             : 'Dit wordt automatisch gevuld als u de postcode en huisnummer ingevuld heeft',
            city               : 'De plaats wordt automatisch gevuld na invullen postcode en huisnummer',
            po_box             : ''
          }
        },
        futuremail: {
          correspondence_email: 'Correspondentie e-mailadres',
          update_account_email: 'Dit e-mailadres is ook mijn mijnWML account e-mailadres.',
          sendcontrol_label: 'Factuur digitaal ontvangen?',
          email_post: {
            yes: 'Ja',
            no: 'Nee'
          },
          hints: {
            correspondence_email: 'Via dit e-mailadres ontvangt u alle post van WML',
            sendcontrol_label: 'sendcontrol_label'
          }
        },
        summary                          : {
          page_title        : 'Woning aanmelden',
          date              : 'Datum',
          email_post: {
            label: 'Post ontvangen via E-mail',
            yes: 'Ja',
            no: 'Nee'
          },
          email             : 'Persoonsgegevens',
          email_address_label: 'Correspondentie<br> e-mailadres',
          update_account_email : 'Dit e-mailadres is ook mijn mijnWML account e-mailadres.',
          meter_reading     : 'Meterstand',
          meter_reading_edit: 'Meterstand wijzigen',
          move_in_date_edit : 'Datum sleuteloverdracht wijzigen',
          future_connection_address : 'Toekomstige leveringsadres',
          future_address_edit      : 'Toekomstige leveringsadres wijzigen',
          address           : 'Adres',
          meter_number      : 'Meternummer',
          connection_address: 'Leveringsadres',
          address_edit      : 'Leveringsadres wijzigen',
          correspondence_address_edit: 'Correspondentieadres wijzigen',
          new_correspondence_address: 'Nieuw Correspondentieadres',
          future: {
            change_correspondence: 'Correspondentiegegevens wijzigen',
            correspondence: 'Correspondentiegegevens',
            email: 'E-mailadres',
            update_account_email: 'Dit e-mailadres is ook mijn mijnWML account e-mailadres.',
            digital: 'Digitaal post ontvangen?'
          },
          cancel            : 'Vorige',
          save              : 'Bevestigen'
        },
        thank_you                        : {
          page_title: 'De woning is aangemeld voor drinkwaterlevering',
          page_future_title: 'Bedankt voor uw toekomstige aanmelding bij WML.',
          text      : 'De woning is aangemeld voor drinkwaterlevering. U ontvangt hiervan een bevestiging per e-mail. Wij gaan uw gegevens verwerken in onze administratie en binnen twee weken ontvangt u bericht.',
          future_text: 'U ontvangt op {{date}} een herinnering per e-mail. Hierin vragen wij u de watermeterstand door te geven. Wij maken dan uw aanmelding compleet.',
          btn       : 'Naar het overzicht'
        }
      },
      premise_unregister   : {
        page_title                : 'Woning afmelden',
        premises_select           : 'Selecteer het leveringsadres dat u wilt afmelden',
        premises_unregistered     : 'Reeds afgemelde leveringsadressen',
        premises_unregistered_desc: 'Kloppen de gegevens niet, neem dan contact op met de  <a href=\"/contact\" title=\"Klantenservice\">klantenservice</a>. Controleer je huidig  <a href=\"/mijn-persoonlijke-gegevens\" title=\"correspondentieadres\">correspondentieadres</a> en  <a href=\"/mijn-persoonlijke-gegevens\" title=\"e-mailadres\">e-mailadres</a>.',
        none_selectable           : 'Er zijn geen leveringsadressen die u kunt afmelden via het mijnWML portaal.',
        not_selectable            : 'Leveringsadressen die u niet kunt afmelden via mijnWML',
        not_selectable_text       : 'Wilt u één van de onderstaande leveringsadressen afmelden, neem dan <a href=\"/contact\" title=\"Klantenservice\">contact</a> op met de klantenservice.',
        not_selectable_text_single: 'Wilt u onderstaand leveringsadres afmelden, neem dan <a href=\"/contact\" title=\"Klantenservice\">contact</a> op met de klantenservice.',
        no_premises               : 'Er zijn geen woningen ',
        previous                  : 'Vorige',
        cancel                    : 'Annuleren',
        save                      : 'Volgende',
        customernumber                   : 'Klantnummer',
        customernumber_placeholder       : '12345678',
        postal_code                      : 'Postcode',
        postal_code_placeholder          : '0000 AB',
        house_number                     : 'Huisnummer',
        house_number_placeholder         : '12',
        house_number_addition            : 'toevoeging',
        house_number_addition_placeholder: 'A',
        btn_next                  : 'Volgende',
        unregister_addresses_table: {
          address: 'Adres',
          meter_number: 'Meter<wbr>nr.',
          date: 'Datum',
          meter_reading: 'Meter<wbr>stand'
        },
        meter_reading             : {
          page_title       : 'Woning afmelden',
          date_key_transfer: 'Datum sleuteloverdracht',
          meter_reading    : 'Meterstand',
          meter_number     : 'Meternummer',
          file_upload_description   : 'Afbeeldingen moeten kleiner zijn dan 20 MB. Toegestane bestandstypen gif, jpg, png.​',
          file_upload               : 'Foto van de watermeter toevoegen',
          file_upload_btn           : 'Bladeren',
          cancel           : 'Vorige',
          save             : 'Volgende',
          hints            : {
            meter_reading: '',
            meter_number : 'Het meternummer vindt u op de watermeter en begint met 003 of 005, VIK of VI.'
          }
        },
        login: {
          hints: {
            customer_number: 'Klantnummer hint',
            postal_code: 'De postcode van het adres dat u wilt afmelden.',
            house_number: 'Het huisnummer met eventuele toevoeging van het adres dat u wilt afmelden.'
          }
        },
        correspondence            : {
          page_title                        : 'Woning afmelden',
          text                              : 'De woning die u wilt afmelden is ook uw huidige correspondentieadres. Geef een nieuw correspondentieadres door.',
          new_correspondence                : 'Nieuw correspondentieadres',
          other                             : 'Nieuw adres toevoegen',
          country                           : 'Land',
          select_a_country                  : 'Selecteer een land',
          option_NL                         : 'Nederland',
          option_BE                         : 'Belgie',
          option_DE                         : 'Duitsland',
          houseno_postal_code               : 'Postcode & Huisnummer',
          houseno_po_box                    : 'Postcode & Postbus',
          postal_code                       : 'Postcode',
          postal_code_placeholder           : '0000 AB',
          postal_code_placeholder_be        : '0000',
          postal_code_placeholder_de        : '00000',
          houseno_and_addtion               : 'Huisnummer & toevoeging',
          street                            : 'Straat',
          city                              : 'Plaats',
          po_box                            : 'Postbus',
          cancel                            : 'Vorige',
          save                              : 'Volgende',
          hints                             : {
            select_a_country   : '',
            postal_code        : '',
            houseno_and_addtion: '',
            street             : 'Dit wordt automatisch gevuld als u de postcode en huisnummer ingevuld heeft',
            city               : 'De plaats wordt automatisch gevuld na invullen postcode en huisnummer',
            po_box             : ''
          }
        },
        email: {
          page_title: 'Woning afmelden',
          cancel: 'Vorige',
          hints: {
            email: 'Uw e-mailadres waarmee wij contact met u op kunnen nemen'
          },
          email_request: {
            text: 'Wilt u de eindafrekening per e-mail ontvangen dan verzoeken wij u hier uw e-mailadres in te vullen:',
            label_short: 'E-mailadres',
            label: 'E-mailadres voor bevestiging',
            placeholder: 'E-mailadres'
          },
          email_post: {
            label: 'Mogen wij dit e-mailadres ook gebruiken om in de toekomst uw post digitaal te versturen?',
            yes: 'Ja',
            no: 'Nee'
          }
        },
        futuremail: {
          correspondence_email: 'Correspondentie e-mailadres',
          update_account_email: 'Dit e-mailadres is ook mijn mijnWML account e-mailadres.',
          sendcontrol_label: 'Factuur digitaal ontvangen?',
          email_post: {
            yes: 'Ja',
            no: 'Nee'
          },
          hints: {
            correspondence_email: 'Via dit e-mailadres ontvangt u alle post van WML',
            sendcontrol_label: 'sendcontrol_label'
          }
        },
        summary                   : {
          page_title        : 'Woning afmelden',
          date              : 'Datum',
          meter_reading     : 'Meterstand',
          meter_reading_edit: 'Meterstand wijzigen',
          email             : 'Persoonsgegevens',
          email_address_label: 'Correspondentie<br> e-mailadres',
          email_label       : 'E-mailadres voor bevestiging',
          email_edit        : 'E-mailadres wijzigen',
          email_post        : 'Post ontvangen via E-mail',
          address           : 'Adres',
          meter_number      : 'Meternummer',
          connection_address: 'Nieuw Correspondentieadres',
          current_connection_address: 'Correspondentieadres',
          address_edit      : 'Correspondentieadres wijzigen',
          po_box            : 'Postbus',
          future: {
            change_correspondence: 'Correspondentiegegevens wijzigen',
            correspondence: 'Correspondentiegegevens',
            email: 'E-mailadres',
            update_account_email: 'Dit e-mailadres is ook mijn mijnWML account e-mailadres.',
            digital: 'Digitaal post ontvangen?'
          },
          save              : 'Bevestigen',
          done              : 'Afronden',
          update_account_email : 'Dit e-mailadres is ook mijn mijnWML account e-mailadres.',
          already_unregistered_desc: 'De woning op onderstaand leveringsadres is al afgemeld. Kloppen de gegevens niet? Wijzig dit meteen of neem <a href=\"/contact\" title=\"Klantenservice\">contact</a> op met onze klantenservice.'
        },
        thank_you                 : {
          page_title: 'De woning is afgemeld voor drinkwaterlevering',
          text      : 'De woning is afgemeld voor drinkwaterlevering. U ontvangt hiervan een bevestiging per e-mail. Wij gaan uw gegevens verwerken in onze administratie en binnen twee weken ontvangt u de eindafrekening.',
          page_future_title: 'Bedankt voor uw toekomstige afmelding bij WML.',
          future_text: 'U ontvangt op {{date}} een herinnering per e-mail. Hierin vragen wij u de watermeterstand door te geven. U ontvangt dan uw eindafrekening.',
          btn       : 'Naar mijn overzicht',
          btn_home  : 'Naar de Home pagina'
        }
      },
      premises             : {
        action_overview : {
          premise_unregister_title     : 'Ik wil mijn woning afmelden voor drinkwaterlevering',
          premise_unregister_paragraph : 'Ga verder als u uw woning wilt afmelden voor drinkwaterlevering.',
          premise_unregister_paragraph2: 'Gaat u verhuizen en wilt u de oude woning afmelden? Dit gaat alleen als de sleuteloverdracht al is geweest.',
          premise_unregister_btn       : 'Ga verder',
          premise_register_title       : 'Ik wil mijn woning aanmelden voor drinkwaterlevering',
          premise_register_paragraph   : 'Ga verder als u uw woning wilt aanmelden voor drinkwaterlevering.',
          premise_register_paragraph2  : 'Gaat u verhuizen en wilt u de nieuwe woning aanmelden? Dit gaat alleen als de sleuteloverdracht al is geweest.',
          premise_register_btn         : 'Ga verder'
        },
        askContinueModal: {
          moving_in : {
            title     : 'De woning is aangemeld voor drinkwaterlevering.',
            paragraph : 'U ontvangt hiervan een bevestiging per e-mail',
            paragraph2: 'Gaat u verhuizen en wilt u de oude woning afmelden? Dit gaat alleen als de sleuteloverdracht al is geweest.',
            yes       : 'Ja',
            no        : 'Nee'
          },
          moving_out: {
            title     : 'De woning is afgemeld voor drinkwaterlevering.',
            paragraph : 'U ontvangt hiervan een bevestiging per e-mail',
            paragraph2: 'Gaat u verhuizen naar een nieuwe woning in Limburg en wilt u deze aanmelden? Dit gaat alleen als de sleuteloverdracht al is geweest.'
          }
        }
      },
      vacancy_page         : {
        titles: {
          description       : 'Beschrijving',
          core_activities   : 'Kernactiviteiten',
          edu_work_exp      : 'Opleiding & werkervaring',
          skills            : 'Vaardigheden & competenties',
          competences       : 'Competenties',
          other_info        : 'Overige informatie',
          content_info      : 'Inhoudelijke informatie',
          working_conditions: 'Arbeidsvoorwaardelijke informatie',
          procedure         : 'Interesse?'
        }
      },
      vacancyForm          : {
        apply_to_vacancy_text         : 'Wil je reageren op deze vacature? Vul dan onderstaand formulier in.',
        vacancy                       : 'Vacature',
        gender                        : 'Geslacht',
        male                          : 'M',
        female                        : 'V',
        name                          : 'Naam',
        street                        : 'Straatnaam',
        house_no_and_addition         : 'Huisnummer & toevoeging',
        house_no_placeholder          : '12',
        house_no_addition_placeholder : 'A',
        postal_code                   : 'Postcode',
        postal_code_placeholder       : '0000 AB',
        postal_code_placeholder_BE    : '0000',
        postal_code_placeholder_DE    : '00000',
        city                          : 'Woonplaats',
        country                       : 'Land',
        email                         : 'E-mailadres',
        phone                         : 'Telefoonnummer',
        vacancy_found_at              : 'Vacature gevonden via',
        conditions_accepted           : 'Ik heb de privacyverklaring sollicitanten gelezen en mhet versturen van mijn sollicitatiebrief en mijn curriculum vitae geef ik WML toestemming mijn persoonsgegevens te verwerken en op te nemen in de de database van WML. Ingeval ik WML ongevraagde en aanvullende persoonsgegevens verstrek, geef ik WML hierbij toestemming ook deze persoonsgegevens te verwerken.',
        conditions_text               : 'Je staat op het punt een sollicitatie in te dienen bij WML. WML heeft een privacyverklaring voor sollicitanten opgesteld. Hierin kun je lezen welke persoonsgegevens WML van jou verwerkt, met welke doelen en op welke wijze. Hieronder vragen wij toestemming om jouw sollicitatiebrief en curriculum vitae ten behoeve van de sollicitatie te verwerken. De privacyverklaring sollicitanten kun je <a href=\"/assets/privacyverklaring_sollicitanten.pdf\" target=\"_blank\">hier</a> downloaden.',
        conditions_revoke             : 'Je gegeven toestemming kun je altijd weer intrekken. Dit heeft geen terugwerkende kracht, de eerder onder de toestemming verrichte verwerkingen door WML blijven rechtsgeldig. WML zal na jouw intrekking de verwerking staken. Dit betekent dat de sollicitatieprocedure geen doorgang vindt. Stuur voor het intrekken van je toestemming een mail naar <a href=\"mailto:vacature@wml.nl?subject=Intrekken toestemming verwerken persoonsgegevens sollicitant\">vacature@wml.nl</a> en vermeld daarin je naam, om welke vacature het gaat en dat je de toestemming intrekt.',
        add_motivation_btn            : 'Motivatiebrief toevoegen',
        add_cv_btn                    : 'CV toevoegen',
        send_application_btn          : 'Verstuur sollicitatie',
        validation_error              : {
          max_size: 'Het is helaas bestand te groot. De maximale upload grote is 6MB.'
        }
      },
      detail_page          : {
        bottom_block_title : 'Regel al uw zaken zelf via mijnWML',
        bottom_block_text  : 'Donec vitae lobortis sapien, vel mattis justo. Quisque auctor eu ligula non vestibulum. Donec nisl nunc, commodo elementum lacus ac, scelerisque venenatis lectus. Maecenas elementum eu enim eget ultrices. Donec vitae lorem vulputate',
        bottom_block_button: 'Ga naar mijnWML',
        view_video         : 'Bekijk video',
        user_responses     : {
          title       : 'Reacties',
          form_title  : 'Reageren',
          form_name   : 'Naam',
          form_email  : 'E-mail',
          form_message: 'Bericht',
          form_send   : 'Verstuur'
        },
        read_more          : 'lees meer'
      },
      list_page            : {
        list_item_read_more: 'lees meer',
        page_counter       : '<strong>{{range}}</strong> van <strong>{{total}}</strong> items'
      },
      videoList: {
        btnDefaultTxt: 'Klik hier'
      },
      faq                  : {
        title           : 'Vraag en antwoord',
        other_question  : 'Heeft u een andere vraag?',
        text            : 'Bekijk de <a href=\"/veel-gestelde-vragen\">veelgestelde vragen</a> over andere onderwerpen of <a href=\"/contact\" title=\"Klantenservice\">stel ons een vraag</a>.',
        top_items       : 'Top {{length}} veelgestelde vragen',
        categories_title: 'Veelgestelde vragen per categorie',
        view_video      : 'Bekijk video'
      },
      breadcrumb           : {
        home             : 'Home',
        profile          : 'Mijn account',
        dashboard        : 'Mijn overzicht',
        customer         : 'Mijn persoonlijke gegevens',
        invoicesDashboard: 'Mijn financiële gegevens',
        usageDashboard   : 'Mijn verbruik'
      },
      standpipe            : {
        form          : {
          title                       : 'Standpijp aanvragen',
          company_name                : 'Bedrijfsnaam',
          client_name                 : 'Naam aanvrager',
          invoice_address             : 'Factuuradres',
          street                      : 'Straat / postbus',
          house_no_and_addition       : 'Huisnummer & toevoeging',
          postal_code                 : 'Postcode',
          city                        : 'Plaats',
          phone                       : 'Telefoonnummer',
          email                       : 'E-mail',
          invoice_electronic          : 'Ik wil mijn factuur via e-mail ontvangen',
          standpipe_location          : 'Locatie standpijp',
          location_contact_person     : 'Contactpersoon',
          location_phone              : 'Telefoonnummer',
          location_street             : 'Straat',
          location_house_no           : 'Huisnummer & toevoeging (dichtsbijzijnd)',
          location_postal_code        : 'Postcode',
          location_city               : 'Plaats',
          location_hydrant            : 'Brandkraannummer (indien bekend)',
          location_message            : 'Aanvullende informatie',
          location_message_irrigation : 'Aanvullende informatie (voor locaties)',
          date_time                   : 'Datum en tijdstip',
          date_time_text              : 'Uw aanvraag dient minimaal 5 werkdagen voor de gewenste plaatsingsdatum verstuurd te worden. Voor spoedaanvragen wordt € 76,- toeslag berekend.',
          date_time_text_irrigation   : 'Uw aanvraag dient minimaal 5 werkdagen voor de gewenste plaatsingsdatum verstuurd te worden. Na de initiële plaatsing van de standpijp door een monteur van WML, mag u zelf de standpijp plaatsen op de daartoe aangewezen brandkranen. Hiertoe dient u wel de gebruiksinstructies nauwlettend op te volgen.',
          date_start                  : 'Datum plaatsing (alleen werkdagen)',
          time_start                  : 'Tijdstip',
          date_end                    : 'Datum verwijdering (alleen werkdagen)',
          time_end                    : 'Tijdstip',
          text_presence_required      : 'Bij de plaatsing en verwijdering is aanwezigheid vereist. Als u niet aanwezig bent, wordt de standpijp niet geplaatst of verwijderd en worden voorrijkosten in rekening gebracht.',
          capacity                    : 'Capaciteit',
          capacity_standpipe          : 'Capaciteit standpijp',
          capacity_text_paragraph1    : 'Een standpijp met een capaciteit van 4 m3/uur is vergelijkbaar met een huisaansluiting. Een standpijp beschikt over twee tapkranen met een uitloopkoppeling van ¾”, waarop 2 slangen (type ‘tuinslang’) aangesloten kunnen worden. Sommige standpijpen beschikken over een ¾” Geka koppeling.',
          capacity_text_paragraph2    : '* Heeft u een hogere capaciteit dan 4 m3/uur geselecteerd, dan neemt onze afdeling Klantenservice telefonisch contact met u op. WML beoordeelt dan of de gewenste grotere capaciteit mogelijk is op de gewenste locatie en of deze bij WML voorradig is. Voor een grotere capaciteit betaalt u een hoger huurbedrag.',
          capacity_text_irrigation    : 'De beregeningsstandpijp is voorzien van een brandslang van 10 meter welke dient om uw buffer-bassin te vullen. Het is niet mogelijk uw beregeningsinstallatie rechtstreeks aan te sluiten op de standpijp.',
          treatment                   : 'Bent u voornemens om de standpijp aan te sluiten op een apparaat/installatie, stoffen toe te voegen aan het water of het te behandelen, alvorens u deze gebruikt?',
          treatment_option_yes        : 'Ja',
          treatment_option_no         : 'Nee',
          quality                     : 'Drinkwaterkwaliteit',
          quality_warn                : 'Leidingwater onttrokkken via een standpijp is geen officieel drinkwater. Voor gebruik als drinkwater geldt een kookadvies van 3 minuten. WML kan u helpen om uw evenement toch van bacteriologisch betrouwbaar water te voorzien. Onze afdeling Verkoop geeft u graag informatie. Telefoonnummer 043 880 8558.',
          quality_warn_irrigation     : 'Leidingwater onttrokken via een standpijp is geen officieel drinkwater. Voor gebruik als drinkwater geldt een kookadvies van 3 minuten.',
          consumption                 : 'Bent u voornemens het water uit de standpijp te gebruiken voor consumptieve doeleinden (drinkwater)?',
          consumption_option_yes      : 'Ja',
          consumption_option_no       : 'Nee',
          rates                       : 'Tarieven',
          terms_rent                  : 'Ik ga akkoord met de huurtarieven van WML',
          rates_irrigation            : 'De tarieven voor de beregeningsstandpijp zijn op aanvraag. We zullen hiervoor telefonisch contact met u opnemen.',
          terms                       : 'Voorwaarden',
          accept_conditions           : 'Ik ga akkoord met de <a href=\"/footer/huurvoorwaarden-standpijpen\" title=\"Huurvoorwaarden Standpijpen\">Huurvoorwaarden Standpijpen</a>, de <a href=\"/footer/algemene-voorwaarden\" title=\"Algemene Voorwaarden Drinkwater\">Algemene Voorwaarden Drinkwater</a> en de <a href=\"/footer/aanvullende-voorwaarden-zakelijke-diensten-wml-nv\" title=\"Aanvullende Voorwaarden Zakelijke Diensten WML NV\">Aanvullende Voorwaarden Zakelijke Diensten WML NV</a>.',
          accept_conditions_irrigation: 'Ik ga akkoord met de <a href=\"/footer/algemene-voorwaarden\" title=\"Algemene Voorwaarden Drinkwater\">Algemene Voorwaarden Drinkwater</a>, de <a href=\"/footer/aanvullende-voorwaarden-zakelijke-diensten-wml-nv\" title=\"Aanvullende Voorwaarden Zakelijke Diensten WML NV\">Aanvullende Voorwaarden Zakelijke Diensten WML NV</a> en de <a href=\"/footer/huurvoorwaarden-beregeningsstandpijpen\" title=\"Huurvoorwaarden Beregeningsstandpijpen\">Huurvoorwaarden Beregeningsstandpijpen</a>.',
          customer_research           : 'Klantonderzoek',
          customer_research_email     : 'WML mag mij periodiek via e-mail voorzien van informatie of vragen deel te nemen aan een klantonderzoek',
          send                        : 'Verstuur aanvraag',
          hints                       : {
            date_end           : 'Vul bij jaarhuur de datum van volgend jaar in bij verwijdering standpijp.',
            date_end_irrigation: 'Na ontvangst van dit formulier nemen wij telefonisch contact met u op om de exacte plaatsingslocatie(s) van de beregeningsstandpijp met u af te stemmen.',
            location_message   : 'Na ontvangst van dit formulier nemen wij telefonisch contact met u op om de exacte plaatsingslocatie(s) van de beregeningsstandpijp met u af te stemmen.'
          }
        },
        start_timeslot: {
          '0800-1200': '08.00 - 12.00 uur',
          '1230-1630': '12.30 - 16.30 uur'
        },
        end_timeslot  : {
          '0800-1200': '08.00 - 12.00 uur',
          '1230-1630': '12.30 - 16.30 uur',
          '1630-2400': '16.30 - 24.00 uur'
        },
        capacity      : {
          hour4 : '4 m3/uur',
          hour6 : '6 m3/uur',
          hour10: '10 m3/uur* (geen jaarhuur mogelijk)',
          hour16: '16 m3/uur* (geen jaarhuur mogelijk)',
          hour35: '35 m3 / uur'
        }
      },
      waterhardheid        : {
        postal_code            : 'Postcode',
        postal_code_placeholder: '0000 AB',
        house_no               : 'Huisnummer',
        house_no_placeholder   : '1',
        submit                 : 'Controleer uw hardheid'
      },
      damage_form          : {
        title                       : 'Schadeformulier',
        information_legend          : 'Persoons- en Adresgegevens',
        customer_number             : 'Klantnummer',
        name                        : 'Naam',
        initials                    : 'Voorletters',
        street                      : 'Straat',
        house_no                    : 'Huisnummer & toevoeging',
        postal_code                 : 'postcode',
        postal_code_placeholder     : '0000 AB',
        city                        : 'Plaats',
        phone_number                : 'Telefoonnummer',
        email                       : 'E-mail',
        iban                        : 'IBAN',
        damage_legend               : 'Schade',
        date                        : 'Datum',
        time                        : 'Tijdstip',
        location                    : 'Waar',
        about                       : 'Betreft',
        add_img_btn                 : 'Bijlagen m.b.t de schade toevoegen',
        upload_limit                : 'Het uploadlimiet is overschreden. U kunt maximaal <span>{{uploadLimit}}</span> aan afbeeldingen uploaden.',
        damage_report_label         : 'Heeft u de schade al gemeld bij uw eigen verzekering',
        damage_report_true          : 'Ja',
        damage_report_false         : 'Nee',
        insurance_agency            : 'Bij welke verzekeringsmaatschappij?',
        polis                       : 'Polisnummer',
        damage_cause                : 'Feitelijke omschrijving oorzaak schade',
        item_description            : 'Omschrijving',
        item_purchase_date          : 'Aankoopdatum',
        item_purchase_price         : 'Aanschafprijs',
        item_day_value              : 'Dagwaarde',
        item_estimated_damage       : 'Schatting schade c.q. herstelkosten',
        add_item                    : 'Voeg een nieuwe regel toe',
        declaration                 : 'Verklaring',
        send_form                   : 'Verstuur'
      },
      search               : {
        title      : 'Zoekresultaat',
        no_result  : 'Er is helaas geen resultaat gevonden.',
        search     : 'Zoeken',
        what       : 'Waar bent u naar op zoek?',
        btn        : 'Zoeken',
        placeholder: 'Doorzoek de website',
        read_more: 'Lees meer',
        no_suggestions: 'Geen suggesties',
        one_result: '1 resultaat gevonden',
        many_results: '<strong>%START%</strong> - <strong>%END%</strong> van <strong>%TOTAL%</strong> items',
        few_results: '%TOTAL% resultaten gevonden',
        no_results_for_query: 'Geen resultaten gevonden voor %QUERY%',
        previous: 'Vorige',
        next: 'Volgende'
      },
      corporation  : {
        title                 : 'Leveringsadres kiezen',
        text                  : 'Kies het leveringsadres waarvan u de gegevens wilt inzien.',
        search                : 'Zoeken',
        select_btn            : 'Selecteer adres',
        filter_active         : 'Actieve leveringsadressen',
        filter_inActive       : 'Inactieve leveringsadressen',
        contract_active_title : 'Actief:',
        contract_address_title: 'Leveringsadres:',
        active_from           : 'Van:',
        active_to             : 'Tot:',
        active_now            : 'heden',
        contract_info_title   : 'Contract:',
        contract_id_no        : 'Contractnummer:',
        contract_meter_no     : 'Meternummer:',
        contract_install_no   : 'Perceelnummer:'
      },
      carafe               : {
        form: {
          legend_company_info              : 'Bedrijfsgegevens',
          kvk_number                       : 'KvK-nummer',
          company_name                     : 'Bedrijfsnaam',
          contact_person_name              : 'Naam contactpersoon',
          contact_person_phone             : 'Telefoonnummer contactpersoon',
          contact_person_email             : 'E-mailadres contactpersoon',
          legend_address                   : 'Adres',
          company_street                   : 'Straat',
          postal_code                      : 'Postcode',
          company_house_number             : 'Huisnummer',
          company_city                     : 'Plaats',
          placeholder_housenumber          : '12',
          placeholder_housenumber_additions: 'A',
          placeholder_postal_code          : '0000 AB',
          legend_order                     : 'Bestelling',
          type_order                       : 'Type bestelling',
          choose_type                      : 'Kies een type',
          choose_type_option_first_set     : 'Eerste gratis 12 karaffen',
          choose_type_option_extra         : 'Extra karaffen tegen inkoopprijs - &euro;42.50 excl. BTW per 6 karaffen extra',
          order_amount                     : 'Extra karaffensets',
          questions                        : 'Eventuele vragen of opmerkingen',
          btn_send                         : 'Karaffen aanvragen',
          accept_conditions                : 'Ik ga akkoord met de <a href=\"/footer/voorwaarden-karaffen\" title=\"Verkoopvoorwaarden Karaffen\">voorwaarden</a> en tarieven voor extra karaffen'
        }
      },
      waterEstafette        : {
        form: {
          association: {
            title                          : 'Gegevens vereniging',
            name                           : 'Naam vereniging',
            type                           : 'Soort vereniging (bijv. voetbalvereniging)',
            postal_code                    : 'Postcode vereniging',
            placeholder_postal_code        : '0000 AB',
            city                           : 'Woonplaats vereniging'
          },
          contact    : {
            title: 'Gegevens contactpersoon',
            name : 'Naam contactpersoon vereniging',
            email: 'E-mailadres',
            phone: 'Mobiel nummer'
          },
          competitors: {
            title                  : 'Inschrijving (max. 15 personen)',
            number_of_persons_error: 'Let op: Het maximaal deelnemers per vereniging is 15. <br>U dient uw inschrijving aan te passen voordat u deze kunt verzenden.',
            type                   : 'Discipline',
            count                  : 'Aantal',
            distance               : 'Afstand',
            add_competitor         : 'Deelnemer(s) toevoegen'

          },
          btn_send   : 'Inschrijven'
        },
        vote_form : {
          title : 'Stemmen',
          city : 'Kies de locatie van de vereniging waarop u wilt stemmen',
          registrations : 'Verenigingen',
          already_voted : 'Uw stem is verwerkt, Bedankt voor uw stem!',
          btn_send : 'Stemmen'
        }
      },
      social: {
        share_page: "Deel deze pagina:"
      },
      overlay: {
        unavailable: {
          title: 'Website momenteel te druk',
          text: 'Op dit moment is de WML website niet goed bereikbaar.<br />Probeer het over een aantal minuten a.u.b. nogmaals.',
          link: 'Kijk op twitter voor de actuele informatie.'
        }
      },
      password: {
        criteria: {
          title: 'Uw wachtwoord moet voldoen aan:',
          min_length_single: 'Minimale lengte van 1 karakter',
          min_length_plural: 'Minimale lengte van {{value}} karakters',
          min_caps_single: 'Minimaal 1 hoofdletter',
          min_caps_plural: 'Minimaal {{value}} hoofdletters',
          min_lowercase_single: 'Minimaal 1 letter',
          min_lowercase_plural: 'Minimaal {{value}} letters',
          min_numbers_single: 'Minimaal 1 cijfer',
          min_numbers_plural: 'Minimaal {{value}} cijfers',
          min_special_chars_single: 'Minimaal 1 speciaal karakter',
          min_special_chars_plural: 'Minimaal {{value}} speciale karakters'
        }
      }
    });
})();

(function() {
  'use strict';

  angular.module('wml.portal.storage', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  socialSharing.$inject = ["$location"];
  function socialSharing($location) {
    return {
      restrict  : 'E',
      templateUrl : 'app/components/generic/directives/social/views/social-buttons.html',
      replace     : false,
      link: function(scope, iElem, iAttrs) {
        scope.currentUrl = $location.absUrl();
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('socialSharing', socialSharing)
})();

(function() {
  'use strict';

  angular.module('wml.portal.signup', []);

})();

(function() {
  'use strict';

  angular.module('wml.portal.standpipe', []);

})();

(function() {
  'use strict';

  angular.module('wml.portal.sideMenu', []);

})();

(function () {
  'use strict';

  waterhardheidService.$inject = ["RestangularExt"];
  function waterhardheidService(RestangularExt){

    function getHardness(postalCode, houseNumber){
      return RestangularExt.all('waterhardheid').customGET(null, {'postal_code' : postalCode, 'house_number': houseNumber});
    }

    return {
      getHardness : getHardness
    }
  }


  angular
    .module('wml.portal.waterhardheid')
    .factory('waterhardheidService', waterhardheidService)
})();

(function () {
  'use strict';

  waterEstafetteService.$inject = ["RestangularExt"];
  function waterEstafetteService(RestangularExt){
    var _formRouteRegister        = RestangularExt.all('/form/waterestafette/register');
    var _formRouteRegisterCities  = RestangularExt.all('/form/waterestafette/register/cities');
    var _formRouteVote            = RestangularExt.all('/form/waterestafette/vote');

    return {
      register              : register,
      getRegistrations      : getRegistrations,
      getRegistrationCities : getRegistrationCities,
      vote                  : vote
    };

    function register(data) {
      return _formRouteRegister.post(data);
    }

    function getRegistrations(city) {
      return _formRouteRegister.customGET(null,{city: city});
    }

    function getRegistrationCities() {
      return _formRouteRegisterCities.customGET();
    }

    function vote(registrationId) {
      return _formRouteVote.one(registrationId.id).post();
    }
  }


  angular
    .module('wml.portal.water-estafette')
    .factory('waterEstafetteService', waterEstafetteService)
})();

(function(){
  'use strict';

  videoListService.$inject = ["RestangularExt"];
  function videoListService(RestangularExt){
    var url = '/instellingen/website-blok-bodem';
    var _cache = null;

    function getBlockContent(){
      if(_cache === null){
        _cache = RestangularExt.all('proxy').customGET(null, {url: url});
      }
      return _cache;
    }

    return {
      getBlockContent : getBlockContent
    }

  }

  angular
    .module('wml.portal.videoList')
    .factory('videoListService', videoListService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.detailPage', []);

})();

(function(){
  'use strict';

  function vacancyDetailService(){

    var _defaults = {
      gender              : '',
      name                : '',
      street              : '',
      house_no            : '',
      house_no_addition   : '',
      postal_code         : '',
      city                : '',
      country             : 'NL',
      email               : '',
      phone               : '',
      vacancy_found_at    : '',
      motivation_file     : '',
      resume_file         : ''
    };

    var _data;
    _data = angular.copy(_defaults);

    return {
      data: _data
    }
  }

  angular
    .module('wml.portal.detailPage')
    .factory('vacancyDetailService', vacancyDetailService);

})();

(function() {
  'use strict';

  /** @ngInject */
  usageMeterReadingService.$inject = ["storage"];
  function usageMeterReadingService(storage) {

    return {
      setMeterReading: setMeterReading,
      getMeterReading: getMeterReading
    };

    function setMeterReading(data) {
      storage('meter_reading', data);
    }

    function getMeterReading() {
      return storage('meter_reading');
    }
  }

  angular.module('wml.portal.usage')
    .factory('usageMeterReadingService', usageMeterReadingService);

})();

(function() {
  'use strict';

  /** @ngInject */
  usageChartService.$inject = ["customerService", "$filter", "moment"];
  function usageChartService(customerService, $filter, moment) {

    var chartConfig = {
      chart: {
        type: 'column',
        height: '500',
        spacingTop: 40,
        spacingBottom: 40
      },
      colors: ['#abd4e9'],
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          useHTML: true,
          style: {
            display: 'flex',
            flexDirection: 'column'
          },
        },
        categories: []
      },
      yAxis: {
        min: 0,
        title: {
          text: ''
        },
        labels: {
          useHTML: true,
          format: '{value} m<sup>3</sup>'
        },
        tickInterval: 50,
        maxPadding: 0.5,
        stackLabels: {
          enabled: true,
          verticalAlign: 'middle',
          align: 'center',
          y: 0,
          useHTML:true,
          formatter: function() {return '<div class="chart-stackedLabel">'+this.total+' m<sup>3</sup></div>';},
          style: {
            fontSize: '10px',
            fontWeight: 'normal',
            color: '#fff',
            textShadow: "none",
            textOutline: "none"
          }
        },
        plotLines: [{
          value: 150,
          id: 'usagePlotline',
          color: '#000',
          width: 1,
          zIndex: 5
        }]
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            y: -20,
            shape: 'callout',
            borderRadius: 5,
            borderWidth: 1,
            borderColor:  '#0098db',
            backgroundColor: '#0098db',
            color: '#fff',
            align:'center',
            crop:false,
            overflow:'none',
            style:  {
              color: "#fff",
              fontSize: "13px",
              fontWeight: "normal",
              textOutline: "none"
            },
            useHTML:  true,
            inside:false,
            enabled: true
          }
        }
      },
      series: [{
        data: []
      }],
      title: {
        text: ''
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      }
    };

    var chartExtraConfig = {
      bShowChart              : false,
      selectedChartAddress    : {},
      chartFilterAddresses    : [],
      meter_reading_results   : [],
      exchanged               : false,
      exchangeDate            : null,
      isExchangeDateRecent    : false,
      smartMeter              : false
    };

    return {
      getConfig               : chartConfig,
      chartExtraConfig        : chartExtraConfig,
      initChart               : initChart,
      getConsumption          : getConsumption
    };

    function initChart(connections) {
      chartExtraConfig.chartFilterAddresses = connections.map(function (item) {
        if (item.device.serial_number) { // exclude if no serial_number. without you can't get consumption
          var option = {};
          option.label = _formatAddressString(item);
          option.value = {
            contract_account_id: item.contract_account_id,
            contract_id: item.contract_id,
            smart_meter: item.smart_meter
          };
          return option;
        }
      }).filter(function (stripEmpty) {
        return stripEmpty;
      });

      chartExtraConfig.selectedChartAddress = chartExtraConfig.chartFilterAddresses[0].value;

      getConsumption(chartExtraConfig.selectedChartAddress);
    }

    function getConsumption(address) {
      chartExtraConfig.smartMeter = address.smart_meter;
      if (!chartExtraConfig.smartMeter && address.contract_account_id && address.contract_id) {
        customerService.getConsumption(address.contract_account_id, address.contract_id, 'periodic').then(function(response) {
          chartExtraConfig.meter_reading_results = [];

          if (response[0]) {
            if (response[0].meter_reading_results) {
              chartExtraConfig.meter_reading_results = response[0].meter_reading_results.filter(function (item) {
                return !item.is_open;
              });
            }
            chartExtraConfig.exchanged = response[0].exchanged;
            chartExtraConfig.exchangeDate = response[0].exchange_date;
            if (chartExtraConfig.exchangeDate) {
              chartExtraConfig.isExchangeDateRecent = moment().subtract(3, 'years').isBefore(chartExtraConfig.exchangeDate);
            }
          }

          _composeChart(chartExtraConfig.meter_reading_results);
        });
      }
    }

    function _composeChart(data) {
      chartExtraConfig.bShowChart = true;

      data.reverse();
      var xAxisLabels = [];
      var aConsumptions = [];

      for(var i = 0; i < data.length; i++){
        if(data[i].previous_reading_date_time && data[i].consumption > 0){
          var label = $filter('date')(data[i].previous_reading_date_time, "dd-MM-yyyy") + '<br/>' + $filter('date')(data[i].reading_date_time, "dd-MM-yyyy");

          xAxisLabels.push(label);

          var formatted = '<div class="chart-label-text">' +
            '<strong>' + Math.round(data[i].daily_consumption_in_liter) + '</strong><br/>' +
            '<strong>liter</strong><br/>' +
            '<div class="chart-small-label-text">per dag</div>' +
            '</div>';

          aConsumptions.push(
            {
              y: data[i].consumption,
              dataLabels: {
                format: formatted
              }
            }
          );

        }
      }

      chartConfig.series[0].data = aConsumptions.slice(-3);
      chartConfig.xAxis.categories = xAxisLabels.slice(-3);
    }

    function _formatAddressString(item){
      if (angular.isDefined(item.address.house_no_addition) && item.address.house_no_addition.length) {
        return item.address.street + ' ' + item.address.house_no + ' ' + item.address.house_no_addition + ', ' + item.address.city;
      } else {
        return item.address.street + ' ' + item.address.house_no + ', ' + item.address.city;
      }
    }

  }

  angular.module('wml.portal.usage')
    .factory('usageChartService', usageChartService);

})();

(function() {
  'use strict';

  /** @ngInject */
  function storageService() {

    var _this = this;

    var STORAGE_LOCALSTORAGE    = 'localStorage';
    var STORAGE_SESSIONSTORAGE  = 'sessionStorage';

    var _defaultStorageEngine = STORAGE_LOCALSTORAGE;
    var _storageEngines       = [STORAGE_LOCALSTORAGE, STORAGE_SESSIONSTORAGE];
    var _storageKeyPrefix     = null;
    var _storages             = {};

    _this.setDefaultStorageEngine = function(engine) {
      if(_storageEngines.indexOf(engine) === -1) {
        throw new Error('Invalid storage engine.');
      }
      _defaultStorageEngine = engine;

      return _this;
    };

    _this.setStorageKeyPrefix  = function(prefix) {
      if(angular.isString(prefix)) {
        _storageKeyPrefix = prefix;
      }
      return _this;
    };

    _this.registerStorage  = function(storageKey, interceptor, parser, engine) {
      interceptor = (angular.isFunction(interceptor)) ? interceptor : function(data) {return data;};
      parser      = (angular.isFunction(parser)) ? parser : function(data) {return data};
      engine      = (_storageEngines.indexOf(engine) !== -1) ? engine : _defaultStorageEngine;

      if(!angular.isString(storageKey)) {
        throw new Error('storageKey needs to be a string');
      }

      if(_storageKeyPrefix) {
        storageKey  = [_storageKeyPrefix, storageKey].join('.');
      }

      if(angular.isDefined(_storages[storageKey])) {
        throw new Error('storage is already registered');
      }

      _storages[storageKey] = {
        engine      : engine,
        interceptor : interceptor,
        parser      : parser
      };

      return _this;
    };

    _this.lsTest = function (){
      var test = 'test';
      try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch(e) {
        return false;
      }
    };

    /** @ngInject */
    _this.$get = function($window) {
      return function(storageKey, value) {

        if(_this.lsTest() === true){
          // available
          if(_storageKeyPrefix) {
            storageKey  = [_storageKeyPrefix, storageKey].join('.');
          }

          if(angular.isUndefined(_storages[storageKey])) {
            throw new Error('Unknown storage with key: ' + storageKey);
          }

          var storage = _storages[storageKey];

          if(angular.isUndefined(value)) {
            // getter
            return storage.parser($window[storage.engine].getItem(storageKey));
          } else {
            // setter
            if(value === null) {
              $window[storage.engine].removeItem(storageKey);
            } else {
              $window[storage.engine].setItem(storageKey, storage.interceptor(value));
            }
            return true;
          }
        }
      }
    }
    _this.$get.$inject = ["$window"];
  }

  angular
    .module('wml.portal.storage')
    .provider('storage', storageService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.corporation', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  corporationStateCheckService.$inject = ["storage"];
  function corporationStateCheckService(storage) {

    var _allowedStates = [
      'accountOptions',
      'chooseAddress',
      'dashboard',
      'customerEdit',
      'profile',
      'profilePassword',
      'profileEmail',
      'invoices',
      'invoicesRemaining',
      'premisesActionOverview',
      'premisesRegister',
      'premisesRegisterMeterReading',
      'premisesRegisterNewPremises',
      'premisesRegisterSummary',
      'premisesRegisterThankYou',
      'premisesUnregisterMoveOutDate',
      'premisesUnregister',
      'premisesUnregisterMeterReading',
      'premisesUnregisterCorrespondenceAddress',
      'premisesUnregisterSummary',
      'premisesUnregisterThankYou'
    ];

    return {
      isAllowedSecureState: isAllowedSecureState
    };

    function isAllowedSecureState(state) {
      if(angular.isObject(storage('corporation_address'))){
        return _allowedStates.indexOf(state) !== -1;
      } else if (state === 'chooseAddress' || state === 'accountOptions') {
        return true;
      }
      return false;
    }

  }

  angular.module('wml.portal.corporation')
    .factory('corporationStateCheckService', corporationStateCheckService);

})();

(function(){
  'use strict';

  standpipeService.$inject = ["RestangularExt", "moment"];
  function standpipeService(RestangularExt, moment){
    var _standpipeRoute  = RestangularExt.all('/form/standpipe');

    return {
      send: send
    };

    function send(data) {
      var _data = angular.copy(data);

      if(angular.isDefined(_data.duration) && angular.isDefined(_data.duration.start_date)){
        _data.duration.start_date = moment(_data.duration.start_date).format('YYYY-MM-DD');
      }

      if(angular.isDefined(_data.duration) && angular.isDefined(_data.duration.end_date)){
        _data.duration.end_date = moment(_data.duration.end_date).format('YYYY-MM-DD');
      }

      return _standpipeRoute.post(_data);
    }
  }

  angular
    .module('wml.portal.standpipe')
    .factory('standpipeService', standpipeService);

})();

(function() {
  'use strict';

  /** @ngInject */
  signUpService.$inject = ["RestangularExt"];
  function signUpService(RestangularExt) {
    var _signUpRoute = RestangularExt.all('/customer/register');

    return {
      signUp   : signUp
    };

    function signUp(data){
      return _signUpRoute.post(data);
    }
  }

  angular.module('wml.portal.signup')
    .factory('signUpService', signUpService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.search', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  searchService.$inject = ["RestangularExt"];
  function searchService(RestangularExt) {

    return {
      search      : search
    };

    function search(query) {
      query = encodeURIComponent(query);
      return RestangularExt.oneUrl('bingcustomsearch', 'https://api.cognitive.microsoft.com/bingcustomsearch/v7.0/search?q='+query+'&customconfig=3578062967&responseFilter=Webpages&mkt=nl-NL&safesearch=Moderate').withHttpConfig({withCredentials : false}).get(null, {
        'Ocp-Apim-Subscription-Key': 'e55e549acc884c20aa600d4d1e76d3e2',
        'Authorization': ''});
    }

  }

  angular.module('wml.portal.search')
    .factory('searchService', searchService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.restBackend', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  restBackend.$inject = ["RestangularExt"];
  function restBackend(RestangularExt) {
    var _getSapStatusRoute = RestangularExt.all('/sap-status');
    var _getCrisisMsgRoute = RestangularExt.all('/crisis-msg');

    return {
      getSapStatus: getSapStatus,
      getCrisisMsg: getCrisisMsg
    };

    function getSapStatus() {
      return _getSapStatusRoute.customGET();
    }

    function getCrisisMsg() {
      return _getCrisisMsgRoute.customGET();
    }
  }

  angular.module('wml.portal.restBackend')
    .factory('restBackend', restBackend);

})();

(function() {
  'use strict';

  angular.module('wml.portal.restangular', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  RestangularExt.$inject = ["$rootScope", "Restangular"];
  function RestangularExt($rootScope, Restangular) {
    return Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.addRequestInterceptor(function(element) {
        $rootScope.$broadcast('wml.loader.start');
        return element;
      });

      RestangularConfigurer.addResponseInterceptor(function (data) {
        // intercept all responses and broadcast to the loader
        $rootScope.$broadcast('wml.loader.stop');

        return data;
      });

      RestangularConfigurer.setErrorInterceptor(function (response, deferred) {
        // intercept all errors and broadcast to the loader
        $rootScope.$broadcast('wml.loader.abort');
      });

    });
  }

  angular.module('wml.portal.restangular')
    .factory('RestangularExt', RestangularExt);

})();

(function() {
  'use strict';

  angular.module('wml.portal.registry', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  registryService.$inject = ["$windowProvider"];
  function registryService($windowProvider) {

    var _this = this;

    var _$window        = $windowProvider.$get();
    var _bDevelopment   = false;
    var _bBeta          = false;
    var _bTesting       = false;
    var _bAcceptance    = false;
    var _hostName       = _$window.location.hostname;
    var _bProduction = true; var _RestApi = 'https://api.wml.nl';

    _this.RestApi         = _RestApi;
    _this.DevelopmentMode = _bDevelopment;
    _this.BetaMode        = _bBeta;
    _this.TestingMode     = _bTesting;
    _this.AcceptanceMode  = _bAcceptance;
    _this.ProductionMode  = _bProduction;
    _this.hostName        = _hostName;

    _this.$get  = getModule;

    /** @ngInject */
    function getModule() {
      return {
        hostName        : _hostName,
        restApiUrl      : _this.RestApi,
        developmentMode : _this.DevelopmentMode,
        betaMode        : _this.BetaMode,
        testingMode     : _this.TestingMode,
        productionMode  : _this.ProductionMode
      };
    }

  }

  angular.module('wml.portal.registry')
    .provider('registry', registryService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.register', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  registerService.$inject = ["storage", "RestangularExt"];
  function registerService(storage, RestangularExt) {

    var _defaults = {
      insertions            : [],
      connectionAddress     : {
        premise_id                 : null,
        customerType               : 'residence',
        number_of_persons          : null,
        postal_code                : null,
        house_no                   : null,
        house_no_addition          : null,
        street                     : null,
        city                       : null,
        contract_id                : false,
        device_id                  : false,
        hasDifferentCorrespondence : false,
        meter_number              : false
      },
      correspondenceAddress : {
        country             : null,
        type                : null,
        postal_code         : null,
        house_no            : null,
        house_no_addition   : null,
        street              : null,
        city                : null,
        po_box_postal_code  : null,
        po_box              : null
      },
      personalInformation   : {
        customerType        : null,
        salutation          : null,
        initials            : null,
        insertion           : null,
        lastName            : null,
        birthday            : null,
        companyName         : null,
        phone               : null,
        mobile_phone        : null,
        email               : null,
        emailInvoice        : true,
        customerSurvey      : false
      },
      meterReading          : {
        date                : new Date(),
        deviation_code      : null,
        deviation_reason    : null,
        meter_reading       : '',
        num1                : 0,
        num2                : 0,
        num3                : 0,
        num4                : 0,
        num5                : 0,
        file_upload: {
          file: null,
          name: null,
          type: null,
        },
      },
      paymentMethod         : {
        payment_method      : {
          label: null,
          value: null
        },
        payment_frequency   : {
          label: null,
          value: null
        },
        payment_date        : {
          label: null,
          value: null
        },
        iban   : null
      },
      portalAccount           : {
        email                 : null,
        email_conformation    : null,
        password              : null,
        password_confirmation : null,
        isSet                 : null
      },
      summary                 : {
        conditionAccepted     : false
      },
      forced_meter_reading  : false,
      prospect: {
        exits: null,
        moveDate: null,
        premise: null
      },
      bIsInFuture: null,
      credentials: {
        postal_code: null,
        house_no: null,
        house_no_addition: null,
        future_move_token: ''
      }
    };

    var _registerData;

    if(storage('register_customer') !== null) {
      _registerData = storage('register_customer');
    } else {
      _registerData = angular.copy(_defaults);
    }

    return {
      data      : _registerData,
      storeData : storeData,
      clearData : clearData,
      save      : save,
      prospectToUser: prospectToUser
    };

    function storeData() {
      // do not save the file upload data to the cookie, base64 will become too big.
      var copy = angular.copy(_registerData);
      copy.fileUpload = null;
      // file object does not need to get saved in cookie
      if (copy.meterReading && copy.meterReading.file_upload) {
        copy.meterReading.file_upload.file = null;   // base64 can get too big to save in Fcookie.
      }
      storage('register_customer', copy);
    }

    function clearData() {
      _resetField(_registerData);
      storage('register_customer', null);
    }

    function save() {
      return RestangularExt.all('register').post(_registerData);
    }

    function prospectToUser() {
      return RestangularExt.all('register/prospect-to-user').post(_registerData);
    }

    function _resetField(field, keyPath) {
      keyPath = keyPath || [];

      if(angular.isObject(field)) {
        for(var key in field) {
          if(field.hasOwnProperty(key)) {
            keyPath.push(key);
            if(angular.isObject(field[key]) && angular.isObject(_defaultForKey(keyPath))) {
              // keyPath.pop();
              _resetField(field[key], keyPath);
            } else {
              field[key]  = _defaultForKey(keyPath);
              keyPath.pop();
            }
          }
        }
        keyPath.pop();
      }
    }

    function _defaultForKey(keyPath) {
      var tmpValue  = angular.copy(_defaults);
      for(var i=0; i < keyPath.length; i++) {
        if(angular.isDefined(tmpValue[keyPath[i]])) {
          tmpValue  = tmpValue[keyPath[i]]
        } else {
          return null;
        }
      }
      return tmpValue;
    }
  }

  angular.module('wml.portal.register')
    .factory('registerService', registerService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.profile', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  profileService.$inject = ["RestangularExt", "storage"];
  function profileService(RestangularExt, storage) {
    var _profileRoute         = RestangularExt.all('/profile');
    var _changePasswordRoute  = RestangularExt.all('/profile/password');
    var _changeEmailRoute     = RestangularExt.all('/profile/email');

    return {
      getProfile:     getProfile,
      changePassword: changePassword,
      changeEmail:    changeEmail
    };

    function getProfile() {
      return _profileRoute.customGET();
    }

    function changePassword(data) {
      var obj = {
        current_password: data.current_password,
        password: data.password,
        password_confirmation: data.password_confirmation,
      };

      if(storage('activation_query')){
        obj = angular.extend(obj, storage('activation_query'));
      }

      return _changePasswordRoute.customPUT(obj);
    }

    function changeEmail(data) {
      var obj = {
        email: data.email,
        email_confirmation: data.email_confirmation,
        email_update_correspondence: data.update_correspondence_email || false,
      };

      return _changeEmailRoute.customPUT(obj);
    }
  }

  angular.module('wml.portal.profile')
    .factory('profileService', profileService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.premises', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  premisesService.$inject = ["$q", "$uibModal", "$rootScope", "storage", "$translate", "registry", "ivAuthenticate"];
  function premisesService($q, $uibModal, $rootScope, storage, $translate, registry, ivAuthenticate) {

    return {
      storeProcesStatus   : storeProcesStatus,
      getProcesStatus     : getProcesStatus,
      clearProcesStatus   : clearProcesStatus,
      askToContinueModal  : askToContinueModal,
      getCsvExportUrl     : getCsvExportUrl
    };

    function storeProcesStatus(data){
      storage('premises_procces_status', data);
    }

    function getProcesStatus(){
      return storage('premises_procces_status');
    }

    function clearProcesStatus(){
      storage('premises_procces_status', null);
    }

    function askToContinueModal() {
      var _deferred           = $q.defer();
      var _scope              = $rootScope.$new();
      _scope.title            = $translate.instant('premises.askContinueModal.' + storage('premises_procces_status') + '.title');
      _scope.paragraph        = $translate.instant('premises.askContinueModal.' + storage('premises_procces_status') + '.paragraph');
      _scope.paragraph2       = $translate.instant('premises.askContinueModal.' + storage('premises_procces_status') + '.paragraph2');

      _scope.modal = $uibModal.open({
        templateUrl: 'app/components/premises/partials/ask-to-continue.modal.partial.html',
        backdrop: 'static',
        scope: _scope,
        size: 'lg'
      });

      _scope.cancel = function(){
        _scope.modal.close();
        _deferred.reject();
      };

      _scope.next = function(){
        _scope.modal.close();
        _deferred.resolve();
      };
      return _deferred.promise;
    }

    function getCsvExportUrl() {
      return registry.restApiUrl + '/customer/'+ storage('customer_number') +'/premise/export/csv?access_token=' + ivAuthenticate.getAccessToken();
    }

  }

  angular.module('wml.portal.premises')
    .factory('premisesService', premisesService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.premisesUnregister', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  premiseUnregisterService.$inject = ["$rootScope", "storage", "RestangularExt"];
  function premiseUnregisterService($rootScope, storage, RestangularExt) {

    var _defaults = {
      address: {
        premise_id : null,
        postal_code : null,
        house_no          : null,
        house_no_addition : null,
        city              : null,
        street            : null
      },
      meter_reading:{
        date : null,
        last_meter_reading_date: null,
        deviation_code  : null,
        deviation_reason  : null,
        meter_reading: '',
        num1  : 0,
        num2  : 0,
        num3  : 0,
        num4  : 0,
        num5  : 0,
        file_upload: {
          file: null,
          name: null,
          type: null,
        },
      },
      correspondence: {
        bSetNew     : false,
        type        : null,
        country     : null,
        city        : null,
        postal_code : null,
        po_box_postal_code : null,
        po_box            : null,
        street            : null,
        house_no          : null,
        house_no_addition : null,
        confirmationEmail: null,
        bSetAsNewEmail: false
      },
      forced_meter_reading: false,
      futureMoveOut: {
        exits: null,
        moveDate: null,
        premise: null
      },
      bIsInFuture: null,
      credentials: {
        customer_number: null,
        postal_code: null,
        house_no: null,
        house_no_addition: null,
        future_move_token: '',
        grant_type: null
      },
      email: {
        correspondence_exists: false,
        correspondence: null,
        update_account_email: false,
        digital: false,
        bSetNew: false
      },
      afterNewRegister: false
    };

    $rootScope.$on("clear-cache", function () {
      clearData();
    });

    var _unregisterData;

    if (storage('premises_unregister') !== null) {
      _unregisterData = storage('premises_unregister');
    } else {
      _unregisterData = angular.copy(_defaults);
    }

    return {
      storeData   : storeData,
      clearData   : clearData,
      data        : _unregisterData,
      unregister  : unregister
    };

    function storeData() {
      // do not save the file upload data to the cookie, base64 will become too big.
      var copy = angular.copy(_unregisterData);
      copy.fileUpload = null;
      // file object does not need to get saved in cookie
      if (copy.meter_reading && copy.meter_reading.file_upload) {
        copy.meter_reading.file_upload.file = null;   // base64 can get too big to save in Fcookie.
      }
      storage('premises_unregister', copy);
    }

    function clearData(){
      _resetField(_unregisterData);
      storage('premises_unregister', null);
      sessionStorage.removeItem('short_token');
    }

    function unregister() {
      return RestangularExt.one('customer', storage('customer_number')).one('premise', _unregisterData.address.premise_id).post('move-out', _unregisterData);
    }

    function _resetField(field, keyPath) {
      keyPath = keyPath || [];

      if(angular.isObject(field)) {
        for(var key in field) {
          if(field.hasOwnProperty(key)) {
            keyPath.push(key);
            if(angular.isObject(field[key]) && angular.isObject(_defaultForKey(keyPath))) {
              _resetField(field[key], keyPath);
            } else {
              field[key]  = _defaultForKey(keyPath);
              keyPath.pop();
            }
          }
        }
        keyPath.pop();
      }
    }

    function _defaultForKey(keyPath) {
      var tmpValue  = angular.copy(_defaults);
      for(var i=0; i < keyPath.length; i++) {
        if(angular.isDefined(tmpValue[keyPath[i]])) {
          tmpValue  = tmpValue[keyPath[i]]
        } else {
          return null;
        }
      }
      return tmpValue;
    }

  }

  angular.module('wml.portal.premisesUnregister')
    .factory('premiseUnregisterService', premiseUnregisterService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.premisesRegister', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  premiseRegisterService.$inject = ["$rootScope", "storage", "RestangularExt"];
  function premiseRegisterService($rootScope, storage, RestangularExt) {
    var _premiseRegisterRoute = RestangularExt.all('/customer');

    var _defaults = {
      address: {
        premise_id: null,
        postal_code       : null,
        house_no          : null,
        house_no_addition : null,
        city              : null,
        street            : null,
        meter_number      : null,
        contract_id       : false,
        device_id         : false
      },
      currentCorrespondenceAddress: {
        country     : null,
        city        : null,
        postal_code : null,
        po_box_postal_code : null,
        po_box            : null,
        street            : null,
        house_no          : null,
        house_no_addition : null
      },
      correspondence: {
        address_id  : false,
        bSetNew     : false,
        type        : null,
        country     : null,
        city        : null,
        postal_code : null,
        po_box_postal_code : null,
        po_box            : null,
        street            : null,
        house_no          : null,
        house_no_addition : null
      },
      meter_reading:{
        date : null,
        deviation_code  : null,
        deviation_reason  : null,
        meter_reading: '',
        num1  : 0,
        num2  : 0,
        num3  : 0,
        num4  : 0,
        num5  : 0,
        file_upload: {
          file: null,
          name: null,
          type: null,
        },
      },
      forced_meter_reading: false,
      prospect: {
        exits: null,
        moveDate: null,
        premise: null
      },
      bIsInFuture: null,
      credentials: {
        postal_code: null,
        house_no: null,
        house_no_addition: null,
        future_move_token: ''
      },
      email: {
        correspondence: null,
        update_account_email: false,
        digital: false,
        bSetNew: false
      }
    };

    $rootScope.$on("clear-cache", function () {
      clearData();
    });

    var _registerData;

    if(storage('premises_register') !== null){
      _registerData = storage('premises_register');
    } else {
      _registerData = angular.copy(_defaults);
    }

    return {
      storeData : storeData,
      clearData : clearData,
      // isProspectCheck : isProspectCheck,
      data      : _registerData,
      register  : register
    };

    function storeData() {
      // do not save the file upload data to the cookie, base64 will become too big.
      var copy = angular.copy(_registerData);
      copy.fileUpload = null;
      // file object does not need to get saved in cookie
      if (copy.meter_reading && copy.meter_reading.file_upload) {
        copy.meter_reading.file_upload.file = null;   // base64 can get too big to save in Fcookie.
      }
      storage('premises_register', copy);
    }

    function clearData(){
      storage('premises_register', null);
      _resetField(_registerData);
      sessionStorage.removeItem('short_token');
    }

    function register() {
      return _premiseRegisterRoute.one(storage('customer_number')).one('premise', _registerData.address.premise_id).post('move-in', _registerData);
    }

    // function isProspectCheck(postalCode, houseNumber, houseNumberAddition) {
    //     //   return RestangularExt.one('prospect').customGET(null, {postal_code: postalCode, house_number: houseNumber, house_number_addition: houseNumberAddition});
    //     // }

    function _resetField(field, keyPath) {
      keyPath = keyPath || [];

      if(angular.isObject(field)) {
        for(var key in field) {
          if(field.hasOwnProperty(key)) {
            keyPath.push(key);
            if(angular.isObject(field[key]) && angular.isObject(_defaultForKey(keyPath))) {
              // keyPath.pop();
              _resetField(field[key], keyPath);
            } else {
              field[key]  = _defaultForKey(keyPath);
              keyPath.pop();
            }
          }
        }
        keyPath.pop();
      }
    }

    function _defaultForKey(keyPath) {
      var tmpValue  = angular.copy(_defaults);
      for(var i=0; i < keyPath.length; i++) {
        if(angular.isDefined(tmpValue[keyPath[i]])) {
          tmpValue  = tmpValue[keyPath[i]]
        } else {
          return null;
        }
      }
      return tmpValue;
    }
  }

  angular.module('wml.portal.premisesRegister')
    .factory('premiseRegisterService', premiseRegisterService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.news', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  newsService.$inject = ["RestangularExt"];
  function newsService(RestangularExt) {

    return {
      addComment: addComment
    };

    function addComment(name, email, message, content_index) {
      return RestangularExt.all('news/comment').post({
        name         : name,
        email        : email,
        message      : message,
        content_index: content_index
      });
    }
  }

  angular.module('wml.portal.news')
    .factory('newsService', newsService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.navigation', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  navigationService.$inject = ["RestangularExt", "$q", "$stateRegistry", "HeaderSwitchRoute", "MessageRoute", "FooterRoute", "ivAuthenticate", "$state", "$transitions"];
  function navigationService(RestangularExt, $q, $stateRegistry, HeaderSwitchRoute, MessageRoute, FooterRoute, ivAuthenticate, $state, $transitions) {
    var _cache        = {
      header: [],
      footer: []
    };
    var _parsedCache  = null;

    /** @ngInject */
    var translationLoadedFn = function($q, $translate, $interval) {
      var deferred  = $q.defer();

      var checkInterval = $interval(function() {
        if($translate.isReady()) {
          $interval.cancel(checkInterval);
          deferred.resolve();
        }
      }, 100);

      return deferred.promise;
    };
    translationLoadedFn.$inject = ["$q", "$translate", "$interval"];

    $transitions.onStart({
      to: function (state) {

        angular.forEach(_cache.header, function(item){
          item.active     = false;
        });

        function setActive(childItem) {
          if(childItem.parentId) {
            angular.forEach(_cache.header, function(item){
              if(item.id === childItem.parentId){
                item.active = true;

                if(angular.isDefined(item.parentId)) {
                  setActive(item);
                }
              }
            })
          }
        }

        angular.forEach(_cache.header, function(item){
          if(item.name === state.name){
            item.active = true;

            setActive(item)
          }
        });
      }
    });

    return {
      load          : load,
      getStateByUrl : getStateByUrl,
      getMenu       : _cache
    };


    function fetch(callback) {
      if(angular.equals(_cache, {header: [], footer: []})) {
        RestangularExt.all('navigation').customGET().then(function(response){
          var data  = response.plain();
          for(var key in data) {
            if(_cache[key] && data.hasOwnProperty(key)) {
              _cache[key].splice(0, _cache[key].length);
              for(var i=0; i < data[key].length; i++) {
                _cache[key].push(data[key][i]);
              }
            }
          }
          callback(_cache);
        });
      } else {
        callback(_cache);
      }
    }

    function load() {
      if(!_parsedCache) {
        var deferred  = $q.defer();
        fetch(function(items) {
          angular.forEach(items, function(navBlock) {
            angular.forEach(navBlock, function(item, key) {
              var templateUrl;
              var controller;
              var controllerAs;
              var resolve;

              switch(item.type) {
                case 'default'  : {
                  templateUrl   = 'app/components/detail-page/views/detail-page.view.html';
                  controller    = 'DetailPageController';
                  controllerAs  = 'detail';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;} };
                } break;

                case 'list'  : {
                  templateUrl   = 'app/components/list-page/views/list-page.view.html';
                  controller    = 'ListPageController';
                  controllerAs  = 'list';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;} };
                } break;
                case 'vacancy-list':
                case 'vacancy-list-internal'  : {
                  templateUrl   = 'app/components/vacancy/views/vacancy-list.view.html';
                  controller    = 'VacancyListController';
                  controllerAs  = 'list';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;} };
                } break;
                case 'detail'  : {
                  templateUrl   = 'app/components/detail-page/views/detail-page.view.html';
                  controller    = 'DetailPageController';
                  controllerAs  = 'detail';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;}, detailId: function () {return item.detail;} };
                } break;
                case 'vacancy-detail'  : {
                  templateUrl   = 'app/components/vacancy/views/vacancy-detail.view.html';
                  controller    = 'VacancyDetailController';
                  controllerAs  = 'detail';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;}, detailId: function () {return item.detail;} };
                } break;
                case 'standpipe'  : {
                  templateUrl   = 'app/components/standpipe/views/standpipe.view.html';
                  controller    = 'StandpipeController';
                  controllerAs  = 'detail';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;}, detailId: function () {return item.detail;} };
                } break;
                case 'carafe'  : {
                  templateUrl   = 'app/components/carafe/views/carafe.view.html';
                  controller    = 'CarafeController';
                  controllerAs  = 'detail';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;}, detailId: function () {return item.detail;} };
                } break;
                case 'water-estafette'  : {
                  templateUrl   = 'app/components/water-estafette/views/registration.view.html';
                  controller    = 'waterEstafetteRegistrationController';
                  controllerAs  = 'detail';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;}, detailId: function () {return item.detail;} };
                } break;
                case 'water-estafette-vote'  : {
                  templateUrl   = 'app/components/water-estafette/views/vote.view.html';
                  controller    = 'waterEstafetteVoteController';
                  controllerAs  = 'detail';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;}, detailId: function () {return item.detail;} };
                } break;
                case 'waterhardheid' : {
                  templateUrl   = 'app/components/waterhardheid/views/waterhardheid.view.html';
                  controller    = 'waterhardheidController';
                  controllerAs  = 'waterhardheid';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;} };
                } break;
                case 'damage-form' : {
                  templateUrl   = 'app/components/damage-form/views/damage-form.view.html';
                  controller    = 'damageFormController';
                  controllerAs  = 'damage';
                  resolve       = {translationsLoaded  : translationLoadedFn, pageType: function() {return item.type}, contentId: function() {return item.id;} };
                } break;
                case 'video-list': {
                  templateUrl = 'app/components/video-list/views/video-list.view.html';
                  controller = 'VideoListController';
                  controllerAs = 'videoList';
                  resolve = { translationsLoaded: translationLoadedFn, pageType: function () { return item.type; }, contentId: function () { return item.id; } };
                } break;
              }

              var state = {
                name  : item.name,
                url: item.url,
                views: {
                  header: HeaderSwitchRoute,
                  message: MessageRoute,
                  content: {
                    templateUrl: templateUrl,
                    controller: controller,
                    controllerAs: controllerAs
                  },
                  footer: FooterRoute
                },
                resolve : resolve
              };

              var bannerView = 'banners@' + item.name;

              state.views[bannerView] = {
                templateUrl     : 'app/components/banners/views/banners.view.html',
                controller      : 'BannersController',
                controllerAs    : 'banner'
              };

              var sideMenuConfig = 'sideMenu@' + item.name;

              state.views[sideMenuConfig] = {
                templateUrl     : 'app/components/side-menu/views/side-menu.view.html',
                controller      : 'SideMenuController',
                controllerAs    : 'sideMenu'
              };

              $stateRegistry.register(state);

              ivAuthenticate.addInsecureState(item.name);
            });
          });

          deferred.resolve(true);
        });
        _parsedCache  = deferred.promise;
      }

      return _parsedCache;
    }

    function getStateByUrl(urlPath) {
      var states  = $state.get();
      for(var j=0; j < $state.get().length; j++) {
        if(states[j].url === urlPath) {
          return states[j].name;
        }
      }

      return false;
    }

  }

  angular.module('wml.portal.navigation')
    .factory('navigationService', navigationService);

})();

(function () {
  'use strict';

  angular.module('wml.portal.meterReading', []);
})();

(function() {
  'use strict';

  /** @ngInject */
  meterReadingService.$inject = ["RestangularExt", "$q", "$filter", "$rootScope", "storage"];
  function meterReadingService(RestangularExt, $q, $filter, $rootScope, storage) {

    var _defaults = {
      date : null,
      deviations: null,
      deviation_code: null,
      deviation_reason: null,
      deviation_text: null,
      meter_reading: '',
      keep_installment_amount: null,
      num1: '',
      num2: '',
      num3: '',
      num4: '',
      num5: '',
      num6: '',
      num7: '',
      email: '',
      optional_email: false,
      forced_meter_reading: false,
      forced_meter_reading_err_code: null,
      consumption: null,
      file_upload: {
        file: null,
        name: null,
        type: null,
      },
      address: {
        city: null,
        house_no: null,
        house_no_addition: null,
        postal_code: null,
        street: null,
      },
      meter_number: null,
      credentials: {
        assignment_number: null,
        postal_code: null,
        meter_reading: null,
      }
    };

    var _meterReadingRoute = RestangularExt.all('/meter-reading');

    var cacheServiceName = 'meterreading';
    var cache = {
      list  : null
    };

    var _meterReadingData;

    if (storage('meter_readings') !== null) {
      _meterReadingData = storage('meter_readings');
    } else {
      _meterReadingData = angular.copy(_defaults);
    }

    function clearData() {
      _resetField(_meterReadingData);
      $rootScope.$broadcast('clear-cache', {meterreading: true});
      storage('meter_readings', null);
    }

    function _resetField(field, keyPath) {
      keyPath = keyPath || [];

      if (angular.isObject(field)) {
        for (var key in field) {
          if (field.hasOwnProperty(key)) {
            keyPath.push(key);
            if (angular.isObject(field[key]) && angular.isObject(_defaultForKey(keyPath))) {
              _resetField(field[key], keyPath);
            } else {
              field[key] = _defaultForKey(keyPath);
              keyPath.pop();
            }
          }
        }
        keyPath.pop();
      }
    }

    function _defaultForKey(keyPath) {
      var tmpValue = angular.copy(_defaults);
      for (var i = 0; i < keyPath.length; i++) {
        if (angular.isDefined(tmpValue[keyPath[i]])) {
          tmpValue = tmpValue[keyPath[i]];
        } else {
          return null;
        }
      }
      return tmpValue;
    }

    $rootScope.$on("clear-cache", function(evt, evtData) {
      var key;
      if(angular.isObject(evtData)) {
        if(evtData[cacheServiceName]) {
          if(typeof evtData[cacheServiceName] === 'boolean' && evtData[cacheServiceName] === true) {
            for(key in cache) {
              cache[key] = null;
            }
          } else if(angular.isObject(evtData[cacheServiceName])) {
            for(key in cache) {
              if(typeof evtData[cacheServiceName][key] === 'boolean' && evtData[cacheServiceName][key] === true) {
                cache[key]  = null;
              }
            }
          }
        }
      } else {
        for(key in cache) {
          cache[key] = null;
        }
      }
    });

    return {
      getMeterReadings: getMeterReadings,
      setMeterReading: setMeterReading,
      getWFL: getWFL,
      setWFL: setWFL,
      checkMeterReading: checkMeterReading,
      meterReadingCheck: meterReadingCheck,
      verifyReading: verifyReading,
      meterDetails: meterDetails,
      storeData: storeData,
      clearData: clearData,
      data: _meterReadingData
    };

    function getMeterReadings() {
      if (!cache.list) {
        cache.list = _meterReadingRoute.getList();
      }
      return cache.list;
    }

    function storeData() {
      // do not save the file upload data to the cookie, base64 will become too big.
      var copy = angular.copy(_meterReadingData);
      copy.fileUpload = null;
      // file object does not need to get saved in cookie
      if (copy.file_upload) {
        copy.file_upload.file = null;   // base64 can get too big to save in cookie.
      }
      storage('meter_readings', copy);
    }

    function setMeterReading(assignmentNumber, postalCode, meterReading, force, date, deviationCode, deviationText, deviationReason, email, file_upload, keep_installment_amount) {

      date = $filter('date')(date, 'yyyy-MM-ddTHH:mm:ss');

      // 20170828 - rob@ivengi.com -  Do not parse as int due to parsing octal when string starts with one
      //                              or more zeroes in older javascript engines!
      //                              Parsing to integer logic moved to API!
      // meterReading = parseInt(meterReading);
      force = (typeof force === 'boolean') ? force : false;

      if (force === true) {
        if (angular.isDefined(deviationCode) === false) {
          $q.reject();
        }
      }

      deviationCode = deviationCode || null;
      deviationText = deviationText || null;
      deviationReason = deviationReason || null;

      return _meterReadingRoute.one(assignmentNumber).post(null, {
        reading: meterReading,
        force: force,
        date: date,
        deviation_code: deviationCode,
        deviation_text: deviationText,
        deviation_reason: deviationReason,
        postal_code: postalCode,
        email: email,
        file_upload: file_upload,
        keep_installment_amount: keep_installment_amount
      });
    }

    function getWFL(data) {
      return _meterReadingRoute.one(data.assignment_number).all('wfl').customGET();
    }

    function setWFL(data, wflAmount, wflMonth) {
      return _meterReadingRoute.one(data.assignment_number + '/wfl').post(null, {
        wfl_amount: wflAmount,
        wfl_month: wflMonth
      });
    }

    // regular yearly meterreading check
    function checkMeterReading(assignmentNumber, postalCode, meterReading, date) {
      date = $filter('date')(date, 'yyyy-MM-ddTHH:mm:ss');

      return _meterReadingRoute.one(assignmentNumber + '/check').post(null, {
        reading: meterReading,
        date: date,
        postal_code: postalCode,
      });
    }

    // function used to check meterreading for registering or moving in / out, where there probably is no assignment id (unlike regular yearly meterreading check that uses checkMeterReading)
    function meterReadingCheck(postalCode, meterReading, date, contractId, deviceId, moveReason) {
      date = $filter('date')(date, 'yyyy-MM-ddTHH:mm:ss');
      var data = {
        reading: meterReading,
        date: date,
        postal_code: postalCode,
        contract_id: contractId,
        device_id: deviceId,
        move_reason: moveReason
      };

      return _meterReadingRoute.customPOST(data, 'check');
    }

    function verifyReading(data) {
      return _meterReadingRoute.one(data.assignment_number).all('verify-address').customPOST({postal_code : data.postal_code})
    }

    function meterDetails(data) {
      return _meterReadingRoute.one(data.assignment_number).all('meter-details').customGET(null,{postal_code : data.postal_code})
    }
  }

  angular.module('wml.portal.meterReading')
    .factory('meterReadingService', meterReadingService);
})();

(function() {
  'use strict';

  angular.module('wml.portal.invoices', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  invoicesService.$inject = ["$rootScope", "$q", "Restangular", "RestangularExt", "storage"];
  function invoicesService($rootScope, $q, Restangular, RestangularExt, storage) {
    var _customerRoute = RestangularExt.all('/customer');
    var cache = {
      account_balance : null
    };
    var _aInvoices = [];

    $rootScope.$on("clear-cache", function(evt, evtData) {
      _aInvoices            = [];
      cache.account_balance = null;
    });

    return {
      getInvoices               : getInvoices,
      getInvoiceDetail          : getInvoiceDetail,
      startPayment              : startPayment,
      getAccountBalance         : getAccountBalance,
      getProcessPaymentStatus   : getProcessPaymentStatus,
      postInstallmentPlan       : postInstallmentPlan,
      getInstallmentPlanChecks  : getInstallmentPlanChecks
    };

    function getInvoices(params, refresh) {
      params = params || {};

      var paramsString = '';
      angular.forEach(params, function(value, key){
        paramsString += key + '_' + value + '_';
      });

      var deferred = $q.defer();

      if (angular.isUndefined(_aInvoices[paramsString]) || refresh) {
        _customerRoute.one(storage('customer_number')).getList('invoice', params).then(function (response) {
          _aInvoices[paramsString] = response;
          _parseData(response);
        });
      } else {
        _parseData(_aInvoices[paramsString]);
      }

      function _parseData(response) {
        var len = response.length;
        for (var i = 0; i < len; i++) {
          if (response[i].selectable) {
            response[i].selected = false;
          }
        }
        deferred.resolve(response);
      }

      return deferred.promise;
    }

    function getProcessPaymentStatus(id) {
      return Restangular.all('/payment').customGET('postback', {id: id});
    }

    function getInstallmentPlanChecks(contractAccountId) {
      return _customerRoute.one(storage('customer_number')).one('contract-account', contractAccountId).one('installment-plan-checks').get();
    }

    function postInstallmentPlan(contractAccountId, paymentArrangement, invoice) {
      var data = {
        paymentArrangement: paymentArrangement,
        invoice: invoice
      };
      return _customerRoute.one(storage('customer_number')).one('contract-account', contractAccountId).all('installment-plan').post(data);
    }

    function getInvoiceDetail(id) {
      return Restangular.all('/customer').one(storage('customer_number')).one('invoice', id).get();
    }

    function getAccountBalance() {
      if(!cache.account_balance) {
        cache.account_balance = _customerRoute.one(storage('customer_number')).one('account-balance').get();
      }
      return cache.account_balance;
    }

    function startPayment(invoices) {
      return _customerRoute.one(storage('customer_number')).customPOST({
        invoices  : invoices
      }, 'invoice/pay');
    }
  }

  angular.module('wml.portal.invoices')
    .factory('invoicesService', invoicesService);

})();



(function() {
  'use strict';

  angular.module('wml.portal.incidents', []);
})();

(function() {
  'use strict';

  /** @ngInject */
  incidentService.$inject = ["RestangularExt", "$q", "$translate"];
  function incidentService(RestangularExt, $q, $translate) {

    var _cache = null;

    return {
      load  : load
    };

    function load() {
      if(_cache === null) {
        var deferred  = $q.defer();
        _cache  = deferred.promise;

        RestangularExt.all('incidents').getList().then(function(response) {
          var malfunctions  = response.filter(function(item) {
            return item.is_malfunction;
          });

          var planned_incidents = response.filter(function(item) {
            return (!item.is_malfunction);
          });
          var translationOnePromise = (malfunctions.length === 1) ? $translate('header.incidents.malfunctions_prefix_single') : $translate('header.incidents.malfunctions_prefix_plural');
          // eslint-disable-next-line no-negated-condition
          var translationTwoPromise = (malfunctions.length !== 1) ? $translate('header.incidents.malfunctions_plural') : '';

          $q.all(
            [
              translationOnePromise,
              translationTwoPromise
            ]
          ).then(function (malfunctionTranslations) {
            deferred.resolve({
              total: {
                malfunctions: malfunctions.length,
                planned_incidents: planned_incidents.length,
                combined: (malfunctions.length + planned_incidents.length)
              },
              malfunctions: malfunctions,
              planned_incidents: planned_incidents,
              malfunctions_prefix: malfunctionTranslations[0],
              malfunctions_plural: malfunctionTranslations[1]
            });
          });
        }, function(error) {
          deferred.reject(error);
        });
      }

      return _cache;
    }

  }

  angular.module('wml.portal.incidents')
    .factory('incidentService', incidentService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.home', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  homeService.$inject = ["RestangularExt"];
  function homeService(RestangularExt) {

    var url = '/home';
    var _cache = null;

    function getData(){
      if(_cache === null){
        _cache = RestangularExt.all('proxy').customGET(null, {url: url});
      }
      return _cache;
    }

    return {
      getData : getData
    }

  }

  angular.module('wml.portal.home')
    .factory('homeService', homeService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.header', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  headerService.$inject = ["RestangularExt", "$q", "navigationService"];
  function headerService(RestangularExt, $q, navigationService) {

    var _header = null;

    return {
      loadData  : loadData
    };

    function loadData() {
      if(_header === null) {
        var deferred  = $q.defer();

        RestangularExt.all('proxy').customGET(null, {url  : '/instellingen/headers'}).then(function(response) {
          for(var i = 0; i < response.links_left.length; i++){
            response.links_left = response.links_left.map(function(item) {
              item.name = navigationService.getStateByUrl(item.link);
              return item;
            });
          }

          for(var j = 0; j < response.links_right.length; j++){
            response.links_right = response.links_right.map(function(item) {
              item.name = navigationService.getStateByUrl(item.link);
              return item;
            });
          }

          deferred.resolve(response);
        });

        _header = deferred.promise;
      }

      return _header;
    }

  }

  angular.module('wml.portal.header')
    .factory('headerService', headerService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.footer', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  footerService.$inject = ["RestangularExt", "navigationService", "$q"];
  function footerService(RestangularExt, navigationService, $q) {

    var _footer = null;

    return {
      loadData  : loadData
    };

    function loadData() {
      if(_footer === null) {
        var deferred  = $q.defer();

        navigationService.load().then(function() {
          RestangularExt.all('proxy').customGET(null, {url  : '/instellingen/footer'}).then(function(response) {
            for(var i in response) {
              if(response.hasOwnProperty(i)){
                for(var j in response[i]) {
                  if(response[i].hasOwnProperty(j)){
                    if(angular.isArray(response[i][j])) {
                      response[i][j]  = response[i][j].map(function(item) {
                        item.name = navigationService.getStateByUrl(item.link);
                        return item;
                      });
                    }
                  }
                }
              }
            }
            deferred.resolve(response);
          });
        });

        _footer = deferred.promise;
      }

      return _footer;
    }

  }

  angular.module('wml.portal.footer')
    .factory('footerService', footerService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.faq', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  faqService.$inject = ["RestangularExt"];
  function faqService(RestangularExt) {

    //url to FAQs
    var _faqRoute  = RestangularExt.all('/proxy');
    var _faq = null;

    return{
      getFaqs : getFaqs
    };

    //get FAQ's from url. stateName can be send from controller to get specific FAQs
    function getFaqs(){
      if(_faq === null){
        _faq = _faqRoute.customGET(null, {url  : '/instellingen/faq'})
      }
      return _faq;
    }

  }

  angular.module('wml.portal.faq')
    .factory('faqService', faqService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.enum', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  enumService.$inject = ["$rootScope", "RestangularExt"];
  function enumService($rootScope, RestangularExt) {
    var _enumRoute = RestangularExt.all('enum');

    var cacheServiceName  = 'enum';
    var cache = {
      salutations         : null,
      insertions          : null,
      countries           : null,
      addressTypes        : null,
      paymentMethods      : null,
      paymentFrequency    : null,
      paymentDates        : null,
      weekdays            : null,
      dayparts            : null,
      contactform         : null,
      businesscontactform : null,
      standpipe           : null,
      sendcontrol         : null
    };

    $rootScope.$on("clear-cache", function(evt, evtData) {
      var key;
      if(angular.isObject(evtData)) {
        if(evtData[cacheServiceName]) {
          if(typeof evtData[cacheServiceName] === 'boolean' && evtData[cacheServiceName] === true) {
            for(key in cache) {
              cache[key] = null;
            }
          } else if(angular.isObject(evtData[cacheServiceName])) {
            for(key in cache) {
              if(typeof evtData[cacheServiceName][key] === 'boolean' && evtData[cacheServiceName][key] === true) {
                cache[key]  = null;
              }
            }
          }
        }
      } else {
        for(key in cache) {
          cache[key] = null;
        }
      }
    });

    return {
      getSalutations                  : getSalutations,
      getCountries                    : getCountries,
      getAddressTypes                 : getAddressTypes,
      getPaymentMethods               : getPaymentMethods,
      getPaymentFrequency             : getPaymentFrequency,
      getPaymentDates                 : getPaymentDates,
      getWeekdays                     : getWeekdays,
      getDayparts                     : getDayparts,
      getContactFormSubjects          : getContactFormSubjects,
      getBusinessContactFormSubjects  : getBusinessContactFormSubjects,
      getInsertions                   : getInsertions,
      getStandpipe                    : getStandpipe,
      getSendControl                  : getSendControl
    };

    function getSalutations() {
      if(cache.salutations === null){
        cache.salutations = _enumRoute.one('salutation').getList();
      }
      return cache.salutations;
    }

    function getCountries() {
      if(cache.countries === null){
        cache.countries = _enumRoute.one('country').getList();
      }
      return cache.countries;
    }

    function getAddressTypes() {
      if(cache.addressTypes === null){
        cache.addressTypes = _enumRoute.one('address').getList();
      }
      return cache.addressTypes;
    }

    function getPaymentMethods() {
      if(cache.paymentMethods === null){
        cache.paymentMethods = _enumRoute.one('paymentmethod').getList();
      }
      return cache.paymentMethods;
    }

    function getPaymentFrequency() {
      if(cache.paymentFrequency === null){
        cache.paymentFrequency = _enumRoute.one('paymentfrequency').getList();
      }
      return cache.paymentFrequency;
    }

    function getPaymentDates() {
      if(cache.paymentDates === null){
        cache.paymentDates = _enumRoute.one('paymentdate').getList();
      }
      return cache.paymentDates;
    }

    function getWeekdays() {
      if(cache.weekdays === null){
        cache.weekdays = _enumRoute.one('weekday').getList();
      }
      return cache.weekdays;
    }

    function getDayparts() {
      if(cache.dayparts === null){
        cache.dayparts = _enumRoute.one('timeslot').customGET();
      }
      return cache.dayparts;
    }

    function getContactFormSubjects() {
      if(cache.contactform === null) {
        cache.contactform = _enumRoute.one('contactform').customGET();
      }
      return cache.contactform;
    }

    function getBusinessContactFormSubjects() {
      if(cache.businesscontactform === null) {
        cache.businesscontactform = _enumRoute.one('businesscontactform').customGET();
      }
      return cache.businesscontactform;
    }

    function getInsertions() {
      if(!cache.insertions) {
        cache.insertions  = RestangularExt.all('enum/insertion').getList();
      }

      return cache.insertions;
    }

    function getStandpipe(type, fieldname) {
      var cacheName = type + fieldname;

      if(!cache[cacheName]) {
        cache[cacheName]  = RestangularExt.all('enum/standpipe/' + type + '|' + fieldname).getList();
      }

      return cache[cacheName];
    }

    function getSendControl() {
      if(!cache.sendcontrol) {
        cache.sendcontrol  = RestangularExt.all('enum/sendcontrol').getList();
      }

      return cache.sendcontrol;
    }
  }


  angular.module('wml.portal.enum')
    .factory('enumService', enumService);

})();

(function(){
  'use strict';

  detailService.$inject = ["RestangularExt"];
  function detailService(RestangularExt){
    var url = '/instellingen/website-blok-bodem';
    var _cache = null;

    function getBlockContent(){
      if(_cache === null){
        _cache = RestangularExt.all('proxy').customGET(null, {url: url});
      }
      return _cache;
    }

    return {
      getBlockContent : getBlockContent
    }

  }

  angular
    .module('wml.portal.detailPage')
    .factory('detailService', detailService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.dashboard', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  function dashboardService() {


    return {

    };


  }

  angular.module('wml.portal.dashboard')
    .factory('dashboardService', dashboardService);

})();

(function(){
  'use strict';

  angular.module('wml.portal.damage-form', []);
})();

(function(){
  'use strict';

  function damageFormService(){
    var _defaults = {
      customer_number       : '',
      name                  : '',
      initials              : '',
      street                : '',
      house_number          : '',
      house_number_addition : '',
      postal_code           : '',
      city                  : '',
      phone                 : '',
      email                 : '',
      iban                  : '',
      date                  : '',
      time                  : '',
      location              : '',
      about                 : '',
      img                   : null,
      report_insurance      : false,
      insurance_agency      : '',
      polis                 : '',
      damage_cause          : '',
      damagedItems          : [
        {
          description       : '',
          purchase_date     : '',
          purchase_price    : '',
          day_value         : '',
          estimated_damage  : ''
        }
      ],
      accept_declaration    : false
    };

    var _data = angular.copy(_defaults);

    function clearData(){
      return _data = angular.extend(_data, _defaults);
    }

    return {
      data      : _data,
      clearData : clearData
    }
  }
  angular
    .module('wml.portal.damage-form')
    .factory('damageFormService', damageFormService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.customer', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  customerService.$inject = ["$rootScope", "$q", "RestangularExt", "storage"];
  function customerService($rootScope, $q, RestangularExt, storage) {
    var _customerRoute  = RestangularExt.all('/customer');

    var cacheServiceName  = 'customer';
    var cache = {
      premise   : null,
      address   : null,
      customer  : null,
      customers : null
    };

    $rootScope.$on("clear-cache", function(evt, evtData) {
      var key;
      if(angular.isObject(evtData)) {
        if(evtData[cacheServiceName]) {
          if(typeof evtData[cacheServiceName] === 'boolean' && evtData[cacheServiceName] === true) {
            for(key in cache) {
              cache[key] = null;
            }
          } else if(angular.isObject(evtData[cacheServiceName])) {
            for(key in cache) {
              if(typeof evtData[cacheServiceName][key] === 'boolean' && evtData[cacheServiceName][key] === true) {
                cache[key]  = null;
              }
            }
          }
        }
      } else {
        for(key in cache) {
          cache[key] = null;
        }
      }
    });

    return {
      hasFutureMove         : hasFutureMove,
      getFutureMove         : getFutureMove,
      getFutureMoveCustomerNr: getFutureMoveCustomerNr,
      getCustomer           : getCustomer,
      getCustomers          : getCustomers,
      getPremises           : getPremises,
      getPremise            : getPremise,
      getInfo               : getInfo,
      getEmail              : getEmail,
      getAddress            : getAddress,
      getAddresses          : getAddresses,
      saveAddress           : saveAddress,
      clearAddressCache     : clearAddressCache,
      getContractAccount    : getContractAccount,
      savePaymentDetails    : savePaymentDetails,
      getBudgetBillingPlan  : getBudgetBillingPlan,
      setBudgetBillingPlan  : setBudgetBillingPlan,
      setReadingResult      : setReadingResult,
      getConsumption        : getConsumption,
      getDataLogger         : getDataLogger
    };

    function hasFutureMove(moveData) {
      return _customerRoute.one(storage('customer_number')).customGET('future-move', {postal_code: moveData.postal_code, house_number: moveData.house_no, house_number_addition: moveData.house_no_addition});
    }

    function getFutureMove(moveData) {
      return _customerRoute.one(storage('customer_number')).customGET('future-move', {request_code: moveData.future_move_token, postal_code: moveData.postal_code, house_number: moveData.house_no, house_number_addition: moveData.house_no_addition});
    }

    function getFutureMoveCustomerNr(futureMoveToken) {
      return _customerRoute.one(storage('customer_number')).customGET('future-move', {request_code: futureMoveToken});
    }

    function getCustomer() {
      if (cache.customer === null) {
        cache.customer = _customerRoute.one(storage('customer_number')).get();
      }
      return cache.customer;
    }

    function getCustomers() {
      if (cache.customers === null) {
        cache.customers = _customerRoute.getList();
      }
      return cache.customers;
    }

    function getPremises(params) {
      if (angular.isDefined(params)) {
        // When filtered dont cache and return promise
        return _customerRoute.one(storage('customer_number')).getList('premise', params);
      }

      if(cache.premise === null && angular.isUndefined(params)) {
        cache.premise = _customerRoute.one(storage('customer_number')).getList('premise');
      }
      return cache.premise;
    }

    function getPremise(premiseId) {
      return _customerRoute.one(storage('customer_number')).one('premise', premiseId).get();
    }

    function getInfo(contract) {
      return _customerRoute.one(storage('customer_number')).one('info').get(contract);
    }

    function getEmail() {
      return _customerRoute.one(storage('customer_number')).one('email').get();
    }

    function getAddress() {
      if(cache.address === null) {
        var deferred  = $q.defer();
        cache.address = deferred.promise;

        _customerRoute.one(storage('customer_number')).getList('address', {standard: true}).then(function(data) {
          deferred.resolve(data[0]);
        });
      }
      return cache.address;
    }

    function getAddresses() {
      if(cache.addresses === null) {
        cache.addresses = _customerRoute.one(storage('customer_number')).getList('address');
      }
      return cache.addresses;
    }

    function saveAddress(address) {
      return _customerRoute.one(storage('customer_number')).all('address').post(address);
    }

    function clearAddressCache() {
      cache.address = null;
    }

    function getContractAccount(contactAccountId) {
      return _customerRoute.one(storage('customer_number')).one('contract-account', contactAccountId).get();
    }

    function savePaymentDetails(contractAccountId, contractId, data) {
      return _customerRoute.one(storage('customer_number')).one('contract-account', contractAccountId).one('contract', contractId).all('payment-details').customPUT(data);
    }

    function getBudgetBillingPlan(contractAccountId, contractId) {
      return _customerRoute.one(storage('customer_number')).one('contract-account', contractAccountId).one('contract', contractId).customGET('budget-billing-plan');
    }

    function setBudgetBillingPlan(contractAccountId, contractId, data) {
      return _customerRoute.one(storage('customer_number')).one('contract-account', contractAccountId).one('contract', contractId).all('budget-billing-plan').customPUT(data);
    }

    function setReadingResult(contractAccountId, contractId, budgetBillingPlanId, meterReading) {
      return _customerRoute.one(storage('customer_number')).one('contract-account', contractAccountId).one('contract', contractId).one('budget-billing-plan', budgetBillingPlanId).customGET("recommendation", meterReading);
    }

    function getConsumption(contractAccountId, contractId, aggregate) {
      aggregate = aggregate || null;

      var getParams = {};
      if(aggregate) {
        getParams.aggregate = aggregate;
      }

      return _customerRoute.one(storage('customer_number')).one('contract-account', contractAccountId).one('contract', contractId).one('consumption').get(getParams);
    }

    function getDataLogger(contractAccountId, contractId, params) {
      var getParams = params || {};
      return _customerRoute.one(storage('customer_number')).one('contract-account', contractAccountId).one('contract', contractId).one('data-logger').get(getParams);
    }

  }

  angular.module('wml.portal.customer')
    .factory('customerService', customerService);

})();



(function () {
  'use strict';

  /** @ngInject */
  corporationService.$inject = ["$rootScope", "RestangularExt", "registry", "ivAuthenticate", "storage"];
  function corporationService($rootScope, RestangularExt, registry, ivAuthenticate, storage) {

    var cacheServiceName = 'corporation';
    var cache = {
      activeAddresses: null,
      inActiveAddresses: null
    };

    $rootScope.$on("clear-cache", function (evt, evtData) {
      var key;
      if (angular.isObject(evtData)) {
        if (evtData[cacheServiceName]) {
          if (typeof evtData[cacheServiceName] === 'boolean' && evtData[cacheServiceName] === true) {
            for (key in cache) {
              cache[key] = null;
            }
          } else if (angular.isObject(evtData[cacheServiceName])) {
            for (key in cache) {
              if (typeof evtData[cacheServiceName][key] === 'boolean' && evtData[cacheServiceName][key] === true) {
                cache[key] = null;
              }
            }
          }
        }
      } else {
        for (key in cache) {
          cache[key] = null;
        }
      }
    });

    return {
      getAddresses        : getAddresses,
      getAddressInfo      : getAddressInfo,
      getCsvExportUrl     : getCsvExportUrl
    };

    function getAddresses(activeAddresses, refresh) {
      if (refresh || (!cache.activeAddresses && activeAddresses) || (!cache.inActiveAddresses && !activeAddresses)) {
        var result = RestangularExt.all('corporation/address').getList({inactive: !activeAddresses}).then(function(items) {
          return items.map(function (item) {
            var searchkey = item.street + item.house_number + item.house_number_addition + item.postal_code + item.city + item.installation_id + item.serial_number_id + item.contract_id;
            item.searchkey = searchkey.replace(/\s/g, '').toLowerCase();
            return item;
          });
        });

        if (activeAddresses) {
          cache.activeAddresses = result;
        } else {
          cache.inActiveAddresses = result;
        }
      }
      return (activeAddresses ? cache.activeAddresses : cache.inActiveAddresses);
    }

    function getAddressInfo(postalCode, houseNumber, houseNumberAddition) {
      var getParams = {
        postal_code: postalCode,
        house_number: houseNumber
      };

      if (houseNumberAddition) {
        getParams.house_number_addition = houseNumberAddition;
      }

      return RestangularExt.all('corporation/address').customGET(null, getParams);
    }

    function getCsvExportUrl() {
      var url   = registry.restApiUrl + '/corporation/address/export/csv?access_token=' + ivAuthenticate.getAccessToken();

      if(storage('customer_number')) {
        url = url + '&customer=' + storage('customer_number');
      }

      return url;
    }

  }

  angular.module('wml.portal.corporation')
    .factory('corporationService', corporationService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.contactperson', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  contactPersonService.$inject = ["$q", "$rootScope", "Restangular", "RestangularExt", "storage", "customerService"];
  function contactPersonService($q, $rootScope, Restangular, RestangularExt, storage, customerService) {
    var _customerRoute  = RestangularExt.all('/customer');

    var cacheServiceName  = 'contactperson';
    var cache = {
      contactperson   : null
    };

    var updated = {};

    $rootScope.$on("clear-cache", function(evt, evtData) {
      var key;
      if(angular.isObject(evtData)) {
        if(evtData[cacheServiceName]) {
          if(typeof evtData[cacheServiceName] === 'boolean' && evtData[cacheServiceName] === true) {
            for(key in cache) {
              cache[key] = null;
            }
          } else if(angular.isObject(evtData[cacheServiceName])) {
            for(key in cache) {
              if(typeof evtData[cacheServiceName][key] === 'boolean' && evtData[cacheServiceName][key] === true) {
                cache[key]  = null;
              }
            }
          }
        }
      } else {
        for(key in cache) {
          cache[key] = null;
        }
      }
    });

    return {
      load                            : load,
      save                            : save,
      remove                          : remove,
      addUpdate                       : addUpdate,
      getUpdated                      : getUpdated,
      getAdministrationContactPerson  : getAdministrationContactPerson
    };

    function load(accountId, withLoader) {
      withLoader  = (typeof withLoader === 'boolean') ? withLoader : false;

      var restangularRef  = (withLoader) ? RestangularExt : Restangular;

      accountId = accountId || storage('customer_number');

      var key =  'account_' + accountId;

      cache.contactperson = cache.contactperson || {};

      if(!cache.contactperson[key]) {
        cache.contactperson[key]  = restangularRef.one('customer', accountId).get();
      }

      return cache.contactperson[key].then(function(data) {

        function checkForUpdate(accountId, data) {
          if(updated[accountId]) {
            for(var key in updated[accountId]) {
              data[key] = updated[accountId][key];
            }
            data.customer_number  = updated[accountId].relation_account_id;

            var email;
            if(angular.isString(updated[accountId].email)) {
              email = updated[accountId].email;
            } else if(angular.isObject(updated[accountId].email) && updated[accountId].email.correspondence) {
              email = updated[accountId].email.correspondence;
            }

            data.email  = {
              correspondence  : email
            };

            return data;
          }

          return data;
        }

        return checkForUpdate(accountId, data);
      });
    }

    function getAdministrationContactPerson() {
      var deferred2 = $q.defer();

      load(undefined, true).then(function (response) {
        var deferred  = $q.defer();

        deferred.promise.then(function(data) {
          deferred2.resolve(data);
        }, function() {
          customerService.getCustomer().then(function(response) {
            deferred2.resolve(response);
          });
        });

        if(response.contact_persons && response.contact_persons.length) {
          var bFound  = false;
          for(var i = 0; i < response.contact_persons.length; i++) {
            if(response.contact_persons[i].account_relationship_type === 'administration') {
              bFound= true;
              load(response.contact_persons[i].related_account_id, true).then(function(data) {
                for(var key in updated) {
                  if(updated[key].relation_type === 'administration') {
                    data.customer_number  = key;
                    data.email  = updated[key].email;
                  }
                }

                var email = null;
                if(angular.isString(data.email)) {
                  email = data.email;
                } else if(angular.isObject(data.email) && data.email.correspondence) {
                  email = data.email.correspondence;
                }

                data.email  = {
                  correspondence  : email
                };

                deferred.resolve(data);
              });
            }
          }
          if(bFound === false) {
            deferred.reject();
          }
        } else {

          for(var key in updated) {
            if(updated[key].relation_type === 'administration') {
              response.customer_number  = key;
              response.email  = updated[key].email;
            }
          }

          var email = null;
          if(angular.isString(response.email)) {
            email = response.email;
          } else if(angular.isObject(response.email) && response.email.correspondence) {
            email = response.email.correspondence;
          }

          response.email  = {
            correspondence  : email
          };
          deferred.resolve(response);
        }
      });

      return deferred2.promise;
    }

    function getUpdated() {
      return updated;
    }

    function save(data, mode) {
      if(!angular.isObject(data)) {
        $q.reject();
      }

      if (mode === 'EDIT') {
        return _customerRoute.one(storage('customer_number')).all('contact-person').customPUT(data);
      } // else 'ADD'
      return _customerRoute.one(storage('customer_number')).all('contact-person').customPOST(data);
    }

    function remove(data) {
      if (!angular.isObject(data)) {
        $q.reject();
      }
      return _customerRoute.one(storage('customer_number')).customDELETE('contact-person', data);
    }

    function addUpdate(accountId, data) {
      updated[accountId]  = data;
    }
  }

  angular.module('wml.portal.contactperson')
    .factory('contactPersonService', contactPersonService);

})();

(function(){
  'use strict';

  angular.module('wml.portal.carafe', []);

})();

(function(){
  'use strict';

  carafeService.$inject = ["RestangularExt"];
  function carafeService(RestangularExt){
    var _carafeRoute  = RestangularExt.all('/form/carafe');

    return {
      send: send
    };

    function send(data) {
      var _data = angular.copy(data);
      if(_data.company.house_number_addition.length){
        _data.company.house_number = _data.company.house_number + ' ' +  _data.company.house_number_addition;
      }
      _data.order.amount = parseInt(_data.order.amount);

      return _carafeRoute.post(_data);
    }
  }


  angular
    .module('wml.portal.carafe')
    .factory('carafeService', carafeService);

})();

(function () {
  'use strict';

  angular.module('wml.portal.calendars', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  calendarsService.$inject = ["RestangularExt"];
  function calendarsService(RestangularExt) {
    // url to imanager
    var _calendarRoute = RestangularExt.all('/proxy');
    var _calendar = null;
    var _calendarSettings = {};

    return {
      getCalendars: getCalendars
    };

    // get calendars's from url
    function getCalendars(type) {
      if (_calendar === null) {
        _calendar = _calendarRoute.customGET(null, {url: '/instellingen/calendars'});
      }
      return _calendar.then(function (response) {
        _calendarSettings = {
          premisesUnregister: {
            moveOutMaxDate: Number(response.premesis_unregister_max_date_move_out.data),
            moveOutMinDate: Number(response.premesis_unregister_min_date_move_out.data),
            meterReadingMaxDate: Number(response.premesis_unregister_max_date_meter_reading.data),
            meterReadingMinDate: Number(response.premesis_unregister_min_date_meter_reading.data),
            moveOutMaxDateCorporation: Number(response.premesis_unregister_max_date_move_out_corporation.data),
            moveOutMinDateCorporation: Number(response.premesis_unregister_min_date_move_out_corporation.data),
            meterReadingMaxDateCorporation: Number(response.premesis_unregister_max_date_meter_reading_corporation.data),
            meterReadingMinDateCorporation: Number(response.premesis_unregister_min_date_meter_reading_corporation.data)
          },
          premisesRegister: {
            moveInMaxDate: Number(response.premesis_register_max_date_move_in.data),
            moveInMinDate: Number(response.premesis_register_min_date_move_in.data),
            meterReadingMaxDate: Number(response.premesis_register_max_date_meter_reading.data),
            meterReadingMinDate: Number(response.premesis_register_min_date_meter_reading.data),
            moveInMaxDateCorporation: Number(response.premesis_register_max_date_move_in_corporation.data),
            moveInMinDateCorporation: Number(response.premesis_register_min_date_move_in_corporation.data),
            meterReadingMaxDateCorporation: Number(response.premesis_register_max_date_meter_reading_corporation.data),
            meterReadingMinDateCorporation: Number(response.premesis_register_min_date_meter_reading_corporation.data)
          },
          register: {
            moveInMaxDate: Number(response.register_max_date.data),
            moveInMinDate: Number(response.register_min_date.data),
            meterReadingMaxDate: Number(response.register_max_date_meter_reading.data),
            meterReadingMinDate: Number(response.register_min_date_meter_reading.data)
          },
          meterReading: {
            maxDate: Number(response.meter_reading_max_date.data),
            minDate: Number(response.meter_reading_min_date.data)
          }
        };
        return _calendarSettings[type];
      });
    }
  }

  angular.module('wml.portal.calendars')
    .factory('calendarsService', calendarsService);
})();

(function() {
  'use strict';
  
  angular.module('wml.portal.breadcrumbs', []);
  
})();

(function() {
  'use strict';

  /** @ngInject */
  function breadcrumbs() {

    var _this     = this;
    var _mappings = {};

    function validateRegisterObj(obj) {
      if(angular.isObject(obj)) {
        var requiredProperties  = ['path', 'states'];
        for(var i=0; i < requiredProperties.length; i++) {
          if(angular.isDefined(obj[requiredProperties[i]]) && angular.isArray(obj[requiredProperties[i]])) {
            return true;
          }
        }
      }
      return false;
    }

    _this.register  = function(registerObj) {
      if(validateRegisterObj(registerObj) === false) {
        throw new Error('Invalid breadcrumb register object');
      }

      var key = registerObj.path.join('_');

      if(angular.isDefined(_mappings[key])) {
        throw new Error('Breadcrumb path is already defined');
      }

      _mappings[key]  = registerObj;

      return _this;
    };


    /** @ngInject */
    _this.$get  = function($state, $translate) {
      return {
        getPath : getPath
      };

      function getPath() {
        for(var key in _mappings) {
          if(_mappings[key].states.indexOf($state.current.name) !== -1) {
            var aPath = _mappings[key].path.map(function(item) {
              return {
                state : item,
                label : $translate.instant('breadcrumb.' + item)
              }
            });

            // aPath.push({
            //   state : $state.current.name,
            //   label : $translate.instant('breadcrumb.' + $state.current.name)
            // });

            return aPath;
          }
        }
        return null;
      }
    };
    _this.$get.$inject = ["$state", "$translate"];

  }

  angular.module('wml.portal.breadcrumbs')
    .provider('breadcrumbs', breadcrumbs);

})();

(function() {
  'use strict';

  angular.module('wml.portal.billingInformation', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  billingInformationService.$inject = ["RestangularExt", "storage", "$rootScope"];
  function billingInformationService(RestangularExt, storage, $rootScope) {

    var cacheServiceName  = 'billingInformation';
    var cache = {
      sendcontrol : null
    };

    var updated = {};

    $rootScope.$on("clear-cache", function(evt, evtData) {
      var key;
      if(angular.isObject(evtData)) {
        if(evtData[cacheServiceName]) {
          if(typeof evtData[cacheServiceName] === 'boolean' && evtData[cacheServiceName] === true) {
            for(key in cache) {
              cache[key] = null;
            }
          } else if(angular.isObject(evtData[cacheServiceName])) {
            for(key in cache) {
              if(typeof evtData[cacheServiceName][key] === 'boolean' && evtData[cacheServiceName][key] === true) {
                cache[key]  = null;
              }
            }
          }
        }
      } else {
        for(key in cache) {
          cache[key] = null;
        }
      }
    });

    return {
      getSendControl    : getSendControl,
      updateSendControl : updateSendControl
    };

    function getSendControl() {
      if(cache.sendcontrol === null) {
        cache.sendcontrol = RestangularExt.one('customer', storage('customer_number')).customGET('send-control');
      }
      return cache.sendcontrol;
    }

    function updateSendControl(sendControl) {
      return RestangularExt.one('customer', storage('customer_number')).customPUT({sendcontrol: sendControl}, 'send-control').then(function(response) {
        cache.sendcontrol = null;
        return response;
      });
    }

  }

  angular.module('wml.portal.billingInformation')
    .factory('billingInformationService', billingInformationService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.banners', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  bannerService.$inject = ["RestangularExt"];
  function bannerService(RestangularExt) {

    var cache = {};

    return {
      loadData  : loadData
    };


    function loadData(contentIndexes) {
      var url = '/instellingen/banners';

      if(angular.isArray(contentIndexes) && contentIndexes.length){
        url = url+'?contentindexes=' + contentIndexes.join(',');
      }

      if(!cache[url]) {
        cache[url] = RestangularExt.all('proxy').customGETLIST(null, {url: url});
      }

      return cache[url];
    }

  }

  angular.module('wml.portal.banners')
    .factory('bannerService', bannerService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.authentication', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  authenticationService.$inject = ["RestangularExt"];
  function authenticationService(RestangularExt) {
    var _forgotPasswordRoute = RestangularExt.all('/authenticate/forgot-password');

    return {
      forgotPassword : forgotPassword
    };

    function forgotPassword(email) {
      return _forgotPasswordRoute.post({email: email});
    }
  }

  angular.module('wml.portal.authentication')
    .factory('authenticationService', authenticationService);

})();

(function () {
  'use strict';
  angular.module('wml.portal.appointment', []);
})();

(function() {
  'use strict';

  /** @ngInject */
  appointmentService.$inject = ["$q", "$rootScope", "RestangularExt", "storage"];
  function appointmentService($q, $rootScope, RestangularExt, storage) {
    var _msaRoute = RestangularExt.all('/meter-service-appointment');

    var cacheServiceName = 'appointment';
    var cache = {
      list  : null
    };

    $rootScope.$on("clear-cache", function(evt, evtData) {
      clearAppointment();
      var key;
      if(angular.isObject(evtData)) {
        if(evtData[cacheServiceName]) {
          if(typeof evtData[cacheServiceName] === 'boolean' && evtData[cacheServiceName] === true) {
            for(key in cache) {
              cache[key] = null;
            }
          } else if(angular.isObject(evtData[cacheServiceName])) {
            for(key in cache) {
              if(typeof evtData[cacheServiceName][key] === 'boolean' && evtData[cacheServiceName][key] === true) {
                cache[key]  = null;
              }
            }
          }
        }
      } else {
        for(key in cache) {
          cache[key] = null;
        }
      }
    });

    return {
      verifyAppointment     : verifyAppointment,
      getAppointment        : getAppointment,
      getAppointments       : getAppointments,
      getAppointmentSlots   : getAppointmentSlots,
      storeAppointment      : storeAppointment,
      saveAppointment       : saveAppointment,
      clearAppointment      : clearAppointment,
      deleteAppointment     : deleteAppointment
    };

    function verifyAppointment(data){
      var obj = {
        postal_code : data.postal_code,
        filter_type_z6: data.filter_type_z6 || false
      };

      return _msaRoute.one(data.service_number).get(obj).then(function(response){
        //get a response and store
        storeAppointment(response.plain());
        return response;
      });
    }

    function getAppointment() {
      return storage('appointment');
    }

    function getAppointments(){
      if(!cache.list) {
        cache.list  = _msaRoute.getList();
      }
      return cache.list;
    }

    function getAppointmentSlots() {
      var data = getAppointment();
      var obj = {
        postal_code : data.address.postal_code,
        meter_type  : data.meter_type
      };
      return  _msaRoute.one(data.notify_no).one('time-slot').get(obj);
    }

    function storeAppointment(data) {
      if(angular.isDefined(storage('appointment')) && storage('appointment') !== null){
        data = angular.extend(storage('appointment'), data);
      }
      storage('appointment', data);
    }

    function deleteAppointment(data) {
      return _msaRoute.one(data.notify_no).customDELETE('schedule', {start: data.start, end: data.end, email: data.email});
    }

    function saveAppointment(data) {
      var appointmentData = {};

      if(data.appointment === 'other'){
        appointmentData.weekday     = data.appointment_other.weekday.value;
        appointmentData.timeslot    = data.appointment_other.timeslot.value;
        appointmentData.custom      = true;
      } else {
        appointmentData             = data.appointment;
        appointmentData.custom      = false;
      }

      if(angular.isDefined(data.meter_type)){
        appointmentData.meter_type  = data.meter_type.value;
      }

      if(angular.isDefined(data.email)){
        appointmentData.email       = data.email;
      }

      var params = {
        postal_code : data.address.postal_code
      };

      return  _msaRoute.one(data.notify_no).customPOST(appointmentData, "schedule", params, {})
    }

    function clearAppointment() {
      return storage('appointment', null);
    }

  }

  angular.module('wml.portal.appointment')
    .factory('appointmentService', appointmentService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.app-info', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  appInfoService.$inject = ["RestangularExt", "$http", "storage"];
  function appInfoService(RestangularExt, $http, storage) {

    var _cache  = {
      api       : null,
      frontend  : null
    };

    var _appInfo  = {
      api       : {
        version : null
      },
      frontend  : {
        version : null
      }
    };

    var _observers  = {
      api       : [],
      frontend  : []
    };

    if(storage('app_info')) {
      _appInfo  = storage('app_info');
    }

    return {
      getApiInfo              : getApiInfo,
      getFrontendInfo         : getFrontendInfo,
      onApiVersionChange      : onApiVersionChange,
      onFrontendVersionChange : onFrontendVersionChange,
      versionCompare          : versionCompare
    };

    function getApiInfo() {
      if(!_cache.api) {
        _cache.api = RestangularExt.all('app-info').customGET().then(function(response) {
          if(_appInfo.api.version !== response.version) {
            for(var i = 0; i < _observers.api.length; i++) {
              _observers.api[i].apply(null, [response.version, _appInfo.api.version]);
            }

            _appInfo.api.version  = response.version;
            storage('app_info', _appInfo);
          }

          return response;
        });
      }

      return _cache.api;
    }

    function getFrontendInfo() {
      if(!_cache.frontend) {
        _cache.frontend = $http.get('/app-info.json').then(function(response) {
          if(_appInfo.frontend.version !== response.data.version) {
            for(var i = 0; i < _observers.frontend.length; i++) {
              _observers.frontend[i].apply(null, [response.data.version, _appInfo.frontend.version]);
            }

            _appInfo.frontend.version  = response.data.version;
            storage('app_info', _appInfo);
          }

          return response;
        });
      }

      return _cache.frontend;
    }

    function onApiVersionChange(observerFn) {
      if(typeof observerFn === 'function') {
        _observers.api.push(observerFn);
      }
    }


    function onFrontendVersionChange(observerFn) {
      if(typeof observerFn === 'function') {
        _observers.frontend.push(observerFn);
      }
    }

    function versionCompare(v1, v2) {
      if(angular.isString(v1) === false || angular.isString(v2) === false) {
        // Could net determine
        return 0;
      }

      var regex = /^v((?:[0-9]+\.){2}[0-9]{1,})$/;

      var v1Match = v1.match(regex);
      var v2Match = v2.match(regex);

      if(!v1Match || !v2Match) {
        // Could not determine. Invalid version string
        return 0;
      }

      var v1Parts = v1Match[1].split('.').map(function(number) { return parseInt(number) });
      var v2Parts = v2Match[1].split('.').map(function(number) { return parseInt(number) });

      for(var i = 0; i < v1Parts.length; i++) {
        if(v1Parts[i] < v2Parts[i]) {
          return -1;
        } else if(v1Parts[i] > v2Parts[i]) {
          return 1;
        }
      }

      return 0;
    }

  }

  angular.module('wml.portal.app-info')
    .factory('appInfoService', appInfoService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.address', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  addressService.$inject = ["Restangular"];
  function addressService(Restangular) {

    var _addressRoute = Restangular.all('address');

    return {
      autofill  : autofill
    };

    function autofill(data) {
      return _addressRoute.customPOST(data, 'autocomplete');
    }
  }

  angular.module('wml.portal.address')
    .factory('addressService', addressService);

})();

(function() {
  'use strict';

  /** @ngInject */
  activationService.$inject = ["RestangularExt"];
  function activationService(RestangularExt) {
    var _activationRoute = RestangularExt.all('/customer/activate');

    return {
      activate                : activate,
      requestNewActivation    : requestNewActivation
    };

    function activate(activationFields) {
      return _activationRoute.post(activationFields);
    }

    //renew activation
    function requestNewActivation(activationFields) {
      return _activationRoute.get(activationFields);
    }

  }

  angular.module('wml.portal.authentication')
    .factory('activationService', activationService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.404', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  error404Service.$inject = ["RestangularExt"];
  function error404Service(RestangularExt) {

    var url = '/instellingen/error-404';
    var _cache = null;

    function getData(){
      if(_cache === null){
        _cache = RestangularExt.all('proxy').customGET(null, {url: url});
      }
      return _cache;
    }

    return {
      getData : getData
    }

  }

  angular.module('wml.portal.404')
    .factory('error404Service', error404Service);

})();

(function() {
  'use strict';

  angular.module('wml.portal.contact', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  contactFormService.$inject = ["RestangularExt", "$rootScope"];
  function contactFormService(RestangularExt, $rootScope) {

    var _url_contact = '/instellingen/contact';
    var _url_business = '/instellingen/contact-zakelijk';
    var _cache = {
      contact : null,
      business : null
    };

    return {
      getCustomer      : getCustomer,
      getContactTypes  : getContactTypes,
      send             : send,
      getData          : getData,
      sendBusinessForm : sendBusinessForm,
      getBusinessData  : getBusinessData
    };

    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    function getContactTypes(type) {
      type = type || '';
      return RestangularExt.all('form/contact/type').customPOST({
        type: type
      });
    }

    function getCustomer(customerNumber, houseNumber, houseNumberAddition, postalCode) {
      houseNumberAddition = houseNumberAddition || '';
      return RestangularExt.all('form/contact/customer').customPOST({
        customer_number       : customerNumber,
        house_number          : houseNumber,
        house_number_addition : houseNumberAddition,
        postal_code           : postalCode
      });
    }

    function send(data) {
      if(typeof data.premises.postal_code !== 'string' && (data.premises.postal_code.numbers && data.premises.postal_code.letters)) {
        data.premises.postal_code  = data.premises.postal_code.numbers + data.premises.postal_code.letters;
      }

      return RestangularExt.all('form/contact').customPOST(data);
    }

    function sendBusinessForm(data) {
      return RestangularExt.all('form/business-contact').customPOST(data);
    }

    function getData(){
      if(_cache.contact === null){
        _cache.contact = RestangularExt.all('proxy').customGET(null, {url: _url_contact});
      }
      return _cache.contact;
    }

    function getBusinessData(){
      if(_cache.business === null){
        _cache.business = RestangularExt.all('proxy').customGET(null, {url: _url_business});
      }
      return _cache.business;
    }
  }

  angular.module('wml.portal.contact')
    .factory('contactFormService', contactFormService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.cms', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  cmsService.$inject = ["RestangularExt", "$location", "$rootScope"];
  function cmsService(RestangularExt, $location, $rootScope) {

    var cache = {};

    return {
      loadData: loadData,
      loadPhotoSubNav: loadPhotoSubNav,
      setSEO: setSEO
    };

    function loadData(querystring) {
      var url = $location.path();

      if(angular.isDefined(querystring)){
        url = url + querystring;
      }

      if(!cache[url]) {
        cache[url] = RestangularExt.all('proxy').customGET(null, {url  : url});
      }

      return cache[url];
    }

    function loadPhotoSubNav(path, querystring) {
      var url = angular.isDefined(path) ? path : $location.path();
      url += '/photonav=1';
      if (angular.isDefined(querystring)) {
        url += querystring;
      }

      if (!cache[url]) {
        cache[url] = RestangularExt.all('proxy').customGET(null, {url: url});
      }

      return cache[url];
    }

    function setSEO(data){
      if(angular.isDefined(data.Content)){
        if(angular.isDefined(data.Content.seo_title) && data.Content.seo_title.data){
          $rootScope.seo_title = data.Content.seo_title.data;
        }
        if(angular.isDefined(data.Content.seo_description) && data.Content.seo_description.data){
          $rootScope.seo_description = data.Content.seo_description.data;
        }
        if(angular.isDefined(data.Content.seo_keywords) && data.Content.seo_keywords.data){
          $rootScope.seo_keywords = data.Content.seo_keywords.data;
        }
      } else if(angular.isDefined(data.ListContent)){
        if(angular.isDefined(data.ListContent.fs_seo_title) && data.ListContent.fs_seo_title.data){
          $rootScope.seo_title = data.ListContent.fs_seo_title.data;
        }
        if(angular.isDefined(data.ListContent.fs_seo_description) && data.ListContent.fs_seo_description.data){
          $rootScope.seo_description = data.ListContent.fs_seo_description.data;
        }
        if(angular.isDefined(data.ListContent.fs_seo_keywords) && data.ListContent.fs_seo_keywords.data){
          $rootScope.seo_keywords = data.ListContent.fs_seo_keywords.data;
        }
      }
    }

  }

  angular.module('wml.portal.cms')
    .factory('cmsService', cmsService);

})();

(function() {
  'use strict';

  angular.module('wml.portal.routes', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  readspeakerText.$inject = ["$rootScope", "$transitions", "$cookies"];
  function readspeakerText($rootScope, $transitions, $cookies) {
    return {
      restrict: 'E',
      replace: false,
      templateUrl : 'app/components/generic/directives/readspeaker/views/readspeaker-text.html',
      link: function (scope, elem, attrs, _ctrl) {

        if (!$cookies.get('_rspkrLoadCore')) {
          window.ReadSpeaker.loadCore();
        }

        scope.readClass = 'content';

        // Listen for changes for the classes to read
        $rootScope.$on('readspeaker.readclass', function(evt, data) {
          scope.readClass = data;
          if(data === '') {
            document.getElementById('readspeak').classList.add('hidden');
          }
        });

        // Listen for route change and stop reader if needed
        $transitions.onStart({}, function() {
          stopPlaying();
          var _readSpeaker = elem[0].querySelectorAll('#readspeaker_button1');
          if(_readSpeaker[0].classList.contains('rsdetached')){
            _readSpeaker[0].classList.remove('rsdetached');
            _readSpeaker[0].style.top = "auto";
            _readSpeaker[0].style.left = "auto";
          }
        });

        $rootScope.$on('readspeaker.form.isPlaying', function(evt, isPlaying) {
          if (isPlaying && scope.isPlaying) {
            stopPlaying();
          }
        });

        scope.currentLocation = encodeURIComponent(window.location);
        scope.isPlaying = false;

        scope.toggleReadspeaker = function() {
          if (scope.isPlaying) {
            stopPlaying();
          } else {
            startPlaying();
          }
        };

        function startPlaying() {
          var playButton = elem[0].querySelectorAll('.rsbtn_play');
          if (playButton.length > 0) {
            clickElement(playButton[0]);
            scope.isPlaying = true;
            $rootScope.$broadcast('readspeaker.text.isPlaying', scope.isPlaying);
          }
        }

        function stopPlaying() {
          var stopButton = elem[0].querySelectorAll('.rsbtn_closer');
          if (stopButton.length > 0) {
            clickElement(stopButton[0]);
            scope.isPlaying = false;
            $rootScope.$broadcast('readspeaker.text.isPlaying', scope.isPlaying);
          }
        }

        function clickElement(element) {
          var event;
          if (typeof(Event) === 'function') {
            event = new Event('click');
          } else {
            event = document.createEvent('Event');
            event.initEvent('click', true, true);
          }
          element.dispatchEvent(event);
        }

        frInit();
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('readspeakerText', readspeakerText);
})();

(function() {
  'use strict';

  /** @ngInject */
  readspeakerForm.$inject = ["$transitions", "$rootScope"];
  function readspeakerForm($transitions, $rootScope) {
    return {
      restrict: 'E',
      templateUrl : 'app/components/generic/directives/readspeaker/views/readspeaker-form.html',
      link: function (scope, elem, attrs, _ctrl) {

        var isClicked = false;
        scope.isPlaying = false;
        scope.currentLocation = encodeURIComponent(window.location);

        // Listen for route change and stop reader if needed
        $transitions.onStart({}, function() {
        });

        $rootScope.$on('readspeaker.text.isPlaying', function(evt, isPlaying) {
          if (isPlaying && scope.isPlaying) {
            stopPlaying();
          }
        });

        scope.toggleReadspeaker = function() {
          if (scope.isPlaying) {
            stopPlaying();
          } else {
            startPlaying();
          }
        };

        function startPlaying() {

          if (!isClicked) {
            if(typeof frInit === 'function') {
              frInit();
            }
            isClicked = true;
          }

          var rsButton = elem[0].querySelectorAll('.fr_play_button');
          if (rsButton.length > 0) {
            clickElement(rsButton[0]);
            scope.isPlaying = true;
            $rootScope.$broadcast('readspeaker.form.isPlaying', scope.isPlaying);
          }
        }

        function stopPlaying() {
          var rsButton = elem[0].querySelectorAll('.fr_play_button');
          if (rsButton.length > 0) {
            clickElement(rsButton[0]);
            scope.isPlaying = false;
            $rootScope.$broadcast('readspeaker.form.isPlaying', scope.isPlaying);
          }
        }

        function clickElement(element) {
          var event;
          if (typeof(Event) === 'function') {
            event = new Event('click');
          } else {
            event = document.createEvent('Event');
            event.initEvent('click', true, true);
          }
          element.dispatchEvent(event);
        }


      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('readspeakerForm', readspeakerForm);
})();

(function() {
  'use strict';

  angular.module('wml.portal.paymentMethod', []);

})();

(function () {
  'use strict';

  /** @ngInject */
  password.$inject = ["$timeout", "passwordService"];
  function password($timeout, passwordService) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/generic/directives/password/views/password.view.html',
      require: 'ngModel',
      scope: {
        password: '=ngModel',
        equals: '=',
        validate: '=',
        id: '@',
        placeholder: '@',
        ngRequired: '=ngRequired'
      },
      link: function (scope, elem, attrs, ctrl) {
        scope.validate = typeof scope.validate === 'boolean' ? scope.validate : true;
        scope.ngRequired = typeof scope.ngRequired === 'boolean' ? scope.ngRequired : true;
        scope.id = attrs.id;
        scope.showPassword = false;
        scope.passwordActive = false;
        scope.placeholder = scope.placeholder || 'login.password';

        scope.toggleVisibility = function () {
          scope.showPassword = !scope.showPassword;
        };
        scope.$watch('password', function () {
          if (scope.validate) {
            ctrl.$setValidity('password', passwordService.validateInput(scope.password, true));
          }
        });

        scope.$watchGroup(['password', 'equals'], function () {
          var confirmationIsSet = angular.isDefined(scope.password) && angular.isString(scope.password) && scope.password.length > 0;
          var passwordIsSet = angular.isDefined(scope.equals) && angular.isString(scope.equals) && scope.equals.length > 0;

          if (confirmationIsSet) {
            ctrl.$setTouched();
          }

          if (confirmationIsSet && passwordIsSet) {
            if (scope.password === scope.equals) {
              ctrl.$setValidity('equals', true);
            } else {
              ctrl.$setValidity('equals', false);
            }
          } else if (!confirmationIsSet && !scope.ngRequired) {
            ctrl.$setValidity('equals', true);
          }
        });
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('password', password);
})();

(function() {
  'use strict';

  /** @ngInject */
  passwordService.$inject = ["RestangularExt", "$q"];
  function passwordService(RestangularExt, $q) {

    var _criteria = {
      minLength: 8,
      minCaps: 1,
      minLowercase: 1,
      minNumbers: 1,
      minSpecialChars: 1
    };

    var _serverSideSettingsLoaded = false;

    RestangularExt.all('proxy').customGET(null, {url: '/instellingen/wachtwoord-criteria'}).then(function(response) {
      Object.assign(_criteria, response);
      _serverSideSettingsLoaded = true;
    });

    var _initialValidationResult = {
      minLength: false,
      minCaps: false,
      minLowercase: false,
      minNumbers: false,
      minSpecialChars: false
    };

    return {
      getCriteria: getCriteria,
      get initialValidationResult() {
        return Object.assign({}, _initialValidationResult);
      },
      validateInput: validateInput
    };

    function getCriteria() {
      if(_serverSideSettingsLoaded) {
        return $q.resolve(_criteria)
      } else {
        var deferredObj = $q.defer();

        var interval = setInterval(function() {
          if(_serverSideSettingsLoaded === true) {
            clearInterval(interval);
            deferredObj.resolve(_criteria);
          }
        }, 200);

        return deferredObj.promise;
      }
    }

    function validateInput(input, returnAsSingleBoolean) {
      returnAsSingleBoolean = (typeof returnAsSingleBoolean === 'boolean') ? returnAsSingleBoolean : false;

      var validationResult = Object.assign({}, _initialValidationResult);

      if(!input) {
        return validationResult;
      }

      validationResult.minLength = (input.length >= _criteria.minLength);

      var caps = input.match(/[A-Z]/g);
      var capsLength = (caps) ? caps.length : 0;
      validationResult.minCaps = (capsLength >= _criteria.minCaps);

      var lowercase = input.match(/[a-z]/g);
      var lowercaseLength = (lowercase) ? lowercase.length : 0;
      validationResult.minLowercase = (lowercaseLength >= _criteria.minLowercase);

      var numbers = input.match(/[0-9]/g);
      var numbersLength = (numbers) ? numbers.length : 0;
      validationResult.minNumbers = (numbersLength >= _criteria.minNumbers);

      validationResult.minSpecialChars = ((input.length - (capsLength + lowercaseLength + numbersLength)) >= _criteria.minSpecialChars);

      if(returnAsSingleBoolean) {
        var numberOfCriteriaMet = 0;
        for(var key in validationResult) {
          if(validationResult[key] === true) {
            numberOfCriteriaMet += 1;
          }
        }
        return (numberOfCriteriaMet === Object.keys(validationResult).length)
      }

      return validationResult;
    }


  }

  angular.module('wml.portal.generic')
    .service('passwordService', passwordService)

})();

(function() {
  'use strict';

  /** @ngInject */
  passwordValidator.$inject = ["passwordService"];
  function passwordValidator(passwordService) {

    return {
      restrict: 'EA',
      require: 'ngModel',
      scope: {
        password: '=ngModel'
      },
      link: function(scope, elem, attrs, ctrl) {
        scope.$watch('password', function(e) {
          ctrl.$setValidity('password', passwordService.validateInput(scope.password, true));
        });
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('passwordValidator', passwordValidator)
})();

(function() {
  'use strict';

  /** @ngInject */
  passwordValidationIndicator.$inject = ["$translate", "passwordService"];
  function passwordValidationIndicator($translate, passwordService) {

    return {
      restrict: 'E',
      templateUrl: 'app/components/generic/directives/password-validator/views/password-validation-indicator.view.html',
      replace: true,
      scope: {
        password: '=password'
      },
      link: function(scope) {
        scope.classes = [];
        scope.validated = passwordService.initialValidationResult;

        passwordService.getCriteria().then(function(criteria) {
          scope.criteria = criteria;

          scope.labels = {
            minLength: (scope.criteria.minLength === 1) ? $translate.instant('password.criteria.min_length_single') : $translate.instant('password.criteria.min_length_plural', {value: scope.criteria.minLength}),
            minCaps: (scope.criteria.minCaps === 1) ? $translate.instant('password.criteria.min_caps_single') : $translate.instant('password.criteria.min_caps_plural', {value: scope.criteria.minCaps}),
            minLowercase: (scope.criteria.minLowercase === 1) ? $translate.instant('password.criteria.min_lowercase_single') : $translate.instant('password.criteria.min_lowercase_plural', {value: scope.criteria.minLowercase}),
            minNumbers: (scope.criteria.minNumbers === 1) ? $translate.instant('password.criteria.min_numbers_single') : $translate.instant('password.criteria.min_numbers_plural', {value: scope.criteria.minNumbers}),
            minSpecialChars: (scope.criteria.minSpecialChars === 1) ? $translate.instant('password.criteria.min_special_chars_single') : $translate.instant('password.criteria.min_special_chars_plural', {value: scope.criteria.minSpecialChars})
          };

          scope.$watch('password', function(e) {
            scope.classes.splice(0, scope.classes.length);
            validateInput(scope.password);
          });

          function validateInput(input) {
            Object.assign(scope.validated, passwordService.validateInput(input));

            var totalCriteria = Object.keys(scope.validated).length;
            var totalSucceeded = 0;
            for(var key in scope.validated) {
              if(scope.validated.hasOwnProperty(key)) {
                if(scope.validated[key] === true) {
                  totalSucceeded += 1;
                }
              }
            }

            if(totalSucceeded === totalCriteria) {
              scope.classes.push('fa-lock', 'text-success');
            } else if(totalSucceeded > (totalCriteria / 2)) {
              scope.classes.push('fa-unlock', 'text-warning');
            } else {
              scope.classes.push('fa-unlock', 'text-danger');
            }
          }

        });

      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('passwordValidationIndicator', passwordValidationIndicator)
})();

(function() {
  'use strict';

  angular.module('wml.portal.message', []);

})();

(function() {
  'use strict';

  loader.$inject = ["$rootScope"];
  function loader($rootScope) {

    return {
      restrict  : 'EA',
      templateUrl : 'app/components/generic/directives/loader/views/overlay.html',
      replace     : false,
      link: function(scope, iElem, iAttrs) {
        var loadingElementsCounter  = 0;
        $rootScope.loading          = true;

        scope.$on('wml.loader.start', function() {
          loadingElementsCounter++;
          if(loadingElementsCounter > 0) {
            $rootScope.loading = true;
          }
        });

        scope.$on('wml.loader.stop', function() {
          loadingElementsCounter--;
          if(loadingElementsCounter <= 0) {
            loadingElementsCounter  = 0; // correction for if any exceptions would ever occur
            $rootScope.loading = false;
          }
        });

        scope.$on('wml.loader.abort', function() {
          loadingElementsCounter  = 0;
          $rootScope.loading = false;
        });
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('loader', loader)
})();

(function() {
  'use strict';

  angular.module('wml.portal.login', []);

})();

(function() {
  'use strict';

  angular.module('wml.portal.listPage', []);

})();

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "a.m.",
      "p.m."
    ],
    "DAY": [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag"
    ],
    "ERANAMES": [
      "voor Christus",
      "na Christus"
    ],
    "ERAS": [
      "v.Chr.",
      "n.Chr."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    "SHORTDAY": [
      "zo",
      "ma",
      "di",
      "wo",
      "do",
      "vr",
      "za"
    ],
    "SHORTMONTH": [
      "jan.",
      "feb.",
      "mrt.",
      "apr.",
      "mei",
      "jun.",
      "jul.",
      "aug.",
      "sep.",
      "okt.",
      "nov.",
      "dec."
    ],
    "STANDALONEMONTH": [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE d MMMM y",
    "longDate": "d MMMM y",
    "medium": "d MMM y HH:mm:ss",
    "mediumDate": "d MMM y",
    "mediumTime": "HH:mm:ss",
    "short": "dd-MM-yy HH:mm",
    "shortDate": "dd-MM-yy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "\u00a4\u00a0-",
        "negSuf": "",
        "posPre": "\u00a4\u00a0",
        "posSuf": ""
      }
    ]
  },
  "id": "nl-nl",
  "localeID": "nl_NL",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

(function() {
  'use strict';

  /** @ngInject */
  function strReplace() {
    return function (text, find, replacement) {
      text = text || '';
      find = find || '';
      replacement = replacement || '';
      return text.replace(new RegExp(find, 'ig'), replacement);
    };
  }

  angular.module('wml.portal.generic')
    .filter('strReplace', strReplace);

})();

(function() {
  'use strict';

  angular.module('wml.portal.account', []);
})();

(function() {
  'use strict';

  /** @ngInject */
  function matchFilter() {
    return function(items, filter) {
      if(filter) {
        return items.filter(function(item) {
          return (item.customer_number.indexOf(filter) >= 0);
        });
      } else {
        return items;
      }
    }
  }

  angular.module('wml.portal.account')
    .filter('match', matchFilter);

})();

(function() {
  'use strict';

  /** @ngInject */
  function matchCorporationFilter() {
    return function (items, searchValue) {
      if (searchValue) {
        searchValue = searchValue.replace(/\s/g, '').toLowerCase();
        return items.filter(function (item) {
          return (item.searchkey.indexOf(searchValue) !== -1);
        });
      }
      return items;
    };
  }

  angular.module('wml.portal.corporation')
    .filter('matchCorporationFilter', matchCorporationFilter);

})();

(function() {
  'use strict';

  /** @ngInject */
  serverSideValidation.$inject = ["$rootScope"];
  function serverSideValidation($rootScope) {
    return {
      restrict  : 'A',
      link: function(scope, elm, attrs, ctrl) {
        var _fieldname = attrs.serverSideValidation;
        var _event = $rootScope.$on('wml.portal.invalid.fields', function (event, response) {
          if (angular.isDefined(response) && angular.isArray(response)) {
            angular.forEach(response, function(item){
              if(item === _fieldname){
                elm.addClass('server-error');
                elm.on('focus', function(){
                  elm.removeClass('server-error');
                });
              }
            });
          }
        });

        scope.$on('$destroy', function() {
          _event();
        });
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('serverSideValidation', serverSideValidation)
})();

(function() {
  'use strict';

  /** @ngInject */
  function searchResultTarget() {
    return {
      restrict: 'A',
      scope: {
        link: '='
      },
      link: function(scope, element) {
        element.attr('href', scope.link);
        var regex = /cms\/assets/;
        if (regex.test(scope.link)) {
          element.attr('target', '_blank');
        }
      }
    }
  }

  angular
    .module('wml.portal.search')
    .directive('searchResultTarget', searchResultTarget);
})();

(function() {
  'use strict';

  /** @ngInject */
  scrollHeader.$inject = ["$window"];
  function scrollHeader($window) {
    return {
      restrict  : 'A',
      scope: {
        'offsetTop'         : '@offsetTop',
        'offsetTopMobile'   : '@offsetTopMobile',
        'navOffset'         : '@navOffset',
        'fadeTime'          : '@fadeTime',
        'fadeTimeMobile'    : '@fadeTimeMobile'
      },
      link: function(scope, elm, attrs, ctrl) {
        var _topOffset  = scope.offsetTop;
        var _fadeTime   = scope.fadeTime;

        var _screen = angular.element($window);

        function _adjustOffset(){
          if($window.innerWidth < 992){
            scope.offsetTop = scope.offsetTopMobile;
            scope.fadeTime  = scope.fadeTimeMobile;
          } else {
            scope.offsetTop = _topOffset;
            scope.fadeTime  = _fadeTime;
          }
        }

        function _adjustScrollClasses() {
          var _currentOffset = $window.pageYOffset;
          if (_currentOffset >= scope.fadeTime && scope.fadeTime !== null) {
            elm.addClass("fadeout");
          } else {
            elm.removeClass("fadeout");
          }

          if (_currentOffset >= scope.offsetTop) {
            elm.addClass("min");
          } else {
            elm.removeClass("min");
          }

          if (_currentOffset >= scope.navOffset) {
            elm.addClass("movenav");
          } else {
            elm.removeClass("movenav");
          }
        }

        _screen.on("resize scroll", function() {
          _adjustOffset();
          _adjustScrollClasses();
        });

        _adjustOffset();
        _adjustScrollClasses();
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('scrollHeader', scrollHeader);
})();

(function() {
  'use strict';

  /** @ngInject */
  autoTabTo.$inject = ["$timeout"];
  function autoTabTo($timeout) {

    return {
      restrict  : 'A',
      require   : 'ngModel',
      scope     : {
        'fieldValue' : '=ngModel',
      },
      link: function(scope, elm, attrs, ctrl) {
        var _fieldValue = null;
        function _focusNext(){
          var element = document.getElementById(attrs.autoTabTo);
          if (element){
            element.focus();
          }
        }

        elm.on('keyup', function(e) {
          if (angular.isDefined(this.value) && this.value.length === attrs.maxlength && (angular.isUndefined(elm.attr('data-overwrite-on-keyup')) || elm.attr('data-overwrite-on-keyup') === 'false')) {
            elm.attr('data-overwrite-on-keyup', 'true');
            _focusNext();
          } else {
            if(scope.fieldValue !== ''){
              if(e.key.length === 1){
                $timeout(function() {
                  scope.fieldValue = e.key;
                  _focusNext();
                });
              }
            }
          }
        });
      }
    };
  };

  angular.module('wml.portal.generic')
    .directive('autoTabTo', autoTabTo)
})();

(function () {
  'use strict';

  function meterImages() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/meter-readings/directives/views/meter-image.view.html'
    };
  }

  angular.module('wml.portal.meterReading')
    .directive('meterImages', meterImages);
})();

(function() {
  'use strict';

  function match() {
    return {
      require   : 'ngModel',
      restrict  : 'A',
      scope: {
        modelValue : '=ngModel',
        otherModelValue: "=match"
      },
      link: function(scope, elm, attrs, ctrl) {
        scope.$watchGroup(['modelValue', 'otherModelValue'], function() {
          if((angular.isDefined(scope.modelValue) && angular.isString(scope.modelValue) && scope.modelValue.length) && (angular.isDefined(scope.otherModelValue) && angular.isString(scope.otherModelValue) && scope.otherModelValue.length)){
            if(scope.modelValue === scope.otherModelValue){
              ctrl.$setValidity('match', true);
            } else {
              ctrl.$setValidity('match', false);
            }
          }
        });
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('match', match)
})();

(function () {
  'use strict';

  function limitTo() {

    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, elm, attrs, ctrl) {
        var _limit      = parseInt(attrs.limitTo);

        function validateLimit(text) {
          if (!!text) {
            if (text.length > _limit) {
              text = text.substring(0, _limit);
              ctrl.$setViewValue(text);
              ctrl.$commitViewValue();
              ctrl.$render();
            }
            return text;
          }
          return '';
        }

        ctrl.$parsers.unshift(validateLimit);
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('limitTo', limitTo)
})();

(function() {
  'use strict';

  function limitNumberRange() {
    return {
      require   : 'ngModel',
      restrict  : 'A',
      scope: {
        number : '=ngModel',
        lowerLimit: "=lowerLimit",
        upperLimit: "=upperLimit"
      },
      link: function(scope, elm, attrs, ctrl) {
        scope.$watch('number', function() {
          if(scope.number){
            var parsedNumberWithoutDots = scope.number.replace(".", "");
            var parsedNumber = parseFloat(parsedNumberWithoutDots.replace(",", "."));
            if(parsedNumber && parsedNumber >= scope.lowerLimit && parsedNumber <= scope.upperLimit){
              ctrl.$setValidity('limitNumberRange', true);
            } else {
              ctrl.$setValidity('limitNumberRange', false);
            }
          }
        });
      }
    };
  };

  angular.module('wml.portal.generic')
    .directive('limitNumberRange', limitNumberRange)
})();

(function() {
  'use strict';

  function initials() {
    return {
      restrict  : 'A',
      require   : 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        function fromUser(text) {
          if (text) {
            var formatted = text.replace(/[^A-Za-z]/g, '').toUpperCase().split('').join('.');
            ctrl.$setViewValue(formatted);
            if (formatted) {
              ctrl.$setViewValue(formatted + '.');
            }
            ctrl.$render();
          }
        }
        scope.$watch(attrs.ngModel, fromUser);
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('initials', initials)
})();

(function () {
  'use strict';

  /** @ngInject */
  equalHeight.$inject = ["$window", "$timeout"];
  function equalHeight($window, $timeout) {
    return equalHeight = {
      restrict: 'A',
      groups: {},
      link: function (scope, element, attrs) {
        $timeout(getHighest); // make sure angular has proceeded the binding
        angular.element($window).bind('resize', getHighest);

        function getHighest() {
          if (!equalHeight.groups[attrs.equalHeight]) { // if not exists then create the group
            equalHeight.groups[attrs.equalHeight] = {
              height: 0,
              elems:[]
            };
          }

          equalHeight.groups[attrs.equalHeight].elems.push(element);
          element[0].style.height = 'auto'; // make sure we capture the origin height

          if (equalHeight.groups[attrs.equalHeight].height < element[0].offsetHeight) {
            equalHeight.groups[attrs.equalHeight].height = element[0].offsetHeight;
          }

          angular.forEach(equalHeight.groups[attrs.equalHeight].elems, function(elem){
            elem[0].style.height = equalHeight.groups[attrs.equalHeight].height + 'px';
          });

          if(angular.isDefined(attrs.equalNumItems) && parseInt(attrs.equalNumItems) == equalHeight.groups[attrs.equalHeight].elems.length){
            equalHeight.groups[attrs.equalHeight].height = 0;
            equalHeight.groups[attrs.equalHeight].elems = [];
          }
        }
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('equalHeight', equalHeight)
})();

(function() {
  'use strict';

  /** @ngInject */
  dateFormat.$inject = ["moment"];
  function dateFormat(moment) {
    return {
      require   : 'ngModel',
      restrict  : 'A',
      scope     : {
        'options'    : '=dateFormat',
        'dateString' : '=ngModel'
      },
      link  : function(scope, elem, attrs, ctrl) {
        var format = 'DD-MM-YYYY';

        if(angular.isObject(scope.options)){
          if(angular.isDefined(scope.options.format)){
            format = scope.options.format;
          }
        }


        scope.$watch('dateString', function() {
          if(angular.isDefined(scope.dateString) && angular.isString(scope.dateString) && scope.dateString.length) {
            var valid = moment(scope.dateString, format).isValid();
            var date    = moment(scope.dateString, format);

            if(angular.isObject(scope.options)){
              if(angular.isDefined(scope.options.minDate)){
                var minDate = moment(scope.options.minDate, format);

                if(date.isBefore(minDate)) {
                  valid = false;
                }
              }

              if(angular.isDefined(scope.options.maxDate)){
                var maxDate = moment(scope.options.maxDate, format);

                if(date.isSameOrAfter(maxDate)) {
                  valid = false;
                }
              }
            }
            ctrl.$setValidity('dateFormat', valid);
          } else {
            ctrl.$setValidity('dateFormat', true)
          }
        });
      }
    }
  }

  angular.module('wml.portal.generic')
    .directive('dateFormat', dateFormat)
})();

(function() {
  'use strict';

  function checkNumber() {
    return {
      restrict  : 'A',
      require   : 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        var NUMBER_REGEXP = /^\d+$/;

        function fromUser(text) {
          if(text){
            if (text.length) {
              ctrl.$setValidity('checkNumber', NUMBER_REGEXP.test(text));
            }
            return text;
          } else {
            ctrl.$setValidity('checkNumber', true);
          }
          return '';
        }

        ctrl.$parsers.unshift(fromUser);
        ctrl.$formatters.unshift(fromUser);
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('checkNumber', checkNumber)
})();





(function() {
  'use strict';

  function checkLetters() {
    var LETTERS_REGEXP = /^[a-zA-Z]+$/;

    return {
      require   : 'ngModel',
      restrict  : 'A',
      scope     : {
        'letters'    : '=ngModel'
      },
      link: function(scope, elm, attrs, ctrl) {
        scope.$watch('letters', function() {
          if(angular.isString(scope.letters) && scope.letters.length){
            ctrl.$setValidity('checkLetters', LETTERS_REGEXP.test(scope.letters));
          } else {
            ctrl.$setValidity('checkLetters', true);
          }
        });
      }
    };
  };

  angular.module('wml.portal.generic')
    .directive('checkLetters', checkLetters)
})();

(function() {
  'use strict';

  function checkEmail() {
    var EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    return {
      require   : 'ngModel',
      restrict  : 'A',
      scope     : {
        'email'    : '=ngModel'
      },
      link: function(scope, elm, attrs, ctrl) {
        scope.$watch('email', function() {
          if(angular.isDefined(scope.email) && angular.isString(scope.email) && scope.email.length){
            ctrl.$setValidity('checkEmail', EMAIL_REGEXP.test(scope.email));
          }
        });
      }
    };
  };

  angular.module('wml.portal.generic')
    .directive('checkEmail', checkEmail)
})();

(function () {
  'use strict';

  /** @ngInject */
  checkDateInPeriod.$inject = ["moment"];
  function checkDateInPeriod(moment) {
    return {
      restrict: 'A',
      require: ['ngModel', '^uib-datepicker-popup'],
      scope: false,
      link: function (scope, elm, attrs, ctrls) {
        var ngModelCtrl = ctrls[0];
        scope.$watch(function () {
          return ngModelCtrl.$modelValue;
        }, function (date) {
          var datepickerOptions = scope.$eval(attrs.datepickerOptions);
          if (moment(date).isValid()) {
            var hasMinDate = Boolean(datepickerOptions.minDate);
            if (hasMinDate && moment(date).isBefore(moment(datepickerOptions.minDate))) {
              ngModelCtrl.$setValidity('minDate', false);
            } else {
              ngModelCtrl.$setValidity('minDate', true);
            }

            var hasMaxDate = Boolean(datepickerOptions.maxDate);
            if (hasMaxDate && moment(date).isAfter(moment(datepickerOptions.maxDate))) {
              ngModelCtrl.$setValidity('maxDate', false);
            } else {
              ngModelCtrl.$setValidity('maxDate', true);
            }
          }
        });
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('checkDateInPeriod', checkDateInPeriod)
})();

(function () {
  'use strict';

  function uibDatepickerMonth($provide) {
    $provide.decorator('uibDatepickerDirective', ['$delegate', '$document', function ($delegate, $document) {
      var doc = $document[0];
      var directive = $delegate[0];
      // get a copy of the directive's original compile function
      var directiveCompile = directive.compile;

      // overwrite the original compile function
      directive.compile = function (tElement, tAttrs) {
        // call the directive's compile with apply to send the original 'this' and arguments to it
        var link = directiveCompile.apply(this, arguments);

        // here's where the magic starts
        return function (scope, element, attrs, ctrls) {
          // call the original link
          link.apply(this, arguments);

          // var uibWeeks = doc.getElementsByClassName('uib-weeks');

          // move is the internal function called when you click
          // on the chevrons for previous and next month
          var originalMove = scope.move;
          scope.move = function (direction) {
            originalMove.apply(this, arguments);
            // when move is called, the 'this' object contains a 'title' property with the current month!
            var currentMonth = this.$parent.activeDt.date;

            // emit the event to parent scopes
            scope.$emit('datepicker.monthChanged', currentMonth);

            scope.datepicker.refreshView();

            scope.$emit('datepicker.format', scope.datepickerMode);
          };

          var originalToggleMode = scope.toggleMode;
          scope.toggleMode = function (direction) {
            originalToggleMode.apply(this, arguments);
            // when move is called, the 'this' object contains a 'title' property with the current month!
            var current = this.title;
            // emit the event to parent scopes
            scope.$emit('datepicker.toggleModeChanged', current);
          };

          var originalSelect = scope.select;
          scope.select = function (date) {
            originalSelect.apply(this, arguments);
            // when move is called, the 'this' object contains a 'title' property with the current month!
            var currentMonth = this.dt.date;
            // emit the event to parent scopes
            scope.$emit('datepicker.monthChanged', currentMonth);

            scope.datepicker.refreshView();

            scope.$emit('datepicker.format', scope.datepickerMode);
          };
        };
      };

      return $delegate;
    }]);
  }

  angular.module('wml.portal.generic').config(['$provide', uibDatepickerMonth]);
})();

(function () {
  'use strict';

  waterhardheidController.$inject = ["cmsService", "$rootScope", "detailService", "waterhardheidService"];
  function waterhardheidController(cmsService,$rootScope, detailService, waterhardheidService){
    var vm = this;
    vm.hardness = null;

    //public functions
    vm.getHardness = getHardness;

    cmsService.loadData().then(function(data) {
      vm.data = data;

      cmsService.setSEO(data);

      $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);
    });

    function getHardness(){
      waterhardheidService.getHardness(vm.form.postal_code, vm.form.house_no).then(function (response) {
        if(response !== false){
           vm.hardness = response[0].hardness;
        }else {
          vm.hardness = response;
        }
      }, errorHardness);

      function errorHardness(error){
        Error(error);
      }
    }

    detailService.getBlockContent().then(function(response){
      vm.bottomBlock = response.plain();
    });
  }

  angular
    .module('wml.portal.waterhardheid')
    .controller('waterhardheidController',waterhardheidController)

})();

(function () {
  'use strict';

  waterEstafetteVoteController.$inject = ["cmsService", "$rootScope", "detailService", "waterEstafetteService", "storage"];
  function waterEstafetteVoteController(cmsService,$rootScope, detailService, waterEstafetteService, storage){
    var vm                  = this;

    //public functions
    vm.sendingData                = false;
    vm.bShowForm                  = true;
    vm.cities                     = [];
    vm.selectedCity               = null;
    vm.registrations              = null;

    vm.formData = {
      id  : null
    };


    // Public function definitions
    vm.send                       = send;
    vm.getRegistrations           = getRegistrations;


    // Public functions
    function send() {
      if (vm.form.$valid) {
        vm.sendingData = true;
        waterEstafetteService.vote(vm.formData)
          .then(function () {
            vm.bShowForm = false;
            storage('waterestafette_voted', true)
          })
          .finally(function () {
            vm.sendingData = false;
          });
      }
    }

    function getRegistrations() {
      waterEstafetteService.getRegistrations(vm.selectedCity).then(function(registrations){
        vm.registrations = registrations;
      })
    }


    cmsService.loadData().then(function(data) {
      vm.data = data;

      cmsService.setSEO(data);

      $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);
    });

    // Private functions

    function _getCities() {
      waterEstafetteService.getRegistrationCities().then(function(cities){
        vm.cities = cities;
      })
    }

    activate();

    function activate() {
      _getCities();

      if(storage('waterestafette_voted')){
        vm.bShowForm = false;
      }

      cmsService.loadData().then(function (data) {
        vm.data = data;

        cmsService.setSEO(data);

        $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);
      });

      detailService.getBlockContent().then(function (response) {
        vm.bottomBlock = response.plain();
      });

    }
  }

  angular
    .module('wml.portal.water-estafette')
    .controller('waterEstafetteVoteController',waterEstafetteVoteController)

})();

(function() {
  'use strict';

  /** @ngInject */
  VideoListController.$inject = ["cmsService", "videoListService"];
  function VideoListController(cmsService, videoListService) {
    var vm  = this;
    vm.bottomBlock = {};

    cmsService.loadData().then(function(data) {
      vm.data = data.plain();
      cmsService.setSEO(data);
    });

    _getContent();

    function _getContent() {
      videoListService.getBlockContent().then(function(response){
        vm.bottomBlock = response.plain();
      });
    }
  }

  angular
    .module('wml.portal.videoList')
    .controller('VideoListController', VideoListController);
})();

(function() {
  'use strict';

  /** @ngInject */
  VacancyListController.$inject = ["cmsService"];
  function VacancyListController(cmsService) {
    var vm  = this;

    cmsService.loadData().then(function(data) {
      vm.data = data.plain();
      cmsService.setSEO(data);
    });
  }

  angular
    .module('wml.portal.vacancy')
    .controller('VacancyListController', VacancyListController);
})();

(function() {
  'use strict';

  /** @ngInject */
  VacancyDetailController.$inject = ["registry", "cmsService", "vacancyDetailService", "Upload", "$rootScope"];
  function VacancyDetailController(registry, cmsService, vacancyDetailService, Upload, $rootScope) {
    var vm  = this;

    //public variables
    vm.motivationFileName = null;
    vm.resumeFileName     = null;
    vm.candidate          = vacancyDetailService.data;
    vm.showVacancyForm    = true;
    vm.sendingData        = false;
    vm.form               = null;

    vm.countries = [
      {
        id: 'NL',
        label: 'NL'
      },
      {
        id: 'BE',
        label: 'BE'
      },
      {
        id: 'DE',
        label: 'DE'
      }];

    //public functions
    vm.readMotivationFile  = readMotivationFile;
    vm.readResumeFile      = readResumeFile;
    vm.sendApplicationForm = sendApplicationForm;

    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    cmsService.loadData().then(function(data) {
      vm.data = data;
      cmsService.setSEO(data);
    });

    function readMotivationFile(){
      vm.motivationFileName = (vm.candidate.motivation_file && vm.candidate.motivation_file.name) ? vm.candidate.motivation_file.name : "";
    }

    function readResumeFile(){
      vm.resumeFileName = (vm.candidate.resume_file && vm.candidate.resume_file.name) ? vm.candidate.resume_file.name : "";
    }

    function sendApplicationForm(){
      if(vm.form.$valid) {
        vm.sendingData = true;

        var files = [
          vm.candidate.motivation_file,
          vm.candidate.resume_file
        ];

        var formData = angular.extend({}, vm.candidate, {
          vacancy_name: vm.data.Content.vac_name.data
        });

        Upload.upload({
          url   : registry.restApiUrl + '/form/vacancy',
          data  : formData
        }).then(function(response){
          vm.showVacancyForm = false;
          $rootScope.$broadcast('wml.portal.message', response.data);
        }).finally(function(){
          vm.sendingData = false;
        })
      }
    }
  }

  angular
    .module('wml.portal.detailPage')
    .controller('VacancyDetailController', VacancyDetailController);
})();

(function () {
  'use strict';

  /** @ngInject */
  UsageMeterReadingsController.$inject = ["$state", "$scope", "$stateParams", "$filter", "moment", "customerService", "usageMeterReadingService", "cancelLink", "goToLink"];
  function UsageMeterReadingsController($state, $scope, $stateParams, $filter, moment, customerService, usageMeterReadingService, cancelLink, goToLink) {
    var vm = this;

    // private variables
    var _budgetBillingPlan = {};

    // Public variables
    vm.form        = null;
    vm.sendingData = false;
    vm.consumption = null;
    vm.meter_number = null;
    vm.premise_id  = $stateParams.premise_id;

    vm.data = {
      date              : moment().format('DD-MM-YYYY'),
      meter_reading     : '',
      num1              : '',
      num2              : '',
      num3              : '',
      num4              : '',
      num5              : '',
      num6              : '',
      num7              : ''
    };

    // Public function definitions
    vm.save   = save;
    vm.cancel = cancel;

    // Public functions
    function save() {
      var combinedReadingNumbers = vm.data.num1 + vm.data.num2 + vm.data.num3 + vm.data.num4 + vm.data.num5 + vm.data.num6 + vm.data.num7;
      var meterReading = {reading_result: combinedReadingNumbers};

      if(vm.form.$valid) {
        var data = meterReading;
        usageMeterReadingService.setMeterReading(data);
        if(angular.isDefined(_budgetBillingPlan.budget_billing_plan_id) && _budgetBillingPlan.is_changeable){
          vm.sendingData = true;
          customerService.setReadingResult($stateParams.contract_account_id, $stateParams.contract_id, _budgetBillingPlan.budget_billing_plan_id, meterReading).then(function(response) {
            data = angular.extend(response.plain(), meterReading);
            usageMeterReadingService.setMeterReading(data);
          }).finally(function(){
            vm.sendingData = false;
            $state.go(goToLink, $stateParams);
          });
        } else {
          $state.go(goToLink, $stateParams);
        }
      }
    }

    function cancel() {
      $state.go(cancelLink, $stateParams);
    }

    // Private functions

    activate();

    function activate() {
      customerService.getBudgetBillingPlan($stateParams.contract_account_id, $stateParams.contract_id).then(function (response) {
        _budgetBillingPlan = response;
      });

      customerService.getConsumption($stateParams.contract_account_id, $stateParams.contract_id).then(function (response) {
        for (var i = 0; i < response[0].meter_reading_results.length; i++) {
          if (response[0].meter_reading_results[i].is_open === false) {
            response[0].meter_reading_results[i].reading_date_time = $filter('date')(response[0].meter_reading_results[i].reading_date_time, 'longDate');
            vm.consumption = response[0].meter_reading_results[i];
            vm.meter_number = response[0].serial_number;
            break;
          }
        }
      });

      customerService.getPremise(vm.premise_id).then(function(response){

        vm.numberOfMeterNumbers = response.device.pre_decimal || 5;

        vm.aNumberOfMeterNumbers  = [];
        for(var i=0; i < vm.numberOfMeterNumbers; i++){
          vm.aNumberOfMeterNumbers[i] = i + 1;
        }

        $scope.$watch(function() {return vm.data.meter_reading;}, function(newValue) {
          if(angular.isString(newValue)) {
            var data    = newValue.split('');
            var length  = data.length;
            if(length < vm.numberOfMeterNumbers) {
              for(var j=0; j < (vm.numberOfMeterNumbers-length); j++) {
                data.unshift('0');
              }
            }
            for(var k=0; k < data.length; k++) {
              var key = 'num' + (k+1);
              vm.data[key]  = data[k];
            }
          } else {
            for(var l=1; l <= vm.numberOfMeterNumbers; l++) {
              vm.data['num' + l]  = 0;
            }
          }
        });
      });
    }
  }

  angular
    .module('wml.portal.usage')
    .controller('UsageMeterReadingsController', UsageMeterReadingsController);
})();

(function () {
  'use strict';

  /** @ngInject */
  UsageInstallmentChangedController.$inject = ["$stateParams", "$rootScope", "customerService", "cancelLink"];
  function UsageInstallmentChangedController($stateParams, $rootScope, customerService, cancelLink) {
    var vm = this;

    // private variables

    // Public variables
    vm.contract_account_id    = $stateParams.contract_account_id;
    vm.contract_id            = $stateParams.contract_id;
    vm.premise_id             = $stateParams.premise_id;

    // Public function definitions

    // Public functions

    // Private functions

    activate();

    function activate() {
      customerService.getPremise(vm.premise_id).then(function(response){
        if (angular.isDefined(response.address.house_no_addition) && response.address.house_no_addition.length) {
          vm.premise = response.address.street + ' ' + response.address.house_no + ' ' + response.address.house_no_addition + ', ' + response.address.postal_code + ' ' + response.address.city;
        } else {
          vm.premise = response.address.street + ' ' + response.address.house_no + ', ' + response.address.postal_code + ' ' + response.address.city;
        }

        $rootScope.$broadcast('clear-cache');
      });

      customerService.getBudgetBillingPlan($stateParams.contract_account_id, $stateParams.contract_id).then(function(response) {
        vm.budgetBillingPlan = response;
      });

      vm.cancelLink = cancelLink;
    }
  }

  angular
    .module('wml.portal.usage')
    .controller('UsageInstallmentChangedController', UsageInstallmentChangedController);
})();

(function () {
  'use strict';

  /** @ngInject */
  UsageInstallmentChangeController.$inject = ["$filter", "$stateParams", "customerService", "$state"];
  function UsageInstallmentChangeController($filter, $stateParams, customerService, $state) {
    var vm = this;

    // private variables

    // Public variables
    vm.budgetBillingPlan      = {};
    vm.stateParams            = $stateParams;
    vm.data                   = {};
    vm.sendingData            = false;
    vm.visibleForm            = true;

    // Public function definitions
    vm.filterCurrency = filterCurrency;
    vm.save           = save;

    // Public functions
    function save (){
      if(vm.form.$valid) {
        vm.sendingData = true;
        vm.data.installment_amount =  vm.data.installment_amount.replace(new RegExp('\\.', 'g'), '');
        customerService.setBudgetBillingPlan($stateParams.contract_account_id, $stateParams.contract_id, vm.data).then(function() {
          $state.go('invoicesInstallmentChanged', $stateParams);
        }).finally(function(){
          vm.sendingData = false;
        })
      }
    }

    function filterCurrency() {
      if(vm.data.installment_amount){
        vm.data.installment_amount = $filter('number')(parseInstallment(), 1) + '0';
      }
    }

    // Private functions

    function parseInstallment(){
      var _lastIndexOf  = vm.data.installment_amount.lastIndexOf('.');
      var _amountLength = vm.data.installment_amount.length;
      var _amount       = vm.data.installment_amount;
      if(_lastIndexOf !== -1 && (_amountLength - _lastIndexOf <= 3 )){
        _amount = _amount.substr(0,_lastIndexOf) + ',' + vm.data.installment_amount.substr(_lastIndexOf,_amountLength);
      }
      return _amount.replace(new RegExp('\\.', 'g'), '').replace(",", ".");
    }

    activate();

    function activate() {
      customerService.getBudgetBillingPlan($stateParams.contract_account_id, $stateParams.contract_id).then(function(response) {
        vm.visibleForm  = true;
        vm.budgetBillingPlan = response;
      }, function(error) {
        if(angular.isObject(error) && angular.isDefined(error.data) && angular.isDefined(error.data.code) && error.data.code === 8009) {
          vm.visibleForm  = false;
        }
      });
    }

  }

  angular
    .module('wml.portal.usage')
    .controller('UsageInstallmentChangeController', UsageInstallmentChangeController);
})();

(function () {
  'use strict';

  /** @ngInject */
  UsageDashboardController.$inject = ["$uibModal", "$scope", "$state", "$translate", "customerService", "meterReadingService", "usageChartService"];
  function UsageDashboardController($uibModal, $scope, $state, $translate, customerService, meterReadingService, usageChartService) {
    var vm = this;

    // private variables
    var _meterReadings;

    // Public variables
    vm.usageScanModal           = null;
    vm.bShowMeterReadingButton  = false;
    vm.bShowUsageScan           = false;
    vm.connectionAddresses      = null;

    vm.is_company               = false;

    vm.bShowChart               = false;
    vm.chartFilterAddresses     = null;
    vm.chartFormData            = {
      persons : 150
    };

    vm.chartExtraConfig             = usageChartService.chartExtraConfig;
    vm.chartConfig                  = usageChartService.getConfig;
    vm.chartConfig.yAxis.plotLines  = [];

    // Public function definitions
    vm.startUsageScan           = startUsageScan;
    vm.openMeterReadingsModal   = openMeterReadingsModal;
    vm.chartUpdatePlotline      = chartUpdatePlotline;
    vm.changeChart              = changeChart;
    vm.getDisplayNameMeterReadingCategory = getDisplayNameMeterReadingCategory;

    // Public functions
    function changeChart() {
      usageChartService.getConsumption(vm.chartExtraConfig.selectedChartAddress);
    }

    function startUsageScan(){
      goToUsageScan();
    }

    function getDisplayNameMeterReadingCategory(catId) {
      var customer = ['KL', 'T', 'I', '06', '02'];
      var wml = ['OW', 'OM', '01', 'IN'];
      var estimated = ['03', '04', 'SW'];
      if (customer.indexOf(catId) !== -1) { return $translate.instant('usage.chart.graph_labels.customer'); }
      if (wml.indexOf(catId) !== -1) { return $translate.instant('usage.chart.graph_labels.wml'); }
      if (estimated.indexOf(catId) !== -1) { return $translate.instant('usage.chart.graph_labels.estimated'); }
      return '-';
    }

    function openMeterReadingsModal() {
      vm.meterReadings = _meterReadings;
      if(angular.isObject(vm.meterReadings) && vm.meterReadings.length > 1){
        $scope.modal  = vm;
        vm.meterReadingsModal = $uibModal.open({
          templateUrl   : 'app/components/usage/partials/meter-readings.modal.partial.html',
          scope         : $scope,
          size          : 'lg'
        });

        vm.meterReadingsModal.result.then(function(params){
          $state.go('meterReadingRecording', params)
        });
      } else {
        var params = {assignment_number: vm.meterReadings[0].assignment_number, postal_code : vm.meterReadings[0].device.address.postal_code};
        $state.go('meterReadingRecording', params)
      }
    }

    function chartUpdatePlotline(){
      vm.chartConfig.getChartObj().yAxis[0].removePlotLine('usagePlotline');
      vm.chartConfig.getChartObj().yAxis[0].addPlotLine({
        value: vm.chartFormData.persons,
        id: 'usagePlotline',
        color: '#000',
        width: 1,
        zIndex: 5
      });
    }

    // Private functions
    function goToUsageScan() {
      if(angular.isObject(vm.connectionAddresses) && vm.connectionAddresses.length > 1){
        vm.usageScanModal = $uibModal.open({
          templateUrl: 'app/components/usage/partials/connection-addresses.modal.partial.html',
          scope: $scope,
          size: 'lg'
        });

        vm.usageScanModal.result.then(function(params){
          $state.go('usageMeterReadings', params);
        });
      } else {
        var params = {contract_account_id: vm.connectionAddresses[0].contract_account_id, contract_id: vm.connectionAddresses[0].contract_id, premise_id: vm.connectionAddresses[0].premise_id};
        $state.go('usageMeterReadings', params);
      }
    }

    function getPremises() {
      customerService.getPremises().then(function(response){

        vm.connectionAddresses = response;
        vm.bShowUsageScan = vm.connectionAddresses.length;

        usageChartService.initChart(response);
      });
    }

    function checkMeterReadings() {
      meterReadingService.getMeterReadings().then(getMeterReadingsSuccess);
    }

    function getMeterReadingsSuccess(response) {
      _meterReadings = response;
      if (angular.isArray(_meterReadings) && _meterReadings.length > 0) {
        vm.bShowMeterReadingButton = true;
      }
    }

    function getCustomer() {
      customerService.getCustomer().then(getCustomerSuccess);
    }

    function getCustomerSuccess(response) {
      vm.is_company = response.is_company;
    }

    activate();

    function activate() {
      checkMeterReadings();
      getPremises();
      getCustomer();
    }

  }

  angular
    .module('wml.portal.usage')
    .controller('UsageDashboardController', UsageDashboardController);
})();

(function () {
  'use strict';

  /** @ngInject */
  UsageCompareController.$inject = ["$filter", "$state", "$stateParams", "$rootScope", "$q", "customerService", "usageMeterReadingService", "cancelLink", "goToLink", "bShowAdvisedCheckbox"];
  function UsageCompareController($filter, $state, $stateParams, $rootScope, $q, customerService, usageMeterReadingService, cancelLink, goToLink, bShowAdvisedCheckbox) {
    var vm = this;

    // private variables


    // Public variables
    vm.data           = {};
    vm.consumption    = {};
    vm.sendingData    = false;

    // Public function definitions
    vm.filterCurrency       = filterCurrency;
    vm.save                 = save;
    vm.cancel               = cancel;
    vm.bShowAdvisedCheckbox = bShowAdvisedCheckbox;

    if(!bShowAdvisedCheckbox){
      vm.data.use_advised = true;
    }

    // Public functions
    function filterCurrency() {
      vm.data.installment_amount = $filter('number')(parseInstallment(), 1) + '0';
    }

    function save() {
      if(vm.form.$valid) {
        vm.sendingData = true;
        vm.data.installment_amount =  vm.data.installment_amount.replace(new RegExp('\\.', 'g'), '');
        customerService.setBudgetBillingPlan($stateParams.contract_account_id, $stateParams.contract_id, vm.data).then(function() {
          $state.go(goToLink, $stateParams);
        }).finally(function(){
          vm.sendingData = false;
        })
      }
    }

    function cancel() {
      $state.go(cancelLink, $stateParams);
    }

    // Private functions

    function parseInstallment(){
      var _lastIndexOf  = vm.data.installment_amount.lastIndexOf('.');
      var _amountLength = vm.data.installment_amount.length;
      var _amount       = vm.data.installment_amount;
      if (_lastIndexOf !== -1 && (_amountLength - _lastIndexOf <= 3 )){
        _amount = _amount.substr(0, _lastIndexOf) + ',' + vm.data.installment_amount.substr(_lastIndexOf, _amountLength);
      }
      return _amount.replace(new RegExp('\\.', 'g'), '').replace(",", ".");
    }

    activate();

    function activate() {
      var promises = {
        qGetConsumption       : customerService.getConsumption($stateParams.contract_account_id, $stateParams.contract_id),
        qGetBudgetBillingPlan : customerService.getBudgetBillingPlan($stateParams.contract_account_id, $stateParams.contract_id)
      };

      $q.all(promises).then(function(response) {
        var consumption       = response.qGetConsumption[0];
        vm.budgetBillingPlan  = response.qGetBudgetBillingPlan;

        var meterReading = usageMeterReadingService.getMeterReading();

        if(angular.isDefined(meterReading.level) && angular.isDefined(meterReading.code)){
          $rootScope.$broadcast('wml.portal.message', {level: meterReading.level, code:meterReading.code});
          meterReading.new_amount = vm.budgetBillingPlan.amount;
        }

        meterReading.reading_result = parseInt(meterReading.reading_result);

        if(consumption.meter_reading_results.length > 0 && angular.isObject(meterReading)){
          consumption.meter_reading_results = consumption.meter_reading_results.slice(0,1);

          meterReading.consumption = meterReading.reading_result - consumption.meter_reading_results[0].reading_result;
          meterReading.reading_date_time   = moment().format();
          consumption.meter_reading_results.unshift(meterReading);
        }

        vm.data.installment_amount         = $filter('number')(meterReading.new_amount, 1) + '0';
        vm.consumption = consumption;
      });
    }
  }

  angular
    .module('wml.portal.usage')
    .controller('UsageCompareController', UsageCompareController);
})();

(function() {
  'use strict';

  /** @ngInject */
  StandpipeController.$inject = ["cmsService", "detailService", "$rootScope", "enumService", "standpipeService"];
  function StandpipeController(cmsService, detailService, $rootScope, enumService, standpipeService) {
    // private variables
    var vm  = this;

    // public variables
    vm.sendingData        = false;
    vm.form               = null;
    vm.formData           = {
      company:{
        company_name:'',
        client_name:''
      },
      billing:{
        street:'',
        house_no:'',
        postal_code:'',
        city:'',
        house_no_addition:'',
        phone:'',
        email:'',
        invoice_electronic:true
      },
      location:{
        phone:'',
        contact_person:'',
        street:'',
        postal_code:'',
        city:'',
        house_no:'',
        hydrant:'',
        message:'',
        house_no_addition:''
      },
      duration: {
        start_date: "",
        start_timeslot: "",
        end_date: "",
        end_timeslot: ""
      },
      capacity:'',
      treatment:'',
      consumption:'',
      accept_rates: '',
      accept_conditions:''
    };

    vm.bottomBlock        = {};
    vm.startTimeslot      = null;
    vm.endTimeslot        = null;
    vm.capacity           = null;
    vm.formType           = null;
    vm.bShowForm          = true;
    vm.readOnlyCapacity   = false;

    // datepickers
    vm.showDatepickerStart       = false;
    vm.showDatepickerEnd         = false;
    vm.datepickerFormat          = "dd-MM-yyyy";
    vm.datepickerOptions         = {
      minDate : new Date(),
      dateDisabled : disabled
    };

    // Public function definitions
    vm.openDatepickerStart    = openDatepickerStart;
    vm.openDatepickerEnd      = openDatepickerEnd;
    vm.send                   = send;

    // Public functions
    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    function openDatepickerStart() {
      vm.showDatepickerStart = true;
    }

    function openDatepickerEnd() {
      vm.showDatepickerEnd = true;
    }

    function send(){
      if(vm.form.$valid) {
        vm.sendingData = true;

        standpipeService.send(vm.formData)
          .then(function () {
            vm.bShowForm = false;
          })
          .finally(function () {
            vm.sendingData = false;
          });
      }
    }



    // Private functions
    function disabled(data) {
      var date = data.date,
        mode = data.mode;
      return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
    }

    activate();

    function activate() {
      cmsService.loadData().then(function(data) {
        vm.data = data;

        if(angular.isDefined(data.Content.form) && data.Content.form.index){
          vm.formType = data.Content.form.index;
          vm.formData.type = vm.formType;

          enumService.getStandpipe(vm.formType, 'start_timeslot').then(function (response) {
            vm.startTimeslot = response.plain();
          });

          enumService.getStandpipe(vm.formType, 'end_timeslot').then(function (response) {
            vm.endTimeslot = response.plain();
          });

          enumService.getStandpipe(vm.formType, 'capacity').then(function (response) {
            vm.capacity = response.plain();

            if(vm.capacity.length === 1){
              vm.formData.capacity = vm.capacity[0].value;
              vm.readOnlyCapacity  = true;
            }
          });
        }

        cmsService.setSEO(data);

        $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);
      });

      detailService.getBlockContent().then(function(response){
        vm.bottomBlock = response.plain();
      });

    }
  }

  angular
    .module('wml.portal.standpipe')
    .controller('StandpipeController', StandpipeController);
})();

(function() {
  'use strict';

  /** @ngInject */
  SignUpThankYouController.$inject = ["$translate", "$rootScope"];
  function SignUpThankYouController($translate, $rootScope) {
    var vm  = this;

    // private variables

    // Public variables
    vm.text = $translate.instant('message.backoffice.1013');

    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');


    // Public function definitions


    // Public functions

    // Private functions

    activate();

    function activate() {

    }
  }

  angular
    .module('wml.portal.signup')
    .controller('SignUpThankYouController', SignUpThankYouController);
})();

(function() {
  'use strict';

  /** @ngInject */
  SignUpController.$inject = ["signUpService", "$state", "$rootScope"];
  function SignUpController(signUpService, $state, $rootScope) {
    var vm  = this;

    // private variables

    // Public variables
    vm.form = null;
    vm.data = {};
    vm.sendingData  = false;

    // Public function definitions
    vm.signUp = signUp;

    // Public functions

    function signUp() {
      vm.form.$commitViewValue();
      if(vm.form.$valid) {
        vm.sendingData = true;
        signUpService.signUp(vm.data).then(function(){
          $state.go('sign-upThankYou');
        }).finally(function(){
          vm.sendingData = false;
        });
      }
    }

    // Private functions

    activate();

    function activate() {
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }
  }

  angular
    .module('wml.portal.signup')
    .controller('SignUpController', SignUpController);
})();

(function() {
  'use strict';

  /** @ngInject */
  SideMenuController.$inject = ["$state", "navigationService"];
  function SideMenuController($state, navigationService) {
    var vm  = this;

    vm.currentState     = $state.current.name;
    vm.menuItems        = navigationService.getMenu.header;
    vm.getItems         = getItems;

    function getItems(level, parent) {
      parent = parent || null;
      return vm.menuItems.filter(function(item) {
        if(!parent) {
          return (parseInt(item.parent, 10) === parseInt(level, 10) && item.active && item.bVisible);
        } else {
          return (parseInt(item.parent, 10) === parseInt(level, 10) && parseInt(item.parentId, 10) === parseInt(parent, 10) && item.bVisible);
        }
      });
    }

  }

  angular
    .module('wml.portal.sideMenu')
    .controller('SideMenuController', SideMenuController);
})();

(function() {
  'use strict';

  /** @ngInject */
  SearchController.$inject = ["searchService", "$location", "$window", "$rootScope", "$scope", "$translate", "$q", "$timeout"];
  function SearchController(searchService, $location, $window, $rootScope, $scope, $translate, $q, $timeout) {
    var vm  = this;
    var _locationListener       = null;
    var _lastSearch             = null;

    // Public variables
    vm.data                     = {};
    vm.form                     = null;
    vm.sendingData              = false;
    vm.searchResults            = [];

    //public function definitions
    vm.send = send;

    var searchContainer = document.querySelector('.js-search-container');

    $scope.$watch(function() {
      var matches = $location.hash().match(/q=(.*)/);
      return matches[1];
    }, function(value, oldValue) {
      if (value && value !== oldValue) {
        var queryInput = document.querySelector('#oi-query');
        var submitButton = document.querySelector('#oi-submit');
        // vm.data.query = value;
        queryInput.value = value;
        $timeout(function() {
          queryInput.dispatchEvent(new Event('change'));
          submitButton.dispatchEvent(new Event('click'));
          window.location.reload();
        }, 1000);

      }
    });

    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    var translatePromises = [
      $translate('search.many_results'),
      $translate('search.few_results'),
      $translate('search.one_result'),
      $translate('search.no_results_for_query'),
      $translate('search.previous'),
      $translate('search.next')
    ];

    $q.all(translatePromises).then(function(translations) {
      $window.sitesearch(function(openindex) {
        var $searchForm = searchContainer.querySelector('.search-form');
        var $searchInput = searchContainer.querySelector('.search-input');
        var $openSearch = document.querySelector('.js-open-search');

        function openSearch() {
          searchContainer.classList.toggle('active');
          document.body.classList.add('no-scroll');
          if ($searchInput) $searchInput.focus();
        }

        openindex.lang.restrict = 'nl';
        openindex.result.showAddr = '';
        openindex.result.mm = 0;
        openindex.pager.manyResults = translations[0];
        openindex.pager.fewResults = translations[1];
        openindex.pager.oneResult = translations[2];
        openindex.pager.noResults = translations[3];
        openindex.pager.prevLabel = translations[4];
        openindex.pager.nextLabel = translations[5];
        openindex.useQueryStringParameters = true;

        // 20190527 - rob@ivengi.com -  'Misuse' template function to add parsed result data to array to make
        //                              Angular rendering possible.
        openindex.result.template = function (doc, url, title, addr, snippet, links, rank, image, time) {
          var div = document.createElement(('DIV'));
          div.innerHTML = title;

          $scope.$apply(function() {
            vm.searchResults.push({
              doc: doc,
              url: getParameterByName('url', url) || url,
              title: div.textContent || div.innerText || '',
              addr: addr,
              snippet: snippet,
              links: links,
              rank: rank,
              image: image,
              time: time
            });
          });
        };

        // openindex.result.addrLink = true;
        openindex.useQueryStringParameters = false;

        if ($openSearch) {
          $openSearch.onclick = function (e) {
            e.preventDefault();
            openSearch();
          };
        }

        openindex.notfound.defaultText = $translate.instant('search.no_result');
        openindex.notfound.text = $translate.instant('search.no_suggestions');

      });

    });
    //public functions
    function send(){
      vm.sendingData = true;
      $location.search('q', vm.data.query);
      if(vm.data.query !== _lastSearch){
        vm.searchResults = [];
        searchService.search(vm.data.query).then(function(response){
          $rootScope.$broadcast('wml.portal.message.cancel');
          if(response.webPages){
            vm.searchResults = response.webPages.value;
          }
        }).finally(function(){
          vm.sendingData = false;
          _lastSearch = vm.data.query;
        });
      } else {
        vm.sendingData = false;
      }
    }

    function search() {
      var location = $location.search();
      if(angular.isDefined(location.q)){
        vm.data.query = location.q;
        if(vm.data.query.length){
          if(vm.data.query !== _lastSearch){
            searchService.search(vm.data.query).then(function(response){
              $rootScope.$broadcast('wml.portal.message.cancel');
              if(response.webPages){
                vm.searchResults = response.webPages.value;
              }
            }).finally(function(){
              _lastSearch = vm.data.query;
            })
          }
        }
      }
    }
  }

  angular
    .module('wml.portal.search')
    .controller('SearchController', SearchController);
})();

(function() {
  'use strict';

  /** @ngInject */
  RoutesController.$inject = ["$state"];
  function RoutesController($state) {
    var vm = this;

    vm.list = $state.get();
  }

  angular.module('wml.portal.routes')
    .controller('RoutesController', RoutesController);

})();

(function () {
  'use strict';

  waterEstafetteRegistrationController.$inject = ["cmsService", "$rootScope", "detailService", "waterEstafetteService"];
  function waterEstafetteRegistrationController(cmsService,$rootScope, detailService, waterEstafetteService){
    var vm                  = this;
    var _maxNumberOfPersons = 15;

    //public functions
    vm.sendingData                = false;
    vm.bShowForm                  = true;
    vm.bShowNumberOfPersonsError  = false;
    vm.form                       = null;
    vm.personsOptions             = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];

    vm.types = [
      {
        label : 'Hardlopen',
        value:  'running'
      },
      {
        label : 'Wielrennen',
        value:  'cycling'
      }
    ];

    vm.distances = {
      running : [5,10,15],
      cycling : [40,60,90]
    };


    vm.formData = {
      association  : {
        name              : '',
        type              : '',
        postal_code       : '',
        city              : ''
      },
      contact      : {
        name       : '',
        email      : '',
        phone      : ''
      },
      competitors: [
        {
          type                 : 'cycling',
          number_of_persons    : 1,
          distance             : 90
        },
        {
          type                 : 'running',
          number_of_persons    : 1,
          distance             : ''
        }
      ]
    };


    // Public function definitions
    vm.send           = send;
    vm.addCompetitor  = addCompetitor;
    vm.removeRow      = removeRow;


    // Public functions
    function addCompetitor(){
      vm.formData.competitors.push({
        type                 : '',
        number_of_persons    : '',
        distance             : ''
      });
    }

    function removeRow(index){
      if(index > 0){
        vm.formData.competitors.splice(index, 1);
      }
    }

    function send() {
      if (vm.form.$valid) {
        vm.sendingData = true;
        if(_validateNumberOfPersons() <= _maxNumberOfPersons){
          vm.bShowNumberOfPersonsError = false;
          waterEstafetteService.register(vm.formData)
            .then(function () {
              vm.bShowForm = false;
            })
            .finally(function () {
              vm.sendingData = false;
            });
        } else {
          vm.bShowNumberOfPersonsError = true;
          vm.sendingData = false;
        }
      }
    }


    cmsService.loadData().then(function(data) {
      vm.data = data;

      cmsService.setSEO(data);

      $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);
    });

    // Private functions

    function _validateNumberOfPersons(){
      var count = 0;
      for(var i = 0; i < vm.formData.competitors.length; i++){
        count = count + vm.formData.competitors[i].number_of_persons;
      }
      return count;
    }

    activate();

    function activate() {

      cmsService.loadData().then(function (data) {
        vm.data = data;

        cmsService.setSEO(data);

        $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);
      });

      detailService.getBlockContent().then(function (response) {
        vm.bottomBlock = response.plain();
      });

    }
  }

  angular
    .module('wml.portal.water-estafette')
    .controller('waterEstafetteRegistrationController',waterEstafetteRegistrationController)

})();

(function() {
  'use strict';

  /** @ngInject */
  RegisterSummaryController.$inject = ["$rootScope", "$state", "registerService"];
  function RegisterSummaryController($rootScope, $state, registerService) {
    var vm  = this;
    vm.sendingData = false;

    // public variables
    vm.data = registerService.data;
    vm.insertion = {
      value: null,
      label: null
    };

    // public functions
    vm.previousState = previousState;
    vm.save = save;

    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    function save() {
      // check if vm.data.file_upload.name is set
      // if no more recollection of fileUpload, then file is gone due to refresh.
      if (vm.data && vm.data.meterReading && vm.data.meterReading.file_upload && vm.data.meterReading.file_upload.name && !vm.data.meterReading.file_upload.file) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 11013});
        vm.data.meterReading.file_upload = null;
        registerService.storeData();
        return;
      }

      vm.sendingData = true;
      registerService.save().then(function (data) {
        if (angular.isDefined(data.type) && data.type === 'message' && data.level !== 'success') {
          if (angular.isDefined(data.level) && (data.level === 'warning' || data.level === 'info')) {
            $rootScope.$broadcast('wml.portal.message', data);
            if (data.code === 12004 || data.code === 12008) {
              vm.data.forced_meter_reading = true;
              $state.go('registerMeterReading', {meterError: data.code});
            }
          }
        } else {
          $state.go('registerConfirmation');
        }
      }).catch(function () {
        // Notification: register api call failed contact customer support
        $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12106});
      }).finally(function () {
        vm.sendingData = false;
      });
    }

    // previous state function
    function previousState() {
      var bIsInFuture = vm.data.bIsInFuture;
      if (!bIsInFuture) { $state.go('registerPaymentMethod'); }
      if (bIsInFuture) { $state.go('registerPersonalInfo'); }
    }

    activate();
    function activate() {
      if (vm.data.personalInformation.insertion && vm.data.personalInformation.insertion.value) {
        vm.insertion = _.find(vm.data.insertions, function (ins) {
          return ins.value === vm.data.personalInformation.insertion.value;
        });
      }
    }
  }

  angular
    .module('wml.portal.register')
    .controller('RegisterSummaryController', RegisterSummaryController);
})();

(function() {
  'use strict';

  /** @ngInject */
  RegisterPortalController.$inject = ["$state", "registerService", "$rootScope"];
  function RegisterPortalController($state, registerService, $rootScope) {
    var vm  = this;

    // public variables
    vm.data           = registerService.data;

    // public functions
    vm.sendingData = false;
    vm.save          = save;
    vm.cancel = cancel;
    vm.skipStep      = skipStep;

    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    // function prospectToUser() {
    //   var bIsInFuture = vm.data.bIsInFuture;
    //   if (!bIsInFuture && vm.data.credentials.future_move_token) {
    //     vm.sendingData = true;
    //     registerService.prospectToUser().then(function (data) {
    //       if (angular.isDefined(data.type) && data.type === 'message' && data.level !== 'success') {
    //         if (angular.isDefined(data.level) && (data.level === 'warning' || data.level === 'info')) {
    //           $rootScope.$broadcast('wml.portal.message', data);
    //         }
    //       } else {
    //         $state.go('registerSummary');
    //       }
    //     }).catch(function () {
    //       // Notification: register api call failed contact customer support
    //       $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12106});
    //     }).finally(function () {
    //       vm.sendingData = false;
    //     });
    //   }
    //   $state.go('registerSummary');
    // }

    // save function
    function save() {
      vm.data.portalAccount.isSet = true;
      registerService.storeData();
      // prospectToUser();
    }

    function cancel() {
      $state.go('registerPaymentMethod');
    }

    function skipStep(){
      vm.data.portalAccount.email                 = null;
      vm.data.portalAccount.email_confirmation    = null;
      vm.data.portalAccount.password              = null;
      vm.data.portalAccount.password_confirmation = null;
      vm.data.portalAccount.isSet                 = false;
      registerService.storeData();
      // prospectToUser();
    }
  }

  angular
    .module('wml.portal.register')
    .controller('RegisterPortalController', RegisterPortalController);
})();

(function() {
  'use strict';

  /** @ngInject */
  RegisterPersonalInfoController.$inject = ["$state", "enumService", "registerService", "moment", "$rootScope"];
  function RegisterPersonalInfoController($state, enumService, registerService, moment, $rootScope) {
    var vm = this;

    // public variables
    vm.data = registerService.data;
    vm.emailInvoice = true;
    vm.customerSurvey = false;
    vm.salutations = [];
    vm.dateNow = moment().subtract(18, 'years').format('DD-MM-YYYY');

    // @TODO-mmy this is currently done through data.connectionAddress.customerType in view
    // @TODO-mmy should be data.personalInformation.customerType in view
    // @TODO-mmy also need to update API
    if (vm.data.personalInformation.customerType === null) {
      vm.data.personalInformation.customerType = 'residence';
    }

    // public functions
    vm.save = save;
    vm.toggleEmailInvoices = toggleEmailInvoices;
    vm.toggleCustomerSurvey = toggleCustomerSurvey;
    vm.previousState = previousState;

    // toggle functions
    function toggleEmailInvoices() {
      vm.emailInvoice = !vm.emailInvoice;
    }

    function toggleCustomerSurvey() {
      vm.customerSurvey = !vm.customerSurvey;
    }

    // save function
    function save() {
      registerService.storeData();
      // if not in future or token, go to meter readin
      var bIsInFuture = vm.data.bIsInFuture;
      if (!bIsInFuture || vm.data.credentials.future_move_token) { $state.go('registerMeterReading'); }
      if (bIsInFuture) {
        vm.data.personalInformation.emailInvoice = false;
        vm.data.personalInformation.customerSurvey = false;
        registerService.storeData();
        $state.go('registerSummary');
      }
    }

    // previous state function
    function previousState(){
      if (vm.data.connectionAddress.hasDifferentCorrespondence === true) {
        $state.go('registerCorrespondence');
      } else {
        $state.go('register');
      }
    }

    // enum service functions
    function getSalutations() {
      enumService.getSalutations().then(function(data){
        vm.salutations = data;
      });
    }
    function getInsertions() {
      enumService.getInsertions().then(function(data) {
        vm.data.insertions = data;
      });
    }

    function init(){
      getSalutations();
      getInsertions();
      if (vm.data.credentials.future_move_token && vm.data.connectionAddress.customerType === 'company') {
        vm.data.personalInformation.companyName = vm.data.personalInformation.lastName;
      }
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }

    init();
  }

  angular
    .module('wml.portal.register')
    .controller('RegisterPersonalInfoController', RegisterPersonalInfoController);
})();

(function () {
  'use strict';

  /** @ngInject */
  RegisterPaymentMethodController.$inject = ["$scope", "$state", "enumService", "registerService", "$rootScope"];
  function RegisterPaymentMethodController($scope, $state, enumService, registerService, $rootScope) {
    var vm = this;

    // private variables
    var _paymentDates = [];
    var _paymentFrequency = [];

    // public variables
    vm.data = registerService.data;
    vm.paymentMethods = [];
    vm.paymentFrequency = [];
    vm.paymentDates = [];

    // public functions
    vm.save = save;
    vm.cancel = cancel;
    vm.filterPaymentDays = filterPaymentDays;

    // save functions
    function save() {
      registerService.storeData();
      // 20210923 - rob@ivengi.com
      //            Skip registerPortal state on customer request
      $state.go('registerSummary');
    }

    function cancel() {
      $state.go('registerMeterReading');
    }

    // enumService Data
    function getPaymentMethods() {
      enumService.getPaymentMethods().then(function (data) {
        vm.paymentMethods = data.plain();

        // if not set preselect automatic payments
        if (vm.data.paymentMethod.payment_method.value === null && vm.data.paymentMethod.payment_method.label === null) {
          vm.data.paymentMethod.payment_method = vm.paymentMethods[0];
        }

        // if set set selected
        if (vm.data.paymentMethod.payment_method.value !== null && vm.data.paymentMethod.payment_method.label !== null) {
          for (var i = 0; i < vm.paymentMethods.length; i++) {
            if (vm.data.paymentMethod.payment_method.value === vm.paymentMethods[i].value) {
              vm.data.paymentMethod.payment_method = vm.paymentMethods[i];
              break;
            }
          }
        }
      });
    }

    function filterFrequencies() {
      vm.paymentFrequency = _paymentFrequency.filter(function (item) {
        if (vm.data.paymentMethod.payment_method.value === 'automatic_collection') {
          return item.value === '01' || item.value === '03';
        }
        return item.value === '03';
      });
    }

    function getPaymentFrequency() {
      enumService.getPaymentFrequency().then(function (data) {
        var _data = data.plain();

        // remove frequncy 02 & 04
        _paymentFrequency = _data.filter(function (item) {
          return item.value !== '02' && item.value !== '04';
        });

        filterFrequencies();

        // if set set selected
        if (vm.data.paymentMethod.payment_frequency.value !== null && vm.data.paymentMethod.payment_frequency.label !== null) {
          for (var i = 0; i < _paymentFrequency.length; i++) {
            if (vm.data.paymentMethod.payment_frequency.value === _paymentFrequency[i].value) {
              vm.data.paymentMethod.payment_frequency = _paymentFrequency[i];
              break;
            }
          }
        }
      });
    }

    function getPaymentDates() {
      enumService.getPaymentDates().then(function (data) {
        _paymentDates = data.plain();

        if (vm.data.paymentMethod.payment_frequency.value !== null && vm.data.paymentMethod.payment_frequency.label !== null) {
          filterPaymentDays();
        }
      });
    }

    function filterPaymentDays() {
      if (vm.data.paymentMethod.payment_frequency.value !== '01') {
        vm.paymentDates = _paymentDates.filter(function (item) {
          return item.value === '14D';
        });
        vm.data.paymentMethod.payment_date = vm.paymentDates[0];
      } else {
        vm.paymentDates = _paymentDates;

        if (vm.data.paymentMethod.payment_date.value !== null && vm.data.paymentMethod.payment_date.label !== null) {
          for (var k = 0; k < vm.paymentDates.length; k++) {
            if (vm.data.paymentMethod.payment_date.value === vm.paymentDates[k].value) {
              vm.data.paymentMethod.payment_date = vm.paymentDates[k];
              break;
            }
          }
        }
      }
    }

    var unregisterPaymentMethodWatcher = $scope.$watch(function () {
      return vm.data.paymentMethod.payment_method;
    }, function (newValue, oldValue) {
      filterFrequencies();
      if (newValue.value === 'bank_transfer') {
        for (var i = 0; i < vm.paymentFrequency.length; i++) {
          if (parseInt(vm.paymentFrequency[i].value) === 3) {
            vm.data.paymentMethod.payment_frequency = vm.paymentFrequency[i];
            break;
          }
        }
      }
    });

    $scope.$on('$destroy', unregisterPaymentMethodWatcher);

    function activate() {
      getPaymentMethods();
      getPaymentFrequency();
      getPaymentDates();
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }

    activate();
  }

  angular
    .module('wml.portal.register')
    .controller('RegisterPaymentMethodController', RegisterPaymentMethodController);
})();

(function () {
  'use strict';

  /** @ngInject */
  RegisterMoveInDateController.$inject = ["$document", "$timeout", "$state", "$scope", "$rootScope", "calendarsService", "storage", "registerService"];
  function RegisterMoveInDateController($document, $timeout, $state, $scope, $rootScope, calendarsService, storage, registerService) {
    var vm = this;

    // Public variables
    vm.form = null;
    vm.data = registerService.data;

    vm.showDatepicker = false;
    vm.datepickerFormat = "dd-MM-yyyy";
    vm.datepickerCurrentMonth = new Date();
    vm.datepickerOptions = {
      customClass: datePickerClass,
      maxDate: null,
      minDate: null
    };

    // Public function definitions
    vm.next = next;
    vm.cancel = cancel;
    vm.openDatepicker = openDatepicker;

    activate();

    $scope.$on('datepicker.monthChanged', function (event, newVal) {
      vm.datepickerCurrentMonth = newVal;
    });

    $scope.$on('datepicker.format', function (event, mode) {
      datepickerFormat(mode);
    });

    function datepickerFormat(mode) {
      if (mode === 'day') {
        $timeout(function () {
          var uibWeeks = $document[0].getElementsByClassName('uib-weeks');
          for (var i = 0; i < uibWeeks.length; i += 1) {
            var uibBans = uibWeeks[i].getElementsByClassName('uib-ban');
            if (uibBans.length === 7) {
              uibWeeks[i].style.display = 'none';
            }
            if (uibBans.length !== 7) {
              uibWeeks[i].style.display = 'table-row';
            }
          }
        }, 100);
      }
    }

    function datePickerClass(data) {
      var date = data.date;
      var mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        if (new Date(dayToCheck).getMonth() !== vm.datepickerCurrentMonth.getMonth()) {
          if (new Date(dayToCheck) > vm.datepickerCurrentMonth) {
            return 'uib-ban';
          }
          return 'uib-nope';
        }
        return 'uib-yeah';
      }
      return '';
    }

    function openDatepicker() {
      vm.datepickerCurrentMonth = (vm.data.meterReading.date) ? vm.data.meterReading.date : new Date();
      vm.showDatepicker = true;
      datepickerFormat('day');
    }

    function getCalendarSettingsFromImanager() {
      calendarsService.getCalendars('premisesRegister').then(function (response) {
        var max = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.moveInMaxDateCorporation : response.moveInMaxDate);
        var min = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.moveInMinDateCorporation : response.moveInMinDate);
        vm.datepickerOptions.maxDate = (isNaN(max)) ? null : new Date(new Date().setDate(new Date().getDate() + max));
        vm.datepickerOptions.minDate = (isNaN(min)) ? null : new Date(new Date().setDate(new Date().getDate() - min));
      });
    }

    // Public functions
    function next() {
      if (vm.form.$valid) {
        var today = new Date().setHours(0, 0, 0, 0);
        var moveInDate = new Date(vm.data.meterReading.date).setHours(0, 0, 0, 0);
        vm.data.bIsInFuture = (moveInDate > today);

        registerService.storeData();
        $state.go('register');
      }
    }

    function cancel() {
      registerService.clearData();
      $state.go('sign-up');
    }

    function activate() {
      getCalendarSettingsFromImanager();
      if (vm.data.meterReading.date !== null) {
        vm.data.meterReading.date = new Date(vm.data.meterReading.date);
      }
    }
  }

  angular
    .module('wml.portal.register')
    .controller('RegisterMoveInDateController', RegisterMoveInDateController);
})();

(function() {
  'use strict';

  /** @ngInject */
  RegisterMeterReadingController.$inject = ["$document", "$timeout", "$scope", "$state", "$stateParams", "calendarsService", "registerService", "$rootScope", "Upload", "meterReadingService", "MOVE_REASON"];
  function RegisterMeterReadingController($document, $timeout, $scope, $state, $stateParams, calendarsService, registerService, $rootScope, Upload, meterReadingService, MOVE_REASON) {
    var vm = this;

    vm.sendingData = false;
    vm.currentMeterReading = false;
    // public variables
    vm.data = registerService.data;
    vm.showDatepicker = false;
    vm.datepickerFormat = "dd-MM-yyyy";
    vm.datepickerCurrentMonth = new Date();
    vm.datepickerOptions = {
      customClass: datePickerClass,
      maxDate: null,
      minDate: null
    };

    if (!(vm.data.meterReading.date instanceof Date)) {
      vm.data.meterReading.date = new Date(vm.data.meterReading.date);
    }

    vm.fileToUpload = null;

    // public functions
    vm.openDatepicker = openDatepicker;
    vm.save = save;
    vm.cancel = cancel;
    vm.fileChange = fileChange;

    $scope.$on('datepicker.monthChanged', function (event, newVal) {
      vm.datepickerCurrentMonth = newVal;
    });

    $scope.$on('datepicker.format', function (event, mode) {
      datepickerFormat(mode);
    });

    function prospectToUser() {
      var bIsInFuture = vm.data.bIsInFuture;
      if (!bIsInFuture && vm.data.credentials.future_move_token) {
        vm.sendingData = true;
        registerService.prospectToUser().then(function (data) {
          if (angular.isDefined(data.type) && data.type === 'message' && data.level !== 'success') {
            if (angular.isDefined(data.level) && (data.level === 'warning' || data.level === 'info')) {
              $rootScope.$broadcast('wml.portal.message', data);
            }
          } else {
            $state.go('registerPaymentMethod');
          }
        }).catch(function () {
          // Notification: register api call failed contact customer support
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12106});
        }).finally(function () {
          vm.sendingData = false;
        });
      }
      $state.go('registerPaymentMethod');
    }

    function datepickerFormat(mode) {
      if (mode === 'day') {
        $timeout(function () {
          var uibWeeks = $document[0].getElementsByClassName('uib-weeks');
          for (var i = 0; i < uibWeeks.length; i += 1) {
            var uibBans = uibWeeks[i].getElementsByClassName('uib-ban');
            if (uibBans.length === 7) {
              uibWeeks[i].style.display = 'none';
            }
            if (uibBans.length !== 7) {
              uibWeeks[i].style.display = 'table-row';
            }
          }
        }, 100);
      }
    }

    function datePickerClass(data) {
      var date = data.date;
      var mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        if (new Date(dayToCheck).getMonth() !== vm.datepickerCurrentMonth.getMonth()) {
          if (new Date(dayToCheck) > vm.datepickerCurrentMonth) {
            return 'uib-ban';
          }
          return 'uib-nope';
        }
        return 'uib-yeah';
      }
      return '';
    }

    function openDatepicker() {
      vm.datepickerCurrentMonth = (vm.data.meterReading.date) ? vm.data.meterReading.date : new Date();
      vm.showDatepicker = true;
      datepickerFormat('day');
    }

    function getCalendarSettingsFromImanager() {
      calendarsService.getCalendars('register').then(function (response) {
        var max = response.meterReadingMaxDate;
        var min = response.meterReadingMinDate;
        vm.datepickerOptions.maxDate = (isNaN(max)) ? null : new Date(new Date().setDate(new Date().getDate() + max));
        vm.datepickerOptions.minDate = (isNaN(min)) ? null : new Date(new Date().setDate(new Date().getDate() - min));
      });
    }

    function fileChange(file, errFiles) {
      $rootScope.$broadcast('wml.portal.message.cancel');
      if (errFiles.length > 0) {
        if (errFiles[0].$error === "maxSize") {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
        } else {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
        }
      }
      if (file) {
        vm.data.meterReading.file_upload = null;
        vm.fileToUpload = file;
      }
    }

    // meter reading
    function watchMeterNumbers(){
      vm.currentMeterReading = vm.data.meterReading.meter_reading;

      $scope.$watch(function () { return vm.data.meterReading.meter_reading; }, function (newValue) {
        if (angular.isString(newValue)) {
          if (vm.data.meterReading.meter_reading && vm.currentMeterReading && vm.currentMeterReading !== newValue) {
            vm.data.forced_meter_reading = false;
            vm.currentMeterReading = vm.data.meterReading.meter_reading;
          }
          var data = newValue.split('');
          var length = data.length;
          if(length < 5) {
            for (var j=0; j < (5-length); j++) {
              data.unshift('0');
            }
          }
          for (var k=0; k < data.length; k++) {
            var key = 'num' + (k+1);
            vm.data.meterReading[key]  = data[k];
          }
        } else {
          for (var l=1; l <= 5; l++) {
            vm.data.meterReading['num' + l]  = 0;
          }
        }
      });
    }

    // save functions
    function save() {
      vm.sendingData = true;
      if (vm.form.$valid) {
        Upload.base64DataUrl(vm.fileToUpload)
          .then(function (dataUrl) {
            if (dataUrl) {
              vm.data.meterReading.file_upload = {
                file: dataUrl,
                name: vm.fileToUpload.name,
                type: vm.fileToUpload.type
              };
            }
          })
          .finally(function () {
            var today = new Date().setHours(0, 0, 0, 0);
            var moveInDate = new Date(vm.data.meterReading.date).setHours(0, 0, 0, 0);
            vm.data.bIsInFuture = (moveInDate > today);
            registerService.storeData();
            vm.currentMeterReading = vm.data.meterReading.meter_reading;
            if (vm.data.forced_meter_reading) {
              if (!vm.data.bIsInFuture) {
                prospectToUser();
              }
              if (vm.data.bIsInFuture) {
                vm.data.personalInformation.emailInvoice = false;
                vm.data.personalInformation.customerSurvey = false;
                registerService.storeData();
                $state.go('registerSummary');
              }
            } else {
              checkMeterReading();
            }
          });
      }
    }

    function checkMeterReadingSuccess(response) {
      if (angular.isDefined(response)) {
        if (angular.isDefined(response.level) && response.level === 'warning') {
          vm.data.forced_meter_reading = true;
          registerService.storeData();
          $state.go('registerMeterReading', {meterError: response.code});
        } else {
          if (!vm.data.bIsInFuture) {
            prospectToUser();
            $state.go('registerPaymentMethod');
          }
          if (vm.data.bIsInFuture) {
            vm.data.personalInformation.emailInvoice = false;
            vm.data.personalInformation.customerSurvey = false;
            registerService.storeData();
            $state.go('registerSummary');
          }
        }
      }
    }

    function checkMeterReading() {
      meterReadingService.meterReadingCheck(vm.data.connectionAddress.postal_code, vm.data.meterReading.meter_reading, vm.data.meterReading.date, vm.data.connectionAddress.contract_id, vm.data.connectionAddress.device_id, MOVE_REASON.MOVE_IN).then(function (response) {
        checkMeterReadingSuccess(response);
      }).catch(function (error) {
        if (error === null) {
          return;
        }


        var params = (angular.isDefined(error.fields)) ? error.fields : {};

        if (angular.isDefined(error.code)) {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params: params});
        } else if (error.data.code === 11011) { // exception - on register give generic warning and set force on
          vm.data.forced_meter_reading = true;
          registerService.storeData();
          $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 12004});
          $state.go('registerMeterReading', {meterError: 12004});
        } else {
          // Notification, no mail address available to send confirmation (12006)
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12006'});
        }
      }).finally(function () {
        vm.sendingData = false;
      });
    }

    function cancel() {
      $state.go('registerPersonalInfo');
    }

    activate();
    function activate() {
      getCalendarSettingsFromImanager();
      watchMeterNumbers();
      if (vm.data.forced_meter_reading && ($stateParams.meterError === 12004 || $stateParams.meterError === 12008 || $stateParams.meterError === 11004 || $stateParams.meterError === 11003)) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: $stateParams.meterError});
      }
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }
  }

  angular
    .module('wml.portal.register')
    .controller('RegisterMeterReadingController', RegisterMeterReadingController);
})();

(function () {
  'use strict';

  /** @ngInject */
  RegisterLoginController.$inject = ["$state", "$rootScope", "$timeout", "$location", "customerService", "registerService", "$stateParams", "ivAuthenticate", "storage", "jwtHelper"];
  function RegisterLoginController($state, $rootScope, $timeout, $location, customerService, registerService, $stateParams, ivAuthenticate, storage, jwtHelper) {
    var vm = this;

    vm.form = null;
    vm.data = registerService.data;
    vm.sendingData = false;

    // Public function definitions
    vm.doLogin = doLogin;

    function doLogin() {
      vm.form.$commitViewValue();
      if (vm.form.$valid) {
        $rootScope.$broadcast('wml.portal.message.cancel');
        $rootScope.$broadcast('wml.loader.start');

        vm.sendingData = true;

        vm.data.credentials.postal_code = vm.form.postal_code;
        vm.data.credentials.house_no = vm.form.house_no;
        vm.data.credentials.house_no_addition = vm.form.house_no_addition;

        // if hosFutureMove token query param
        if (vm.data.credentials.future_move_token.length) {
          // ivAuthenticate.shortTermLogin not needed here, API use future move token to vallidate user
          customerService.getFutureMove(vm.data.credentials).then(function (futureMoveRes) {
            var futureMove = futureMoveRes[0];
            vm.data.prospect = {
              exists: Boolean(futureMove.customer),
              moveDate: futureMove.date || '',
              premise: {
                postal_code: futureMove.postal_code,
                house_no: futureMove.house_num_1,
                house_no_addition: futureMove.house_num_2
              }
            };

            vm.data.personalInformation.initials = futureMove.first_name;
            vm.data.personalInformation.insertion = futureMove.prefix;
            vm.data.personalInformation.lastName = futureMove.last_name;
            vm.data.personalInformation.phone = futureMove.phone;
            vm.data.personalInformation.mobile_phone = futureMove.mobile;
            vm.data.personalInformation.email = futureMove.email;
            vm.data.personalInformation.birthday = futureMove.birthdate;

            var today = new Date().setHours(0, 0, 0, 0);
            var moveInDate = new Date(futureMove.date).setHours(0, 0, 0, 0);
            vm.data.bIsInFuture = (moveInDate > today);

            if (vm.data.prospect.exists) {
              vm.data.meterReading.date = new Date(vm.data.prospect.moveDate).setHours(0, 0, 0, 0);
              registerService.storeData();
              $state.go('register');
            } else {
              // Notification: This token has no future move request assigned, contact customer service
              $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
            }
          }).catch(function () {
            if (error === null) { return; }

            var params = (angular.isDefined(error.fields)) ? error.fields : {};

            if (angular.isDefined(error.code)) {
              $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params: params});
            } else {
              // Notification: Failed to get future move data, contact customer service
              $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12101});
            }

          }).finally(function () {
            $timeout(function () {
              $rootScope.$broadcast('wml.loader.stop');
            }, 1000);

            vm.sendingData = false;
          });
        } // else if no token available, this will be caught in active()
      } else {
        // not valid form
        $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code: '1001'});
      }
    }

    function activate() {
      var queryParams = $location.search();
      if (queryParams.fm && queryParams.fm.length) {
        // future move token exists
        if (/^\w+$/gi.test(queryParams.fm)) {
          vm.data.credentials.future_move_token = queryParams.fm;
          return;
        } else {
          // Notification: invalid token format, contact customer service.
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12100});
          return;
        }
      } else {
        // Notification: no token available, contact customer service.
        $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12105});
      }
    }
    activate();
  }

  angular.module('wml.portal.register')
    .controller('RegisterLoginController', RegisterLoginController);

})();

(function() {
  'use strict';

  /** @ngInject */
  RegisterCorrespondenceController.$inject = ["$state", "addressService", "registerService"];
  function RegisterCorrespondenceController($state, addressService, registerService) {
    var vm  = this;

    var _lastAutofill     = null;
    var _lastAutofillPo   = null;

    // public variables
    vm.data = registerService.data;

    if(vm.data.correspondenceAddress.country === null){
      vm.data.correspondenceAddress.country        = 'NL';
    }
    if(vm.data.correspondenceAddress.type === null) {
      vm.data.correspondenceAddress.type           = 'address';
    }

    vm.loading             = false;

    // public function defenitions
    vm.save               = save;
    vm.previousState      = previousState;
    vm.autofillHouseNo    = autofillHouseNo;
    vm.autofillPoBox      = autofillPoBox;
    vm.changeCountry      = changeCountry;
    vm.changeType         = changeType;

    // public functions
    function save() {
      if (vm.form.$valid) {
        registerService.storeData();
        $state.go('registerPersonalInfo');
      }
    }

    function previousState() {
      $state.go('register');
    }

    function autofillHouseNo() {
      if(vm.data.correspondenceAddress.country !== 'NL'){
        return false;
      }

      if(angular.isString(vm.data.correspondenceAddress.postal_code) && angular.isString(vm.data.correspondenceAddress.house_no)) {
        vm.data.correspondenceAddress.postal_code = vm.data.correspondenceAddress.postal_code.toUpperCase();

        if(/^[0-9]{4}[A-Z]{2}$/.test(vm.data.correspondenceAddress.postal_code)) {

          var data = {
            postal_code : vm.data.correspondenceAddress.postal_code,
            house_no    : vm.data.correspondenceAddress.house_no
          };

          var autofillKey = data.postal_code + '_' + data.house_no;

          if(angular.isString(vm.data.correspondenceAddress.house_no_addition) && vm.data.correspondenceAddress.house_no_addition.length > 0) {
            data.house_no_addition  = vm.data.correspondenceAddress.house_no_addition;
            autofillKey = autofillKey + '_' + vm.data.correspondenceAddress.house_no_addition;
          }

          if(autofillKey === _lastAutofill) {
            return false;
          }

          vm.data.correspondenceAddress.city        = null;
          vm.data.correspondenceAddress.street      = null;
          vm.loading          = true;

          _lastAutofill = autofillKey;

          autoFill(data);
        }
      }
    }

    function autofillPoBox() {
      if(vm.data.correspondenceAddress.country !== 'NL'){
        return false;
      }

      if(angular.isString(vm.data.correspondenceAddress.po_box_postal_code) && angular.isString(vm.data.correspondenceAddress.po_box)) {
        vm.data.correspondenceAddress.po_box_postal_code = vm.data.correspondenceAddress.po_box_postal_code.toUpperCase();

        if(/^[0-9]{4}[A-Z]{2}$/.test(vm.data.correspondenceAddress.po_box_postal_code)) {
          var data = {
            po_box_postal_code  : vm.data.correspondenceAddress.po_box_postal_code,
            po_box              : vm.data.correspondenceAddress.po_box
          };

          var autofillKey = data.po_box_postal_code + '_' + data.po_box;

          if(autofillKey === _lastAutofillPo) {
            return false;
          }

          vm.data.correspondenceAddress.city = null;
          vm.loading     = true;

          _lastAutofillPo = autofillKey;

          autoFill(data);
        }
      }
    }

    function changeCountry() {
      resetForm();

      if(vm.data.correspondenceAddress.country !== 'NL'){
        vm.data.correspondenceAddress.type = 'address';
      } else {
        vm.data.correspondenceAddress.type = '';
      }
    }

    function changeType(){
      resetForm();
    }

    //private functions
    function autoFill(data) {
      addressService.autofill(data).then(function(response) {
        var address = angular.copy(response.plain());
        vm.loading = false;

        if(address.street){
          vm.data.correspondenceAddress.street = address.street;
        }
        if(address.house_no_addition){
          vm.data.correspondenceAddress.house_no_addition = address.house_no_addition;
        }
        if(address.city){
          vm.data.correspondenceAddress.city = address.city;
        }
      });
    }

    function resetForm() {
      _lastAutofillPo = null;
      _lastAutofill   = null;

      vm.data.correspondenceAddress.postal_code         = null;
      vm.data.correspondenceAddress.po_box_postal_code  = null;
      vm.data.correspondenceAddress.po_box              = null;
      vm.data.correspondenceAddress.street              = null;
      vm.data.correspondenceAddress.house_no            = null;
      vm.data.correspondenceAddress.house_no_addition   = null;
      vm.data.correspondenceAddress.city                = null;
    }

  }

  angular
    .module('wml.portal.register')
    .controller('RegisterCorrespondenceController', RegisterCorrespondenceController);
})();

(function() {
  'use strict';

  /** @ngInject */
  RegisterController.$inject = ["$scope", "$state", "addressService", "registerService", "customerService", "$rootScope"];
  function RegisterController($scope, $state, addressService, registerService, customerService, $rootScope) {
    var vm = this;

    // private variables
    var _lastAutofill = null;
    vm.data = registerService.data;

    // public variables
    vm.loading  = false;
    vm.noValidAddress = true;

    // public functions
    vm.save = save;
    vm.cancel = cancel;
    vm.autofillHouseNo = autofillHouseNo;
    vm.hideNotification = hideNotification;

    $scope.$watch(function() {return vm.data.connectionAddress.customerType;}, function(newValue, oldValue) {
      if(newValue === 'company') {
        vm.data.connectionAddress.number_of_persons = 1;
      }
    });

    // save functions
    function save() {
      if (vm.form.$valid) {
        registerService.storeData();

        var futureMoveCheck = {
          postal_code: vm.data.connectionAddress.postal_code,
          house_no: vm.data.connectionAddress.house_no,
          house_no_addition: vm.data.connectionAddress.house_no_addition,
        };

        // always check if address has future move
        customerService.hasFutureMove(futureMoveCheck).then(function (isProspect) {
          // api Type Enum = MOVE_OUT:'O', MOVE_IN: 'I', MOVE_IN_OUT:'X';
          var moveInAlreadyExists = (isProspect.exists && (isProspect.move_in_out === 'I' || isProspect.move_in_out === 'X'));
          if (moveInAlreadyExists && !vm.data.credentials.future_move_token.length) {
            // notification: is already a prospect, contact customer service
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12103'});
            return;
          }

          if (!vm.data.connectionAddress.hasDifferentCorrespondence) {
            $state.go('registerPersonalInfo');
          } else {
            $state.go('registerCorrespondence');
          }
        })
          .catch(function () {
            // notification: failed to check if has future move data, contact customer service.
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12104'});
            return;
          });
      }
    }

    function cancel() {
      // make decision based on future move token, go to premisses-register login
      if (vm.data.credentials.future_move_token.length) {
        $state.go('registerLogin', {fm: vm.data.credentials.future_move_token});
      } else {
        $state.go('registerMoveInDate');
      }
    }

    function hideNotification() {
      $rootScope.$broadcast('wml.portal.message.cancel');
    }

    // autofill functions
    function autofillHouseNo() {
      if(angular.isString(vm.data.connectionAddress.postal_code) && angular.isString(vm.data.connectionAddress.house_no)) {
        vm.data.connectionAddress.postal_code = vm.data.connectionAddress.postal_code.toUpperCase();

        if (/^[0-9]{4}[A-Z]{2}$/.test(vm.data.connectionAddress.postal_code.replace(/\s/g, ''))) {
          var data = {
            postal_code       : vm.data.connectionAddress.postal_code,
            house_no          : vm.data.connectionAddress.house_no,
            house_no_addition : null
          };

          if(angular.isString(vm.data.connectionAddress.house_no_addition) && vm.data.connectionAddress.house_no_addition.length > 0) {
            data.house_no_addition  = vm.data.connectionAddress.house_no_addition;
          }

          var autofillKey = data.postal_code + '_' + data.house_no + '_' + data.house_no_addition;
          if(autofillKey === _lastAutofill) {
            return false;
          }
          vm.noValidAddress   = true;
          vm.loading                            = true;
          vm.data.connectionAddress.city        = null;
          vm.data.connectionAddress.street      = null;

          _lastAutofill = autofillKey;

          autoFill(data);
        }
      }
    }

    function autoFill(data) {
      addressService.autofill(data).then(function(response) {
        var address = angular.copy(response.plain());

        vm.data.connectionAddress.premise_id  = address.premise_id || null;
        vm.loading = false;
        vm.noValidAddress   = false;

        // $rootScope.$broadcast('wml.portal.message.cancel');

        if(typeof address.valid_for_subscription === 'boolean' && !address.valid_for_subscription){
          vm.noValidAddress = true;
          $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code: '1005'});
        }

        if(address.city === null){
          vm.noValidAddress = true;
          $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code: '1004'});
        }

        if(address.street){
          vm.data.connectionAddress.street = address.street;
        }

        if(address.house_no_addition){
          vm.data.connectionAddress.house_no_addition = address.house_no_addition;
        }

        if(address.city){
          vm.data.connectionAddress.city = address.city;
        }

        if (address.meter_number) {
          vm.data.connectionAddress.meter_number = address.meter_number;
        }

        if (address.contract_id) {
          vm.data.connectionAddress.contract_id = address.contract_id;
        }

        if (address.device_id) {
          vm.data.connectionAddress.device_id = address.device_id;
        }
      });
    }

    activate();

    function activate() {
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

      if (angular.isDefined(vm.data.prospect.exists) && vm.data.prospect.exists && vm.data.credentials.future_move_token.length) {
        vm.data.connectionAddress.postal_code = vm.data.prospect.premise.postal_code;
        vm.data.connectionAddress.house_no = vm.data.prospect.premise.house_no;
        vm.data.connectionAddress.house_no_addition = vm.data.prospect.premise.house_no_addition;
      }

      if (vm.data.connectionAddress.postal_code && vm.data.connectionAddress.house_no) {
        vm.autofillHouseNo();
      }

      if(vm.data.connectionAddress.city !== null){
        vm.noValidAddress = false;
      }
    }

  }

  angular
    .module('wml.portal.register')
    .controller('RegisterController', RegisterController);
})();

(function () {
  'use strict';

  /** @ngInject */
  RegisterConfirmationController.$inject = ["$rootScope", "registerService"];
  function RegisterConfirmationController($rootScope, registerService) {
    var vm = this;

    vm.data = registerService.data;
    vm.isInFuture = '';
    vm.moveInDate = '';

    activate();

    function activate() {
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
      vm.isInFuture = (vm.data.bIsInFuture) ? 'future_' : '';
      vm.moveInDate = vm.data.meterReading.date;
      registerService.clearData();
    }
  }
  angular
    .module('wml.portal.register')
    .controller('RegisterConfirmationController', RegisterConfirmationController);
})();

(function() {
  'use strict';

  /** @ngInject */
  profilePasswordController.$inject = ["$state", "$timeout", "profileService", "storage"];
  function profilePasswordController($state, $timeout, profileService, storage) {

    var vm = this;


    // private variables

    // Public variables
    vm.form = null;
    vm.bShowCurrentPassword = true;
    vm.sendingData          = false;

    // Public function definitions
    vm.save = save;

    // Public functions
    function save() {
      vm.form.$commitViewValue();
      if(vm.form.$valid) {
        vm.sendingData = true;
        profileService.changePassword(vm.form).then(function(){
          storage('activation_query', null);
          $timeout(function() {
            $state.go('profile');
          }, 2000);
        }).finally(function(){
          vm.sendingData = false;
        });
      }
    }

    // Private functions
    activate();

    function activate(){
      if(storage('activation_query')){
        vm.bShowCurrentPassword = false;
      }
    }
  }

  angular
    .module('wml.portal.profile')
    .controller('ProfilePasswordController', profilePasswordController);
})();

(function() {
  'use strict';

  /** @ngInject */
  profileEmailController.$inject = ["$rootScope", "$state", "profileService"];
  function profileEmailController($rootScope, $state, profileService) {

    var vm = this;

    // Public variables
    vm.form         = null;
    vm.sendingData  = false;

    // Public function definitions
    vm.save = save;

    // Public functions
    function save() {
      vm.form.$commitViewValue();
      if(vm.form.$valid) {
        vm.sendingData = true;
        profileService.changeEmail(vm.form).then(function (response) {
          if (vm.form.update_correspondence_email) {
            $rootScope.$broadcast('clear-cache', {customer: {customer: true}});
          }
          vm.form.email              = '';
          vm.form.email_confirmation = '';
          vm.form.update_correspondence_email = false;
          vm.form.$setPristine();
          $state.go('profile', {message: response});
          vm.sendingData = false;
        });
      }
    }
  }

  angular
    .module('wml.portal.profile')
    .controller('ProfileEmailController', profileEmailController);
})();

(function() {
  'use strict';

  /** @ngInject */
  profileController.$inject = ["$rootScope", "$stateParams", "profileService"];
  function profileController($rootScope, $stateParams, profileService) {

    var vm = this;
    vm.data = {};

    activate();

    function activate() {
      if ($stateParams.message) {
        $rootScope.$broadcast('wml.portal.message', $stateParams.message);
      }

      profileService.getProfile().then(function(response) {
        vm.data = response;
      });
    }

  }

  angular
    .module('wml.portal.profile')
    .controller('ProfileController', profileController);
})();

(function() {
  'use strict';

  /** @ngInject */
  PremisesActionOverviewController.$inject = ["premisesService"];
  function PremisesActionOverviewController(premisesService) {
    var vm  = this;

  }

  angular.module('wml.portal.premises')
    .controller('PremisesActionOverviewController', PremisesActionOverviewController);

})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesUnregisterThankYouController.$inject = ["$rootScope", "premiseUnregisterService", "ivAuthenticate"];
  function PremisesUnregisterThankYouController($rootScope, premiseUnregisterService, ivAuthenticate) {

    var vm = this;
    vm.data = premiseUnregisterService.data;
    vm.isAuth = false;

    vm.isInFuture = null;
    vm.inFutureTranslation = '';
    vm.moveOutDate = '';

    // private variables

    // Public variables

    // Public function definitions

    // Public functions

    // Private functions

    activate();

    function activate() {
      if (ivAuthenticate.isAuthenticated()) {
        vm.isAuth = true;
      }
      vm.isInFuture = vm.data.bIsInFuture;
      vm.inFutureTranslation = (vm.isInFuture) ? 'future_' : '';
      vm.moveOutDate = vm.data.meter_reading.date;
      premiseUnregisterService.clearData();
      $rootScope.$broadcast('clear-cache', {customer: true});
    }
  }

  angular
    .module('wml.portal.premisesRegister')
    .controller('PremisesUnregisterThankYouController', PremisesUnregisterThankYouController);
})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesUnregisterSummaryController.$inject = ["$state", "premiseUnregisterService", "premisesService", "customerService", "$rootScope", "ivAuthenticate", "storage"];
  function PremisesUnregisterSummaryController($state, premiseUnregisterService, premisesService, customerService, $rootScope, ivAuthenticate, storage) {
    var vm = this;

    // private variables

    // Public variables
    vm.sendingData      = false;
    vm.form             = null;
    vm.data             = premiseUnregisterService.data;

    // Public function definitions
    vm.save                          = save;
    vm.cancel                        = cancel;

    // Public functions
    function save() {
      // check if vm.data.file_upload.name is set
      // if no more recollection of fileUpload, then file is gone due to refresh.
      if (vm.data && vm.data.meter_reading && vm.data.meter_reading.file_upload && vm.data.meter_reading.file_upload.name && !vm.data.meter_reading.file_upload.file) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 11013});
        vm.data.meter_reading.file_upload = null;
        premiseUnregisterService.storeData();
        return;
      }
      vm.sendingData = true;
      if(vm.data.correspondence.bSetNew === false) {
        customerService.getAddress().then(function (response) {
          var data = response.plain();
          var bSetAsNewEmail = vm.data.correspondence.bSetAsNewEmail;
          var confirmationEmail = vm.data.correspondence.confirmationEmail;
          vm.data.correspondence = data;
          vm.data.correspondence.bSetAsNewEmail = bSetAsNewEmail;
          vm.data.correspondence.confirmationEmail = confirmationEmail;
          vm.data.correspondence.country = response.country_id; // set country to two digit code
          vm.data.correspondence.type = 'address';

          if(data.po_box.length){
            vm.data.correspondence.type = 'po_box';
          }

          vm.data.correspondence.bSetNew = false;
          premiseUnregister();
        });
      } else {
        premiseUnregister();
      }
    }

    function premiseUnregister(){
      premiseUnregisterService.unregister().then(function(response) {
        if(vm.data.correspondence.bSetNew === true){
          customerService.clearAddressCache();
        }
        unregisterSuccess(response);
      }).catch(function (error) {
        if (error === null) { return; }

        var params = (angular.isDefined(error.fields)) ? error.fields : {};

        if (angular.isDefined(error.code)) {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params: params});
        } else {
          // Notification, no mail address available to send confirmation (12006)
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12006'});
        }
      }).finally(function () {
        vm.sendingData = false;
      });
    }

    function unregisterSuccess(response) {
      if (vm.data.afterNewRegister) {
        // if already unregistered and nothing changed, nav to home
        return $state.go('home');
      } else if (angular.isObject(response) && angular.isDefined(response.code) && (response.code === 12004 || response.code === 12008)) {
        $rootScope.$broadcast('wml.portal.message', response);
        vm.data.forced_meter_reading = true;
        $state.go('premisesUnregisterMeterReading', {meterError: response.code});
      } else {
        if (storage('corporation') && angular.isObject(storage('corporation_address'))) {
          clearCache();
          // 20181217 - rob@ivengi.com
          //            Redirect to chooseAddress for corporation when successfully unregistering an address
          $state.go('chooseAddress', {refresh: true});
          // $state.go('premisesUnregisterThankYou');
        } else {
          if (premisesService.getProcesStatus() === 'moving_out') {
            if (ivAuthenticate.isAuthenticated() && !vm.data.bIsInFuture) {
              premisesService.askToContinueModal().then(function () {
                $state.go('premisesRegister');
              }, function () {
                $state.go('customer');
              }).finally(function () {
                clearCache();
              });
            } else {
              $state.go('premisesUnregisterThankYou');
            }
          } else {
            $state.go('premisesUnregisterThankYou');
          }
        }
      }
    }

    function cancel() {
      var bIsInFuture = vm.data.bIsInFuture;
      if (ivAuthenticate.isAuthenticated()) {
        if (bIsInFuture) {
          if (vm.data.email.bSetNew && vm.data.email.correspondence) {
            $state.go('premisesUnregisterFutureCorrespondenceEmail');
          } else {
            $state.go('premisesUnregister');
          }
        }
        if (!bIsInFuture) {
          if (vm.data.correspondence.bSetNew === true) {
            $state.go('premisesUnregisterCorrespondenceAddress');
          } else {
            $state.go('premisesUnregisterMeterReading');
          }
        }
      } else {
        if (vm.data.afterNewRegister) {
          $rootScope.$broadcast('clear-cache');
          $state.go('home');
        }
        else if (!bIsInFuture) { $state.go('premisesUnregisterEmail'); }
        else if (bIsInFuture) { $state.go('premisesUnregister'); }
      }
    }

    function clearCache() {
      premiseUnregisterService.clearData();
      $rootScope.$broadcast('clear-cache', {customer : true});
    }

    // Private functions
    activate();

    function activate() {

    }
  }

  angular.module('wml.portal.premisesUnregister')
    .controller('PremisesUnregisterSummaryController', PremisesUnregisterSummaryController);
})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesUnregisterMoveOutDateController.$inject = ["$rootScope", "$timeout", "$document", "$state", "$scope", "$filter", "calendarsService", "moment", "premiseUnregisterService", "customerService", "ivAuthenticate", "premisesService", "storage"];
  function PremisesUnregisterMoveOutDateController($rootScope, $timeout, $document, $state, $scope, $filter, calendarsService, moment, premiseUnregisterService, customerService, ivAuthenticate, premisesService, storage) {
    var vm = this;

    // Public variables
    vm.form = null;
    vm.data = premiseUnregisterService.data;

    vm.showDatepicker = false;
    vm.datepickerFormat = "dd-MM-yyyy";
    vm.datepickerCurrentMonth = new Date();
    vm.datepickerOptions = {
      customClass: datePickerClass,
      maxDate: null,
      minDate: null
    };

    // Public function definitions
    vm.next = next;
    vm.cancel = cancel;
    vm.openDatepicker = openDatepicker;

    activate();

    $scope.$on('datepicker.monthChanged', function (event, newVal) {
      vm.datepickerCurrentMonth = newVal;
    });

    $scope.$on('datepicker.format', function (event, mode) {
      datepickerFormat(mode);
    });

    function datepickerFormat(mode) {
      if (mode === 'day') {
        $timeout(function () {
          var uibWeeks = $document[0].getElementsByClassName('uib-weeks');
          for (var i = 0; i < uibWeeks.length; i += 1) {
            var uibBans = uibWeeks[i].getElementsByClassName('uib-ban');
            if (uibBans.length === 7) {
              uibWeeks[i].style.display = 'none';
            }
            if (uibBans.length !== 7) {
              uibWeeks[i].style.display = 'table-row';
            }
          }
        }, 100);
      }
    }

    function datePickerClass(data) {
      var date = data.date;
      var mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        if (new Date(dayToCheck).getMonth() !== vm.datepickerCurrentMonth.getMonth()) {
          if (new Date(dayToCheck) > vm.datepickerCurrentMonth) {
            return 'uib-ban';
          }
          return 'uib-nope';
        }
        return 'uib-yeah';
      }
      return '';
    }

    function openDatepicker() {
      vm.datepickerCurrentMonth = (vm.data.meter_reading.date) ? vm.data.meter_reading.date : new Date();
      vm.showDatepicker = true;
      datepickerFormat('day');
    }

    function getCalendarSettingsFromImanager() {
      calendarsService.getCalendars('premisesUnregister').then(function (response) {
        var max = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.moveOutMaxDateCorporation : response.moveOutMaxDate);
        var min = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.moveOutMinDateCorporation : response.moveOutMinDate);
        vm.datepickerOptions.maxDate = (isNaN(max)) ? null : new Date(new Date().setDate(new Date().getDate() + max));
        vm.datepickerOptions.minDate = (isNaN(min)) ? null : new Date(new Date().setDate(new Date().getDate() - min));
      });
    }

    function next() {
      if (vm.form.$valid) {

        var today = new Date().setHours(0, 0, 0, 0);
        var moveOutDate = new Date(vm.data.meter_reading.date).setHours(0, 0, 0, 0);
        vm.data.bIsInFuture = (moveOutDate > today);

        premiseUnregisterService.storeData();
        if (ivAuthenticate.isAuthenticated()) {
          $state.go('premisesUnregister');
        } else {
          $state.go('premisesUnregisterLogin');
        }
      }
    }

    function cancel() {
      premisesService.clearProcesStatus();
      premiseUnregisterService.clearData();
      if (ivAuthenticate.isAuthenticated()) {
        premiseUnregisterService.clearData();
        $state.go('customer');
      } else {
        $rootScope.$broadcast('clear-cache', {customer: true});
        premiseUnregisterService.clearData();
        $state.go('home');
      }
    }

    function activate() {
      if (storage('corporation')) {
        $state.go('premisesUnregister');
      }
      getCalendarSettingsFromImanager();
      if (vm.data.meter_reading.date !== null) {
        vm.data.meter_reading.date = new Date(vm.data.meter_reading.date);
      }
    }
  }

  angular
    .module('wml.portal.premisesUnregister')
    .controller('PremisesUnregisterMoveOutDateController', PremisesUnregisterMoveOutDateController);
})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesUnregisterMeterReadingController.$inject = ["$document", "$timeout", "$rootScope", "$state", "$stateParams", "$scope", "$filter", "calendarsService", "premiseUnregisterService", "customerService", "storage", "ivAuthenticate", "Upload", "meterReadingService", "MOVE_REASON"];
  function PremisesUnregisterMeterReadingController($document, $timeout, $rootScope, $state, $stateParams, $scope, $filter, calendarsService, premiseUnregisterService, customerService, storage, ivAuthenticate, Upload, meterReadingService, MOVE_REASON) {

    var vm = this;

    // private variables
    var _correspondenceAddress  = null;
    var _chosenPremise          = null;
    var _state                   = '';

    // Public variables
    vm.form             = null;
    vm.data             = premiseUnregisterService.data;
    vm.consumption      = null;

    vm.currentMeterReading = false;

    vm.showDatepicker = false;
    vm.datepickerFormat = "dd-MM-yyyy";
    vm.datepickerCurrentMonth = new Date();
    vm.datepickerOptions = {
      customClass: datePickerClass,
      minDate: null,
      maxDate: null
    };

    vm.fileToUpload = null;
    vm.sendingData  = false;

    // Public function definitions
    vm.next                          = next;
    vm.cancel                        = cancel;
    vm.openDatepicker                = openDatepicker;
    vm.fileChange                    = fileChange;

    $scope.$on('datepicker.monthChanged', function (event, newVal) {
      vm.datepickerCurrentMonth = newVal;
    });

    $scope.$on('datepicker.format', function (event, mode) {
      datepickerFormat(mode);
    });

    function datepickerFormat(mode) {
      if (mode === 'day') {
        $timeout(function () {
          var uibWeeks = $document[0].getElementsByClassName('uib-weeks');
          for (var i = 0; i < uibWeeks.length; i += 1) {
            var uibBans = uibWeeks[i].getElementsByClassName('uib-ban');
            if (uibBans.length === 7) {
              uibWeeks[i].style.display = 'none';
            }
            if (uibBans.length !== 7) {
              uibWeeks[i].style.display = 'table-row';
            }
          }
        }, 100);
      }
    }

    function datePickerClass(data) {
      var date = data.date;
      var mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        if (new Date(dayToCheck).getMonth() !== vm.datepickerCurrentMonth.getMonth()) {
          if (new Date(dayToCheck) > vm.datepickerCurrentMonth) {
            return 'uib-ban';
          }
          return 'uib-nope';
        }
        return 'uib-yeah';
      }
      return '';
    }

    function openDatepicker() {
      vm.datepickerCurrentMonth = (vm.data.meter_reading.date) ? vm.data.meter_reading.date : new Date();
      vm.showDatepicker = true;
      datepickerFormat('day');
    }

    function getCalendarSettingsFromImanager() {
      calendarsService.getCalendars('premisesUnregister').then(function (response) {
        var max = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.meterReadingMaxDateCorporation : response.meterReadingMaxDate);
        var min = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.meterReadingMinDateCorporation : response.meterReadingMinDate);
        vm.datepickerOptions.maxDate = (isNaN(max)) ? null : new Date(new Date().setDate(new Date().getDate() + max));
        vm.datepickerOptions.minDate = (isNaN(min)) ? null : new Date(new Date().setDate(new Date().getDate() - min));
      });
    }

    function fileChange(file, errFiles) {
      $rootScope.$broadcast('wml.portal.message.cancel');
      if (errFiles.length > 0) {
        if (errFiles[0].$error === "maxSize") {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
        } else {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
        }
      }
      if (file) {
        vm.data.meter_reading.file_upload = null;
        vm.fileToUpload = file;
      }
    }

    function checkMeterReadingSuccess(response) {
      if (angular.isObject(response) && angular.isDefined(response.code) && (response.code === 11003 || response.code === 11004)) {
        $rootScope.$broadcast('wml.portal.message', response);
        vm.data.forced_meter_reading = true;
        premiseUnregisterService.storeData();
        $state.go('premisesUnregisterMeterReading', {meterError: response.code});
      } else {
        $state.go(_state);
      }
    }

    function checkMeterReading() {
      meterReadingService.meterReadingCheck(vm.data.credentials.postal_code, vm.data.meter_reading.meter_reading, vm.data.meter_reading.date, vm.data.address.contract_id, vm.data.address.device.id, MOVE_REASON.MOVE_OUT).then(function (response) {
        checkMeterReadingSuccess(response);
      }).catch(function (error) {
        if (error === null) {
          return;
        }

        var params = (angular.isDefined(error.fields)) ? error.fields : {};

        if (angular.isDefined(error.code)) {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params: params});
        } else {
          // Notification, no mail address available to send confirmation (12006)
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12006'});
        }
      }).finally(function () {
        vm.sendingData = false;
      });
    }

    function next() {
      vm.sendingData = true;
      if (vm.form.$valid) {
        Upload.base64DataUrl(vm.fileToUpload)
          .then(function (dataUrl) {
            if (dataUrl) {
              vm.data.meter_reading.file_upload = {
                file: dataUrl,
                name: vm.fileToUpload.name,
                type: vm.fileToUpload.type
              };
            }
          })
          .finally(function () {
            if (_correspondenceAddress === _chosenPremise && !storage('corporation')) {
              vm.data.correspondence.bSetNew = true;
              _state = 'premisesUnregisterCorrespondenceAddress';
            } else {
              vm.data.correspondence.bSetNew = false;
              _state = (ivAuthenticate.isAuthenticated()) ? 'premisesUnregisterSummary' : 'premisesUnregisterEmail';
            }
            premiseUnregisterService.storeData();
            if (vm.data.forced_meter_reading) {
              $state.go(_state);
            } else {
              checkMeterReading();
            }
          });
      }
    }

    function cancel() {
      $state.go('premisesUnregister');
    }

    // Private functions
    function getAddressesSuccess(response) {
      _correspondenceAddress = response.house_no + response.house_no_addition + response.postal_code;
      _chosenPremise = vm.data.address.address.house_no + vm.data.address.address.house_no_addition + vm.data.address.address.postal_code;
    }

    function watchMeterNumbers(){
      vm.aNumberOfMeterNumbers  = [];
      for(var i=0; i < vm.numberOfMeterNumbers; i++){
        vm.aNumberOfMeterNumbers[i] = i + 1;
      }
      vm.currentMeterReading = vm.data.meter_reading.meter_reading;

      //meter reading
      $scope.$watch(function() {return vm.data.meter_reading.meter_reading;}, function(newValue) {
        if(angular.isString(newValue)) {
          if (vm.data.meter_reading.meter_reading && vm.currentMeterReading && vm.currentMeterReading !== newValue) {
            vm.data.forced_meter_reading = false;
            vm.currentMeterReading = vm.data.meter_reading.meter_reading;
          }
          var data    = newValue.split('');
          var length  = data.length;
          if(length < vm.numberOfMeterNumbers) {
            for(var j=0; j < (vm.numberOfMeterNumbers-length); j++) {
              data.unshift('0');
            }
          }
          for(var k=0; k < data.length; k++) {
            var key = 'num' + (k+1);
            vm.data.meter_reading[key]  = data[k];
          }
        } else {
          for(var l=1; l <= vm.numberOfMeterNumbers; l++) {
            vm.data.meter_reading['num' + l]  = 0;
          }
        }
      });
    }

    activate();

    function activate() {

      getCalendarSettingsFromImanager();

      if(vm.data.meter_reading.date !== null){
        vm.data.meter_reading.date = new Date(vm.data.meter_reading.date);
      }

      if (vm.data.forced_meter_reading && ($stateParams.meterError === 12004 || $stateParams.meterError === 12008 || $stateParams.meterError === 11004 || $stateParams.meterError === 11003)) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 12004});
      }

      customerService.getAddress().then(getAddressesSuccess);

      if (storage('corporation') && angular.isObject(storage('corporation_address'))) {
        vm.numberOfMeterNumbers = 5;
        watchMeterNumbers();

      } else  {
        customerService.getPremise(vm.data.address.premise_id).then(function(response){
          vm.numberOfMeterNumbers = response.device.pre_decimal || 5;
          watchMeterNumbers();
        });

        customerService.getConsumption(vm.data.address.contract_account_id, vm.data.address.contract_id).then(function(response){
          for(var i=0; i < response[0].meter_reading_results.length; i++) {
            if(response[0].meter_reading_results[i].is_open === false) {
              response[0].meter_reading_results[i].reading_date_time  = $filter('date')(response[0].meter_reading_results[i].reading_date_time, 'longDate');
              vm.consumption = response[0].meter_reading_results[i];
              break;
            }
          }
        });
      }
    }
  }

  angular
    .module('wml.portal.premisesUnregister')
    .controller('PremisesUnregisterMeterReadingController', PremisesUnregisterMeterReadingController);
})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesUnregisterLoginController.$inject = ["$state", "$rootScope", "$timeout", "customerService", "premisesService", "premiseUnregisterService", "premiseRegisterService", "$stateParams", "$location", "ivAuthenticate", "storage", "jwtHelper"];
  function PremisesUnregisterLoginController($state, $rootScope, $timeout, customerService, premisesService, premiseUnregisterService, premiseRegisterService, $stateParams, $location, ivAuthenticate, storage, jwtHelper) {
    var vm = this;

    vm.form = null;
    vm.data = premiseUnregisterService.data;
    vm.sendingData = false;

    // Public function definitions
    vm.doLogin = doLogin;
    vm.cancel = cancel;
    vm.loginError = loginError;
    vm.formatFutureMoveResponse = formatFutureMoveResponse;

    // Public functions
    function cancel() {
      if (vm.data.credentials.future_move_token.length) {
        $rootScope.$broadcast('clear-cache');
        $state.go('home');
      } else {
        $state.go('premisesUnregisterMoveOutDate');
      }
    }

    function doLogin() {
      vm.form.$commitViewValue();
      if (vm.form.$valid) {
        $rootScope.$broadcast('wml.portal.message.cancel');
        $rootScope.$broadcast('wml.loader.start');

        vm.sendingData = true;

        vm.data.credentials.customer_number = vm.form.customer_number;
        vm.data.credentials.postal_code = vm.form.postal_code;
        vm.data.credentials.house_no = vm.form.house_no;
        vm.data.credentials.house_no_addition = vm.form.house_no_addition;
        vm.data.credentials.grant_type = 'short_term';

        ivAuthenticate.shortTermLogin(vm.data.credentials).then(function (response) {
          var claims = jwtHelper.decodeToken(response.data.access_token);

          if (angular.isDefined(claims)) {
            if (angular.isDefined(claims.corporation)) {
              storage('corporation', claims.corporation);
            }
            if (angular.isDefined(claims.company)) {
              storage('company', claims.company);
            }
          }

          if (angular.isDefined(claims) && angular.isDefined(claims.aud)) {
            storage('customer_number', claims.aud);

            // if hosFutureMoveOut token query param
            if (vm.data.credentials.future_move_token.length) {
              // get the FutureMoveOut data
              customerService.getFutureMove(vm.data.credentials).then(function (futureMoveRes) {
                vm.data.futureMoveOut = vm.formatFutureMoveResponse(futureMoveRes[0]);
                // if future move out exists and is equal to credentials
                if (vm.data.futureMoveOut.exists) {
                  vm.data.meter_reading.date = new Date(vm.data.futureMoveOut.moveDate).setHours(0, 0, 0, 0);
                  premiseUnregisterService.storeData();
                  $state.go('premisesUnregister');
                } else {
                  // Notification: This token has no future move request assigned, contact customer service
                  $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
                }
              }).catch(function () {
                // Notification: Failed to get future move data, contact customer service
                $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12101});
              });
            } else {
              // if not has a future move out token
              premiseUnregisterService.storeData();
              $state.go('premisesUnregister');
            }
          } else {
            // Notification: invalid credentials
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 2000});
          }
        }, function (error) { // ivAuthenticate.shortTermLogin
          vm.loginError(error);
        }).finally(function () {
          $timeout(function () {
            $rootScope.$broadcast('wml.loader.stop');
          }, 1000);
          vm.sendingData = false;
        });
      } else {
        // not valid form
        $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code: '1001'});
      }
    }

    function formatFutureMoveResponse(futureMove) {
      return {
        exists: Boolean(futureMove.customer),
        moveDate: futureMove.date || '',
        premise: {
          postal_code: futureMove.postal_code,
          house_no: futureMove.house_num_1,
          house_no_addition: futureMove.house_num_2
        }
      };
    }

    function loginError(error) {
      if (error === null) { return; }
      var params = (angular.isDefined(error.fields)) ? error.fields : {};
      if (angular.isDefined(error.code)) {
        $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params: params});
      } else {
        $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '2014'});
      }
    }

    function activate() {
      var queryParams = $location.search();
      if (queryParams.fm && queryParams.fm.length) {
        // logout current user
        if (ivAuthenticate.isAuthenticated()) {
          ivAuthenticate.logout().then(function () {
            $rootScope.$broadcast('clear-cache');
            location.reload();
          });
        } else {
          // date not set && future move token exists
          if (/^\w+$/gi.test(queryParams.fm)) {
            customerService.getFutureMoveCustomerNr(queryParams.fm).then(function (futureMoveCustomerNr) {
              if (futureMoveCustomerNr) {
                vm.form.customer_number = futureMoveCustomerNr;
                vm.data.credentials.future_move_token = queryParams.fm;
                return;
              }
              throw new Error(); // Notification: invalid token format
            }).catch(function () {
              // Notification: invalid token format
              $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12100});
              return;
            });
          } else {
            // Notification: invalid token format
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12100});
            return;
          }
        }
      } else if (ivAuthenticate.isAuthenticated() && angular.isDefined(vm.data.bIsInFuture)) {
        // move on, there is no future move out / anonymous login page needed
        $state.go('premisesUnregister');
      } else if (ivAuthenticate.isAuthenticated() || angular.isUndefined(vm.data.bIsInFuture)) {
        // date not set, previous view skipped, go to move out date view
        $state.go('premisesUnregisterMoveOutDate');
      } else if (!ivAuthenticate.isAuthenticated()) {
        // save while clearing session
        var bIsInFuture = vm.data.bIsInFuture;
        var meterDate = vm.data.meter_reading.date;
        // clear previously set session data
        $rootScope.$broadcast('clear-cache', {customer: true});
        premiseUnregisterService.clearData();
        vm.data.bIsInFuture = bIsInFuture;
        vm.data.meter_reading.date = meterDate;
        premiseUnregisterService.storeData();
      }
    }
    activate();
  }

  angular.module('wml.portal.premisesUnregister')
    .controller('PremisesUnregisterLoginController', PremisesUnregisterLoginController);

})();

(function() {
  'use strict';

  /**
   * @ngInject
   * Gets called when future move in and no correspondence e-mail is known.
   *
   * */
  premisesUnregisterFutureCorrespondenceEmailController.$inject = ["$scope", "$state", "customerService", "addressService", "ivAuthenticate", "premiseUnregisterService", "$rootScope"];
  function premisesUnregisterFutureCorrespondenceEmailController($scope, $state, customerService, addressService, ivAuthenticate, premiseUnregisterService, $rootScope) {

    var vm = this;

    // Public variables
    vm.form = null;
    vm.data = premiseUnregisterService.data;
    vm.loading = false;

    // Public function definitions
    vm.next = next;
    vm.cancel = cancel;

    // Public functions
    function next() {
      if (vm.form.$valid) {
        vm.data.email.bSetNew = true;
        premiseUnregisterService.storeData();
        $state.go('premisesUnregisterSummary');
      }
    }

    function cancel() {
      $state.go('premisesUnregister');
    }

    activate();

    function activate() {
    }
  }

  angular.module('wml.portal.premisesUnregister')
    .controller('premisesUnregisterFutureCorrespondenceEmailController', premisesUnregisterFutureCorrespondenceEmailController);

})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesUnregisterEmailController.$inject = ["$state", "$rootScope", "$timeout", "customerService", "premisesService", "premiseUnregisterService", "premiseRegisterService", "$stateParams", "ivAuthenticate", "storage"];
  function PremisesUnregisterEmailController($state, $rootScope, $timeout, customerService, premisesService, premiseUnregisterService, premiseRegisterService, $stateParams, ivAuthenticate, storage) {
    var vm = this;

    vm.form = null;
    vm.data = {};
    vm.sendingData = false;
    vm.data = premiseUnregisterService.data;

    // Public function definitions
    vm.save = save;
    vm.cancel = cancel;

    // Public functions
    function save() {
      if (vm.form.$valid) {
        if (vm.data.afterNewRegister) {
          vm.data.correspondence.bSetAsNewEmail = true;
        }
        premiseUnregisterService.storeData();
        $state.go('premisesUnregisterSummary');
      }
    }

    function cancel() {
      if (vm.data.afterNewRegister) {
        $state.go('premisesUnregisterSummary');
      } else if (vm.data.correspondence.bSetNew === true) {
        $state.go('premisesUnregisterCorrespondenceAddress');
      } else {
        $state.go('premisesUnregisterMeterReading');
      }
    }

    function activate() {
    }
    activate();
  }

  angular.module('wml.portal.premisesUnregister')
    .controller('PremisesUnregisterEmailController', PremisesUnregisterEmailController);

})();

(function() {
  'use strict';

  /** @ngInject */
  PremisesUnregisterCorrespondenceAddressController.$inject = ["$scope", "$state", "customerService", "addressService", "ivAuthenticate", "premiseUnregisterService", "$rootScope"];
  function PremisesUnregisterCorrespondenceAddressController($scope, $state, customerService, addressService, ivAuthenticate, premiseUnregisterService, $rootScope) {

    var vm  = this;
    // private variables
    var _currentAddress   = null;
    var _lastAutofill     = null;
    var _lastAutofillPo   = null;

    // Public variables
    vm.form                   = null;
    vm.premises               = [];
    vm.bShowOther             = false;
    vm.bShowPremisesSelection = true;
    vm.data                   = premiseUnregisterService.data;
    vm.loading                = false;
    vm.validNewCorrespondenceAddress = false;

    // Public function definitions
    vm.autofillHouseNo    = autofillHouseNo;
    vm.autofillPoBox      = autofillPoBox;
    vm.showOther          = showOther;
    vm.save               = save;
    vm.changeCountry      = changeCountry;
    vm.changeType         = changeType;
    vm.validCorrespondenceAddress = validCorrespondenceAddress;


    // Public functions
    function autofillHouseNo() {
      if(vm.data.correspondence.country !== 'NL'){
        return false;
      }

      if(!angular.isString(vm.data.correspondence.address_id) && angular.isString(vm.data.correspondence.postal_code) && angular.isString(vm.data.correspondence.house_no)) {
        vm.data.correspondence.postal_code = vm.data.correspondence.postal_code.toUpperCase();

        if(/^[0-9]{4}[A-Z]{2}$/.test(vm.data.correspondence.postal_code)) {

          var data = {
            postal_code : vm.data.correspondence.postal_code,
            house_no : vm.data.correspondence.house_no
          };

          var autofillKey = data.postal_code + '_' + data.house_no;

          if (angular.isString(vm.data.correspondence.house_no_addition)) {
            data.house_no_addition = vm.data.correspondence.house_no_addition;
            autofillKey = autofillKey + '_' + vm.data.correspondence.house_no_addition;
          }

          if(autofillKey === _lastAutofill) {
            return false;
          }

          vm.data.correspondence.city        = null;
          vm.data.correspondence.street      = null;
          vm.loading                         = true;

          _lastAutofill = autofillKey;

          autoFill(data);
        }
      }
    }

    function autofillPoBox() {
      if(vm.data.correspondence.country !== 'NL'){
        return false;
      }

      if(!angular.isString(vm.data.correspondence.address_id) && angular.isString(vm.data.correspondence.po_box_postal_code) && angular.isString(vm.data.correspondence.po_box)) {
        vm.data.correspondence.po_box_postal_code = vm.data.correspondence.po_box_postal_code.toUpperCase();

        if(/^[0-9]{4}[A-Z]{2}$/.test(vm.data.correspondence.po_box_postal_code)) {

          var data = {
            po_box_postal_code  : vm.data.correspondence.po_box_postal_code,
            po_box              : vm.data.correspondence.po_box
          };

          var autofillKey = data.po_box_postal_code + '_' + data.po_box;

          if(autofillKey === _lastAutofillPo) {
            return false;
          }

          vm.data.correspondence.city = null;
          vm.loading                    = true;

          _lastAutofillPo = autofillKey;

          autoFill(data);
        }
      }
    }

    function showOther(bShowOther){
      vm.bShowOther = bShowOther;
    }

    function save() {
      if (vm.form.$valid) {
        if (vm.validCorrespondenceAddress()) {
          if (vm.data.correspondence.type === null || !vm.data.correspondence.type.length) {
            vm.data.correspondence.type = 'address';
          }
          if (vm.data.afterNewRegister) {
            vm.data.correspondence.bSetNew = true;
          }

          premiseUnregisterService.storeData();
          if ((ivAuthenticate.isAuthenticated() && !vm.data.credentials.future_move_token.length) || vm.data.afterNewRegister) {
            $state.go('premisesUnregisterSummary');
          } else {
            $state.go('premisesUnregisterEmail');
          }
        }
      }
    }

    function changeCountry() {
      resetForm();
      if(vm.data.correspondence.country !== 'NL'){
        vm.data.correspondence.type = 'address';
      } else {
        vm.data.correspondence.type = '';
      }
    }

    function changeType() {
      resetForm();
    }

    // Private functions
    function resetForm() {
      _lastAutofillPo = null;
      _lastAutofill   = null;

      vm.data.correspondence.postal_code        = null;
      vm.data.correspondence.po_box_postal_code = null;
      vm.data.correspondence.po_box             = null;
      vm.data.correspondence.street             = null;
      vm.data.correspondence.house_no           = null;
      vm.data.correspondence.house_no_addition  = null;
      vm.data.correspondence.city               = null;
    }

    function getPremises() {
      customerService.getPremises().then(getPremiseSuccess);
    }

    function getPremiseSuccess(response) {
      vm.premises = response.filter(function(item){
        var _address = item.address.house_no + item.address.house_no_addition + item.address.postal_code;
        return (_address !== _currentAddress && item.is_correspondence_option);
      });

      if(vm.premises.length === 0){
        vm.bShowPremisesSelection = false;
      }
    }

    function getAddress() {
      customerService.getAddress().then(getAddressesSuccess);
    }

    function getAddressesSuccess(response) {
      vm.correspondenceAddress = response;
      _currentAddress = vm.correspondenceAddress.house_no + vm.correspondenceAddress.house_no_addition + vm.correspondenceAddress.postal_code;
      getPremises();
    }

    function validCorrespondenceAddress() {
      if (vm.data.address.is_correspondence_option) {
        var _currentCorrespondenceAddress = vm.data.address.address.house_no + vm.data.address.address.house_no_addition + vm.data.address.address.postal_code;
        _currentCorrespondenceAddress = _currentCorrespondenceAddress.split(' ').join('');
        var _newCorrespondenceAddress = vm.data.correspondence.house_no + (vm.data.correspondence.house_no_addition || '') + vm.data.correspondence.postal_code;
        _newCorrespondenceAddress = _newCorrespondenceAddress.split(' ').join('');
        if (_currentCorrespondenceAddress === _newCorrespondenceAddress) {
          vm.validNewCorrespondenceAddress = false;
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '5005'});
        } else {
          vm.validNewCorrespondenceAddress = true;
        }
        return !(_currentCorrespondenceAddress === _newCorrespondenceAddress);
      }
    }

    function autoFill(data) {
      addressService.autofill(data).then(function(response) {
        var address = angular.copy(response.plain());
        vm.loading  = false;
        if (vm.validCorrespondenceAddress()) {
          vm.data.correspondence.street = address.street || '';
          vm.data.correspondence.house_no_addition = address.house_no_addition || '';
          vm.data.correspondence.city = address.city || '';
        }
      });
    }

    activate();

    function activate() {
      getAddress();

      $scope.$watch(function() {return vm.data.correspondence.address_id}, function(newValue) {
        if(angular.isDefined(newValue) && angular.isObject(newValue)) {
          vm.data.correspondence.country              = newValue.country;
          vm.data.correspondence.city                 = newValue.city;
          vm.data.correspondence.postal_code          = newValue.postal_code;
          vm.data.correspondence.street               = newValue.street;
          vm.data.correspondence.house_no             = newValue.house_no;
          vm.data.correspondence.house_no_addition    = newValue.house_no_addition;
        }
      });
    }
  }

  angular.module('wml.portal.premisesUnregister')
    .controller('PremisesUnregisterCorrespondenceAddressController', PremisesUnregisterCorrespondenceAddressController);

})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesUnregisterController.$inject = ["$state", "$rootScope", "customerService", "premisesService", "premiseUnregisterService", "premiseRegisterService", "$stateParams", "ivAuthenticate", "storage", "moment"];
  function PremisesUnregisterController($state, $rootScope, customerService, premisesService, premiseUnregisterService, premiseRegisterService, $stateParams, ivAuthenticate, storage, moment) {
    var vm = this;

    vm.data = premiseUnregisterService.data;
    vm.registrablePremises = []; // all addresses that can be unregistered
    vm.activePremises = []; // address that are not active but can ub unregistered
    vm.premisesAlreadyUnregistered = []; // address that are not active but can ub unregistered
    vm.unregistrablePremises = []; // addresses that can not be unregistered

    // Public function definitions
    vm.next = next;
    vm.getEmail = getEmail;
    vm.cancel = cancel;
    vm.setAddress = setAddress;
    vm.setInfoForInactivePremises = setInfoForInactivePremises;
    vm.getInfo = getInfo;
    vm.preSetInfoForInactiveAddressAndNav = preSetInfoForInactiveAddressAndNav;
    vm.activateCorporation = activateCorporation;
    vm.activateStandardCustomer = activateStandardCustomer;

    // Public functions
    function next() {
      if (vm.form.$valid) {
        premiseUnregisterService.storeData();

        var futureMoveCheck = {
          postal_code: vm.data.address.address.postal_code,
          house_no: vm.data.address.address.house_no,
          house_no_addition: vm.data.address.address.house_no_addition
        };

        // check if future move already exists
        customerService.hasFutureMove(futureMoveCheck).then(function (hasFutureMoveRes) {
          // api Type Enum = MOVE_OUT:'O', MOVE_IN: 'I', MOVE_IN_OUT:'X';
          var moveOutAlreadyExists = (hasFutureMoveRes.exists && (hasFutureMoveRes.move_in_out === 'O' || hasFutureMoveRes.move_in_out === 'X'));
          if (moveOutAlreadyExists && !vm.data.credentials.future_move_token.length) {
            // notification: has a future move, contact customer service
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12107'});
            return;
          }
          var bIsInFuture = vm.data.bIsInFuture;
          if (!bIsInFuture || vm.data.credentials.future_move_token) { $state.go('premisesUnregisterMeterReading'); }
          if (bIsInFuture) {
            if (vm.data.email.correspondence_exists) {
              $state.go('premisesUnregisterSummary');
            } else {  // future unregister - no correspondence email address known, which is needed.
              $state.go('premisesUnregisterFutureCorrespondenceEmail');
            }
          }
        })
          .catch(function () {
            // notification: failed to check if has future move data, contact customer service.
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12104'});
            return;
          });
      }
    }

    function cancel() {
      if (vm.data.credentials.future_move_token.length || !ivAuthenticate.isAuthenticated()) {
        $state.go('premisesUnregisterLogin', {fm: vm.data.credentials.future_move_token});
      } else if (storage('corporation')) {
        $state.go('dashboard');
      } else {
        $state.go('premisesUnregisterMoveOutDate');
      }
    }

    function setAddress() { // order matters
      if (vm.data.address && vm.data.address.premise_id !== null) { // if unregister address already in session
        for (var i = 0; i < vm.registrablePremises.length; i++) {
          if (vm.data.address.premise_id === vm.registrablePremises[i].premise_id) {
            return vm.registrablePremises[i];
          }
        }
      } else if (vm.data.futureMoveOut.exists) { // hasFutureMoveOut.exists
        var fmop = vm.data.futureMoveOut.premise;
        var futurMoveResAddress = fmop.house_no + (fmop.house_no_addition || '') + fmop.postal_code;
        futurMoveResAddress = futurMoveResAddress.split(' ').join('').toUpperCase();
        for (var j = 0; j < vm.registrablePremises.length; j++) {
          var jRegPremise = vm.registrablePremises[j];
          var jRegistrablePremiseAddress = jRegPremise.address.house_no + (jRegPremise.address.house_no_addition || '') + jRegPremise.address.postal_code;
          jRegistrablePremiseAddress = jRegistrablePremiseAddress.split(' ').join('').toUpperCase();
          if (jRegistrablePremiseAddress === futurMoveResAddress) {
            return vm.registrablePremises[j];
          }
        }
      } else if (vm.data.credentials.customer_number !== null) { // credentials for short term token exist
        var creds = vm.data.credentials;
        var credsAddress = creds.house_no + (creds.house_no_addition || '') + creds.postal_code;
        credsAddress = credsAddress.split(' ').join('').toUpperCase();
        for (var k = 0; k < vm.registrablePremises.length; k++) {
          var kRegPremise = vm.registrablePremises[k];
          var kRegistrablePremiseAddress = kRegPremise.address.house_no + (kRegPremise.address.house_no_addition || '') + kRegPremise.address.postal_code;
          kRegistrablePremiseAddress = kRegistrablePremiseAddress.split(' ').join('').toUpperCase();
          if (kRegistrablePremiseAddress === credsAddress) {
            return vm.registrablePremises[k];
          }
        }
      }
      /**
       * @NOTE disabled by request
       *
       * Issuelog #220 FO62
       * Aangemeld scenario : in het overzichtsscherm waar de klant een adres kan selecteren om af te melden (blok 1),
       * willen we dat de klant ALTIJD zelf een adres selecteert,
       * ook al is er maar 1 adres. Dus nooit een bolletje al aanvinken.
       */
      // else { // isAuthenticated && !futureMoveOut, take the first
      //   if (vm.registrablePremises.length === 1) {
      //     return vm.registrablePremises[0];
      //   }
      // }
    }

    function preSetInfoForInactiveAddressAndNav(info) {
      vm.data.afterNewRegister = true;
      vm.data.meter_reading.meter_reading = info.meter_reading;
      vm.data.meter_reading.last_meter_reading_date = info.meter_reading_datetime;
      vm.data.correspondence.city = info.address.city;
      vm.data.correspondence.postal_code = info.address.postal_code;
      vm.data.correspondence.po_box_postal_code = info.address.po_box_postal_code;
      vm.data.correspondence.po_box = info.address.po_box;
      vm.data.correspondence.street = info.address.street;
      vm.data.correspondence.house_no = info.address.house_no;
      vm.data.correspondence.house_no_addition = info.address.house_no_addition;
      vm.data.correspondence.confirmationEmail = info.correspondence_email;
      vm.data.email.correspondence = info.correspondence_email;
      vm.data.correspondence.type = vm.data.correspondence.po_box ? 'po_box' : 'address';
      premiseUnregisterService.storeData();

      // future unregister - no correspondence email address known, which is needed.
      if (vm.data.bIsInFuture && !vm.data.email.correspondence_exists) {
        $state.go('premisesUnregisterFutureCorrespondenceEmail');
      } else {
        $state.go('premisesUnregisterSummary');
      }
    }

    function activateCorporation() {
      var _currentAddress = storage('corporation_address');
      var currentAddress = {
        premise_id: _currentAddress.premise_id,
        contract_id: _currentAddress.contract_id,
        device: {
          id: _currentAddress.device_id,
          serial_number: _currentAddress.serial_number_id
        },
        address: {
          address_no: _currentAddress.address_number,
          postal_code: _currentAddress.postal_code,
          house_no: _currentAddress.house_number,
          house_no_addition: _currentAddress.house_number_addition,
          city: _currentAddress.city,
          street: _currentAddress.street
        }
      };
      vm.registrablePremises.push(currentAddress);
      vm.activePremises.push(currentAddress);
      vm.data.address = vm.registrablePremises[0];
    }

    function getInfo() {
      customerService.getInfo({
        contract_account_id: vm.data.address.contract_account_id,
        contract_id: vm.data.address.contract_id
      }).then(function (info) {
        vm.data.email.correspondence = info.correspondence_email;
        premiseUnregisterService.storeData();
      });
    }

    function setInfoForInactivePremises() {
      customerService.getInfo({
        contract_account_id: vm.data.address.contract_account_id,
        contract_id: vm.data.address.contract_id
      }).then(function (info) {
        vm.preSetInfoForInactiveAddressAndNav(info);
      });
    }

    function activateStandardCustomer(premises) {
      var _premises = angular.copy(premises);
      vm.unregistrablePremises = _premises.filter(function (item) {
        // can not unregister these (unregistrablePremises)
        // must call customer support
        return !item.is_subscription_option && item.is_active;
      });

      var credsAddress = null;
      // when logged in via short term - only show address you logged in with.
      if (!ivAuthenticate.isAuthenticated() && vm.data.credentials && vm.data.credentials.house_no && vm.data.credentials.postal_code) {
        var creds = vm.data.credentials;
        credsAddress = creds.house_no + (creds.house_no_addition || '') + creds.postal_code;
        credsAddress = credsAddress.split(' ').join('').toUpperCase();
      }
      // get all addresses with subscription option; address you can unregister
      vm.registrablePremises = _premises.filter(function (item) {
        if (credsAddress) {
          var itemAddress = item.address.house_no + (item.address.house_no_addition || '') + item.address.postal_code;
          itemAddress = itemAddress.split(' ').join('').toUpperCase();
          var isMatchingAddress = credsAddress === itemAddress;
          return item.is_subscription_option && isMatchingAddress;
        }
        return item.is_subscription_option;
      });
      // get all active addresses with subscription option.
      vm.activePremises = _premises.filter(function (item) {
        if (credsAddress) {
          var itemAddress = item.address.house_no + (item.address.house_no_addition || '') + item.address.postal_code;
          itemAddress = itemAddress.split(' ').join('').toUpperCase();
          var isMatchingAddress = credsAddress === itemAddress;
          return item.is_subscription_option && item.is_active && isMatchingAddress;
        }
        return item.is_subscription_option && item.is_active;
      });
      // get all inactive addresses with subscription option, not older than 3 months (#62)
      vm.premisesAlreadyUnregistered = _premises.filter(function (item) {
        if (credsAddress) { return false; }
        var isNotOlderThanThreeMonths = moment(item.move_out_date).add(3, 'months') > moment();
        return !item.is_active && isNotOlderThanThreeMonths;
      });

      // select address based on user auth, session, future move token
      vm.data.address = vm.setAddress();

      if (vm.data.address) {
        if (vm.data.credentials.customer_number === null && vm.data.address.is_active) {
          vm.getInfo();
        } else if (!vm.data.address.is_active) {
          // If not active, pre set info, go to summary (#62).
          // only for short login
          vm.setInfoForInactivePremises();
        }
      }
    }

    function getEmail() {
      customerService.getEmail().then(getEmailSuccess);
    }

    function getEmailSuccess(response) {
      vm.data.email.correspondence_exists = response.correspondence_email;
      premiseUnregisterService.storeData();
    }

    function activate() {

      if ($stateParams.clearCache === 'true') {
        premiseUnregisterService.clearData();
        premiseRegisterService.clearData();
        premisesService.clearProcesStatus();
      }

      if (angular.isUndefined(premisesService.getProcesStatus()) || premisesService.getProcesStatus() === null) {
        premisesService.storeProcesStatus('moving_out');
      }

      if (storage('corporation') && angular.isObject(storage('corporation_address'))) {
        vm.activateCorporation();
      } else {
        customerService.getPremises({getInactive: true}).then(function (premises) {
          vm.activateStandardCustomer(premises);
        });
      }
      vm.getEmail();
    }

    activate();
  }

  angular.module('wml.portal.premisesUnregister')
    .controller('PremisesUnregisterController', PremisesUnregisterController);

})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesRegisterThankYouController.$inject = ["$rootScope", "premiseRegisterService"];
  function PremisesRegisterThankYouController($rootScope, premiseRegisterService) {

    var vm = this;
    vm.data = premiseRegisterService.data;

    vm.isInFuture = '';
    vm.moveInDate = '';

    // private variables

    // Public variables

    // Public function definitions

    // Public functions

    // Private functions

    activate();

    function activate() {
      vm.isInFuture = (vm.data.bIsInFuture) ? 'future_' : '';
      vm.moveInDate = vm.data.meter_reading.date;
      premiseRegisterService.clearData();
    }
  }

  angular
    .module('wml.portal.premisesRegister')
    .controller('PremisesRegisterThankYouController', PremisesRegisterThankYouController);
})();

(function () {
  'use strict';

  /** @ngInject */
  premisesRegisterSummaryController.$inject = ["$state", "ivAuthenticate", "premiseRegisterService", "premisesService", "$rootScope", "storage"];
  function premisesRegisterSummaryController($state, ivAuthenticate, premiseRegisterService, premisesService, $rootScope, storage) {

    var vm = this;

    // private variables

    // Public variables
    vm.form = null;
    vm.data = premiseRegisterService.data;
    vm.bCorporation = storage('corporation') || false;

    // Public function definitions
    vm.save = save;
    vm.cancel = cancel;
    vm.sendingData = false;

    // Public functions
    function save() {
      // check if vm.data.file_upload.name is set
      // if no more recollection of fileUpload, then file is gone due to refresh.
      if (vm.data && vm.data.meter_reading && vm.data.meter_reading.file_upload && vm.data.meter_reading.file_upload.name && !vm.data.meter_reading.file_upload.file) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 11013});
        vm.data.meter_reading.file_upload = null;
        premiseRegisterService.storeData();
        return;
      }
      vm.sendingData = true;
      premiseRegisterService.register()
        .then(registerSuccess)
        .catch(function (error) {
          // Notification, no mail address available to send confirmation (12006)?
          if (error === null) { return; }

          var params = (angular.isDefined(error.fields)) ? error.fields : {};

          if (angular.isDefined(error.code)) {
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params: params});
          } else {
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12006'});
          }
        }).finally(function () {
          vm.sendingData = false;
        });
    }

    function registerSuccess(response) {
      if(angular.isObject(response) && angular.isDefined(response.code) && (response.code === 12004 || response.code === 12008)) {
        $rootScope.$broadcast('wml.portal.message', response);
        vm.data.forced_meter_reading = true;
        $state.go('premisesRegisterMeterReading', {meterError: response.code});
      } else {
        if (storage('corporation') && angular.isObject(storage('corporation_address'))) {
          clearCache();
          $state.go('premisesRegisterThankYou');
        } else {
          if (premisesService.getProcesStatus() === 'moving_in') {
            if (ivAuthenticate.isAuthenticated() && !vm.data.bIsInFuture) {
              premisesService.askToContinueModal().then(function () {
                $state.go('premisesUnregister');
              }, function () {
                $state.go('customer');
              }).finally(function () {
                clearCache();
              });
            } else {
              $state.go('premisesRegisterThankYou');
            }
          } else {
            $state.go('premisesRegisterThankYou');
          }
        }
      }
    }

    function cancel() {
      var bIsInFuture = vm.data.bIsInFuture;
      if (!bIsInFuture && vm.data.correspondence.bSetNew) {
        $state.go('premisesRegisterCorrespondenceAddress');
      } else if (!bIsInFuture) {
        $state.go('premisesRegisterNewPremises');
      } else if (bIsInFuture && vm.data.email.bSetNew && vm.data.email.correspondence) {
        $state.go('premisesRegisterFutureCorrespondenceEmail');
      } else {
        $state.go('premisesRegister');
      }
    }

    function clearCache() {
      premiseRegisterService.clearData();
      $rootScope.$broadcast('clear-cache', {customer : true});
    }

    // Private functions
    activate();

    function activate() {
    }
  }

  angular
    .module('wml.portal.premisesRegister')
    .controller('premisesRegisterSummaryController', premisesRegisterSummaryController);
})();

(function() {
  'use strict';

  /** @ngInject */
  premisesRegisterNewPremisesController.$inject = ["$scope", "$state", "customerService", "addressService", "ivAuthenticate", "premiseRegisterService"];
  function premisesRegisterNewPremisesController($scope, $state, customerService, addressService, ivAuthenticate, premiseRegisterService) {

    var vm = this;
    // private variables

    // Public variables
    vm.form = null;
    vm.data = premiseRegisterService.data;
    vm.loading = false;

    // Public function definitions
    vm.save = save;

    // Public functions
    function save() {
      if (vm.form.$valid) {
        premiseRegisterService.storeData();
        if (vm.data.correspondence.bSetNew) {
          $state.go('premisesRegisterCorrespondenceAddress');
        } else {
          $state.go('premisesRegisterSummary');
        }
      }
    }

    function getAddress() {
      customerService.getAddress().then(getAddressesSuccess);
    }
    function getAddressesSuccess(response) {
      vm.data.currentCorrespondenceAddress = response;
    }

    activate();

    function activate() {
      getAddress();
    }
  }

  angular.module('wml.portal.premisesRegister')
    .controller('premisesRegisterNewPremisesController', premisesRegisterNewPremisesController);

})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesRegisterMoveInDateController.$inject = ["$document", "$timeout", "$state", "$scope", "$rootScope", "calendarsService", "premiseRegisterService", "premisesService", "storage"];
  function PremisesRegisterMoveInDateController($document, $timeout, $state, $scope, $rootScope, calendarsService, premiseRegisterService, premisesService, storage) {
    var vm = this;

    // Public variables
    vm.form = null;
    vm.data = premiseRegisterService.data;

    vm.showDatepicker = false;
    vm.datepickerFormat = "dd-MM-yyyy";
    vm.datepickerCurrentMonth = new Date();
    vm.datepickerOptions = {
      customClass: datePickerClass,
      maxDate: null,
      minDate: null
    };

    // Public function definitions
    vm.next = next;
    vm.cancel = cancel;
    vm.openDatepicker = openDatepicker;

    activate();

    $scope.$on('datepicker.monthChanged', function (event, newVal) {
      vm.datepickerCurrentMonth = newVal;
    });

    $scope.$on('datepicker.format', function (event, mode) {
      datepickerFormat(mode);
    });

    function datepickerFormat(mode) {
      if (mode === 'day') {
        $timeout(function () {
          var uibWeeks = $document[0].getElementsByClassName('uib-weeks');
          for (var i = 0; i < uibWeeks.length; i += 1) {
            var uibBans = uibWeeks[i].getElementsByClassName('uib-ban');
            if (uibBans.length === 7) {
              uibWeeks[i].style.display = 'none';
            }
            if (uibBans.length !== 7) {
              uibWeeks[i].style.display = 'table-row';
            }
          }
        }, 100);
      }
    }

    function datePickerClass(data) {
      var date = data.date;
      var mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        if (new Date(dayToCheck).getMonth() !== vm.datepickerCurrentMonth.getMonth()) {
          if (new Date(dayToCheck) > vm.datepickerCurrentMonth) {
            return 'uib-ban';
          }
          return 'uib-nope';
        }
        return 'uib-yeah';
      }
      return '';
    }

    function openDatepicker() {
      vm.datepickerCurrentMonth = (vm.data.meter_reading.date) ? vm.data.meter_reading.date : new Date();
      vm.showDatepicker = true;
      datepickerFormat('day');
    }

    function getCalendarSettingsFromImanager() {
      calendarsService.getCalendars('premisesRegister').then(function (response) {
        var max = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.moveInMaxDateCorporation : response.moveInMaxDate);
        var min = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.moveInMinDateCorporation : response.moveInMinDate);
        vm.datepickerOptions.maxDate = (isNaN(max)) ? null : new Date(new Date().setDate(new Date().getDate() + max));
        vm.datepickerOptions.minDate = (isNaN(min)) ? null : new Date(new Date().setDate(new Date().getDate() - min));
      });
    }

    // Public functions
    function next() {
      if (vm.form.$valid) {
        var today = new Date().setHours(0, 0, 0, 0);
        var moveInDate = new Date(vm.data.meter_reading.date).setHours(0, 0, 0, 0);
        vm.data.bIsInFuture = (moveInDate > today);

        premiseRegisterService.storeData();
        $state.go('premisesRegister');
      }
    }

    function cancel() {
      premisesService.clearProcesStatus();
      premiseRegisterService.clearData();
      $state.go('customer');
    }

    function activate() {
      if (storage('corporation')) {
        $state.go('premisesRegister');
      }
      getCalendarSettingsFromImanager();
      if (vm.data.meter_reading.date !== null) {
        vm.data.meter_reading.date = new Date(vm.data.meter_reading.date);
      }
    }
  }

  angular
    .module('wml.portal.register')
    .controller('PremisesRegisterMoveInDateController', PremisesRegisterMoveInDateController);
})();

(function () {
  'use strict';

  /** @ngInject */
  premisesRegisterMeterReadingController.$inject = ["$document", "$timeout", "$rootScope", "$state", "$scope", "$stateParams", "calendarsService", "premiseRegisterService", "Upload", "storage", "meterReadingService", "MOVE_REASON"];
  function premisesRegisterMeterReadingController($document, $timeout, $rootScope, $state, $scope, $stateParams, calendarsService, premiseRegisterService, Upload, storage, meterReadingService, MOVE_REASON) {
    var vm = this;

    // private variables

    // Public variables
    vm.form = null;
    vm.data = premiseRegisterService.data;
    vm.sendingData = false;
    vm.currentMeterReading = false;
    vm.showDatepicker = false;
    vm.datepickerFormat = "dd-MM-yyyy";
    vm.datepickerCurrentMonth = new Date();
    vm.datepickerOptions = {
      customClass: datePickerClass,
      maxDate: null,
      minDate: null
    };

    vm.fileToUpload = null;

    // Public function definitions
    vm.next = next;
    vm.cancel = cancel;
    vm.openDatepicker = openDatepicker;
    vm.fileChange = fileChange;

    $scope.$on('datepicker.monthChanged', function (event, newVal) {
      vm.datepickerCurrentMonth = newVal;
    });

    $scope.$on('datepicker.format', function (event, mode) {
      datepickerFormat(mode);
    });

    function datepickerFormat(mode) {
      if (mode === 'day') {
        $timeout(function () {
          var uibWeeks = $document[0].getElementsByClassName('uib-weeks');
          for (var i = 0; i < uibWeeks.length; i += 1) {
            var uibBans = uibWeeks[i].getElementsByClassName('uib-ban');
            if (uibBans.length === 7) {
              uibWeeks[i].style.display = 'none';
            }
            if (uibBans.length !== 7) {
              uibWeeks[i].style.display = 'table-row';
            }
          }
        }, 100);
      }
    }

    function datePickerClass(data) {
      var date = data.date;
      var mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        if (new Date(dayToCheck).getMonth() !== vm.datepickerCurrentMonth.getMonth()) {
          if (new Date(dayToCheck) > vm.datepickerCurrentMonth) {
            return 'uib-ban';
          }
          return 'uib-nope';
        }
        return 'uib-yeah';
      }
      return '';
    }

    function openDatepicker() {
      vm.datepickerCurrentMonth = (vm.data.meter_reading.date) ? vm.data.meter_reading.date : new Date();
      vm.showDatepicker = true;
      datepickerFormat('day');
    }

    function getCalendarSettingsFromImanager() {
      calendarsService.getCalendars('premisesRegister').then(function (response) {
        var max = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.meterReadingMaxDateCorporation : response.meterReadingMaxDate);
        var min = (storage('corporation') && angular.isObject(storage('corporation_address')) ? response.meterReadingMinDateCorporation : response.meterReadingMinDate);
        vm.datepickerOptions.maxDate = (isNaN(max)) ? null : new Date(new Date().setDate(new Date().getDate() + max));
        vm.datepickerOptions.minDate = (isNaN(min)) ? null : new Date(new Date().setDate(new Date().getDate() - min));
      });
    }

    function fileChange(file, errFiles) {
      $rootScope.$broadcast('wml.portal.message.cancel');
      if (errFiles.length > 0) {
        if (errFiles[0].$error === "maxSize") {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
        } else {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
        }
      }
      if (file) {
        vm.data.meter_reading.file_upload = null;
        vm.fileToUpload = file;
      }
    }

    function next() {
      vm.sendingData = true;
      vm.form.$commitViewValue();
      if (vm.form.$valid) {
        Upload.base64DataUrl(vm.fileToUpload)
          .then(function (dataUrl) {
            if (dataUrl) {
              vm.data.meter_reading.file_upload = {
                file: dataUrl,
                name: vm.fileToUpload.name,
                type: vm.fileToUpload.type
              };
            }
          })
          .finally(function () {
            var today = new Date().setHours(0, 0, 0, 0);
            var moveInDate = new Date(vm.data.meter_reading.date).setHours(0, 0, 0, 0);
            vm.data.bIsInFuture = (moveInDate > today);
            premiseRegisterService.storeData();

            var bIsInFuture = vm.data.bIsInFuture;
            if (bIsInFuture) {
              $state.go('premisesRegisterSummary');
            } else if (vm.data.forced_meter_reading) {
              if (storage('corporation')) {
                $state.go('premisesRegisterSummary');
              } else {
                $state.go('premisesRegisterNewPremises');
              }
            } else {
              checkMeterReading();
            }
          });
      }
    }

    function checkMeterReadingSuccess(response) {
      if (angular.isObject(response) && angular.isDefined(response.code) && (response.code === 11003 || response.code === 11004)) {
        $rootScope.$broadcast('wml.portal.message', response);
        vm.data.forced_meter_reading = true;
        premiseRegisterService.storeData();
        $state.go('premisesRegisterMeterReading', {meterError: response.code});
      } else if (storage('corporation')) {
        $state.go('premisesRegisterSummary');
      } else {
        $state.go('premisesRegisterNewPremises');
      }
    }

    function checkMeterReading() {
      meterReadingService.meterReadingCheck(vm.data.address.postal_code, vm.data.meter_reading.meter_reading, vm.data.meter_reading.date, vm.data.address.contract_id, vm.data.address.device_id, MOVE_REASON.MOVE_IN).then(function (response) {
        checkMeterReadingSuccess(response);
      }).catch(function (error) {
        if (error === null) {
          return;
        }

        var params = (angular.isDefined(error.fields)) ? error.fields : {};

        if (angular.isDefined(error.code)) {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params: params});
        } else if (error.data.code === 11011) { // exception - on register give generic warning and set force on
          vm.data.forced_meter_reading = true;
          premiseRegisterService.storeData();
          $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 12004});
          $state.go('premisesRegisterMeterReading', {meterError: 12004});
        } else {
          // Notification, no mail address available to send confirmation (12006)
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12006'});
        }
      }).finally(function () {
        vm.sendingData = false;
      });
    }

    function cancel() {
      $state.go('premisesRegister');
    }

    // Private functions
    activate();

    function activate() {
      getCalendarSettingsFromImanager();
      if (vm.data.meter_reading.date !== null) {
        vm.data.meter_reading.date = new Date(vm.data.meter_reading.date);
      }

      if (vm.data.forced_meter_reading && ($stateParams.meterError === 12004 || $stateParams.meterError === 12008 || $stateParams.meterError === 11004 || $stateParams.meterError === 11003)) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 12004}); // cannot give reason, only picture
      }

      vm.currentMeterReading = vm.data.meter_reading.meter_reading;

      //meter reading
      $scope.$watch(function() {return vm.data.meter_reading.meter_reading;}, function(newValue) {
        if(angular.isString(newValue)) {
          if (vm.data.meter_reading.meter_reading && vm.currentMeterReading && vm.currentMeterReading !== newValue) {
            vm.data.forced_meter_reading = false;
            vm.currentMeterReading = vm.data.meter_reading.meter_reading;
          }

          var data    = newValue.split('');
          var length  = data.length;
          if(length < 5) {
            for(var j=0; j < (5-length); j++) {
              data.unshift('0');
            }
          }
          for(var k=0; k < data.length; k++) {
            var key = 'num' + (k+1);
            vm.data.meter_reading[key]  = data[k];
          }
        } else {
          for(var l=1; l <= 5; l++) {
            vm.data.meter_reading['num' + l]  = 0;
          }
        }
      });
    }
  }

  angular
    .module('wml.portal.premisesRegister')
    .controller('premisesRegisterMeterReadingController', premisesRegisterMeterReadingController);
})();

(function () {
  'use strict';

  /** @ngInject */
  PremisesRegisterLoginController.$inject = ["$state", "$rootScope", "$timeout", "$location", "customerService", "premiseRegisterService", "$stateParams", "ivAuthenticate", "storage", "jwtHelper"];
  function PremisesRegisterLoginController($state, $rootScope, $timeout, $location, customerService, premiseRegisterService, $stateParams, ivAuthenticate, storage, jwtHelper) {
    var vm = this;

    vm.form = null;
    vm.data = premiseRegisterService.data;
    vm.sendingData = false;

    // Public function definitions
    vm.doLogin = doLogin;

    function doLogin() {
      vm.form.$commitViewValue();
      if (vm.form.$valid) {
        $rootScope.$broadcast('wml.portal.message.cancel');
        $rootScope.$broadcast('wml.loader.start');

        vm.sendingData = true;

        vm.data.credentials.customer_number = vm.form.customer_number;
        vm.data.credentials.postal_code = vm.form.postal_code;
        vm.data.credentials.house_no = vm.form.house_no;
        vm.data.credentials.house_no_addition = vm.form.house_no_addition;

        ivAuthenticate.shortTermLogin(vm.data.credentials).then(function (response) {
          var claims = jwtHelper.decodeToken(response.data.access_token);

          if (angular.isDefined(claims)) {
            if (angular.isDefined(claims.corporation)) {
              storage('corporation', claims.corporation);
            }
            if (angular.isDefined(claims.company)) {
              storage('company', claims.company);
            }
          }

          if (angular.isDefined(claims) && angular.isDefined(claims.aud)) {
            storage('customer_number', claims.aud);

            // if hosFutureMove token query param
            if (vm.data.credentials.future_move_token.length) {

              customerService.getFutureMove(vm.data.credentials).then(function (futureMoveRes) {
                var futureMove = futureMoveRes[0];
                vm.data.prospect = {
                  exists: Boolean(futureMove.customer),
                  moveDate: futureMove.date || '',
                  premise: {
                    postal_code: futureMove.postal_code,
                    house_no: futureMove.house_num_1,
                    house_no_addition: futureMove.house_num_2
                  }
                };
                vm.data.address.house_no = futureMove.house_num_1;
                vm.data.address.house_no_addition = futureMove.house_num_2;
                vm.data.address.postal_code = futureMove.postal_code;
                // if prospect exists
                if (vm.data.prospect.exists) {
                  // we are on the right track
                  vm.data.meter_reading.date = new Date(vm.data.prospect.moveDate).setHours(0, 0, 0, 0);
                  premiseRegisterService.storeData();
                  $state.go('premisesRegister');
                } else {
                  // Notification: This token has no future move request assigned, contact customer service
                  $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
                }
              }).catch(function () {
                // Notification: Failed to get future move data, contact customer service
                $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12101});
              });
            } // else if no token available, this will be caught in active()
          } else {
            // Notification: invalid credentials
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 2000});
          }
        }, function (error) {
          if (error === null) { return; }

          var params = (angular.isDefined(error.fields)) ? error.fields : {};

          if (angular.isDefined(error.code)) {
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params : params});
          } else {
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '2014'});
          }
        }).finally(function () {
          $timeout(function () {
            $rootScope.$broadcast('wml.loader.stop');
          }, 1000);

          vm.sendingData = false;
        });
      } else {
        // not valid form
        $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code: '1001'});
      }
    }

    function activate() {
      // this controller is only used with future move token
      var queryParams = $location.search();
      if (queryParams.fm && queryParams.fm.length) {
        // date not set && future move token exists
        if (/^\w+$/gi.test(queryParams.fm)) {
          customerService.getFutureMoveCustomerNr(queryParams.fm).then(function (futureMoveCustomerNr) {
            if (futureMoveCustomerNr) {
              vm.form.customer_number = futureMoveCustomerNr;
              vm.data.credentials.future_move_token = queryParams.fm;
              return;
            }
            throw new Error(); // Notification: invalid token format
          }).catch(function () {
            // Notification: invalid token format
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12100});
            return;
          });
        } else {
          // Notification: invalid token format, contact customer service.
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12100});
          return;
        }
      } else {
        // Notification: no token available, contact customer service.
        $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12105});
      }
    }
    activate();
  }

  angular.module('wml.portal.register')
    .controller('PremisesRegisterLoginController', PremisesRegisterLoginController);

})();

(function() {
  'use strict';

  /**
   * @ngInject
   * Gets called when future move in and no correspondence e-mail is known.
   *
   * */
  premisesRegisterFutureCorrespondenceEmailController.$inject = ["$scope", "$state", "customerService", "addressService", "ivAuthenticate", "premiseRegisterService", "$rootScope"];
  function premisesRegisterFutureCorrespondenceEmailController($scope, $state, customerService, addressService, ivAuthenticate, premiseRegisterService, $rootScope) {

    var vm = this;

    // Public variables
    vm.form = null;
    vm.data = premiseRegisterService.data;
    vm.loading = false;

    // Public function definitions
    vm.next = next;
    vm.cancel = cancel;

    // Public functions

    function next() {
      if (vm.form.$valid) {
        vm.data.email.bSetNew = true;
        premiseRegisterService.storeData();
        $state.go('premisesRegisterSummary');
      }
    }

    function cancel() {
      $state.go('premisesRegister');
    }
  }

  angular.module('wml.portal.premisesRegister')
    .controller('premisesRegisterFutureCorrespondenceEmailController', premisesRegisterFutureCorrespondenceEmailController);

})();

(function() {
  'use strict';

  /** @ngInject */
  premisesRegisterCorrespondenceAddressController.$inject = ["$scope", "$state", "customerService", "addressService", "ivAuthenticate", "premiseRegisterService", "$rootScope"];
  function premisesRegisterCorrespondenceAddressController($scope, $state, customerService, addressService, ivAuthenticate, premiseRegisterService, $rootScope) {

    var vm  = this;
    // private variables
    var _lastAutofill = null;
    var _lastAutofillPo = null;

    // Public variables
    vm.form = null;
    vm.premises = [];
    vm.bShowOther = false;
    vm.bShowPremisesSelection = true;
    vm.data = premiseRegisterService.data;
    vm.loading = false;

    // Public function definitions
    vm.autofillHouseNo = autofillHouseNo;
    vm.autofillPoBox = autofillPoBox;
    vm.showOther = showOther;
    vm.save = save;
    vm.changeCountry = changeCountry;
    vm.changeType = changeType;

    // Public functions
    function autofillHouseNo() {
      if(vm.data.correspondence.country !== 'NL'){
        return false;
      }

      if(!angular.isString(vm.data.correspondence.address_id) && angular.isString(vm.data.correspondence.postal_code) && angular.isString(vm.data.correspondence.house_no)) {
        vm.data.correspondence.postal_code = vm.data.correspondence.postal_code.toUpperCase();

        if(/^[0-9]{4}[A-Z]{2}$/.test(vm.data.correspondence.postal_code)) {

          var data = {
            postal_code : vm.data.correspondence.postal_code,
            house_no : vm.data.correspondence.house_no
          };

          var autofillKey = data.postal_code + '_' + data.house_no;

          if (angular.isString(vm.data.correspondence.house_no_addition)) {
            data.house_no_addition = vm.data.correspondence.house_no_addition;
            autofillKey = autofillKey + '_' + vm.data.correspondence.house_no_addition;
          }

          if(autofillKey === _lastAutofill) {
            return false;
          }

          vm.data.correspondence.city        = null;
          vm.data.correspondence.street      = null;
          vm.loading                         = true;

          _lastAutofill = autofillKey;

          autoFill(data);
        }
      }
    }

    function autofillPoBox() {
      if(vm.data.correspondence.country !== 'NL'){
        return false;
      }

      if(!angular.isString(vm.data.correspondence.address_id) && angular.isString(vm.data.correspondence.po_box_postal_code) && angular.isString(vm.data.correspondence.po_box)) {
        vm.data.correspondence.po_box_postal_code = vm.data.correspondence.po_box_postal_code.toUpperCase();

        if(/^[0-9]{4}[A-Z]{2}$/.test(vm.data.correspondence.po_box_postal_code)) {

          var data = {
            po_box_postal_code  : vm.data.correspondence.po_box_postal_code,
            po_box              : vm.data.correspondence.po_box
          };

          var autofillKey = data.po_box_postal_code + '_' + data.po_box;

          if(autofillKey === _lastAutofillPo) {
            return false;
          }

          vm.data.correspondence.city = null;
          vm.loading                    = true;

          _lastAutofillPo = autofillKey;

          autoFill(data);
        }
      }
    }

    function showOther(bShowOther){
      vm.bShowOther = bShowOther;
    }

    function save() {
      if (vm.form.$valid) {
        if (vm.data.correspondence.type === null || !vm.data.correspondence.type.length) {
          vm.data.correspondence.type = 'address';
        }

        premiseRegisterService.storeData();
        $state.go('premisesRegisterSummary');
      }
    }

    function changeCountry() {
      resetForm();
      if(vm.data.correspondence.country !== 'NL'){
        vm.data.correspondence.type = 'address';
      } else {
        vm.data.correspondence.type = '';
      }
    }

    function changeType() {
      resetForm();
    }

    // Private functions
    function resetForm() {
      _lastAutofillPo = null;
      _lastAutofill   = null;

      vm.data.correspondence.postal_code        = null;
      vm.data.correspondence.po_box_postal_code = null;
      vm.data.correspondence.po_box             = null;
      vm.data.correspondence.street             = null;
      vm.data.correspondence.house_no           = null;
      vm.data.correspondence.house_no_addition  = null;
      vm.data.correspondence.city               = null;
    }

    function getPremises() {
      customerService.getPremises().then(getPremiseSuccess);
    }

    function getPremiseSuccess(response) {
      vm.premises = response;

      if (vm.premises.length === 0) {
        vm.bShowPremisesSelection = false;
      }
    }

    function autoFill(data) {
      addressService.autofill(data).then(function(response) {
        var address = angular.copy(response.plain());
        vm.loading = false;
        vm.data.correspondence.street = address.street || '';
        vm.data.correspondence.house_no_addition = address.house_no_addition || '';
        vm.data.correspondence.city = address.city || '';
      });
    }

    activate();

    function activate() {
      getPremises();

      if (vm.data.correspondence.address_id === null) {
        vm.showOther(true);
      }

      $scope.$watch(function() {return vm.data.correspondence.address_id}, function(newValue) {
        if (angular.isDefined(newValue) && angular.isObject(newValue)) {
          vm.data.correspondence.country = newValue.country;
          vm.data.correspondence.city = newValue.city;
          vm.data.correspondence.postal_code = newValue.postal_code;
          vm.data.correspondence.street = newValue.street;
          vm.data.correspondence.house_no = newValue.house_no;
          vm.data.correspondence.house_no_addition = newValue.house_no_addition;
        }
      });
    }
  }

  angular.module('wml.portal.premisesRegister')
    .controller('premisesRegisterCorrespondenceAddressController', premisesRegisterCorrespondenceAddressController);

})();

(function () {
  'use strict';

  /** @ngInject */
  premisesRegisterController.$inject = ["$state", "addressService", "premiseRegisterService", "premiseUnregisterService", "customerService", "storage", "$rootScope", "premisesService", "$stateParams"];
  function premisesRegisterController($state, addressService, premiseRegisterService, premiseUnregisterService, customerService, storage, $rootScope, premisesService, $stateParams) {

    var vm = this;

    // private variables
    var _lastAutofill = null;

    // Public variables
    vm.data = premiseRegisterService.data;
    vm.form = null;
    vm.noValidAddress = true;
    vm.loading = false;

    // Public function definitions
    vm.next = next;
    vm.getCustomer = getCustomer;
    vm.cancel = cancel;
    vm.autoFill = autoFill;
    vm.autofillHouseNo = autofillHouseNo;

    // Public functions
    function next() {
      vm.form.$commitViewValue();
      if (vm.form.$valid) {
        premiseRegisterService.storeData();

        var futureMoveCheck = {
          postal_code: vm.data.address.postal_code,
          house_no: vm.data.address.house_no,
          house_no_addition: vm.data.address.house_no_addition,
        };

        // always check if address has future move
        customerService.hasFutureMove(futureMoveCheck).then(function (isProspect) {
          // api Type Enum = MOVE_OUT:'O', MOVE_IN: 'I', MOVE_IN_OUT:'X';
          var moveInAlreadyExists = (isProspect.exists && (isProspect.move_in_out === 'I' || isProspect.move_in_out === 'X'));
          if (moveInAlreadyExists && !vm.data.credentials.future_move_token.length) {
            // notification: is already a prospect, contact customer service
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12103'});
            return;
          }
          // if not in future or token, go to meter reading
          var bIsInFuture = vm.data.bIsInFuture;
          var bCorrespondanceEmailKnown = vm.data.email.correspondence;
          if (!bIsInFuture || vm.data.credentials.future_move_token) { $state.go('premisesRegisterMeterReading'); }
          if (bIsInFuture) {
            if (bCorrespondanceEmailKnown) {
              $state.go('premisesRegisterSummary');
            } else {
              $state.go('premisesRegisterFutureCorrespondenceEmail');
            }
          }
        })
          .catch(function () {
            // notification: failed to check if has future move data, contact customer service.
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: '12104'});
            return;
          });
      }
    }

    function cancel() {
      // make decision based on future move token, go to premisses-register login
      if (vm.data.credentials.future_move_token.length) {
        $state.go('premisesRegisterLogin', {fm: vm.data.credentials.future_move_token});
      } else {
        if (storage('corporation')) {
          $state.go('customer');
        }
        $state.go('premisesRegisterMoveInDate');
      }
    }

    function autofillHouseNo() {
      if (angular.isString(vm.data.address.postal_code) && angular.isString(vm.data.address.house_no)) {
        vm.data.address.postal_code = vm.data.address.postal_code.toUpperCase();

        if (/^[0-9]{4}[A-Z]{2}$/.test(vm.data.address.postal_code.replace(/\s/g, ''))) {
          var data = {
            postal_code       : vm.data.address.postal_code,
            house_no          : vm.data.address.house_no,
            house_no_addition : null
          };

          if (angular.isString(vm.data.address.house_no_addition) && vm.data.address.house_no_addition.length > 0) {
            data.house_no_addition  = vm.data.address.house_no_addition;
          }

          var autofillKey = data.postal_code + '_' + data.house_no + '_' + data.house_no_addition;
          if (autofillKey === _lastAutofill) {
            return false;
          }
          vm.noValidAddress           = true;
          vm.loading                  = true;
          vm.data.address.city        = null;
          vm.data.address.street      = null;

          _lastAutofill = autofillKey;

          autoFill(data);
        }
      }
    }

    function getCustomer() {
      customerService.getCustomer().then(getCustomerSuccess)
    }

    function getCustomerSuccess(response) {
      vm.data.email.correspondence = response.email.correspondence;
      premiseRegisterService.storeData();
    }

    function autoFill(data) {
      addressService.autofill(data).then(function(response) {
        var address = angular.copy(response.plain());

        vm.loading          = false;
        vm.noValidAddress   = false;

        $rootScope.$broadcast('wml.portal.message.cancel');

        if(typeof address.valid_for_subscription === 'boolean' && !address.valid_for_subscription){
          vm.noValidAddress = true;
          $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code: '1005'});
        }

        if(address.city === null){
          vm.noValidAddress = true;
          $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code: '1004'});
        }

        if(address.street){
          vm.data.address.street = address.street;
        }
        if(address.house_no_addition){
          vm.data.address.house_no_addition = address.house_no_addition;
        }
        if(address.city){
          vm.data.address.city = address.city;
        }

        if(address.contract_id){
          vm.data.address.contract_id = address.contract_id;
        }

        if (address.meter_number) {
          vm.data.address.meter_number = address.meter_number;
        }

        if(address.premise_id){
          vm.data.address.premise_id = address.premise_id;
        }

        if (address.device_id) {
          vm.data.address.device_id = address.device_id;
        }
      });
    }

    // Private functions
    activate();

    function activate() {
      if($stateParams.clearCache === 'true'){
        premiseRegisterService.clearData();
        premiseUnregisterService.clearData();
        premisesService.clearProcesStatus();
      }

      if (angular.isDefined(vm.data.prospect.exists) && vm.data.prospect.exists && vm.data.credentials.future_move_token.length) {
        vm.data.connectionAddress = vm.data.prospect.premise;
      }

      if ((vm.data.address.postal_code && vm.data.address.house_no) || vm.data.connectionAddress) {
        vm.autofillHouseNo();
      }

      if (vm.data.address.city !== null) {
        vm.noValidAddress = false;
      }

      if (angular.isUndefined(premisesService.getProcesStatus()) || premisesService.getProcesStatus() === null) {
        premisesService.storeProcesStatus('moving_in');
      }

      if (angular.isUndefined(vm.data.credentials.grant_type) || vm.data.credentials.grant_type !== 'short_term') {
        vm.getCustomer();
      }
    }
  }

  angular
    .module('wml.portal.premisesRegister')
    .controller('premisesRegisterController', premisesRegisterController);
})();

(function () {
  'use strict';

  /** @ngInject */
  PaymentMethodController.$inject = ["$q", "$rootScope", "$stateParams", "$state", "enumService", "customerService", "$scope"];
  function PaymentMethodController($q, $rootScope, $stateParams, $state, enumService, customerService, $scope) {

    var vm = this;

    // private variables
    var _payment_dates          = [];
    var _paymentFrequency       = [];

    var _currentFrequency       = null;

    // Public variables
    vm.form                   = null;
    vm.bPaymentMethodDisabled = false;
    vm.draft                  = {};
    vm.paymentFrequency       = [];
    vm.sendingData            = false;

    // Public function definitions
    vm.save               = save;
    vm.filterPaymentDays  = filterPaymentDays;
    vm.filterFrequencies  = filterFrequencies;

    // Public functions
    function save() {
      vm.form.$commitViewValue();
      if (vm.form.$valid) {
        vm.sendingData = true;
        customerService.savePaymentDetails($stateParams.contract_account_id, $stateParams.contract_id, vm.draft).then(function(){
          $rootScope.$broadcast('clear-cache');
          $state.go('invoicesDashboardSaved');
        }).finally(function(){
          vm.sendingData = false;
        });
      }
    }

    function filterPaymentDays() {
      //20170323 - mike@ivengi.com: When payment frequency is not monthly (01), filter available payment days. Show current payment day and option 14D which relates to 16th of the month
      vm.payment_dates = [];
      if(vm.draft.payment_frequency !== '01'){
        vm.payment_dates = _payment_dates.filter(function(item){
          return item.value === vm.draft.payment_date || item.value === '14D';
        });
      } else {
        vm.payment_dates = _payment_dates;
      }

    }

    // Private functions
    function getPaymentMethods() {
      return enumService.getPaymentMethods().then(function (data) {
        vm.paymentMethods = data;
      });
    }

    function getPaymentFrequency() {
      return enumService.getPaymentFrequency().then(function (data) {
        _paymentFrequency = data;
      });
    }

    function filterFrequencies() {
      vm.paymentFrequency = _paymentFrequency.filter(function(item){
        if(vm.draft.payment_method === 'automatic_collection'){
          return item.value === '01' || item.value === '03' || item.value === _currentFrequency;
        } else {
          return item.value === '03' || item.value === _currentFrequency;
        }
      });

      filterPaymentDays();
    }

    function getPaymentDates() {
      enumService.getPaymentDates().then(function (data) {
        _payment_dates = data;
      });
    }

    function getCurrentPaymentMethod(){
      customerService.getContractAccount($stateParams.contract_account_id).then(function(response) {

        var contract = null;
        for(var i=0; i < response.contracts.length; i++ ) {
          if(response.contracts[i].contract_id === $stateParams.contract_id) {
            contract  = response.contracts[i];
            break;
          }
        }

        _currentFrequency = contract.cycle || null;

        vm.draft = {
          payment_method    : response.incoming_payment_method_id,
          payment_frequency : _currentFrequency,
          payment_date      : response.payment_terms
        };

        if(angular.isDefined(response.incoming_bank_account) && response.incoming_bank_account !== null){
          vm.draft.iban = response.incoming_bank_account.iban;
        }

        filterFrequencies();

        if(vm.draft.payment_method === 'automatic_collection'){
          vm.bPaymentMethodDisabled = true;
        }
      });
    }



    activate();

    function activate() {
      $q.all([getPaymentFrequency(), getPaymentMethods(), getPaymentDates()]).then(function() {
        getCurrentPaymentMethod();
      });
    }
  }

  angular
    .module('wml.portal.paymentMethod')
    .controller('PaymentMethodController', PaymentMethodController);
})();

(function () {
  'use strict';

  /** @ngInject */
  meterReadingThankYouController.$inject = ["$state", "ivAuthenticate", "customerService", "$rootScope", "moment", "meterReadingService", "$stateParams"];
  function meterReadingThankYouController($state, ivAuthenticate, customerService, $rootScope, moment, meterReadingService, $stateParams) {
    var vm = this;
    vm.data = meterReadingService.data;

    // private variables

    // Public variables

    // Public function definitions

    vm.next = next;
    vm.save = save;

    vm.accept_conditions = false;
    vm.amount = 5;
    vm.custom_amount = 5;
    vm.wflSuccess = false;
    vm.isAuthenticated = false;
    // Public functions

    function next() {
      meterReadingService.clearData();
      if (vm.isAuthenticated) {
        $state.go('dashboard');
      } else {
        $state.go('home');
      }
    }

    // Private functions

    activate();

    function activate() {
      if (ivAuthenticate.isAuthenticated()) {
        vm.isAuthenticated = true;
      }
      meterReadingService.getWFL($stateParams).then(function (response) {
        vm.data.wfl_amount = response.wfl_amount;
        vm.data.wfl_month = response.wfl_month;
        vm.data.wfl_possible = response.wfl_possible;
      });
    }

    function save() {
      // if optie 'anders' [amount = 0] use vm.custom_amount [min 5];
      if (vm.accept_conditions) {
        if (vm.amount === 0) {
          vm.data.wfl_amount = vm.custom_amount;
        } else {
          vm.data.wfl_amount = vm.amount;
        }

        if (vm.data.wfl_amount >= 5) {
          vm.data.wfl_month = moment().format('M');

          meterReadingService.setWFL($stateParams, vm.data.wfl_amount, vm.data.wfl_month).then(function (response) {
            if (response) {
              vm.wflSuccess = true;
              $rootScope.$broadcast('clear-cache', {customer: {customer: true}});
              $rootScope.$broadcast('wml.portal.custom_message', {level: 'success', code: '1000'});
            }
          });
        }
      }
    }
  }

  angular
    .module('wml.portal.meterReading')
    .controller('meterReadingThankYouController', meterReadingThankYouController);
})();

(function () {
  'use strict';

  /** @ngInject */
  meterReadingSummaryController.$inject = ["$state", "$rootScope", "$scope", "$stateParams", "$filter", "$translate", "meterReadingService", "storage"];
  function meterReadingSummaryController($state, $rootScope, $scope, $stateParams, $filter, $translate, meterReadingService, storage) {
    var vm = this;
    // private variables
    var _state = 'meterReadingRecording';
    var _stateParams = {};

    // Public variables
    vm.data = meterReadingService.data;

    vm.isCorporation = storage('corporation') || false;
    vm.isCompany = storage('company') || false;

    // Public function definitions
    vm.save = save;
    vm.cancel = cancel;
    vm.gotoMeterReading = gotoMeterReading;
    vm.sendingData = false;

    // Public functions
    function save() {
      var meterReading = vm.data.num1 + vm.data.num2 + vm.data.num3 + vm.data.num4 + vm.data.num5 + vm.data.num6 + vm.data.num7;
      vm.sendingData = true;

      if (vm.data.deviations && vm.data.deviation_code !== null) {
        var found = $filter('filter')(vm.data.deviations, {code: vm.data.deviation_code}, true);
        if (found.length === 1) {
          vm.data.deviation_text = $translate.instant('meter_readings.deviations.' + found[0].translate_key);
        }
      }
      // check if vm.data.file_upload.name is set
      // if no more recollection of fileUpload, then file is gone due to refresh.
      if (vm.data && vm.data.file_upload && vm.data.file_upload.name && !vm.data.file_upload.file) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 11013});
        vm.data.file_upload = null;
        meterReadingService.storeData();
        return;
      }

      meterReadingService.setMeterReading(vm.data.credentials.assignment_number, vm.data.credentials.postal_code, meterReading, vm.data.forced_meter_reading, vm.data.date, vm.data.deviation_code, vm.data.deviation_text, vm.data.deviation_reason, vm.data.email, vm.data.file_upload, vm.data.keep_installment_amount).then(function (response) {
        if (angular.isDefined(response)) {
          // should not happen anymore, since we checked beforehand.
          if (angular.isDefined(response.level) && response.level === 'warning') {
            if (response.fields && response.fields.deviations) {
              vm.data.forced_meter_reading = true;
              vm.data.forced_meter_reading_err_code = response.code;
              vm.data.deviations = response.fields.deviations;
              vm.data.keep_installment_amount = null; // if forced, you can't choose to keep installment amount
              // meterReadingService.storeData();
              $state.go(_state, _stateParams);
            }
          } else {
            $state.go('meterReadingThankYou', _stateParams);
          }
        }
      }).finally(function () {
        vm.sendingData = false;
      });
    }

    function gotoMeterReading() {
      $state.go(_state, _stateParams);
    }

    function cancel() {
      $state.go('meterReadingEmailConfirmation', _stateParams);
    }

    // Private functions
    activate();
    function activate() {
      _stateParams.assignment_number = vm.data.credentials.assignment_number;
      _stateParams.postal_code = vm.data.credentials.postal_code;
      _stateParams.meter_reading = vm.data.meter_reading;
      if (vm.data.credentials.meter_reading) {
        _state = 'meterReadingRecordingExtReading';
        _stateParams.meter_reading = vm.data.credentials.meter_reading;
      }
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }
  }
  angular
    .module('wml.portal.meterReading')
    .controller('meterReadingSummaryController', meterReadingSummaryController);
})();

(function () {
  'use strict';

  /** @ngInject */
  meterReadingRecordingNumberController.$inject = ["$state", "$stateParams", "meterReadingService", "$rootScope", "storage"];
  function meterReadingRecordingNumberController($state, $stateParams, meterReadingService, $rootScope, storage) {
    var vm = this;
    var _state = 'meterReadingRecording';
    var _stateParams = {};

    // private variables

    // Public variables
    vm.form = null;
    vm.sendingData = false;

    vm.data = meterReadingService.data;

    if (angular.isDefined($stateParams.assignment_number)) {
      vm.data.credentials.assignment_number = $stateParams.assignment_number;
    }

    if (angular.isDefined($stateParams.meter_reading)) {
      _state = 'meterReadingRecordingExtReading';
      vm.data.credentials.meter_reading = $stateParams.meter_reading;
      _stateParams.meter_reading = $stateParams.meter_reading;
    }

    // Public function definitions
    vm.next = next;

    // Public functions
    function next() {
      vm.form.$commitViewValue();

      if (vm.form.$valid) {
        vm.sendingData = true;
        meterReadingService.verifyReading(vm.data.credentials).then(function (data) {
          // check if isCompany and isCorporation and storage those - later in summary needed to show/hide checkbox
          if (angular.isDefined(data.isCompany)) {
            storage('company', data.isCompany);
          }
          if (angular.isDefined(data.isCorporation)) {
            storage('corporation', data.isCorporation);
          }
          meterReadingService.storeData();
          _stateParams.assignment_number = vm.data.credentials.assignment_number;
          _stateParams.postal_code = vm.data.credentials.postal_code;
          $state.go(_state, _stateParams);
        }).finally(function () {
          vm.sendingData = false;
        });
      }
    }

    // Private functions
    activate();

    function activate() {
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }
  }

  angular
    .module('wml.portal.meterReading')
    .controller('meterReadingRecordingNumberController', meterReadingRecordingNumberController);
})();

(function () {
  'use strict';

  /** @ngInject */
  meterReadingEmailConfirmationController.$inject = ["$state", "$stateParams", "meterReadingService", "$rootScope"];
  function meterReadingEmailConfirmationController($state, $stateParams, meterReadingService, $rootScope) {
    var vm = this;
    var _state = 'meterReadingRecording';
    var _stateParams = {};

    // private variables

    // Public variables
    vm.form = null;

    vm.data = meterReadingService.data;

    if (angular.isDefined($stateParams.assignment_number)) {
      vm.data.credentials.assignment_number = $stateParams.assignment_number;
    }

    if (angular.isDefined($stateParams.meter_reading)) {
      _state = 'meterReadingRecordingExtReading';
      vm.data.credentials.meter_reading = $stateParams.meter_reading;
      _stateParams.meter_reading = $stateParams.meter_reading;
    }

    // Public function definitions
    vm.next = next;
    vm.cancel = cancel;

    // Public functions
    function next() {
      vm.form.$commitViewValue();

      if (vm.form.$valid) {
        if (!vm.data.optional_email) {
          vm.data.email = '';
        }
        // vm.sendingData = true;
        meterReadingService.storeData();
        $state.go('meterReadingSummary', $stateParams);
      }
    }

    function cancel() {
      $state.go(_state, _stateParams);
    }
    // Private functions
    activate();

    function activate() {
      _stateParams.assignment_number = vm.data.credentials.assignment_number;
      _stateParams.postal_code = vm.data.credentials.postal_code;
      _stateParams.meter_reading = vm.data.meter_reading;
      if (vm.data.credentials.meter_reading) {
        _state = 'meterReadingRecordingExtReading';
        _stateParams.meter_reading = vm.data.credentials.meter_reading;
      }
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }
  }

  angular
    .module('wml.portal.meterReading')
    .controller('meterReadingEmailConfirmationController', meterReadingEmailConfirmationController);
})();

(function () {
  'use strict';

  /** @ngInject */
  meterReadingController.$inject = ["$document", "$timeout", "$state", "$rootScope", "$scope", "$stateParams", "$filter", "$translate", "calendarsService", "meterReadingService", "ivAuthenticate", "Upload"];
  function meterReadingController($document, $timeout, $state, $rootScope, $scope, $stateParams, $filter, $translate, calendarsService, meterReadingService, ivAuthenticate, Upload) {
    var vm = this;
    // private variables

    // Public variables
    vm.form = null;

    vm.showDatepicker = false;
    vm.datepickerFormat = "dd-MM-yyyy";
    vm.datepickerCurrentMonth = new Date();
    vm.datepickerOptions = {
      customClass: datePickerClass,
      maxDate: null,
      minDate: null
    };
    vm.currentMeterReading = false;
    vm.data = meterReadingService.data;
    vm.consumption = null;

    vm.fileToUpload = null;

    // Public function definitions
    vm.save = save;
    vm.cancel = cancel;
    vm.openDatepicker = openDatepicker;
    vm.fileChange = fileChange;

    $scope.$on('datepicker.monthChanged', function (event, newVal) {
      vm.datepickerCurrentMonth = newVal;
    });

    $scope.$on('datepicker.format', function (event, mode) {
      datepickerFormat(mode);
    });
    function datepickerFormat(mode) {
      if (mode === 'day') {
        $timeout(function () {
          var uibWeeks = $document[0].getElementsByClassName('uib-weeks');
          for (var i = 0; i < uibWeeks.length; i += 1) {
            var uibBans = uibWeeks[i].getElementsByClassName('uib-ban');
            if (uibBans.length === 7) {
              uibWeeks[i].style.display = 'none';
            }
            if (uibBans.length !== 7) {
              uibWeeks[i].style.display = 'table-row';
            }
          }
        }, 100);
      }
    }

    function datePickerClass(data) {
      var date = data.date;
      var mode = data.mode;
      if (mode === 'day') {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
        var currentMonthToCheck = angular.isString(vm.datepickerCurrentMonth) ? new Date(vm.datepickerCurrentMonth) : vm.datepickerCurrentMonth;
        if (new Date(dayToCheck).getMonth() !== currentMonthToCheck.getMonth()) {
          if (new Date(dayToCheck) > vm.datepickerCurrentMonth) {
            return 'uib-ban';
          }
          return 'uib-nope';
        }
        return 'uib-yeah';
      }
      return '';
    }

    function openDatepicker() {
      vm.datepickerCurrentMonth = (vm.data.date) ? vm.data.date : new Date();
      vm.showDatepicker = true;
      datepickerFormat('day');
    }

    function getCalendarSettingsFromImanager() {
      calendarsService.getCalendars('meterReading').then(function (response) {
        var max = response.maxDate;
        var min = response.minDate;
        vm.datepickerOptions.maxDate = (isNaN(max)) ? null : new Date(new Date().setDate(new Date().getDate() + max));
        vm.datepickerOptions.minDate = (isNaN(min)) ? null : new Date(new Date().setDate(new Date().getDate() - min));
      });
    }

    function fileChange(file, errFiles) {
      $rootScope.$broadcast('wml.portal.message.cancel');
      if (errFiles.length > 0) {
        if (errFiles[0].$error === "maxSize") {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
        } else {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 12102});
        }
      }
      if (file) {
        vm.data.file_upload = null;
        vm.fileToUpload = file;
      }
    }

    function save() {
      if (vm.form.$valid) {
        Upload.base64DataUrl(vm.fileToUpload)
          .then(function (dataUrl) {
            if (dataUrl) {
              vm.data.file_upload = {
                file: dataUrl,
                name: vm.fileToUpload.name,
                type: vm.fileToUpload.type
              };
            }
          })
          .finally(function () {
            if (vm.data.credentials.assignment_number === null || vm.data.credentials.postal_code === null) {
              vm.data.credentials.assignment_number = $stateParams.assignment_number;
              vm.data.credentials.postal_code = $stateParams.postal_code;
            }
            // when deviation reason given, do not do a check again.
            if (vm.data.deviations && vm.data.deviation_code !== null) {
              var found = $filter('filter')(vm.data.deviations, {code: vm.data.deviation_code}, true);
              if (found.length === 1) {
                vm.data.deviation_text = $translate.instant('meter_readings.deviations.' + found[0].translate_key);
              }

              meterReadingService.storeData();
              $state.go('meterReadingEmailConfirmation', $stateParams);
            } else {
              // after first time setting meterreading, check if plausible. If not we'll retrieve devation reasons.
              meterReadingService.checkMeterReading(vm.data.credentials.assignment_number, vm.data.credentials.postal_code, vm.data.meter_reading, vm.data.date).then(function (response) {
                if (angular.isDefined(response)) {
                  if (angular.isDefined(response.level) && response.level === 'warning') {
                    if (response.fields && response.fields.deviations) {
                      vm.data.forced_meter_reading = true;
                      vm.data.forced_meter_reading_err_code = response.code;
                      vm.data.deviations = response.fields.deviations;
                      meterReadingService.storeData();
                      $state.go('meterReadingRecording',
                        {
                          assignment_number: vm.data.credentials.assignment_number,
                          postal_code: vm.data.credentials.postal_code,
                          meter_reading: vm.data.meter_reading
                        });
                    }
                  } else {
                    meterReadingService.storeData();
                    $state.go('meterReadingEmailConfirmation', $stateParams);
                  }
                }
              });
            }
          });
      }
    }

    function cancel() {
      meterReadingService.clearData();
      if (ivAuthenticate.isAuthenticated() !== false) {
        $state.go('dashboard');
      } else {
        $state.go('home');
      }
    }

    // Private functions

    activate();

    function activate() {
      getCalendarSettingsFromImanager();
      if (vm.data && vm.data.date && angular.isString(vm.data.date)) {
        vm.data.date = new Date(vm.data.date);
      }
      meterReadingService.meterDetails($stateParams).then(function (response) {
        if (response.address) {
          vm.data.address = {
            city: response.address.city,
            house_no: response.address.house_no,
            house_no_addition: response.address.house_no_addition,
            postal_code: response.address.postal_code,
            street: response.address.street,
          };
        }

        if (response.meter_number) {
          vm.data.meter_number = response.meter_number;
        }

        if (response.previous_reading) {
          vm.consumption = response.previous_reading;
          if (angular.isDefined(vm.consumption.date)) {
            vm.consumption.date = $filter('date')(vm.consumption.date, 'longDate');
          }
        }

        vm.numberOfMeterNumbers = parseInt(response.nr_wheels_before) || 5;
        vm.aNumberOfMeterNumbers = [];
        for (var i = 0; i < vm.numberOfMeterNumbers; i++) {
          vm.aNumberOfMeterNumbers[i] = i + 1;
        }

        vm.currentMeterReading = vm.data.meter_reading;

        $scope.$watch(function () { return vm.data.meter_reading; }, function (newValue) {
          if (angular.isString(newValue)) {

            if (!vm.data.meter_reading) {
              if ($stateParams.meter_reading && $stateParams.meter_reading !== newValue) {
                vm.data.forced_meter_reading = false;
                vm.data.deviation_code = null;
                vm.data.deviation_reason = null;
                vm.data.deviation_text = null;
              }
            } else {
              if (vm.currentMeterReading && vm.currentMeterReading !== newValue) {
                vm.data.forced_meter_reading = false;
                vm.data.deviation_code = null;
                vm.data.deviation_reason = null;
                vm.data.deviation_text = null;
              }
            }

            var data = newValue.split('');
            var length = data.length;
            if (length < vm.numberOfMeterNumbers) {
              for (var j = 0; j < (vm.numberOfMeterNumbers-length); j++) {
                data.unshift('0');
              }
            }
            for(var k=0; k < data.length; k++) {
              var key = 'num' + (k+1);
              vm.data[key]  = data[k];
            }
          } else {
            for(var l=1; l <= vm.numberOfMeterNumbers; l++) {
              vm.data['num' + l]  = 0;
            }
          }
        });

        $scope.$watchCollection(function() {return [vm.data.num1, vm.data.num2, vm.data.num3, vm.data.num4, vm.data.num5, vm.data.num6, vm.data.num7]}, function() {
          // s3p14 - now possible to come back to page, only set null if not equal to previous meter_reading.
          if (Number(vm.data.num1 + vm.data.num2 + vm.data.num3 + vm.data.num4 + vm.data.num5 + vm.data.num6 + vm.data.num7) !== Number(vm.data.meter_reading)) {
            vm.data.deviation_code    = null;
            vm.data.deviation_reason  = null;
          }
        });

        meterReadingService.storeData();
      });

      vm.data.meter_reading = vm.data.meter_reading || $stateParams.meter_reading || '';

      if (vm.data.forced_meter_reading) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: vm.data.forced_meter_reading_err_code || 11003});
      }

      // check if vm.data.file_upload.name is set
      // if no more recollection of fileUpload, then file is gone due to refresh.
      if (vm.data && vm.data.file_upload && vm.data.file_upload.name && !vm.data.file_upload.file) {
        $rootScope.$broadcast('wml.portal.message', {level: 'warning', code: 11013});
        vm.data.file_upload = null;
        meterReadingService.storeData();
        return;
      }

      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }
  }

  angular
    .module('wml.portal.meterReading')
    .controller('meterReadingController', meterReadingController);
})();

(function () {
  'use strict';

  /** @ngInject */
  MessageController.$inject = ["$rootScope", "$translate", "$document", "$scope", "$timeout", "restBackend"];
  function MessageController($rootScope, $translate, $document, $scope, $timeout, restBackend) {

    var vm = this;
    var _message;
    var _stickyMessage;
    var _httpMessage;
    var _customMessage;
    var _cancelMessage;

    // private variables
    // Public variables
    vm.code           = null;
    vm.level          = null;
    vm.messageType    = null;
    vm.bHideError     = false;
    vm.stickyMessage  = {};
    // Public function definitions
    // Public functions
    // Private functions

    activate();

    function activate() {

      _message = $rootScope.$on('wml.portal.message', function (event, response) {
        if (angular.isDefined(response)) {
          response.params = response.params || response.fields || {};
          vm.code         = response.code;
          vm.level        = response.level;
          vm.message      = $translate.instant('message.backoffice.' + vm.code, response.params);
          vm.messageType  = 'backoffice_message';
          vm.bHideError   = false;

          scrollToMessage();
        }
      });

      _stickyMessage = $rootScope.$on('wml.portal.sticky_message', function (event, response) {
        if (angular.isDefined(response)) {
          response.params = response.params || response.fields || {};
          vm.stickyMessage.code         = response.code;
          vm.stickyMessage.level        = response.level;
          vm.stickyMessage.message      = response.message || $translate.instant('message.backoffice.' + vm.stickyMessage.code, response.params);
          vm.stickyMessage.messageType  = 'sticky_message';
        }
      });

      _httpMessage = $rootScope.$on('wml.portal.http_message', function (event, response) {
        if (angular.isDefined(response)) {
          vm.level = response.level;
          vm.messageType = 'http_message';
          $translate('message.http.' + response.code).then(function (translation) {
            vm.message = translation;
          }, function () {
            $translate('message.http.xxx').then(function (translation) {
              vm.message  = translation;
            });
          });
          vm.bHideError = false;
          scrollToMessage();
        }
      });

      _customMessage = $rootScope.$on('wml.portal.custom_message', function (event, response) {
        if (angular.isDefined(response)) {
          response.params = response.params || {};
          vm.code = response.code;
          vm.level = response.level;
          vm.message  = $translate.instant('message.custom.' + vm.code, response.params);
          vm.messageType = 'custom_message';
          vm.bHideError = false;
          scrollToMessage();
        }
      });

      _cancelMessage = $rootScope.$on('wml.portal.message.cancel', function () {
        vm.bHideError = true;
      });

      $scope.$on('$destroy', function() {
        _message();
        _cancelMessage();
        _httpMessage();
        _customMessage();
      });
    }

    function scrollToMessage() {
      $timeout(function () {
        var messageElement = angular.element(document.getElementById('messageScroll'));
        $document.scrollToElement(messageElement, 150, 1000);
      },0);
    }

    restBackend.getSapStatus().then(function(res) {
      if (!res.status) {
        $rootScope.$broadcast('wml.portal.sticky_message', {
          code: 19000,
          level: 'error',
          messageType: 'sticky_message'
        });
      }
    });

    restBackend.getCrisisMsg().then(function (res) {
      if (res.show && res.show) {
        $rootScope.$broadcast('wml.portal.sticky_message', {
          level: res.level || 'error',
          messageType: 'sticky_message',
          message: res.data
        });
      }
    });
  }

  angular
    .module('wml.portal.message')
    .controller('MessageController', MessageController);
})();

(function() {
  'use strict';

  /** @ngInject */
  LoginController.$inject = ["$state", "$http", "$rootScope", "$timeout", "profileService", "RestangularExt", "storage", "$location", "activationService", "ivAuthenticate"];
  function LoginController($state, $http, $rootScope, $timeout, profileService, RestangularExt, storage, $location, activationService, ivAuthenticate) {
    var vm  = this;

    // private variables

    // Public variables
    vm.form = null;
    vm.sendingData  = false;

    // Public function definitions
    vm.doLogin = doLogin;

    // Public functions

    function doLogin(){
      vm.form.$commitViewValue();
      if(vm.form.$valid) {

        $rootScope.$broadcast('wml.portal.message.cancel');
        $rootScope.$broadcast('wml.loader.start');

        vm.sendingData = true;
        var credentials = {
          email       : vm.form.email,
          password    : vm.form.password
        };

        ivAuthenticate.login(credentials).then(function(response) {
          var claims  = ivAuthenticate.getJWTClaims();

          if (angular.isDefined(claims)) {
            if (angular.isDefined(claims.corporation)) {
              storage('corporation', claims.corporation);
            }
            if (angular.isDefined(claims.company)) {
              storage('company', claims.company);
            }
          }

          if(!storage('customer_number', response.customer_number) && (response.data.accounts && response.data.accounts.length > 1)) {
            if(angular.isDefined(claims) && angular.isDefined(claims.aud)) {
              storage('customer_number', claims.aud);
            }
            $state.go('accountOptions');
          } else {
            profileService.getProfile().then(getProfileSuccess);
          }

        },function (error) {
          if(error === null){
            return;
          }

          var params  = (angular.isDefined(error.fields)) ? error.fields : {};

          if(angular.isDefined(error.code)) {
            $rootScope.$broadcast('wml.portal.message', {level: 'error', code: error.code, params : params});
          } else {
            $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code: '1002'});
          }
        }).finally(function(){
          $timeout(function() {
            $rootScope.$broadcast('wml.loader.stop');
          }, 1000);

          vm.sendingData = false;
        });
      } else {
        $rootScope.$broadcast('wml.portal.custom_message', {level: 'error', code:'1001'});
      }
    }

    function getProfileSuccess(response) {
      RestangularExt.setDefaultHeaders(angular.extend(RestangularExt.configuration.defaultHeaders, {'X-Customer-Number': response.customer_number}));
      $http.defaults.headers.common['X-Customer-Number']  = response.customer_number;
      storage('customer_number', response.customer_number);
      $rootScope.$broadcast('clear-cache');

      if(storage('corporation') === true){
        $state.go('chooseAddress');
      } else {
        $state.go('dashboard');
      }
    }


    // Private functions

    function verifyActivation() {
      if($state.current.name === 'loginActivate'){
        var location = $location.search();
        if(angular.isDefined(location.e) && angular.isDefined(location.a) && angular.isDefined(location.r) && angular.isDefined(location.t) && angular.isDefined(location.h) && angular.isDefined(location.p)){
          activationService.activate(location).then(function(response){
            if(angular.isDefined(response.type) && response.type === 'message'){
              $rootScope.$broadcast('wml.portal.message', response);
            }
          })
        }
      }
    }

    activate();

    function activate() {
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
      verifyActivation();
    }

  }

  angular
    .module('wml.portal.login')
    .controller('LoginController', LoginController);
})();

(function() {
  'use strict';

  /** @ngInject */
  ListFaqController.$inject = ["faqService", "cmsService", "$rootScope"];
  function ListFaqController(faqService, cmsService, $rootScope) {
    var vm  = this;
    // private variables

    // Public variables
    vm.faqList   = [];
    vm.faqCategories = [];
    vm.topFaqs = [];

    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    // Private functions
    function getFaqsFromURI(){
      //call service function to get FAQs
      faqService.getFaqs().then(function(response){
        vm.faqList = response.Faqs;
        createCategoryList();
        createTopFaqsList();
        cmsService.setSEO(response);
      });
    }

    vm.filterOnCategory = function(category){
      return function(item){
        for(var i = 0; i < item.categories.length; i++){
          if (item.categories[i].name === category){
            return true;
          }
        }
      }
    };

    function createCategoryList(){
      angular.forEach(vm.faqList, function(item, key){
        for(var i = 0; i < item.categories.length; i++){
          if (_.findIndex(vm.faqCategories, item.categories[i]) === -1){
            vm.faqCategories.push(item.categories[i]);
          }
        }
      });
      _.sortBy(vm.faqCategories, 'name');
    }

    function createTopFaqsList(){
      vm.topFaqs = vm.faqList.filter(function(item){
        return item.top_question === '1';
      });
    }

    activate();

    function activate(){
      getFaqsFromURI();
    }
  }

  angular
    .module('wml.portal.faq')
    .controller('ListFaqController', ListFaqController);
})();

(function() {
  'use strict';

  /** @ngInject */
  ListPageController.$inject = ["cmsService"];
  function ListPageController(cmsService) {
    var vm  = this;

    // Public variables
    vm.currentPage = 1;

    // private variables

    // Public function definitions
    vm.changePage = changePage;

    // Public functions
    function changePage(){
      activate();
    }

    // Private functions
    activate();

    function activate (){
      var querystring = '?page=' + vm.currentPage;
      cmsService.loadData(querystring).then(function(data) {
        vm.data = data.plain();
        vm.currentPage = vm.data.Pagination.CurrentPage;
        cmsService.setSEO(data);
      });
    }
  }

  angular
    .module('wml.portal.listPage')
    .controller('ListPageController', ListPageController);
})();

(function() {
  'use strict';

  /** @ngInject */
  InvoicesPaymentArrangementController.$inject = ["$q", "$stateParams", "enumService", "$window", "$state", "$rootScope", "customerService", "invoicesService", "ivAuthenticate"];
  function InvoicesPaymentArrangementController($q, $stateParams, enumService, $window, $state, $rootScope, customerService, invoicesService, ivAuthenticate) {
    var vm = this;

    // private variables
    vm.contract_account_id = null;

    // Public variables
    vm.connectionAddresses    = [];
    vm.form                   = null;
    vm.bPaymentMethodDisabled = false;
    vm.draft                  = {
      automatic_collection: false
    };
    vm.sendingData            = false;
    vm.paymentFrequency       = [];

    // Public function definitions
    vm.save = save;
    vm.updatePaymentFrequencyAmount = updatePaymentFrequencyAmount;

    // Public functions
    function save() {
      invoicesService.postInstallmentPlan(vm.contract_account_id, vm.draft).then(function () {
        $state.go('invoicesDashboard', {refresh: true});
      });
    }

    // update the payment amount per frequency
    function updatePaymentFrequencyAmount() {
      vm.draft.payment_frequency_amount = vm.draft.total_amount / vm.draft.payment_frequency;
    }

    // get iban number of contract-account
    function getCurrentPaymentMethod() {
      customerService.getContractAccount().then(function(response) {
        if (!angular.isArray(response) || response.length < 1) { return;}
        for (var i = 0; i < response.length; i += 1) {
          if (angular.isDefined(response[i].incoming_bank_account) && response[i].incoming_bank_account !== null) {
            // use first available iban
            vm.draft.iban = response[i].incoming_bank_account.iban;
            return;
          }
        }
      });
    }

    activate();

    function activate() {
      customerService.getPremises().then(function (data) {
        if (data.length > 0 && data[0].contract_account_id) {
          vm.contract_account_id = data[0].contract_account_id;
          invoicesService.getInstallmentPlanChecks(vm.contract_account_id).then(function (data) {
            // make array for terms options of select box, from 1 - data.terms.
            var counter = 1;
            while (counter < data.terms) {
              vm.paymentFrequency.push(counter += 1);
            }

            vm.draft.total_amount = data.total_amount;
            vm.draft.payment_frequency = 2;
            vm.updatePaymentFrequencyAmount();
          });
        }
      });

      getCurrentPaymentMethod();
    }

  }
  angular
    .module('wml.portal.invoices')
    .controller('InvoicesPaymentArrangementController', InvoicesPaymentArrangementController);
})();

(function() {
  'use strict';

  /** @ngInject */
  InvoicesDashboardController.$inject = ["$window", "$state", "$rootScope", "$stateParams", "customerService", "invoicesService", "ivAuthenticate", "$location"];
  function InvoicesDashboardController($window, $state, $rootScope, $stateParams, customerService, invoicesService, ivAuthenticate, $location) {
    var vm  = this;

    // private variables
    vm.showPaymentArrangementButton = false;

    // Public variables
    vm.maxBalanceForPaymentArrangement = 300;
    vm.currentContactPaymentMethod = null;
    vm.connectionAddresses = null;
    vm.postalCodeFilterParam = null;
    vm.filterParams = {
      page: 1,
      limit: 5
    };

    // Public function definitions
    vm.filterOnPostalCode = filterOnPostalCode;
    vm.openPDF            = openPDF;

    // Public functions
    function filterOnPostalCode(){
      customerService.getPremises({postal_code: vm.postalCodeFilterParam}).then(getPremisesSuccess);
    }

    function openPDF(url) {
      var pdfWindow = $window.open('about:blank', '_blank');
      pdfWindow.location.href = url + '?access_token=' + ivAuthenticate.getAccessToken();
    }

    // Private functions
    function getPremises() {
      customerService.getPremises().then(getPremisesSuccess);
    }

    function getPremisesSuccess(response) {
      vm.connectionAddresses = response;
      if (vm.connectionAddresses.length > 0 && vm.connectionAddresses[0].contract_account_id) {
        invoicesService.getInstallmentPlanChecks(vm.connectionAddresses[0].contract_account_id).then(function (data) {
          vm.showPaymentArrangementButton = data.installation_plan_allowed;
        });
      }
    }

    function getInvoices() {
      var filterParams = angular.copy(vm.filterParams);
      filterParams.outstanding = 0;
      filterParams.document_types = ['PA'].join(',');
      invoicesService.getInvoices(filterParams).then(function(response){
        vm.invoices = response;
      });
    }

    function getRemainingInvoices() {
      // when returning from new payment arrangement, refresh invoice list
      var queryParams = $location.search();

      var filterParams = angular.copy(vm.filterParams);
      filterParams.outstanding = 1;
      invoicesService.getInvoices(filterParams, queryParams.refresh).then(function(response){
        vm.remainingInvoices = response;
      });
    }

    function getCurrentPaymentMethod() {
      customerService.getContractAccount($stateParams.contract_account_id).then(function(response) {
        if (!angular.isArray(response) || response.length < 1) { return;}
        response = response.shift();
        vm.currentContactPaymentMethod = response.incoming_payment_method_id;
      });
    }

    function getAccountBalance() {
      invoicesService.getAccountBalance().then(function (response) {
        vm.currentAccountBalance = response;
      });
    }

    activate();

    function activate(){
      getPremises();
      getInvoices();
      getRemainingInvoices();
      getCurrentPaymentMethod();
      getAccountBalance();

      if(angular.isDefined($state.current.name) && $state.current.name == "invoicesDashboardSaved"){
        $rootScope.$broadcast('wml.portal.custom_message', {level: 'success', code:'1000'});
      }
    }
  }

  angular
    .module('wml.portal.invoices')
    .controller('InvoicesDashboardController', InvoicesDashboardController);
})();

(function () {
  'use strict';

  /** @ngInject */
  InvoicesController.$inject = ["$scope", "$uibModal", "invoicesService", "$window", "$location", "customerService", "$state", "ivAuthenticate", "$translate", "storage"];
  function InvoicesController($scope, $uibModal, invoicesService, $window, $location, customerService, $state, ivAuthenticate, $translate, storage) {
    var vm = this;

    // private variables
    var _bInvoiceRemainingState   = false;
    var _aSelectedInvoices        = [];

    // Public variables
    vm.connectionAddresses        = null;
    vm.data                       = null;
    vm.currentToggledDetail       = null;
    vm.currentDetailData          = null;
    vm.amountRemaining            = null;
    vm.csvExportHref              = null;
    vm.yearFilters                = [];
    vm.invoiceAddresses           = {};
    vm.collapseFilter             = true;
    vm.numberOfPayableItems       = 0;

    vm.enableIDEAL                = true;

    vm.corporationAddress         = storage('corporation_address');
    vm.bCorporation               = storage('corporation') || false;

    vm.filterParams = {
      page: 1,
      limit: 10
    };

    // Public function definitions
    vm.toggleDetail     = toggleDetail;
    vm.openPDF          = openPDF;
    vm.openCSV          = openCSV;
    vm.calculateAmount  = calculateAmount;
    vm.changePage       = changePage;
    vm.filter           = filter;
    vm.doPayment        = doPayment;

    // Public functions
    function toggleDetail(id, bGetDetailedInfo) {
      vm.currentDetailData  = null;
      if (vm.currentToggledDetail === id) {
        vm.currentToggledDetail = null;
      } else {
        if(bGetDetailedInfo === true){
          invoicesService.getInvoiceDetail(id).then(function (response) {
            vm.currentDetailData = response;
          });
        }
        vm.currentToggledDetail = id;
      }
    }

    function openPDF(url) {
      var pdfWindow = $window.open('about:blank', '_blank');
      pdfWindow.location.href = url + '?access_token=' + ivAuthenticate.getAccessToken();
    }

    function openCSV() {
      $window.location.href = vm.csvExportHref;
    }

    function calculateAmount(invoice, index) {

      // 20171121 - rob@ivengi.com - Disabled on clients request
      // for(var i = 0; i < vm.data.length; i++) {
      //   if(i > index) {
      //     vm.data[i].selected = false;
      //   }
      // }

      if (invoice.selected) {
        _aSelectedInvoices.push(invoice.invoice_id);
      } else {
        var index = _aSelectedInvoices.indexOf(invoice.invoice_id);
        _aSelectedInvoices.splice(index, 1);
      }

      vm.amountRemaining = 0;
      angular.forEach(vm.data, function (item) {
        if (item.amount_remaining > 0 && item.selected) {
          vm.amountRemaining += item.amount_remaining;
        }
      });
    }

    function filter() {
      vm.filterParams.page  = 1;
      vm.amountRemaining    = 0;
      getInvoices();
    }

    function doPayment() {
      invoicesService.startPayment(_aSelectedInvoices).then(function(result) {
        if(angular.isDefined(result.redirect_url)) {
          $window.location.href = result.redirect_url;
        }
      });
    }

    function changePage() {
      getInvoices();
    }

    // Private functions
    function getInvoices() {
      invoicesService.getInvoices(vm.filterParams).then(function (response) {
        vm.yearFilters    = (response.meta.years.length > vm.yearFilters.length) ? response.meta.years : vm.yearFilters;
        vm.data           = response;
        vm.csvExportHref  = response.meta.export.csv + '&access_token=' + ivAuthenticate.getAccessToken();

        // Keep track of possible payable invoices. If none found, disable iDeal
        for(var i = 0; i < vm.data.length; i += 1) {
          if(vm.data[i].selectable === true) {
            vm.numberOfPayableItems += 1;
            vm.data[i].selected = true;
            vm.calculateAmount(vm.data[i], i);
          }
        }
        if(vm.numberOfPayableItems === 0) {
          vm.enableIDEAL = false;
        }

        if(storage('customer_number')) {
          vm.csvExportHref = vm.csvExportHref + '&customer=' + storage('customer_number');
        }
      });
    }

    function getAddresses() {
      customerService.getPremises({inactive: 1, unique_addresses: 1}).then(getAddressesSuccess);
    }

    function getAddressesSuccess(response) {
      vm.connectionAddresses = response.map(function(item) {
        var option = {};
        option.label = formatAddressString(item);
        option.value = item.address.address_no;

        return option;
      });

      // Set invoice address, used in tooltip when hovering invoices
      angular.forEach(response,function (item) {
        if(angular.isUndefined(vm.invoiceAddresses[item.address.address_no])){
          vm.invoiceAddresses[item.address.address_no] = formatAddressString(item);
        }
      });

      var availableAddressNumbers = vm.connectionAddresses.map(function(item) {
        return item.value;
      });

      vm.connectionAddresses.push({
        label : $translate.instant('general.remaining'),
        value : 'not:' + availableAddressNumbers.join(',')
      });

      if(angular.isDefined(vm.connectionAddresses[0])){
        if(vm.connectionAddresses.length === 1){
          vm.filterParams.address_number = vm.connectionAddresses[0].value;
          filter();
        }
      }

      // if(angular.isDefined(vm.connectionAddresses[0]) && !_bInvoiceRemainingState){ todo _bInvoiceRemainingState still needed?
      //   //vm.filterParams.address_number = vm.connectionAddresses[0].value;
      //   filter();
      // }

      getInvoices();
    }

    function formatAddressString(item){
      if (angular.isDefined(item.address.house_no_addition) && item.address.house_no_addition.length) {
        return item.address.street + ' ' + item.address.house_no + ' ' + item.address.house_no_addition + ', ' + item.address.city;
      } else {
        return item.address.street + ' ' + item.address.house_no + ', ' + item.address.city;
      }
    }

    function formatCorporationAddressString(item){
      if (angular.isDefined(item.house_number_addition) && item.house_number_addition.length) {
        return item.street + ' ' + item.house_number + ' ' + item.house_number_addition + ', ' + item.city;
      } else {
        return item.street + ' ' + item.house_number + ', ' + item.city;
      }
    }

    activate();

    function activate() {
      if(angular.isDefined($state.current.name) && $state.current.name === "invoicesRemaining") {
        _bInvoiceRemainingState = true;
        vm.filterParams.outstanding = 1;
        vm.filterParams.limit = 1000;
      }

      if(storage('corporation') && angular.isObject(storage('corporation_address'))) {
        vm.filterParams.address_number = vm.corporationAddress.address_number;
        vm.invoiceAddresses[vm.corporationAddress.address_number] = formatCorporationAddressString(vm.corporationAddress);
        getInvoices();

        vm.connectionAddresses = [{
          label: vm.invoiceAddresses[vm.corporationAddress.address_number],
          value: vm.corporationAddress.address_number
        }, {
          label: $translate.instant('general.remaining'),
          value: 'not:' + vm.corporationAddress.address_number
        }];
      } else {
        var paymentId = angular.copy($location.search().id);
        if(paymentId && paymentId.length) {
          $location.search('id', '');
          invoicesService.getProcessPaymentStatus(paymentId).then(function(response) {
            var modalScope = $scope.$new();
            modalScope.response = response;
            modalScope.modal = $uibModal.open({
              templateUrl   : 'app/components/invoices/partials/payment-status.partial.html',
              scope         : modalScope,
              size          : 'lg'
            });
            getAddresses();
          }, function() {
            getAddresses();
          });
        } else {
          getAddresses();
        }
      }
    }
  }

  angular
    .module('wml.portal.invoices')
    .controller('InvoicesController', InvoicesController);
})();

(function() {
  'use strict';

  /** @ngInject */
  HomeController.$inject = ["navigationService", "incidentService", "homeService", "cmsService", "$rootScope", "$window"];
  function HomeController(navigationService, incidentService, homeService, cmsService, $rootScope, $window) {
    var vm  = this;
    vm.newsItems = {};
    vm.newsItemsLength = 0;

    // methods
    vm.showIncidents = showIncidents;
    vm.openWebsite = openWebsite;

    navigationService.load();

    incidentService.load().then(function(response) {
      vm.incidents  = response;
    });

    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    homeService.getData().then(function(response){
      var aNewsItems = [];
      for (var prop in response.news.ContentItems) {
        if (response.news.ContentItems.hasOwnProperty(prop)) {
          aNewsItems.push(response.news.ContentItems[prop])
        }
      }

      vm.newsItemsLength = aNewsItems.length;

      if(vm.newsItemsLength){
        aNewsItems.sort(function(a,b){
          return new Date(b.time.UnixTime) - new Date(a.time.UnixTime);
        });
        vm.newsItems = aNewsItems;
      }

      cmsService.setSEO(response);
    });

    function showIncidents() {
      $window.open('https://www.waterstoring.nl/wml', '_blank');
    }

    function openWebsite() {
      $window.open('https://www.wml.nl/thuis/veelgestelde-vragen/storing', '_blank');
    }

  }

  angular
    .module('wml.portal.home')
    .controller('HomeController', HomeController);
})();

(function () {
  'use strict';

  /** @ngInject */
  HeaderSwitchController.$inject = ["$rootScope", "$uibModal", "$scope", "$window", "storage", "$state", "ivAuthenticate"];
  function HeaderSwitchController($rootScope, $uibModal, $scope, $window, storage, $state, ivAuthenticate) {
    var vm = this;
    // private variables

    // Public variables
    vm.isInsecureState = ivAuthenticate.isInsecureState($state.current.name);
    vm.isShortTermState = ivAuthenticate.isShortTermState($state.current.name);
    vm.bAuthenticated = false;
    vm.headerType = null;

    // Public function definitions

    activate();

    function activate() {
      // 1. check if homepage. need home header
      if ($state.current.name === 'home') {
        vm.headerType = 'homeHeader';
      } else {
        // 2. check if authenticated
        if (ivAuthenticate.isAuthenticated()) {
          // 3. need portal.header
          vm.headerType = 'portalHeader';
          vm.bAuthenticated = true;
        } else {
          // 3. need main.header
          vm.headerType = 'mainHeader';
          vm.bAuthenticated = false;
        }
      }
    }
  }

  angular
    .module('wml.portal.header')
    .controller('HeaderSwitchController', HeaderSwitchController);
})();

(function() {
  'use strict';

  /** @ngInject */
  PortalHeaderController.$inject = ["$state", "$rootScope", "$window", "customerService", "storage", "ivAuthenticate", "incidentService", "navigationService", "breadcrumbs", "headerService", "$location"];
  function PortalHeaderController($state, $rootScope, $window, customerService, storage, ivAuthenticate, incidentService, navigationService, breadcrumbs, headerService, $location) {
    var vm  = this;
    // private variables

    // Public variables
    vm.customers                = null;
    vm.currentCustomer          = null;
    vm.isNavCollapsed           = true;
    vm.isCompany                = false;
    vm.breadcrumbs              = breadcrumbs.getPath();
    vm.headerContent            = null;
    vm.currentState             = $state.current.name;
    vm.searchLink               = $state.href("search");
    vm.searchQuery              = '';
    vm.bCorporation             = storage('corporation') || false;

    // Public function definitions
    vm.changeCustomer = changeCustomer;
    vm.logout         = logout;
    vm.showIncidents  = showIncidents;
    vm.goToIncident   = goToIncident;
    vm.search         = search;

    navigationService.load();

    // Public functions
    function search(){
      $location.url(vm.searchLink).search('q',vm.searchQuery);
    }

    function changeCustomer(customerNumber) {
      storage('customer_number', customerNumber);
      $state.go('dashboard');
    }

    function logout() {
      ivAuthenticate.logout().then(function() {
        $rootScope.$broadcast('clear-cache');
        $window.location.href = $state.href('login');
      });
    }

    // Private functions
    function getCustomers() {
      customerService.getCustomers().then(getCustomersSuccess, function() {
        vm.bAuthenticated = false;
      });
    }

    function getCustomersSuccess(response) {
      vm.customers = response;

      var currentCustomerNumber = storage('customer_number');

      vm.currentCustomer = _.find(vm.customers, function(item){
        return item.customer_number === currentCustomerNumber;
      });

      if(vm.currentCustomer.is_company === true){
        vm.isCompany        = true;
      }
    }
    activate();

    function activate(){
      headerService.loadData().then(function(response){
        vm.headerContent = response;
      });

      if(ivAuthenticate.isAuthenticated()){
        vm.bAuthenticated = true;
        getCustomers();
      } else {
        vm.bAuthenticated = false;
      }
      incidentService.load().then(handleIncidents);
    }

    function handleIncidents(response) {
      vm.incidents  = response;
    }

    function showIncidents() {
      $window.open('https://www.waterstoring.nl/wml', '_blank');
    }

    function goToIncident(link) {
      $window.open(link, '_blank');
    }
  }

  angular
    .module('wml.portal.header')
    .controller('PortalHeaderController', PortalHeaderController);
})();

(function() {
  'use strict';

  /** @ngInject */
  HeaderMainController.$inject = ["$rootScope", "$uibModal", "$scope", "$window", "storage", "$state", "ivAuthenticate", "customerService", "navigationService", "incidentService", "headerService", "$location"];
  function HeaderMainController($rootScope, $uibModal, $scope, $window, storage, $state, ivAuthenticate, customerService, navigationService, incidentService, headerService, $location) {
    var vm  = this;
    // private variables

    // Public variables
    vm.customers            = null;
    vm.currentCustomer      = null;
    vm.isNavCollapsed       = true;
    vm.isSearchCollapsed    = true;
    vm.isInsecureState      = ivAuthenticate.isInsecureState($state.current.name);
    vm.isShortTermState     = ivAuthenticate.isShortTermState($state.current.name);
    vm.meterReadingForm     = null;
    vm.meterReadingData     = {};
    vm.headerContent        = null;
    vm.menuItems            = navigationService.getMenu.header;
    vm.searchLink           = $state.href("search");
    vm.searchQuery          = '';
    vm.bCorporation         = storage('corporation') || false;
    vm.activeSlide          = 0;
    vm.intervalSlide        = 6000;

    // Public function definitions
    vm.changeCustomer     = changeCustomer;
    vm.logout             = logout;
    vm.showIncidents      = showIncidents;
    vm.goToIncident       = goToIncident;
    vm.goToMeterReading   = goToMeterReading;
    vm.search             = search;
    vm.getMenuItems       = getMenuItems;
    vm.openVideoModal     = openVideoModal;

    function openVideoModal(videoUrl){
      vm.intervalSlide = -1;

      $scope.modal  = vm;
      $scope.videoUrl  = videoUrl;

      vm.videoModal = $uibModal.open({
        templateUrl: 'app/components/header/views/partials/video.modal.partial.html',
        scope: $scope,
        size: 'lg',
        windowTopClass: 'video-modal'
      });

      vm.videoModal.result.then(function(){
        vm.intervalSlide = 6000;
      }, function(){
        vm.intervalSlide = 6000;
      })
    }

    function getMenuItems() {
      return vm.menuItems.filter(function(item) {
          return (parseInt(item.parent, 10) === 0 && item.bVisible && item.type !== 'detail' && item.name);
      });
    }

    function search(){
      $location.url(vm.searchLink).hash('q='+ vm.searchQuery);
    }


    function goToMeterReading (){
      var _number = '';
      if(angular.isDefined(vm.meterReadingData.num1)){ _number += vm.meterReadingData.num1; }
      if(angular.isDefined(vm.meterReadingData.num2)){ _number += vm.meterReadingData.num2; }
      if(angular.isDefined(vm.meterReadingData.num3)){ _number += vm.meterReadingData.num3; }
      if(angular.isDefined(vm.meterReadingData.num4)){ _number += vm.meterReadingData.num4; }
      if(angular.isDefined(vm.meterReadingData.num5)){ _number += vm.meterReadingData.num5; }

      $state.go('meterReadingExtReading', { meter_reading: _number})
    }

    navigationService.load();


    // Public functions
    function changeCustomer(customerNumber) {
      storage('customer_number', customerNumber);
      $state.go('dashboard');
    }

    function logout() {
      ivAuthenticate.logout().then(function() {
        $rootScope.$broadcast('clear-cache');
        $window.location.href = $state.href('login');
      });
    }

    // Private functions
    function getCustomers() {
      customerService.getCustomers().then(getCustomersSuccess, function() {
        vm.bAuthenticated = false;
      });
    }

    function getCustomersSuccess(response) {
      vm.customers = response;

      var currentCustomerNumber = storage('customer_number');

      vm.currentCustomer = _.find(vm.customers, function(item){
        return item.customer_number === currentCustomerNumber;
      });
    }
    activate();

    function activate(){
      headerService.loadData().then(function(response){
        vm.headerContent = response;
      });



      if(ivAuthenticate.isAuthenticated()){
        vm.bAuthenticated = true;
        getCustomers();
      } else {
        vm.bAuthenticated = false;
      }

      incidentService.load().then(handleIncidents);
    }

    function handleIncidents(response) {
      vm.incidents  = response;
    }

    function showIncidents() {
      $window.open('https://www.waterstoring.nl/wml', '_blank');
    }

    function goToIncident(link) {
      $window.open(link, '_blank');
    }
  }

  angular
    .module('wml.portal.header')
    .controller('HeaderMainController', HeaderMainController);
})();

(function() {
  'use strict';

  /** @ngInject */
  FooterController.$inject = ["appInfoService", "registry", "footerService"];
  function FooterController(appInfoService, registry, footerService) {
    var vm  = this;

    vm.displayVersioning  = (registry.developmentMode || registry.testingMode);
    vm.apiInfo            = null;
    vm.frontendInfo       = null;
    vm.data               = null;

    footerService.loadData().then(function(response){
      vm.data = response.plain();
    });

    appInfoService.getApiInfo().then(function(response) {
      vm.apiInfo  = response;
    });

    appInfoService.getFrontendInfo().then(function(response) {
      vm.frontendInfo  = response.data;
    });
  }

  angular
    .module('wml.portal.footer')
    .controller('FooterController', FooterController);
})();

(function() {
  'use strict';

  /** @ngInject */
  FaqController.$inject = ["$state", "faqService"];
  function FaqController($state, faqService) {
    var vm  = this;
    // private variables

    // Public variables
    vm.bShowOtherQuestionsBlock   = false;
    vm.faqList                    = [];

    // Public function definitions

    // Public functions


    // Private functions
    function getFaqsFromURI(){
      //set stateName to filter FAQs
      var stateName = $state.current.name;

      //call service function to get FAQs
      faqService.getFaqs().then(function(response){
        vm.faqList = response.Faqs.filter(function(item) {
          return (item.states.indexOf(stateName) !== -1);
        });

      });
    }

    activate();

    function activate(){
      getFaqsFromURI();

      if(angular.isDefined($state.current.data) && angular.isDefined($state.current.data.bShowOtherQuestionsBlock)){
        vm.bShowOtherQuestionsBlock = $state.current.data.bShowOtherQuestionsBlock;
      } else {
        vm.bShowOtherQuestionsBlock = true;
      }
    }
  }

  angular
    .module('wml.portal.faq')
    .controller('FaqController', FaqController);
})();

(function() {
  'use strict';

  /** @ngInject */
  DetailPageController.$inject = ["$scope", "$state", "cmsService", "$interval", "$rootScope", "detailService", "newsService", "Restangular", "vcRecaptchaService", "$timeout"];
  function DetailPageController($scope, $state, cmsService, $interval, $rootScope, detailService, newsService, Restangular, vcRecaptchaService, $timeout) {
    var vm  = this;
    vm.bottomBlock = {};

    // public variables
    vm.sendingData = false;
    vm.form        = null;
    vm.formData    = {};
    vm.photoSubNav = [];
    vm.conversionItems = [];
    vm.showSocial = true;

    // public functions
    vm.send   = send;
    vm.afterSend = afterSend;
    vm._getCmsData = _getCmsData;
    vm._getContent = _getContent;

    function _getCmsData() {
      cmsService.loadData().then(function (data) {
        vm.data = data;

        var showPhotoNav = parseInt(vm.data.Content.show_photo_nav.index, 10) === 1;
        if (showPhotoNav) {
          var photoSubnavPath;
          if (angular.isDefined(vm.data.Content.photo_subnav_path.data)) {
            var pathValue = vm.data.Content.photo_subnav_path.data.trim();
            if (pathValue) {
              photoSubnavPath = pathValue;
            }
          }

          cmsService.loadPhotoSubNav(photoSubnavPath).then(function (childNav) {
            var chunkSize = parseInt(vm.data.Content.photo_nav_columns.index, 10);
            for (var i = 0; i < childNav.length; i += chunkSize) {
              var chunk = childNav.slice(i, i + chunkSize);
              vm.photoSubNav.push(chunk);
            }
          });
        }

        cmsService.setSEO(data);

        $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);

        $timeout(function() {
          var topTapPhones = document.querySelectorAll('.toptap-phone');
          var topTapEmails = document.querySelectorAll('.toptap-email');
          var topTapPhone = (topTapPhones && topTapPhones.length > 0) ? topTapPhones[0] : null;
          var topTapEmail = (topTapEmails && topTapEmails.length > 0) ? topTapEmails[0] : null;

          if (topTapPhone) {
            topTapPhone.addEventListener('click', doLinkedInConversion);
          }

          if (topTapEmail) {
            topTapEmail.addEventListener('click', doLinkedInConversion);
          }
        }, 2000);
      });
    }

    function _getContent() {
      detailService.getBlockContent().then(function(response){
        vm.bottomBlock = response.plain();
      });
    }

    function afterSend() {
      doLinkedInConversion();
    }

    function doLinkedInConversion() {
      if (vm.data && vm.data.Content && vm.data.Content.moduleid && vm.data.Content.moduleid === 387) {
        var linkedInPixelConversion = '<img height="1" width="1" style="display:none;" alt="" src="https://dc.ads.linkedin.com/collect/?pid=993148&conversionId=865508&fmt=gif" />';
        if (vm.conversionItems.indexOf(linkedInPixelConversion) === -1) {
          $timeout(function() {
            vm.conversionItems.push(linkedInPixelConversion);
          }, 0);
        }
      }
    }

    function send(){
      if(vm.form.$valid) {
        vm.sendingData = true;
        newsService.addComment(vm.formData.name, vm.formData.email, vm.formData.message, vm.data.CurrentId)
          .then(function() {
            var d = new Date();

            vm.data.Responses.push({
              name  : {data: vm.formData.name},
              message: {data: vm.formData.message},
              time: {Date: d.getDate() + '-' + (d.getMonth()+1) + '-' + d.getFullYear()}
            });

            vm.form.$setPristine();
            vm.formData.name = null;
            vm.formData.message = null;
            vm.formData.email = null;

          }).finally(function() {
          vm.sendingData  = false;
        });
      }
    }

    function activate() {
      vm.showSocial = $state.current.url.indexOf('/over-wml/werken-bij-wml') !== -1 || $state.current.url.indexOf('/over-wml/nieuws') !== -1;

      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

      vm._getCmsData();
      vm._getContent();
    }

    activate();
  }

  angular
    .module('wml.portal.detailPage')
    .controller('DetailPageController', DetailPageController);
})();

(function() {
  'use strict';

  /** @ngInject */
  DashboardController.$inject = ["$state", "$stateParams", "$uibModal", "$scope", "appointmentService", "customerService", "meterReadingService", "profileService", "invoicesService", "usageChartService", "billingInformationService", "contactPersonService", "storage", "corporationService", "ivAuthenticate", "$window"];
  function DashboardController($state, $stateParams, $uibModal, $scope, appointmentService, customerService, meterReadingService, profileService, invoicesService, usageChartService, billingInformationService, contactPersonService, storage, corporationService, ivAuthenticate, $window) {
    var vm  = this;
    // private variables
    var _unplannedMSA  =  [];
    var _meterReadings =  [];

    // Public variables
    vm.bShowMSAUnplannedButton  = false;
    vm.bShowMSAplannedButton    = false;
    vm.plannedMSA               = [];
    vm.personal                 = {};
    vm.profile                  = {};
    vm.correspondenceAddress    = [];
    vm.bShowMeterReadingButton  = false;
    vm.accountBalance           = [];
    vm.connectionAddresses      = [];
    vm.multipleCustomerNumbers  = false;
    vm.draft                    = {};

    vm.chartExtraConfig             = usageChartService.chartExtraConfig;
    vm.chartConfig                  = usageChartService.getConfig;
    vm.chartConfig.yAxis.plotLines  = [];

    vm.filterParams = {
      page: 1,
      limit: 5
    };

    vm.corporationAddress = storage('corporation_address');

    // Public function definitions
    vm.openMSAModal             = openMSAModal;
    vm.openPlannedMSA           = openPlannedMSA;
    vm.deletePlannedMSA         = deletePlannedMSA;
    vm.openMeterReadingsModal   = openMeterReadingsModal;
    vm.changeChart              = changeChart;
    vm.openPDF                  = openPDF;

    // Public functions
    function changeChart(){
      usageChartService.getConsumption(vm.chartExtraConfig.selectedChartAddress);
    }

    function openMSAModal(){
      if(angular.isArray(_unplannedMSA) && _unplannedMSA.length > 1){
        vm.msaConnectionAddresses = _unplannedMSA;
        vm.msaModal = $uibModal.open({
          templateUrl: 'app/components/dashboard/partials/connection-addresses.modal.partial.html',
          scope: $scope,
          size: 'lg'
        });

        vm.msaModal.result.then(function(data){
          goToMSA(data)
        });
      } else {
        var data = {service_number:_unplannedMSA[0].notify_no, postal_code : _unplannedMSA[0].address.postal_code};
        goToMSA(data)
      }
    }

    function openPlannedMSA(data) {
      data.action = 'update';
      goToMSA(data);
    }

    function openMeterReadingsModal() {
      vm.meterReadings = _meterReadings;

      if(angular.isObject(vm.meterReadings) && vm.meterReadings.length > 1){
        $scope.modal  = vm;
        vm.meterReadingsModal = $uibModal.open({
          templateUrl   : 'app/components/usage/partials/meter-readings.modal.partial.html',
          scope         : $scope,
          size          : 'lg'
        });

        vm.meterReadingsModal.result.then(function(params){
          $state.go('meterReadingRecording', params)
        });
      } else {
        var params = {assignment_number: vm.meterReadings[0].assignment_number, postal_code: vm.meterReadings[0].device.address.postal_code};
        $state.go('meterReadingRecording', params)
      }
    }

    // Private functions
    function checkMSA(){
      appointmentService.getAppointments().then(getMSASuccess);
    }

    function getMSASuccess(response) {
      if(response.length > 0){
        // Only use Z6 type appointments for the green banner to schedule. These are AMV appointments.
        _unplannedMSA = response.filter(function(item){
          return item.is_scheduled === false && item.notify_type === 'Z6';
        });

        vm.plannedMSA = response.filter(function(item){
          return item.is_scheduled === true;
        });

        if(_unplannedMSA.length > 0){
          vm.bShowMSAUnplannedButton = true;
        } else {
          vm.bShowMSAUnplannedButton = false;
        }

        if(vm.plannedMSA.length > 0){
          vm.bShowMSAplannedButton = true;
        } else {
          vm.bShowMSAplannedButton = false;
        }
      }
    }

    function goToMSA(data) {
      if (appointmentService.clearAppointment()) {
        appointmentService.verifyAppointment(data).then(function () {
          if (data.action === 'update') {
            $state.go('appointmentEmailUpdate');
          } else {
            $state.go('appointmentEmailCreate');
          }
        });
      }
    }

    // unschedule: notifno, begtstmp endtstmp
    function deletePlannedMSA(data) {
      if (appointmentService.clearAppointment()) {
        appointmentService.verifyAppointment(data).then(function () {
          $state.go('appointmentEmailDelete');
        });
      }
    }

    function checkMeterReadings() {
      meterReadingService.getMeterReadings().then(getMeterReadingsSuccess);
    }

    function getMeterReadingsSuccess(response) {
      _meterReadings = response;
      if(angular.isArray(_meterReadings) && _meterReadings.length > 0){
        vm.bShowMeterReadingButton = true;
      }
    }

    function getCustomer(){
      customerService.getCustomer().then(getCustomerSuccess)
    }

    function getCustomers() {
      customerService.getCustomers().then(function(response) {
        if(response.length > 1) {
          vm.multipleCustomerNumbers  = true;
        }
      });
    }

    function getCustomerSuccess(response) {
      // Store the export url in this success handler to make sure a valid access token is fetched in the service.
      vm.downloadPremiseCsvUrl  = corporationService.getCsvExportUrl();

      vm.personal = response;
       profileService.getProfile().then(function (response) {
         vm.profile = response;
      });

      if(storage('corporation')){
        contactPersonService.getAdministrationContactPerson().then(function(data) {
          vm.billing_email  = data.email.correspondence;

          var updatedRecords  = contactPersonService.getUpdated();
          for(var key in updatedRecords) {
            if(updatedRecords[key].relation_type === 'administration') {
              vm.contactPersonData['administration']  = updatedRecords[key];
              if(angular.isString(updatedRecords[key].email)){
                vm.billing_email  = updatedRecords[key].email;
              }
              if(angular.isObject(updatedRecords[key].email) && angular.isString(updatedRecords[key].email.correspondence)){
                vm.billing_email  = updatedRecords[key].email.correspondence;
              }
            }
          }
        });
      }
    }

    function getAddresses() {
      customerService.getAddresses();
      customerService.getAddress().then(getAddressesSuccess);
    }

    function getAddressesSuccess(response) {
      vm.correspondenceAddress = response;
    }

    function getAccountBalance(){
      invoicesService.getAccountBalance().then(function(response){
        vm.accountBalance = response;
      });
    }

    function getPremises() {
      customerService.getPremises().then(getPremisesSuccess);
    }

    function getPremisesSuccess(response) {
      if(response.length <= 2){
        vm.connectionAddresses = response;
      }

      usageChartService.initChart(response);
    }

    function getSendControl() {
      billingInformationService.getSendControl().then(getSendControlSuccess);
    }

    function getSendControlSuccess(response) {
      vm.billing_information  = response;
    }

    function getInvoices() {
      var filterParams = angular.copy(vm.filterParams);
      filterParams.outstanding = 0;
      filterParams.document_types = ['PA'].join(',');
      filterParams.address_number = vm.corporationAddress.address_number;
      invoicesService.getInvoices(filterParams).then(function(response){
        vm.invoices = response;
      });
    }

    function getRemainingInvoices() {
      var filterParams = angular.copy(vm.filterParams);
      filterParams.outstanding = 1;
      filterParams.address_number = vm.corporationAddress.address_number;
      invoicesService.getInvoices(filterParams).then(function(response){
        vm.remainingInvoices = response;
      });
    }

    function openPDF(url) {
      var pdfWindow = $window.open('about:blank', '_blank');
      pdfWindow.location.href = url + '?access_token=' + ivAuthenticate.getAccessToken();
    }

    activate();

    function activate(){
      if(storage('corporation') && angular.isObject(storage('corporation_address'))) {
        vm.downloadPremiseCsvUrl  = corporationService.getCsvExportUrl();
        getCustomer();
        getCustomers();
        getSendControl();
        getInvoices();
        getRemainingInvoices();
      } else {
        getCustomer();
        getCustomers();
        checkMSA();
        checkMeterReadings();
        getAddresses();
        getAccountBalance();
        getPremises();
      }
    }
  }

  angular
    .module('wml.portal.dashboard')
    .controller('DashboardController', DashboardController);
})();

(function(){
  'use strict';

  damageFormController.$inject = ["detailService", "cmsService", "$rootScope", "damageFormService", "Upload", "registry"];
  function damageFormController(detailService, cmsService, $rootScope, damageFormService, Upload, registry) {
    var vm = this;

    //public variables
    vm.formData     = damageFormService.data;
    vm.showForm     = true;
    vm.invalidFiles = null;

    //public function
    $rootScope.$broadcast('readspeaker.readclass', '');

    vm.addDamagedItem = addDamagedItem;
    vm.sendForm       = sendForm;
    vm.removeRow      = removeRow;

    cmsService.loadData().then(function(data) {
      vm.data = data;

      cmsService.setSEO(data);

      $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);
    });

    detailService.getBlockContent().then(function(response){
      vm.bottomBlock = response.plain();
    });

    function addDamagedItem(){

      vm.formData.damagedItems.push({
        description      : '',
        purchase_date    : '',
        purchase_price   : '',
        day_value        : '',
        estimated_damage : ''
      });
    }

    function removeRow(index){
      if(index > 0){
        vm.formData.damagedItems.splice(index, 1);
      }
    }

    function sendForm(){

      if(vm.form.$valid){
        Upload.upload({
          url: registry.restApiUrl+'/form/damage',
          data : vm.formData
        }).then(function(response){
          vm.showForm = false;
          $rootScope.$broadcast('wml.portal.message', response.data);
          damageFormService.clearData();
        },function(error){
          throw new Error('damage form error:', error);
        })
      }
    }

  }
  angular
    .module('wml.portal.damage-form')
    .controller('damageFormController', damageFormController);
})();

(function() {
  'use strict';

  /** @ngInject */
  CustomerEditController.$inject = ["$rootScope", "$scope", "customerService", "contactPersonService", "enumService", "billingInformationService", "$filter", "moment", "$state", "$timeout"];
  function CustomerEditController($rootScope, $scope, customerService, contactPersonService, enumService, billingInformationService, $filter, moment, $state, $timeout) {
    var vm  = this;

    // private variables
    var SEND_CONTROL  = {
      MAIL    : 0,
      DIGITAL : 3
    };

    // Public variables
    vm.data                       = {};
    vm.form                       = null;
    vm.salutations                = [];
    vm.dateNow                    = moment().subtract(18, 'years').format('DD-MM-YYYY');
    vm.sendingData                = false;
    vm.contactPersonData          = {general: false, administration: false, incidents: false, newsletter: false};

    // Public function definitions
    vm.save   = save;
    vm.cancel = cancel;

    // Public functions
    function save(){
      vm.form.$commitViewValue();
      if(vm.form.$valid) {
        vm.sendingData  = true;

        vm.data.email.update_account_email = Boolean(vm.data.email.update_account_email);

        vm.data.save().then(function(response) {
          $rootScope.$broadcast('clear-cache', {customer : {customer: true}});

          billingInformationService.updateSendControl(vm.data.sendcontrol).then(function(response) {
            $state.go('customerSaved');
            vm.sendingData = false;
            return response;
          });

          return response;
        }).finally(function () {
          vm.sendingData = false;
        });
      }
    }

    function cancel(){
      $rootScope.$broadcast('clear-cache', {customer : {customer: true}});
      $state.go('customer');
    }

    // Private functions
    function getSalutations () {
      enumService.getSalutations().then(function(data) {
        vm.salutations = data;
      });
    }

    function getCustomer(){
      customerService.getCustomer().then(getCustomerSuccess)
    }

    function getCustomerSuccess(response) {
      response.date_of_birth = $filter('date')(response.date_of_birth, "dd-MM-yyyy");
      vm.data = response;
      $timeout(function() {
        vm.form.$commitViewValue();
      }, 0);

      getSendControlOptions();
      getSendControl();
    }

    function getSendControlOptions() {
      enumService.getSendControl().then(sendControlOptionsSuccess);
    }

    function sendControlOptionsSuccess(response) {
      vm.sendcontrol  = response;
    }

    function getSendControl() {
      billingInformationService.getSendControl().then(sendControlSuccess);
    }

    function sendControlSuccess(response) {
      vm.data.sendcontrol = response.sendcontrol;
    }

    function getAdministrationContactPerson() {
      contactPersonService.getAdministrationContactPerson().then(function(response) {

        vm.data.billing_email = response.email.correspondence;
        vm.data.relation_account_id = response.customer_number;

        var updatedRecords  = contactPersonService.getUpdated();
        for(var key in updatedRecords) {
          if(updatedRecords[key].relation_type === 'administration') {
            vm.contactPersonData['administration']  = updatedRecords[key];
            if(angular.isString(updatedRecords[key].email)){
              vm.data.billing_email  = updatedRecords[key].email;
            }
            if(angular.isObject(updatedRecords[key].email) && angular.isString(updatedRecords[key].email.correspondence)){
              vm.data.billing_email  = updatedRecords[key].email.correspondence;
            }
          }
        }
      });
    }

    activate();

    function activate(){
      getSalutations();
      getCustomer();
      getAdministrationContactPerson();
    }

    var unregister  = $scope.$watch(function() {return vm.data.sendcontrol;}, function(newValue) {
      vm.data.is_digital  = (newValue === SEND_CONTROL.DIGITAL);
      if(vm.data.is_digital === false) {
        vm.data.billing_email = null;
      }
    });

    $scope.$on('$destroy', function() {
      $rootScope.$broadcast('clear-cache', {customer : {customer: true}});
      unregister();
    });
  }

  angular
    .module('wml.portal.customer')
    .controller('CustomerEditController', CustomerEditController);
})();

(function() {
  'use strict';

  /** @ngInject */
  CustomerDashboardController.$inject = ["customerService", "$window", "$state", "$translate", "$rootScope", "enumService", "contactPersonService", "billingInformationService", "premisesService", "registry", "storage", "moment"];
  function CustomerDashboardController(customerService, $window, $state, $translate, $rootScope, enumService, contactPersonService, billingInformationService, premisesService, registry, storage, moment) {

    var vm  = this;

    // private variables
    vm.monthTranslations = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

    // Public variables
    vm.data                       = {};
    vm.insertions                 = null;
    vm.connectionAddresses        = null;
    vm.editDonation               = false;
    vm.changedWflAmount           = 0;
    vm.acknowledgeStopWfl         = false;

    // contacyPersons settings
    vm.contactPersonTypes         = ['general', 'administration', 'incidents', 'newsletter'];
    vm.contactPersonMaxPerType    = {general: 1, administration: 1, incidents: 3, newsletter: 3}; // type: record<contactPersonTypes, number>
    vm.contactPersonModePerType   = {general: false, administration: false, incidents: false, newsletter: false}; // TODO enum. VIEW EDIT ADD; type: record<contactPersonTypes, contactPersonMode[]>
    vm.contactPersonAvailability  = {general: false, administration: false, incidents: false, newsletter: false}; // at least one of type available; type: record<contactPersonTypes, boolean[]>
    vm.contactPersonData          = {general: false, administration: false, incidents: false, newsletter: false}; // the actual contact data; type: record<contactPersonTypes, contactPerson[]>
    vm.contactPersonDataCopy      = {general: [], administration: [], incidents: [], newsletter: []}; // a copy for editing; type: record<contactPersonTypes, contactPerson[]>
    vm.contactPersonSendingData   = {general: false, administration: false, incidents: false, newsletter: false}; // submit form booleans; type: record<contactPersonTypes, boolean[]>
    vm.contactPersonForms         = {general: false, administration: false, incidents: false, newsletter: false}; // forms; type: record<contactPersonTypes, form[]>

    // Public function definitions
    vm.editContactPerson  = editContactPerson;
    vm.downloadPremiseCsv = downloadPremiseCsv;
    vm.goToDatalogger     = goToDatalogger;
    vm.saveContactPerson   = saveContactPerson;
    vm.saveCustomerAccount = saveCustomerAccount;
    vm.cancelContactPerson = cancelContactPerson;
    vm.addContactPerson    = addContactPerson;
    vm.removeContactPerson = removeContactPerson;
    vm.removeContactPersonRow = removeContactPersonRow;
    vm.saveDonationChange = saveDonationChange;

    function saveDonationChange(stop) {
      vm.editDonation = false;
      if (stop) {
        vm.changedWflAmount = 0;
      }
      // only make call if there is a change
      if (vm.changedWflAmount !== vm.data.wfl_amount) {
        vm.data.email.update_account_email = false;
        vm.data.wfl_amount = vm.changedWflAmount;
        vm.data.wfl_month = moment().format('M');
        vm.month = vm.monthTranslations[vm.data.wfl_month - 1];
        vm.data.save().then(function (response) {
          $rootScope.$broadcast('wml.portal.custom_message', {level: 'success', code: '1000'});
          $rootScope.$broadcast('clear-cache', { customer: {customer: true } });
          return response;
        });
      }
    }

    // Public functions
    function addContactPerson(contactPersonType) {
      // check if allowed (max)
      if (!vm.contactPersonData[contactPersonType] || (vm.contactPersonData[contactPersonType].length < vm.contactPersonMaxPerType[contactPersonType])) {
        if (!vm.contactPersonData[contactPersonType]) {
          vm.contactPersonAvailability[contactPersonType] = true;
          vm.contactPersonData[contactPersonType] = [];
          vm.contactPersonModePerType[contactPersonType] = [];
        }
        vm.contactPersonData[contactPersonType].push({});
        vm.contactPersonModePerType[contactPersonType][vm.contactPersonData[contactPersonType].length-1] = 'ADD';
      }
    }

    function editContactPerson(contactPersonType, account, rowIndex) {
      if(angular.isDefined(account) && angular.isObject(account)) {
        vm.contactPersonDataCopy[contactPersonType][rowIndex] = _.cloneDeep(vm.contactPersonData[contactPersonType][rowIndex]);
        vm.contactPersonModePerType[contactPersonType][rowIndex] = 'EDIT';
      }
    }

    function removeContactPerson(contactPersonType, account, rowIndex) {
      var params = { type: contactPersonType };
      if (angular.isDefined(account) && angular.isObject(account)) {
        params.account_id = account.customer_number || account.relation_account_id;
        contactPersonService.remove(params).then(function (data) {
          vm.removeContactPersonRow(contactPersonType, rowIndex);
          $rootScope.$broadcast('clear-cache', {contactperson : {contactperson: true}, customer : {customer: true}});
        }).catch(function () {
          vm.contactPersonModePerType[contactPersonType][rowIndex] = 'VIEW';
        });
      }
    }

    function removeContactPersonRow(contactPersonType, rowIndex) {
      vm.contactPersonData[contactPersonType].splice(rowIndex, 1);
      vm.contactPersonDataCopy[contactPersonType].splice(rowIndex, 1);
      vm.contactPersonModePerType[contactPersonType].splice(rowIndex, 1);
      if (!vm.contactPersonData[contactPersonType].length) {
        vm.contactPersonAvailability[contactPersonType] = false;
        vm.contactPersonData[contactPersonType] = false;
        vm.contactPersonModePerType[contactPersonType] = false;
      }
    }

    function cancelContactPerson(contactPersonType, rowIndex) {
      // edit, set back copy of data
      if (vm.contactPersonModePerType[contactPersonType][rowIndex] === 'EDIT') {
        vm.contactPersonData[contactPersonType][rowIndex] = vm.contactPersonDataCopy[contactPersonType][rowIndex];
        vm.contactPersonModePerType[contactPersonType][rowIndex] = 'VIEW';
      }
      // add, remove temp
      if (vm.contactPersonModePerType[contactPersonType][rowIndex] === 'ADD') {
        vm.removeContactPersonRow(contactPersonType, rowIndex);
      }
    }

    // save general admin contact
    function saveCustomerAccount(contactPersonType, rowIndex) {
      if (vm.contactPersonForms[contactPersonType][rowIndex].$invalid) {
        return;
      }
      if (!angular.isArray(vm.contactPersonSendingData[contactPersonType])) {
        vm.contactPersonSendingData[contactPersonType] = [];
      }
      vm.contactPersonSendingData[contactPersonType][rowIndex] = true;
      vm.data.email.update_account_email = false;
      vm.data.email = vm.contactPersonData[contactPersonType][rowIndex].email || '';
      vm.data.phone = vm.contactPersonData[contactPersonType][rowIndex].phone || '';
      vm.data.mobile_phone = vm.contactPersonData[contactPersonType][rowIndex].mobile_phone || '';
      // customer.edit.controller.js
      vm.data.save().then(function(response) {
        $rootScope.$broadcast('clear-cache', {contactperson : {contactperson: true}, customer : {customer: true}});
        return response;
      }).finally(function () {
        vm.contactPersonModePerType[contactPersonType][rowIndex] = 'VIEW';
        vm.contactPersonSendingData[contactPersonType].splice(rowIndex, 1);
      });
    }

    // save regular contact
    function saveContactPerson(contactPersonType, rowIndex) {
      if (vm.contactPersonForms[contactPersonType][rowIndex].$invalid) {
        return;
      }
      if (!angular.isArray(vm.contactPersonSendingData[contactPersonType])) {
        vm.contactPersonSendingData[contactPersonType] = [];
      }
      vm.contactPersonSendingData[contactPersonType][rowIndex] = true;
      // save row, set to view
      // build object to save
      var contactPerson = {
        account_id  : vm.contactPersonData[contactPersonType][rowIndex].customer_number || vm.contactPersonData[contactPersonType][rowIndex].relation_account_id || null,
        type        : contactPersonType || null,
        firstname   : vm.contactPersonData[contactPersonType][rowIndex].firstname || '',
        insertion   : vm.contactPersonData[contactPersonType][rowIndex].insertion || '',
        lastname    : vm.contactPersonData[contactPersonType][rowIndex].lastname || '',
        email       : vm.contactPersonData[contactPersonType][rowIndex].email.correspondence || '',
        phone       : vm.contactPersonData[contactPersonType][rowIndex].phone || '',
        mobile_phone       : vm.contactPersonData[contactPersonType][rowIndex].mobile_phone || ''
      };
      contactPersonService.save(contactPerson, vm.contactPersonModePerType[contactPersonType][rowIndex]).then(function (data) {
        if (data.fields && data.fields.contact_person) {
          vm.contactPersonData[contactPersonType][rowIndex].name = data.fields.contact_person.name;
          if (contactPerson.account_id) {
            $rootScope.$broadcast('wml.portal.custom_message', {level: 'success', code: '1000'});
            contactPersonService.addUpdate(contactPerson.account_id, data.fields.contact_person);
          } else {
            vm.contactPersonData[contactPersonType][rowIndex].customer_number = data.fields.contact_person.relation_account_id;
            contactPersonService.addUpdate(data.fields.contact_person.relation_account_id, data.fields.contact_person);
          }
        }
        $rootScope.$broadcast('clear-cache', {contactperson : {contactperson: true}, customer : {customer: true}});
      }).finally(function () {
        // stop loader, set row in view mode
        vm.contactPersonModePerType[contactPersonType][rowIndex] = 'VIEW';
        vm.contactPersonSendingData[contactPersonType].splice(rowIndex, 1);
      });
    }

    function goToDatalogger(contractAccountId, contractId) {
      var customerId = storage('customer_number');
      $window.location.href = $window.location.protocol + '//' + registry.hostName + '/data-logger/dashboard?contractAccountId=' + contractAccountId + '&contractId=' + contractId + '&customer=' + customerId;
    }

    function downloadPremiseCsv() {
      $window.location.href = premisesService.getCsvExportUrl();
    }

    // Private functions
    function getCustomer(){
      customerService.getCustomer().then(getCustomerSuccess)
    }

    function getCustomerSuccess(response) {
      vm.data = response;
      vm.month = vm.data.wfl_month ? vm.monthTranslations[Number(vm.data.wfl_month) - 1] : false;
      vm.changedWflAmount = vm.data.wfl_amount || 0;

      if(vm.data.is_company) {
        if(vm.data.contact_persons) {
          // general contact person is used to display the customer account correspondence address
          vm.contactPersonAvailability['general'] = true;
          vm.contactPersonModePerType['general'] = ['VIEW'];
          vm.contactPersonData['general'] = [{
            email: vm.data.email,
            lastname: vm.data.lastname,
            name: vm.data.name,
            phone: vm.data.phone,
            mobile_phone: vm.data.mobile_phone,
          }];
          // store contact person data in array
          for(var i=0; i < vm.data.contact_persons.length; i++) {
            // do not render "general" contact persons.
            // general is replaced by correspondence which is not a contact person but the customer account email
            // show the customer account email in the contact persons section and make it editable
            // if edited it will update the account email and or phone number
            if (vm.data.contact_persons[i].account_relationship_type === 'general') {
              continue;
            }
            // mark type for available
            vm.contactPersonAvailability[vm.data.contact_persons[i].account_relationship_type]  = true;
            // get customer data
            contactPersonService.load(vm.data.contact_persons[i].related_account_id).then(function(data) {
              // store contact person data in array
              if (!angular.isArray(vm.contactPersonData[data.contact_persons[0].account_relationship_type])) {
                vm.contactPersonData[data.contact_persons[0].account_relationship_type] = [];
                vm.contactPersonModePerType[data.contact_persons[0].account_relationship_type] = [];
              }
              vm.contactPersonModePerType[data.contact_persons[0].account_relationship_type].push('VIEW');
              vm.contactPersonData[data.contact_persons[0].account_relationship_type].push(data);
            });
          }
        }
      } else {
        contactPersonService.getAdministrationContactPerson().then(function(data) {
          vm.billing_email  = data.email.correspondence;

          if (!angular.isArray(vm.contactPersonData['administration']) && data.contact_persons && data.contact_persons[0] && data.contact_persons[0].account_relationship_type === 'administration') {
            vm.contactPersonData['administration'] = [data];
            vm.contactPersonModePerType[data.contact_persons[0].account_relationship_type] = ['VIEW'];
          }

          // what it do??
          var updatedRecords  = contactPersonService.getUpdated();
          for(var key in updatedRecords) {
            if(updatedRecords[key].relation_type === 'administration') {
              // todo >> test, need to be array?
              vm.contactPersonData['administration'].push(updatedRecords[key]); // administration can only be 1
              if(angular.isString(updatedRecords[key].email)){
                vm.billing_email  = updatedRecords[key].email;
              }
              if(angular.isObject(updatedRecords[key].email) && angular.isString(updatedRecords[key].email.correspondence)){
                vm.billing_email  = updatedRecords[key].email.correspondence;
              }
            }
          }
        });
      }
    }

    function getPremises() {
      customerService.getPremises().then(getPremiseSuccess);
    }

    function getAddresses() {
      customerService.getAddress().then(getAddressesSuccess);
    }

    function getSendControl() {
      billingInformationService.getSendControl().then(getSendControlSuccess);
    }

    function getPremiseSuccess(response) {
      vm.connectionAddresses = response;
    }

    function getAddressesSuccess(response) {
      vm.correspondenceAddress = response;
    }

    function getSendControlSuccess(response) {
      vm.billing_information  = response;
    }

    activate();

    function activate(){
      getCustomer();
      getPremises();
      getAddresses();
      getSendControl();

      enumService.getInsertions().then(function(data) {
        vm.insertions = data;
      });

      // @TODO-mmy no longer need this? handled in edit func
      if (angular.isDefined($state.current.name) && $state.current.name === "customerSaved") {
        $rootScope.$broadcast('wml.portal.custom_message', {level: 'success', code: '1000'});
      }
    }
  }

  angular
    .module('wml.portal.customer')
    .controller('CustomerDashboardController', CustomerDashboardController);
})();

(function() {
  'use strict';

  angular.module('wml.portal.correspondence', []);

})();

(function() {
  'use strict';

  /** @ngInject */
  CorrespondenceAddressEditController.$inject = ["$scope", "$state", "customerService", "addressService"];
  function CorrespondenceAddressEditController($scope, $state, customerService, addressService) {
    var vm  = this;

    // private variables
    var _currentAddress   = null;
    var _lastAutofill     = null;
    var _lastAutofillPo   = null;

    // Public variables
    vm.form                   = null;
    vm.draft                  = {};
    vm.premises               = [];
    vm.bShowOther             = false;
    vm.sendingData            = false;
    vm.bShowPremisesSelection = true;
    vm.loading                = false;

    // Public function definitions
    vm.autofillHouseNo    = autofillHouseNo;
    vm.autofillPoBox      = autofillPoBox;
    vm.showOther          = showOther;
    vm.save               = save;
    vm.changeCountry      = changeCountry;
    vm.changeType         = changeType;


    // Public functions
    function autofillHouseNo() {
      if(vm.draft.country !== 'NL'){
        return false;
      }

      if(!angular.isString(vm.draft.address_id) && angular.isString(vm.draft.postal_code) && angular.isString(vm.draft.house_no)) {
        vm.draft.postal_code = vm.draft.postal_code.toUpperCase();
        if(/^[0-9]{4}[A-Z]{2}$/.test(vm.draft.postal_code)) {

          var data = {
            postal_code : vm.draft.postal_code,
            house_no : vm.draft.house_no,
            house_no_addition : vm.draft.house_no_addition
          };

          var autofillKey = data.postal_code + '_' + data.house_no;

          if (angular.isString(vm.draft.house_no_addition)) {
            data.house_no_addition = vm.draft.house_no_addition;
            autofillKey = autofillKey + '_' + data.house_no_addition;
          }

          if(autofillKey === _lastAutofill) {
            return false;
          }

          vm.draft.city        = null;
          vm.draft.street      = null;
          vm.loading           = true;

          _lastAutofill = autofillKey;

          autoFill(data);
        }
      }
    }

    function autofillPoBox() {
      if(vm.draft.country !== 'NL'){
        return false;
      }

      if(!angular.isString(vm.draft.address_id) && angular.isString(vm.draft.po_box_postal_code) && angular.isString(vm.draft.po_box)) {
        vm.draft.po_box_postal_code = vm.draft.po_box_postal_code.toUpperCase();
        if(/^[0-9]{4}[A-Z]{2}$/.test(vm.draft.po_box_postal_code)) {

          var data = {
            po_box_postal_code  : vm.draft.po_box_postal_code,
            po_box              : vm.draft.po_box
          };

          var autofillKey = data.po_box_postal_code + '_' + data.po_box;

          if(autofillKey === _lastAutofillPo) {
            return false;
          }

          vm.draft.city        = null;
          vm.loading           = true;

          _lastAutofillPo = autofillKey;

          autoFill(data);
        }
      }
    }

    function showOther(bShowOther){
      vm.bShowOther = bShowOther;
    }

    function save() {
      if(vm.form.$valid) {
        vm.sendingData = true;
        customerService.saveAddress(vm.draft).then(function(){
          customerService.clearAddressCache();
          $state.go('customerSaved');
        }).finally(function(){
          vm.sendingData = false;
        });
      }
    }

    function changeCountry() {
      resetForm();
      if(vm.draft.country !== 'NL'){
        vm.draft.type = 'address';
      } else {
        vm.draft.type = '';
      }
    }

    function changeType() {
      resetForm();
    }

    // Private functions
    function resetForm() {
      _lastAutofillPo = null;
      _lastAutofill   = null;

      vm.draft.postal_code        = null;
      vm.draft.po_box_postal_code = null;
      vm.draft.po_box             = null;
      vm.draft.street             = null;
      vm.draft.house_no           = null;
      vm.draft.house_no_addition  = null;
      vm.draft.city               = null;
    }

    function getPremises() {
      customerService.getPremises().then(getPremiseSuccess);
    }

    function getPremiseSuccess(response) {
      vm.premises = response.filter(function(item){
        var _address = item.address.house_no + item.address.house_no_addition + item.address.postal_code;
        return (_address !== _currentAddress && item.is_correspondence_option);
      });

      if(vm.premises.length === 0){
        vm.bShowPremisesSelection = false;
      }
    }

    function getAddress() {
      customerService.getAddress().then(getAddressesSuccess);
    }

    function getAddressesSuccess(response) {
      vm.correspondenceAddress = response;
      _currentAddress = vm.correspondenceAddress.house_no + vm.correspondenceAddress.house_no_addition + vm.correspondenceAddress.postal_code;
      getPremises();
    }

    function autoFill(data) {
      addressService.autofill(data).then(function(response) {
        var address = angular.copy(response.plain());
        vm.loading  = false;

        if(address.street){
          vm.draft.street = address.street;
        }
        if(address.house_no_addition){
          vm.draft.house_no_addition = address.house_no_addition;
        }
        if(address.city){
          vm.draft.city = address.city;
        }
      });
    }

    activate();

    function activate() {
      resetForm();
      getAddress();

      $scope.$watch(function() {return vm.draft.address_id}, function(newValue) {
        if(angular.isDefined(newValue) && angular.isObject(newValue)) {
          vm.draft.country              = newValue.country;
          vm.draft.city                 = newValue.city;
          vm.draft.postal_code          = newValue.postal_code;
          vm.draft.street               = newValue.street;
          vm.draft.house_no             = newValue.house_no;
          vm.draft.house_no_addition    = newValue.house_no_addition;
        } else {
          resetForm();
        }
      });
    }
  }

  angular.module('wml.portal.correspondence')
    .controller('CorrespondenceAddressEditController', CorrespondenceAddressEditController);

})();




(function() {
  'use strict';

  /** @ngInject */
  ContactPersonFormController.$inject = ["$stateParams", "$state", "$rootScope", "$translate", "enumService", "contactPersonService"];
  function ContactPersonFormController($stateParams, $state, $rootScope, $translate, enumService, contactPersonService) {
    // private variables
    var vm = this;
    var typeMapping = {
      general         : $translate.instant('customer.contact_persons.type.general').toLowerCase(),
      administration  : $translate.instant('customer.contact_persons.type.administration').toLowerCase(),
      incidents       : $translate.instant('customer.contact_persons.type.incidents').toLowerCase(),
      newsletter      : $translate.instant('customer.contact_persons.type.newsletter').toLowerCase()
    };

    // Public variables
    vm.form = null;
    vm.sendingData  = false;
    vm.insertions   = null;
    vm.pageTitle    = null;
    vm.data = {
      account_id  : null,
      type        : null,
      firstname   : null,
      insertion   : null,
      lastname    : null,
      email       : null,
      phone       : null
    };

    if($state.current.name === 'contactPersonAdd'){
      vm.pageTitle = $translate.instant('customer.contact_persons.page_title_add');
    } else {
      vm.pageTitle = $translate.instant('customer.contact_persons.page_title');
    }

    // Public function definitions
    vm.save     = save;

    // Public functions
    function save() {
      if(vm.form.$valid) {
        vm.sendingData  = true;
        contactPersonService.save(vm.data).then(function(data) {
          if(data.fields && data.fields.contact_person) {
            if(vm.data.account_id){
              contactPersonService.addUpdate(vm.data.account_id, data.fields.contact_person);
            } else {
              contactPersonService.addUpdate(data.fields.contact_person.relation_account_id, data.fields.contact_person);
            }
            $rootScope.$broadcast('clear-cache', {customer: {customer: true}});
            $state.go('customer');
          }
        }).finally(function() {
          vm.sendingData  = false;
        });
      }
    }

    // Private functions
    function activate() {
      if($stateParams.account_id) {
        vm.data.account_id  = $stateParams.account_id;
        contactPersonService.load($stateParams.account_id).then(function(response) {
          vm.data.firstname = response.firstname || '';
          vm.data.lastname  = response.lastname || '';
          vm.data.insertion = response.insertion || '';
          vm.data.email     = response.email.correspondence || '';
          vm.data.phone     = response.phone || '';
        });
      }

      for(var key in typeMapping) {
        if(typeMapping[key] === $stateParams.type) {
          vm.data.type  = key;
          break;
        }
      }

      enumService.getInsertions().then(function(data) {
        vm.insertions = data;
      });
    }

    activate();

  }

  angular.module('wml.portal.contactperson')
    .controller('ContactPersonFormController', ContactPersonFormController);

})();

(function() {
  'use strict';

  /** @ngInject */
  ContactThankYouController.$inject = ["ivAuthenticate", "$rootScope"];
  function ContactThankYouController(ivAuthenticate, $rootScope) {
    var vm  = this;
    // private variables

    // Public variables
    vm.bAuthenticated = ivAuthenticate.isAuthenticated();

    // Public function definitions



    // Public functions


    // Private functions

    activate();


    function activate(){
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }

  }

  angular
    .module('wml.portal.contact')
    .controller('ContactThankYouController', ContactThankYouController);
})();

(function() {
  'use strict';

  /** @ngInject */
  ContactController.$inject = ["enumService", "contactFormService", "storage", "$state", "addressService", "customerService", "ivAuthenticate", "$timeout", "$rootScope", "$translate", "Upload", "registry"];
  function ContactController(enumService, contactFormService, storage, $state, addressService, customerService, ivAuthenticate, $timeout, $rootScope, $translate, Upload, registry) {
    var vm = this;
    var isCorporation = storage('corporation') || false;

    vm.bAuthenticated = false;

    // Public variables
    vm.forms = {
      subject: {},
      customer: {},
      contact: {},
    };
    vm.connectionAdresses = null;
    vm.data = {
      premises: {},
      other_address: {
        check: false,
      },
    };
    vm.subjects = null;
    vm.timeBrackets = {
      morning: 'morning',
      afternoon: 'afternoon',
      no_preference: 'no_preference',
    };
    vm.activepart = 1;

    vm.fileToUpload = null;
    vm.loading = false;

    // Public function definitions
    vm.send = send;
    vm.cancel = cancel;
    vm.next = next;
    vm.prev = prev;
    vm.fileChange = fileChange;
    vm.autofillHouseNo = autofillHouseNo;

    function autoFill(data, addressObj) {
      addressService.autofill(data).then(function (response) {
        var address = angular.copy(response.plain());
        addressObj.loading = false;

        if (address.street) {
          addressObj.street = address.street;
        }
        if(address.house_no_addition){
          addressObj.house_no_addition = address.house_no_addition;
        }
        if (address.city) {
          addressObj.city = address.city;
        }
      });
    }

    function autofillHouseNo(addressObj) {
      if(angular.isString(addressObj.postal_code) && angular.isString(addressObj.house_no)) {
        addressObj.postal_code = addressObj.postal_code.toUpperCase();

        if(/^[0-9]{4}[A-Z]{2}$/.test(addressObj.postal_code)) {

          var data = {
            postal_code : addressObj.postal_code,
            house_no    : addressObj.house_no
          };

          var autofillKey = data.postal_code + '_' + data.house_no;

          if (angular.isString(addressObj.house_no_addition) && addressObj.house_no_addition.length > 0) {
            data.house_no_addition = addressObj.house_no_addition;
            autofillKey = autofillKey + '_' + addressObj.house_no_addition;
          }

          if (autofillKey === addressObj._lastAutofill) {
            return false;
          }

          addressObj.city = null;
          addressObj.street = null;
          addressObj.loading = true;

          addressObj._lastAutofill = autofillKey;

          autoFill(data, addressObj);
        }
      }
    }

    // Public functions
    function fileChange(file, errFiles) {
      $rootScope.$broadcast('wml.portal.message.cancel');
      if (errFiles.length > 0) {
        if (errFiles[0].$error === "maxSize") {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 27000});
        } else {
          $rootScope.$broadcast('wml.portal.message', {level: 'error', code: 27001});
        }
      }
      if (file) {
        vm.fileToUpload = file;
      }
    }

    function send() {
      $rootScope.$broadcast('wml.portal.message.cancel');
      if (vm.forms.subject.$valid && vm.forms.customer.$valid && vm.forms.contact.$valid) {
        Upload.base64DataUrl(vm.fileToUpload)
          .then(function (dataUrl) {
            if (dataUrl) {
              vm.data.file_upload = dataUrl;
              vm.data.file_type = vm.fileToUpload.type;
              vm.data.file_name = vm.fileToUpload.name;
            }
          })
          .finally(function () {
            var subjectType = vm.subjects[vm.data.contact_type].webContactType;
            var subjectReason = (vm.data.contact_reason)
              ? ': ' + vm.subjects[vm.data.contact_type].contactReasons[vm.data.contact_reason]
              : '';
            vm.data.subject = subjectType + subjectReason;
            contactFormService.send(vm.data).then(function (data) {
              $state.go('contactThankYou');
            });
          });
      }
    }

    function cancel() {
      $state.go('home');
    }

    function prev() {
      vm.activepart = vm.activepart - 1;
      $rootScope.$broadcast('wml.portal.message.cancel');
    }

    function next(form) {
      if (vm.forms[form].$valid) {
        if (vm.activepart === 2 && vm.data.customer_number && vm.connectionAdresses && vm.connectionAdresses.length) {
          contactFormService.getCustomer(vm.data.customer_number, vm.data.premises.house_no, vm.data.premises.house_no_addition, vm.data.premises.postal_code).then(function () {
            nextAction(true);
          });
        } else {
          nextAction(true);
        }
      } else {
        nextAction(false);
      }
    }
    function nextAction(next) {
      if (next) {
        vm.activepart = vm.activepart + 1;
      }
      $rootScope.$broadcast('wml.portal.message.cancel');
    }

    function translateTimeBrackets() {
      var timeBracketKeys = Object.keys(vm.timeBrackets);

      timeBracketKeys.forEach(function (bracketKey) {
        vm.timeBrackets[bracketKey] = $translate.instant('contact.time_bracket.' + vm.timeBrackets[bracketKey]);
      });
      timeBracketKeys.sort(function (a, b) {
        if (vm.timeBrackets[a] < vm.timeBrackets[b]) return -1;
        if (vm.timeBrackets[a] > vm.timeBrackets[b]) return 1;
        return 0;
      });
    }

    function getSubjects() {
      contactFormService.getContactTypes().then(function (data) {
        if (!data) { return; }
        data = data.plain();
        var subjects = angular.copy(data);

        var subjectKeys = Object.keys(subjects);

        // second level sort
        subjectKeys.forEach(function (key) {
          if (!subjects[key].contactReasons) { return; }
          return Object.keys(subjects[key].contactReasons).sort(function(a, b) {
            if (subjects[key].contactReasons[a] < subjects[key].contactReasons[b]) return -1;
            if (subjects[key].contactReasons[a] > subjects[key].contactReasons[b]) return 1;
            return 0;
          });
        });

        // first level sort
        subjectKeys.sort(function (a, b) {
          if (subjects[a].webContactType < subjects[b].webContactType) return -1;
          if (subjects[a].webContactType > subjects[b].webContactType) return 1;
          return 0;
        });
        vm.subjects = subjects;
      });
    }

    function getCustomerSuccess(response) {
      vm.data.customer_number = response.customer_number || null;
      vm.data.name = response.name || null;
      vm.data.phone = response.phone || null;
      vm.data.mobile_phone = response.mobile_phone || null;
      vm.data.email = response.email.correspondence || null;
      vm.isCompany = response.is_company;

      getPremises();
    }

    function getPremises() {
      customerService.getPremises().then(function (response) {
        vm.connectionAdresses = response.plain();
        angular.forEach(vm.connectionAdresses, function(value, key) {
          vm.connectionAdresses[key].address.premise_id = vm.connectionAdresses[key].premise_id;
        });

        if(vm.connectionAdresses.length >= 1) {
          vm.data.premises = vm.connectionAdresses[0].address;
        }

      }, function (premisesError) {
        throw Error('getPremises error:', premisesError);
      });
    }

    activate();

    function activate() {
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
      // get iManager data for contact page
      contactFormService.getData().then(function (response) {
        vm.contactInformation = response;
        $rootScope.seo_title = response.Content.seo_title.data;
        $rootScope.seo_description = response.Content.seo_description.data;
        $rootScope.seo_keywords = response.Content.seo_keywords.data;
      });

      getSubjects();
      translateTimeBrackets();

      vm.bAuthenticated = ivAuthenticate.isAuthenticated();
      if (vm.bAuthenticated && !isCorporation) {
        customerService.getCustomer().then(getCustomerSuccess);
      }
    }
  }

  angular
    .module('wml.portal.contact')
    .controller('ContactController', ContactController);
})();

(function() {
  'use strict';

  /** @ngInject */
  CmsController.$inject = ["$rootScope", "$state", "navigationService", "$location"];
  function CmsController($rootScope, $state, navigationService, $location) {
    $rootScope.$broadcast('wml.loader.start');
    var goToLoc = '';
    navigationService.load().then(function() {

      var stateName = navigationService.getStateByUrl($location.path());

      if (stateName) {
        goToLoc = stateName;
      } else if($location.path() === '/') {
        goToLoc = 'home';
      } else {
        goToLoc = 'pageNotFound';
      }
    }).finally(function () {
      $rootScope.$broadcast('wml.loader.abort');
      $state.go(goToLoc);
    });
  }

  angular.module('wml.portal.cms')
    .controller('CmsController', CmsController);

})();

(function() {
  'use strict';

  /** @ngInject */
  CorporationAddressController.$inject = ["corporationService", "storage", "$state", "$location"];
  function CorporationAddressController(corporationService, storage, $state, $location) {
    var vm = this;
    // private variables

    // Public variables
    vm.addressesStatus = true;

    // Public function definitions
    vm.select = select;
    vm.activate = activate;

    // Public functions
    function select(data) {
      storage('corporation_address', data);
      $state.go('dashboard');
    }

    function activate() {
      var queryParams = $location.search();
      corporationService.getAddresses(vm.addressesStatus, queryParams.refresh).then(function (response) {
        vm.addresses = response;
        if (vm.addressesStatus && vm.addresses.length) {
          storage('corporation_address', vm.addresses[0]);
        }
      });
    }

    // Private functions
    activate();
  }

  angular
    .module('wml.portal.corporation')
    .controller('CorporationAddressController', CorporationAddressController);
})();

(function () {
  'use strict';

  CarafeController.$inject = ["cmsService", "$rootScope", "detailService", "carafeService"];
  function CarafeController(cmsService, $rootScope, detailService, carafeService) {
    // private variables
    var vm = this;

    // public variables
    vm.sendingData = false;
    vm.form = null;
    vm.formData = {
      company            : {
        kvk_number           : "",
        name                 : "",
        street               : "",
        house_number         : "",
        house_number_addition: "",
        postal_code          : "",
        city                 : ""
      },
      contact_person     : {
        name : "",
        phone: "",
        email: ""
      },
      order              : {
        type   : {
          introduction: false,
          subsequent: false
        },
        amount : 0,
        remarks: ""
      },
      conditions_accepted: false
    };

    vm.bShowForm = true;

    // Public function definitions
    vm.send = send;


    //public functions
    $rootScope.$broadcast('readspeaker.readclass', 'content');

    function send() {
      if (vm.form.$valid) {
        vm.sendingData = true;

        carafeService.send(vm.formData)
          .then(function () {
            vm.bShowForm = false;
          })
          .finally(function () {
            vm.sendingData = false;
          });
      }
    }

    // Private functions
    activate();

    function activate() {

      cmsService.loadData().then(function (data) {
        vm.data = data;

        cmsService.setSEO(data);

        $rootScope.$broadcast('wml.website.getBanners', data.Content.banners.ContentIndex);
      });

      detailService.getBlockContent().then(function (response) {
        vm.bottomBlock = response.plain();
      });

    }
  }

  angular
    .module('wml.portal')
    .controller('CarafeController', CarafeController)

})();

(function(){
  'use strict';

  BusinessContactController.$inject = ["enumService", "contactFormService", "$state", "$rootScope", "$translate"];
  function BusinessContactController(enumService, contactFormService, $state, $rootScope, $translate){
    var vm = this;

    //public variables
    vm.subjects = null;
    vm.content = null;
    vm.data = {
      company : null,
      contact_person : null,
      phone_number : null,
      email : null,
      subject : null,
      message : null
    };

    //public functions
    vm.submitForm = submitForm;


    function submitForm(){
      contactFormService.sendBusinessForm(vm.data).then(function(response){
        $state.go('contactThankYou');
      });
    }

    function activate(){
      enumService.getBusinessContactFormSubjects().then(function(data){
        vm.subjects = angular.copy(data).map(function(item) {
          item.label = $translate.instant('contact.' + item.label);
          return item;
        });

        vm.subjects.sort(function(a, b){
          if(a.label < b.label) return -1;
          if(a.label > b.label) return 1;
          return 0;
        })
      });

      contactFormService.getBusinessData().then(function (response) {
        vm.contactInformation = response;
        $rootScope.seo_title = response.Content.seo_title.data;
        $rootScope.seo_description = response.Content.seo_description.data;
        $rootScope.seo_keywords = response.Content.seo_keywords.data;
      });

      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    }
    activate();
  }
  angular
    .module('wml.portal.contact')
    .controller('BusinessContactController', BusinessContactController);
})();

(function() {
  'use strict';

  /** @ngInject */
  BillingInformationController.$inject = ["$scope", "$rootScope", "enumService", "billingInformationService", "contactPersonService", "$state"];
  function BillingInformationController($scope, $rootScope, enumService, billingInformationService, contactPersonService, $state) {
    var vm = this;

    var SEND_CONTROL  = {
      MAIL    : 0,
      DIGITAL : 3
    };

    vm.data = {
      account_id: null,
      email : null,
      sendcontrol: null,
      is_digital: null
    };

    vm.save = save;

    function save() {
      if(vm.data.is_digital) {
        vm.sendingData  = true;
        contactPersonService.save({
          type: 'administration',
          email: vm.data.email,
          account_id: vm.data.account_id
        }).then(function(data) {
          if(data.fields && data.fields.contact_person) {
            vm.data.account_id  = data.fields.contact_person.relation_account_id;
            contactPersonService.addUpdate(data.fields.contact_person.relation_account_id, data.fields.contact_person);
            $rootScope.$broadcast('clear-cache', {customer: {customer: true}});
          }

          billingInformationService.updateSendControl(vm.data.sendcontrol).then(function(response) {
            $state.go('customerSaved');
          });
        });
      } else {
        billingInformationService.updateSendControl(vm.data.sendcontrol).then(function(response) {
          $state.go('customerSaved');
        });
      }
    }

    function getSendControlOptions() {
      enumService.getSendControl().then(sendControlOptionsSuccess);
    }

    function sendControlOptionsSuccess(response) {
      vm.sendcontrol  = response;
    }

    function getSendControl() {
      billingInformationService.getSendControl().then(sendControlSuccess);
    }

    function sendControlSuccess(response) {
      vm.data.sendcontrol = response.sendcontrol;
    }

    function getAdministrationContactPerson() {
      contactPersonService.getAdministrationContactPerson().then(function(response) {
        vm.data.account_id  = response.customer_number;
        vm.data.email       = response.email.correspondence;
      });
    }

    function activate() {
      getSendControlOptions();
      getSendControl();
      getAdministrationContactPerson();
    }

    activate();

    var unregister  = $scope.$watch(function() {return vm.data.sendcontrol;}, function(newValue) {
      vm.data.is_digital  = (newValue === SEND_CONTROL.DIGITAL);
      if(vm.data.is_digital === false) {
        vm.data.email = null;
      }
    });

    $scope.$on('$destroy', function() {
      unregister();
    });
  }

  angular.module('wml.portal.billingInformation')
    .controller('BillingInformationController', BillingInformationController);

})();

(function() {
  'use strict';

  /** @ngInject */
  BannersController.$inject = ["bannerService", "$rootScope"];
  function BannersController(bannerService, $rootScope) {
    var vm  = this;

    // public variables
    vm.banners = null;

    $rootScope.$on('wml.website.getBanners', function(evt, data){
      bannerService.loadData(data).then(function(response){
        vm.banners = response;
      });
    });
  }

  angular
    .module('wml.portal.banners')
    .controller('BannersController', BannersController);
})();

(function() {
  'use strict';

  /** @ngInject */
  PasswordRestoreController.$inject = ["$location", "$state", "$http", "activationService", "ivAuthenticate", "Restangular", "profileService", "storage"];
  function PasswordRestoreController($location, $state, $http, activationService, ivAuthenticate, Restangular, profileService, storage) {

    var vm  = this;

    // private variables

    // Public variables

    // Public function definitions

    // Public functions

    // Private functions

    function restorePassword(){
      var location = $location.search();
      storage('activation_query', location);

      if(angular.isDefined(location.e) && angular.isDefined(location.a) && angular.isDefined(location.r) && angular.isDefined(location.t) && angular.isDefined(location.p) && angular.isDefined(location.h)){
        activationService.activate(location).then(function(response) {
          ivAuthenticate.handleLoginSuccess({data: response});
          profileService.getProfile().then(getProfileSuccess);
        });
      }
    }

    function getProfileSuccess(response) {
      Restangular.setDefaultHeaders(angular.extend(Restangular.configuration.defaultHeaders, {'X-Customer-Number': response.customer_number}));
      $http.defaults.headers.common['X-Customer-Number']  = response.customer_number;
      storage('customer_number', response.customer_number);
      $state.go('profilePassword');
    }

    activate();

    function activate(){
      restorePassword();
    }
  }

  angular
    .module('wml.portal.authentication')
    .controller('PasswordRestoreController', PasswordRestoreController);
})();

(function() {
  'use strict';

  /** @ngInject */
  PasswordForgotController.$inject = ["authenticationService"];
  function PasswordForgotController(authenticationService) {

    var vm  = this;

    // private variables

    // Public variables
    vm.form = null;
    vm.sendingData  = false;
    vm.bEmailSent   = false;

    // Public function definitions
    vm.resetPassword = resetPassword;

    // Public functions

    function resetPassword(){
      vm.form.$commitViewValue();
      if(vm.form.$valid) {
        vm.sendingData = true;
        authenticationService.forgotPassword(vm.form.email).then(function(){
          vm.bEmailSent = true;
        }, function(){
          vm.bEmailSent = false;
        }).finally(function(){
          vm.sendingData = false;
        });
      }
    }

    // Private functions


    activate();

    function activate(){
    }
  }

  angular
    .module('wml.portal.authentication')
    .controller('PasswordForgotController', PasswordForgotController);
})();

(function () {
  'use strict';

  /** @ngInject */
  appointmentSummaryController.$inject = ["$rootScope", "$state", "appointmentService", "enumService", "ivAuthenticate"];
  function appointmentSummaryController($rootScope, $state, appointmentService, enumService, ivAuthenticate) {
    var vm = this;

    // private variables


    // Public variables
    vm.data         = {};
    vm.sendingData  = false;
    vm.summary      = {};
    vm.mode = '';

    // Public function definitions

    vm.save       = save;
    vm.cancel     = cancel;

    // Public functions

    function save() {
      if (vm.form.$valid) {
        vm.sendingData = true;
        if (vm.mode !== 'Delete') {
          appointmentService.saveAppointment(vm.summary).then(function () {
            $rootScope.$broadcast('clear-cache', {appointment : true});
            appointmentService.clearAppointment();
            $state.go('appointmentConfirmation'+vm.mode);
          }).finally(function () {
            vm.sendingData = false;
          });
        }
        if (vm.mode === 'Delete') {
          appointmentService.deleteAppointment(vm.summary).then(function () {
            $rootScope.$broadcast('clear-cache', {appointment : true});
            appointmentService.clearAppointment();
            $state.go('appointmentConfirmationDelete');
          }).finally(function () {
            vm.sendingData = false;
          });
        }
      }
    }

    function cancel() {
      appointmentService.clearAppointment();
      if (ivAuthenticate.isAuthenticated()) {
        $state.go('dashboard');
      } else {
        $state.go('appointmentFormCreate');
      }
    }

    // Private functions

    activate();

    function activate() {
      vm.mode = $state.current.name.split('appointmentSummary')[1];
      vm.summary = appointmentService.getAppointment();
      vm.isScheduled = vm.summary.is_scheduled;
      if (angular.isObject(vm.summary)) {
        var aSelectedMeter = vm.summary.device.future_qn.filter(function (item) {
          return item.value === vm.summary.meter_type;
        });
        vm.summary.meter_type = aSelectedMeter[0];

        if (vm.summary.appointment !== 'other') {
          if (vm.mode !== 'Delete' ) {
            appointmentService.getAppointmentSlots().then(function (response) {
              response = response.filter(function (item) {
                return item.start === vm.summary.appointment;
              });
              // todo error when slot not available
              vm.summary.appointment = response[0];
            });
          }
          if (vm.mode === 'Delete') {
            vm.summary.appointment = {
              start: vm.summary.start,
              end: vm.summary.end,
            };
          }
        }
        if(angular.isDefined(vm.summary.appointment_other)){
          enumService.getWeekdays().then(function (response) {
            response = response.filter(function (item) {
              return item.value === vm.summary.appointment_other.weekday;
            });
            vm.summary.appointment_other.weekday = response[0];
          });

          enumService.getDayparts().then(function (response) {
            response = response.filter(function (item) {
              return item.value == vm.summary.appointment_other.timeslot;
            });
            vm.summary.appointment_other.timeslot = response[0];
          });
        }

      }

      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

    }
  }

  angular
    .module('wml.portal.appointment')
    .controller('appointmentSummaryController', appointmentSummaryController);
})();

(function () {
  'use strict';

  /** @ngInject */
  appointmentFormController.$inject = ["$state", "appointmentService", "$rootScope"];
  function appointmentFormController($state, appointmentService, $rootScope) {
    var vm = this;

    // private variables

    // Public variables
    vm.form = null;
    vm.data = {};
    vm.sendingData = false;

    // Public function definitions

    vm.next = next;

    // Public functions
    function next() {
      vm.form.$commitViewValue();
      if (vm.form.$valid) {
        vm.sendingData = true;
        vm.data.filter_type_z6 = true;
        appointmentService.verifyAppointment(vm.data).then(function () {
          $state.go('appointmentEmailCreate');
        }).finally(function () {
          vm.sendingData = false;
        });
      }
    }

    // Private functions

    activate();

    function activate() {
      appointmentService.clearAppointment();
      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }
  }

  angular
    .module('wml.portal.appointment')
    .controller('appointmentFormController', appointmentFormController);
})();

(function () {
  'use strict';

  /** @ngInject */
  appointmentEmailController.$inject = ["$state", "appointmentService", "ivAuthenticate"];
  function appointmentEmailController($state, appointmentService, ivAuthenticate) {
    var vm = this;

    // private variables

    // Public variables
    vm.form = null;
    vm.data = {};
    vm.appointment = null;
    vm.isScheduled = false;
    vm.mode = '';

    // Public function definitions

    vm.next = next;
    vm.cancel = cancel;

    // Public functions
    function next() {
      vm.form.$commitViewValue();
      if (vm.form.$valid) {
        appointmentService.storeAppointment(vm.data);
        $state.go('appointmentCalendar' + vm.mode);
      }
    }

    function cancel() {
      appointmentService.clearAppointment();
      if (ivAuthenticate.isAuthenticated()) {
        $state.go('dashboard');
      } else {
        $state.go('appointmentFormCreate');
      }
    }

    // Private functions

    activate();

    function activate() {
      vm.mode = $state.current.name.split('appointmentEmail')[1];

      var appointmentData = appointmentService.getAppointment();
      if (angular.isObject(appointmentData)) {
        if (appointmentData.device) {
          vm.meterTypes = appointmentData.device.future_qn;
        }
        vm.isScheduled = appointmentData.is_scheduled;
        vm.data = appointmentData;
        if (!vm.isScheduled) {
          if (angular.isUndefined(vm.data.meter_type)) {
            vm.data.meter_type = appointmentData.device.preselected || 'meter_default';
          }
        }
      }
    }
  }

  angular
    .module('wml.portal.appointment')
    .controller('appointmentEmailController', appointmentEmailController);
})();

(function () {
  'use strict';

  /** @ngInject */
  appointmentConfirmationController.$inject = ["$state", "$translate", "ivAuthenticate", "$rootScope"];
  function appointmentConfirmationController($state, $translate, ivAuthenticate, $rootScope) {
    var vm = this;

    // private variables
    var _goToState = null;

    // Public variables

    // Public function definitions
    vm.next = next;

    // Public functions
    function next() {
      $state.go(_goToState);
    }

    // Private functions

    activate();

    function activate() {
      vm.mode = $state.current.name.split('appointmentConfirmation')[1];
      if (ivAuthenticate.isAuthenticated()) {
        $translate('msa.confirmation.btn_dashboard').then(function (translation) {
          vm.btnTxt = translation;
        });
        _goToState = 'dashboard';
      } else {
        $translate('msa.confirmation.btn_home').then(function (translation) {
          vm.btnTxt = translation;
        });
        _goToState = 'home';
      }
    }

    $rootScope.$broadcast('readspeaker.readclass', 'rs-text');

  }

  angular
    .module('wml.portal.appointment')
    .controller('appointmentConfirmationController', appointmentConfirmationController);
})();

(function () {
  'use strict';

  /** @ngInject */
  appointmentCalendarController.$inject = ["$state", "appointmentService", "enumService", "ivAuthenticate", "$rootScope"];
  function appointmentCalendarController($state, appointmentService, enumService, ivAuthenticate, $rootScope) {
    var vm = this;

    // private variables


    // Public variables
    vm.form               = null;
    vm.data               = {};
    vm.weekday            = [];
    vm.dayparts           = [];
    vm.appointmentsSlots  = null;
    vm.mode = '';

    // Public function definitions

    vm.next = next;
    vm.cancel = cancel;

    // Public functions
    function next() {
      if (vm.form.$valid) {
        appointmentService.storeAppointment(vm.data);
        $state.go('appointmentSummary' + vm.mode);
      }
    }

    function cancel() {
      appointmentService.clearAppointment();
      if (ivAuthenticate.isAuthenticated()) {
        $state.go('dashboard');
      } else {
        $state.go('appointmentFormCreate');
      }
    }

    // Private functions

    activate();

    function activate() {

      vm.mode = $state.current.name.split('appointmentCalendar')[1];

      var appointmentData = appointmentService.getAppointment();
      if (angular.isObject(appointmentData)) {
        vm.data = appointmentData;
        if (angular.isUndefined(vm.data.appointment) && angular.isString(vm.data.start) && vm.data.start.length > 0) {
          vm.data.appointment = vm.data.start;
        }
      }

      enumService.getWeekdays().then(function(response) {
        vm.weekday = response.plain();
      });

      enumService.getDayparts().then(function(response) {
        vm.dayparts = response.plain();
      });

      if (vm.mode !== 'Delete') {
        appointmentService.getAppointmentSlots().then(function (response) {
          vm.appointmentsSlots = response;
        });
      } else { // Delete
        vm.appointmentsSlots = [{
          start: vm.data.start,
          end: vm.data.end,
        }];
      }

      $rootScope.$broadcast('readspeaker.readclass', 'rs-text');
    }

  }

  angular
    .module('wml.portal.appointment')
    .controller('appointmentCalendarController', appointmentCalendarController);
})();

(function() {
  'use strict';

  /** @ngInject */
  AccountSelectController.$inject = ["$rootScope", "$http", "RestangularExt", "$state", "storage", "customerService", "profileService"];
  function AccountSelectController($rootScope, $http, RestangularExt, $state, storage, customerService, profileService) {
    var vm  = this;

    vm.options  = [];

    vm.select = select;
    vm.account_email;
    vm.filter;

    function activate() {
      customerService.getCustomers().then(function(data) {
        vm.options  = data;
      });

      profileService.getProfile().then(function(data) {
        if(data.email && data.email.account) {
          vm.account_email  = data.email.account;
        }
      });
    }

    function select(option) {
      RestangularExt.setDefaultHeaders(angular.extend(RestangularExt.configuration.defaultHeaders, {'X-Customer-Number': option.customer_number}));
      $http.defaults.headers.common['X-Customer-Number']  = option.customer_number;
      storage('customer_number', option.customer_number);
      $rootScope.$broadcast('clear-cache');

      if(storage('corporation') === true){
        $state.go('chooseAddress');
      } else {
        $state.go('dashboard');
      }
    }

    activate();
  }

  angular.module('wml.portal.account')
    .controller('AccountSelectController', AccountSelectController);

})();

(function(){
  'use strict';
  /** @ngInject */
  notFoundController.$inject = ["error404Service"];
  function notFoundController(error404Service){

    var vm  = this;
    vm.data = null;

    activate();

    function activate() {
      error404Service.getData().then(function(response){
        vm.data = response;
      });
    }
  }
  angular
    .module('wml.portal.404')
    .controller('notFoundController', notFoundController);
})();

if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

(function() {
  'use strict';

  /** @ngInject */
  config.$inject = ["$translateProvider", "storageProvider", "$injector", "translations_nl_NL", "registryProvider"];
  function config($translateProvider, storageProvider, $injector, translations_nl_NL, registryProvider) {
    var defaultLanguage = 'nl_NL';

    // To prevent timing issues, define storage key prefix at this point also to make sure keys are consistent
    storageProvider.setStorageKeyPrefix('wml');
    // register storage
    storageProvider.registerStorage('language', null, null, 'localStorage');
    // manually load $window service as dependency for storage service
    var $window     = $injector.get('$windowProvider').$get();
    // manually load storage service
    var storage     = storageProvider.$get($window);

    var preferredLanguage = defaultLanguage;

    var storedLanguageISO = storage('language');

    if(angular.isDefined(storedLanguageISO)) {
      preferredLanguage = storedLanguageISO;
    }

    storage('language', preferredLanguage);

    if(registryProvider.DevelopmentMode) {
      $translateProvider.translations('NL', translations_nl_NL);
    } else {
      $translateProvider.useUrlLoader(registryProvider.RestApi + '/translation');
    }
    $translateProvider.preferredLanguage('NL');
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
  }

  angular
    .module('wml.portal')
    .config(config);

})();

(function () {
  'use strict';

  runBlock.$inject = ["Restangular", "$rootScope", "$cookies", "$http", "storage", "ivAuthenticate", "$transitions", "$window", "$location", "$state", "corporationStateCheckService", "$translate", "registry"];
  angular
    .module('wml.portal')
    .run(runBlock);

  /** @ngInject */
  function runBlock(Restangular, $rootScope, $cookies, $http, storage, ivAuthenticate, $transitions, $window, $location, $state, corporationStateCheckService, $translate, registry) {
    $rootScope.previewBarStyling = {
      display: 'none'
    };

    $rootScope.$watch('preview', function (newValue, oldValue) {
      if (newValue === false && newValue !== oldValue) {
        $cookies.remove('IpCmsH');
        $cookies.remove('sip');
        $window.location.reload();
      }

      if (newValue === true) {
        $rootScope.previewBarStyling.display = 'block';
      } else {
        $rootScope.previewBarStyling.display = 'none';
      }
    });

    $rootScope.preview = false;
    if (parseInt($cookies.get('IpCmsH'), 10) === 1 && $cookies.get('sip')) {
      $rootScope.preview = true;
      Restangular.setDefaultHeaders(angular.extend(Restangular.configuration.defaultHeaders, {'X-IManager-Preview': 'true', 'X-IManager-Session': $cookies.get('sip')}));
    }

    function localstorageTest() {
      var test = 'test';
      try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch (e) {
        return false;
      }
    }

    if (localstorageTest() !== true) {
      $translate('message.custom.1006').then(function (translation) {
        alert(translation);
      });
    }

    $rootScope.ngModelOptions = {
      updateOn: 'default blur',
      debounce: {default: 500, blur: 0}
    };

    // Handle response types warning and info
    Restangular.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
      if (data !== null) {
        if (angular.isDefined(data.type) && data.type === 'message') {
          if (angular.isDefined(data.level) && (data.level === 'warning' || data.level === 'info' || data.level === 'success')) {
            $rootScope.$broadcast('wml.portal.message', data);
          }
        }
      }

      return data;
    });

    $rootScope.$on('iv.authenticate.aborted', function () {
      $rootScope.$broadcast('wml.loader.abort');
    });

    // Handle http error responses and check if error message attached or not.
    Restangular.setErrorInterceptor(function (response, deferred) {
      // intercept all errors and broadcast to the loader
      $rootScope.$broadcast('wml.loader.abort');

      if (response.status === 429) {
        if (response.config.url.indexOf(registry.restApiUrl) !== -1) {
          $rootScope.$broadcast('wml.unavailable.start');
          deferred.reject();
        }
      } else if (angular.isDefined(response.data) && response.data !== null && angular.isDefined(response.data.type) && response.data.type === 'message') {
        if (angular.isDefined(response.data.level) && response.data.level === 'error') {
          if (angular.isDefined(response.data.fields) && angular.isArray(response.data.fields) && response.data.fields.length > 0) {
            $rootScope.$broadcast('wml.portal.invalid.fields', response.data.fields);
          }
          $rootScope.$broadcast('wml.portal.message', response.data);
        }
      } else if (response.status !== 401) {
        $rootScope.$broadcast('wml.portal.http_message', {
          level: 'error_http',
          code: response.status
        });
      } else {
        deferred.reject();
      }
    });

    // Handle getList operations that return an object
    Restangular.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
      var extractedData;
      if (operation === "getList" && angular.isObject(data) && angular.isObject(data.meta)) {
        extractedData = data.items;
        extractedData.meta = data.meta;
        return extractedData;
      }
      return data;
    });

    $transitions.onBefore({}, function (transition) {
      if (storage('corporation')) {
        if (!corporationStateCheckService.isAllowedSecureState(transition.to().name) && !ivAuthenticate.isInsecureState(transition.to().name)) {
          if (angular.isObject(storage('corporation_address'))) {
            return transition.router.stateService.target('dashboard');
          }
          return transition.router.stateService.target('chooseAddress');
        }
      }
    });

    $transitions.onStart({
      to: function (state) {
        $rootScope.insecureRoute = (ivAuthenticate.isInsecureState(state.name));
        $rootScope.seo_title = '';
        $rootScope.seo_description = '';
        $rootScope.seo_keywords = '';
      },
      from: function (state) {
        if (state.name.length) {
          storage('previous_state', state.name);
        }
      }
    }, function () {
      // intercept all page changes and broadcast to the loader
      $rootScope.$broadcast('wml.loader.abort');
    });

    // Scroll to top when changing page
    $transitions.onError({}, function () {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('wml.loader.abort');
    });

    // Scroll to top when changing page
    $transitions.onFinish({}, function () {
      $window.scrollTo(0, 0);
    });

    // Set customernumber in Header when communication with backend
    if (ivAuthenticate.isAuthenticated()) {
      var currentCustomerNumber = storage('customer_number');
      if (angular.isDefined(currentCustomerNumber) === false || currentCustomerNumber === null || /[0-9]{8}/.test(currentCustomerNumber) === false) {
        var claims = ivAuthenticate.getJWTClaims();
        if (angular.isDefined(claims) && angular.isDefined(claims.aud)) {
          storage('customer_number', claims.aud);
        }

        if (angular.isDefined(claims)) {
          if (angular.isDefined(claims.corporation)) {
            storage('corporation', claims.corporation);
          }
          if (angular.isDefined(claims.company)) {
            storage('company', claims.company);
          }
        }
      }

      Restangular.setDefaultHeaders(angular.extend(Restangular.configuration.defaultHeaders, {'X-Customer-Number': currentCustomerNumber}));
      $http.defaults.headers.common['X-Customer-Number'] = currentCustomerNumber;
    } else {
      if (!sessionStorage.getItem(ivAuthenticate.getLocalShortTokenStorageKey()) || ivAuthenticate.isShortTermTokenExpired()) {
        sessionStorage.removeItem(ivAuthenticate.getLocalShortTokenStorageKey());
        storage('customer_number', null);
      }
      storage('corporation', null);
      storage('company', null);
      storage('corporation_address', null);
    }
  }
})();

(function () {
  'use strict';

  routerConfig.$inject = ["$stateProvider", "$urlRouterProvider", "HeaderSwitchRoute", "FooterRoute", "MessageRoute"];
  angular
    .module('wml.portal')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, HeaderSwitchRoute, FooterRoute, MessageRoute) {

    /** @ngInject */
    var translationLoadedFn = function($q, $translate, $interval) {
      var deferred  = $q.defer();

      var checkInterval = $interval(function() {
        if($translate.isReady()) {
          $interval.cancel(checkInterval);
          deferred.resolve();
        }
      }, 100);

      return deferred.promise;
    };
    translationLoadedFn.$inject = ["$q", "$translate", "$interval"];

    $urlRouterProvider.otherwise('/cms');
    $stateProvider
      .state('routes', {
        url: '/routes',
        views: {
          content: {
            templateUrl: 'app/components/routes/views/routes.view.html',
            controller: 'RoutesController',
            controllerAs: 'routes'
          }
        }
      })
      .state('home', {
        url: '/home',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/home/views/home.view.html',
            controller: 'HomeController',
            controllerAs: 'home'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('listPage', {
        url: '/list-page',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/list-page/views/list-page.view.html',
            controller: 'ListPageController',
            controllerAs: 'listPage'
          },
          'sideMenu@listPage': {
            templateUrl     : 'app/components/side-menu/views/side-menu.view.html',
            controller      : 'SideMenuController',
            controllerAs    : 'sideMenu'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('detailPage', {
        url: '/detail-page',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/detail-page/views/detail-page.view.html',
            controller: 'detailPageController',
            controllerAs: 'detailPage'
          },
          'sideMenu@detailPage': {
            templateUrl     : 'app/components/side-menu/views/side-menu.view.html',
            controller      : 'SideMenuController',
            controllerAs    : 'sideMenu'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('cms', {
        url:  '/*cms',
        views:  {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content : {
            controller  : 'CmsController'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('pageNotFound', {
        url: '/404',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/404/views/404.view.html',
            controller: 'notFoundController',
            controllerAs: 'notFound'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('search', {
        url: '/zoeken',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/search/views/search.view.html',
            controller: 'SearchController',
            controllerAs: 'search'
          },
          footer: FooterRoute
        }
      })

      // /account
      .state('profile', {
        url: '/account',
        params: {message: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/profile/views/profile.view.html',
            controller: 'ProfileController',
            controllerAs: 'profile'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('profilePassword', {
        url: '/account/wachtwoord-wijzigen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/profile/views/profile.password.view.html',
            controller: 'ProfilePasswordController',
            controllerAs: 'password'
          },
          'faq@profilePassword': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('profileEmail', {
        url: '/account/email-wijzigen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/profile/views/profile.email.view.html',
            controller: 'ProfileEmailController',
            controllerAs: 'email'
          },
          'faq@profileEmail': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })

      // /mijn-verbruik
      .state('usageDashboard', {
        url: '/mijn-verbruik',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/usage/views/usage.dashboard.view.html',
            controller: 'UsageDashboardController',
            controllerAs: 'usage'
          },
          'faq@usageDashboard': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('usageMeterReadings', {
        url: '/mijn-verbruik/meterstand-doorgeven/{contract_account_id}/contract/{contract_id}/adres/{premise_id}',
        resolve: {
          cancelLink : function(){ return 'usageDashboard'; },
          goToLink      : function(){ return 'usageCompare'; },
          translationsLoaded  : translationLoadedFn
        },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/usage/views/usage.meter-readings-usage-scan.view.html',
            controller: 'UsageMeterReadingsController',
            controllerAs: 'meterReadings'
          },
          'faq@usageMeterReadings': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        }
      })
      .state('usageCompare', {
        url: '/mijn-verbruik/meterstand-doorgeven/verbruik-vergelijken/{contract_account_id}/contract/{contract_id}/adres/{premise_id}',
        resolve: {
          cancelLink            : function(){ return 'usageMeterReadings'; },
          goToLink              : function(){ return 'installmentChanged'; },
          bShowAdvisedCheckbox  : function(){ return true; },
          translationsLoaded    : translationLoadedFn
        },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/usage/views/usage.compare.view.html',
            controller: 'UsageCompareController',
            controllerAs: 'usage'
          },
          'faq@usageCompare': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        }
      })
      .state('installmentChanged', {
        url: '/mijn-verbruik/meterstand-doorgeven/verbruik-vergelijken/termijnbedrag-gewijzigd/{contract_account_id}/contract/{contract_id}/adres/{premise_id}',
        resolve: {
          cancelLink: function(){ return 'usageDashboard'; },
          translationsLoaded  : translationLoadedFn
        },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/usage/views/usage.installment-amount-changed.view.html',
            controller: 'UsageInstallmentChangedController',
            controllerAs: 'usage'
          },
          'faq@installmentChanged': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        }
      })

      // /contact
      .state('contact', {
        url: '/contactformulier',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/contact/views/contact.view.html',
            controller: 'ContactController',
            controllerAs: 'contact'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('business_contact', {
        url: '/contact-zakelijk',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/contact/views/business.contact.view.html',
            controller: 'BusinessContactController',
            controllerAs: 'contact'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('contactThankYou', {
        url: '/contactformulier/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/contact/views/contact.thank-you.view.html',
            controller: 'ContactThankYouController',
            controllerAs: 'contact'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })

      // /login
      .state('login', {
        url: '/inloggen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/login/views/login.view.html',
            controller: 'LoginController',
            controllerAs: 'login'
          },
          'faq@login': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('loginActivate', {
        url: '/inloggen/activeren',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/login/views/login.view.html',
            controller: 'LoginController',
            controllerAs: 'login'
          },
          'faq@loginActivate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('passwordForgot', {
        url: '/wachtwoord-vergeten',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/authentication/views/authentication.forgot-password.view.html',
            controller: 'PasswordForgotController',
            controllerAs: 'password'
          },
          'faq@passwordForgot': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('passwordRestore', {
        url: '/wachtwoord-herstellen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/authentication/views/authentication.restore-password.view.html',
            controller: 'PasswordRestoreController',
            controllerAs: 'password'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })

      // /klant-worden, /registreren
      .state('register', {
        url: '/klant-worden',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.view.html',
            controller: 'RegisterController',
            controllerAs: 'register'
          },
          'faq@register': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('registerLogin', {
        url: '/klant-worden/login?fm',
        params: {clearCache: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.login.view.html',
            controller: 'RegisterLoginController',
            controllerAs: 'registerLogin'
          },
          'faq@registerLogin': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('registerMoveInDate', {
        url: '/klant-worden/move-in-date',
        params: {clearCache: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.move-in-date.view.html',
            controller: 'RegisterMoveInDateController',
            controllerAs: 'registerMoveInDate'
          },
          'faq@registerMoveInDate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve: {
          translationsLoaded: translationLoadedFn
        }
      })
      .state('registerCorrespondence', {
        url: '/klant-worden/correspondentie-gegevens',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.correspondence.view.html',
            controller: 'RegisterCorrespondenceController',
            controllerAs: 'registerCorrespondence'
          },
          'faq@registerCorrespondence': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('registerPersonalInfo', {
        url: '/klant-worden/persoonsgegevens',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.personal-info.view.html',
            controller: 'RegisterPersonalInfoController',
            controllerAs: 'registerPersonalInfo'
          },
          'faq@registerPersonalInfo': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('registerMeterReading', {
        url: '/klant-worden/meterstand',
        params: {meterError: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.meter-reading.view.html',
            controller: 'RegisterMeterReadingController',
            controllerAs: 'registerMeterReading'
          },
          'faq@registerMeterReading': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('registerPaymentMethod', {
        url: '/klant-worden/betaalwijze',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.payment-method.view.html',
            controller: 'RegisterPaymentMethodController',
            controllerAs: 'registerPaymentMethod'
          },
          'faq@registerPaymentMethod': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('registerPortal', {
        url: '/klant-worden/mijn-wml',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.portal.view.html',
            controller: 'RegisterPortalController',
            controllerAs: 'registerPortal'
          },
          'faq@registerPortal': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('registerSummary', {
        url: '/klant-worden/overzicht',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.summary.view.html',
            controller: 'RegisterSummaryController',
            controllerAs: 'registerSummary'
          },
          'faq@registerSummary': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('registerConfirmation', {
        url: '/klant-worden/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/register/views/register.confirmation.view.html',
            controller: 'RegisterConfirmationController',
            controllerAs: 'registerConfirmation'
          },
          'faq@registerConfirmation': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('sign-up', {
        url: '/registreren',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/sign-up/views/sign-up.view.html',
            controller: 'SignUpController',
            controllerAs: 'signUp'
          },
          'faq@sign-up': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('sign-upThankYou', {
        url: '/registreren/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/sign-up/views/sign-up.thank-you.view.html',
            controller: 'SignUpThankYouController',
            controllerAs: 'signUp'
          },
          'faq@sign-upThankYou': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('accountOptions', {
        url: '/klantnummers',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/account/views/accountselect.view.html',
            controller: 'AccountSelectController',
            controllerAs: 'account'
          },
          footer: FooterRoute
        }
      })
      .state('chooseAddress', {
        url: '/adres-kiezen?refresh',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/corporation/views/choose-address.corporation.view.html',
            controller: 'CorporationAddressController',
            controllerAs: 'corporation'
          },
          footer: FooterRoute
        }
      })

      // /dashboard
      .state('dashboard', {
        url: '/mijn-overzicht',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateProvider: ['$templateRequest', 'storage',
              function($templateRequest, storage)
              {
                if(storage('corporation') === true) {
                  return $templateRequest('app/components/dashboard/views/corporation.dashboard.view.html');
                } else {
                  return $templateRequest('app/components/dashboard/views/dashboard.view.html');
                }
              }
            ],
            controller: 'DashboardController',
            controllerAs: 'dashboard'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })

      // /mijn-financiele-gegevens
      .state('invoicesDashboard', {
        url: '/mijn-financiele-gegevens?refresh',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/invoices/views/invoices.dashboard.view.html',
            controller: 'InvoicesDashboardController',
            controllerAs: 'financial'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('invoicesDashboardSaved', {
        url: '/mijn-financiele-gegevens/opgeslagen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/invoices/views/invoices.dashboard.view.html',
            controller: 'InvoicesDashboardController',
            controllerAs: 'financial'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('invoices', {
        url: '/mijn-financiele-gegevens/facturen',
        data: {
          bShowOtherQuestionsBlock: false
        },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/invoices/views/invoices.view.html',
            controller: 'InvoicesController',
            controllerAs: 'invoice'
          },
          'faq@invoices': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('invoicesRemaining', {
        url: '/mijn-financiele-gegevens/openstaand',
        data: {
          bShowOtherQuestionsBlock: false
        },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/invoices/views/invoices.remaining.view.html',
            controller: 'InvoicesController',
            controllerAs: 'invoice'
          },
          'faq@invoicesRemaining': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('invoicesPaymentArrangement', {
        url: '/mijn-financiele-gegevens/betalingsregeling',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/invoices/views/invoices.payment-arrangement.view.html',
            controller: 'InvoicesPaymentArrangementController',
            controllerAs: 'invoice'
          },
          'faq@invoicesPaymentArrangement': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('paymentMethodEdit', {
        url: '/mijn-financiele-gegevens/betaalwijze-wijzigen/{contract_account_id}/contract/{contract_id}',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/payment-method/views/payment-method.view.html',
            controller: 'PaymentMethodController',
            controllerAs: 'payments'
          },
          'faq@paymentMethodEdit': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('installmentChange', {
        url: '/mijn-financiele-gegevens/termijnbedrag-wijzigen/{contract_account_id}/contract/{contract_id}/adres/{premise_id}',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/usage/views/usage.installment-amount-change.view.html',
            controller: 'UsageInstallmentChangeController',
            controllerAs: 'usage'
          },
          'faq@installmentChange': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('installmentMeterReadings', {
        url: '/mijn-financiele-gegevens/termijnbedrag-wijzigen/meterstand-doorgeven/{contract_account_id}/contract/{contract_id}/adres/{premise_id}',
        resolve: {
          cancelLink : function(){ return 'invoicesDashboard'; },
          goToLink      : function(){ return 'invoicesUsageCompare'; },
          translationsLoaded  : translationLoadedFn
        },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/usage/views/usage.meter-readings-usage-scan.view.html',
            controller: 'UsageMeterReadingsController',
            controllerAs: 'meterReadings'
          },
          'faq@installmentMeterReadings': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        }
      })
      .state('invoicesUsageCompare', {
        url: '/mijn-financiele-gegevens/termijnbedrag-wijzigen/meterstand-doorgeven/verbruik-vergelijken/{contract_account_id}/contract/{contract_id}/adres/{premise_id}',
        resolve: {
          cancelLink            : function(){ return 'installmentMeterReadings'; },
          goToLink              : function(){ return 'invoicesInstallmentChanged'; },
          bShowAdvisedCheckbox  : function(){ return false; },
          translationsLoaded    : translationLoadedFn
        },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/usage/views/usage.compare.view.html',
            controller: 'UsageCompareController',
            controllerAs: 'usage'
          },
          'faq@invoicesUsageCompare': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        }
      })
      .state('invoicesInstallmentChanged', {
        url: '/mijn-financiele-gegevens/termijnbedrag-wijzigen/termijnbedrag-gewijzigd/{contract_account_id}/contract/{contract_id}/adres/{premise_id}',
        resolve: {
          cancelLink: function(){ return 'invoicesDashboard'; },
          translationsLoaded  : translationLoadedFn
        },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/usage/views/usage.installment-amount-changed.view.html',
            controller: 'UsageInstallmentChangedController',
            controllerAs: 'usage'
          },
          'faq@invoicesInstallmentChanged': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        }
      })

      // /afspraak/maken, /meter-verwisselen
      .state('msaServicenumberForm', {
        url: '/meter-verwisselen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.servicenumber-form.view.html',
            controller: 'appointmentFormController',
            controllerAs: 'service'
          },
          'faq@appointmentFormCreate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentFormCreate', {
        url: '/afspraak/maken',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.servicenumber-form.view.html',
            controller: 'appointmentFormController',
            controllerAs: 'service'
          },
          'faq@appointmentFormCreate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentEmailCreate', {
        url: '/afspraak/maken/email',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.email.view.html',
            controller: 'appointmentEmailController',
            controllerAs: 'service'
          },
          'faq@appointmentEmailCreate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentCalendarCreate', {
        url: '/afspraak/maken/calendar',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.calendar.view.html',
            controller: 'appointmentCalendarController',
            controllerAs: 'service'
          },
          'faq@appointmentCalendarCreate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentSummaryCreate', {
        url: '/afspraak/maken/overzicht',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.summary.view.html',
            controller: 'appointmentSummaryController',
            controllerAs: 'service'
          },
          'faq@appointmentSummaryCreate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentConfirmationCreate', {
        url: '/afspraak/maken/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.confirmation.view.html',
            controller: 'appointmentConfirmationController',
            controllerAs: 'service'
          },
          'faq@appointmentConfirmationCreate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentFormUpdate', {
        url: '/afspraak/wijzigen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.servicenumber-form.view.html',
            controller: 'appointmentFormController',
            controllerAs: 'service'
          },
          'faq@appointmentFormUpdate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentEmailUpdate', {
        url: '/afspraak/wijzigen/email',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.email.view.html',
            controller: 'appointmentEmailController',
            controllerAs: 'service'
          },
          'faq@appointmentEmailUpdate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentCalendarUpdate', {
        url: '/afspraak/wijzigen/calendar',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.calendar.view.html',
            controller: 'appointmentCalendarController',
            controllerAs: 'service'
          },
          'faq@appointmentCalendarUpdate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentSummaryUpdate', {
        url: '/afspraak/wijzigen/overzicht',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.summary.view.html',
            controller: 'appointmentSummaryController',
            controllerAs: 'service'
          },
          'faq@appointmentSummaryUpdate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentConfirmationUpdate', {
        url: '/afspraak/wijzigen/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.confirmation.view.html',
            controller: 'appointmentConfirmationController',
            controllerAs: 'service'
          },
          'faq@appointmentConfirmationUpdate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentFormDelete', {
        url: '/afspraak/annuleren',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.servicenumber-form.view.html',
            controller: 'appointmentFormController',
            controllerAs: 'service'
          },
          'faq@appointmentFormDelete': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentEmailDelete', {
        url: '/afspraak/annuleren/email',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.email.view.html',
            controller: 'appointmentEmailController',
            controllerAs: 'service'
          },
          'faq@appointmentEmailDelete': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentCalendarDelete', {
        url: '/afspraak/annuleren/calendar',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.calendar.view.html',
            controller: 'appointmentCalendarController',
            controllerAs: 'service'
          },
          'faq@appointmentCalendarDelete': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentSummaryDelete', {
        url: '/afspraak/annuleren/overzicht',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.summary.view.html',
            controller: 'appointmentSummaryController',
            controllerAs: 'service'
          },
          'faq@appointmentSummaryDelete': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('appointmentConfirmationDelete', {
        url: '/afspraak/annuleren/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/appointment/views/appointment.confirmation.view.html',
            controller: 'appointmentConfirmationController',
            controllerAs: 'service'
          },
          'faq@appointmentConfirmationDelete': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })

      // meterstand
      .state('meterReading', {
        url: '/meterstand-doorgeven/{assignment_number}',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/meter-readings/views/meter-reading.recording-number.view.html',
            controller: 'meterReadingRecordingNumberController',
            controllerAs: 'meterReadings'
          },
          'faq@meterReading': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('meterReadingExtReading', {
        url: '/meterstand-doorgeven/stand/{meter_reading}',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/meter-readings/views/meter-reading.recording-number.view.html',
            controller: 'meterReadingRecordingNumberController',
            controllerAs: 'meterReadings'
          },
          'faq@meterReadingExtReading': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('meterReadingRecordingExtReading', {
        url: '/meterstand-doorgeven/stand/{meter_reading}/{assignment_number}/opname/{postal_code}',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/meter-readings/views/meter-reading.view.html',
            controller: 'meterReadingController',
            controllerAs: 'meterReadings'
          },
          'faq@meterReadingRecordingExtReading': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('meterReadingRecording', {
        url: '/meterstand-doorgeven/{assignment_number}/opname/{postal_code}',
        params: {meter_reading: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/meter-readings/views/meter-reading.view.html',
            controller: 'meterReadingController',
            controllerAs: 'meterReadings'
          },
          'faq@meterReadingRecording': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('meterReadingEmailConfirmation', {
        url: '/meterstand-doorgeven/{assignment_number}/confirmation',
        params: {meter_reading: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/meter-readings/views/meter-reading.email-confirmation.view.html',
            controller: 'meterReadingEmailConfirmationController',
            controllerAs: 'meterReadings'
          },
          'faq@meterReadingRecordingEmailConfirmation': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('meterReadingSummary', {
        url: '/meterstand-doorgeven/{assignment_number}/summary',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/meter-readings/views/meter-reading.summary.view.html',
            controller: 'meterReadingSummaryController',
            controllerAs: 'meterReadings'
          },
          'faq@meterReadingSummary': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('meterReadingThankYou', {
        url: '/meterstand-doorgeven/{assignment_number}/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/meter-readings/views/meter-reading.thank-you.view.html',
            controller: 'meterReadingThankYouController',
            controllerAs: 'meterReadings'
          },
          'faq@meterReadingThankYou': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })

      // /mijn-persoonlijke-gegevens
      .state('customer', {
        url: '/mijn-persoonlijke-gegevens',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/customer/views/customer.dashboard.view.html',
            controller: 'CustomerDashboardController',
            controllerAs: 'personal'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('customerEdit', {
        url: '/mijn-persoonlijke-gegevens/wijzigen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/customer/views/customer.edit.view.html',
            controller: 'CustomerEditController',
            controllerAs: 'customer'
          },
          'faq@customerEdit': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('customerSaved', {
        url: '/mijn-persoonlijke-gegevens/opgeslagen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/customer/views/customer.dashboard.view.html',
            controller: 'CustomerDashboardController',
            controllerAs: 'personal'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('contactPersonEdit', {
        url: '/contactpersoon/{type}/bewerken/{account_id}',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/contactperson/views/contactperson.form.view.html',
            controller: 'ContactPersonFormController',
            controllerAs: 'contactperson'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded : translationLoadedFn
        }
      })
      .state('contactPersonAdd', {
        url: '/contactpersoon/{type}/toevoegen',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/contactperson/views/contactperson.form.view.html',
            controller: 'ContactPersonFormController',
            controllerAs: 'contactperson'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded : translationLoadedFn
        }
      })
      .state('correspondenceAddress', {
        url : '/mijn-correspondentie-gegevens/adres',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/correspondence/views/correspondence.edit.view.html',
            controller: 'CorrespondenceAddressEditController',
            controllerAs: 'correspondence'
          },
          'faq@correspondenceAddress': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('billingInformation', {
        url:  '/factuurgegevens',
        views:  {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/billing-information/views/billing-information.view.html',
            controller: 'BillingInformationController',
            controllerAs: 'billinginformation'
          },
          'faq@billingInformation': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          }
        }
      })

      // persoonlijke gegevens woning
      .state('premisesActionOverview', {
        url:  '/mijn-persoonlijke-gegevens/verhuizen',
        views:  {
          header  : HeaderSwitchRoute,
          message : MessageRoute,
          content : {
            templateUrl   : 'app/components/premises/views/premises-action-overview.view.html',
            controller    : 'PremisesActionOverviewController',
            controllerAs  : 'premises'
          },
          'faq@premisesActionOverview' : {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesRegisterMoveInDate', {
        url: '/mijn-persoonlijke-gegevens/move-in-date',
        params: {clearCache: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.move-in-date.view.html',
            controller: 'PremisesRegisterMoveInDateController',
            controllerAs: 'premisesRegisterMoveInDate'
          },
          'faq@premisesRegisterMoveInDate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve: {
          translationsLoaded: translationLoadedFn
        }
      })
      .state('premisesRegisterLogin', {
        url: '/woning-aanmelden?fm',
        params : { clearCache: null },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.login.view.html',
            controller: 'PremisesRegisterLoginController',
            controllerAs: 'premisesRegisterLogin'
          },
          'faq@premisesRegisterLogin': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesRegister', {
        url: '/mijn-persoonlijke-gegevens/woning-aanmelden/',
        params : { clearCache: null },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.view.html',
            controller: 'premisesRegisterController',
            controllerAs: 'premises'
          },
          'faq@premisesRegister': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesRegisterFutureCorrespondenceEmail', {
        url: '/mijn-persoonlijke-gegevens/woning-aanmelden/e-mail',
        params : { clearCache: null },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.future.correpondence.email.view.html',
            controller: 'premisesRegisterFutureCorrespondenceEmailController',
            controllerAs: 'premises'
          },
          'faq@premisesRegister': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesRegisterMeterReading', {
        url: '/mijn-persoonlijke-gegevens/woning-aanmelden/meterstand',
        params: {meterError: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.meter-reading.view.html',
            controller: 'premisesRegisterMeterReadingController',
            controllerAs: 'premises'
          },
          'faq@premisesRegisterMeterReading': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesRegisterNewPremises', {
        url: '/mijn-persoonlijke-gegevens/woning-aanmelden/correspondentie',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.new-premises.view.html',
            controller: 'premisesRegisterNewPremisesController',
            controllerAs: 'premises'
          },
          'faq@premisesRegisterNewPremises': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesRegisterCorrespondenceAddress', {
        url: '/mijn-persoonlijke-gegevens/woning-aanmelden/correspondentie-gegevens',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.correspondence.view.html',
            controller: 'premisesRegisterCorrespondenceAddressController',
            controllerAs: 'premises'
          },
          'faq@premisesRegisterCorrespondenceAddress': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesRegisterSummary', {
        url: '/mijn-persoonlijke-gegevens/woning-aanmelden/overzicht',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.summary.view.html',
            controller: 'premisesRegisterSummaryController',
            controllerAs: 'premises'
          },
          'faq@premisesRegisterSummary': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesRegisterThankYou', {
        url: '/mijn-persoonlijke-gegevens/woning-aanmelden/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-register/views/premises-register.thank-you.view.html',
            controller: 'PremisesRegisterThankYouController',
            controllerAs: 'premises'
          },
          'faq@premisesRegisterThankYou': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesUnregisterLogin', {
        url: '/afmelden-woning?fm',
        params: {clearCache: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.login.view.html',
            controller: 'PremisesUnregisterLoginController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregisterLogin': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve: {
          translationsLoaded: translationLoadedFn
        }
      })
      .state('premisesUnregisterMoveOutDate', {
        url: '/mijn-persoonlijke-gegevens/woning-afmelden/move-out-date',
        params: {clearCache: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.move-out-date.view.html',
            controller: 'PremisesUnregisterMoveOutDateController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregisterMoveOutDate': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve: {
          translationsLoaded: translationLoadedFn
        }
      })
      .state('premisesUnregisterEmail', {
        url: '/mijn-persoonlijke-gegevens/woning-afmelden/email',
        params: {clearCache: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.email.view.html',
            controller: 'PremisesUnregisterEmailController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregisterEmail': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve: {
          translationsLoaded: translationLoadedFn
        }
      })
      .state('premisesUnregister', {
        url: '/mijn-persoonlijke-gegevens/woning-afmelden',
        params : { clearCache: null },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.view.html',
            controller: 'PremisesUnregisterController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregister': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesUnregisterFutureCorrespondenceEmail', {
        url: '/mijn-persoonlijke-gegevens/woning-afmelden/e-mail',
        params : { clearCache: null },
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.future.correpondence.email.view.html',
            controller: 'premisesUnregisterFutureCorrespondenceEmailController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregister': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesUnregisterMeterReading', {
        url: '/mijn-persoonlijke-gegevens/woning-afmelden/meterstand',
        params: {meterError: null},
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.meter-reading.view.html',
            controller: 'PremisesUnregisterMeterReadingController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregisterMeterReading': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesUnregisterCorrespondenceAddress', {
        url: '/mijn-persoonlijke-gegevens/woning-afmelden/correspondentie-gegevens',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.correspondence.view.html',
            controller: 'PremisesUnregisterCorrespondenceAddressController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregisterCorrespondenceAddress': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesUnregisterSummary', {
        url: '/mijn-persoonlijke-gegevens/woning-afmelden/overzicht',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.summary.view.html',
            controller: 'PremisesUnregisterSummaryController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregisterSummary': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
      .state('premisesUnregisterThankYou', {
        url: '/mijn-persoonlijke-gegevens/woning-afmelden/bedankt',
        views: {
          header: HeaderSwitchRoute,
          message: MessageRoute,
          content: {
            templateUrl: 'app/components/premises-unregister/views/premises-unregister.thank-you.view.html',
            controller: 'PremisesUnregisterThankYouController',
            controllerAs: 'premises'
          },
          'faq@premisesUnregisterThankYou': {
            templateUrl     : 'app/components/faq/views/faq.view.html',
            controller      : 'FaqController',
            controllerAs    : 'faq'
          },
          footer: FooterRoute
        },
        resolve : {
          translationsLoaded  : translationLoadedFn
        }
      })
  }
})();

/* global _:false, moment:false */
(function() {
  'use strict';

  angular.module('wml.portal')
    .constant('_', _)
    .constant('moment', moment)
    .constant('HeaderSwitchRoute', {
      templateUrl     : 'app/components/header/views/header.switch.view.html',
      controller      : 'HeaderSwitchController',
      controllerAs    : 'header'
    })
    .constant('FooterRoute', {
      templateUrl     : 'app/components/footer/views/footer.view.html',
      controller      : 'FooterController',
      controllerAs    : 'footer'
    })
    .constant('MessageRoute', {
      templateUrl     : 'app/components/message/views/message.view.html',
      controller      : 'MessageController',
      controllerAs    : 'message'
    })
    .constant('MOVE_REASON', {
      MOVE_IN: '06',
      MOVE_OUT: '03'
    });
})();



(function () {
  'use strict';

  config.$inject = ["storageProvider", "RestangularProvider", "registryProvider", "tmhDynamicLocaleProvider", "ivAuthenticateProvider", "$qProvider", "$httpProvider", "$locationProvider", "ivIformProvider"];
  angular
    .module('wml.portal')
    .config(config);

  /** @ngInject */
  function config(storageProvider, RestangularProvider, registryProvider, tmhDynamicLocaleProvider, ivAuthenticateProvider, $qProvider, $httpProvider, $locationProvider, ivIformProvider) {
    // Set restangular api base
    RestangularProvider.setBaseUrl(registryProvider.RestApi);

    ivIformProvider.setApiBaseUrl(window.location.origin + '/');

    // Set html5 urls
    $locationProvider.html5Mode(true);

    // Set default header
    $httpProvider.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";
    $httpProvider.defaults.withCredentials = true;

    // Show error on unhandled rejections
    $qProvider.errorOnUnhandledRejections(registryProvider.DevelopmentMode);

    // Configure iv-authenticate
    ivAuthenticateProvider
      .setLoginUrl(registryProvider.RestApi + '/authenticate')
      .setShortTokenLoginUrl(registryProvider.RestApi + '/authenticate')
      .setRefreshTokenUrl(registryProvider.RestApi + '/authenticate/refresh-token')
      .setRedirectState('login')
      .addShortTermState('premisesUnregister')
      .addShortTermState('premisesUnregisterFutureCorrespondenceEmail')
      .addShortTermState('premisesUnregisterMeterReading')
      .addShortTermState('premisesUnregisterCorrespondenceAddress')
      .addShortTermState('premisesUnregisterSummary')
      .addShortTermState('premisesUnregisterEmail')
      .addShortTermState('premisesUnregisterThankYou')
      .addShortTermState('premisesRegister')
      .addShortTermState('premisesRegisterNewPremises')
      .addShortTermState('premisesRegisterCorrespondenceAddress')
      .addShortTermState('premisesRegisterFutureCorrespondenceEmail')
      .addShortTermState('premisesRegisterMeterReading')
      .addShortTermState('premisesRegisterSummary')
      .addShortTermState('premisesRegisterThankYou')
      .addInsecureState('paneltestRegister')
      .addInsecureState('premisesUnregisterMoveOutDate')
      .addInsecureState('premisesRegisterMoveInDate')
      .addInsecureState('home')
      .addInsecureState('contact')
      .addInsecureState('contactThankYou')
      .addInsecureState('login')
      .addInsecureState('loginActivate')
      .addInsecureState('register')
      .addInsecureState('registerLogin')
      .addInsecureState('registerMoveInDate')
      .addInsecureState('registerCorrespondence')
      .addInsecureState('registerPersonalInfo')
      .addInsecureState('registerMeterReading')
      .addInsecureState('registerPaymentMethod')
      .addInsecureState('registerPortal')
      .addInsecureState('registerSummary')
      .addInsecureState('registerConfirmation')
      .addInsecureState('sign-up')
      .addInsecureState('sign-upThankYou')
      .addInsecureState('passwordRestore')
      .addInsecureState('passwordForgot')
      .addInsecureState('meterReadingNoAssignmentNum')
      .addInsecureState('meterReading')
      .addInsecureState('meterReadingRecording')
      .addInsecureState('meterReadingEmailConfirmation')
      .addInsecureState('meterReadingExtReading')
      .addInsecureState('meterReadingRecordingExtReading')
      .addInsecureState('meterReadingSummary')
      .addInsecureState('meterReadingThankYou')
      .addInsecureState('premisesUnregisterLogin')
      .addInsecureState('premisesRegisterLogin')
      .addInsecureState('msaSummary')
      .addInsecureState('msaTimeTable')
      .addInsecureState('msaServicenumberForm')
      .addInsecureState('appointmentFormCreate')
      .addInsecureState('appointmentEmailCreate')
      .addInsecureState('appointmentCalendarCreate')
      .addInsecureState('appointmentSummaryCreate')
      .addInsecureState('appointmentConfirmationCreate')

      .addInsecureState('appointmentFormUpdate')
      .addInsecureState('appointmentEmailUpdate')
      .addInsecureState('appointmentCalendarUpdate')
      .addInsecureState('appointmentSummaryUpdate')
      .addInsecureState('appointmentConfirmationUpdate')

      .addInsecureState('appointmentFormDelete')
      .addInsecureState('appointmentEmailDelete')
      .addInsecureState('appointmentCalendarDelete')
      .addInsecureState('appointmentSummaryDelete')
      .addInsecureState('appointmentConfirmationDelete')

      .addInsecureState('cms')
      .addInsecureState('faqList')
      .addInsecureState('pageNotFound')
      .addInsecureState('business_contact')
      .addInsecureState('search')
      .addInsecureState('routes');

    // Configure storage provider
    storageProvider
      .setDefaultStorageEngine('sessionStorage')
      .setStorageKeyPrefix('wml')
      .registerStorage('customer_number', null, null, 'localStorage')
      .registerStorage('company', _parseToJson, _parseFromJson, 'localStorage')
      .registerStorage('corporation', _parseToJson, _parseFromJson, 'localStorage')
      .registerStorage('corporation_address', _parseToJson, _parseFromJson, 'sessionStorage')
      .registerStorage('testpanel_userid', null, null, 'localStorage')
      .registerStorage('activation_query', _parseToJson, _parseFromJson, 'sessionStorage')
      .registerStorage('previous_state')
      .registerStorage('meter_reading', _parseToJson, _parseFromJson, 'sessionStorage')
      .registerStorage('meter_readings', _parseToJson, _parseFromJson, 'sessionStorage')
      .registerStorage('appointment', _parseToJson, _parseFromJson, 'sessionStorage')
      .registerStorage('premises_register', _parseToJson, _parseFromJson, 'sessionStorage')
      .registerStorage('premises_unregister', _parseToJson, _parseFromJson, 'sessionStorage')
      .registerStorage('premises_procces_status', null, null, 'sessionStorage')
      .registerStorage('register_customer', _parseToJson, _parseFromJson, 'sessionStorage')
      .registerStorage('app_info', _parseToJson, _parseFromJson, 'localStorage')
      .registerStorage('waterestafette_voted', null, null, 'localStorage');

    function _parseToJson (data) {
      if (data) {
        return angular.toJson(data);
      } else {
        return data;
      }
    }

    function _parseFromJson (data) {
      if (data) {
        return JSON.parse(data);
      } else {
        return data;
      }
    }

    // Configure translations
    tmhDynamicLocaleProvider.localeLocationPattern('./app/i18n/angular-locale_{{locale}}.js');
    tmhDynamicLocaleProvider.defaultLocale('nl-nl');
  }

})();

(function() {
  'use strict';

  breadcrumbConfig.$inject = ["breadcrumbsProvider"];
  angular
    .module('wml.portal')
    .config(breadcrumbConfig);

  /** @ngInject */
  function breadcrumbConfig(breadcrumbsProvider) {
    breadcrumbsProvider
      .register({
        path    : ['home'],
        states  : ['dashboard', 'profile', 'accountOptions', 'premisesUnregisterLogin', 'premisesUnregisterMoveOutDate']
      })
      .register({
        path    : ['home', 'dashboard'],
        states  : ['customer', 'invoicesDashboard', 'usageDashboard', 'invoicesDashboardSaved', 'premisesRegisterMoveInDate']
      })
      .register({
        path    : ['home', 'profile'],
        states  : ['profilePassword', 'profileEmail']
      })
      // mijn persoonlijke gegevens
      .register({
        path    : ['home', 'dashboard', 'customer'],
        states  : ['premisesUnregisterThankYou', 'premisesUnregisterSummary', 'premisesUnregisterCorrespondenceAddress', 'premisesUnregisterMeterReading', 'premisesUnregister', 'premisesRegisterThankYou', 'premisesRegisterSummary', 'premisesRegisterNewPremises', 'premisesRegisterMeterReading', 'premisesRegister', 'premisesActionOverview', 'correspondenceAddress', 'customerEdit', 'customerSaved', 'contactPersonEdit', 'contactPersonAdd']
      })
      // mijn financiele gegevens
      .register({
        path    : ['home', 'dashboard', 'invoicesDashboard'],
        states  : ['invoicesInstallmentChanged', 'invoicesUsageCompare', 'installmentMeterReadings', 'installmentChange', 'paymentMethodEdit', 'invoicesRemaining', 'invoices']
      })
      // mijn verbruik
      .register({
        path    : ['home', 'dashboard', 'usageDashboard'],
        states  : ['installmentChanged', 'usageCompare', 'usageMeterReadings']
      })

  }

})();

angular.module("wml.portal").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/404/views/404.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-6 not-found content\">\n      <h1 ng-if=\"notFound.data.Content.title.data\">{{notFound.data.Content.title.data}}</h1>\n      <div ng-if=\"notFound.data.Content.text.data\" ng-bind-html=\"notFound.data.Content.text.data\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/account/views/accountselect.view.html","<div class=\"container\">\n  <div class=\"card-options-wrapper\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <h1>{{\'account.page_title\' | translate}}</h1>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"card-options-margin-seperator\">\n        <div class=\"col-xs-12 col-md-8\">\n          <p translate=\"account.intro_text\" translate-value-email=\"{{account.account_email}}\"></p>\n        </div>\n        <div class=\"col-xs-12 col-md-4\">\n          <div class=\"card-options-search-wrapper card-options-filter-option\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{\'account.search\' | translate}}\" ng-model=\"account.filter\">\n            <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-xs-12 col-md-4\" ng-repeat=\"option in account.options | match:account.filter track by option.customer_number\">\n        <div class=\"dashboard-block\">\n          <h3>{{\'account.customer_number\' | translate}} {{option.customer_number}}</h3>\n          <p>{{option.name}}</p>\n          <a class=\"btn-custom btn-primary card-option-btn\" ng-click=\"account.select(option)\">\n            {{\'account.select_btn\' | translate}}\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/appointment/views/appointment.calendar.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1 ng-if=\"service.mode === \'Create\'\">{{\'msa.time_table.title.create\' | translate}}</h1>\n        <h1 ng-if=\"service.mode === \'Update\'\" translate=\"msa.time_table.title.update\" translate-value-issue=\"{{service.data.notify_damage_text}}\"></h1>\n        <h1 ng-if=\"service.mode === \'Delete\'\" translate=\"msa.time_table.title.delete\" translate-value-issue=\"{{service.data.notify_damage_text}}\"></h1>\n        <form name=\"service.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div ng-if=\"service.appointmentsSlots === null\">{{\'msa.time_table.loading_choices\' | translate}}</div>\n          <fieldset class=\"time-table-fieldset\">\n            <div class=\"radio\" ng-repeat=\"slot in service.appointmentsSlots\" ng-class=\"{\'first\': $first}\">\n              <label>\n                <input ng-checked=\"service.appointmentsSlots.length === 1\" type=\"radio\" ng-model=\"service.data.appointment\" ng-required=\"!service.data.appointment\" ng-value=\"slot.start\">\n                <span class=\"time-table-data first\">{{slot.start | date: \'dd MMM\'}}</span><span class=\"time-table-data\">{{slot.start | date: \'EEEE\'}}</span><span class=\"time-table-data\">{{slot.start | date: \'HH:mm\'}} - {{slot.end | date: \'HH:mm\'}}</span>\n              </label>\n            </div>\n            <!--<div class=\"radio\" ng-if=\"service.appointmentsSlots && service.appointmentsSlots.length <= 3\">-->\n              <!--<label>-->\n                <!--<input type=\"radio\" ng-model=\"service.data.appointment\" ng-required=\"!service.data.appointment\" value=\"other\">-->\n                <!--<span class=\"time-table-data first\">Anders</span>-->\n                <!--<span class=\"time-table-data\">-->\n                  <!--<div class=\"form-group\">-->\n                    <!--<label for=\"weekday\" class=\"sr-only\">Dag</label>-->\n                    <!--<select ng-required=\"service.data.appointment == \'other\'\" id=\"weekday\" class=\"form-control\" ng-model=\"service.data.appointment_other.weekday\" ng-options=\"day.value as day.timestamp | date : \'EEEE\' for day in service.weekday\">-->\n                      <!--<option value=\"\">Dag</option>-->\n                    <!--</select>-->\n                  <!--</div>-->\n                <!--</span>-->\n                <!--<span class=\"time-table-data\">-->\n                  <!--<div class=\"form-group\">-->\n                    <!--<label for=\"timeslot\" class=\"sr-only\">Dag</label>-->\n                    <!--<select ng-required=\"service.data.appointment == \'other\'\" id=\"timeslot\" class=\"form-control\" ng-model=\"service.data.appointment_other.timeslot\" ng-options=\"daypart.value as daypart.timeslot for daypart in service.dayparts\">-->\n                      <!--<option value=\"\">Dagdeel</option>-->\n                    <!--</select>-->\n                  <!--</div>-->\n                <!--</span>-->\n              <!--</label>-->\n            <!--</div>-->\n          </fieldset>\n\n          <button ng-disabled=\"service.form.$invalid || service.appointmentsSlots === null\" ng-click=\"service.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'msa.time_table.next_btn\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"service.cancel()\" title=\"Annuleren\">{{\'msa.time_table.cancel_btn\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/appointment/views/appointment.confirmation.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix rs-text\">\n        <h1 ng-if=\"service.mode === \'Create\'\" translate=\"msa.confirmation.title.create\"></h1>\n        <h1 ng-if=\"service.mode === \'Update\'\" translate=\"msa.confirmation.title.update\"></h1>\n        <h1 ng-if=\"service.mode === \'Delete\'\" translate=\"msa.confirmation.title.delete\"></h1>\n        <p>{{ \'msa.confirmation.page_text\' | translate}}</p>\n        <p ng-if=\"service.mode !== \'Delete\'\">{{ \'msa.confirmation.page_text_addendum\' | translate}}</p>\n        <button ng-click=\"service.next()\" type=\"button\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ service.btnTxt }}</button>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/appointment/views/appointment.email.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1 ng-if=\"service.mode === \'Create\'\">{{\'msa.choose_meter.title.create\' | translate}}</h1>\n        <h1 ng-if=\"service.mode === \'Update\'\" translate=\"msa.choose_meter.title.update\" translate-value-issue=\"{{service.data.notify_damage_text}}\"></h1>\n        <h1 ng-if=\"service.mode === \'Delete\'\" translate=\"msa.choose_meter.title.delete\" translate-value-issue=\"{{service.data.notify_damage_text}}\"></h1>\n\n        <div class=\"meter-service-form-block\">\n          <div>{{service.data.address.street}} {{service.data.address.house_no}} {{service.data.address.house_no_addition}}</div>\n          <div>{{service.data.address.postal_code}} {{service.data.address.city}}</div>\n        </div>\n\n        <form name=\"service.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{\'msa.choose_meter.email_address_confirmation\' | translate}}</label>\n            <input ng-required=\"true\" aria-required=\"true\" ng-model-options=\"$root.ngModelOptions\" check-email ng-model=\"service.data.email\" type=\"email\" class=\"form-control\" id=\"email\" placeholder=\"{{\'msa.choose_meter.email_address_confirmation\' | translate}}\">\n          </div>\n\n          <fieldset class=\"radiogroup-metertype\" ng-if=\"!service.isScheduled\">\n            <legend>{{\'msa.choose_meter.water_meter_selection\' | translate}}</legend>\n\n            <div class=\"radio\" ng-class=\"{\'first\' : $first}\" ng-repeat=\"meter in service.meterTypes\">\n              <label>\n                <input type=\"radio\" ng-model=\"service.data.meter_type\" ng-value=\"meter.value\">\n                {{ \'msa.choose_meter.\' + meter.type | translate }}\n                <div class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'msa.choose_meter.hints.information_view_\' + meter.type | translate }}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n                <img ng-src=\"/app/images/dynamic-meter-images/{{meter.type}}.jpg\" alt=\"{{ \'msa.choose_meter.\' + meter.type | translate }} meter\" class=\"image\">\n              </label>\n            </div>\n          </fieldset>\n\n          <button ng-disabled=\"service.form.$invalid\" ng-click=\"service.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'msa.choose_meter.next\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"service.cancel()\" title=\"{{\'msa.choose_meter.cancel\' | translate}}\">{{\'msa.choose_meter.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n\n\n\n");
$templateCache.put("app/components/appointment/views/appointment.servicenumber-form.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'msa.service_number_form.title\' | translate}}</h1>\n\n        <form name=\"service.form\" ng-model-options=\"$root.ngModelOptions\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"service_number\" class=\"required\">{{\'msa.service_number_form.service_number\' | translate}}</label>\n            <input ng-required=\"true\" aria-required=\"false\" check-number ng-model=\"service.data.service_number\" type=\"text\" class=\"form-control\" id=\"service_number\" placeholder=\"12345678\">\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"postal-code\" class=\"required\">{{\'msa.service_number_form.postal_code\' | translate}}</label>\n            <input ui-mask=\"9999 AA\" placeholder=\"{{\'msa.service_number_form.placeholder_postal_code\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"service.data.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\">\n          </div>\n\n          <button ng-disabled=\"service.form.$invalid || service.sendingData\" ng-click=\"service.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'msa.service_number_form.next\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/appointment/views/appointment.summary.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1 ng-if=\"service.mode === \'Create\'\">{{\'msa.summary.title.create\' | translate}}</h1>\n        <h1 ng-if=\"service.mode === \'Update\'\" translate=\"msa.summary.title.update\" translate-value-issue=\"{{service.summary.notify_damage_text}}\"></h1>\n        <h1 ng-if=\"service.mode === \'Delete\'\" translate=\"msa.summary.title.delete\" translate-value-issue=\"{{service.summary.notify_damage_text}}\"></h1>\n        <form name=\"service.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"meter-service-form-block\">\n            <a ui-sref=\"{{\'appointmentEmail\'+service.mode}}\" title=\"{{\'msa.summary.edit_your_information\' | translate}}\" class=\"edit-icon pull-right\">\n              <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n            </a>\n            <h3>{{\'msa.summary.your_information\' | translate}}</h3>\n            <div class=\"block-innner\">\n              <strong>{{\'msa.summary.connection_address\' | translate}}</strong>\n              <div>{{service.summary.address.street}} {{service.summary.address.house_no}} {{service.summary.address.house_no_addition}}</div>\n              <div>{{service.summary.address.postal_code}} {{service.summary.address.city}}</div>\n            </div>\n            <strong>{{\'msa.summary.email_address_confirmation\' | translate}}</strong>\n            <div>{{service.summary.email}}</div>\n          </div>\n\n          <div class=\"meter-service-form-block\" ng-if=\"!service.isScheduled\">\n            <a ui-sref=\"{{\'appointmentEmail\'+service.mode}}\" title=\"{{\'msa.summary.edit_preferred_meter\' | translate}}\" class=\"edit-icon pull-right\">\n              <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n            </a>\n            <h3>{{\'msa.summary.preferred_meter\' | translate}}</h3>\n            <div class=\"block-innner-col first\">\n              <img ng-src=\"/app/images/dynamic-meter-images/{{service.summary.meter_type.type}}.jpg\" alt=\"{{ \'msa.choose_meter.\' + service.summary.meter_type.type | translate }} meter\" class=\"image\">\n            </div>\n            <div class=\"block-innner-col\">\n              <strong>{{ \'msa.summary.\' + service.summary.meter_type.type | translate }}</strong>\n              <div>{{ \'msa.summary.text_\' + service.summary.meter_type.type | translate }}</div>\n            </div>\n          </div>\n\n          <div class=\"meter-service-form-block\">\n            <a ui-sref=\"{{\'appointmentCalendar\'+service.mode}}\" title=\"{{\'msa.summary.edit_date_and_time\' | translate}}\" class=\"edit-icon pull-right\">\n              <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n            </a>\n            <h3>{{\'msa.summary.date_and_time\' | translate}}</h3>\n            <div class=\"block-innner\" ng-if=\"service.summary.appointment.start && service.summary.appointment !== \'other\'\">\n              <div>{{ service.summary.appointment.start | date : \'EEEE dd MMMM\'}}</div>\n              <div>{{ service.summary.appointment.start | date : \'HH:mm\'}} - {{ service.summary.appointment.end | date : \'HH:mm\'}}</div>\n            </div>\n            <div class=\"block-innner\" ng-if=\"service.summary.appointment_other && service.summary.appointment === \'other\'\">\n              <div>{{ service.summary.appointment_other.weekday.timestamp | date : \'EEEE\'}} - {{ service.summary.appointment_other.timeslot.timeslot | date : \'EEEE\'}}</div>\n            </div>\n          </div>\n\n\n          <div class=\"checkbox\">\n            <label>\n              <input type=\"checkbox\" ng-model=\"service.data.bAgree\" ng-required=\"true\"> {{\'msa.summary.agree\' | translate}}\n            </label>\n          </div>\n\n          <button ng-disabled=\"service.form.$invalid || service.sendingData\" ng-click=\"service.save()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{\'msa.summary.\' + service.mode + \'_appointment\' | lowercase | translate }}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"service.cancel()\" title=\"{{\'msa.summary.cancel\' | translate}}\">{{\'msa.summary.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/authentication/views/authentication.forgot-password.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'forgot_password.page_title\' | translate}}</h1>\n\n        <form ng-if=\"!password.bEmailSent\" name=\"password.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <div class=\"form-group\" translate=\"forgot_password.text\"></div>\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{ \'forgot_password.email\' | translate}}</label>\n            <input check-email ng-required=\"true\" ng-model=\"password.form.email\" type=\"email\" class=\"form-control\" id=\"email\" placeholder=\"{{ \'forgot_password.email\' | translate}}\">\n            <div ng-if=\"\'forgot_password.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'forgot_password.hints.email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <button ng-disabled=\"password.form.$invalid || password.sendingData\" ng-click=\"password.resetPassword()\" title=\"{{ \'forgot_password.forgot_btn\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right\">{{ \'forgot_password.forgot_btn\' | translate}}</button>\n        </form>\n\n        <div ng-if=\"password.bEmailSent\">{{ \'forgot_password.emailSent\' | translate}}</div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/authentication/views/authentication.restore-password.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'forgot_password.page_title\' | translate}}</h1>\n        <p>{{ \'forgot_password.please_wait\' | translate}}</p>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/banners/views/banners.view.html","<div class=\"row\" ng-if=\"banner.banners\">\n  <div class=\"col-xxs-custom col-xs-4 col-md-12\" ng-repeat=\"banner in banner.banners\">\n    <div ng-if=\"banner.type === \'banner-01\' && banner.content.titel.data && banner.content.link.data\">\n      <a target=\"{{banner.content.target.index}}\" href=\"{{banner.content.link.data}}\" title=\"{{banner.content.titel.data}}\">\n        <div class=\"side-content-item\">\n          <div class=\"side-content-item-text\">{{banner.content.titel.data}}</div>\n        </div>\n      </a>\n    </div>\n    <div ng-if=\"banner.type === \'banner-01\' && banner.content.titel.data && !banner.content.link.data\">\n      <div class=\"side-content-item\">\n        <div class=\"side-content-item-text\">{{banner.content.titel.data}}</div>\n      </div>\n    </div>\n\n    <div ng-if=\"banner.type === \'banner-02\' && banner.content.link.data && banner.content.img.bMediaAvailable && banner.content.img.image.bMediaAvailable\">\n      <a target=\"{{banner.content.target.index}}\" href=\"{{banner.content.link.data}}\" title=\"{{banner.content.titel.data}}\">\n        <div class=\"side-content-item\">\n          <img class=\"side-content-item-image\" alt=\"{{banner.content.img.description}}\" ng-src=\"{{banner.content.img.image.mediaSrc}}\">\n        </div>\n      </a>\n    </div>\n    <div ng-if=\"banner.type === \'banner-02\' && !banner.content.link.data && banner.content.img.bMediaAvailable && banner.content.img.image.bMediaAvailable\">\n      <div class=\"side-content-item\">\n        <img class=\"side-content-item-image\" alt=\"{{banner.content.img.description}}\" ng-src=\"{{banner.content.img.image.mediaSrc}}\">\n      </div>\n    </div>\n\n    <div ng-if=\"banner.type === \'banner-03\' && banner.content.titel.data && banner.content.link.data && banner.content.img.bMediaAvailable && banner.content.img.image.bMediaAvailable\">\n      <a target=\"{{banner.content.target.index}}\" href=\"{{banner.content.link.data}}\" title=\"{{banner.content.titel.data}}\">\n        <div class=\"side-content-item\">\n          <div class=\"side-content-item-overlay\"></div>\n          <img class=\"side-content-item-image\" alt=\"{{banner.content.img.description}}\" ng-src=\"{{banner.content.img.image.mediaSrc}}\">\n          <div class=\"side-content-item-text\">{{banner.content.titel.data}}</div>\n        </div>\n      </a>\n    </div>\n    <div ng-if=\"banner.type === \'banner-03\' && banner.content.titel.data && !banner.content.link.data && banner.content.img.bMediaAvailable && banner.content.img.image.bMediaAvailable\">\n      <div class=\"side-content-item\">\n        <div class=\"side-content-item-overlay\"></div>\n        <img class=\"side-content-item-image\" alt=\"{{banner.content.img.description}}\" ng-src=\"{{banner.content.img.image.mediaSrc}}\">\n        <div class=\"side-content-item-text\">{{banner.content.titel.data}}</div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/billing-information/views/billing-information.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'customer.billing_information.page_title\' | translate}}</h1>\n\n        <form name=\"billingInformation.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <div class=\"form-group usage-form-block\">\n            <label class=\"group-label required\">{{ \'customer.billing_information.sendcontrol_label\' | translate }}</label>\n            <div ng-if=\"\'customer.billing_information.hints.sendcontrol\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.billing_information.hints.sendcontrol\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n            <div class=\"radio\" ng-repeat=\"option in billinginformation.sendcontrol track by $index\">\n              <label>\n                <input ng-model=\"billinginformation.data.sendcontrol\" type=\"radio\" name=\"optionsRadios\" id=\"{{\'optionsRadios\' + $index}}\" ng-value=\"option.value\">\n                {{ \'customer.billing_information.sendcontrol.option_\' + option.value | translate}}\n              </label>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"billinginformation.data.is_digital\">\n            <div ng-if=\"\'customer.billing_information.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.billing_information.hints.email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n            <label for=\"billing-email\" class=\"required\">{{ \'customer.billing_information.email\' | translate }}</label>\n            <input ng-model=\"billinginformation.data.email\" type=\"text\" class=\"form-control\" id=\"billing-email\" check-email ng-required=\"billinginformation.data.is_digital\">\n          </div>\n\n          <button ng-disabled=\"billingInformation.form.$invalid || billingInformation.sendingData\" ng-click=\"billinginformation.save()\" title=\"Opslaan\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'customer.billing_information.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"customer\" title=\"{{ \'customer.billing_information.cancel\' | translate}}\">{{ \'customer.billing_information.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/carafe/views/carafe.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n      <div ui-view=\"banners\"></div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"detail.data.Content.title.data\">{{detail.data.Content.title.data}}</h1>\n          <div ng-if=\"detail.data.Content.intro.data\" class=\"intro-text\">{{detail.data.Content.intro.data}}</div>\n          <h2 class=\"page-intro-title\" ng-if=\"detail.data.Content.title_block_1.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_1.data}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.text_block_1.data\" ng-bind-html=\"detail.data.Content.text_block_1.data\"></div>\n        </div>\n      </div>\n      <div class=\"row content\">\n        <div class=\"col-xs-12\">\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_1.bMediaAvailable && detail.data.Content.detail_image_1.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_1.description}}\" ng-src=\"{{detail.data.Content.detail_image_1.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.title_block_2.data || detail.data.Content.text_block_2.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_2.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_2.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_2.data\" ng-bind-html=\"detail.data.Content.text_block_2.data\"></div>\n          </div>\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_2.bMediaAvailable && detail.data.Content.detail_image_2.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_2.description}}\" ng-src=\"{{detail.data.Content.detail_image_2.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.text_block_2_2.data\">\n            <div ng-bind-html=\"detail.data.Content.text_block_2_2.data\"></div>\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video2.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video2.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video2.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.title_block_3.data || detail.data.Content.text_block_3.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_3.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_3.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_3.data\" ng-bind-html=\"detail.data.Content.text_block_3.data\"></div>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_3_left.data || detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Links\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_3_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"detail.data.Content.text_block_3_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Rechts\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video3.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video3.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video3.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_4_left.data || detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Links\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_4_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"detail.data.Content.text_block_4_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Rechts\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n          </div>\n\n\n          <div class=\"row standpipe-form form-wrapper\" ng-if=\"detail.bShowForm\">\n            <div class=\"col-md-12\">\n              <div class=\"form\">\n                <form name=\"detail.form\" class=\"clearfix vacancy-form\" novalidate=\"novalidate\">\n                  <fieldset>\n                    <legend>{{\'carafe.form.legend_company_info\' | translate}}</legend>\n                    <div class=\"form-group\">\n                      <label for=\"kvk-number\" class=\"required\">{{\'carafe.form.kvk_number\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"kvk-number\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.company.kvk_number\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"client_name\" class=\"required\">{{\'carafe.form.company_name\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"client_name\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.company.name\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"contact_name\" class=\"required\">{{\'carafe.form.contact_person_name\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"contact_name\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.contact_person.name\">\n                    </div>\n                    <div class=\"form-group\">\n                      <label for=\"contact_phone\" class=\"required\">{{\'carafe.form.contact_person_phone\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"contact_phone\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.contact_person.phone\">\n                    </div>\n                    <div class=\"form-group\">\n                      <label for=\"contact_email\" class=\"required\">{{\'carafe.form.contact_person_email\' | translate}}</label>\n                      <input check-email ng-required=\"true\" aria-required=\"true\" id=\"contact_email\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.contact_person.email\">\n                    </div>\n                  </fieldset>\n                  <fieldset>\n                    <legend>{{\'carafe.form.legend_address\' | translate}}</legend>\n                    <div class=\"form-group\">\n                      <label for=\"street\" class=\"required\">{{\'carafe.form.company_street\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"street\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.company.street\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"postal-code\" class=\"required\">{{\'carafe.form.postal_code\' | translate}}</label>\n                      <input ui-mask=\"9999 AA\" placeholder=\"{{\'carafe.form.placeholder_postal_code\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"detail.formData.company.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\">\n                    </div>\n\n                    <div class=\"form-group clearfix\">\n                      <label for=\"housenumber\" class=\"required\">{{\'carafe.form.company_house_number\' | translate}}</label><br>\n                      <div class=\"medium\">\n                        <input check-number ng-required=\"true\" ng-model=\"detail.formData.company.house_number\" type=\"text\" class=\"form-control\" id=\"housenumber\" placeholder=\"{{\'carafe.form.placeholder_housenumber\' | translate}}\">\n                      </div>\n                      <div class=\"small\">\n                        <input ng-model=\"detail.formData.company.house_number_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"house-number-addition\" placeholder=\"{{\'carafe.form.placeholder_housenumber_additions\' | translate}}\">\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"city\" class=\"required\">{{\'carafe.form.company_city\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"city\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.company.city\">\n                    </div>\n                  </fieldset>\n                  <fieldset>\n                    <legend class=\"required\">{{\'carafe.form.legend_order\' | translate}}</legend>\n                    <div class=\"form-group\">\n                      <div class=\"checkbox\">\n                        <label for=\"introduction\">\n                          <input aria-required=\"false\" type=\"checkbox\" id=\"introduction\" ng-model=\"detail.formData.order.type.introduction\">\n                          {{\'carafe.form.choose_type_option_first_set\' | translate}}\n                        </label>\n                      </div>\n                    </div>\n                    <div class=\"form-group\">\n                      <div class=\"checkbox\">\n                        <label for=\"subsequent\">\n                          <input aria-required=\"false\" type=\"checkbox\" id=\"subsequent\" ng-model=\"detail.formData.order.type.subsequent\">\n                          {{\'carafe.form.choose_type_option_extra\' | translate}}\n                        </label>\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\" ng-if=\"detail.formData.order.type.subsequent\">\n                      <label for=\"extra-sets\" class=\"required\">{{\'carafe.form.order_amount\' | translate}}</label>\n                      <input check-number ng-required=\"true\" aria-required=\"true\" id=\"extra-sets\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.order.amount\">\n                    </div>\n                    <div class=\"form-group\">\n                      <label for=\"remarks\" class=\"required\">{{\'carafe.form.questions\' | translate}}</label>\n                      <textarea rows=\"3\" ng-model=\"detail.formData.order.remarks\" class=\"form-control\" id=\"remarks\"></textarea>\n                    </div>\n                    <div class=\"form-group\">\n                      <div class=\"checkbox\">\n                        <label for=\"accept_conditions_2\" class=\"required\">\n                          <input ng-required=\"true\" aria-required=\"true\" type=\"checkbox\" id=\"accept_conditions_2\" ng-model=\"detail.formData.conditions_accepted\">\n                          <span translate=\"carafe.form.accept_conditions\"></span>\n                        </label>\n                      </div>\n                    </div>\n                  </fieldset>\n                  <div class=\"btn-group pull-right\">\n                    <button ng-disabled=\"detail.form.$invalid || detail.sendingData || (detail.formData.order.type.introduction === false && detail.formData.order.type.subsequent === false)\" class=\"btn-primary btn-custom\" ng-click=\"detail.send()\">{{\'carafe.form.btn_send\' | translate}}</button>\n                  </div>\n                </form>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form detail-form\">\n            <h2>{{detail.bottomBlock.title}}</h2>\n            <p>{{detail.bottomBlock.text}}</p>\n            <button class=\"btn btn-primary btn-custom\" ui-sref=\"dashboard\">{{detail.bottomBlock.button}}</button>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/contact/views/business.contact.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'business_contact.page_title\' | translate}}</h1>\n\n        <form name=\"contact.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\" ng-submit=\"contact.submitForm()\">\n\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"company\">{{ \'business_contact.company\' | translate}}</label>\n            <input type=\"text\" ng-model=\"contact.data.company\" class=\"form-control\" ng-required=\"true\" id=\"company\">\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"contact-person\">{{ \'business_contact.contact_person\' | translate}}</label>\n            <input type=\"text\" ng-model=\"contact.data.contact_person\" class=\"form-control\" ng-required=\"true\" id=\"contact-person\">\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"phone_number\">{{ \'business_contact.phone_number\' | translate}}</label>\n            <input pattern=\"^[0-9\\s+]+$\" type=\"text\" ng-model=\"contact.data.phone_number\" class=\"form-control\" ng-required=\"true\" id=\"phone_number\">\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"email\">{{ \'business_contact.email\' | translate}}</label>\n            <input check-email type=\"text\" id=\"email\" class=\"form-control\" ng-required=\"true\" ng-model=\"contact.data.email\">\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"subject\">{{ \'business_contact.subject\' | translate}}</label>\n            <select id=\"subject\" class=\"form-control\" ng-required=\"true\" ng-model=\"contact.data.subject\" ng-options=\"subject.value as subject.label for subject in contact.subjects\">\n              <option value=\"\">{{ \'business_contact.option_choice\' | translate}}</option>\n            </select>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"message\">{{ \'business_contact.message\' | translate}}</label>\n            <textarea id=\"message\" ng-model=\"contact.data.message\" ng-required=\"true\" class=\"form-control\"></textarea>\n          </div>\n          <div class=\"form-group\">\n            <input ng-disabled=\"contact.form.$invalid\" type=\"submit\" value=\"{{ \'business_contact.btn\' | translate}}\" class=\"btn-primary btn-custom\">\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6 rs-text\">\n      <div ng-if=\"contact.contactInformation.Content.info.data\" ng-bind-html=\"contact.contactInformation.Content.info.data\"></div>\n      <div ng-if=\"contact.contactInformation.Content.info_cmv.data\" ng-bind-html=\"contact.contactInformation.Content.info_cmv.data\"></div>\n      <div ng-if=\"contact.contactInformation.Content.info_ks.data\" ng-bind-html=\"contact.contactInformation.Content.info_ks.data\"></div>\n      <div ng-if=\"contact.contactInformation.Content.info_visitors.data\" ng-bind-html=\"contact.contactInformation.Content.info_visitors.data\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/contact/views/contact.thank-you.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <div class=\"form rs-text\">\n        <h1>{{ \'contact.thank_you.page_title\' | translate}}</h1>\n        <p>{{ \'contact.thank_you.text\' | translate}}</p>\n        <a ng-if=\"contact.bAuthenticated\" ui-sref=\"dashboard\" class=\"btn-primary btn-custom\">{{\'contact.thank_you.btn\' | translate}}</a>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/contact/views/contact.view.html","<div id=\"player\" style=\"position: fixed; top: 0px; right: 0px; width: 1px; height: 1px; border: 0px solid Black\"></div>\n<iframe id=\"iplayer\" style=\"position: absolute; top: 2px; right: 0px; width: 1px; height: 1px; border: 0\"></iframe>\n<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n\n        <h1>{{ \'contact.page_title.main\' | translate}}</h1>\n\n        <div ng-show=\"contact.activepart === 1\" id=\"contact-form-subject\">\n          <h3>{{\'contact.page_title.step1\' | translate}}</h3>\n          <p class=\"content\">{{\'contact.subject.content\' | translate}}</p>\n          <br>\n          <form name=\"contact.forms.subject\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n            <div ng-if=\"contact.subjects\" class=\"form-group\">\n              <label for=\"contact-contact-type\" class=\"required\">{{ \'contact.subject_choice\' | translate}}</label>\n              <select ng-required=\"true\" id=\"contact-contact-type\" class=\"form-control\" ng-model=\"contact.data.contact_type\" ng-options=\"key as value.webContactType for (key, value) in contact.subjects\">\n                <option value=\"\">{{ \'contact.choose_option\' | translate}}</option>\n              </select>\n            </div>\n\n            <div ng-show=\"contact.data.contact_type && contact.subjects[contact.data.contact_type].contactReasons\" class=\"form-group\">\n              <select ng-required=\"contact.subjects[contact.data.contact_type].contactReasons\" id=\"contact-contact-reason\" class=\"form-control\" ng-model=\"contact.data.contact_reason\" ng-options=\"key as value for (key, value) in contact.subjects[contact.data.contact_type].contactReasons\">\n                <option value=\"\">{{ \'contact.choose_option\' | translate}}</option>\n              </select>\n            </div>\n\n            <div ng-show=\"contact.data.contact_type && (!contact.subjects[contact.data.contact_type].contactReasons || contact.data.contact_reason)\" class=\"form-group\">\n              <label for=\"question\" class=\"required\">{{ \'contact.question\' | translate}}</label>\n              <textarea rows=\"10\" ng-required=\"true\" ng-model=\"contact.data.message\" class=\"form-control\" id=\"question\" placeholder=\"{{ \'contact.question\' | translate}}\"></textarea>\n            </div>\n\n            <div ng-show=\"contact.data.contact_type && (!contact.subjects[contact.data.contact_type].contactReasons || contact.data.contact_reason)\" class=\"form-group\">\n              <label for=\"fileUpload\">{{ \'contact.file_upload\' | translate}}</label>\n              <div class=\"file-upload-container\">\n                <input ng-value=\"contact.fileToUpload.name\" ng-required=\"false\" ngf-resize=\"{width: 1200, height: 1200, quality: .8}\" ng-disabled=\"true\" type=\"text\" class=\"form-control\" id=\"filenameField\" placeholder=\"\">\n                <button class=\"btn-custom btn-file btn-primary button-margin-left\" ngf-max-size=\"20MB\" ngf-select=\"contact.fileChange($file, $invalidFiles);\" class=\"hidden\" ng-required=\"false\" ng-model=\"contact.data.fileUpload\" id=\"fileUpload\" name=\"fileUpload\" type=\"file\" ngf-accept=\"\'application/pdf, image/jpeg, image/png, image/gif, .doc, .docx, .xls, .xlsx, .odt, .ods\'\">\n                  <label for=\"fileUpload\">{{ \'contact.file_upload_btn\' | translate}}</label>\n                </button>\n              </div>\n              <div class=\"clearfix\"></div>\n              <div class=\"field-description\">{{ \'contact.file_upload_description\' | translate }}</div>\n            </div>\n\n            <button ng-disabled=\"contact.forms.subject.$invalid\" ng-click=\"contact.next(\'subject\')\" type=\"button\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'contact.next_btn\' | translate}}</button>\n            <button ng-click=\"contact.cancel()\" type=\"button\" class=\"btn-custom btn-cancel pull-right\">{{ \'contact.cancel_btn\' | translate}}</button>\n          </form>\n        </div>\n\n        <div ng-show=\"contact.activepart === 2\" id=\"contact-form-customer\">\n<!--          <h3>{{\'contact.customer_data_title\' | translate}}</h3>-->\n          <h3>{{\'contact.page_title.step2\' | translate}}</h3>\n          <form name=\"contact.forms.customer\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n            <div class=\"form-group\">\n              <label for=\"customer-number\">{{ \'contact.customernumber\' | translate}}</label>\n              <input check-number ng-minlength=\"8\" ng-maxlength=\"8\" ng-trim=\"false\" limit-to=\"8\" ng-model=\"contact.data.customer_number\" type=\"text\" class=\"form-control\" id=\"customer-number\" placeholder=\"{{ \'contact.customernumber_placeholder\' | translate}}\">\n              <div class=\"field-description\">{{ \'contact.customernumber_description\' | translate}}</div>\n              <div ng-if=\"\'contact.hints.customernumber\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact.hints.customernumber\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div ng-if=\"(contact.connectionAdresses.length <= 1 && contact.bAuthenticated) || !contact.bAuthenticated\">\n\n              <div class=\"form-group\">\n                <label for=\"contact-premises-postal-code\" class=\"required\">{{\'contact.postal_code\' | translate}}</label>\n                <input ng-required=\"true\" ui-mask=\"9999 AA\" placeholder=\"{{ \'contact.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-model=\"contact.data.premises.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"contact-premises-postal-code\" ng-blur=\"contact.autofillHouseNo(contact.data.premises)\">\n                <div ng-if=\"\'contact.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"contact-premises-housenumber\" class=\"required\">{{ \'contact.house_number\' | translate}} & {{ \'contact.house_number_addition\' | translate}}</label><br>\n                <div class=\"correspondence-medium-input\">\n                  <input check-number ng-required=\"true\" ng-model=\"contact.data.premises.house_no\" type=\"text\" class=\"form-control\" id=\"contact-premises-housenumber\" placeholder=\"\" ng-blur=\"contact.autofillHouseNo(contact.data.premises)\">\n                </div>\n                <div class=\"correspondence-small-input\">\n                  <input ng-model=\"contact.data.premises.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"contact-premises-house-number-addition\" placeholder=\"\" ng-blur=\"contact.autofillHouseNo(contact.data.premises)\">\n                </div>\n                <div ng-if=\"\'contact.hints.house_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact.hints.house_number\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label for=\"contact-premises-street\" class=\"required\">{{\'contact.street\' | translate}}</label>\n                <div class=\"form-loader-wrap\">\n                  <div ng-if=\"contact.data.premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                  <input ng-disabled=\"contact.data.customer_number\" ng-required=\"true\" ng-model=\"contact.data.premises.street\" type=\"text\" class=\"form-control\" id=\"contact-premises-street\" placeholder=\"\">\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label for=\"contact-premises-city\" class=\"required\">{{\'contact.place\' | translate}}</label>\n                <div class=\"form-loader-wrap\">\n                  <div ng-if=\"contact.data.premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                  <input ng-disabled=\"contact.data.customer_number\" ng-required=\"true\" ng-model=\"contact.data.premises.city\" type=\"text\" class=\"form-control\" id=\"contact-premises-city\" placeholder=\"\">\n                </div>\n              </div>\n\n            </div>\n\n            <div ng-if=\"contact.connectionAdresses.length > 1 && contact.bAuthenticated\">\n              <div class=\"form-group\">\n                <label for=\"contact-premises\" class=\"required\">{{\'contact.choose_premises\' | translate}}</label>\n                <select id=\"contact-premises\" class=\"form-control\" ng-model=\"contact.data.premises\" ng-options=\"premises.address as premises.address.street+\' \'+premises.address.house_no+premises.address.house_no_addition+\', \'+premises.address.postal_code+\' \'+premises.address.city  for premises in contact.connectionAdresses\">\n                  <option ng-if=\"contact.connectionAddresses.length > 1\" value=\"\">{{\'contact.choose_option\'}}</option>\n                </select>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <div class=\"group-label\">{{ \'contact.other_address.check.label\' | translate}}</div>\n              <div class=\"radio\">\n                <label>\n                  <input ng-model=\"contact.data.other_address.check\" type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios1\" ng-value=\"false\">\n                  {{ \'contact.other_address.check.yes\' | translate}}\n                </label>\n              </div>\n              <div class=\"radio\">\n                <label>\n                  <input ng-model=\"contact.data.other_address.check\" type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios2\" ng-value=\"true\">\n                  {{ \'contact.other_address.check.no\' | translate}}\n                </label>\n              </div>\n            </div>\n\n            <div ng-if=\"contact.data.other_address.check\">\n              <div class=\"form-group\">\n                <label for=\"contact-premises-postal-code\" class=\"required\">{{\'contact.other_address.postal_code\' | translate}}</label>\n                <input ng-required=\"true\" ui-mask=\"9999 AA\" placeholder=\"{{ \'contact.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-model=\"contact.data.other_address.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"contact-other_address-postal-code\" ng-blur=\"contact.autofillHouseNo(contact.data.other_address)\">\n                <div ng-if=\"\'contact.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"contact-premises-housenumber\" class=\"required\">{{ \'contact.other_address.house_number\' | translate}} & {{ \'contact.other_address.house_number_addition\' | translate}}</label><br>\n                <div class=\"correspondence-medium-input\">\n                  <input check-number ng-required=\"true\" ng-model=\"contact.data.other_address.house_no\" type=\"text\" class=\"form-control\" id=\"contact-other_address-housenumber\" placeholder=\"\" ng-blur=\"contact.autofillHouseNo(contact.data.other_address)\">\n                </div>\n                <div class=\"correspondence-small-input\">\n                  <input ng-model=\"contact.data.other_address.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"contact-other_address-house-number-addition\" placeholder=\"\" ng-blur=\"contact.autofillHouseNo(contact.data.other_address)\">\n                </div>\n                <div ng-if=\"\'contact.hints.house_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact.hints.house_number\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label for=\"contact-premises-street\" class=\"required\">{{\'contact.other_address.street\' | translate}}</label>\n                <div class=\"form-loader-wrap\">\n                  <div ng-if=\"contact.data.other_address.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                  <input ng-required=\"true\" ng-model=\"contact.data.other_address.street\" type=\"text\" class=\"form-control\" id=\"contact-other_address-street\" placeholder=\"\">\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label for=\"contact-premises-city\" class=\"required\">{{\'contact.other_address.place\' | translate}}</label>\n                <div class=\"form-loader-wrap\">\n                  <div ng-if=\"contact.data.other_address.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                  <input ng-required=\"true\" ng-model=\"contact.data.other_address.city\" type=\"text\" class=\"form-control\" id=\"contact-other_address-city\" placeholder=\"\">\n                </div>\n              </div>\n            </div>\n\n            <button ng-disabled=\"contact.forms.customer.$invalid\" ng-click=\"contact.next(\'customer\')\" type=\"button\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'contact.next_btn\' | translate}}</button>\n            <button ng-click=\"contact.prev()\" type=\"button\" class=\"btn-custom btn-primary pull-right\">{{ \'contact.previous_btn\' | translate}}</button>\n          </form>\n        </div>\n\n        <div ng-show=\"contact.activepart === 3\" id=\"contact-form-contact\">\n          <h3>{{\'contact.page_title.step3\'| translate}}</h3>\n          <form name=\"contact.forms.contact\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n            <div class=\"form-group\">\n              <label for=\"name\" class=\"required\">{{ \'contact.name\' | translate}}</label>\n              <input ng-required=\"true\" ng-model=\"contact.data.name\" type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"{{ \'contact.name\' | translate}}\">\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"email\" class=\"required\">{{ \'contact.email\' | translate}}</label>\n              <input check-email ng-required=\"true\" ng-model=\"contact.data.email\" type=\"text\" class=\"form-control\" id=\"email\" placeholder=\"{{ \'contact.email\' | translate}}\">\n              <div ng-if=\"\'contact.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact.hints.email\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"phone\">{{ \'contact.phone\' | translate}}</label>\n              <input check-number ng-trim=\"false\" limit-to=\"10\" ng-minlength=\"10\" ng-model=\"contact.data.phone\" type=\"text\" class=\"form-control\" id=\"phone\" placeholder=\"{{ \'contact.phone\' | translate}}\">\n              <div ng-if=\"\'contact.hints.phone\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact.hints.phone\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"mobile_phone\">{{ \'contact.mobile_phone\' | translate}}</label>\n              <input check-number limit-to=\"10\" ng-minlength=\"10\" ng-model=\"contact.data.mobile_phone\" type=\"text\" class=\"form-control\" id=\"mobile_phone\" placeholder=\"{{ \'contact.mobile_phone\' | translate}}\">\n              <div ng-if=\"\'contact.hints.mobile_phone\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact.hints.mobile_phone\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"contact-time-bracket\" class=\"required\">{{ \'contact.time_bracket.label\' | translate}}</label>\n              <select ng-required=\"true\" id=\"contact-time-bracket\" class=\"form-control\" ng-model=\"contact.data.timeBracket\" ng-options=\"tValue for (tKey, tValue) in contact.timeBrackets\">\n                <option value=\"\">{{ \'contact.choose_option\' | translate}}</option>\n              </select>\n            </div>\n\n            <button ng-disabled=\"contact.forms.contact.$invalid || contact.sendingData\" ng-click=\"contact.send()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'contact.send_btn\' | translate}}</button>\n            <button ng-click=\"contact.prev()\" type=\"button\" class=\"btn-custom btn-primary pull-right\">{{ \'contact.previous_btn\' | translate}}</button>\n          </form>\n        </div>\n\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6 rs-text\">\n      <div ng-if=\"contact.contactInformation.Content.info.data\" ng-bind-html=\"contact.contactInformation.Content.info.data\"></div>\n      <div ng-if=\"!contact.isCompany && contact.contactInformation.Content.info_ks.data\" ng-bind-html=\"contact.contactInformation.Content.info_ks.data\"></div>\n      <div ng-if=\"contact.isCompany && contact.contactInformation.Content.info_cmv.data\" ng-bind-html=\"contact.contactInformation.Content.info_cmv.data\"></div>\n      <div ng-if=\"contact.contactInformation.Content.info_visitors.data\" ng-bind-html=\"contact.contactInformation.Content.info_visitors.data\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/contactperson/views/contactperson.form.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'contact_persons.page_title\' | translate}}</h1>\n\n        <form name=\"contactperson.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n\n          <div class=\"form-group\">\n            <label for=\"contactperson-firstname\">{{ \'contact_persons.firstName\' | translate }}</label>\n            <input ng-model=\"contactperson.data.firstname\" type=\"text\" class=\"form-control\" id=\"contactperson-firstname\">\n            <div ng-if=\"\'contact_persons.hints.firstName\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.firstName\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"insertion\">{{\'contact_persons.insertion\' | translate}}</label>\n\n            <select ng-model=\"contactperson.data.insertion\" class=\"form-control\" id=\"insertion\" ng-options=\"insertion.value as insertion.label for insertion in contactperson.insertions\">\n              <option value=\"\"></option>\n            </select>\n            <div ng-if=\"\'contact_persons.hints.insertion\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.insertion\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"contactperson-lastname\" class=\"required\">{{ \'contact_persons.lastName\' | translate }}</label>\n            <input ng-required=\"true\" ng-model=\"contactperson.data.lastname\" type=\"text\" class=\"form-control\" id=\"contactperson-lastname\">\n            <div ng-if=\"\'contact_persons.hints.lastName\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.lastName\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"contactperson-email\" class=\"required\">{{ \'contact_persons.email\' | translate}}</label>\n            <input server-side-validation=\"email\" check-email ng-required=\"true\" ng-model=\"contactperson.data.email\" type=\"email\" class=\"form-control\" id=\"contactperson-email\" placeholder=\"{{ \'contact_persons.email\' | translate}}\">\n            <div ng-if=\"\'contact_persons.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"contactperson-phonenumber\">{{ \'contact_persons.phone\' | translate}}</label>\n            <input server-side-validation=\"phone\" check-number ng-model=\"contactperson.data.phone\" ng-minlength=\"10\" ng-trim=\"false\" limit-to=\"10\" type=\"text\" class=\"form-control\" id=\"contactperson-phonenumber\" placeholder=\"{{ \'contact_persons.phone\' | translate}}\">\n            <div ng-if=\"\'contact_persons.hints.phone\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.phone\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <button ng-disabled=\"contactperson.form.$invalid || contactperson.sendingData\" ng-click=\"contactperson.save()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'contact_persons.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"customer\" title=\"{{ \'contact_persons.cancel\' | translate}}\">{{ \'contact_persons.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n\n\n\n");
$templateCache.put("app/components/corporation/views/choose-address.corporation.view.html","<div class=\"container\">\n  <div class=\"card-options-wrapper\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <h1>{{\'corporation.title\' | translate}}</h1>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"card-options-margin-seperator\">\n        <div class=\"col-xs-12 col-md-6\">\n          <p>{{\'corporation.text\' | translate}}</p>\n        </div>\n        <div class=\"col-xs-12 col-md-6\">\n          <div class=\"card-options-search-wrapper card-options-filter-option\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{\'corporation.search\' | translate}}\" ng-model=\"corporation.filter\">\n            <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n          </div>\n          <div class=\"card-options-filter-option pull-right\">\n            <select ng-change=\"corporation.activate()\" class=\"form-control\" ng-model=\"corporation.addressesStatus\">\n              <option ng-value=\"true\" selected=\"selected\">{{\'corporation.filter_active\' | translate}}</option>\n              <option ng-value=\"false\">{{\'corporation.filter_inActive\' | translate}}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-xs-12 col-md-4\" ng-repeat=\"option in corporation.addresses | matchCorporationFilter:corporation.filter track by $index\">\n        <div class=\"dashboard-block\">\n          <p>\n            <strong>{{\'corporation.contract_address_title\' | translate}}</strong><br>\n            {{option.street}} {{option.house_number}} {{option.house_number_addition}}<br>{{option.postal_code}} {{option.city}}\n          </p>\n          <p>\n            <strong>{{\'corporation.contract_info_title\' | translate}}</strong><br>\n            {{\'corporation.contract_id_no\' | translate}} {{option.contract_id}}<br>\n            {{\'corporation.contract_meter_no\' | translate}} {{option.serial_number_id}} <br>\n            {{\'corporation.contract_install_no\' | translate}} {{option.installation_id}}\n          </p>\n          <p>\n            <strong>{{\'corporation.contract_active_title\' | translate}}</strong><br>\n            {{\'corporation.active_from\' | translate}} {{option.contract_start_date | date:\'dd-MM-yyyy\'}}<br>\n            {{\'corporation.active_to\' | translate}} <span ng-if=\"option.contract_end_date\">{{option.contract_end_date | date:\'dd-MM-yyyy\'}}</span><span ng-if=\"!option.contract_end_date\">{{\'corporation.active_now\' | translate}}</span>\n          </p>\n\n          <a class=\"btn-custom btn-primary card-option-btn\" ng-click=\"corporation.select(option)\">\n            {{\'corporation.select_btn\' | translate}}\n          </a>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n");
$templateCache.put("app/components/correspondence/views/correspondence.edit.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'customer.correspondence.page_title\' | translate}}</h1>\n        <form name=\"correspondence.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"correspondence-form-block\">\n            <strong>{{\'customer.correspondence.current_correspondence\' | translate}}</strong>\n            <div ng-if=\"correspondence.correspondenceAddress.po_box.length\">{{\'customer.correspondence.po_box\' | translate}} {{correspondence.correspondenceAddress.po_box}}, {{correspondence.correspondenceAddress.po_box_postal_code}} {{correspondence.correspondenceAddress.city}}</div>\n            <div ng-if=\"correspondence.correspondenceAddress.po_box.length == 0\">{{correspondence.correspondenceAddress.street}} {{correspondence.correspondenceAddress.house_no}} {{correspondence.correspondenceAddress.house_no_addition}}, {{correspondence.correspondenceAddress.postal_code}} {{correspondence.correspondenceAddress.city}}</div>\n          </div>\n          <strong>{{\'customer.correspondence.new_correspondence\' | translate}}</strong>\n          <div ng-if=\"correspondence.bShowPremisesSelection\">\n            <div class=\"radio\" ng-repeat=\"premise in correspondence.premises\">\n              <label>\n                <input ng-required=\"!correspondence.bShowOther\" type=\"radio\" ng-model=\"correspondence.draft.address_id\" ng-value=\"premise.address\" ng-change=\"correspondence.showOther(false)\">\n                {{premise.address.street}} {{premise.address.house_no}}<span ng-if=\"premise.address.house_no_addition\"> {{premise.address.house_no_addition}}</span>, {{premise.address.postal_code}} {{premise.address.city}}\n              </label>\n            </div>\n            <div class=\"radio\">\n              <label>\n                <input type=\"radio\" ng-model=\"correspondence.draft.address_id\" ng-value=\"null\" ng-change=\"correspondence.showOther(true)\">\n                <strong>{{\'customer.correspondence.other\' | translate}}</strong>\n              </label>\n            </div>\n          </div>\n\n          <div ng-if=\"correspondence.bShowOther || !correspondence.bShowPremisesSelection\" ng-class=\"{\'left-indent\': correspondence.bShowOther, \'top-indent\': !correspondence.bShowPremisesSelection}\">\n            <div class=\"form-group\">\n              <label for=\"correspondence-country\" class=\"required\">{{\'customer.correspondence.country\' | translate}}</label>\n              <select ng-required=\"true\" id=\"correspondence-country\" class=\"form-control\" ng-model=\"correspondence.draft.country\" ng-change=\"correspondence.changeCountry()\">\n                <option value=\"\">{{\'customer.correspondence.select_a_country\' | translate}}</option>\n                <option value=\"NL\">{{\'customer.correspondence.option_NL\' | translate}}</option>\n                <option value=\"BE\">{{\'customer.correspondence.option_BE\' | translate}}</option>\n                <option value=\"DE\">{{\'customer.correspondence.option_DE\' | translate}}</option>\n              </select>\n              <div ng-if=\"\'customer.correspondence.hints.select_a_country\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.correspondence.hints.select_a_country\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"radio\" ng-if=\"correspondence.draft.country\" ng-show=\"correspondence.draft.country == \'NL\'\">\n              <label>\n                <input ng-required=\"!correspondence.draft.type\" ng-change=\"correspondence.changeType()\" type=\"radio\" ng-model=\"correspondence.draft.type\" value=\"address\">\n                {{\'customer.correspondence.houseno_postal_code\' | translate}}\n              </label>\n            </div>\n            <div class=\"radio\" ng-if=\"correspondence.draft.country == \'NL\'\">\n              <label>\n                <input ng-required=\"!correspondence.draft.type\" ng-change=\"correspondence.changeType()\" type=\"radio\" ng-model=\"correspondence.draft.type\" value=\"po_box\">\n                {{\'customer.correspondence.houseno_po_box\' | translate}}\n              </label>\n            </div>\n\n            <div ng-class=\"{\'left-indent\' :  correspondence.draft.country == \'NL\'}\" ng-if=\"correspondence.draft.type == \'address\' && correspondence.draft.country.length\">\n              <div class=\"form-group\">\n                <div ng-if=\"correspondence.draft.country == \'NL\'\">\n                  <label for=\"correspondence-postal-code\" class=\"required\">{{\'customer.correspondence.postal_code\' | translate}}</label>\n                  <input ui-mask=\"9999 AA\" placeholder=\"{{\'customer.correspondence.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"correspondence.draft.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-postal-code\" ng-blur=\"correspondence.autofillHouseNo()\">\n                </div>\n\n                <div ng-if=\"correspondence.draft.country == \'BE\'\">\n                  <label for=\"correspondence-postal-code-be\" class=\"required\">{{\'customer.correspondence.postal_code\' | translate}}</label>\n                  <input check-number ng-minlength=\"4\" ng-maxlength=\"4\" ng-trim=\"false\" limit-to=\"4\" ng-required=\"true\" ng-model=\"correspondence.draft.postal_code\" placeholder=\"{{\'customer.correspondence.postal_code_placeholder_be\' | translate}}\" type=\"text\" class=\"form-control\" id=\"correspondence-postal-code-be\">\n                </div>\n\n                <div ng-if=\"correspondence.draft.country == \'DE\'\">\n                  <label for=\"correspondence-postal-code-de\" class=\"required\">{{\'customer.correspondence.postal_code\' | translate}}</label>\n                  <input check-number ng-minlength=\"5\" ng-maxlength=\"5\" ng-trim=\"false\" limit-to=\"5\" ng-required=\"true\" ng-model=\"correspondence.draft.postal_code\" placeholder=\"{{\'customer.correspondence.postal_code_placeholder_de\' | translate}}\" type=\"text\" class=\"form-control\" id=\"correspondence-postal-code-de\">\n                </div>\n\n                <div ng-if=\"\'customer.correspondence.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.correspondence.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"correspondence-housenumber\" class=\"required\">{{\'customer.correspondence.houseno_and_addtion\' | translate}}</label><br>\n                <div class=\"correspondence-medium-input\">\n                  <input check-number ng-required=\"true\" ng-model=\"correspondence.draft.house_no\" type=\"text\" class=\"form-control\" id=\"correspondence-housenumber\" placeholder=\"\" ng-blur=\"correspondence.autofillHouseNo()\">\n                </div>\n                <div class=\"correspondence-small-input\">\n                  <input ng-model=\"correspondence.draft.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-house-number-addition\" placeholder=\"\" ng-blur=\"correspondence.autofillHouseNo()\">\n                </div>\n                <div ng-if=\"\'customer.correspondence.hints.houseno_and_addtion\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.correspondence.hints.houseno_and_addtion\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"form-group\">\n                  <label for=\"correspondence-street\" class=\"required\">{{\'customer.correspondence.street\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"correspondence.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-required=\"true\" ng-model=\"correspondence.draft.street\" type=\"text\" class=\"form-control\" id=\"correspondence-street\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'customer.correspondence.hints.street\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.correspondence.hints.street\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"correspondence-city\" class=\"required\">{{\'customer.correspondence.city\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"correspondence.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-required=\"true\" ng-model=\"correspondence.draft.city\" type=\"text\" class=\"form-control\" id=\"correspondence-city\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'customer.correspondence.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.correspondence.hints.city\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"left-indent\" ng-if=\"correspondence.draft.type == \'po_box\' && correspondence.draft.country.length\">\n              <div class=\"form-group\">\n                <label for=\"correspondence-postal-code-po\" class=\"required\">{{\'customer.correspondence.postal_code\' | translate}}</label><br>\n                <input ui-mask=\"9999 AA\" placeholder=\"{{\'customer.correspondence.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"correspondence.draft.po_box_postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-postal-code-po\" ng-blur=\"correspondence.autofillPoBox()\">\n\n                <div ng-if=\"\'customer.correspondence.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.correspondence.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"correspondence-po\" class=\"required\">{{\'customer.correspondence.po_box\' | translate}}</label><br>\n\n                <input ng-required=\"true\" ng-maxlength=\"5\" ng-model=\"correspondence.draft.po_box\" type=\"text\" class=\"form-control\" id=\"correspondence-po\" ng-blur=\"correspondence.autofillPoBox()\">\n                <div ng-if=\"\'customer.correspondence.hints.po_box\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.correspondence.hints.po_box\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"form-group\">\n                  <label for=\"correspondence-city-po\" class=\"required\">{{\'customer.correspondence.city\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"correspondence.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-required=\"true\" ng-model=\"correspondence.draft.city\" type=\"text\" class=\"form-control\" id=\"correspondence-city-po\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'customer.correspondence.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.correspondence.hints.city\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <button ng-disabled=\"correspondence.form.$invalid || correspondence.sendingData\" ng-click=\"correspondence.save()\" title=\"Opslaan\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'customer.correspondence.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"customer\" title=\"{{ \'customer.correspondence.cancel\' | translate}}\">{{ \'customer.correspondence.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/customer/views/customer.dashboard.view.html","<div class=\"container\">\n<!-- Page Title -->\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1 ng-if=\"!personal.data.is_company\" class=\"dashboard-title\">{{ \'customer.dashboard_title\' | translate }}</h1>\n      <h1 ng-if=\"personal.data.is_company\" class=\"dashboard-title\">{{ \'customer.dashboard_title_company\' | translate }}</h1>\n    </div>\n  </div>\n\n<!-- Contacts block -->\n  <div class=\"row\">\n\n    <div class=\"col-xs-12 col-md-12\" ng-if=\"personal.data.is_company\">\n      <div class=\"dashboard-block\">\n        <h2>{{ \'customer.contact_persons.title\' | translate }}</h2>\n        <div class=\"display-table invoices-table\">\n          <div class=\"table table-custom-width\">\n\n            <!-- table header (desktop screen size) -->\n            <div class=\"thead hidden-xs hidden-sm\">\n              <div class=\"tr\">\n                <div class=\"th xs-td-2\"></div>\n                <div class=\"th xs-td-2\">{{\'customer.contact_persons.name\' | translate }}</div>\n                <div class=\"th xs-td-3\">{{\'customer.contact_persons.email\' | translate }}</div>\n                <div class=\"th xs-td-2\">{{\'customer.contact_persons.phone\' | translate }}</div>\n                <div class=\"th xs-td-2\">{{\'customer.contact_persons.mobile_phone\' | translate }}</div>\n                <div class=\"th xs-td-1\"></div>\n              </div>\n            </div>\n\n            <!-- LOOP OVER CONTACT PERSON TYPES -->\n            <div class=\"tbody\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-repeat=\"contactPersonType in personal.contactPersonTypes\">\n\n              <!-- NO CONTACT FOR CONTACT TYPE, SHOW EMPTY ROW-->\n              <div ng-if=\"personal.contactPersonAvailability[contactPersonType] === false\" class=\"tr\">\n                <!--contact add--><a ng-hide=\"contactPersonType === \'general\'\" class=\"visible-sm visible-xs disable-border\" role=\"button\" ng-click=\"personal.addContactPerson(contactPersonType)\"><i class=\"fa fa-plus pull-right\"></i>x</a>\n                <!--contact type-->\n                <div class=\"td customer-label md-td-2\">{{ \'customer.contact_persons.type.\' + contactPersonType | translate }}:\n                  <span ng-if=\"\'customer.contact_persons.type.hints.\' + contactPersonType | translate\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.contact_persons.type.hints.\' + contactPersonType | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </span>\n                </div>\n                <!--contact name--><div class=\"td md-td-2\"></div>\n                <!--contact email--><div class=\"td md-td-3\"></div>\n                <!--contact phone--><div class=\"td md-td-2\"></div>\n                <!--contact mobile phone--><div class=\"td md-td-2\"></div>\n                <!--contact add--><div class=\"td md-td-1\"><a ng-hide=\"contactPersonType === \'general\'\" class=\"hidden-sm hidden-xs\" role=\"button\" ng-click=\"personal.addContactPerson(contactPersonType)\"><i class=\"fa fa-plus pull-right\"></i></a></div>\n              </div><!--END tr-->\n\n              <!-- ROW PER CONTACT IN CONTACT TYPE -->\n              <div novalidate=\"novalidate\" ng-form name=\"personal.contactPersonForms[contactPersonType][$index]\" ng-if=\"personal.contactPersonAvailability[contactPersonType] === true\" class=\"tr\" ng-repeat=\"contactPerson in personal.contactPersonData[contactPersonType] track by $index\">\n                <!--contact edit/cancel/save MOBILE BTN\'S-->\n                <!--edit--><a class=\"visible-sm visible-xs disable-border pull-right\" ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'VIEW\'\" role=\"button\" ng-click=\"personal.editContactPerson(contactPersonType, contactPerson, $index)\"><i class=\"fa fa-pencil\"></i></a>\n                <!--trash--><a class=\"visible-sm visible-xs disable-border pull-right\" ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'VIEW\'\" role=\"button\" ng-click=\"personal.removeContactPerson(contactPersonType, contactPerson, $index)\" ng-hide=\"contactPersonType === \'administration\' || contactPersonType === \'general\'\"><i class=\"fa fa-trash pull-left\"></i></a>\n                <!--save contact-->                          <button class=\"btn-custom btn-primary pull-right visible-sm visible-xs disable-border\" style=\"margin: 0 6px; padding: 0 14px\" ng-if=\"contactPersonType !== \'general\' && (personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\')\" ng-click=\"personal.saveContactPerson(contactPersonType, $index)\" ng-disabled=\"personal.contactPersonForms[contactPersonType][$index].$invalid || personal.contactPersonSendingData[contactPersonType][$index]\"><i class=\"fa fa-check\"></i></button>\n                <!--save customer (correspondence,general)--><button class=\"btn-custom btn-primary pull-right visible-sm visible-xs disable-border\" style=\"margin: 0 6px; padding: 0 14px\" ng-if=\"contactPersonType === \'general\' && (personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\')\" ng-click=\"personal.saveCustomerAccount(contactPersonType, $index)\" ng-disabled=\"personal.contactPersonForms[contactPersonType][$index].$invalid || personal.contactPersonSendingData[contactPersonType][$index]\"><i class=\"fa fa-check\"></i></button>\n                <!--cancel--><a class=\"visible-sm visible-xs disable-border pull-right\" ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\'\" role=\"button\" ng-click=\"personal.cancelContactPerson(contactPersonType, $index)\"><i class=\"fa fa-close\"></i></a>\n\n                <!--contact type-->\n                <div class=\"td customer-label md-td-2\">\n                  <div ng-class=\"{\'visible-xs visible-sm\': !$first}\">\n                    {{ \'customer.contact_persons.type.\' + contactPersonType | translate }}:\n                    <span ng-if=\"\'customer.contact_persons.type.hints.\' + contactPersonType | translate\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.contact_persons.type.hints.\' + contactPersonType | translate}}\" popover-placement=\"top-right\">\n                      <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                    </span>\n                  </div>\n                </div>\n                <!--contact name-->\n                <div class=\"td md-td-2\">\n                  <div ng-if=\"contactPerson === false\"><img src=\"/app/images/loader.svg\"></div>\n                  <div ng-if=\"contactPerson\">\n                    <div class=\"customer-label visible-xs visible-sm\">{{\'customer.contact_persons.name\' | translate }}:</div>\n                    <div ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'VIEW\'\">\n                      {{contactPerson.name}}\n                    </div>\n                    <div ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\'\">\n                      <div ng-hide=\"contactPersonType === \'general\'\" class=\"form-group\">\n                        <input ng-disabled=\"personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\'\" placeholder=\"{{ \'contact_persons.firstName\' | translate }}\" ng-model=\"contactPerson.firstname\" type=\"text\" class=\"form-control\" id=\"contactperson-firstname\">\n                        <div ng-if=\"\'contact_persons.hints.firstName\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.firstName\' | translate}}\" popover-placement=\"top-right\">\n                          <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                        </div>\n                      </div>\n                      <div ng-hide=\"contactPersonType === \'general\'\" class=\"form-group\">\n                        <select ng-disabled=\"personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\'\" ng-model=\"contactPerson.insertion\" class=\"form-control\" id=\"insertion\" ng-options=\"insertion.value as insertion.label for insertion in personal.insertions\">\n                          <option value=\"\"></option>\n                        </select>\n                        <div ng-if=\"\'contact_persons.hints.insertion\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.insertion\' | translate}}\" popover-placement=\"top-right\">\n                          <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                        </div>\n                      </div>\n                      <div class=\"form-group\">\n                        <input ng-disabled=\"contactPersonType === \'general\' || personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\'\" placeholder=\"{{ \'contact_persons.lastName\' | translate }}\" ng-required=\"true\" ng-model=\"contactPerson.lastname\" type=\"text\" class=\"form-control\" id=\"contactperson-lastname\">\n                        <div ng-if=\"\'contact_persons.hints.lastName\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.lastName\' | translate}}\" popover-placement=\"top-right\">\n                          <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <!--contact email-->\n                <div class=\"td md-td-3\">\n                  <div ng-if=\"contactPerson === false\"><img src=\"/app/images/loader.svg\"></div>\n                  <div ng-if=\"contactPerson\">\n                    <div class=\"customer-label visible-xs visible-sm\">{{\'customer.contact_persons.email\' | translate }}:</div>\n                    <div ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'VIEW\'\">\n                      <span ng-bind=\"contactPerson.email.correspondence\"></span>\n                    </div>\n                    <div ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\'\">\n                      <div class=\"form-group\">\n                        <input placeholder=\"{{ \'contact_persons.email\' | translate }}\" server-side-validation=\"email\" check-email ng-required=\"true\" ng-model=\"contactPerson.email.correspondence\" type=\"email\" class=\"form-control\" id=\"contactperson-email\">\n                        <div ng-if=\"\'contact_persons.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.email\' | translate}}\" popover-placement=\"top-right\">\n                          <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <!--contact phone-->\n                <div class=\"td md-td-2\">\n                  <div ng-if=\"contactPerson === false\"><img src=\"/app/images/loader.svg\"></div>\n                  <div ng-if=\"contactPerson\">\n                    <div class=\"customer-label visible-xs visible-sm\">{{\'customer.contact_persons.phone\' | translate }}:</div>\n                    <div ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'VIEW\'\">\n                      {{contactPerson.phone}}\n                    </div>\n                    <div ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\'\">\n                      <div class=\"form-group\">\n                        <input ng-disabled=\"contactPersonType === \'administration\'\" placeholder=\"{{ \'contact_persons.phone\' | translate }}\" server-side-validation=\"phone\" check-number ng-model=\"contactPerson.phone\" ng-minlength=\"10\" ng-trim=\"false\" limit-to=\"10\" type=\"text\" class=\"form-control\" id=\"contactperson-phonenumber\">\n                        <div ng-if=\"\'contact_persons.hints.phone\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.phone\' | translate}}\" popover-placement=\"top-right\">\n                          <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <!--contact mobile-->\n                <div class=\"td md-td-2\">\n                  <div ng-if=\"contactPerson === false\"><img src=\"/app/images/loader.svg\"></div>\n                  <div ng-if=\"contactPerson\">\n                    <div class=\"customer-label visible-xs visible-sm\">{{\'customer.contact_persons.mobile_phone\' | translate }}:</div>\n                    <div ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'VIEW\'\">\n                      {{contactPerson.mobile_phone}}\n                    </div>\n                    <div ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\'\">\n                      <div class=\"form-group\">\n                        <input ng-disabled=\"contactPersonType === \'administration\'\" placeholder=\"{{ \'contact_persons.mobile_phone\' | translate }}\" server-side-validation=\"mobile_phone\" check-number ng-model=\"contactPerson.mobile_phone\" ng-minlength=\"10\" ng-trim=\"false\" limit-to=\"10\" type=\"text\" class=\"form-control\" id=\"contactperson-mobile_phonenumber\">\n                        <div ng-if=\"\'contact_persons.hints.mobile_phone\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'contact_persons.hints.mobile_phone\' | translate}}\" popover-placement=\"top-right\">\n                          <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <!--contact edit/cancel/save DESKTOP BTN\'S-->\n                <div class=\"td md-td-1\">\n                  <div class=\"pull-right\" style=\"width: 43px\">\n                    <!--edit--><a class=\"hidden-sm hidden-xs\" ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'VIEW\'\" role=\"button\" ng-click=\"personal.editContactPerson(contactPersonType, contactPerson, $index)\"><i class=\"fa fa-pencil pull-right\"></i></a>\n                    <!--trash--><a class=\"hidden-sm hidden-xs\" ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'VIEW\'\" role=\"button\" ng-click=\"personal.removeContactPerson(contactPersonType, contactPerson, $index)\" ng-hide=\"contactPersonType === \'administration\' || contactPersonType === \'general\'\"><i class=\"fa fa-trash pull-left\"></i></a>\n                    <!--cancel--><a class=\"hidden-sm hidden-xs\" ng-if=\"personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\'\" role=\"button\" ng-click=\"personal.cancelContactPerson(contactPersonType, $index)\"><i class=\"fa fa-close pull-right\"></i></a>\n                    <!--save contact-->                          <button class=\"btn-custom btn-primary pull-right hidden-sm hidden-xs\" style=\"padding: 0 14px\" ng-if=\"contactPersonType !== \'general\' && (personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\')\" ng-click=\"personal.saveContactPerson(contactPersonType, $index)\" ng-disabled=\"personal.contactPersonForms[contactPersonType][$index].$invalid || personal.contactPersonSendingData[contactPersonType][$index]\"><i class=\"fa fa-check\"></i></button>\n                    <!--save customer (correspondence,general)--><button class=\"btn-custom btn-primary pull-right hidden-sm hidden-xs\" style=\"padding: 0 14px\" ng-if=\"contactPersonType === \'general\' && (personal.contactPersonModePerType[contactPersonType][$index] === \'EDIT\' || personal.contactPersonModePerType[contactPersonType][$index] === \'ADD\')\" ng-click=\"personal.saveCustomerAccount(contactPersonType, $index)\" ng-disabled=\"personal.contactPersonForms[contactPersonType][$index].$invalid || personal.contactPersonSendingData[contactPersonType][$index]\"><i class=\"fa fa-check\"></i></button>\n                  </div>\n                </div>\n              </div><!--END tr-->\n\n              <!-- ADD CONTACT FOR CONTACT TYPE -->\n              <div ng-if=\"personal.contactPersonAvailability[contactPersonType] === true && personal.contactPersonData[contactPersonType].length < personal.contactPersonMaxPerType[contactPersonType]\" class=\"tr\">\n                <!--contact add--><a ng-hide=\"contactPersonType === \'general\'\" class=\"visible-sm visible-xs disable-border\" role=\"button\" ng-click=\"personal.addContactPerson(contactPersonType)\"><i class=\"fa fa-plus pull-right\"></i></a>\n                <!--contact type--><div class=\"td customer-label md-td-3\"></div>\n                <!--contact name--><div class=\"td md-td-3\"></div>\n                <!--contact email--><div class=\"td md-td-3\"></div>\n                <!--contact phone--><div class=\"td md-td-2\"></div>\n                <!--contact mobile--><div class=\"td md-td-2\"></div>\n                <!--contact add--><div class=\"td md-td-1\"><a ng-hide=\"contactPersonType === \'general\'\" class=\"hidden-sm hidden-xs\" role=\"button\" ng-click=\"personal.addContactPerson(contactPersonType)\"><i class=\"fa fa-plus pull-right\"></i></a></div>\n              </div><!--END tr-->\n\n\n\n\n\n            </div><!--END tbody-->\n\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n<!-- customer/correspondence block -->\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"dashboard-block\">\n        <h2 ng-if=\"!personal.data.is_company\">{{ \'customer.block_title\' | translate }}</h2>\n        <h2 ng-if=\"personal.data.is_company\">{{ \'customer.block_title_company\' | translate }}</h2>\n        <div class=\"display-table\">\n          <div class=\"table table-mobile-block customer-info-wrapper\">\n            <div class=\"tbody customer-info-block\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.customernumber\' | translate }}</div>\n                <div class=\"td\">{{ personal.data.customer_number || \'-\' }}</div>\n              </div>\n            </div>\n            <div class=\"tbody customer-info-block\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.name\' | translate }}</div>\n                <div class=\"td\">{{ personal.data.name || \'-\' }}</div>\n              </div>\n            </div>\n            <div class=\"tbody customer-info-block\" ng-if=\"!personal.data.is_company\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.birthday\' | translate }}</div>\n                <div class=\"td\">{{ personal.data.date_of_birth | date: \'dd-MM-yyyy\' || \'-\' }}</div>\n              </div>\n            </div>\n            <div class=\"tbody customer-info-block\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.phonenumber\' | translate }}</div>\n                <div class=\"td\">{{ personal.data.phone || \'-\' }}</div>\n              </div>\n            </div>\n            <div class=\"tbody customer-info-block\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.mobile_phonenumber\' | translate }}</div>\n                <div class=\"td\">{{ personal.data.mobile_phone || \'-\' }}</div>\n              </div>\n            </div>\n            <div class=\"tbody customer-info-block\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.correspondence_email\' | translate }}</div>\n                <div class=\"td\">{{ personal.data.email.correspondence || \'-\' }}</div>\n              </div>\n            </div>\n            <div class=\"tbody customer-info-block\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.invoice_sendcontrol\' | translate }}</div>\n                <div class=\"td\">{{\'customer.sendcontrol.option_\' + personal.billing_information.sendcontrol | translate}}</div>\n              </div>\n            </div>\n            <!--<div class=\"tbody customer-info-block\" ng-if=\"!personal.data.is_company && personal.billing_information.is_digital\">-->\n              <!--<div class=\"tr\">-->\n                <!--<div class=\"td customer-label\">{{ \'customer.invoice_email\' | translate }}</div>-->\n                <!--<div class=\"td\">-->\n                  <!-- {{personal.billing_email}} -->\n                <!--</div>-->\n              <!--</div>-->\n            <!--</div>-->\n\n            <div class=\"tbody customer-info-block\" ng-if=\"personal.data.is_company\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.newsletter\' | translate }}</div>\n                <div class=\"td\" ng-if=\"!!personal.data.company_newsletter_subscription === true\">{{ \'customer.yes\' | translate }}</div>\n                <div class=\"td\" ng-if=\"!!personal.data.company_newsletter_subscription === false\">{{ \'customer.no\' | translate }}</div>\n              </div>\n            </div>\n            <div class=\"tbody customer-info-block\">\n              <div class=\"tr\">\n                <div class=\"td customer-label\">{{ \'customer.customer_surveys\' | translate }}</div>\n                <div class=\"td\" ng-if=\"personal.data.survey_participation === true\">{{ \'customer.yes\' | translate }}</div>\n                <div class=\"td\" ng-if=\"personal.data.survey_participation === false\">{{ \'customer.no\' | translate }}</div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <a ng-if=\"!personal.data.is_company\" ui-sref=\"customerEdit\" class=\"btn-primary btn-custom margin\" title=\"{{ \'customer.change_customer\' | translate }}\">{{ \'customer.change_customer\' | translate }}</a>\n        <a ng-if=\"personal.data.is_company\" ui-sref=\"customerEdit\" class=\"btn-primary btn-custom margin\" title=\"{{ \'customer.change_customer_company\' | translate }}\">{{ \'customer.change_customer_company\' | translate }}</a>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"row\">\n        <div class=\"col-xs-12 col-md-12\">\n          <div class=\"dashboard-block\">\n            <h2>{{ \'customer.my_correspondence\' | translate }}</h2>\n            <div class=\"display-table\">\n              <div class=\"table table-mobile-block\">\n                <div class=\"tbody\">\n                  <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n                    <div class=\"td customer-label\">{{ \'customer.correspondence_address\' | translate }}</div>\n                    <div class=\"td\" ng-if=\"personal.correspondenceAddress.po_box.length\">{{ \'customer.po_box\' | translate }} {{personal.correspondenceAddress.po_box}}, {{personal.correspondenceAddress.po_box_postal_code}} {{personal.correspondenceAddress.city}}</div>\n                    <div class=\"td\" ng-if=\"personal.correspondenceAddress.po_box.length == 0\">{{personal.correspondenceAddress.street}} {{personal.correspondenceAddress.house_no}}<span ng-if=\"personal.correspondenceAddress.house_no_addition\"> {{personal.correspondenceAddress.house_no_addition}}</span>, {{personal.correspondenceAddress.postal_code}} {{personal.correspondenceAddress.city}}<span ng-if=\"personal.correspondenceAddress.country_id != \'NL\'\">, {{personal.correspondenceAddress.country}}</span></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <a ui-sref=\"correspondenceAddress\" class=\"btn-custom btn-primary\" title=\"{{ \'customer.change_correspondence_address\' | translate }}\">{{ \'customer.change_correspondence_address\' | translate }}</a>\n          </div>\n        </div>\n      </div>\n      <!--Donation block - Water for life -->\n      <div class=\"row\" ng-if=\"personal.data.wfl_amount > 0 && personal.month\">\n        <div class=\"col-xs-12 col-md-12\">\n          <div class=\"dashboard-block\">\n            <img class=\"img-responsive\" src=\"/app/images/water_for_life_logo.svg\">\n            <p>{{ \'customer.wfl.text\' | translate }}</p>\n            <p></p>\n            <div class=\"form-group\">\n              {{ \'customer.wfl.amount_text\' | translate }}\n              <span ng-if=\"!personal.editDonation\">\n                <label>{{personal.data.wfl_amount | currency}} in {{personal.month | lowercase}}.</label>\n                <a ng-click=\"personal.editDonation = true\" title=\"{{\'customer.wfl.donation.edit\' | translate}}\" class=\"edit-icon pull-right\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a>\n              </span>\n              <span ng-if=\"personal.editDonation\" novalidate=\"novalidate\" ng-form name=\"personal.wfl\">\n                &euro;\n<!--                create input of type number with a pattern attribute that only allows digits and 2 decimals-->\n                <input ng-model=\"personal.changedWflAmount\" ng-required=\"true\" style=\"width: 75px; display: inline\" min=\"5\" type=\"number\" class=\"form-control\" pattern=\"^\\d+(\\.\\d{0,2})?$\" id=\"wfl_amount\">\n                in {{personal.month | lowercase }}.\n                <button ng-disabled=\"personal.wfl.$invalid || personal.changedWflAmount < 5\" ng-click=\"personal.saveDonationChange()\" type=\"button\" class=\"btn-custom btn-primary\" title=\"{{\'customer.wfl.donation.edit\' | translate}}\">\n                  {{\'customer.wfl.donation.edit\' | translate}}\n                </button>\n                <a ng-click=\"personal.editDonation = false\" role=\"button\" style=\"margin: 0 8px\" ng-click=\"personal.cancelContactPerson(contactPersonType, $index)\">\n                  <i class=\"fa fa-close\"></i>\n                </a>\n              </span>\n            </div>\n\n            <div>\n              <a ng-click=\"personal.acknowledgeStopWfl = true\" class=\"btn-link\" style=\"float: none\" title=\"{{\'customer.wfl.donation.stop\' | translate}}\">{{\'customer.wfl.donation.stop\' | translate}}</a>\n              <br>\n              <br>\n              <div ng-if=\"personal.acknowledgeStopWfl\">\n                <label>{{\'customer.wfl.donation.acknowledge\' | translate}}</label>\n                <span>\n                  <button ng-click=\"personal.saveDonationChange(true)\" type=\"button\" class=\"btn-custom btn-primary\" title=\"{{\'customer.wfl.donation.yes\' | translate}}\">\n                    {{\'customer.wfl.donation.yes\' | translate}}\n                  </button>\n                  <button ng-click=\"personal.acknowledgeStopWfl = false\" type=\"button\" class=\"btn-custom btn-secondary\" title=\"{{\'customer.wfl.donation.no\' | translate}}\">\n                    {{\'customer.wfl.donation.no\' | translate}}\n                  </button>\n                </span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!--<div class=\"row\" ng-if=\"!personal.data.is_company\">-->\n        <!--<div class=\"col-xs-12 col-md-12\">-->\n          <!--<div class=\"dashboard-block\">-->\n            <!--<h2>{{ \'customer.billing_information_block_title\' | translate }}</h2>-->\n            <!--<div class=\"display-table\">-->\n              <!--<div class=\"table table-mobile-block\">-->\n                <!--<div class=\"tbody\">-->\n                  <!--<div class=\"tr odd\" ng-if=\"personal.billing_information.is_digital\">-->\n                    <!--<div class=\"td customer-label\">{{ \'customer.invoice_email\' | translate }}</div>-->\n                    <!--<div class=\"td\">-->\n                      <!--{{personal.billing_email}}-->\n                    <!--</div>-->\n                  <!--</div>-->\n                  <!--<div class=\"tr even\" ng-class=\"{\'odd\': (!personal.billing_information.is_digital), \'even\': (personal.billing_information.is_digital)}\">-->\n                    <!--<div class=\"td customer-label\">{{ \'customer.invoice_sendcontrol\' | translate }}</div>-->\n                    <!--<div class=\"td\">{{\'customer.sendcontrol.option_\' + personal.billing_information.sendcontrol | translate}}</div>-->\n                  <!--</div>-->\n                <!--</div>-->\n              <!--</div>-->\n            <!--</div>-->\n            <!--<a ui-sref=\"billingInformation\" class=\"btn-custom btn-primary\" title=\"{{ \'customer.billing_information_edit\' | translate }}\">{{ \'customer.billing_information_edit\' | translate }}</a>-->\n          <!--</div>-->\n        <!--</div>-->\n      <!--</div>-->\n    </div>\n  </div>\n\n<!-- Premises Move away banner -->\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"form dashboard-block disable-border dashboard-xs-padding\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-md-6\">\n            <h2>{{ \'customer.moving_away\' | translate }}</h2>\n            <p>{{ \'customer.moving_away_text\' | translate}}</p>\n          </div>\n          <div class=\"col-xs-12 col-md-4 col-sm-8\">\n            <a ui-sref=\"premisesActionOverview\" class=\"btn-custom btn-primary btn-block button-margin-bottom\">{{ \'customer.submit_moving_away\' | translate }}</a>\n            <a ui-sref=\"premisesRegisterMoveInDate({ clearCache: \'true\'})\" class=\"btn-custom btn-secondary btn-block\">{{ \'customer.sign_up_residence\' | translate }}</a>\n            <a ui-sref=\"premisesUnregisterMoveOutDate({ clearCache: \'true\'})\" class=\"btn-custom btn-secondary btn-block\">{{ \'customer.sign_out_residence\' | translate }}</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n<!-- Connection addresses block -->\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"dashboard-block\">\n        <h2 class=\"pull-left\">{{ \'customer.connection_addresses\' | translate }}</h2>\n\n        <a role=\"button\" ng-click=\"personal.downloadPremiseCsv()\" class=\"btn-link pull-right ng-binding\">{{\'customer.download_csv\' | translate}} <i class=\"fa fa-download\" aria-hidden=\"true\"></i></a>\n\n        <div class=\"display-table invoices-table\">\n          <div class=\"table\">\n            <div class=\"thead hidden-xs hidden-sm\">\n              <div class=\"tr\">\n                <div class=\"th\">{{ \'customer.connection_meter_number\' | translate }}</div>\n                <div class=\"th\">{{ \'customer.connection_address\' | translate }}</div>\n              </div>\n            </div>\n            <div class=\"tbody\" ng-repeat=\"connection in personal.connectionAddresses\" ng-if=\"(personal.data.is_company && connection.device.serial_number) || !personal.data.is_company\">\n              <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n                <div class=\"td\">\n                  <div ng-if=\"connection.device.serial_number\">\n                    <span class=\"visible-xs visible-sm customer-label\">{{ \'customer.connection_meter_number\' | translate }}</span>\n                    {{connection.device.serial_number}}\n                    <span class=\"smart_meter\" ng-if=\"personal.data.is_company\">\n                      <a ng-if=\"connection.device.data_logger\" ng-click=\"personal.goToDatalogger(connection.contract_account_id, connection.contract_id)\">{{ \'customer.smart_meter_link\' | translate }}</a>\n                      <a ng-if=\"connection.device.smart_meter && !connection.device.data_logger\" href=\"https://wml.energyict.com/wml-portal/\" target=\"_blank\">{{ \'customer.smart_meter_link\' | translate }}</a>\n                    </span>\n                  </div>\n                  <div ng-if=\"!connection.device.serial_number\">-</div>\n                </div>\n                <div class=\"td\">\n                  <span class=\"visible-xs visible-sm customer-label\">{{ \'customer.connection_address\' | translate }}</span>\n                  {{connection.address.street}} {{connection.address.house_no}}<span ng-if=\"connection.address.house_no_addition\"> {{connection.address.house_no_addition}}</span>, {{connection.address.postal_code}} {{connection.address.city}}\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/customer/views/customer.edit.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1 ng-if=\"!customer.data.is_company && !customer.data.is_corporation\">{{ \'customer.edit.page_title\' | translate}}</h1>\n        <h1 ng-if=\"customer.data.is_company || customer.data.is_corporation\">{{ \'customer.edit.page_title_company\' | translate}}</h1>\n\n        <form name=\"customer.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"customer-salutation\">{{ \'customer.edit.salutation\' | translate}}</label>\n            <select id=\"customer-salutation\" class=\"form-control\" ng-model=\"customer.data.salutation\" ng-options=\"salutation.value as salutation.label for salutation in customer.salutations\">\n              <option value=\"\"></option>\n            </select>\n            <div ng-if=\"\'customer.edit.hints.salutation\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'customer.edit.hints.salutation\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"customer-name\">{{ \'customer.name\' | translate }}</label>\n            <input ng-disabled=\"true\" ng-model=\"customer.data.name\" type=\"text\" class=\"form-control\" id=\"customer-name\">\n          </div>\n\n          <div class=\"form-group\" ng-if=\"!customer.data.is_company && !customer.data.is_corporation\">\n            <label for=\"customer-birthday\">{{ \'customer.edit.birthday\' | translate}}</label>\n            <input server-side-validation=\"date_of_birth\" model-view-value=\"true\" date-format=\"{ minDate: \'01-01-1900\', maxDate: customer.dateNow}\" ui-mask=\"99-99-9999\" placeholder=\"01-01-1985\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-model=\"customer.data.date_of_birth\" type=\"text\" class=\"form-control\" id=\"customer-birthday\">\n            <div ng-if=\"\'customer.edit.hints.birthday\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.edit.hints.birthday\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"customer-phonenumber\">{{ \'customer.edit.phonenumber\' | translate}}</label>\n            <input server-side-validation=\"phone\" check-number ng-model=\"customer.data.phone\" ng-minlength=\"10\" ng-trim=\"false\" limit-to=\"10\" type=\"text\" class=\"form-control\" id=\"customer-phonenumber\" placeholder=\"{{ \'customer.edit.phonenumber\' | translate}}\">\n            <div ng-if=\"\'customer.edit.hints.phonenumber\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.edit.hints.phonenumber\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"customer-mobile-phonenumber\">{{ \'customer.edit.mobile_phonenumber\' | translate}}</label>\n            <input server-side-validation=\"mobile_phone\" check-number ng-model=\"customer.data.mobile_phone\" ng-minlength=\"10\" ng-trim=\"false\" limit-to=\"10\" type=\"text\" class=\"form-control\" id=\"customer-mobile-phonenumber\" placeholder=\"{{ \'customer.edit.mobile_phonenumber\' | translate}}\">\n            <div ng-if=\"\'customer.edit.hints.mobile_phonenumber\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.edit.hints.mobile_phonenumber\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"customer-correspondence-email\" class=\"required\">{{ \'customer.edit.correspondence_email\' | translate}}</label>\n            <input server-side-validation=\"email.correspondence\" check-email ng-required=\"true\" ng-model=\"customer.data.email.correspondence\" type=\"email\" class=\"form-control\" id=\"customer-correspondence-email\" placeholder=\"{{ \'customer.edit.correspondence_email\' | translate}}\">\n            <div ng-if=\"\'customer.edit.hints.correspondence_email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.edit.hints.correspondence_email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <input ng-model=\"customer.data.email.update_account_email\" ng-checked=\"customer.data.email.update_account_email\" type=\"checkbox\" id=\"updateAccountEmail\">\n            <label for=\"updateAccountEmail\" class=\"label_info\">{{ \'customer.edit.update_account_email\' | translate}}</label>\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"group-label\">{{ \'customer.billing_information.sendcontrol_label\' | translate }}</label>\n            <div ng-if=\"\'customer.billing_information.hints.sendcontrol\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.billing_information.hints.sendcontrol\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n            <div class=\"radio\" ng-repeat=\"option in customer.sendcontrol track by $index\">\n              <label>\n                <input ng-model=\"customer.data.sendcontrol\" type=\"radio\" name=\"optionsRadiosSendcontrols\" id=\"{{\'optionsRadios\' + $index}}\" ng-value=\"option.value\">\n                {{ \'customer.billing_information.sendcontrol.option_\' + option.value | translate}}\n              </label>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"customer.data.is_company\">\n            <div class=\"group-label\">{{ \'customer.edit.newsletter\' | translate}}</div>\n            <div ng-if=\"\'customer.edit.hints.newsletter\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.edit.hints.newsletter\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n            <div class=\"radio\">\n              <label>\n                <input ng-disabled=\"true\" ng-model=\"customer.data.company_newsletter_subscription\" type=\"radio\" name=\"optionsNewsletter\" value=\"true\">\n                {{ \'customer.edit.yes\' | translate}}\n              </label>\n            </div>\n            <div class=\"radio\">\n              <label>\n                <input ng-disabled=\"true\" ng-model=\"customer.data.company_newsletter_subscription\" type=\"radio\" name=\"optionsNewsletter\" ng-value=\"false\">\n                {{ \'customer.edit.no\' | translate}}\n              </label>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <div class=\"group-label\">{{ \'customer.edit.customer_surveys\' | translate}}</div>\n            <div ng-if=\"\'customer.edit.hints.customer_surveys\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'customer.edit.hints.customer_surveys\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n            <div class=\"radio\">\n              <label>\n                <input ng-model=\"customer.data.survey_participation\" type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios1\" ng-value=\"true\">\n                {{ \'customer.edit.yes\' | translate}}\n              </label>\n            </div>\n            <div class=\"radio\">\n              <label>\n                <input ng-model=\"customer.data.survey_participation\" type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios2\" ng-value=\"false\">\n                {{ \'customer.edit.no\' | translate}}\n              </label>\n            </div>\n          </div>\n\n          <button ng-disabled=\"customer.form.$invalid || customer.sendingData\" ng-click=\"customer.save()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'customer.edit.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"customer.cancel()\" title=\"{{ \'customer.edit.cancel\' | translate}}\">{{ \'customer.edit.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/damage-form/views/damage-form.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n      <div ui-view=\"banners\"></div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"damage.data.Content.title.data\">{{damage.data.Content.title.data}}</h1>\n          <div ng-if=\"damage.data.Content.intro.data\" class=\"intro-text\">{{damage.data.Content.intro.data}}</div>\n          <h2 class=\"page-intro-title paragraph-title\" ng-if=\"damage.data.Content.title_block_1.data\">{{damage.data.Content.title_block_1.data}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"damage.data.Content.text_block_1.data\" ng-bind-html=\"damage.data.Content.text_block_1.data\"></div>\n        </div>\n      </div>\n      <div class=\"row content\">\n        <div class=\"col-xs-12\">\n          <div class=\"detail-content-image\" ng-if=\"damage.data.Content.detail_image_1.bMediaAvailable && damage.data.Content.detail_image_1.image.bMediaAvailable\">\n            <img alt=\"{{damage.data.Content.detail_image_1.description}}\" ng-src=\"{{damage.data.Content.detail_image_1.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"damage.data.Content.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{damage.data.Content.video.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{damage.data.Content.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"damage.data.Content.title_block_2.data || damage.data.Content.text_block_2.data\">\n            <h2 ng-if=\"damage.data.Content.title_block_2.data\" class=\"paragraph-title\">{{damage.data.Content.title_block_2.data}}</h2>\n            <div ng-if=\"damage.data.Content.text_block_2.data\" ng-bind-html=\"damage.data.Content.text_block_2.data\"></div>\n          </div>\n          <div class=\"detail-content-image\" ng-if=\"damage.data.Content.detail_image_2.bMediaAvailable && damage.data.Content.detail_image_2.image.bMediaAvailable\">\n            <img alt=\"{{damage.data.Content.detail_image_2.description}}\" ng-src=\"{{damage.data.Content.detail_image_2.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"damage.data.Content.text_block_2_2.data\">\n            <div ng-bind-html=\"damage.data.Content.text_block_2_2.data\"></div>\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"damage.data.Content.video2.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{damage.data.Content.video2.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{damage.data.Content.video2.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"damage.data.Content.title_block_3.data || damage.data.Content.text_block_3.data\">\n            <h2 ng-if=\"damage.data.Content.title_block_3.data\" class=\"paragraph-title\">{{damage.data.Content.title_block_3.data}}</h2>\n            <div ng-if=\"damage.data.Content.text_block_3.data\" ng-bind-html=\"damage.data.Content.text_block_3.data\"></div>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"damage.data.Content.text_block_3_left.data || damage.data.Content.detail_image_3.bMediaAvailable && damage.data.Content.detail_image_3.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"damage.data.Content.pos_afb.index === \'Links\' && damage.data.Content.detail_image_3.bMediaAvailable && damage.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{damage.data.Content.detail_image_3.description}}\" ng-src=\"{{damage.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"damage.data.Content.text_block_3_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"damage.data.Content.text_block_3_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"damage.data.Content.pos_afb.index === \'Rechts\' && damage.data.Content.detail_image_3.bMediaAvailable && damage.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{damage.data.Content.detail_image_3.description}}\" ng-src=\"{{damage.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"detail-content-video\" ng-if=\"damage.data.Content.video3.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{damage.data.Content.video3.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{damage.data.Content.video3.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"damage.data.Content.text_block_4_left.data || damage.data.Content.detail_image_4.bMediaAvailable && damage.data.Content.detail_image_4.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"damage.data.Content.pos_afb1.index === \'Links\' && damage.data.Content.detail_image_4.bMediaAvailable && damage.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{damage.data.Content.detail_image_4.description}}\" ng-src=\"{{damage.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"damage.data.Content.text_block_4_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"damage.data.Content.text_block_4_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"damage.data.Content.pos_afb1.index === \'Rechts\' && damage.data.Content.detail_image_4.bMediaAvailable && damage.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{damage.data.Content.detail_image_4.description}}\" ng-src=\"{{damage.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"row list-items news-item\" ng-if=\"damage.data.naviagtionChilds && damage.data.naviagtionChilds.length > 0\" ng-repeat-start=\"detailItem in damage.data.naviagtionChilds\">\n            <div class=\"col-md-4 col-sm-4 list-image\">\n              <img ng-if=\"detailItem.Content.intro_image.bMediaAvailable && detailItem.Content.intro_image.image.bMediaAvailable\" title=\"{{detailItem.Content.intro_image.description}}\" ng-src=\"{{detailItem.Content.intro_image.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-8 col-sm-8 list-item\">\n              <div ng-if=\"detailItem.Content.intro_title.data\" class=\"title\">\n                {{detailItem.Content.intro_title.data}}\n              </div>\n              <div class=\"intro\">\n                {{detailItem.Content.intro_text.data}}\n              </div>\n              <div class=\"footer\">\n                <span ng-if=\"detailItem.CurrentUrl\">\n                  <span class=\"more\"><a href=\"{{detailItem.CurrentUrl}}\" title=\"{{detailItem.Content.intro_title.data}}\">{{\'detail_page.read_more\' | translate}}</a></span>\n                  <i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>\n                </span>\n              </div>\n            </div>\n          </div>\n          <hr ng-repeat-end>\n\n          <div ng-if=\"damage.showForm\" class=\"form detail-form\">\n            <form name=\"damage.form\" ng-submit=\"damage.sendForm()\">\n\n              <div class=\"form-header\"><h2>{{\'damage_form.title\' | translate}}</h2></div>\n              <fieldset>\n                <legend>{{\'damage_form.information_legend\' | translate}}</legend>\n                <div class=\"form-group\">\n                  <label for=\"customer_number\">{{\'damage_form.customer_number\' | translate}}</label>\n                  <input check-number limit-to=\"8\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.customer_number\" id=\"customer_number\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"name\">{{\'damage_form.name\' | translate}}</label>\n                  <input ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.name\" id=\"name\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"initials\">{{\'damage_form.initials\' | translate}}</label>\n                  <input ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.initials\" id=\"initials\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"street\">{{\'damage_form.street\' | translate}}</label>\n                  <input ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.street\" id=\"street\">\n                </div>\n                <div class=\"form-group clearfix\">\n                  <label class=\"required\" for=\"house_number\">{{\'damage_form.house_no\' | translate}}</label><br>\n                  <input ng-required=\"true\" class=\"form-control medium\" type=\"text\" ng-model=\"damage.formData.house_number\" id=\"house_number\">\n                  <input class=\"form-control small\" type=\"text\" ng-model=\"damage.formData.house_number_addition\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"postal_code\">{{\'damage_form.postal_code\' | translate}}</label>\n                  <input placeholder=\"{{\'damage_form.postal_code_placeholder\' | translate}}\" ui-mask=\"9999 AA\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.postal_code\" id=\"postal_code\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"city\">{{\'damage_form.city\' | translate}}</label>\n                  <input ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.city\" id=\"city\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"phone\">{{\'damage_form.phone_number\' | translate}}</label>\n                  <input check-number ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.phone\" id=\"phone\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"email\">{{\'damage_form.email\' | translate}}</label>\n                  <input ng-required=\"true\" check-email class=\"form-control\" type=\"text\" ng-model=\"damage.formData.email\" id=\"email\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"iban\">{{\'damage_form.iban\' | translate}}</label>\n                  <input ng-required=\"true\" ng-iban class=\"form-control\" type=\"text\" ng-model=\"damage.formData.iban\" id=\"iban\">\n                </div>\n              </fieldset>\n              <fieldset>\n                <legend>{{\'damage_form.damage_legend\' | translate}}</legend>\n                <div class=\"form-group\">\n                  <label for=\"date\">{{\'damage_form.date\' | translate}}</label>\n                  <input ng-required=\"true\" date-format ui-mask=\"99-99-9999\" model-view-value=\"true\" ui-options=\"{clearOnBlur:false}\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.date\" id=\"date\">\n                </div>\n                <div class=\"form-group\">\n                  <label for=\"time\">{{\'damage_form.time\' | translate}}</label>\n                  <!--<input type=\"text\" ng-pattern=\"/^([01]\\d|2[0-3]):?([0-5]\\d)$/\" class=\"form-control\" ng-model=\"damage.formData.time\" id=\"time\" placeholder=\"&#45;&#45;:&#45;&#45;\">-->\n                  <input type=\"text\" ui-mask=\"99:99\" ng-pattern=\"/^([01]\\d|2[0-3]):?([0-5]\\d)$/\" model-view-value=\"true\" ui-options=\"{clearOnBlur:false}\" class=\"form-control\" ng-model=\"damage.formData.time\" id=\"time\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"location\">{{\'damage_form.location\' | translate}}</label>\n                  <input ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.location\" id=\"location\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"about\">{{\'damage_form.about\' | translate}}</label>\n                  <input ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.about\" id=\"about\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"btn-custom btn-primary\" for=\"image\">{{\'damage_form.add_img_btn\' | translate}} <i class=\"fa fa-image\"></i></label>\n                  <p ng-if=\"damage.formData.img !== null\"><span ng-repeat=\"item in damage.formData.img\"><span ng-if=\"$index > 0\">, </span>{{item.name}}</span></p>\n                  <p ng-if=\"damage.invalidFiles[0].$error === \'maxTotalSize\'\" translate=\"damage_form.upload_limit\" translate-values=\"{uploadLimit: damage.invalidFiles[0].$errorParam}\"></p>\n                  <input class=\"hidden\" type=\"file\" ng-model=\"damage.formData.img\" id=\"image\" accept=\"image/jpeg, image/png\" ngf-max-total-size=\"20MB\" ngf-model-invalid=\"damage.invalidFiles\" multiple=\"multiple\" ngf-select>\n                </div>\n                <div class=\"form-group\">\n                  <div class=\"group-label required\">{{\'damage_form.damage_report_label\' | translate}}</div>\n                  <div class=\"radio\">\n                    <label><input ng-required=\"true\" class=\"\" type=\"radio\" ng-model=\"damage.formData.report_insurance\" name=\"report_insurance\" data-ng-value=\"true\">{{\'damage_form.damage_report_true\' | translate}}</label>\n                  </div>\n                  <div class=\"radio\">\n                    <label><input ng-required=\"true\" class=\"\" type=\"radio\" ng-model=\"damage.formData.report_insurance\" name=\"report_insurance\" data-ng-value=\"false\">{{\'damage_form.damage_report_false\' | translate}}</label>\n                  </div>\n                </div>\n                <div class=\"form-group\" ng-if=\"damage.formData.report_insurance === true\">\n                  <label for=\"insurance_agency\">{{\'damage_form.insurance_agency\' | translate}}</label>\n                  <input class=\"form-control\" type=\"text\" ng-model=\"damage.formData.insurance_agency\" id=\"insurance_agency\">\n                </div>\n                <div class=\"form-group\" ng-if=\"damage.formData.report_insurance === true\">\n                  <label for=\"polis\">{{\'damage_form.polis\' | translate}}</label>\n                  <input class=\"form-control\" type=\"text\" ng-model=\"damage.formData.polis\" id=\"polis\">\n                </div>\n                <div class=\"form-group\">\n                  <label class=\"required\" for=\"damage_cause\">{{\'damage_form.damage_cause\' | translate}}</label>\n                  <textarea ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"damage.formData.damage_cause\" id=\"damage_cause\"></textarea>\n                </div>\n                <div ng-if=\"damage.data.Content.form_damage_text\" ng-bind-html=\"damage.data.Content.form_damage_text.data\"></div>\n                <div class=\"form-group\">\n                  <div class=\"display-table damage-table\">\n                    <div class=\"table table-custom-width\">\n                      <div class=\"thead\">\n                        <div class=\"th\">{{\'damage_form.item_description\' | translate}}</div>\n                        <div class=\"th\">{{\'damage_form.item_purchase_date\' | translate}}</div>\n                        <div class=\"th\">{{\'damage_form.item_purchase_price\' | translate}}</div>\n                        <div class=\"th\">{{\'damage_form.item_day_value\' | translate}}</div>\n                        <div class=\"th\">{{\'damage_form.item_estimated_damage\' | translate}}</div>\n                      </div>\n                      <div class=\"tbody\">\n                        <div class=\"tr\" ng-repeat=\"item in damage.formData.damagedItems\">\n                          <div class=\"td md-td-4\"><input ng-model=\"damage.formData.damagedItems[$index].description\" class=\"form-control-static\" type=\"text\"></div>\n                          <div class=\"td md-td-2\"><input ng-model=\"damage.formData.damagedItems[$index].purchase_date\" class=\"form-control-static\" type=\"text\" date-format ui-mask=\"99-99-9999\" model-view-value=\"true\" ui-options=\"{clearOnBlur:false}\"></div>\n                          <div class=\"td md-td-2\"><input ng-model=\"damage.formData.damagedItems[$index].purchase_price\" class=\"form-control-static\" type=\"text\" pattern=\"[0-9.,€]+\"></div>\n                          <div class=\"td md-td-2\"><input ng-model=\"damage.formData.damagedItems[$index].day_value\" class=\"form-control-static\" type=\"text\" pattern=\"[0-9.,€]+\"></div>\n                          <div class=\"td md-td-2\"><input ng-model=\"damage.formData.damagedItems[$index].estimated_damage\" class=\"form-control-static\" type=\"text\" pattern=\"[0-9.,€]+\"><i ng-if=\"$index > 0\" class=\"fa fa-times delete-row\" ng-click=\"damage.removeRow($index)\"></i></div>\n                        </div>\n                      </div>\n                    </div>\n\n                  </div>\n                  <a class=\"btn-primary btn-custom\" ng-click=\"damage.addDamagedItem()\">\n                    {{\'damage_form.add_item\' | translate}}\n                  </a>\n                </div>\n              </fieldset>\n              <p ng-if=\"damage.data.Content.reconditioning_text\">\n                {{damage.data.Content.reconditioning_text.data}}\n              </p>\n              <div class=\"form-group\">\n                <label class=\"required\" for=\"declaration\">{{\'damage_form.declaration\' | translate}}</label><br>\n                <input ng-required=\"true\" id=\"declaration\" type=\"checkbox\" ng-model=\"damage.formData.accept_declaration\">\n                <p ng-if=\"damage.data.Content.declaration\">\n                  {{damage.data.Content.declaration.data}}\n                </p>\n              </div>\n              <div class=\"form-group\">\n                <input ng-disabled=\"damage.form.$invalid\" type=\"submit\" value=\"{{\'damage_form.send_form\' | translate}}\" class=\"btn-primary btn-custom\">\n              </div>\n            </form>\n\n          </div>\n\n          <div class=\"form detail-form\">\n            <h2>{{damage.bottomBlock.title}}</h2>\n            <p>{{damage.bottomBlock.text}}</p>\n            <button class=\"btn btn-primary btn-custom\" ui-sref=\"dashboard\">{{damage.bottomBlock.button}}</button>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/dashboard/partials/connection-addresses.modal.partial.html","<div class=\"modal-header\">\n  <button type=\"button\" ng-click=\"dashboard.msaModal.dismiss()\" class=\"close lg-close\">\n    <span class=\"fa fa-times\"></span>\n  </button>\n  <h3 class=\"modal-title\" id=\"modal-title\">{{ \'my_dashboard.popup.msa_popup_title\' | translate }}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <div class=\"display-table invoices-table\">\n    <div class=\"table table-striped\">\n      <div class=\"thead hidden-xs\">\n        <div class=\"tr\">\n          <div class=\"th\">{{ \'my_dashboard.popup.notify_no\' | translate }}</div>\n          <div class=\"th\">{{ \'my_dashboard.popup.connection_address\' | translate }}</div>\n        </div>\n      </div>\n      <div class=\"tbody\">\n        <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" role=\"button\" ng-if=\"connection.start === null\" ng-repeat=\"connection in dashboard.msaConnectionAddresses\" ng-click=\"dashboard.msaModal.close({service_number:connection.notify_no, postal_code : connection.address.postal_code})\">\n          <div class=\"td\">\n            <span class=\"visible-xs customer-label\">{{ \'my_dashboard.popup.notify_no\' | translate }}</span>\n            <span>{{connection.notify_no}}</span>\n          </div>\n          <div class=\"td\">\n            <i class=\"pull-right fa fa-arrow-right\" aria-hidden=\"true\"></i>\n            <span class=\"visible-xs customer-label\">{{ \'my_dashboard.popup.connection_address\' | translate }}</span>\n            {{connection.address.street}} {{connection.address.house_no}}\n            <span ng-if=\"connection.address.house_no_addition\"> {{connection.address.house_no_addition}}</span>, {{connection.address.postal_code}} {{connection.address.city}}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/components/dashboard/views/corporation.dashboard.view.html","<div class=\"container dashboard\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1 class=\"dashboard-title\">{{\'my_dashboard.dashboard_title\' |translate}}</h1>\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"row\">\n\n        <div class=\"col-xs-12\" ng-if=\"dashboard.multipleCustomerNumbers\">\n          <div class=\"dashboard-block\">\n            <h2>{{\'my_dashboard.account.active_customer\' | translate}}</h2>\n            <div class=\"form balance-block\">\n              <strong>{{\'my_dashboard.account.customer_number\' | translate}}: </strong>{{dashboard.personal.customer_number}}<br>\n              <strong>{{\'my_dashboard.account.name\' | translate}}: </strong>{{dashboard.personal.name}}\n            </div>\n            <a class=\"btn-custom btn-primary\" ui-sref=\"accountOptions\">{{\'my_dashboard.account.switch_customer\' | translate}}</a>\n          </div>\n        </div>\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\">\n            <h2>{{\'my_dashboard.corporation.csv_overview\' | translate}}</h2>\n            <div class=\"form balance-block\">{{\'my_dashboard.corporation.csv_text\' | translate}}</div>\n            <a class=\"btn-custom btn-primary\" target=\"_blank\" ng-href=\"{{dashboard.downloadPremiseCsvUrl}}\">{{\'my_dashboard.corporation.csv_btn\' | translate}}</a>\n          </div>\n        </div>\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\">\n            <h2>{{ \'customer.block_title_company\' | translate }}</h2>\n            <div class=\"display-table\">\n              <div class=\"table table-mobile-block customer-info-wrapper\">\n                <div class=\"tbody customer-info-block\">\n                  <div class=\"tr\">\n                    <div class=\"td customer-label\">{{ \'customer.customernumber\' | translate }}</div>\n                    <div class=\"td\">{{ dashboard.personal.customer_number || \'-\' }}</div>\n                  </div>\n                </div>\n                <div class=\"tbody customer-info-block\">\n                  <div class=\"tr\">\n                    <div class=\"td customer-label\">{{ \'customer.name\' | translate }}</div>\n                    <div class=\"td\">{{ dashboard.personal.name || \'-\' }}</div>\n                  </div>\n                </div>\n                <div class=\"tbody customer-info-block\">\n                  <div class=\"tr\">\n                    <div class=\"td customer-label\">{{ \'customer.phonenumber\' | translate }}</div>\n                    <div class=\"td\">{{dashboard.personal.phone || \'-\' }}</div>\n                  </div>\n                </div>\n                <div class=\"tbody customer-info-block\">\n                  <div class=\"tr\">\n                    <div class=\"td customer-label\">{{ \'customer.mobile_phonenumber\' | translate }}</div>\n                    <div class=\"td\">{{ dashboard.personal.mobile_phone || \'-\' }}</div>\n                  </div>\n                </div>\n                <div class=\"tbody customer-info-block\">\n                  <div class=\"tr\">\n                    <div class=\"td customer-label\">{{ \'customer.correspondence_email\' | translate }}</div>\n                    <div class=\"td\">{{ dashboard.personal.email.correspondence || \'-\' }}</div>\n                  </div>\n                </div>\n\n                <div class=\"tbody customer-info-block\">\n                  <div class=\"tr\">\n                    <div class=\"td customer-label\">{{ \'customer.invoice_sendcontrol\' | translate }}</div>\n                    <div class=\"td\">{{\'customer.sendcontrol.option_\' + dashboard.billing_information.sendcontrol | translate}}</div>\n                  </div>\n                </div>\n\n                <div class=\"tbody customer-info-block\" ng-if=\"dashboard.billing_information.is_digital\">\n                  <div class=\"tr\">\n                    <div class=\"td customer-label\">{{ \'customer.invoice_email\' | translate }}</div>\n                    <div class=\"td\">\n                      {{dashboard.billing_email}}\n                    </div>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n            <a ui-sref=\"customerEdit\" class=\"btn-primary btn-custom margin\" title=\"{{ \'customer.change_customer_company\' | translate }}\">{{ \'customer.change_customer_company\' | translate }}</a>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\">\n            <h2>{{\'my_dashboard.corporation.dashboard_title\' | translate}}</h2>\n            <div class=\"form balance-block\">\n              <p>{{dashboard.corporationAddress.street}} {{dashboard.corporationAddress.house_number}} {{dashboard.corporationAddress.house_number_addition}}<br>{{dashboard.corporationAddress.postal_code}}\n                {{dashboard.corporationAddress.city}}</p>\n            </div>\n            <a class=\"btn-custom btn-primary\" ui-sref=\"chooseAddress\">{{\'my_dashboard.corporation.switch_address\' | translate}}</a>\n          </div>\n        </div>\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\">\n            <h2>{{ \'invoices.dashboard.title_invoices\' | translate }}</h2>\n            <div class=\"no-invoices\" ng-if=\"dashboard.invoices && !dashboard.invoices.length\">{{ \'invoices.dashboard.no_invoices\' | translate }}</div>\n            <div class=\"display-table invoices-table\" ng-if=\"dashboard.invoices.length\">\n\n              <div class=\"table\">\n                <div class=\"thead hidden-xs hidden-sm\">\n                  <div class=\"tr\">\n                    <div class=\"th\">{{ \'invoices.dashboard.date_invoices\' | translate }}</div>\n                    <div class=\"th\">{{ \'invoices.dashboard.description_invoices\' | translate }}</div>\n                    <div class=\"th\">{{ \'invoices.dashboard.amount_invoices\' | translate }}</div>\n                  </div>\n                </div>\n                <div class=\"tbody\" ng-repeat=\"item in dashboard.invoices\">\n                  <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n                    <div class=\"td padding-right-mobile-tablecell\">\n                      <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.date_invoices\' | translate }}</span> {{item.date | date : \'dd-MM-yyyy\'}}\n                    </div>\n\n                    <div class=\"td\">\n                      <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.description_invoices\' | translate }}</span>\n                      <span ng-if=\"!item.has_pdf\">{{ \'invoices.descriptions.\'+ item.description | translate }}</span>\n                      <a ng-if=\"item.has_pdf\" ng-click=\"dashboard.openPDF(item.pdf_href)\">{{ \'invoices.descriptions.\'+ item.description | translate }} <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i></a>\n                    </div>\n\n                    <div class=\"td state padding-right-mobile-tablecell\" ng-class=\"{\'paid\': item.fully_paid, \'error\': (!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0), \'no-icon\': (!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0), \'warning\': (!item.fully_paid && item.due_date_expired && item.payment_in_process)}\">\n                      <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.amount_invoices\' | translate }}</span>\n                      <span ng-if=\"!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0\">{{item.amount_remaining | currency}}</span>\n                      <span ng-if=\"!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{item.amount_remaining | currency}}</span>\n                      <span ng-if=\"item.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{ \'invoices.table.paid\' | translate}}</span>\n                      <span ng-if=\"item.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <a ng-if=\"dashboard.invoices.length\" ui-sref=\"invoices\" class=\"btn-custom btn-primary\" title=\"{{ \'invoices.dashboard.view_invoices\' | translate }}\">{{ \'invoices.dashboard.view_invoices\' | translate }}</a>\n          </div>\n        </div>\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\">\n            <h2>{{ \'invoices.dashboard.title_remaining_amount\' | translate }}</h2>\n            <div class=\"no-invoices\" ng-if=\"dashboard.remainingInvoices && !dashboard.remainingInvoices.length\">{{ \'invoices.dashboard.no_remaining_invoices\' | translate }}</div>\n            <div class=\"display-table invoices-table\" ng-if=\"dashboard.remainingInvoices.length\">\n              <div class=\"table\">\n                <div class=\"thead hidden-xs hidden-sm\">\n                  <div class=\"tr\">\n                    <div class=\"th\">{{ \'invoices.dashboard.date_invoices\' | translate }}</div>\n                    <div class=\"th\">{{ \'invoices.dashboard.description_invoices\' | translate }}</div>\n                    <div class=\"th\">{{ \'invoices.dashboard.amount_invoices\' | translate }}</div>\n                  </div>\n                </div>\n                <div class=\"tbody\" ng-repeat=\"item in dashboard.remainingInvoices\">\n                  <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n\n                    <div class=\"td padding-right-mobile-tablecell\">\n                      <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.date_invoices\' | translate }}</span>{{item.date | date : \'dd-MM-yyyy\'}}\n                    </div>\n\n                    <div class=\"td\">\n                      <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.description_invoices\' | translate }}</span>{{ \'invoices.descriptions.\'+ item.description | translate }}\n                    </div>\n\n                    <div class=\"td state padding-right-mobile-tablecell\" ng-class=\"{\'paid\': item.fully_paid, \'error\': (!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0), \'no-icon\': (!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0), \'warning\': (!item.fully_paid && item.due_date_expired && item.payment_in_process)}\">\n                      <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.amount_invoices\' | translate }}</span>\n                      <span ng-if=\"!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0\">{{item.amount_remaining | currency}}</span>\n                      <span ng-if=\"!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{item.amount_remaining | currency}}</span>\n                      <span ng-if=\"item.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{ \'invoices.table.paid\' | translate}}</span>\n                      <span ng-if=\"item.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <a ng-if=\"dashboard.remainingInvoices.length\" ui-sref=\"invoicesRemaining\" class=\"btn-custom btn-primary\" title=\"{{ \'invoices.dashboard.view_remaining_amount\' | translate }}\">{{ \'invoices.dashboard.view_remaining_amount\' | translate }}</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"form dashboard-block disable-border dashboard-xs-padding\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-md-6\">\n            <h2>{{ \'customer.moving_away_corporation\' | translate }}</h2>\n            <p>{{ \'customer.moving_away_text_corporation\' | translate}}</p>\n          </div>\n          <div class=\"col-xs-12 col-lg-4 col-md-5 col-sm-8 dashboard-btn-padding\">\n            <a ui-sref=\"premisesActionOverview\" class=\"btn-custom btn-primary btn-block button-margin-bottom\">{{ \'customer.submit_moving_away\' | translate }}</a>\n            <a ui-sref=\"premisesRegisterMoveInDate({ clearCache: \'true\'})\" class=\"btn-custom btn-secondary btn-block\">{{ \'customer.sign_up_residence\' | translate }}</a>\n            <a ui-sref=\"premisesUnregisterMoveOutDate({ clearCache: \'true\'})\" class=\"btn-custom btn-secondary btn-block\">{{ \'customer.sign_out_residence\' | translate }}</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/dashboard/views/dashboard.view.html","<div class=\"container dashboard\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1 class=\"dashboard-title\">{{\'my_dashboard.dashboard_title\' |translate}}</h1>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"message-wrapper success disable-border\" ng-if=\"dashboard.bShowMeterReadingButton\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <h2 class=\"title\">{{\'my_dashboard.meter_reading_title\' |translate}}</h2>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-6 col-xs-12\">\n            <p class=\"text-default\">\n            {{\'my_dashboard.meter_reading_text\' |translate}}\n            </p>\n          </div><div class=\"col-xs-12 col-lg-4 col-md-5 col-sm-8 dashboard-btn-padding\">\n              <button class=\"btn-primary btn-custom btn-success btn-block\" type=\"button\" ng-click=\"dashboard.openMeterReadingsModal()\" title=\"meterstanden doorgeven\">{{\'my_dashboard.meter_reading_button\' | translate}}</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"message-wrapper success disable-border\" ng-if=\"dashboard.bShowMSAUnplannedButton\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <h2>{{\'my_dashboard.msa_make_appointment.title\' |translate}}</h2>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-6 col-xs-12\">\n            <p class=\"text-default\">{{\'my_dashboard.msa_make_appointment.text\' |translate}}</p>\n          </div>\n          <div class=\"col-xs-12 col-lg-4 col-md-5 col-sm-8 dashboard-btn-padding\">\n            <button class=\"btn-primary btn-custom btn-success btn-block\" type=\"button\" ng-click=\"dashboard.openMSAModal()\" title=\"afspraak maken\">{{\'my_dashboard.msa_make_appointment.button\' |translate}}</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\">\n            <h2>{{\'my_dashboard.customer_invoices.title\' | translate}}</h2>\n            <div class=\"form balance-block\">\n              <p>{{\'my_dashboard.customer_invoices.remaining\' | translate}}</p>\n              <span class=\"customer-label\" ng-class=\"{\'outstanding-amount\': dashboard.accountBalance.current_balance > 0}\">{{dashboard.accountBalance.current_balance | currency}}</span>\n              <a ng-if=\"dashboard.accountBalance && dashboard.draft.payment_method !== \'automatic_collection\' && dashboard.accountBalance.current_balance > 0\" ui-sref=\"invoicesRemaining\" class=\"pull-right btn-custom btn-primary invoices-equal-height-button\" title=\"{{\'my_dashboard.customer_invoices.view_remaining_amount\' | translate}}\">{{\'my_dashboard.customer_invoices.view_remaining_amount\' | translate}}</a>\n              <div class=\"clearfix\"></div>\n            </div>\n            <div class=\"display-table\" ng-if=\"dashboard.connectionAddresses.length\">\n              <div class=\"table\">\n                <div class=\"tr\" ng-repeat=\"connection in dashboard.connectionAddresses\">\n                  <div class=\"td\">\n                    <p class=\"address-payment\">{{connection.address.street}} {{connection.address.house_no}}<span ng-if=\"connection.address.house_no_addition\"> {{connection.address.house_no_addition}}</span>, {{connection.address.postal_code}} {{connection.address.city}}</p>\n                    <div>\n\n                      <div class=\"address-payment-info\">\n                        <span class=\"address-payment-label\">{{ \'invoices.dashboard.connection_paymentmethod\' | translate}}</span>\n                        <span class=\"address-payment-value\">\n                          {{\'paymentmethods.\' + connection.payment.method | translate}}\n                        </span>\n                        <a class=\"address-payment-link\" title=\"{{ \'invoices.dashboard.change_payment_method\' | translate }}\" ui-sref=\"paymentMethodEdit({contract_account_id: connection.contract_account_id, contract_id: connection.contract_id})\">\n                          <i class=\"fa fa-pencil\"></i>\n                        </a>\n                      </div>\n\n                      <div class=\"address-payment-info\" ng-if=\"connection.payment.has_budget_billing_plan\">\n                        <span class=\"address-payment-label\">{{ \'invoices.dashboard.connection_installment\' | translate}}</span>\n                        <span class=\"address-payment-value\" ng-if=\"!connection.is_joint_invoicing\">\n                          {{connection.payment.installment_amount | currency}}\n                        </span>\n                        <a class=\"address-payment-link\" ng-if=\"!connection.is_joint_invoicing\" title=\"{{ \'invoices.dashboard.change_installment_amount\' | translate }}\" ui-sref=\"installmentChange({contract_account_id: connection.contract_account_id, contract_id: connection.contract_id, premise_id: connection.premise_id})\">\n                          <i class=\"fa fa-pencil\"></i>\n                        </a>\n                        <span ng-if=\"connection.is_joint_invoicing\" title=\"{{ \'invoices.dashboard.change_installment_amount\' | translate }}\">{{connection.payment.installment_amount | currency}}</span>\n                      </div>\n\n                      <div class=\"address-payment-info\" ng-if=\"connection.payment.iban\">\n                        <span class=\"address-payment-label\">{{ \'change_payment_method.iban\' | translate }}</span>\n                        <span class=\"address-payment-value\">\n                          {{connection.payment.iban}}\n                        </span>\n                        <a class=\"address-payment-link\" title=\"{{ \'change_payment_method.change_iban\' | translate }}\" ui-sref=\"paymentMethodEdit({contract_account_id: connection.contract_account_id, contract_id: connection.contract_id})\">\n                          <i class=\"fa fa-pencil\"></i>\n                        </a>\n                      </div>\n\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <a ui-sref=\"invoicesDashboard\" class=\"btn-custom btn-primary\" title=\"{{\'my_dashboard.customer_invoices.button\' | translate}}\">{{\'my_dashboard.customer_invoices.button\' | translate}}</a>\n          </div>\n        </div>\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\">\n            <h2 ng-if=\"!dashboard.personal.is_company\" class=\"dashboard-title\">{{ \'customer.dashboard_title\' | translate }}</h2>\n            <h2 ng-if=\"dashboard.personal.is_company\" class=\"dashboard-title\">{{ \'customer.dashboard_title_company\' | translate }}</h2>\n            <div class=\"display-table\">\n              <div class=\"table\">\n                <div ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" class=\"tr\">\n                  <div class=\"td\">\n                    <a ui-sref=\"customerEdit\"><i class=\"fa fa-pencil pull-right\"></i></a>\n                    <p class=\"customer-label\" ng-if=\"!dashboard.personal.is_company\">{{ \'customer.block_title\' | translate }}</p>\n                    <p class=\"customer-label\" ng-if=\"dashboard.personal.is_company\">{{ \'customer.block_title_company\' | translate }}</p>\n                    <div ng-if=\"dashboard.personal.name\">{{ dashboard.personal.name }}</div>\n                    <div ng-if=\"dashboard.personal.phone\">{{ dashboard.personal.phone }}</div>\n                    <div ng-if=\"dashboard.personal.mobile_phone\">{{ dashboard.personal.mobile_phone }}</div>\n                    <div ng-if=\"dashboard.personal.email.correspondence\">{{ dashboard.personal.email.correspondence }}</div>\n                  </div>\n                </div>\n                <div class=\"tr\">\n                  <div class=\"td\">\n                    <a ui-sref=\"correspondenceAddress\"><i class=\"fa fa-pencil pull-right\"></i></a>\n                    <p class=\"customer-label\">{{\'my_dashboard.correspondence.address\' | translate}}</p>\n                    <div ng-if=\"dashboard.correspondenceAddress.po_box.length\">\n                      <div>{{ \'customer.po_box\' | translate }} {{dashboard.correspondenceAddress.po_box}}</div>\n                      <div>{{dashboard.correspondenceAddress.po_box_postal_code}} {{dashboard.correspondenceAddress.city}}</div>\n                    </div>\n                    <div ng-if=\"dashboard.correspondenceAddress.po_box.length == 0\">\n                      <div>{{dashboard.correspondenceAddress.street}} {{dashboard.correspondenceAddress.house_no}} {{dashboard.correspondenceAddress.house_no_addition}}</div>\n                      <div>{{dashboard.correspondenceAddress.postal_code}} {{dashboard.correspondenceAddress.city}}</div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <a ui-sref=\"customer\" class=\"btn-custom btn-primary\" title=\"Bekijk alle persoonlijke gegevens\">{{\'my_dashboard.correspondence.button\' | translate}}</a>\n          </div>\n        </div>\n\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\">\n            <h2 class=\"dashboard-title\">{{ \'profile.dashboard.page_title\' | translate }}</h2>\n              <div class=\"display-table\">\n                <div class=\"table table-mobile-block\">\n                  <div class=\"odd tbody profile-info-block\">\n                    <div class=\"tr\">\n                      <div class=\"td profile-label\">{{ \'profile.dashboard.email\' | translate }}</div>\n                      <div class=\"td\">{{ dashboard.profile.email.account || \'-\' }}</div>\n                      <a ui-sref=\"profileEmail\" class=\"td dashboard-profile-pencil\"><i class=\"fa fa-pencil pull-right\"></i></a>\n                    </div>\n                  </div>\n                  <div class=\"even tbody profile-info-block\">\n                    <div class=\"tr\">\n                      <div class=\"td profile-label\">{{ \'profile.dashboard.password\' | translate }}</div>\n                      <div class=\"td\">●●●●●●●●</div>\n                      <a ui-sref=\"profilePassword\" class=\"td dashboard-profile-pencil\"><i class=\"fa fa-pencil pull-right\"></i></a>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <a ui-sref=\"profile\" class=\"btn-custom btn-primary\" title=\"{{ \'profile.dashboard.page_title\' | translate }}\">{{\'my_dashboard.correspondence.button\' | translate}}</a>\n          </div>\n        </div>\n\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\" ng-if=\"dashboard.multipleCustomerNumbers\">\n          <div class=\"dashboard-block\">\n            <h2>{{\'my_dashboard.account.active_customer\' | translate}}</h2>\n\n            <div class=\"form balance-block\">\n              <strong>{{\'my_dashboard.account.customer_number\' | translate}}: </strong>{{dashboard.personal.customer_number}}<br>\n              <strong>{{\'my_dashboard.account.name\' | translate}}: </strong>{{dashboard.personal.name}}\n            </div>\n\n            <a class=\"btn-custom btn-primary\" ui-sref=\"accountOptions\">{{\'my_dashboard.account.switch_customer\' | translate}}</a>\n          </div>\n        </div>\n\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\" ng-if=\"dashboard.chartExtraConfig.chartFilterAddresses.length >= 1 && dashboard.chartExtraConfig.bShowChart\">\n            <h2>{{\'my_dashboard.usage.title\' | translate}}</h2>\n            <div class=\"message-wrapper info clearfix\" ng-if=\"dashboard.chartExtraConfig.chartFilterAddresses.length > 1\">\n              <div class=\"form-group\">\n                <select ng-options=\"address.value as address.label for address in dashboard.chartExtraConfig.chartFilterAddresses\" class=\"form-control\" ng-model=\"dashboard.chartExtraConfig.selectedChartAddress\" ng-change=\"dashboard.changeChart()\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"smart_meter\" ng-if=\"dashboard.chartExtraConfig.smartMeter\">\n              <p>{{\'usage.chart.smart_meter_text\' | translate}}</p>\n              <a href=\"https://wml.energyict.com/wml-portal/\" target=\"_blank\">{{ \'usage.chart.smart_meter_link\' | translate }}</a>\n            </div>\n\n            <div ng-if=\"!dashboard.chartExtraConfig.smartMeter && dashboard.personal.is_company\">\n              <div class=\"display-table usage-chart-table\">\n                <div class=\"table\">\n                  <div class=\"thead hidden-xs hidden-sm\">\n                    <div class=\"tr\">\n                      <div class=\"th\">{{ \'usage.chart.table.recording_period\' | translate }}</div>\n                      <div class=\"th\">{{ \'usage.chart.table.meter_reading\' | translate }}</div>\n                      <div class=\"th\">{{ \'usage.chart.table.usage\' | translate }}</div>\n                    </div>\n                  </div>\n                  <div class=\"tbody\">\n                    <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-repeat=\"reading in dashboard.chartExtraConfig.meter_reading_results | limitTo:6\" ng-if=\"reading.previous_reading_date_time && reading.consumption > 0\">\n                      <div class=\"td\">\n                        <span class=\"visible-xs visible-sm customer-label\">{{ \'usage.chart.table.recording_period\' | translate }}</span>\n                        <div>{{reading.reading_date_time | date: \'dd-MM-yyyy\'}}</div>\n                        <div>{{reading.previous_reading_date_time | date: \'dd-MM-yyyy\'}}</div>\n                      </div>\n\n                      <div class=\"td\">\n                        <span class=\"visible-xs visible-sm customer-label\">{{ \'usage.chart.table.meter_reading\' | translate }}</span>\n                        {{reading.reading_result}}\n                      </div>\n                      <div class=\"td\">\n                        <span class=\"visible-xs visible-sm customer-label\">{{ \'usage.chart.table.usage\' | translate }}</span>\n                        {{reading.consumption}} m<sup>3</sup>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <highchart ng-if=\"!dashboard.chartExtraConfig.smartMeter && !dashboard.personal.is_company  && dashboard.chartConfig.series[0].data.length\" id=\"chart1\" config=\"dashboard.chartConfig\"></highchart>\n\n            <div ng-if=\"!dashboard.personal.is_company && !dashboard.chartExtraConfig.smartMeter\">\n              <p translate=\"usage.chart.text\"></p>\n            </div>\n\n            <div ng-if=\"!dashboard.chartConfig.series[0].data.length && !dashboard.chartExtraConfig.smartMeter\">\n              <p ng-if=\"!dashboard.chartExtraConfig.exchanged || !dashboard.chartExtraConfig.isExchangeDateRecent\">{{ \'usage.chart.no_history\' | translate}}</p>\n              <p ng-if=\"dashboard.chartExtraConfig.exchanged && dashboard.chartExtraConfig.isExchangeDateRecent\" translate=\"usage.chart.no_history_alt\"></p>\n            </div>\n\n            <a ng-if=\"dashboard.chartConfig.series[0].data.length && !dashboard.chartExtraConfig.smartMeter\" ui-sref=\"usageDashboard\" class=\"btn-custom btn-primary btn-usage-chart\" title=\"{{\'usage.chart.button\' | translate}}\">{{\'usage.chart.button\' | translate}}</a>\n          </div>\n        </div>\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block appointment-block\" ng-if=\"dashboard.bShowMSAplannedButton\">\n            <h2>{{\'my_dashboard.msa_planned_appointments.title\' | translate}}</h2>\n            <div class=\"display-table\">\n              <div class=\"table\">\n                <div class=\"tbody\">\n                  <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-repeat=\"msa in dashboard.plannedMSA\">\n                    <div class=\"td\">\n                      <div title=\"{{\'my_dashboard.msa_planned_appointments.label\' | translate}}\">\n                        <a ng-if=\"msa.reschedule_ok\" ui-sref=\"#0\" ng-click=\"dashboard.openPlannedMSA({service_number:msa.notify_no, postal_code : msa.address.postal_code})\" title=\"{{\'my_dashboard.msa_planned_appointments.label\' | translate}}\"><i class=\"fa fa-pencil pull-right\"></i></a>\n                        <a class=\"remove-appointment\" ng-if=\"msa.reschedule_ok\" ui-sref=\"#0\" ng-click=\"dashboard.deletePlannedMSA({service_number:msa.notify_no, postal_code : msa.address.postal_code, start: msa.start, end: msa.end})\" title=\"{{\'my_dashboard.msa_planned_appointments.delete\' | translate}}\"><i class=\"fa fa-trash pull-right\"></i></a>\n                        <p class=\"customer-label\">\n                          {{msa.notify_damage_text ? msa.notify_damage_text: (\'my_dashboard.msa_planned_appointments.empty\' | translate)}}\n                        </p>\n                        <span class=\"customer-label\">\n                          {{msa.start | date : \'EEEE dd MMMM\'}} | {{msa.start | date : \'HH:mm\'}} - {{msa.end | date : \'HH:mm\'}}\n                        </span>\n                        <p>\n                          {{msa.address.street}} {{msa.address.house_no}}{{msa.address.house_no_addition}}, {{msa.address.city}}\n                        </p>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"form dashboard-block disable-border dashboard-xs-padding\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-md-6\">\n            <h2>{{ \'customer.moving_away\' | translate }}</h2>\n            <p>{{ \'customer.moving_away_text\' | translate}}</p>\n          </div>\n          <div class=\"col-xs-12 col-lg-4 col-md-5 col-sm-8 dashboard-btn-padding\">\n            <a ui-sref=\"premisesActionOverview\" class=\"btn-custom btn-primary btn-block button-margin-bottom\">{{ \'customer.submit_moving_away\' | translate }}</a>\n            <a ui-sref=\"premisesRegisterMoveInDate({ clearCache: \'true\'})\" class=\"btn-custom btn-secondary btn-block\">{{ \'customer.sign_up_residence\' | translate }}</a>\n            <a ui-sref=\"premisesUnregisterMoveOutDate({ clearCache: \'true\'})\" class=\"btn-custom btn-secondary btn-block\">{{ \'customer.sign_out_residence\' | translate }}</a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/detail-page/views/detail-page.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n      <div ui-view=\"banners\"></div>\n    </div>\n\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12 rs-text\">\n          <h1 ng-if=\"detail.data.Content.title.data\">{{detail.data.Content.title.data}}</h1>\n\n          <ng-include ng-if=\"detail.data.Content.photo_nav_position.index === \'1\'\" src=\"\'app/components/detail-page/views/partials/photo-subnav.view.html\'\"></ng-include>\n\n          <div ng-if=\"detail.data.Content.intro.data\" class=\"intro-text\">{{detail.data.Content.intro.data}}</div>\n          <h2 class=\"page-intro-title\" ng-if=\"detail.data.Content.title_block_1.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_1.data}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.text_block_1.data\" ng-bind-html=\"detail.data.Content.text_block_1.data\"></div>\n\n          <div ng-if=\"detail.data.Content.form.active === \'1\'\">\n            <div iv-iform form-id=\"{{detail.data.Content.form.formid}}\" after-send=\"detail.afterSend()\" form-language=\"NL\" form-custom-class=\"iform\"></div>\n          </div>\n\n          <div ng-repeat=\"conversionItem in detail.conversionItems\" style=\"display: none\">\n            <div ng-bind-html=\"conversionItem\"></div>\n          </div>\n\n        </div>\n      </div>\n      <div class=\"row content\">\n        <div class=\"col-xs-12\">\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_1.bMediaAvailable && detail.data.Content.detail_image_1.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_1.description}}\" ng-src=\"{{detail.data.Content.detail_image_1.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{detail.data.Content.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <ng-include ng-if=\"detail.data.Content.photo_nav_position.index === \'2\'\" src=\"\'app/components/detail-page/views/partials/photo-subnav.view.html\'\"></ng-include>\n\n          <div class=\"detail-content-text rs-text\" ng-if=\"detail.data.Content.title_block_2.data || detail.data.Content.text_block_2.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_2.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_2.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_2.data\" ng-bind-html=\"detail.data.Content.text_block_2.data\"></div>\n          </div>\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_2.bMediaAvailable && detail.data.Content.detail_image_2.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_2.description}}\" ng-src=\"{{detail.data.Content.detail_image_2.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-text rs-text\" ng-if=\"detail.data.Content.text_block_2_2.data\">\n            <div ng-bind-html=\"detail.data.Content.text_block_2_2.data\"></div>\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video2.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video2.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{detail.data.Content.video2.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <ng-include ng-if=\"detail.data.Content.photo_nav_position.index === \'3\'\" src=\"\'app/components/detail-page/views/partials/photo-subnav.view.html\'\"></ng-include>\n\n          <div class=\"detail-content-text rs-text\" ng-if=\"detail.data.Content.title_block_3.data || detail.data.Content.text_block_3.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_3.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_3.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_3.data\" ng-bind-html=\"detail.data.Content.text_block_3.data\"></div>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_3_left.data || detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Links\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_3_left.data\">\n              <div class=\"image-aside-text rs-text\" ng-bind-html=\"detail.data.Content.text_block_3_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Rechts\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video3.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video3.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{detail.data.Content.video3.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <ng-include ng-if=\"detail.data.Content.photo_nav_position.index === \'4\'\" src=\"\'app/components/detail-page/views/partials/photo-subnav.view.html\'\"></ng-include>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_4_left.data || detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Links\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_4_left.data\">\n              <div class=\"image-aside-text rs-text\" ng-bind-html=\"detail.data.Content.text_block_4_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Rechts\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <ng-include ng-if=\"detail.data.Content.photo_nav_position.index === \'5\'\" src=\"\'app/components/detail-page/views/partials/photo-subnav.view.html\'\"></ng-include>\n\n          <div class=\"row list-items news-item\" ng-if=\"detail.data.naviagtionChilds && detail.data.naviagtionChilds.length > 0\" ng-repeat-start=\"detailItem in detail.data.naviagtionChilds\">\n            <div class=\"col-md-4 col-sm-4 list-image\">\n              <img ng-if=\"detailItem.Content.intro_image.bMediaAvailable && detailItem.Content.intro_image.image.bMediaAvailable\" title=\"{{detailItem.Content.intro_image.description}}\" ng-src=\"{{detailItem.Content.intro_image.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-8 col-sm-8 list-item\">\n              <div ng-if=\"detailItem.Content.intro_title.data\" class=\"title\">\n                {{detailItem.Content.intro_title.data}}\n              </div>\n              <div class=\"intro rs-text\">\n                {{detailItem.Content.intro_text.data}}\n              </div>\n              <div class=\"footer\">\n                <span ng-if=\"detailItem.CurrentUrl\">\n                  <span class=\"more\"><a href=\"{{detailItem.CurrentUrl}}\" title=\"{{detailItem.Content.intro_title.data}}\">{{\'detail_page.read_more\' | translate}}</a></span>\n                  <i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>\n                </span>\n              </div>\n            </div>\n          </div>\n          <hr ng-repeat-end>\n\n          <div ng-if=\"detail.data.Responses.length\">\n            <h2>{{\'detail_page.user_responses.title\' | translate}} ({{detail.data.Responses.length}})</h2>\n            <div class=\"user-responses\" ng-repeat=\"response in detail.data.Responses\">\n              <div class=\"date\">{{response.name.data}} | <em>{{response.time.Date}}</em></div>\n              <div class=\"msg\">{{response.message.data|strReplace:\'(<([^>]+)>)\':\'\'}}</div>\n            </div>\n          </div>\n\n          <social-sharing ng-if=\"detail.showSocial\"></social-sharing>\n\n          <div class=\"form detail-form\" ng-if=\"detail.data.Content.reactie_formulier_tonen.index && detail.data.Content.reactie_formulier_tonen.index === \'true\'\">\n            <h2 class=\"form-header\">{{\'detail_page.user_responses.form_title\' | translate}}</h2>\n            <form name=\"detail.form\" class=\"clearfix\" novalidate=\"novalidate\">\n              <input ng-model=\"detail.formData.contentIndex\" type=\"hidden\" class=\"form-control\" value=\"{{detail.data.CurrentId}}\">\n\n              <div class=\"form-group\">\n                <label for=\"nameField\" class=\"required\">{{\'detail_page.user_responses.form_name\' | translate}}</label>\n                <input ng-required=\"true\" aria-required=\"true\" ng-model=\"detail.formData.name\" type=\"text\" class=\"form-control\" id=\"nameField\">\n              </div>\n\n              <div class=\"form-group\">\n                <label for=\"email\" class=\"required\">{{\'detail_page.user_responses.form_email\' | translate}}</label>\n                <input check-email ng-required=\"true\" ng-model=\"detail.formData.email\" type=\"email\" class=\"form-control\" id=\"email\">\n              </div>\n\n              <div class=\"form-group\">\n                <label for=\"message\" class=\"required\">{{\'detail_page.user_responses.form_message\' | translate}}</label>\n                <textarea ng-required=\"true\" ng-model=\"detail.formData.message\" class=\"form-control\" rows=\"3\" id=\"message\"></textarea>\n              </div>\n\n              <div class=\"recaptcha-wrapper\" vc-recaptcha key=\"\'6LfdNzIUAAAAAFwrKiyUNLJiXtiCJU2fmCGo6-xo\'\"></div>\n\n              <button ng-disabled=\"detail.form.$invalid || detail.sendingData\" ng-click=\"detail.send()\" title=\"{{\'detail_page.user_responses.form_send\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n                {{\'detail_page.user_responses.form_send\' | translate}}\n              </button>\n            </form>\n\n          </div>\n\n          <div class=\"form detail-form rs-text\">\n            <h2>{{detail.bottomBlock.title}}</h2>\n            <p>{{detail.bottomBlock.text}}</p>\n            <button class=\"btn btn-primary btn-custom\" ui-sref=\"dashboard\">{{detail.bottomBlock.button}}</button>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/faq/views/faq.view.html","<div class=\"faq\" ng-if=\"faq.faqList.length\">\n  <h3 class=\"title rs-text\">{{\'faq.title\'|translate}}</h3>\n\n  <uib-accordion class=\"questions\" close-others=\"true\">\n    <div uib-accordion-group ng-repeat=\"singleFaq in faq.faqList\" class=\"panel-default\" is-open=\"status.open\">\n      <uib-accordion-heading>\n        <i ng-class=\"{\'fa fa-angle-up\' : status.open , \'fa fa-angle-down\' : !status.open}\" aria-hidden=\"true\"></i><div class=\"rs-text\" ng-bind-html=\"singleFaq.titel\"></div>\n      </uib-accordion-heading>\n      <div ng-bind-html=\"singleFaq.content\" class=\"rs-text\"></div>\n      <img class=\"faq-image\" ng-if=\"singleFaq.image_url\" ng-src=\"{{singleFaq.image_url}}\" alt=\"{{singleFaq.titel}}\">\n      <div class=\"faq-video\">\n        <embed-video width=\"482\" height=\"271\" ng-if=\"singleFaq.video\" force-protocol=\"https\" data-ng-href=\"{{singleFaq.video}}\" controls=\"0\"><a ng-href=\"{{singleFaq.video}}\">{{\'faq.view_video\' | translate}}</a></embed-video>\n      </div>\n    </div>\n  </uib-accordion>\n</div>\n\n<div class=\"card\" ng-if=\"faq.bShowOtherQuestionsBlock\">\n  <h3>{{\'faq.other_question\'|translate}}</h3>\n  <span translate=\"faq.text\"></span>\n</div>\n");
$templateCache.put("app/components/faq/views/list.faq.view.html","<div class=\"container\">\n  <div class=\"top-questions\">\n    <h1 translate=\"faq.top_items\" translate-value-length=\"{{faq.topFaqs.length}}\"></h1>\n    <div class=\"faq\">\n      <uib-accordion class=\"questions\" close-others=\"true\">\n        <div uib-accordion-group ng-repeat=\"topFaq in faq.topFaqs\" class=\"panel-default\" is-open=\"top_status.open\">\n          <uib-accordion-heading>\n            <i ng-class=\"{\'fa fa-angle-up\' : top_status.open , \'fa fa-angle-down\' : !top_status.open}\" aria-hidden=\"true\"></i><div ng-bind-html=\"topFaq.titel\"></div>\n          </uib-accordion-heading>\n          <div ng-bind-html=\"topFaq.content\"></div>\n          <img class=\"faq-image\" ng-if=\"topFaq.image_url\" ng-src=\"{{topFaq.image_url}}\" alt=\"{{topFaq.titel}}\">\n          <div class=\"faq-video\">\n            <embed-video width=\"482\" height=\"271\" ng-if=\"topFaq.video\" force-protocol=\"https\" data-ng-href=\"{{topFaq.video}}\" controls=\"0\"><a ng-href=\"{{topFaq.video}}\">{{\'faq.view_video\' | translate}}</a></embed-video>\n          </div>\n        </div>\n      </uib-accordion>\n    </div>\n  </div>\n  <div class=\"categories\">\n    <h2 class=\"rs-text\">{{\'faq.categories_title\' | translate}}</h2>\n    <uib-accordion close-others=\"true\">\n      <div uib-accordion-group class=\"faqCategory\" ng-repeat=\"category in faq.faqCategories\" is-open=\"status.open\">\n        <uib-accordion-heading>\n          <h3 class=\"title rs-text\"><i ng-if=\"category.icon\" class=\"fa {{category.icon}}\" aria-hidden=\"true\"></i>{{category.name}}</h3>\n        </uib-accordion-heading>\n        <div class=\"faq\">\n          <uib-accordion class=\"questions\" close-others=\"true\">\n            <div uib-accordion-group ng-repeat=\"singleFaq in faq.faqList | filter:faq.filterOnCategory(category.name)\" class=\"panel-default\" is-open=\"inner_status.open\">\n              <uib-accordion-heading>\n                <i ng-class=\"{\'fa fa-angle-up\' : inner_status.open , \'fa fa-angle-down\' : !inner_status.open}\" aria-hidden=\"true\"></i><div ng-bind-html=\"singleFaq.titel\"></div>\n              </uib-accordion-heading>\n              <div ng-bind-html=\"singleFaq.content\"></div>\n              <img class=\"faq-image\" ng-if=\"singleFaq.image_url\" ng-src=\"{{singleFaq.image_url}}\" alt=\"{{singleFaq.titel}}\">\n              <div class=\"faq-video\">\n                <embed-video width=\"482\" height=\"271\" ng-if=\"singleFaq.video\" force-protocol=\"https\" data-ng-href=\"{{singleFaq.video}}\" controls=\"0\"><a ng-href=\"{{singleFaq.video}}\">{{\'faq.view_video\' | translate}}</a></embed-video>\n              </div>\n            </div>\n          </uib-accordion>\n        </div>\n      </div>\n    </uib-accordion>\n  </div>\n</div>\n");
$templateCache.put("app/components/footer/views/footer.view.html","<footer class=\"footer\">\n  <div class=\"footer-top\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12 col-sm-12 col-md-6\">\n          <div class=\"row\">\n            <div class=\"col-xs-12 col-sm-6\">\n              <div class=\"head first\">{{footer.data.actions.title}}</div>\n              <nav>\n                <ul>\n                  <li ng-repeat=\"item in footer.data.actions.links_left\">\n                    <a ng-if=\"item.name\" title=\"{{item.text}}\" ui-sref=\"{{item.name}}\">{{item.text}}</a>\n                    <a ng-if=\"!item.name\" title=\"{{item.text}}\" href=\"{{item.link}}\" target=\"{{item.target}}\">{{item.text}}</a>\n                  </li>\n                </ul>\n              </nav>\n            </div>\n            <div class=\"col-xs-12 col-sm-6\">\n              <nav>\n                <ul class=\"no-heading\">\n                  <li ng-repeat=\"item in footer.data.actions.links_right\">\n                    <a ng-if=\"item.name\" title=\"{{item.text}}\" ui-sref=\"{{item.name}}\">{{item.text}}</a>\n                    <a ng-if=\"!item.name\" title=\"{{item.text}}\" href=\"{{item.link}}\" target=\"{{item.target}}\">{{item.text}}</a>\n                  </li>\n                </ul>\n              </nav>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-xs-12 col-sm-6 col-md-3\">\n          <div class=\"head\">{{footer.data.questions.title}}</div>\n          <nav>\n            <ul>\n              <li ng-repeat=\"item in footer.data.questions.links\">\n                <a ng-if=\"item.name\" title=\"{{item.text}}\" ui-sref=\"{{item.name}}\">{{item.text}}</a>\n                <a ng-if=\"!item.name\" title=\"{{item.text}}\" href=\"{{item.link}}\" target=\"{{item.target}}\">{{item.text}}</a>\n              </li>\n            </ul>\n          </nav>\n        </div>\n        <div class=\"col-xs-12 col-sm-6 col-md-3\">\n          <div class=\"head\">{{footer.data.contact.title}}</div>\n          <nav>\n            <ul>\n              <li ng-repeat=\"item in footer.data.contact.links\">\n                <a ng-if=\"item.name\" title=\"{{item.text}}\" ui-sref=\"{{item.name}}\">{{item.text}}</a>\n                <a ng-if=\"!item.name\" href=\"{{item.link}}\" title=\"{{item.text}}\" target=\"{{item.target}}\">{{item.text}}</a>\n              </li>\n            </ul>\n          </nav>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"footer-bottom\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12 col-md-4\">\n          <span class=\"follow\">{{footer.data.social_media.title}}</span>\n          <a ng-if=\"footer.data.social_media.facebook\" href=\"{{footer.data.social_media.facebook}}\" target=\"_blank\" class=\"dot\"><i class=\"fa fa-facebook\" aria-hidden=\"true\"></i></a>\n          <a ng-if=\"footer.data.social_media.twitter\" href=\"{{footer.data.social_media.twitter}}\" target=\"_blank\" class=\"dot\"><i class=\"fa fa-twitter\" aria-hidden=\"true\"></i></a>\n          <a ng-if=\"footer.data.social_media.youtube\" href=\"{{footer.data.social_media.youtube}}\" target=\"_blank\" class=\"dot\"><i class=\"fa fa-youtube-play\" aria-hidden=\"true\"></i></a>\n          <a ng-if=\"footer.data.social_media.linkedin\" href=\"{{footer.data.social_media.linkedin}}\" target=\"_blank\" class=\"dot\"><i class=\"fa fa-linkedin\" aria-hidden=\"true\"></i></a>\n          <a ng-if=\"footer.data.social_media.instagram\" href=\"{{footer.data.social_media.instagram}}\" target=\"_blank\" class=\"dot\"><i class=\"fa fa-instagram\" aria-hidden=\"true\"></i></a>\n        </div>\n        <div class=\"col-xs-12 col-md-8\">\n          <div class=\"footer-inner\">\n            <ul>\n              <li ng-if=\"footer.displayVersioning\" uib-tooltip=\"{{footer.apiInfo.version}} | {{footer.apiInfo.build_time}}\">API info</li>\n              <li ng-if=\"footer.displayVersioning\" uib-tooltip=\"{{footer.frontendInfo.version}} | {{footer.frontendInfo.build_time}}\">Frontend info</li>\n              <li ng-repeat=\"item in footer.data.other.links\"><a rel=\"nofollow\" title=\"{{item.text}}\" href=\"{{item.link}}\" target=\"{{item.target}}\">{{item.text}}</a></li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</footer>\n");
$templateCache.put("app/components/header/views/header.home.view.html","<header class=\"header home min\" scroll-header offset-top=\"10\" offset-top-mobile=\"610\" nav-offset=\"610\" fade-time=\"null\" fade-time-mobile=\"null\">\n\n  <ng-include src=\"\'app/components/header/views/partials/topbar.html\'\"></ng-include>\n\n  <div class=\"slideshow-wrapper\" uib-carousel no-pause=\"false\" active=\"header.activeSlide\" interval=\"header.intervalSlide\" template-url=\"app/components/header/views/partials/slideshow.html\">\n    <div class=\"images\" uib-slide ng-repeat=\"slide in header.headerContent.slides track by $index\" index=\"$index\" template-url=\"app/components/header/views/partials/slide.html\">\n      <div class=\"overlay-top\"></div>\n      <div class=\"overlay-bottom\"></div>\n\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-md-4\">\n            <div class=\"message\">\n              <div class=\"side\">\n                <div class=\"bar\"></div>\n              </div>\n              <a ng-if=\"!slide.video\" target=\"{{slide.target}}\" href=\"{{slide.link}}\">\n                <div class=\"info\">\n                  <div class=\"title\" ng-if=\"slide.title\">{{slide.title}}</div>\n                  <div class=\"subtitle\" ng-if=\"slide.subtitle\">{{slide.subtitle}}</div>\n                </div>\n              </a>\n              <div ng-if=\"slide.video\" ng-click=\"header.openVideoModal(slide.video)\" role=\"button\">\n                <div class=\"info\">\n                  <div class=\"title\" ng-if=\"slide.title\">{{slide.title}}</div>\n                  <div class=\"subtitle\" ng-if=\"slide.subtitle\">{{slide.subtitle}}</div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"video\" ng-if=\"slide.video\" ng-click=\"header.openVideoModal(slide.video)\">\n        <i class=\"fa fa-play-circle\"></i>\n      </div>\n      <div ng-if=\"slide.image\" class=\"img\" style=\"background-image: url({{slide.image}})\"></div>\n    </div>\n  </div>\n\n  <div class=\"overlay\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12 hidden-sm hidden-xs\">\n          <nav class=\"pull-left\">\n            <ul>\n              <li><a ui-sref-active=\"current\" ui-sref=\"home\">{{ \'header.nav.home\' | translate }}</a></li>\n              <li ng-repeat=\"item in header.getMenuItems() | orderBy:\'sort_value\'\">\n                <a ng-if=\"item.type !== \'iLink\'\" ng-class=\"{\'current\': item.active}\" ui-sref=\"{{item.name}}\">{{item.label}}</a>\n                <a ng-if=\"item.type === \'iLink\'\" ng-class=\"{\'current\': item.active}\" href=\"{{item.url}}\" target=\"_blank\">{{item.label}}</a>\n              </li>\n              <li class=\"header-search-button\">\n                <div type=\"button\" class=\"pull-left mobile-search-icon\" ng-click=\"header.isSearchCollapsed = !header.isSearchCollapsed\">\n                  <i class=\"fa fa-search\"></i>\n                </div>\n                <div class=\"search-dropdown header-search-dropdown\" uib-collapse=\"header.isSearchCollapsed\">\n                  <form name=\"header.searchForm\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\" class=\"search-form clearfix\" ng-submit=\"header.search()\">\n                    <div class=\"search-box\">\n                      <input ng-model=\"header.searchQuery\" class=\"form-control\" name=\"q\" value=\"\" placeholder=\"{{\'search.placeholder\' | translate}}\">\n                      <i class=\"fa fa-search\" role=\"button\" aria-hidden=\"true\" ng-click=\"header.search()\"></i>\n                    </div>\n                  </form>\n                </div>\n              </li>\n            </ul>\n          </nav>\n\n          <div class=\"line-inner\"></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"line hidden-sm hidden-xs\"></div>\n  </div>\n\n  <div class=\"bottom_container home\">\n    <div class=\"message bgcolor\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-xs-12 col-sm-6 col-md-4\">\n            <div class=\"overtxt\">\n              <div class=\"head\">{{\'header.actions_title\' | translate}}</div>\n                <ul>\n                  <li ng-repeat=\"item in header.headerContent.links_left\">\n                    <a ng-if=\"item.name\" ui-sref=\"{{item.name}}\">{{item.text}}</a>\n                    <a ng-if=\"!item.name\" href=\"{{item.link}}\" target=\"{{item.target}}\">{{item.text}}</a>\n                  </li>\n                </ul>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-sm-6 col-md-4\">\n            <div class=\"bgmiddle\"></div>\n            <div class=\"overtxt\">\n              <div class=\"head\">{{\'header.myWML_actions_title\' | translate}}</div>\n              <ul>\n                <li ng-repeat=\"item in header.headerContent.links_right\">\n                  <a ng-if=\"item.name\" ui-sref=\"{{item.name}}\" title=\"{{item.text}}\">{{item.text}}</a>\n                  <a ng-if=\"!item.name\" href=\"{{item.link}}\" title=\"{{item.text}}\" target=\"{{item.target}}\">{{item.text}}</a>\n                </li>\n              </ul>\n              <button ga-track-event=\"[\'Button\', \'click\', \'home to sign up\']\" ng-if=\"!header.bAuthenticated\" class=\"btn-custom btn-success btn-block\" type=\"button\" ui-sref=\"sign-up\" title=\"{{\'header.button_register\'|translate}}\">{{\'header.button_register\'|translate}}</button>\n              <button ga-track-event=\"[\'Button\', \'click\', \'home to dashboard\']\" ng-if=\"header.bAuthenticated\" class=\"btn-custom btn-success btn-block\" type=\"button\" ui-sref=\"dashboard\" title=\"{{\'header.button_dashboard\'|translate}}\">{{\'header.button_dashboard\'|translate}}</button>\n            </div>\n          </div>\n          <div class=\"col-xs-12 col-md-4\">\n            <div class=\"bgmiddledark\"></div>\n            <div class=\"overtxt meter-reading-overtxt\">\n              <div class=\"head\">{{\'header.submit_meter_reading\' | translate}}</div>\n              <form name=\"header.meterReadingForm\" class=\"clearfix\" novalidate=\"novalidate\">\n                <div class=\"form-group clearfix\">\n                  <div class=\"meter-input\">\n                    <input ng-required=\"false\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" auto-tab-to=\"meter-reading-num2\" ng-model=\"header.meterReadingData.num1\" type=\"text\" class=\"form-control\" id=\"meter-reading-num1\">\n                  </div>\n                  <div class=\"meter-input\">\n                    <input ng-required=\"false\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" auto-tab-to=\"meter-reading-num3\" ng-model=\"header.meterReadingData.num2\" type=\"text\" class=\"form-control\" id=\"meter-reading-num2\">\n                  </div>\n                  <div class=\"meter-input\">\n                    <input ng-required=\"false\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" auto-tab-to=\"meter-reading-num4\" ng-model=\"header.meterReadingData.num3\" type=\"text\" class=\"form-control\" id=\"meter-reading-num3\">\n                  </div>\n                  <div class=\"meter-input\">\n                    <input ng-required=\"false\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" auto-tab-to=\"meter-reading-num5\" ng-model=\"header.meterReadingData.num4\" type=\"text\" class=\"form-control\" id=\"meter-reading-num4\">\n                  </div>\n                  <div class=\"meter-input\">\n                    <input ng-required=\"false\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" auto-tab-to=\"\" ng-model=\"header.meterReadingData.num5\" type=\"text\" class=\"form-control\" id=\"meter-reading-num5\">\n                  </div>\n                  <span class=\"meter-input-comma\">, X X X</span>\n                </div>\n                <button ng-click=\"header.goToMeterReading()\" title=\"{{\'header.submit_meter_reading_btn\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary btn-meter-reading\">{{\'header.submit_meter_reading_btn\' | translate}}\n                </button>\n              </form>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n");
$templateCache.put("app/components/header/views/header.main.view.html","<header class=\"header min\" scroll-header offset-top=\"10\" offset-top-mobile=\"0\" fade-time=\"null\"> <!-- offset-top=\"280\" offset-top-mobile=\"260\" nav-offset=\"260\" fade-time=\"100\" -->\n\n  <ng-include src=\"\'app/components/header/views/partials/topbar.html\'\"></ng-include>\n\n  <div class=\"image\">\n    <div class=\"overlay-top\"></div>\n    <div class=\"overlay-bottom\"></div>\n    <div ng-if=\"header.headerContent.Content.img2.bMediaAvailable && header.headerContent.Content.img2.image.bMediaAvailable\" class=\"img\" style=\"background-image: url({{header.headerContent.Content.img2.image.mediaSrc}})\"></div>\n  </div>\n\n  <div class=\"overlay hidden-xs hidden-sm\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <nav class=\"pull-left\">\n            <ul>\n              <li><a ui-sref-active=\"current\" ui-sref=\"home\">{{ \'header.nav.home\' | translate }}</a></li>\n              <li ng-repeat=\"item in header.getMenuItems() | orderBy:\'sort_value\'\">\n                <a ng-if=\"item.type !== \'iLink\'\" ng-class=\"{\'current\': item.active}\" ui-sref=\"{{item.name}}\">{{item.label}}</a>\n                <a ng-if=\"item.type === \'iLink\'\" ng-class=\"{\'current\': item.active}\" href=\"{{item.url}}\" target=\"_blank\">{{item.label}}</a>\n              </li>\n              <li class=\"header-search-button\">\n                <div type=\"button\" class=\"pull-left mobile-search-icon\" ng-click=\"header.isSearchCollapsed = !header.isSearchCollapsed\">\n                  <i class=\"fa fa-search\"></i>\n                </div>\n                <div class=\"search-dropdown header-search-dropdown\" uib-collapse=\"header.isSearchCollapsed\">\n                  <form name=\"header.searchForm\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\" class=\"search-form clearfix\" ng-submit=\"header.search()\">\n                    <div class=\"search-box\">\n                      <input ng-model=\"header.searchQuery\" class=\"form-control\" name=\"q\" value=\"\" placeholder=\"{{\'search.placeholder\' | translate}}\">\n                      <i class=\"fa fa-search\" role=\"button\" aria-hidden=\"true\" ng-click=\"header.search()\"></i>\n                    </div>\n                  </form>\n                </div>\n              </li>\n            </ul>\n          </nav>\n          <div class=\"line-inner\"></div>\n        </div>\n      </div>\n\n    </div>\n    <div class=\"line\"></div>\n  </div>\n\n  <div class=\"bottom_container\">\n    <div class=\"message\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <span role=\"button\" ng-click=\"header.showIncidents()\" translate=\"header.incidents.incidents_malfunctions\" translate-values=\"{ malfunctions: header.incidents.total.malfunctions, planned_incidents: header.incidents.total.planned_incidents, malfunctions_plural : header.incidents.malfunctions_plural, malfunctions_prefix : header.incidents.malfunctions_prefix }\"></span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"message bgcolor\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <div class=\"message-txt\" ng-if=\"header.headerContent.Content.tekst.data\">{{header.headerContent.Content.tekst.data}}</div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n");
$templateCache.put("app/components/header/views/header.portal.view.html","<header class=\"header portal\" scroll-header offset-top=\"10\" offset-top-mobile=\"0\" fade-time=\"null\">\n\n  <ng-include src=\"\'app/components/header/views/partials/topbar.html\'\"></ng-include>\n\n  <div class=\"image\">\n    <div class=\"overlay-top hidden-xs hidden-sm\"></div>\n    <div class=\"overlay-bottom hidden-xs hidden-sm\"></div>\n\n    <div ng-if=\"header.currentState !== \'dashboard\' && header.currentState !== \'customer\' && header.currentState !== \'invoicesDashboard\' && header.currentState !== \'usageDashboard\' && header.headerContent.Content.img7.bMediaAvailable && header.headerContent.Content.img7.image.bMediaAvailable\" class=\"img\" style=\"background-image: url({{header.headerContent.Content.img7.image.mediaSrc}})\"></div>\n    <div ng-if=\"header.currentState === \'dashboard\' && header.headerContent.Content.img3.bMediaAvailable && header.headerContent.Content.img3.image.bMediaAvailable\" class=\"img\" style=\"background-image: url({{header.headerContent.Content.img3.image.mediaSrc}})\"></div>\n    <div ng-if=\"header.currentState === \'customer\' && header.headerContent.Content.img4.bMediaAvailable && header.headerContent.Content.img4.image.bMediaAvailable\" class=\"img\" style=\"background-image: url({{header.headerContent.Content.img4.image.mediaSrc}})\"></div>\n    <div ng-if=\"header.currentState === \'invoicesDashboard\' && header.headerContent.Content.img5.bMediaAvailable && header.headerContent.Content.img5.image.bMediaAvailable\" class=\"img\" style=\"background-image: url({{header.headerContent.Content.img5.image.mediaSrc}})\"></div>\n    <div ng-if=\"header.currentState === \'usageDashboard\' && header.headerContent.Content.img6.bMediaAvailable && header.headerContent.Content.img6.image.bMediaAvailable\" class=\"img\" style=\"background-image: url({{header.headerContent.Content.img6.image.mediaSrc}})\"></div>\n  </div>\n\n  <div class=\"overlay\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12 hidden-xs hidden-sm\">\n          <nav class=\"pull-left\">\n            <ul>\n              <li><a ui-sref-active=\"current\" ui-sref=\"dashboard\" title=\"{{ \'header.nav.dashboard\' | translate }}\">{{ \'header.nav.dashboard\' | translate }}</a></li>\n              <li ng-if=\"!header.isCompany && !header.bCorporation\"><a ui-sref-active=\"current\" ui-sref=\"customer\" title=\"{{ \'header.nav.customer_dashboard\' | translate }}\">{{ \'header.nav.customer_dashboard\' | translate }}</a></li>\n              <li ng-if=\"header.isCompany && !header.bCorporation\"><a ui-sref-active=\"current\" ui-sref=\"customer\" title=\"{{ \'header.nav.customer_dashboard_company\' | translate }}\">{{ \'header.nav.customer_dashboard_company\' | translate }}</a></li>\n<!--              <li ng-if=\"!header.bCorporation\"><a ui-sref-active=\"current\" ui-sref=\"profile\" title=\"{{ \'header.nav.my_account\' | translate }}\">{{ \'header.nav.my_account\' | translate }}</a></li>-->\n              <li ng-if=\"!header.bCorporation\"><a ui-sref-active=\"current\" ui-sref=\"invoicesDashboard\" title=\"{{ \'header.nav.customer_invoices\' | translate }}\">{{ \'header.nav.customer_invoices\' | translate }}</a></li>\n              <li ng-if=\"!header.bCorporation\"><a ui-sref-active=\"current\" ui-sref=\"usageDashboard\" title=\"{{ \'header.nav.customer_usage\' | translate }}\">{{ \'header.nav.customer_usage\' | translate }}</a></li>\n            </ul>\n          </nav>\n\n          <div class=\"line-inner\"></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"line hidden-xs hidden-sm\"></div>\n  </div>\n\n  <div class=\"bottom_container\">\n    <div class=\"message hidden-xs hidden-sm\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <span role=\"button\" ng-click=\"header.showIncidents()\" translate=\"header.incidents.incidents_malfunctions\" translate-values=\"{ malfunctions: header.incidents.total.malfunctions, planned_incidents: header.incidents.total.planned_incidents, malfunctions_plural : header.incidents.malfunctions_plural, malfunctions_prefix : header.incidents.malfunctions_prefix }\"></span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"message bgcolor breadcrumb\">\n      <div class=\"container hidden-xs hidden-sm\" ng-if=\"!header.bCorporation\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <span class=\"title\">mijnWML:</span>\n            <a ng-repeat-start=\"item in header.breadcrumbs\" ui-sref=\"{{item.state}}\" ui-sref-active=\"current\">{{item.label}}</a>\n            <span ng-repeat-end ng-hide=\"$last\" class=\"stripe\">/</span>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"container hidden-xs hidden-sm\" ng-if=\"header.bCorporation\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <span class=\"title\">{{\'header.customer_number\'|translate}}: {{header.currentCustomer.customer_number}}</span>\n          </div>\n        </div>\n      </div>\n\n      <nav role=\"navigation\" class=\"portalpage-nav hidden-md hidden-lg\">\n        <div class=\"container\">\n          <div type=\"button\" class=\"pull-left visible-xs visible-sm\" ng-click=\"header.isNavCollapsed = !header.isNavCollapsed\">\n            <i class=\"fa fa-bars\"></i>\n          </div>\n        </div>\n        <div class=\"mobile-dropdown-menu\" uib-collapse=\"header.isNavCollapsed\">\n          <div class=\"container-fluid\">\n            <div class=\"row\">\n              <ul>\n                <li><div class=\"container\"><div class=\"col-xs-12\"><a ui-sref=\"dashboard\" title=\"{{ \'header.nav.dashboard\' | translate }}\">{{ \'header.nav.dashboard\' | translate }}</a></div></div></li>\n                <li ng-if=\"!header.isCompany && !header.bCorporation\"><div class=\"container\"><div class=\"col-xs-12\"><a ui-sref=\"customer\" title=\"{{ \'header.nav.customer_dashboard\' | translate }}\">{{ \'header.nav.customer_dashboard\' | translate }}</a></div></div></li>\n                <li ng-if=\"header.isCompany && !header.bCorporation\"><div class=\"container\"><div class=\"col-xs-12\"><a ui-sref=\"customer\" title=\"{{ \'header.nav.customer_dashboard_company\' | translate }}\">{{ \'header.nav.customer_dashboard_company\' | translate }}</a></div></div></li>\n                <li ng-if=\"!header.bCorporation\"><div class=\"container\"><div class=\"col-xs-12\"><a ui-sref=\"invoicesDashboard\" title=\"{{ \'header.nav.customer_invoices\' | translate }}\">{{ \'header.nav.customer_invoices\' | translate }}</a></div></div></li>\n                <li ng-if=\"!header.bCorporation\"><div class=\"container\"><div class=\"col-xs-12\"><a ui-sref=\"usageDashboard\" title=\"{{ \'header.nav.customer_usage\' | translate }}\">{{ \'header.nav.customer_usage\' | translate }}</a></div></div></li>\n                <li ng-if=\"header.bAuthenticated\" class=\"logout-menu-item\"><div class=\"container\"><div class=\"col-xs-12\"><a ng-click=\"header.logout()\">{{\'header.nav.logout\' | translate}}</a></div></div></li>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </nav>\n    </div>\n  </div>\n</header>\n");
$templateCache.put("app/components/header/views/header.switch.view.html","<div ng-if=\"header.headerType === \'homeHeader\'\" ng-controller=\"HeaderMainController as header\">\n  <div ng-include=\"\'app/components/header/views/header.home.view.html\'\"></div>\n</div>\n\n<div ng-if=\"header.headerType === \'mainHeader\'\" ng-controller=\"HeaderMainController as header\">\n  <div ng-include=\"\'app/components/header/views/header.main.view.html\'\"></div>\n</div>\n\n<div ng-if=\"header.headerType === \'portalHeader\'\" ng-controller=\"PortalHeaderController as header\">\n  <div ng-include=\"\'app/components/header/views/header.portal.view.html\'\"></div>\n</div>\n");
$templateCache.put("app/components/home/views/home.view.html","<div class=\"container malfunction-block-wrapper content rs-text\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1>{{\'home.malfunction_title\' | translate}}</h1>\n    </div>\n  </div>\n\n  <div class=\"message activity row\">\n    <div class=\"col-xs-12\">\n      <span class=\"malfunctions-txt\" role=\"button\" ng-click=\"home.showIncidents()\" translate=\"header.incidents.incidents_malfunctions\" translate-values=\"{ malfunctions: home.incidents.total.malfunctions, planned_incidents: home.incidents.total.planned_incidents, malfunctions_plural : home.incidents.malfunctions_plural, malfunctions_prefix : home.incidents.malfunctions_prefix }\"></span>\n      <a ng-click=\"home.openWebsite()\" target=\"_blank\" class=\"btn-custom btn-primary btn-report\" title=\"{{ \'header.incidents.report\' | translate }}\">{{ \'header.incidents.report\' | translate }}</a>\n    </div>\n  </div>\n\n  <div class=\"row\" ng-if=\"home.incidents.malfunctions.length\">\n    <div class=\"col-xs-12 col-md-4\" ng-repeat=\"malfunction in home.incidents.malfunctions | limitTo:3\">\n      <div class=\"malfunction-block\">\n        <div class=\"text-default\">\n          <div class=\"malfunction-block-title\">\n            {{malfunction.title}}\n          </div>\n          <div class=\"malfunction-block-intro\">\n            <span class=\"date\">{{malfunction.start_date|date:\'dd-MM-yyyy\'}}</span>\n            {{malfunction.city}}, {{malfunction.status}}\n          </div>\n          <div class=\"malfunction-block-footer\">\n            <a ng-href=\"{{malfunction.link}}\" target=\"_blank\">\n              {{\'home.more\' | translate}}\n              <i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"container content\">\n  <div ng-if=\"home.newsItemsLength > 0\" class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1>{{\'home.latest_news_title\' | translate}}</h1>\n    </div>\n  </div>\n  <div ng-if=\"home.newsItemsLength > 0\" class=\"row rs-text\">\n\n    <div class=\"col-xs-12 col-md-4\" ng-repeat=\"item in home.newsItems\">\n      <div class=\"news-item\">\n        <div class=\"image\">\n          <img ng-src=\"{{item.detail_block_image.image.mediaSrc}}\" alt=\"{{item.detail_block_title.data}}\">\n        </div>\n        <div class=\"title\">\n          {{item.detail_block_title.data}}\n        </div>\n        <div class=\"intro\">\n          <span class=\"date\">{{item.time.Date}}</span>\n          {{item.detail_block_text.data|strReplace:\'(<([^>]+)>)\':\'\'}}\n        </div>\n        <div class=\"footer\">\n          <!--<span class=\"reactions\">{{\'home.responses\' | translate}}</span>-->\n          <span class=\"more\"><a href=\"{{item.detaillink}}\">{{\'home.more\' | translate}} <i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></a></span>\n\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n");
$templateCache.put("app/components/incidents/views/incidents.modal.view.html","<div class=\"modal-header\">\n  <button type=\"button\" ng-click=\"header.incidents.modal.dismiss()\" class=\"close lg-close\">\n    <span class=\"fa fa-times\"></span>\n  </button>\n  <h3 class=\"modal-title\" id=\"modal-title\">{{ \'incidents.modal_title\' | translate }}</h3>\n</div>\n<div class=\"modal-body clearfix\" id=\"modal-body\">\n  <div class=\"display-table invoices-table\" ng-if=\"header.incidents.total.malfunctions > 0\">\n    <div class=\"table table-striped\">\n      <div class=\"tbody\">\n        <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-repeat=\"malfunction in header.incidents.malfunctions | limitTo:3\">\n          <div class=\"td\">\n            <div role=\"button\" ng-click=\"header.goToIncident(malfunction.link)\" target=\"_blank\">{{malfunction.title}}: {{malfunction.city}}, {{malfunction.status}}<i class=\"pull-right fa fa-arrow-right\" aria-hidden=\"true\"></i></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"display-table invoices-table\" ng-if=\"header.incidents.total.malfunctions === 0\">\n    <div class=\"table table-striped\">\n      <div class=\"tbody\">\n        <div class=\"tr odd\">\n          <div class=\"td\">\n            {{\'incidents.no_malfunctions\' | translate}}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"display-table invoices-table\" ng-if=\"header.incidents.total.malfunctions === 0\">\n    <div class=\"table table-striped\">\n      <div class=\"tbody\">\n        <div class=\"tr odd\">\n          <div class=\"td\">\n            {{\'incidents.no_incidents\' | translate}}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <a ng-if=\"header.incidents.total.combined > 0\" class=\"btn-custom btn-primary pull-right\" href=\"https://www.waterstoring.nl/wml\" target=\"_blank\">{{\'incidents.all_incidents\'|translate}}</a>\n</div>\n\n");
$templateCache.put("app/components/list-page/views/list-page.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"list.data.ListContent.list_page_title.data\">{{list.data.ListContent.list_page_title.data}}</h1>\n          <p ng-if=\"list.data.ListContent.list_page_intro.data\" class=\"intro-text\">{{list.data.ListContent.list_page_intro.data}}</p>\n          <h2 class=\"page-intro-title\" ng-if=\"list.data.ListContent.list_page_subtitle.data\" class=\"paragraph-title\">{{list.data.ListContent.list_page_subtitle.data}}</h2>\n          <p ng-if=\"list.data.ListContent.list_page_text.data\" ng-bind-html=\"list.data.ListContent.list_page_text.data\"></p>\n\n          <div ng-if=\"detail.data.Content.form.active === \'1\'\">\n            <div iv-iform form-id=\"{{detail.data.Content.form.formid}}\" form-language=\"NL\" form-custom-class=\"iform\"></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row list-items news-item\" ng-repeat-start=\"detailItem in list.data.ContentItems\">\n        <div class=\"col-md-4 col-sm-4 list-image\">\n          <img ng-if=\"detailItem.detail_block_image.bMediaAvailable && detailItem.detail_block_image.image.bMediaAvailable\" title=\"{{detailItem.detail_block_image.description}}\" ng-src=\"{{detailItem.detail_block_image.image.mediaSrc}}\">\n        </div>\n        <div class=\"col-md-8 col-sm-8 list-item\">\n          <div ng-if=\"detailItem.detail_block_title.data\" class=\"title\">\n            {{detailItem.detail_block_title.data}}\n          </div>\n          <div class=\"intro\">\n            <span ng-if=\"detailItem.time[\'Date\']\" class=\"date\">{{detailItem.time[\'Date\']}}</span>\n            {{detailItem.detail_block_text.data}}\n          </div>\n          <div class=\"footer\">\n            <!--<span class=\"reactions\">0 reactie(s)</span>-->\n            <span ng-if=\"detailItem.detaillink\">\n              <span class=\"more\"><a title=\"{{\'list_page.list_item_read_more\' | translate}}\" href=\"{{detailItem.detaillink}}\">{{\'list_page.list_item_read_more\' | translate}}</a></span>\n              <i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>\n            </span>\n          </div>\n        </div>\n      </div>\n      <hr ng-repeat-end>\n      <div class=\"pagination-wrapper clearfix\">\n        <div class=\"pull-left pagination-txt\" translate=\"list_page.page_counter\" translate-value-range=\"{{list.data.Pagination.RangeStart}} - {{list.data.Pagination.RangeEnd}}\" translate-value-total=\"{{list.data.Pagination.TotalItems}}\"></div>\n        <div class=\"pull-right pagination-nav\">\n          <ul uib-pagination ng-change=\"list.changePage()\" previous-text=\"{{ \'invoices.pagination.previous\' | translate}}\" next-text=\"{{ \'invoices.pagination.next\' | translate}}\" max-size=\"5\" boundary-links=\"false\" total-items=\"list.data.Pagination.TotalItems\" items-per-page=\"list.data.Pagination.ItemsPerPage\" ng-model=\"list.currentPage\" class=\"pagination\"></ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/invoices/partials/payment-status.partial.html","<div class=\"modal-header\">\n  <button type=\"button\" ng-click=\"modal.dismiss()\" class=\"close lg-close\">\n    <span class=\"fa fa-times\"></span>\n  </button>\n  <h1 class=\"modal-title\" ng-if=\"response.PaymentStatus.Success\">{{ \'invoices.paymentResult.success\' | translate }}</h1>\n  <h1 class=\"modal-title\" ng-if=\"!response.PaymentStatus.Success\">{{ \'invoices.paymentResult.failed\' | translate }}</h1>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  {{\'message.backoffice.\' + response.PaymentStatus.Code|translate}}\n</div>\n");
$templateCache.put("app/components/invoices/partials/popover.partial.html","<div>\n  <span ng-if=\"item.amount_without_costs != 0\">{{\'invoices.table.popover_without_costs\' | translate}} {{item.amount_without_costs | currency}} <br></span>\n  <span ng-if=\"item.costs_total != 0\">{{\'invoices.table.popover_total_costs\' | translate}} {{item.costs_total | currency}}</span>\n</div>\n");
$templateCache.put("app/components/invoices/views/invoices.dashboard.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1 class=\"dashboard-title\">{{ \'invoices.dashboard.dashboard_title\' | translate}}</h1>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12\" ng-class=\"{\'col-md-12\': !financial.remainingInvoices.length, \'col-md-6\': financial.remainingInvoices.length}\" ng-if=\"financial.invoices.length\">\n      <div class=\"dashboard-block invoices-equal-height\" equal-height=\"blocks\" equal-num-items=\"2\">\n        <h2>{{ \'invoices.dashboard.title_invoices\' | translate }}</h2>\n        <div class=\"no-invoices\" ng-if=\"financial.invoices && !financial.invoices.length\">{{ \'invoices.dashboard.no_invoices\' | translate }}</div>\n        <div class=\"display-table invoices-table\">\n          <div class=\"table\">\n            <div class=\"thead hidden-xs hidden-sm\">\n              <div class=\"tr\">\n                <div class=\"th\">{{ \'invoices.dashboard.date_invoices\' | translate }}</div>\n                <div class=\"th\">{{ \'invoices.dashboard.description_invoices\' | translate }}</div>\n                <div class=\"th\">{{ \'invoices.dashboard.amount_invoices\' | translate }}</div>\n              </div>\n            </div>\n            <div class=\"tbody\" ng-repeat=\"item in financial.invoices\">\n              <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n                <div class=\"td padding-right-mobile-tablecell\">\n                  <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.date_invoices\' | translate }}</span> {{item.date | date : \'dd-MM-yyyy\'}}\n                </div>\n\n                <div class=\"td\">\n                  <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.description_invoices\' | translate }}</span>\n                  <span ng-if=\"!item.has_pdf\">{{ \'invoices.descriptions.\'+ item.description | translate }}</span>\n                  <a ng-if=\"item.has_pdf\" ng-click=\"financial.openPDF(item.pdf_href)\">{{ \'invoices.descriptions.\'+ item.description | translate }} <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i></a>\n                </div>\n\n                <div class=\"td state padding-right-mobile-tablecell\" ng-class=\"{\'paid\': item.fully_paid, \'error\': (!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0), \'no-icon\': (!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0), \'warning\': (!item.fully_paid && item.due_date_expired && item.payment_in_process)}\">\n                  <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.amount_invoices\' | translate }}</span>\n                  <span ng-if=\"!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0\">{{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"item.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{ \'invoices.table.paid\' | translate}}</span>\n                  <span ng-if=\"item.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"actions-container\">\n          <a ui-sref=\"invoices\" class=\"btn-custom btn-primary\" title=\"{{ \'invoices.dashboard.view_invoices\' | translate }}\">{{ \'invoices.dashboard.view_invoices\' | translate }}</a>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\" ng-class=\"{\'col-md-12\': !financial.invoices.length, \'col-md-6\': financial.invoices.length}\" ng-if=\"financial.remainingInvoices.length\">\n      <div class=\"dashboard-block invoices-equal-height\" equal-height=\"blocks\" equal-num-items=\"2\">\n        <h2>{{ \'invoices.dashboard.title_remaining_amount\' | translate }}</h2>\n        <div class=\"no-invoices\" ng-if=\"financial.remainingInvoices && !financial.remainingInvoices.length\">{{ \'invoices.dashboard.no_remaining_invoices\' | translate }}</div>\n        <div class=\"display-table invoices-table\">\n          <div class=\"table\">\n            <div class=\"thead hidden-xs hidden-sm\">\n              <div class=\"tr\">\n                <div class=\"th\">{{ \'invoices.dashboard.date_invoices\' | translate }}</div>\n                <div class=\"th\">{{ \'invoices.dashboard.description_invoices\' | translate }}</div>\n                <div class=\"th\">{{ \'invoices.dashboard.amount_invoices\' | translate }}</div>\n              </div>\n            </div>\n            <div class=\"tbody\" ng-repeat=\"item in financial.remainingInvoices\">\n              <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n\n                <div class=\"td padding-right-mobile-tablecell\">\n                  <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.date_invoices\' | translate }}</span>{{item.date | date : \'dd-MM-yyyy\'}}\n                </div>\n\n                <div class=\"td\">\n                  <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.description_invoices\' | translate }}</span>{{ \'invoices.descriptions.\'+ item.description | translate }}\n                </div>\n\n                <div class=\"td state padding-right-mobile-tablecell\" ng-class=\"{\'paid\': item.fully_paid, \'error\': (!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0), \'no-icon\': (!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0), \'warning\': (!item.fully_paid && item.due_date_expired && item.payment_in_process)}\">\n                  <span class=\"customer-label visible-xs visible-sm\">{{ \'invoices.dashboard.amount_invoices\' | translate }}</span>\n                  <span ng-if=\"!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0\">{{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"item.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{ \'invoices.table.paid\' | translate}}</span>\n                  <span ng-if=\"item.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n                </div>\n\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"actions-container\">\n          <a ng-if=\"financial.remainingInvoices.length\" ui-sref=\"invoicesRemaining\" class=\"btn-custom btn-primary\" title=\"{{ \'invoices.dashboard.view_remaining_amount\' | translate }}\">{{ \'invoices.dashboard.view_remaining_amount\' | translate }}</a>\n          <a ng-if=\"financial.showPaymentArrangementButton\" ui-sref=\"invoicesPaymentArrangement\" class=\"btn-custom btn-primary\" title=\"{{ \'invoices.dashboard.view_payment_arrangement\' | translate }}\">{{ \'invoices.dashboard.view_payment_arrangement\' | translate }}</a>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12\">\n      <div class=\"dashboard-block\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <h2 class=\"pull-left\">{{ \'invoices.dashboard.title_connection_addresses\' | translate }}</h2>\n            <div class=\"filter-connection-addresses pull-right\">\n              <form ng-submit=\"financial.filterOnPostalCode()\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ \'invoices.dashboard.postal_filter\' | translate}}\" ng-model=\"financial.postalCodeFilterParam\">\n                <i class=\"fa fa-search\" aria-hidden=\"true\" role=\"button\" ng-click=\"financial.filterOnPostalCode()\"></i>\n              </form>\n            </div>\n          </div>\n        </div>\n        <div class=\"display-table invoices-table\">\n          <div class=\"table table-custom-width\">\n            <div class=\"thead\">\n              <div class=\"tr hidden-xs hidden-sm\">\n                <div class=\"th xs-td-1\">{{ \'invoices.dashboard.connection_meter_number\' | translate }}</div>\n                <div class=\"th xs-td-4\">{{ \'invoices.dashboard.connection_address\' | translate }}</div>\n                <div class=\"th xs-td-2\">{{ \'invoices.dashboard.connection_paymentmethod\' | translate }}</div>\n                <div class=\"th xs-td-2\">{{ \'invoices.dashboard.connection_installment\' | translate }}</div>\n                <div class=\"th xs-td-3\">{{ \'invoices.dashboard.iban\' | translate }}</div>\n              </div>\n            </div>\n            <div class=\"tbody\">\n              <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-repeat=\"connection in financial.connectionAddresses\">\n                <div class=\"td md-td-1\"><span class=\"visible-xs visible-sm table-label\">{{ \'invoices.dashboard.connection_meter_number\' | translate }}</span>{{connection.device.serial_number}}</div>\n                <div class=\"td md-td-4\"><span class=\"visible-xs visible-sm table-label\">{{ \'invoices.dashboard.connection_address\' | translate }}</span>{{connection.address.street}} {{connection.address.house_no}}<span ng-if=\"connection.address.house_no_addition\"> {{connection.address.house_no_addition}}</span>, {{connection.address.postal_code}} {{connection.address.city}}</div>\n                <div class=\"td md-td-2\">\n                  <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.dashboard.connection_paymentmethod\' | translate }}</span>\n                  <a title=\"{{ \'invoices.dashboard.change_payment_method\' | translate }}\" ui-sref=\"paymentMethodEdit({contract_account_id: connection.contract_account_id, contract_id: connection.contract_id})\">{{\'paymentmethods.\' + connection.payment.method | translate}} <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></a>\n                </div>\n                <div class=\"td md-td-2\">\n                  <span ng-if=\"connection.payment.has_budget_billing_plan\">\n                    <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.dashboard.connection_installment\' | translate }}</span>\n                    <a class=\"invoices_installment-amount\" ng-if=\"!connection.is_joint_invoicing\" title=\"{{ \'invoices.dashboard.change_installment_amount\' | translate }}\" ui-sref=\"installmentChange({contract_account_id: connection.contract_account_id, contract_id: connection.contract_id, premise_id: connection.premise_id})\">\n                      <span>&euro; </span>\n                      <span>{{connection.payment.installment_amount | currency: \'\'}}</span>\n                      <span><i class=\"fa fa-pencil pull-right\" aria-hidden=\"true\"></i></span>\n                    </a>\n                    <span ng-if=\"connection.is_joint_invoicing\" title=\"{{ \'invoices.dashboard.change_installment_amount\' | translate }}\">{{connection.payment.installment_amount | currency}}</span>\n                  </span>\n                </div>\n                <div class=\"td md-td-3\">\n                  <span ng-if=\"connection.payment.iban\">\n                    <span class=\"visible-xs visible-sm table-label ng-binding\">{{ \'invoices.dashboard.iban\' | translate }}</span>\n                    <a title=\"{{ \'change_payment_method.change_iban\' | translate }}\" ui-sref=\"paymentMethodEdit({contract_account_id: connection.contract_account_id, contract_id: connection.contract_id})\">\n                      {{connection.payment.iban}} <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n                    </a>\n                  </span>\n                </div>\n\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/invoices/views/invoices.payment-arrangement.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'invoices.payment_arrangement.page_title\' | translate }}</h1>\n        <form name=\"invoice.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <div class=\"form-group\">\n            <label for=\"totalAmountRemaining\">{{\'invoices.payment_arrangement.total_amount_remaining\' | translate}}</label>\n            <input ng-value=\"invoice.draft.total_amount | currency\" type=\"text\" id=\"totalAmountRemaining\" class=\"form-control\" ng-disabled=\"true\">\n          </div>\n\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"payment-frequency\">{{\'invoices.payment_arrangement.payment_frequency\' | translate}}</label>\n<!--            <select ng-if=\"invoice.paymentFrequency\" ng-change=\"invoice.updatePaymentFrequencyAmount()\" id=\"payment-frequency\" class=\"form-control\" ng-required=\"true\" ng-model=\"invoice.draft.payment_frequency\">-->\n            <select ng-if=\"invoice.paymentFrequency.length\" ng-change=\"invoice.updatePaymentFrequencyAmount()\" id=\"payment-frequency\" class=\"form-control\" ng-required=\"true\" ng-model=\"invoice.draft.payment_frequency\" ng-options=\"idx for idx in invoice.paymentFrequency\">\n<!--            <select  ng-if=\"invoice.paymentFrequency\" ng-change=\"invoice.updatePaymentFrequencyAmount()\" id=\"payment-frequency\" class=\"form-control\" ng-required=\"true\" ng-model=\"invoice.draft.payment_frequency\" ng-options=\"idx as idx for (idx, frequency) in invoice.paymentFrequency\">-->\n              <option ng-if=\"invoice.paymentFrequency.length\" value=\"\">{{\'invoices.payment_arrangement.choose_option\' | translate}}</option>\n<!--              <option ng-if=\"invoice.paymentFrequency\" ng-repeat=\"idx in [].constructor(invoice.paymentFrequency) track by $index\" value=\"{{$index}}\">{{$index+1}}</option>-->\n            </select>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"payment-frequency-amount\">{{\'invoices.payment_arrangement.payment_frequency_amount\' | translate}}</label>\n            <input ng-value=\"invoice.draft.payment_frequency_amount | currency\" type=\"text\" id=\"payment-frequency-amount\" class=\"form-control\" ng-disabled=\"true\">\n          </div>\n\n          <div class=\"form-group\">\n            <label ng-class=\"{\'required\': invoice.draft.automatic_collection}\" for=\"iban\">{{ \'invoices.payment_arrangement.iban_number\' | translate }}</label>\n            <input ng-model-options=\"$root.ngModelOptions\" ng-iban id=\"iban\" ng-model=\"invoice.draft.iban\" ng-required=\"invoice.draft.automatic_collection\" type=\"text\" class=\"form-control\">\n          </div>\n\n<!--      <p>{{\'premise_register.new_premises.text2\' | translate}}</p>-->\n\n          <div class=\"form-group clearfix\">\n            <input ng-model=\"invoice.draft.automatic_collection\" ng-checked=\"invoice.draft.automatic_collection\" type=\"checkbox\" id=\"automatic-collection\">\n            <label for=\"automatic-collection\" class=\"label_info\">{{ \'invoices.payment_arrangement.pay_with_ai\' | translate }}</label>\n          </div>\n\n          <button ng-disabled=\"invoice.form.$invalid || invoice.sendingData\" ng-click=\"invoice.save()\" title=\"{{\'invoices.payment_arrangement.save_btn\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'invoices.payment_arrangement.save_btn\' | translate }}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"invoicesDashboard\" title=\"{{\'invoices.payment_arrangement.cancel_btn\' | translate}}\">{{ \'invoices.payment_arrangement.cancel_btn\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/invoices/views/invoices.remaining.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"title clearfix\">\n        <h1 class=\"pull-left\">{{ \'invoices.page_title_remaining\' | translate}}</h1>\n        <a role=\"button\" ng-click=\"invoice.openCSV()\" class=\"btn-link pull-right\">{{ \'invoices.download_csv\' | translate}} <i class=\"fa fa-download\" aria-hidden=\"true\"></i></a>\n      </div>\n\n      <div class=\"message-wrapper info clearfix\" ng-if=\"invoice.data\"><span class=\"visible-xs visible-sm\" ng-click=\"invoice.collapseFilter = !invoice.collapseFilter\">{{\'invoices.filters.mobile_filter_txt\' | translate}}<i class=\"pull-right\" ng-class=\"{\'fa fa-angle-down\' : invoice.collapseFilter, \'fa fa-angle-up\' : !invoice.collapseFilter}\"></i></span>\n        <div ng-class=\"{\'hidden-xs hidden-sm\' : invoice.collapseFilter}\">\n          <div class=\"form-group small\">\n            <form ng-submit=\"invoice.filter()\">\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ \'invoices.filters.invoice_number\' | translate}}\" ng-model=\"invoice.filterParams.invoice_id\">\n              <i class=\"fa fa-search\" aria-hidden=\"true\" role=\"button\" ng-click=\"invoice.filter()\"></i>\n            </form>\n          </div>\n          <div class=\"form-group medium\">\n            <select ng-hide=\"invoice.connectionAddresses.length == 1 || !invoice.connectionAddresses\" ng-options=\"address.value as address.label for address in invoice.connectionAddresses\" class=\"form-control\" ng-model=\"invoice.filterParams.address_number\" ng-change=\"invoice.filter()\">\n              <option value=\"\" selected=\"selected\" ng-if=\"!invoice.bCorporation\">{{\'invoices.filters.connection_address\' | translate}}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"no-invoices\" ng-if=\"invoice.data && !invoice.data.length\">\n        {{ \'invoices.no_remaining_invoices\' | translate }}\n      </div>\n\n      <div class=\"display-table invoices-table\" ng-if=\"invoice.data && invoice.data.length\">\n        <div class=\"table\">\n          <div class=\"thead hidden-xs hidden-sm\">\n            <div class=\"tr\">\n              <div class=\"th icon hidden-sm\"></div>\n              <div class=\"th\">{{ \'invoices.table.date\' | translate}}</div>\n              <div class=\"th invoice-number-padding\">{{ \'invoices.table.invoice_number\' | translate}}</div>\n              <div class=\"th\">{{ \'invoices.table.description\' | translate}}</div>\n              <div class=\"th\">{{ \'invoices.table.due_date\' | translate}}</div>\n              <div class=\"th\">{{ \'invoices.table.payment_method\' | translate}}</div>\n              <div class=\"th state\">{{ \'invoices.table.state\' | translate}}</div>\n              <div class=\"th ideal\" ng-if=\"invoice.enableIDEAL\">{{ \'invoices.table.standard_pay_method\' | translate}}</div>\n              <div class=\"th icon\"></div>\n            </div>\n          </div>\n          <div class=\"tbody\" ng-repeat=\"item in invoice.data track by $index\" ng-class=\"{\'open\' : (item.invoice_id == invoice.currentToggledDetail)}\">\n            <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n\n              <div role=\"button\" class=\"td icon hidden-xs hidden-sm\" ng-click=\"invoice.toggleDetail(item.invoice_id, item.has_details)\">\n                <i class=\"fa fa-angle-down table-icon\" aria-hidden=\"true\"></i>\n              </div>\n\n              <div role=\"button\" class=\"td icon visible-xs visible-sm\" ng-click=\"invoice.toggleDetail(item.invoice_id, false)\">\n                <i class=\"fa fa-angle-down table-icon\" aria-hidden=\"true\"></i>\n              </div>\n\n              <!--<div ng-if=\"!item.has_details\" class=\"td icon  hidden-xs hidden-sm\"></div>-->\n\n              <div class=\"td\">\n                {{item.date | date : \'dd-MM-yyyy\'}}\n                <span class=\"visible-xs visible-sm pull-right mobile-checkbox\" ng-if=\"invoice.enableIDEAL\">\n                  <input ng-change=\"invoice.calculateAmount(item, $index)\" ng-if=\"item.selectable && !item.payment_in_process\" type=\"checkbox\" ng-model=\"item.selected\">\n                </span>\n                <span class=\"visible-xs visible-sm pull-right\" ng-class=\"{\'paid\': item.fully_paid, \'error\': (!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0), \'no-icon\': (!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0 || item.payment_in_process && !item.due_date_expired), \'warning\': (!item.fully_paid && item.payment_in_process)}\">\n                  <span ng-if=\"!item.fully_paid && !item.due_date_expired && !item.payment_in_process || item.amount_remaining < 0\">{{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"item.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{ \'invoices.table.paid\' | translate}}</span>\n                  <span ng-if=\"item.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n                </span>\n              </div>\n\n              <div class=\"td invoice-number-padding\" ng-class=\"{ \'hidden-xs hidden-sm\': !!(item.invoice_id != invoice.currentToggledDetail)}\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.invoice_number\' | translate}}</span>\n                <span ng-if=\"!item.has_pdf\">{{item.invoice_id}}</span>\n                <a ng-if=\"item.has_pdf\" ng-click=\"invoice.openPDF(item.pdf_href)\">\n                  {{item.invoice_id}} <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\n                </a>\n              </div>\n\n              <div class=\"td\" ng-class=\"{ \'hidden-xs hidden-sm\': !!(item.invoice_id != invoice.currentToggledDetail)}\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.description\' | translate}}</span>\n                {{ \'invoices.descriptions.\'+ item.description | translate }}\n              </div>\n\n              <div class=\"td\" ng-class=\"{ \'hidden-xs hidden-sm\': !!(item.invoice_id != invoice.currentToggledDetail)}\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.due_date\' | translate}}</span>\n                {{item.due_date | date : \'dd-MM-yyyy\'}}\n              </div>\n\n              <div class=\"td\" ng-class=\"{ \'hidden-xs hidden-sm\': !!(item.invoice_id != invoice.currentToggledDetail)}\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.payment_method\' | translate}}</span>\n                {{\'paymentmethods.\' + item.payment_method | translate}}\n              </div>\n\n              <div class=\"td state hidden-xs hidden-sm\" ng-class=\"{\'paid\': item.fully_paid, \'error\': (!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0), \'no-icon\': (!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0 || item.payment_in_process), \'warning\': (!item.fully_paid && item.payment_in_process)}\">\n                <div role=\"button\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover-template=\"\'app/components/invoices/partials/popover.partial.html\'\" popover-placement=\"left\">\n                  <span ng-if=\"!item.fully_paid && !item.due_date_expired && !item.payment_in_process || item.amount_remaining < 0\">{{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{item.amount_remaining | currency}}</span>\n                </div>\n\n                <span ng-if=\"item.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{ \'invoices.table.paid\' | translate}}</span>\n                <span ng-if=\"item.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n              </div>\n\n              <div class=\"td ideal hidden-xs hidden-sm\" ng-if=\"invoice.enableIDEAL\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.payment_method\' | translate}}</span>\n                <input ng-change=\"invoice.calculateAmount(item, $index)\" ng-if=\"item.selectable && !item.payment_in_process\" type=\"checkbox\" ng-model=\"item.selected\">\n              </div>\n              <div class=\"td icon hidden-xs hidden-sm\">\n                <div role=\"button\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover-html=\"\'{{invoice.invoiceAddresses[item.address_id]}}\'\" popover-placement=\"left\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n            </div>\n\n            <!--NEW RULE-->\n            <div class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail && !item.is_payment_arrangement\">\n              <div class=\"th\"></div>\n              <div class=\"th back\">{{\'invoices.table.details_without_costs\' | translate}}</div>\n              <div class=\"th back\">{{\'invoices.table.details_total_costs\' | translate}}</div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\" ng-if=\"invoice.enableIDEAL\"></div>\n              <div class=\"th\"></div>\n            </div>\n            <div class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail && !item.is_payment_arrangement\">\n              <div class=\"td\"></div>\n              <div class=\"td back\"><span ng-if=\"item.amount_without_costs != 0\">{{item.amount_without_costs | currency}} <br></span></div>\n              <div class=\"td back\">{{item.costs_total | currency}}</div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\" ng-if=\"invoice.enableIDEAL\"></div>\n              <div class=\"td\"></div>\n            </div>\n            <div class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail && !item.is_payment_arrangement\">\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\" ng-if=\"invoice.enableIDEAL\"></div>\n              <div class=\"td\"></div>\n            </div>\n            <!--END NEW RULE-->\n\n\n            <!--ORIGINAL INVOICES-->\n            <div class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail && item.original_invoices.length\">\n              <div class=\"th\"></div>\n              <div class=\"th back\">Oorspronkelijke facturen</div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th\"></div>\n            </div>\n            <div class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\" ng-repeat=\"inv in item.original_invoices track by $index\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n\n              <div class=\"td\"></div>\n\n              <div class=\"td\">\n                {{inv.date | date : \'dd-MM-yyyy\'}}\n                <span class=\"visible-xs visible-sm pull-right mobile-checkbox\" ng-if=\"invoice.enableIDEAL\">\n                  <input ng-change=\"invoice.calculateAmount(inv, $index)\" ng-if=\"inv.selectable && !inv.payment_in_process\" type=\"checkbox\" ng-model=\"item.selected\">\n                </span>\n                <span class=\"visible-xs visible-sm pull-right\" ng-class=\"{\'paid\': inv.fully_paid, \'error\': (!inv.fully_paid && inv.due_date_expired && !inv.payment_in_process && inv.amount_remaining > 0), \'no-icon\': (!inv.fully_paid && !inv.due_date_expired || inv.amount_remaining < 0 || inv.payment_in_process && !inv.due_date_expired), \'warning\': (!inv.fully_paid && inv.payment_in_process)}\">\n                  <span ng-if=\"!inv.fully_paid && !inv.due_date_expired && !inv.payment_in_process || inv.amount_remaining < 0\">{{inv.amount_remaining | currency}}</span>\n                  <span ng-if=\"!inv.fully_paid && inv.due_date_expired && !inv.payment_in_process && inv.amount_remaining > 0\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{inv.amount_remaining | currency}}</span>\n                  <span ng-if=\"inv.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> {{ \'invoices.table.paid\' | translate}}</span>\n                  <span ng-if=\"inv.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n                </span>\n              </div>\n\n              <div class=\"td invoice-number-padding\" ng-class=\"{ \'hidden-xs hidden-sm\': !!(inv.invoice_id != invoice.currentToggledDetail)}\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.invoice_number\' | translate}}</span>\n                <span ng-if=\"!inv.has_pdf\">{{inv.invoice_id}}</span>\n                <a ng-if=\"inv.has_pdf\" ng-click=\"invoice.openPDF(inv.pdf_href)\">\n                  {{inv.invoice_id}} <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\n                </a>\n              </div>\n\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n\n            </div>\n            <!--END ORIGINAL INVOICES-->\n\n\n            <!--INVOICE DETAILS-->\n            <div ng-if=\"item.has_details\" class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail && invoice.currentDetailData.length\">\n              <div class=\"th\"></div>\n              <div class=\"th back\">{{ \'invoices.table.date\' | translate}}</div>\n              <div class=\"th back\">{{ \'invoices.table.payment_method\' | translate}}</div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\">{{ \'invoices.table.amount\' | translate}}</div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\" ng-if=\"invoice.enableIDEAL\"></div>\n              <div class=\"th\"></div>\n            </div>\n\n            <div ng-if=\"invoice.currentDetailData === null && item.has_details\" class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"td\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"><img src=\"/app/images/loader.svg\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\" ng-if=\"invoice.enableIDEAL\"></div>\n              <div class=\"td\"></div>\n            </div>\n\n            <div ng-if=\"item.has_details\" ng-repeat=\"detail in invoice.currentDetailData\" class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"td\"></div>\n              <div class=\"td back\">{{detail.date | date : \'dd-MM-yyyy\'}}</div>\n              <div class=\"td back\">{{ \'paymentmethods.\' + detail.payment_method | translate}}</div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\">{{detail.amount | currency}}</div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\" ng-if=\"invoice.enableIDEAL\"></div>\n              <div class=\"td\"></div>\n            </div>\n\n            <div class=\"tr sub-row empty-height\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\" ng-if=\"invoice.enableIDEAL\"></div>\n              <div class=\"td\"></div>\n            </div>\n            <!--END INVOICE DETAILS-->\n          </div>\n        </div>\n      </div>\n      <div ng-if=\"invoice.data && invoice.data.length && invoice.enableIDEAL\" class=\"checkout-wrapper clearfix\">\n        <div class=\"center pull-left\">{{ \'invoices.payment_message\' | translate}}</div>\n        <div ng-if=\"!!invoice.amountRemaining\" class=\"total pull-right\">\n          <div class=\"checkout-amount\"><strong>{{ \'invoices.pay_total\' | translate}}</strong> {{invoice.amountRemaining | currency}}</div>\n          <button type=\"button\" ng-click=\"invoice.doPayment()\" class=\"btn-custom btn-success\">{{ \'invoices.pay_btn\' | translate}}</button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row table-faq\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"card\">\n        <h3>{{\'faq.other_question\'|translate}}</h3>\n        <span translate=\"faq.text\"></span>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/invoices/views/invoices.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <div class=\"title clearfix\">\n        <h1 class=\"pull-left\">{{ \'invoices.page_title\' | translate}}</h1>\n      </div>\n\n      <div class=\"message-wrapper info clearfix\" ng-if=\"invoice.data\">\n        <span class=\"visible-xs visible-sm\" ng-click=\"invoice.collapseFilter = !invoice.collapseFilter\">{{\'invoices.filters.mobile_filter_txt\' | translate}}<i class=\"pull-right\" ng-class=\"{\'fa fa-angle-down\' : invoice.collapseFilter, \'fa fa-angle-up\' : !invoice.collapseFilter}\"></i></span>\n        <div ng-class=\"{\'hidden-xs hidden-sm\' : invoice.collapseFilter}\">\n          <div class=\"form-group small\">\n            <form ng-submit=\"invoice.filter()\">\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ \'invoices.filters.invoice_number\' | translate}}\" ng-model=\"invoice.filterParams.invoice_id\">\n              <i class=\"fa fa-search\" aria-hidden=\"true\" role=\"button\" ng-click=\"invoice.filter()\"></i>\n            </form>\n          </div>\n          <div class=\"form-group medium\">\n            <select ng-hide=\"invoice.connectionAddresses.length == 1 || !invoice.connectionAddresses\" ng-options=\"address.value as address.label for address in invoice.connectionAddresses\" class=\"form-control\" ng-model=\"invoice.filterParams.address_number\" ng-change=\"invoice.filter()\">\n              <option value=\"\" selected=\"selected\" ng-if=\"!invoice.bCorporation\">{{\'invoices.filters.connection_address\' | translate}}</option>\n            </select>\n          </div>\n          <div class=\"form-group small\">\n            <select class=\"form-control\" ng-model=\"invoice.filterParams.year\" ng-options=\"value as value for (key, value) in invoice.yearFilters\" ng-change=\"invoice.filter()\">\n              <option value=\"\">{{\'invoices.filters.year\' | translate}}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"no-invoices\" ng-if=\"invoice.data && !invoice.data.length\">\n        {{ \'invoices.no_invoices\' | translate }}\n      </div>\n\n      <div class=\"display-table invoices-table\" ng-if=\"invoice.data && invoice.data.length\">\n        <div class=\"table\">\n          <div class=\"thead hidden-xs hidden-sm\">\n            <div class=\"tr\">\n              <div class=\"th icon\"></div>\n              <div class=\"th\">{{\'invoices.table.date\' | translate}}</div>\n              <div class=\"th\">{{\'invoices.table.invoice_number\' | translate}}</div>\n              <div class=\"th\">{{\'invoices.table.description\' | translate}}</div>\n              <div class=\"th\">{{\'invoices.table.amount\' | translate}}</div>\n              <div class=\"th state\">{{\'invoices.table.status\' | translate}}</div>\n              <div class=\"th icon\"></div>\n            </div>\n          </div>\n          <div class=\"tbody\" ng-repeat=\"item in invoice.data\" ng-class=\"{\'open\' : (item.invoice_id == invoice.currentToggledDetail)}\">\n            <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n\n              <div role=\"button\" ng-if=\"item.has_details\" class=\"td icon hidden-xs hidden-sm\" ng-click=\"invoice.toggleDetail(item.invoice_id, true)\">\n                <i class=\"fa fa-angle-down table-icon\" aria-hidden=\"true\"></i>\n              </div>\n\n              <div role=\"button\" class=\"td icon visible-xs visible-sm\" ng-click=\"invoice.toggleDetail(item.invoice_id, false)\">\n                <i class=\"fa fa-angle-down table-icon\" aria-hidden=\"true\"></i>\n              </div>\n\n              <div ng-if=\"!item.has_details\" class=\"td icon hidden-xs hidden-sm\"></div>\n\n              <div class=\"td\">\n                {{item.date | date : \'dd-MM-yyyy\'}}\n                <span class=\"visible-xs visible-sm pull-right\" ng-class=\"{\'paid\': item.fully_paid, \'error\': (!item.fully_paid && item.due_date_expired && !item.payment_in_process), \'no-icon\': (!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0), \'warning\': (!item.fully_paid && item.due_date_expired && item.payment_in_process)}\">\n                  <span ng-if=\"!item.fully_paid && !item.due_date_expired\">{{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"!item.fully_paid && item.due_date_expired && !item.payment_in_process\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"item.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> <span ng-if=\"!item.is_refund\">{{ \'invoices.table.paid\' | translate}}</span><span ng-if=\"item.is_refund\">{{ \'invoices.table.refunded\' | translate}}</span></span>\n                  <span ng-if=\"item.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n                </span>\n              </div>\n\n              <div class=\"td\" ng-class=\"{ \'hidden-xs hidden-sm\': !!(item.invoice_id != invoice.currentToggledDetail)}\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.invoice_number\' | translate}}</span>\n                <span ng-if=\"!item.has_pdf\">{{item.invoice_id}}</span>\n                <a ng-if=\"item.has_pdf\" ng-click=\"invoice.openPDF(item.pdf_href)\">\n                  {{item.invoice_id}} <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\n                </a>\n              </div>\n\n              <div class=\"td\" ng-class=\"{ \'hidden-xs hidden-sm\': !!(item.invoice_id != invoice.currentToggledDetail)}\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.description\' | translate}}</span>\n                {{ \'invoices.descriptions.\'+ item.description | translate }}\n              </div>\n\n              <div class=\"td\" ng-class=\"{ \'hidden-xs hidden-sm\': !!(item.invoice_id != invoice.currentToggledDetail)}\">\n                <span class=\"visible-xs visible-sm table-label\">{{ \'invoices.table.amount\' | translate}}</span>\n                {{item.amount | currency}}\n              </div>\n\n              <div class=\"td state hidden-xs hidden-sm\" ng-class=\"{\'paid\': item.fully_paid, \'error\': (!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0), \'no-icon\': (!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0), \'warning\': (!item.fully_paid && item.due_date_expired && item.payment_in_process)}\">\n                <div role=\"button\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover-template=\"\'app/components/invoices/partials/popover.partial.html\'\" popover-placement=\"left\">\n                  <span ng-if=\"!item.fully_paid && !item.due_date_expired || item.amount_remaining < 0\">{{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"!item.fully_paid && item.due_date_expired && !item.payment_in_process && item.amount_remaining > 0\"><i class=\"fa fa-exclamation\" aria-hidden=\"true\"></i> {{item.amount_remaining | currency}}</span>\n                  <span ng-if=\"item.fully_paid\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> <span ng-if=\"!item.is_refund\">{{ \'invoices.table.paid\' | translate}}</span><span ng-if=\"item.is_refund\">{{ \'invoices.table.refunded\' | translate}}</span></span>\n                </div>\n                <span ng-if=\"item.payment_in_process\">{{ \'invoices.table.payment_in_process\' | translate}}</span>\n              </div>\n\n              <div role=\"button\" class=\"td icon\"></div>\n            </div>\n\n            <!--NEW RULE-->\n            <div class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"th\"></div>\n              <div class=\"th back\">{{\'invoices.table.details_without_costs\' | translate}}</div>\n              <div class=\"th back\">{{\'invoices.table.details_total_costs\' | translate}}</div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\"></div>\n              <div class=\"th\"></div>\n            </div>\n            <div class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"td\"></div>\n              <div class=\"td back\"><span ng-if=\"item.amount_without_costs != 0\">{{item.amount_without_costs | currency}} <br></span></div>\n              <div class=\"td back\">{{item.costs_total | currency}}</div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td\"></div>\n            </div>\n            <div class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n            </div>\n            <!--END NEW RULE-->\n\n            <div ng-if=\"item.has_details\" class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail && invoice.currentDetailData.length\">\n              <div class=\"th\"></div>\n              <div class=\"th back\">{{ \'invoices.table.date\' | translate}}</div>\n              <div class=\"th back\">{{ \'invoices.table.payment_method\' | translate}}</div>\n              <div class=\"th back\"></div>\n              <div class=\"th back\">{{ \'invoices.table.amount\' | translate}}</div>\n              <div class=\"th back\"></div>\n              <div class=\"th\"></div>\n            </div>\n\n            <div ng-if=\"invoice.currentDetailData === null\" class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"td\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\">\n                <img src=\"/app/images/loader.svg\">\n              </div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\"></div>\n              <div class=\"td\"></div>\n            </div>\n\n            <div ng-if=\"item.has_details\" ng-repeat=\"detail in invoice.currentDetailData\" class=\"tr sub-row hidden-xs hidden-sm\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"td\"></div>\n              <div class=\"td back\">{{detail.date | date : \'dd-MM-yyyy\'}}</div>\n              <div class=\"td back\">{{ \'paymentmethods.\' + detail.payment_method | translate}}</div>\n              <div class=\"td back\"></div>\n              <div class=\"td back\">{{detail.amount | currency}}</div>\n              <div class=\"td back\"></div>\n              <div class=\"td\"></div>\n            </div>\n            <div class=\"tr sub-row empty-height\" ng-show=\"item.invoice_id == invoice.currentToggledDetail\">\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n              <div class=\"td\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"pagination-wrapper clearfix\" ng-if=\"invoice.data.meta\">\n        <div class=\"pull-left pagination-txt\" translate=\"invoices.pagination.page_counter\" translate-value-range=\"{{invoice.data.meta.range.start}} - {{invoice.data.meta.range.end}}\" translate-value-total=\"{{invoice.data.meta.total_items}}\"></div>\n        <div class=\"pull-right pagination-nav\" ng-if=\"invoice.data.meta.total_items > invoice.filterParams.limit\">\n          <ul ng-change=\"invoice.changePage()\" uib-pagination previous-text=\"{{ \'invoices.pagination.previous\' | translate}}\" next-text=\"{{ \'invoices.pagination.next\' | translate}}\" total-items=\"invoice.data.meta.total_items\" ng-model=\"invoice.filterParams.page\" max-size=\"5\" items-per-page=\"10\" boundary-links=\"false\" class=\"pagination\"></ul>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row table-faq\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"card\">\n        <h3>{{\'faq.other_question\'|translate}}</h3>\n        <span translate=\"faq.text\"></span>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/login/views/login.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"register-text\">\n        <div class=\"h1\" translate=\"login.register_text\"></div>\n        <a ui-sref=\"sign-up\" title=\"{{ \'login.signup_btn\' | translate}}\" class=\"btn-custom btn-success sign-up-button\">{{ \'login.signup_btn\' | translate}}</a>\n      </div>\n      <div class=\"form\">\n        <h1>{{ \'login.page_title\' | translate}}</h1>\n        <form name=\"login.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{ \'login.email\' | translate}}</label>\n            <input ng-model-options=\"$root.ngModelOptions\" check-email ng-required=\"true\" ng-model=\"login.form.email\" type=\"email\" class=\"form-control\" id=\"email\" placeholder=\"{{ \'login.email\' | translate}}\">\n            <div ng-if=\"\'login.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'login.hints.email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"password\" class=\"required\">{{ \'login.password\' | translate}}</label>\n            <password id=\"password\" ng-model=\"login.form.password\"></password>\n            <div ng-if=\"\'login.hints.password\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'login.hints.password\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <a ui-sref=\"passwordForgot\" title=\"{{ \'login.forgot_password\' | translate}}\" class=\"btn-link\">{{ \'login.forgot_password\' | translate}}</a>\n          <button ng-disabled=\"login.sendingData\" ng-click=\"login.doLogin()\" title=\"{{ \'login.login_btn\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right float-xs-left\">{{ \'login.login_btn\' | translate}}</button>\n        </form>\n      </div>\n\n      <div class=\"formbuttons\">\n        <div class=\"line\">\n          <div class=\"word\">{{ \'general.or\' | translate}}</div>\n        </div>\n\n        <div class=\"extra_button\">\n          <a ui-sref=\"sign-up\" title=\"{{ \'login.signup_btn\' | translate}}\" class=\"btn-custom btn-secondary sign-up-button\">{{ \'login.signup_btn\' | translate}}</a>\n        </div>\n        <div class=\"extra_button\">\n          <a ui-sref=\"registerMoveInDate\" title=\"{{ \'login.become_customer\' | translate}}\" class=\"btn-link\">{{ \'login.become_customer\' | translate}}</a>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/message/views/message.view.html","<div class=\"container\" ng-show=\"message.stickyMessage\">\n  <div class=\"row\">\n    <div id=\"messageScroll1\" class=\"col-xs-12\">\n      <div ng-if=\"message.stickyMessage.level\" class=\"message-wrapper sticky-message\" ng-class=\"message.stickyMessage.level\">\n        <h2 ng-bind-html=\"message.stickyMessage.message\"></h2>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"container\" ng-show=\"!message.bHideError\">\n  <div class=\"row\">\n    <div id=\"messageScroll\" class=\"col-xs-12\">\n      <div ng-if=\"message.level\" class=\"message-wrapper\" ng-class=\"message.level\" ng-bind-html=\"message.message\">\n      </div>\n    </div>\n  </div>\n</div>\n\n\n");
$templateCache.put("app/components/meter-readings/views/meter-reading.email-confirmation.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'meter_readings.recording_number.page_title\' | translate }}</h1>\n        <form name=\"meterReadings.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <div class=\"form-group\">\n            <div class=\"group-label required\">{{ \'meter_readings.optional_email\' | translate}}</div>\n            <div class=\"radio\">\n              <label><input ng-required=\"true\" ng-model=\"meterReadings.data.optional_email\" type=\"radio\" name=\"confirmation\" ng-value=\"false\">{{ \'meter_readings.no\' | translate}}</label>\n            </div>\n            <div class=\"radio\">\n              <label><input ng-model=\"meterReadings.data.optional_email\" type=\"radio\" name=\"confirmation\" ng-value=\"true\">{{ \'meter_readings.yes\' | translate}}</label>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <div class=\"form-group\" ng-if=\"meterReadings.data.optional_email\">\n              <input check-email id=\"email\" type=\"text\" ng-model=\"meterReadings.data.email\" class=\"form-control\" placeholder=\"{{ \'forgot_password.email\' | translate}}\">\n            </div>\n          </div>\n\n          <button ng-disabled=\"(meterReadings.form.$invalid || (meterReadings.data.optional_email && (!meterReadings.data.email || meterReadings.data.email === \'\')))\" ng-click=\"meterReadings.next()\" title=\"{{ \'meter_readings.btn_next\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'meter_readings.btn_next\' | translate }}\n          </button>\n\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"meterReadings.cancel()\" title=\"{{ \'meter_readings.cancel\' | translate}}\">\n            {{ \'meter_readings.cancel\' | translate}}\n          </button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/meter-readings/views/meter-reading.recording-number.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'meter_readings.recording_number.page_title\' | translate }}</h1>\n        <form name=\"meterReadings.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"assignment_number\" class=\"required\">{{ \'meter_readings.recording_number.number\' | translate }}</label>\n            <input ng-required=\"true\" aria-required=\"true\" check-number ng-model=\"meterReadings.data.credentials.assignment_number\" type=\"text\" class=\"form-control\" id=\"assignment_number\" placeholder=\"12345678\">\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"postal-code\" class=\"required\">{{ \'meter_readings.recording_number.postal_code\' | translate }}</label>\n            <input ui-mask=\"9999 AA\" placeholder=\"{{\'meter_readings.recording_number.placeholder_postal_code\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"meterReadings.data.credentials.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\">\n          </div>\n\n          <button ng-disabled=\"meterReadings.form.$invalid || meterReadings.sendingData\" ng-click=\"meterReadings.next()\" title=\"{{ \'meter_readings.btn_next\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'meter_readings.recording_number.btn_next\' | translate }}\n          </button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/meter-readings/views/meter-reading.summary.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix\">\n        <h1>{{\'meter_readings.summary.page_title\' | translate}}</h1>\n\n        <div class=\"summary-form-block\">\n          <h3>{{\'meter_readings.summary.personal_data_title\' | translate}}</h3>\n          <div class=\"block-inner\">\n            <div class=\"block-inner-label\">{{\'meter_readings.summary.recording_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ meterReadings.data.credentials.assignment_number}}</div>\n            <div class=\"clearfix\"></div>\n          </div>\n          <div class=\"block-inner\">\n            <div class=\"block-inner-label\">{{\'meter_readings.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <div>{{meterReadings.data.address.street}} {{meterReadings.data.address.house_no}} {{meterReadings.data.address.house_no_addition}}</div>\n              <div>{{meterReadings.data.address.postal_code | uppercase}} {{meterReadings.data.address.city}}</div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'meter_readings.summary.meter_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{meterReadings.data.meter_number}}</div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\">\n          <a ng-click=\"meterReadings.gotoMeterReading()\" title=\"{{\'meter_readings.summary.meter_reading.edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'meter_readings.summary.meter_reading.title\' | translate}}</h3>\n          <div class=\"block-inner\">\n            <div class=\"block-inner-label\">{{\'meter_readings.summary.meter_reading.date\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ meterReadings.data.date | date:\'dd-MM-yyyy\'}}</div>\n            <div class=\"clearfix\"></div>\n          </div>\n          <div class=\"block-inner\">\n            <div class=\"block-inner-label\">{{\'meter_readings.summary.meter_reading.reading\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ meterReadings.data.meter_reading}}</div>\n            <div class=\"clearfix\"></div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\">\n          <a ng-click=\"meterReadings.cancel()\" title=\"{{\'meter_readings.summary.email.edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'meter_readings.summary.email.title\' | translate}}</h3>\n          <div class=\"block-innner\" ng-if=\"meterReadings.data.optional_email && meterReadings.data.email && meterReadings.data.email !== \'\'\">\n            <div class=\"block-inner-label\">{{\'meter_readings.summary.email.emailadress\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ meterReadings.data.email}}</div>\n            <div class=\"clearfix\"></div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"!meterReadings.data.optional_email\">\n            <div>{{\'meter_readings.summary.email.none\' | translate}}</div>\n          </div>\n        </div>\n\n<!--        <div class=\"form-group checkbox\" ng-if=\"!meterReadings.isCorporation && !meterReadings.isCompany && !meterReadings.data.forced_meter_reading\">-->\n<!--          <label>-->\n<!--            <input ng-model=\"meterReadings.data.keep_installment_amount\" ng-checked=\"meterReadings.data.keep_installment_amount\" type=\"checkbox\" id=\"keep-installment-amount\">{{ \'meter_readings.keep_installment_amount\' | translate}}-->\n<!--          </label>-->\n<!--          <div ng-if=\"\'meter_readings.hints.keep_installment_amount\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'meter_readings.hints.keep_installment_amount\' | translate}}\" popover-placement=\"top-right\">-->\n<!--            <i class=\"fa fa-info\" aria-hidden=\"true\"></i>-->\n<!--          </div>-->\n<!--        </div>-->\n\n<!--        <div class=\"summary-form-block\" ng-if=\"premises.data.correspondence.confirmationEmail !== null && !premises.data.bIsInFuture\">-->\n<!--          <a ui-sref=\"premisesUnregisterEmail\" title=\"{{\'premise_unregister.summary.email_edit\' | translate}}\" class=\"edit-icon pull-right\">-->\n<!--            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>-->\n<!--          </a>-->\n<!--          <h3>{{\'premise_unregister.summary.email\' | translate}}</h3>-->\n<!--          <div class=\"block-innner\">-->\n<!--            <div class=\"block-inner-label\">{{\'premise_unregister.summary.email_label\' | translate}}</div>-->\n<!--            <div class=\"block-inner-text\">{{premises.data.correspondence.confirmationEmail}}</div>-->\n<!--          </div>-->\n<!--          <div class=\"clearfix\"></div>-->\n<!--          <div class=\"block-innner\">-->\n<!--            <div class=\"block-inner-label\">{{\'premise_unregister.summary.email_post\' | translate}}</div>-->\n<!--            <div class=\"block-inner-text\">{{ \'premise_unregister.email.email_post.\' + (premises.data.correspondence.bSetAsNewEmail === true ? \'yes\':\'no\') | translate}}</div>-->\n<!--          </div>-->\n<!--        </div>-->\n        <button ng-click=\"meterReadings.save()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'meter_readings.summary.save\' | translate}}</button>\n        <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"meterReadings.cancel()\" title=\"{{\'meter_readings.summary.cancel\' | translate}}\">{{\'meter_readings.summary.cancel\' | translate}}</button>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/meter-readings/views/meter-reading.thank-you.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'meter_readings.thank_you.page_title\' | translate}}</h1>\n        <p ng-if=\"meterReadings.data.email\" translate=\"meter_readings.thank_you.text\"></p>\n        <p ng-if=\"!meterReadings.data.email\" translate=\"meter_readings.thank_you.no_email_text\"></p>\n        <br>\n        <div ng-if=\"meterReadings.data.wfl_possible && meterReadings.data.wfl_amount === \'0.00\' && meterReadings.data.wfl_month === 0\">\n          <div ng-if=\"!meterReadings.wflSuccess\">\n            <img class=\"img-responsive\" src=\"/app/images/water_for_life_logo.svg\">\n            <h2>{{ \'meter_readings.thank_you.wfl.title\' | translate}}</h2>\n            <p>{{ \'meter_readings.thank_you.wfl.p1\' | translate}}</p>\n            <p>{{ \'meter_readings.thank_you.wfl.p2\' | translate}}</p>\n            <p>{{ \'meter_readings.thank_you.wfl.p3\' | translate}}</p>\n\n            <div class=\"form-group\">\n              <div class=\"radio\">\n                <label><input ng-required=\"true\" ng-disabled=\"meterReadings.wflSuccess\" value=\"5\" ng-model=\"meterReadings.amount\" type=\"radio\" name=\"amount\" ng-value=\"5\">&euro;{{ \'meter_readings.thank_you.wfl.amount.a5\' | translate }}</label>\n              </div>\n              <div class=\"radio\">\n                <label><input ng-required=\"true\" ng-disabled=\"meterReadings.wflSuccess\" ng-model=\"meterReadings.amount\" type=\"radio\" name=\"amount\" ng-value=\"20\">&euro;{{ \'meter_readings.thank_you.wfl.amount.a20\' | translate }}</label>\n              </div>\n              <div class=\"radio\">\n                <label><input ng-required=\"true\" ng-disabled=\"meterReadings.wflSuccess\" ng-model=\"meterReadings.amount\" type=\"radio\" name=\"amount\" ng-value=\"50\">&euro;{{ \'meter_readings.thank_you.wfl.amount.a50\' | translate }}</label>\n              </div>\n              <div class=\"radio\">\n                <label><input ng-required=\"true\" ng-disabled=\"meterReadings.wflSuccess\" ng-model=\"meterReadings.amount\" type=\"radio\" name=\"amount\" ng-value=\"0\">{{ \'meter_readings.thank_you.wfl.amount.other\' | translate }}</label>\n              </div>\n            </div>\n            <input ng-required=\"meterReadings.amount === 0\" ng-if=\"meterReadings.amount === 0\" ng-model=\"meterReadings.custom_amount\" style=\"width: 100px\" min=\"5\" type=\"number\" class=\"form-control\" id=\"wfl_amount\">\n\n            <p>{{ \'meter_readings.thank_you.wfl.p4\' | translate}}</p>\n            <p>{{ \'meter_readings.thank_you.wfl.p5\' | translate}}</p>\n\n            <div class=\"form-group\">\n              <div class=\"checkbox\">\n                <label for=\"conditions\" class=\"required\">\n                  <input ng-disabled=\"meterReadings.wflSuccess\" ng-required=\"true\" aria-required=\"true\" type=\"checkbox\" id=\"conditions\" ng-model=\"meterReadings.accept_conditions\">\n                  <span translate=\"meter_readings.thank_you.wfl.conditions\"></span>.\n                </label>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"meterReadings.wflSuccess\">\n            <img class=\"img-responsive\" src=\"/app/images/water_for_life_logo.svg\">\n            <p>{{ \'customer.wfl.text\' | translate }}</p>\n          </div>\n          <button ng-disabled=\"meterReadings.form.$invalid || meterReadings.accept_conditions !== true || (meterReadings.amount === 0 && (!meterReadings.custom_amount || meterReadings.custom_amount < 5))\" ng-if=\"!meterReadings.wflSuccess\" ng-click=\"meterReadings.save()\" type=\"submit\" class=\"btn-custom btn-primary button-margin-left\" title=\"{{ \'meter_readings.thank_you.wfl.buttons.donate_now\' | translate }}\">{{ \'meter_readings.thank_you.wfl.buttons.donate_now\' | translate }}</button>\n          <button type=\"button\" ng-click=\"meterReadings.next()\" class=\"btn-custom btn-primary button-margin-left\" title=\"{{ \'meter_readings.thank_you.wfl.buttons.home\' | translate }}\" ng-if=\"meterReadings.wflSuccess && !meterReadings.isAuthenticated\">{{ \'meter_readings.thank_you.wfl.buttons.home\' | translate }}</button>\n          <button type=\"button\" ng-click=\"meterReadings.next()\" class=\"btn-custom btn-primary button-margin-left\" title=\"{{ \'meter_readings.thank_you.wfl.buttons.overview\' | translate }}\" ng-if=\"meterReadings.wflSuccess && meterReadings.isAuthenticated\">{{ \'meter_readings.thank_you.wfl.buttons.overview\' | translate }}</button>\n          <button type=\"button\" ng-click=\"meterReadings.next()\" class=\"btn-custom btn-cancel\" title=\"{{ \'meter_readings.thank_you.wfl.buttons.skip\' | translate }}\" ng-if=\"!meterReadings.wflSuccess\">{{ \'meter_readings.thank_you.wfl.buttons.skip\' | translate }}</button>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/meter-readings/views/meter-reading.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'meter_readings.page_title\' | translate }}</h1>\n        <form name=\"meterReadings.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <p ng-if=\"meterReadings.consumption !== null\" translate=\"meter_readings.last_reading\" translate-values=\"{lastReading : meterReadings.consumption.reading, readingDate : meterReadings.consumption.date}\"></p>\n\n          <div class=\"form-group\">\n            <label for=\"recording-date\" class=\"required\">{{ \'meter_readings.recording_date\' | translate }}</label>\n            <div class=\"input-group\">\n              <input ng-keydown=\"$event.preventDefault()\" ng-click=\"meterReadings.openDatepicker()\" uib-datepicker-popup=\"{{meterReadings.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"meterReadings.datepickerOptions\" is-open=\"meterReadings.showDatepicker\" ng-required=\"true\" ng-model=\"meterReadings.data.date\" type=\"text\" class=\"form-control\" id=\"recording-date\">\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"meterReadings.openDatepicker()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n              </span>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"meterReadings.data.meter_number\">\n            <label for=\"meter-reading\">{{ \'meter_readings.meter_number\' | translate}}</label><br>\n            <input ng-disabled=\"true\" ng-required=\"false\" ng-model=\"meterReadings.data.meter_number\" type=\"text\" class=\"form-control\" id=\"meter-number\">\n            <div ng-if=\"\'meter_readings.hints.meter_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'meter_readings.hints.meter_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"meter-reading\" class=\"required\">{{ \'meter_readings.meter_reading\' | translate}}</label><br>\n            <input ng-required=\"true\" ng-model=\"meterReadings.data.meter_reading\" type=\"text\" class=\"form-control text-right\" id=\"meter-reading\" ng-maxlength=\"meterReadings.numberOfMeterNumbers\" maxlength=\"{{meterReadings.numberOfMeterNumbers}}\" check-number>\n            <div ng-if=\"\'meter_readings.hints.meter_reading\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'meter_readings.hints.meter_reading\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <div class=\"meter-input meter-width-{{meterReadings.numberOfMeterNumbers}}\" ng-class=\"{\'last\': $last}\" ng-repeat=\"number in meterReadings.aNumberOfMeterNumbers\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"meterReadings.data[\'num\'+number]\" type=\"text\" class=\"form-control\" id=\"meter-reading-num{{number}}\">\n            </div>\n            <div class=\"meter-input-disabled-wrapper meter-input-disabled-wrapper{{meterReadings.numberOfMeterNumbers}}\">\n              <span class=\"meter-input-comma\">,</span>\n              <div class=\"meter-input meter-width-{{meterReadings.numberOfMeterNumbers}}\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n              <div class=\"meter-input meter-width-{{meterReadings.numberOfMeterNumbers}}\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n              <div class=\"meter-input meter-width-{{meterReadings.numberOfMeterNumbers}} clear-margin-right\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"meterReadings.data.forced_meter_reading\">\n            <label for=\"deviation-code\">{{ \'meter_readings.deviation_code\' | translate }}</label>\n            <select ng-required=\"meterReadings.data.forced_meter_reading\" id=\"deviation-code\" class=\"form-control\" ng-model=\"meterReadings.data.deviation_code\" ng-options=\"option.code as \'meter_readings.deviations.\' + option.translate_key|translate for option in meterReadings.data.deviations\"></select>\n            <div ng-if=\"\'meter_readings.hints.deviation_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'meter_readings.hints.deviation_code\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-show=\"meterReadings.data.forced_meter_reading && meterReadings.data.deviation_code == \'99\'\">\n            <label for=\"deviation-reason\">{{ \'meter_readings.deviation_reason\' | translate }}</label>\n            <textarea ng-required=\"meterReadings.data.forced_meter_reading && meterReadings.data.deviation_code == \'99\'\" id=\"deviation-reason\" class=\"form-control\" ng-model=\"meterReadings.data.deviation_reason\"></textarea>\n            <div ng-if=\"\'meter_readings.hints.deviation_reason\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'meter_readings.hints.deviation_reason\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div ng-if=\"meterReadings.data.forced_meter_reading\" class=\"form-group\">\n            <label for=\"fileUpload\">{{ \'meter_readings.file_upload\' | translate}}</label>\n\n            <div class=\"current-file-name\" ng-if=\"meterReadings.data.file_upload.name\">\n              {{meterReadings.data.file_upload.name}}\n            </div>\n\n            <div class=\"file-upload-container\">\n              <input ng-value=\"meterReadings.fileToUpload.name\" ng-required=\"false\" ngf-resize=\"{width: 1200, height: 1200, quality: .8}\" ng-disabled=\"true\" type=\"text\" class=\"form-control\" id=\"filenameField\" placeholder=\"\">\n              <button class=\"btn-custom btn-file btn-primary button-margin-left\" ngf-max-size=\"20MB\" ngf-select=\"meterReadings.fileChange($file, $invalidFiles);\" ng-required=\"false\" ng-model=\"meterReadings.data.fileUpload\" id=\"fileUpload\" name=\"fileUpload\" type=\"file\" ngf-accept=\"\'image/jpeg, image/png, image/gif\'\">\n                <label for=\"fileUpload\">{{ \'meter_readings.file_upload_btn\' | translate}}</label>\n              </button>\n            </div>\n\n            <div class=\"clearfix\"></div>\n            <div class=\"field-description\">{{ \'meter_readings.file_upload_description\' | translate }}</div>\n          </div>\n\n          <button ng-disabled=\"meterReadings.form.$invalid\" ng-click=\"meterReadings.save()\" title=\"{{ \'meter_readings.btn_next\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'meter_readings.btn_next\' | translate }}\n          </button>\n\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"meterReadings.cancel()\" title=\"{{ \'meter_readings.cancel\' | translate}}\">\n            {{ \'meter_readings.cancel\' | translate}}\n          </button>\n        </form>\n\n        <meter-images></meter-images>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises/partials/ask-to-continue.modal.partial.html","<div class=\"modal-header\">\n  <h1 class=\"modal-title\" id=\"modal-title\">{{ title }}</h1>\n</div>\n<div class=\"modal-body clearfix\" id=\"modal-body\">\n  <p>{{ paragraph }}</p>\n  <p>{{ paragraph2 }}</p>\n  <button ng-click=\"next()\" type=\"button\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'premises.askContinueModal.moving_in.yes\' | translate}}</button>\n  <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"cancel()\" title=\"{{ \'customer.edit.cancel\' | translate}}\">{{ \'premises.askContinueModal.moving_in.no\' | translate}}</button>\n</div>\n");
$templateCache.put("app/components/payment-method/views/payment-method.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'change_payment_method.page_title\' | translate }}</h1>\n        <form name=\"payments.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"payment-methods\">{{ \'change_payment_method.payment_method\' | translate}}</label>\n            <select ng-change=\"payments.filterFrequencies()\" ng-disabled=\"payments.bPaymentMethodDisabled\" id=\"payment-methods\" class=\"form-control\" ng-model=\"payments.draft.payment_method\" ng-options=\"method.value as \'change_payment_method.\' + method.label | translate for method in payments.paymentMethods\">\n            </select>\n            <div ng-if=\"\'change_payment_method.hints.payment_method\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'change_payment_method.hints.payment_method\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"payment-frequency\">{{ \'change_payment_method.payment_frequency\' | translate}}</label>\n            <select ng-change=\"payments.filterPaymentDays()\" id=\"payment-frequency\" class=\"form-control\" ng-model=\"payments.draft.payment_frequency\" ng-options=\"frequency.value as \'change_payment_method.\' + frequency.label | translate for frequency in payments.paymentFrequency\">\n            </select>\n            <div ng-if=\"\'change_payment_method.hints.payment_frequency\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'change_payment_method.hints.payment_frequency\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <div class=\"form-group\" ng-if=\"payments.draft.payment_method == \'automatic_collection\'\">\n            <label for=\"pay-dates\">{{ \'change_payment_method.pay_date\' | translate}}</label>\n            <select id=\"pay-dates\" class=\"form-control\" ng-model=\"payments.draft.payment_date\" ng-options=\"dates.value as \'change_payment_method.\' + dates.label | translate for dates in payments.payment_dates\">\n            </select>\n            <div ng-if=\"\'change_payment_method.hints.pay_date\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'change_payment_method.hints.pay_date\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"iban\" class=\"required\">{{ \'change_payment_method.iban\' | translate }}</label>\n            <input ng-model-options=\"$root.ngModelOptions\" ng-iban ng-required=\"true\" id=\"iban\" ng-model=\"payments.draft.iban\" type=\"text\" class=\"form-control\">\n            <div ng-if=\"\'change_payment_method.hints.iban\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'change_payment_method.hints.iban\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <button ng-disabled=\"payments.form.$invalid || payments.sendingData\" ng-click=\"payments.save()\" title=\"{{ \'change_payment_method.save_btn\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'change_payment_method.save_btn\' | translate }}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"invoicesDashboard\" title=\"{{ \'change_payment_method.cancel_btn\' | translate}}\">{{ \'change_payment_method.cancel_btn\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n\n\n\n\n\n\n\n\n\n");
$templateCache.put("app/components/premises/views/premises-action-overview.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix\">\n        <h2>{{\'premises.action_overview.premise_unregister_title\' | translate}}</h2>\n        <p>{{\'premises.action_overview.premise_unregister_paragraph\' | translate}}</p>\n        <p>{{\'premises.action_overview.premise_unregister_paragraph2\' | translate}}</p>\n        <a class=\"btn-custom btn-primary pull-right\" ui-sref=\"premisesUnregisterMoveOutDate({ clearCache: \'true\'})\">{{\'premises.action_overview.premise_unregister_btn\' | translate}}</a>\n      </div>\n    </div>\n\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix\">\n        <h2>{{\'premises.action_overview.premise_register_title\' | translate}}</h2>\n        <p>{{\'premises.action_overview.premise_register_paragraph\' | translate}}</p>\n        <p>{{\'premises.action_overview.premise_register_paragraph2\' | translate}}</p>\n        <a class=\"btn-custom btn-primary pull-right\" ui-sref=\"premisesRegisterMoveInDate({ clearCache: \'true\'})\">{{\'premises.action_overview.premise_register_btn\' | translate}}</a>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.correspondence.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_register.correspondence.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n<!--          <p>{{\'premise_register.correspondence.text\' | translate}}</p>-->\n          <div class=\"correspondence-form-block\">\n            <strong>{{\'premise_register.correspondence.current_correspondence\' | translate}}</strong>\n            <div ng-if=\"premises.data.currentCorrespondenceAddress.po_box.length\">{{\'premise_register.correspondence.po_box\' | translate}} {{premises.data.currentCorrespondenceAddress.po_box}}, {{premises.data.currentCorrespondenceAddress.po_box_postal_code}} {{premises.data.currentCorrespondenceAddress.city}}</div>\n            <div ng-if=\"premises.data.currentCorrespondenceAddress.po_box.length == 0\">{{premises.data.currentCorrespondenceAddress.street}} {{premises.data.currentCorrespondenceAddress.house_no}} {{premises.data.currentCorrespondenceAddress.house_no_addition}}, {{premises.data.currentCorrespondenceAddress.postal_code}} {{premises.data.currentCorrespondenceAddress.city}}</div>\n          </div>\n          <strong>{{\'premise_register.correspondence.new_correspondence\' | translate}}</strong>\n          <div ng-if=\"premises.bShowPremisesSelection\">\n            <div class=\"radio\" ng-repeat=\"premise in premises.premises\">\n              <label>\n                <input ng-required=\"!premises.bShowOther\" type=\"radio\" ng-model=\"premises.data.correspondence.address_id\" ng-value=\"premise.address\" ng-change=\"premises.showOther(false)\">\n                {{premise.address.street}} {{premise.address.house_no}}<span ng-if=\"premise.address.house_no_addition\"> {{premise.address.house_no_addition}}</span>, {{premise.address.postal_code}} {{premise.address.city}}\n              </label>\n            </div>\n            <div class=\"radio\">\n              <label>\n                <input type=\"radio\" ng-model=\"premises.data.correspondence.address_id\" ng-value=\"null\" ng-change=\"premises.showOther(true)\">\n                <strong>{{\'premise_register.correspondence.other\' | translate}}</strong>\n              </label>\n            </div>\n          </div>\n\n          <div ng-if=\"premises.bShowOther || !premises.bShowPremisesSelection\" ng-class=\"{\'left-indent\': premises.bShowOther, \'top-indent\': !premises.bShowPremisesSelection}\">\n            <div class=\"form-group\">\n              <label for=\"correspondence-country\" class=\"required\">{{\'premise_register.correspondence.country\' | translate}}</label>\n              <select ng-required=\"true\" id=\"correspondence-country\" class=\"form-control\" ng-model=\"premises.data.correspondence.country\" ng-change=\"premises.changeCountry()\">\n                <option value=\"\">{{\'premise_register.correspondence.select_a_country\' | translate}}</option>\n                <option value=\"NL\">{{\'premise_register.correspondence.option_NL\' | translate}}</option>\n                <option value=\"BE\">{{\'premise_register.correspondence.option_BE\' | translate}}</option>\n                <option value=\"DE\">{{\'premise_register.correspondence.option_DE\' | translate}}</option>\n              </select>\n              <div ng-if=\"\'premise_register.correspondence.hints.select_a_country\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.correspondence.hints.select_a_country\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"radio\" ng-if=\"premises.data.correspondence.country\" ng-show=\"premises.data.correspondence.country == \'NL\'\">\n              <label>\n                <input ng-change=\"premises.changeType()\" ng-required=\"!premises.data.correspondence.type\" type=\"radio\" ng-model=\"premises.data.correspondence.type\" value=\"address\">\n                {{\'premise_register.correspondence.houseno_postal_code\' | translate}}\n              </label>\n            </div>\n            <div class=\"radio\" ng-if=\"premises.data.correspondence.country == \'NL\'\">\n              <label>\n                <input ng-change=\"premises.changeType()\" ng-required=\"!premises.data.correspondence.type\" type=\"radio\" ng-model=\"premises.data.correspondence.type\" value=\"po_box\">\n                {{\'premise_register.correspondence.houseno_po_box\' | translate}}\n              </label>\n            </div>\n\n            <div ng-class=\"{\'left-indent\' :  premises.data.correspondence.country == \'NL\'}\" ng-if=\"premises.data.correspondence.type == \'address\' && premises.data.correspondence.country.length\">\n              <div class=\"form-group\">\n                <div ng-if=\"premises.data.correspondence.country == \'NL\'\">\n                  <label for=\"correspondence-postal-code\" class=\"required\">{{\'premise_register.correspondence.postal_code\' | translate}}</label>\n                  <input ui-mask=\"9999 AA\" placeholder=\"{{ \'premise_register.correspondence.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"premises.data.correspondence.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-postal-code\" ng-blur=\"premises.autofillHouseNo()\">\n                </div>\n\n                <div ng-if=\"premises.data.correspondence.country == \'BE\'\">\n                  <label for=\"correspondence-postal-code-be\" class=\"required\">{{\'premise_register.correspondence.postal_code\' | translate}}</label><br>\n                  <input check-number ng-minlength=\"4\" ng-maxlength=\"4\" ng-trim=\"false\" limit-to=\"4\" ng-required=\"true\" ng-model=\"premises.data.correspondence.postal_code\" placeholder=\"{{ \'premise_register.correspondence.postal_code_placeholder_be\' | translate}}\" type=\"text\" class=\"form-control\" id=\"correspondence-postal-code-be\">\n                </div>\n\n                <div ng-if=\"premises.data.correspondence.country == \'DE\'\">\n                  <label for=\"correspondence-postal-code-de\" class=\"required\">{{\'premise_register.correspondence.postal_code\' | translate}}</label><br>\n                  <input check-number ng-minlength=\"5\" ng-maxlength=\"5\" ng-trim=\"false\" limit-to=\"5\" ng-required=\"true\" ng-model=\"premises.data.correspondence.postal_code\" placeholder=\"{{ \'premise_register.correspondence.postal_code_placeholder_de\' | translate}}\" type=\"text\" class=\"form-control\" id=\"correspondence-postal-code-de\">\n                </div>\n\n                <div ng-if=\"\'premise_register.correspondence.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.correspondence.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"correspondence-housenumber\" class=\"required\">{{\'premise_register.correspondence.houseno_and_addtion\' | translate}}</label><br>\n                <div class=\"correspondence-medium-input\">\n                  <input check-number ng-required=\"true\" ng-model=\"premises.data.correspondence.house_no\" type=\"text\" class=\"form-control\" id=\"correspondence-housenumber\" placeholder=\"\" ng-blur=\"premises.autofillHouseNo()\">\n                </div>\n                <div class=\"correspondence-small-input\">\n                  <input ng-model=\"premises.data.correspondence.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-house-number-addition\" placeholder=\"\" ng-blur=\"premises.autofillHouseNo()\">\n                </div>\n                <div ng-if=\"\'premise_register.correspondence.hints.houseno_and_addtion\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.correspondence.hints.houseno_and_addtion\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"form-group\">\n                  <label for=\"correspondence-street\" class=\"required\">{{\'premise_register.correspondence.street\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-disabled=\"premises.data.correspondence.country == \'NL\'\" ng-required=\"true\" ng-model=\"premises.data.correspondence.street\" type=\"text\" class=\"form-control\" id=\"correspondence-street\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'premise_register.correspondence.hints.street\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.correspondence.hints.street\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"correspondence-city\" class=\"required\">{{\'premise_register.correspondence.city\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-disabled=\"premises.data.correspondence.country == \'NL\'\" ng-required=\"true\" ng-model=\"premises.data.correspondence.city\" type=\"text\" class=\"form-control\" id=\"correspondence-city\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'premise_register.correspondence.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.correspondence.hints.city\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"left-indent\" ng-if=\"premises.data.correspondence.type == \'po_box\' && premises.data.correspondence.country.length\">\n              <div class=\"form-group\">\n                <label for=\"correspondence-postal-code-po\" class=\"required\">{{\'premise_register.correspondence.postal_code\' | translate}}</label>\n                <input ui-mask=\"9999 AA\" placeholder=\"{{ \'premise_register.correspondence.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"premises.data.correspondence.po_box_postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-postal-code-po\" ng-blur=\"premises.autofillPoBox()\">\n\n                <div ng-if=\"\'premise_register.correspondence.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.correspondence.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"correspondence-po\" class=\"required\">{{\'premise_register.correspondence.po_box\' | translate}}</label><br>\n\n                <input ng-required=\"true\" ng-maxlength=\"5\" ng-model=\"premises.data.correspondence.po_box\" type=\"text\" class=\"form-control\" id=\"correspondence-po\" ng-blur=\"premises.autofillPoBox()\">\n                <div ng-if=\"\'premise_register.correspondence.hints.po_box\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.correspondence.hints.po_box\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"form-group\">\n                  <label for=\"correspondence-city-po\" class=\"required\">{{\'premise_register.correspondence.city\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-required=\"true\" ng-model=\"premises.data.correspondence.city\" type=\"text\" class=\"form-control\" id=\"correspondence-city-po\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'premise_register.correspondence.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.correspondence.hints.city\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid\" ng-click=\"premises.save()\" title=\"{{\'premise_register.correspondence.save\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'premise_register.correspondence.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"premisesRegisterNewPremises\" title=\"{{ \'premise_register.correspondence.cancel\' | translate}}\">{{ \'premise_register.correspondence.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.future.correpondence.email.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_register.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <!-- email input -->\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{ \'premise_register.futuremail.correspondence_email\' | translate}}</label>\n            <input server-side-validation=\"email.correspondence\" check-email ng-required=\"true\" ng-model=\"premises.data.email.correspondence\" type=\"email\" class=\"form-control\" id=\"email\" placeholder=\"{{ \'premise_register.futuremail.correspondence_email\' | translate}}\">\n            <div ng-if=\"\'premise_register.futuremail.hints.correspondence_email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.futuremail.hints.correspondence_email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <!-- checkbox also save as account-email -->\n          <div class=\"form-group\">\n            <input ng-model=\"premises.data.email.update_account_email\" ng-checked=\"premises.data.email.update_account_email\" type=\"checkbox\" id=\"updateAccountEmail\">\n            <label for=\"updateAccountEmail\" class=\"label_info\">{{ \'premise_register.futuremail.update_account_email\' | translate}}</label>\n          </div>\n          <!--sendcontrol (digital or not)-->\n          <div class=\"form-group\">\n            <label class=\"group-label\">{{ \'premise_register.futuremail.sendcontrol_label\' | translate }}</label>\n            <div>\n              <label>\n                <input ng-required=\"premises.form.customer_email\" type=\"radio\" ng-model=\"premises.data.email.digital\" ng-value=\"true\">\n                {{\'premise_register.futuremail.email_post.yes\' | translate}}\n              </label>\n            </div>\n            <div>\n              <label>\n                <input ng-required=\"premises.form.customer_email\" type=\"radio\" ng-model=\"premises.data.email.digital\" ng-value=\"false\">\n                {{\'premise_register.futuremail.email_post.no\' | translate}}\n              </label>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid || premises.noValidAddress\" ng-click=\"premises.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'premise_register.save\' | translate}}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{ \'premise_register.previous\' | translate}}\">{{ \'premise_register.previous\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.login.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_register.page_title\' | translate}}</h1>\n        <form name=\"premisesRegisterLogin.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <div class=\"form-group\">\n            <label for=\"customer-number\" class=\"required\">{{ \'premise_register.customernumber\' | translate}}</label>\n            <input ng-required=\"true\" check-number ng-minlength=\"8\" ng-maxlength=\"8\" ng-trim=\"false\" limit-to=\"8\" ng-model=\"premisesRegisterLogin.form.customer_number\" type=\"text\" class=\"form-control\" id=\"customer-number\" placeholder=\"{{ \'premise_register.customernumber_placeholder\' | translate}}\">\n            <div ng-if=\"\'premise_register.login.hints.customer_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.login.hints.customer_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"postal-code\" class=\"required\">{{ \'premise_register.postal_code\' | translate}}</label><br>\n            <input ui-mask=\"9999 AA\" placeholder=\"{{ \'premise_register.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"premisesRegisterLogin.form.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\">\n            <div ng-if=\"\'premise_register.login.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.login.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"housenumber\" class=\"required\">{{ \'premise_register.houseno_and_addtion\' | translate}}</label><br>\n            <div class=\"medium\">\n              <input check-number ng-required=\"true\" ng-model=\"premisesRegisterLogin.form.house_no\" type=\"text\" class=\"form-control\" id=\"housenumber\" placeholder=\"{{ \'premise_register.house_number_placeholder\' | translate}}\">\n            </div>\n            <div class=\"small\">\n              <input ng-model=\"premisesRegisterLogin.form.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"house-number-addition\" placeholder=\"{{ \'premise_register.house_number_addition_placeholder\' | translate}}\">\n            </div>\n            <div ng-if=\"\'premise_register.login.hints.house_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.login.hints.house_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premisesRegisterLogin.form.$invalid || premisesRegisterLogin.sendingData\" ng-click=\"premisesRegisterLogin.doLogin()\" title=\"{{ \'premise_register.save\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'premise_register.save\' | translate }}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premisesRegisterLogin.cancel()\" title=\"{{ \'premise_register.previous\' | translate}}\">{{ \'premise_register.previous\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.meter-reading.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_register.meter_reading.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n\n          <div class=\"form-group\">\n            <label for=\"recording-date\" class=\"required\">{{ \'premise_register.meter_reading.date_key_transfer\' | translate }}</label>\n            <div class=\"input-group\">\n              <input ng-keydown=\"$event.preventDefault()\" ng-click=\"premises.openDatepicker()\" uib-datepicker-popup=\"{{premises.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"premises.datepickerOptions\" is-open=\"premises.showDatepicker\" ng-required=\"true\" ng-model=\"premises.data.meter_reading.date\" type=\"text\" class=\"form-control\" id=\"recording-date\">\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"premises.openDatepicker()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n              </span>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"premises.data.address.meter_number\">\n            <label for=\"meter-reading\">{{ \'premise_register.meter_reading.meter_number\' | translate}}</label><br>\n            <input ng-disabled=\"true\" ng-required=\"false\" ng-model=\"premises.data.address.meter_number\" type=\"text\" class=\"form-control\" id=\"meter-number\">\n            <div ng-if=\"\'premise_register.meter_reading.hints.meter_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'premise_register.meter_reading.hints.meter_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"meter-reading\" class=\"required\">{{ \'premise_register.meter_reading.meter_reading\' | translate}}</label><br>\n            <input ng-required=\"true\" ng-model=\"premises.data.meter_reading.meter_reading\" type=\"text\" class=\"form-control text-right\" id=\"meter-reading\" ng-maxlength=\"5\" maxlength=\"5\" check-number>\n            <div ng-if=\"\'premise_register.meter_reading.hints.meter_reading\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'premise_register.meter_reading.hints.meter_reading\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"premises.data.meter_reading.num1\" type=\"text\" class=\"form-control\" id=\"meter-reading-num1\">\n            </div>\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"premises.data.meter_reading.num2\" type=\"text\" class=\"form-control\" id=\"meter-reading-num2\">\n            </div>\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"premises.data.meter_reading.num3\" type=\"text\" class=\"form-control\" id=\"meter-reading-num3\">\n            </div>\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"premises.data.meter_reading.num4\" type=\"text\" class=\"form-control\" id=\"meter-reading-num4\">\n            </div>\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"premises.data.meter_reading.num5\" type=\"text\" class=\"form-control\" id=\"meter-reading-num5\">\n            </div>\n            <span class=\"meter-input-comma\">,</span>\n            <div class=\"meter-input\">\n              <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n            </div>\n            <div class=\"meter-input\">\n              <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n            </div>\n            <div class=\"meter-input clear-margin-right\">\n              <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n            </div>\n          </div>\n\n          <div ng-if=\"premises.data.forced_meter_reading\" class=\"form-group\">\n            <label for=\"fileUpload\">{{ \'premise_register.meter_reading.file_upload\' | translate}}</label>\n\n            <div class=\"current-file-name\" ng-if=\"premises.data.meter_reading.file_upload.name\">\n              {{premises.data.meter_reading.file_upload.name}}\n            </div>\n\n            <div class=\"file-upload-container\">\n              <input ng-value=\"premises.fileToUpload.name\" ng-required=\"false\" ngf-resize=\"{width: 1200, height: 1200, quality: .8}\" ng-disabled=\"true\" type=\"text\" class=\"form-control\" id=\"filenameField\" placeholder=\"\">\n              <button class=\"btn-custom btn-file btn-primary button-margin-left\" ngf-max-size=\"20MB\" ngf-select=\"premises.fileChange($file, $invalidFiles);\" ng-required=\"false\" ng-model=\"premises.data.fileUpload\" id=\"fileUpload\" name=\"fileUpload\" type=\"file\" ngf-accept=\"\'image/jpeg, image/png, image/gif\'\">\n                <label for=\"fileUpload\">{{ \'premise_register.meter_reading.file_upload_btn\' | translate}}</label>\n              </button>\n            </div>\n\n            <div class=\"clearfix\"></div>\n            <div class=\"field-description\">{{ \'premise_register.meter_reading.file_upload_description\' | translate }}</div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid\" ng-click=\"premises.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'premise_register.meter_reading.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{ \'premise_register.meter_reading.cancel\' | translate}}\">{{ \'premise_register.meter_reading.cancel\' | translate}}</button>\n        </form>\n        <meter-images></meter-images>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.move-in-date.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_register.page_title\' | translate}}</h1>\n        <form name=\"premisesRegisterMoveInDate.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"recording-date\" class=\"required\">{{ \'premise_register.meter_reading.date_key_transfer\' | translate }}</label>\n            <div class=\"input-group\">\n              <input ng-keydown=\"$event.preventDefault()\" ng-click=\"premisesRegisterMoveInDate.openDatepicker()\" uib-datepicker-popup=\"{{premisesRegisterMoveInDate.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"premisesRegisterMoveInDate.datepickerOptions\" is-open=\"premisesRegisterMoveInDate.showDatepicker\" ng-required=\"true\" ng-model=\"premisesRegisterMoveInDate.data.meter_reading.date\" type=\"text\" class=\"form-control\" id=\"recording-date\">\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"premisesRegisterMoveInDate.openDatepicker()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n              </span>\n            </div>\n          </div>\n          <button ng-disabled=\"premisesRegisterMoveInDate.form.$invalid\" ng-click=\"premisesRegisterMoveInDate.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'premise_register.meter_reading.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premisesRegisterMoveInDate.cancel()\" title=\"{{ \'premise_register.cancel\' | translate}}\">{{ \'premise_register.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.new-premises.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_register.correspondence.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <p>{{\'premise_register.new_premises.text1\' | translate}}</p>\n\n          <div class=\"correspondence-form-block\">\n            <strong>{{\'premise_register.new_premises.current_correspondence\' | translate}}</strong>\n            <div ng-if=\"premises.data.currentCorrespondenceAddress.po_box.length\">{{\'premise_register.correspondence.po_box\' | translate}} {{premises.data.currentCorrespondenceAddress.po_box}}, {{premises.data.currentCorrespondenceAddress.po_box_postal_code}} {{premises.data.currentCorrespondenceAddress.city}}</div>\n            <div ng-if=\"premises.data.currentCorrespondenceAddress.po_box.length == 0\">{{premises.data.currentCorrespondenceAddress.street}} {{premises.data.currentCorrespondenceAddress.house_no}} {{premises.data.currentCorrespondenceAddress.house_no_addition}}, {{premises.data.currentCorrespondenceAddress.postal_code}} {{premises.data.currentCorrespondenceAddress.city}}</div>\n          </div>\n\n          <p>{{\'premise_register.new_premises.text2\' | translate}}</p>\n\n          <div class=\"form-group clearfix\" ng-hide=\"register.data.bIsInFuture\">\n            <input ng-model=\"premises.data.correspondence.bSetNew\" ng-checked=\"premises.data.correspondence.bSetNew\" type=\"checkbox\" id=\"differentcorrespondence\">\n            <label for=\"differentcorrespondence\" class=\"label_info\">{{ \'premise_register.new_premises.different_correspondence_address\' | translate}}</label>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid\" ng-click=\"premises.save()\" title=\"{{\'premise_register.new_premises.save\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'premise_register.correspondence.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"premisesRegisterMeterReading\" title=\"{{ \'premise_register.new_premises.cancel\' | translate}}\">{{ \'premise_register.correspondence.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.summary.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix\">\n        <h1>{{\'premise_register.summary.page_title\' | translate}}</h1>\n\n        <div class=\"summary-form-block\">\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.meter_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{premises.data.address.meter_number}}</div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"premises.data.bIsInFuture\">\n          <a ui-sref=\"premisesRegisterMoveInDate\" title=\"{{\'premise_register.summary.move_in_date_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_register.meter_reading.date_key_transfer\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.date\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.meter_reading.date | date:\'dd-MM-yyyy\'}}</div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"premises.data.bIsInFuture\">\n          <a ui-sref=\"premisesRegister\" title=\"{{\'premise_register.summary.future_address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_register.summary.future_connection_address\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <div>{{premises.data.address.street}} {{premises.data.address.house_no}} {{premises.data.address.house_no_addition}}</div>\n              <div>{{premises.data.address.postal_code | uppercase}} {{premises.data.address.city}}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"!premises.data.bIsInFuture\">\n          <a ui-sref=\"premisesRegisterMeterReading\" title=\"{{\'premise_register.summary.meter_reading_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_register.summary.meter_reading\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.date\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.meter_reading.date | date:\'dd-MM-yyyy\'}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.meter_reading\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.meter_reading.meter_reading}}</div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"!premises.data.bIsInFuture\">\n          <a ui-sref=\"premisesRegister\" title=\"{{\'premise_register.summary.address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_register.summary.connection_address\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <div>{{premises.data.address.street}} {{premises.data.address.house_no}} {{premises.data.address.house_no_addition}}</div>\n              <div>{{premises.data.address.postal_code | uppercase}} {{premises.data.address.city}}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"premises.data.correspondence.bSetNew === true && !premises.data.bIsInFuture && !premises.bCorporation\">\n          <a ui-sref=\"premisesRegisterCorrespondenceAddress\" title=\"{{\'premise_register.summary.correspondence_address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_register.summary.new_correspondence_address\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <div ng-if=\"premises.data.correspondence.type === \'address\' || premises.data.correspondence.type === null\">{{premises.data.correspondence.street}} {{premises.data.correspondence.house_no}} {{premises.data.correspondence.house_no_addition}}</div>\n              <div ng-if=\"premises.data.correspondence.type === \'address\' || premises.data.correspondence.type === null\">{{premises.data.correspondence.postal_code | uppercase}} {{premises.data.correspondence.city}}</div>\n              <div ng-if=\"premises.data.correspondence.type === \'po_box\'\">{{ \'premise_unregister.summary.po_box\' | translate }} {{premises.data.correspondence.po_box}}, {{premises.data.correspondence.po_box_postal_code | uppercase}} {{premises.data.correspondence.city}}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"premises.data.email.bSetNew && premises.data.email.correspondence && premises.data.bIsInFuture && !premises.bCorporation\">\n          <a ui-sref=\"premisesRegisterFutureCorrespondenceEmail\" title=\"{{\'premise_register.summary.future.change_correspondence\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_register.summary.future.correspondence\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.future.email\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.email.correspondence }}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.future.update_account_email\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.email.update_account_email ? \'Ja\': \'Nee\' }}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_register.summary.future.digital\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.email.digital ? \'Ja\': \'Nee\' }}</div>\n          </div>\n        </div>\n\n        <button ng-disabled=\"premises.form.$invalid || premises.sendingData\" ng-click=\"premises.save()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'premise_register.summary.save\' | translate}}</button>\n        <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{\'premise_register.summary.cancel\' | translate}}\">{{\'premise_register.summary.cancel\' | translate}}</button>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.thank-you.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix\">\n        <h1>{{ \'premise_register.thank_you.page_\'+premises.isInFuture+\'title\' | translate}}</h1>\n        <p ng-if=\"!premises.isInFuture\">{{\'premise_register.thank_you.text\' | translate}}</p>\n        <p ng-if=\"premises.isInFuture\" translate=\"premise_register.thank_you.future_text\" translate-value-date=\"{{premises.moveInDate | date:\'EEEE d MMMM y\'}}\"></p>\n        <button ui-sref=\"dashboard\" type=\"button\" class=\"btn-custom btn-primary pull-right\">{{ \'premise_register.thank_you.btn\' | translate}}</button>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-register/views/premises-register.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_register.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"postal-code\" class=\"required\">{{ \'premise_register.postal_code\' | translate}}</label>\n            <input ng-disabled=\"premises.data.credentials.future_move_token\" ui-mask=\"9999 AA\" placeholder=\"{{ \'premise_register.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"premises.data.address.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\" ng-blur=\"premises.autofillHouseNo()\">\n\n            <div ng-if=\"\'premise_register.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"housenumber\" class=\"required\">{{ \'premise_register.houseno_and_addtion\' | translate}}</label><br>\n            <div class=\"medium\">\n              <input ng-disabled=\"premises.data.credentials.future_move_token\" ng-blur=\"premises.autofillHouseNo()\" check-number ng-required=\"true\" ng-model=\"premises.data.address.house_no\" type=\"text\" class=\"form-control\" id=\"housenumber\" placeholder=\"{{ \'premise_register.house_number_placeholder\' | translate}}\">\n            </div>\n            <div class=\"small\">\n              <input ng-disabled=\"premises.data.credentials.future_move_token\" ng-blur=\"premises.autofillHouseNo()\" ng-model=\"premises.data.address.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"house-number-addition\" placeholder=\"{{ \'premise_register.house_number_addition_placeholder\' | translate}}\">\n            </div>\n            <div ng-if=\"\'premise_register.hints.house_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.hints.house_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"street\">{{ \'premise_register.street\' | translate}}</label>\n            <div class=\"form-loader-wrap\">\n              <div ng-if=\"premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n              <input ng-disabled=\"true\" ng-model=\"premises.data.address.street\" type=\"text\" class=\"form-control\" id=\"street\">\n            </div>\n            <div ng-if=\"\'premise_register.hints.street\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.hints.street\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"city\">{{ \'premise_register.city\' | translate}}</label>\n            <div class=\"form-loader-wrap\">\n              <div ng-if=\"premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n              <input ng-disabled=\"true\" ng-model=\"premises.data.address.city\" type=\"text\" class=\"form-control\" id=\"city\">\n            </div>\n            <div ng-if=\"\'premise_register.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_register.hints.city\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid || premises.noValidAddress\" ng-click=\"premises.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'premise_register.save\' | translate}}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{ \'premise_register.previous\' | translate}}\">{{ \'premise_register.previous\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.correspondence.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_unregister.correspondence.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <p ng-if=\"premises.data.afterNewRegister\">{{\'premise_unregister.correspondence.text\' | translate}}</p>\n          <strong>{{\'premise_unregister.correspondence.new_correspondence\' | translate}}</strong>\n          <div ng-if=\"premises.bShowPremisesSelection\">\n            <div class=\"radio\" ng-repeat=\"premise in premises.premises\">\n              <label>\n                <input ng-required=\"!premises.bShowOther\" type=\"radio\" ng-model=\"premises.data.correspondence.address_id\" ng-value=\"premise.address\" ng-change=\"premises.showOther(false)\">\n                {{premise.address.street}} {{premise.address.house_no}}<span ng-if=\"premise.address.house_no_addition\"> {{premise.address.house_no_addition}}</span>, {{premise.address.postal_code}} {{premise.address.city}}\n              </label>\n            </div>\n            <div class=\"radio\">\n              <label>\n                <input type=\"radio\" ng-model=\"premises.data.correspondence.address_id\" ng-value=\"null\" ng-change=\"premises.showOther(true)\">\n                <strong>{{\'premise_unregister.correspondence.other\' | translate}}</strong>\n              </label>\n            </div>\n          </div>\n\n          <div ng-if=\"premises.bShowOther || !premises.bShowPremisesSelection\" ng-class=\"{\'left-indent\': premises.bShowOther, \'top-indent\': !premises.bShowPremisesSelection}\">\n            <div class=\"form-group\">\n              <label for=\"correspondence-country\" class=\"required\">{{\'premise_unregister.correspondence.country\' | translate}}</label>\n              <select ng-required=\"true\" id=\"correspondence-country\" class=\"form-control\" ng-model=\"premises.data.correspondence.country\" ng-change=\"premises.changeCountry()\">\n                <option value=\"\">{{\'premise_unregister.correspondence.select_a_country\' | translate}}</option>\n                <option value=\"NL\">{{\'premise_unregister.correspondence.option_NL\' | translate}}</option>\n                <option value=\"BE\">{{\'premise_unregister.correspondence.option_BE\' | translate}}</option>\n                <option value=\"DE\">{{\'premise_unregister.correspondence.option_DE\' | translate}}</option>\n              </select>\n              <div ng-if=\"\'premise_unregister.correspondence.hints.select_a_country\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.correspondence.hints.select_a_country\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"radio\" ng-if=\"premises.data.correspondence.country\" ng-show=\"premises.data.correspondence.country == \'NL\'\">\n              <label>\n                <input ng-change=\"premises.changeType()\" ng-required=\"!premises.data.correspondence.type\" type=\"radio\" ng-model=\"premises.data.correspondence.type\" value=\"address\">\n                {{\'premise_unregister.correspondence.houseno_postal_code\' | translate}}\n              </label>\n            </div>\n            <div class=\"radio\" ng-if=\"premises.data.correspondence.country == \'NL\'\">\n              <label>\n                <input ng-change=\"premises.changeType()\" ng-required=\"!premises.data.correspondence.type\" type=\"radio\" ng-model=\"premises.data.correspondence.type\" value=\"po_box\">\n                {{\'premise_unregister.correspondence.houseno_po_box\' | translate}}\n              </label>\n            </div>\n\n            <div ng-class=\"{\'left-indent\' :  premises.data.correspondence.country == \'NL\'}\" ng-if=\"premises.data.correspondence.type == \'address\' && premises.data.correspondence.country.length\">\n              <div class=\"form-group\">\n                <div ng-if=\"premises.data.correspondence.country == \'NL\'\">\n                  <label for=\"correspondence-postal-code\" class=\"required\">{{\'premise_unregister.correspondence.postal_code\' | translate}}</label>\n                  <input ui-mask=\"9999 AA\" placeholder=\"{{ \'premise_unregister.correspondence.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"premises.data.correspondence.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-postal-code\" ng-blur=\"premises.autofillHouseNo()\">\n                </div>\n\n                <div ng-if=\"premises.data.correspondence.country == \'BE\'\">\n                  <label for=\"correspondence-postal-code-be\" class=\"required\">{{\'premise_unregister.correspondence.postal_code\' | translate}}</label><br>\n                  <input check-number ng-minlength=\"4\" ng-maxlength=\"4\" ng-trim=\"false\" limit-to=\"4\" ng-required=\"true\" ng-model=\"premises.data.correspondence.postal_code\" placeholder=\"{{ \'premise_unregister.correspondence.postal_code_placeholder_be\' | translate}}\" type=\"text\" class=\"form-control\" id=\"correspondence-postal-code-be\">\n                </div>\n\n                <div ng-if=\"premises.data.correspondence.country == \'DE\'\">\n                  <label for=\"correspondence-postal-code-de\" class=\"required\">{{\'premise_unregister.correspondence.postal_code\' | translate}}</label><br>\n                  <input check-number ng-minlength=\"5\" ng-maxlength=\"5\" ng-trim=\"false\" limit-to=\"5\" ng-required=\"true\" ng-model=\"premises.data.correspondence.postal_code\" placeholder=\"{{ \'premise_unregister.correspondence.postal_code_placeholder_de\' | translate}}\" type=\"text\" class=\"form-control\" id=\"correspondence-postal-code-de\">\n                </div>\n\n                <div ng-if=\"\'premise_unregister.correspondence.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.correspondence.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"correspondence-housenumber\" class=\"required\">{{\'premise_unregister.correspondence.houseno_and_addtion\' | translate}}</label><br>\n                <div class=\"correspondence-medium-input\">\n                  <input check-number ng-required=\"true\" ng-model=\"premises.data.correspondence.house_no\" type=\"text\" class=\"form-control\" id=\"correspondence-housenumber\" placeholder=\"\" ng-blur=\"premises.autofillHouseNo()\">\n                </div>\n                <div class=\"correspondence-small-input\">\n                  <input ng-model=\"premises.data.correspondence.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-house-number-addition\" placeholder=\"\" ng-blur=\"premises.autofillHouseNo()\">\n                </div>\n                <div ng-if=\"\'premise_unregister.correspondence.hints.houseno_and_addtion\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.correspondence.hints.houseno_and_addtion\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"form-group\">\n                  <label for=\"correspondence-street\" class=\"required\">{{\'premise_unregister.correspondence.street\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-disabled=\"premises.data.correspondence.country == \'NL\'\" ng-required=\"true\" ng-model=\"premises.data.correspondence.street\" type=\"text\" class=\"form-control\" id=\"correspondence-street\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'premise_unregister.correspondence.hints.street\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.correspondence.hints.street\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"correspondence-city\" class=\"required\">{{\'premise_unregister.correspondence.city\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-disabled=\"premises.data.correspondence.country == \'NL\'\" ng-required=\"true\" ng-model=\"premises.data.correspondence.city\" type=\"text\" class=\"form-control\" id=\"correspondence-city\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'premise_unregister.correspondence.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.correspondence.hints.city\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"left-indent\" ng-if=\"premises.data.correspondence.type == \'po_box\' && premises.data.correspondence.country.length\">\n              <div class=\"form-group\">\n                <label for=\"correspondence-postal-code-po\" class=\"required\">{{\'premise_unregister.correspondence.postal_code\' | translate}}</label>\n                <input ui-mask=\"9999 AA\" placeholder=\"{{ \'premise_unregister.correspondence.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"premises.data.correspondence.po_box_postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-postal-code-po\" ng-blur=\"premises.autofillPoBox()\">\n\n                <div ng-if=\"\'premise_unregister.correspondence.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.correspondence.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"correspondence-po\" class=\"required\">{{\'premise_unregister.correspondence.po_box\' | translate}}</label><br>\n\n                <input ng-required=\"true\" ng-maxlength=\"5\" ng-model=\"premises.data.correspondence.po_box\" type=\"text\" class=\"form-control\" id=\"correspondence-po\" ng-blur=\"premises.autofillPoBox()\">\n                <div ng-if=\"\'premise_unregister.correspondence.hints.po_box\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.correspondence.hints.po_box\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"form-group\">\n                  <label for=\"correspondence-city-po\" class=\"required\">{{\'premise_unregister.correspondence.city\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"premises.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-required=\"true\" ng-model=\"premises.data.correspondence.city\" type=\"text\" class=\"form-control\" id=\"correspondence-city-po\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'premise_unregister.correspondence.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.correspondence.hints.city\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid\" ng-click=\"premises.save()\" title=\"{{\'premise_unregister.correspondence.save\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'premise_unregister.correspondence.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"{{premises.data.afterNewRegister ? \'premisesUnregisterSummary\':\'premisesUnregisterMeterReading\'}}\" title=\"{{ \'premise_unregister.correspondence.cancel\' | translate}}\">{{ \'premise_unregister.correspondence.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.email.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_unregister.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label ng-if=\"!premises.data.afterNewRegister\" for=\"email\" class=\"required\">{{ \'premise_unregister.email.email_request.label\' | translate}}</label>\n            <label ng-if=\"premises.data.afterNewRegister\" for=\"email\" class=\"required\">{{ \'premise_unregister.email.email_request.label_short\' | translate}}</label>\n            <input check-email ng-required=\"true\" ng-model=\"premises.data.correspondence.confirmationEmail\" type=\"email\" class=\"form-control\" id=\"email\" placeholder=\"{{\'premise_unregister.email.email_request.placeholder\' | translate}}\">\n            <div ng-if=\"\'premise_unregister.email.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.email.hints.email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <div ng-if=\"!premises.data.afterNewRegister\">\n            <p><strong>{{\'premise_unregister.email.email_post.label\' | translate}}</strong></p>\n            <div>\n              <label>\n                <input ng-required=\"premises.form.customer_email\" type=\"radio\" ng-model=\"premises.data.correspondence.bSetAsNewEmail\" ng-value=\"true\">\n                {{\'premise_unregister.email.email_post.yes\' | translate}}\n              </label>\n            </div>\n            <div>\n              <label>\n                <input ng-required=\"premises.form.customer_email\" type=\"radio\" ng-model=\"premises.data.correspondence.bSetAsNewEmail\" ng-value=\"false\">\n                {{\'premise_unregister.email.email_post.no\' | translate}}\n              </label>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid\" ng-click=\"premises.save()\" title=\"{{ \'premise_unregister.btn_next\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'premise_unregister.btn_next\' | translate }}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{\'premise_unregister.email.cancel\' | translate}}\">\n            {{\'premise_unregister.email.cancel\' | translate}}\n          </button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.future.correpondence.email.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_unregister.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <!-- email input -->\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{ \'premise_unregister.futuremail.correspondence_email\' | translate}}</label>\n            <input server-side-validation=\"email.correspondence\" check-email ng-required=\"true\" ng-model=\"premises.data.email.correspondence\" type=\"email\" class=\"form-control\" id=\"email\" placeholder=\"{{ \'premise_unregister.futuremail.correspondence_email\' | translate}}\">\n            <div ng-if=\"\'premise_unregister.futuremail.hints.correspondence_email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.futuremail.hints.correspondence_email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <!-- checkbox also save as account-email -->\n          <div class=\"form-group\" ng-if=\"ivAuthenticate.isAuthenticated()\">\n            <input ng-model=\"premises.data.email.update_account_email\" ng-checked=\"premises.data.email.update_account_email\" type=\"checkbox\" id=\"updateAccountEmail\">\n            <label for=\"updateAccountEmail\" class=\"label_info\">{{ \'premise_unregister.futuremail.update_account_email\' | translate}}</label>\n          </div>\n          <!--sendcontrol (digital or not)-->\n          <div class=\"form-group\">\n            <label class=\"group-label\">{{ \'premise_unregister.futuremail.sendcontrol_label\' | translate }}</label>\n            <div>\n              <label>\n                <input ng-required=\"premises.form.customer_email\" type=\"radio\" ng-model=\"premises.data.email.digital\" ng-value=\"true\">\n                {{\'premise_unregister.futuremail.email_post.yes\' | translate}}\n              </label>\n            </div>\n            <div>\n              <label>\n                <input ng-required=\"premises.form.customer_email\" type=\"radio\" ng-model=\"premises.data.email.digital\" ng-value=\"false\">\n                {{\'premise_unregister.futuremail.email_post.no\' | translate}}\n              </label>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid || premises.noValidAddress\" ng-click=\"premises.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'premise_unregister.save\' | translate}}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{ \'premise_unregister.previous\' | translate}}\">{{ \'premise_unregister.previous\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.login.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_unregister.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <div class=\"form-group\">\n            <label for=\"customer-number\" class=\"required\">{{ \'premise_unregister.customernumber\' | translate}}</label>\n            <input ng-required=\"true\" check-number ng-minlength=\"8\" ng-maxlength=\"8\" ng-trim=\"false\" limit-to=\"8\" ng-model=\"premises.form.customer_number\" type=\"text\" class=\"form-control\" id=\"customer-number\" placeholder=\"{{ \'premise_unregister.customernumber_placeholder\' | translate}}\">\n            <div ng-if=\"\'premise_unregister.login.hints.customer_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.login.hints.customer_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"postal-code\" class=\"required\">{{ \'premise_unregister.postal_code\' | translate}}</label><br>\n            <input ui-mask=\"9999 AA\" placeholder=\"{{ \'premise_unregister.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"premises.form.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\">\n            <div ng-if=\"\'premise_unregister.login.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.login.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"housenumber\" class=\"required\">{{ \'premise_unregister.house_number\' | translate}} & {{ \'premise_unregister.house_number_addition\' | translate}}</label><br>\n            <div class=\"medium\">\n              <input check-number ng-required=\"true\" ng-model=\"premises.form.house_no\" type=\"text\" class=\"form-control\" id=\"housenumber\" placeholder=\"{{ \'premise_unregister.house_number_placeholder\' | translate}}\">\n            </div>\n            <div class=\"small\">\n              <input ng-model=\"premises.form.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"house-number-addition\" placeholder=\"{{ \'premise_unregister.house_number_addition_placeholder\' | translate}}\">\n            </div>\n            <div ng-if=\"\'premise_unregister.login.hints.house_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'premise_unregister.login.hints.house_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid || premises.sendingData\" ng-click=\"premises.doLogin()\" title=\"{{ \'premise_unregister.btn_next\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'premise_unregister.btn_next\' | translate }}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{ \'premise_unregister.previous\' | translate}}\">{{ \'premise_unregister.previous\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.meter-reading.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_unregister.meter_reading.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <p ng-if=\"premises.consumption !== null\" translate=\"meter_readings.last_reading\" translate-values=\"{lastReading : premises.consumption.reading_result, readingDate : premises.consumption.reading_date_time}\"></p>\n          <div class=\"form-group\">\n            <label for=\"recording-date\" class=\"required\">{{ \'premise_register.meter_reading.date_key_transfer\' | translate }}</label>\n            <div class=\"input-group\">\n              <input ng-keydown=\"$event.preventDefault()\" ng-click=\"premises.openDatepicker()\" uib-datepicker-popup=\"{{premises.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"premises.datepickerOptions\" is-open=\"premises.showDatepicker\" ng-required=\"true\" ng-model=\"premises.data.meter_reading.date\" type=\"text\" class=\"form-control\" id=\"recording-date\">\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"premises.openDatepicker()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n              </span>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"premises.data.address.device.serial_number\">\n            <label for=\"meter-reading\">{{ \'premise_unregister.meter_reading.meter_number\' | translate}}</label><br>\n            <input ng-disabled=\"true\" ng-required=\"false\" ng-model=\"premises.data.address.device.serial_number\" type=\"text\" class=\"form-control\" id=\"meter-number\">\n            <div ng-if=\"\'premise_unregister.meter_reading.hints.meter_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'premise_unregister.meter_reading.hints.meter_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"meter-reading\" class=\"required\">{{ \'premise_unregister.meter_reading.meter_reading\' | translate}}</label><br>\n            <input ng-required=\"true\" ng-model=\"premises.data.meter_reading.meter_reading\" type=\"text\" class=\"form-control text-right\" id=\"meter-reading\" ng-maxlength=\"premises.numberOfMeterNumbers\" maxlength=\"{{premises.numberOfMeterNumbers}}\" check-number>\n            <div ng-if=\"\'premise_unregister.meter_reading.hints.meter_reading\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'premise_unregister.meter_reading.hints.meter_reading\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <div class=\"meter-input meter-width-{{premises.numberOfMeterNumbers}}\" ng-class=\"{\'last\': $last}\" ng-repeat=\"number in premises.aNumberOfMeterNumbers\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"premises.data.meter_reading[\'num\'+number]\" type=\"text\" class=\"form-control\" id=\"meter-reading-num{{number}}\">\n            </div>\n            <div class=\"meter-input-disabled-wrapper meter-input-disabled-wrapper{{premises.numberOfMeterNumbers}}\">\n              <span class=\"meter-input-comma\">,</span>\n              <div class=\"meter-input meter-width-{{premises.numberOfMeterNumbers}}\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n              <div class=\"meter-input meter-width-{{premises.numberOfMeterNumbers}}\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n              <div class=\"meter-input meter-width-{{premises.numberOfMeterNumbers}} clear-margin-right\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n            </div>\n          </div>\n\n          <div ng-if=\"premises.data.forced_meter_reading\" class=\"form-group\">\n            <label for=\"fileUpload\">{{ \'premise_register.meter_reading.file_upload\' | translate}}</label>\n\n            <div class=\"current-file-name\" ng-if=\"premises.data.meter_reading.file_upload.name\">\n              {{premises.data.meter_reading.file_upload.name}}\n            </div>\n\n            <div class=\"file-upload-container\">\n              <input ng-value=\"premises.fileToUpload.name\" ng-required=\"false\" ngf-resize=\"{width: 1200, height: 1200, quality: .8}\" ng-disabled=\"true\" type=\"text\" class=\"form-control\" id=\"filenameField\" placeholder=\"\">\n              <button class=\"btn-custom btn-file btn-primary button-margin-left\" ngf-max-size=\"20MB\" ngf-select=\"premises.fileChange($file, $invalidFiles);\" ng-required=\"false\" ng-model=\"premises.data.fileUpload\" id=\"fileUpload\" name=\"fileUpload\" type=\"file\" ngf-accept=\"\'image/jpeg, image/png, image/gif\'\">\n                <label for=\"fileUpload\">{{ \'premise_register.meter_reading.file_upload_btn\' | translate}}</label>\n              </button>\n            </div>\n\n            <div class=\"clearfix\"></div>\n            <div class=\"field-description\">{{ \'premise_register.meter_reading.file_upload_description\' | translate }}</div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid\" ng-click=\"premises.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'premise_register.meter_reading.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{ \'premise_register.meter_reading.cancel\' | translate}}\">{{ \'premise_register.meter_reading.cancel\' | translate}}</button>\n        </form>\n        <meter-images></meter-images>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.move-out-date.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_unregister.meter_reading.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"recording-date\" class=\"required\">{{ \'premise_register.meter_reading.date_key_transfer\' | translate }}</label>\n            <div class=\"input-group\">\n              <input ng-keydown=\"$event.preventDefault()\" ng-click=\"premises.openDatepicker()\" uib-datepicker-popup=\"{{premises.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"premises.datepickerOptions\" is-open=\"premises.showDatepicker\" ng-required=\"true\" ng-model=\"premises.data.meter_reading.date\" type=\"text\" class=\"form-control\" id=\"recording-date\">\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"premises.openDatepicker()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n              </span>\n            </div>\n          </div>\n          <button ng-disabled=\"premises.form.$invalid\" ng-click=\"premises.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'premise_register.meter_reading.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{ \'premise_unregister.cancel\' | translate}}\">{{ \'premise_unregister.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.summary.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix\">\n        <h1>{{\'premise_unregister.summary.page_title\' | translate}}</h1>\n        <div class=\"summary-form-block\" ng-if=\"premises.data.afterNewRegister\">\n          <div class=\"block-innner\">\n            <p translate=\"premise_unregister.summary.already_unregistered_desc\"></p>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\">\n          <div class=\"block-innner\" ng-if=\"premises.data.bIsInFuture\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.date\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.meter_reading.date | date:\'dd-MM-yyyy\'}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <div ng-if=\"premises.data.address.address\">{{premises.data.address.address.street}} {{premises.data.address.address.house_no}} {{premises.data.address.address.house_no_addition}}</div>\n              <div ng-if=\"premises.data.address.address\">{{premises.data.address.address.postal_code | uppercase}} {{premises.data.address.address.city}}</div>\n            </div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.meter_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{premises.data.address.device.serial_number}}</div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"!premises.data.bIsInFuture\">\n          <a ng-if=\"!premises.data.afterNewRegister\" ui-sref=\"premisesUnregisterMeterReading\" title=\"{{\'premise_unregister.summary.meter_reading_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_unregister.summary.meter_reading\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.date\' | translate}}</div>\n            <div ng-if=\"premises.data.afterNewRegister\" class=\"block-inner-text\">{{ premises.data.meter_reading.last_meter_reading_date | date:\'dd-MM-yyyy\'}}</div>\n            <div ng-if=\"!premises.data.afterNewRegister\" class=\"block-inner-text\">{{ premises.data.meter_reading.date | date:\'dd-MM-yyyy\'}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.meter_reading\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.meter_reading.meter_reading || \'-\'}}</div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"(premises.data.correspondence.bSetNew === true && !premises.data.bIsInFuture) || premises.data.afterNewRegister\">\n          <a ui-sref=\"premisesUnregisterCorrespondenceAddress\" title=\"{{\'premise_unregister.summary.address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3 ng-if=\"!premises.data.afterNewRegister\">{{\'premise_unregister.summary.connection_address\' | translate}}</h3>\n          <h3 ng-if=\"premises.data.afterNewRegister\">{{\'premise_unregister.summary.current_connection_address\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <div ng-if=\"premises.data.correspondence.type === \'address\' || premises.data.correspondence.type === null\">{{premises.data.correspondence.street}} {{premises.data.correspondence.house_no}} {{premises.data.correspondence.house_no_addition}}</div>\n              <div ng-if=\"premises.data.correspondence.type === \'address\' || premises.data.correspondence.type === null\">{{premises.data.correspondence.postal_code | uppercase}} {{premises.data.correspondence.city}}</div>\n              <div ng-if=\"premises.data.correspondence.type === \'po_box\'\">{{ \'premise_unregister.summary.po_box\' | translate }} {{premises.data.correspondence.po_box}}, {{premises.data.correspondence.po_box_postal_code | uppercase}} {{premises.data.correspondence.city}}</div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"premises.data.correspondence.confirmationEmail !== null && !premises.data.bIsInFuture\">\n          <a ui-sref=\"premisesUnregisterEmail\" title=\"{{\'premise_unregister.summary.email_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_unregister.summary.email\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div ng-if=\"!premises.data.afterNewRegister\" class=\"block-inner-label\">{{\'premise_unregister.summary.email_label\' | translate}}</div>\n            <div ng-if=\"premises.data.afterNewRegister\" class=\"block-inner-label\"><span translate=\"premise_unregister.summary.email_address_label\"></span></div>\n            <div class=\"block-inner-text\">{{premises.data.correspondence.confirmationEmail}}</div>\n          </div>\n          <div class=\"clearfix\"></div>\n          <div class=\"block-innner\" ng-if=\"!premises.data.afterNewRegister\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.email_post\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ \'premise_unregister.email.email_post.\' + (premises.data.correspondence.bSetAsNewEmail === true ? \'yes\':\'no\') | translate}}</div>\n          </div>\n        </div>\n\n        <div class=\"summary-form-block\" ng-if=\"premises.data.email.bSetNew && premises.data.email.correspondence && premises.data.bIsInFuture && !premises.bCorporation\">\n          <a ui-sref=\"premisesUnregisterFutureCorrespondenceEmail\" title=\"{{\'premise_unregister.summary.future.change_correspondence\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'premise_unregister.summary.future.correspondence\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.future.email\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.email.correspondence }}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"ivAuthenticate.isAuthenticated()\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.future.update_account_email\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.email.update_account_email ? \'Ja\': \'Nee\' }}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'premise_unregister.summary.future.digital\' | translate}}</div>\n            <div class=\"block-inner-text\">{{ premises.data.email.digital ? \'Ja\': \'Nee\' }}</div>\n          </div>\n        </div>\n\n        <button ng-disabled=\"premises.form.$invalid || premises.sendingData\" ng-click=\"premises.save()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'premise_unregister.summary.\' + (!premises.data.afterNewRegister ? \'save\' : \'done\') | translate}}</button>\n        <button ng-if=\"!premises.data.afterNewRegister\" type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{\'premise_unregister.previous\' | translate}}\">{{\'premise_unregister.cancel\' | translate}}</button>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.thank-you.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix\">\n        <h1>{{ \'premise_unregister.thank_you.page_\'+premises.inFutureTranslation+\'title\' | translate}}</h1>\n        <p ng-if=\"!premises.isInFuture\">{{\'premise_unregister.thank_you.text\' | translate}}</p>\n        <p ng-if=\"premises.isInFuture\" translate=\"premise_unregister.thank_you.future_text\" translate-value-date=\"{{premises.moveOutDate | date:\'EEEE d MMMM y\'}}\"></p>\n\n        <button ng-if=\"premises.isAuth\" ui-sref=\"dashboard\" type=\"button\" class=\"btn-custom btn-primary pull-right\">{{ \'premise_unregister.thank_you.btn\' | translate}}</button>\n        <button ng-if=\"!premises.isAuth\" ui-sref=\"home\" type=\"button\" class=\"btn-custom btn-primary pull-right\">{{ \'premise_unregister.thank_you.btn_home\' | translate}}</button>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/premises-unregister/views/premises-unregister.view.html","<div class=\"container premises-unregister-view\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'premise_unregister.page_title\' | translate}}</h1>\n        <form name=\"premises.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <!--          Active addresses; can be unregistered -->\n          <div class=\"form-group clearfix\">\n\n            <div class=\"group-label\" ng-if=\"premises.activePremises.length\">\n              <strong>{{\'premise_unregister.premises_select\' | translate}}</strong>\n            </div>\n\n            <div class=\"group-label\" ng-if=\"premises.activePremises.length === 0\">\n              <p>{{\'premise_unregister.none_selectable\' | translate}}</p>\n            </div>\n\n            <div class=\"display-table premises-unregister-table\" ng-if=\"premises.activePremises.length\">\n              <div class=\"table table-custom-width\">\n                <div class=\"thead\">\n                  <div class=\"tr\">\n                    <div class=\"th xs-td-9\" translate=\"premise_unregister.unregister_addresses_table.address\"></div>\n                    <div class=\"th xs-td-3 align-right\" translate=\"premise_unregister.unregister_addresses_table.meter_number\"></div>\n                  </div>\n                </div>\n                <div class=\"tbody\" ng-repeat=\"premise in premises.activePremises\">\n                  <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n                    <div class=\"td xs-td-9\">\n                      <label>\n                        <input type=\"radio\" ng-model=\"premises.data.address\" ng-value=\"premise\" ng-required=\"true\">\n                        <span>{{premise.address.street}} {{premise.address.house_no}}<span ng-if=\"premise.address.house_no_addition\"> {{premise.address.house_no_addition}}</span>,<wbr> {{premise.address.postal_code}} {{premise.address.city}}</span>\n                      </label>\n                    </div>\n                    <div class=\"td xs-td-3 align-right\">{{premise.device.serial_number}}</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <!--          No subscription option; Can not be unregistered by app, call support -->\n          <div class=\"form-group clearfix\" ng-if=\"premises.unregistrablePremises.length\">\n\n            <div class=\"group-label no_subscription_options_label\" ng-if=\"premises.unregistrablePremises.length\">\n              <strong ng-if=\"premises.registrablePremises.length > 0\">{{\'premise_unregister.not_selectable\' | translate}}</strong>\n              <p ng-if=\"premises.unregistrablePremises.length === 1\" translate=\"premise_unregister.not_selectable_text_single\"></p>\n              <p ng-if=\"premises.unregistrablePremises.length > 1\" translate=\"premise_unregister.not_selectable_text\"></p>\n            </div>\n\n            <div class=\"display-table premises-unregister-table\">\n              <div class=\"table table-custom-width\">\n                <!--                <div class=\"thead hidden-xs hidden-sm\">-->\n                <div class=\"thead\">\n                  <div class=\"tr\">\n                    <div class=\"th xs-td-9\" translate=\"premise_unregister.unregister_addresses_table.address\"></div>\n                    <div class=\"th xs-td-3 align-right\" translate=\"premise_unregister.unregister_addresses_table.meter_number\"></div>\n                  </div>\n                </div>\n                <div class=\"tbody\" ng-repeat=\"premiseUnreg in premises.unregistrablePremises\">\n                  <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n                    <div class=\"td xs-td-9\">\n                      <span>{{premiseUnreg.address.street}} {{premiseUnreg.address.house_no}}<span ng-if=\"premiseUnreg.address.house_no_addition\"> {{premiseUnreg.address.house_no_addition}}</span>,<wbr> {{premiseUnreg.address.postal_code}} {{premiseUnreg.address.city}}</span>\n                    </div>\n                    <div class=\"td xs-td-3 align-right\">{{premiseUnreg.device.serial_number}}</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <!--          Already unregistered addresses; adresses that were unregistered by someone other than the customer -->\n          <div class=\"form-group clearfix\" ng-if=\"premises.premisesAlreadyUnregistered.length\">\n            <div class=\"group-label\">\n              <strong>{{\'premise_unregister.premises_unregistered\' | translate}}</strong>\n              <p translate=\"premise_unregister.premises_unregistered_desc\"></p>\n            </div>\n\n            <div class=\"display-table premises-unregister-table\">\n              <div class=\"table table-custom-width\">\n                <div class=\"thead hidden-xs hidden-sm\">\n                  <div class=\"tr\">\n                    <div class=\"th xs-td-4\" translate=\"premise_unregister.unregister_addresses_table.address\"></div>\n                    <div class=\"th xs-td-3\" translate=\"premise_unregister.unregister_addresses_table.date\"></div>\n                    <div class=\"th xs-td-3 align-right\" translate=\"premise_unregister.unregister_addresses_table.meter_reading\"></div>\n                    <div class=\"th xs-td-2 align-right\" translate=\"premise_unregister.unregister_addresses_table.meter_number\"></div>\n                  </div>\n                </div>\n                <div class=\"tbody\" ng-repeat=\"premiseAU in premises.premisesAlreadyUnregistered\">\n                  <!--                <div class=\"thead hidden-xs hidden-sm\">-->\n                  <!--                <div class=\"tr visible-xs visible-sm\">-->\n                  <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n                    <div class=\"td xs-td-12 md-td-4\">\n                        <span class=\"customer-label visible-xs visible-sm\" translate=\"premise_unregister.unregister_addresses_table.address\"></span>\n                        <span>{{premiseAU.address.street}} {{premiseAU.address.house_no}}<br><span ng-if=\"premiseAU.address.house_no_addition\"> {{premiseAU.address.house_no_addition}}</span><wbr> {{premiseAU.address.postal_code}} {{premiseAU.address.city}}</span>\n                    </div>\n                    <div class=\"td xs-td-4 sm-td-4 md-td-2\">\n                      <span class=\"customer-label visible-xs visible-sm\" translate=\"premise_unregister.unregister_addresses_table.date\"></span>\n                      {{premiseAU.move_out_date | date : \'dd-MM-yyyy\'}}\n                    </div>\n                    <div class=\"td xs-td-4 sm-td-4 md-td-2 col-meter-reading\">\n                      <span class=\"customer-label visible-xs visible-sm\" translate=\"premise_unregister.unregister_addresses_table.meter_reading\"></span>\n                      {{premiseAU.device.meter_reading || \'-\'}}\n                    </div>\n                    <div class=\"td xs-td-4 sm-td-4 md-td-2 align-right\">\n                      <span class=\"customer-label visible-xs visible-sm\" translate=\"premise_unregister.unregister_addresses_table.meter_number\"></span>\n                      {{premiseAU.device.serial_number}}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <button ng-disabled=\"premises.form.$invalid || !premises.activePremises.length\" ng-if=\"premises.registrablePremises.length !== 0\" ng-click=\"premises.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'premise_unregister.save\' | translate}}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"premises.cancel()\" title=\"{{ \'premise_unregister.previous\' | translate}}\">{{ \'premise_unregister.previous\' | translate}}</button>\n\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/profile/views/profile.email.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'profile.change_email.page_title\' | translate}}</h1>\n\n        <form name=\"email.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{ \'profile.change_email.new_email\' | translate}}</label>\n            <input ng-required=\"true\" ng-model=\"email.form.email\" type=\"text\" class=\"form-control\" id=\"email\" placeholder=\"{{ \'profile.change_email.new_email\' | translate}}\">\n            <div ng-if=\"\'profile.change_email.hints.new_email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'profile.change_email.hints.new_email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"email-repeat\" class=\"required\">{{ \'profile.change_email.repeat_email\' | translate}}</label>\n            <input match=\"email.form.email\" ng-required=\"true\" ng-model=\"email.form.email_confirmation\" type=\"text\" class=\"form-control\" id=\"email-repeat\" placeholder=\"{{ \'profile.change_email.repeat_email\' | translate}}\">\n            <div ng-if=\"\'profile.change_email.hints.new_email_repeat\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'profile.change_email.hints.new_email_repeat\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <input ng-model=\"email.form.update_correspondence_email\" ng-checked=\"email.form.update_correspondence_email\" type=\"checkbox\" id=\"updateCorrespondenceEmail\">\n            <label for=\"updateCorrespondenceEmail\" class=\"label_info\">{{ \'profile.change_email.update_correspondence_email\' | translate}}</label>\n          </div>\n\n          <button ng-disabled=\"email.form.$invalid || email.sendingData\" ng-click=\"email.save()\" title=\"{{ \'profile.change_email.save_btn\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right\">{{ \'profile.change_email.save_btn\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/profile/views/profile.password.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'profile.change_password.page_title\' | translate}}</h1>\n\n        <form name=\"password.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <div class=\"form-group\" ng-if=\"password.bShowCurrentPassword\">\n            <label for=\"current_password\" class=\"required\">{{ \'profile.change_password.current_password\' | translate}}</label>\n            <password id=\"current_password\" ng-model=\"password.form.current_password\" validate=\"false\" placeholder=\"{{ \'profile.change_password.current_password\' | translate}}\" ng-required=\"true\"></password>\n            <div ng-if=\"\'profile.change_password.hints.current_password\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'profile.change_password.hints.current_password\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"password\" class=\"required\">{{ \'profile.change_password.new_password\' | translate}}</label>\n            <password id=\"password\" ng-model=\"password.form.password\" validate=\"true\" ng-required=\"true\"></password>\n            <div ng-if=\"\'profile.change_password.hints.new_password\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'profile.change_password.hints.new_password\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"password-repeat\" class=\"required\">{{ \'profile.change_password.repeat_password\' | translate}}</label>\n            <password id=\"password-repeat\" ng-model=\"password.form.password_confirmation\" validate=\"false\" placeholder=\"{{ \'profile.change_password.repeat_password\' | translate}}\" equals=\"password.form.password\"></password>\n            <div ng-if=\"\'profile.change_password.hints.new_password_repeat\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'profile.change_password.hints.new_password_repeat\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <button ng-disabled=\"password.form.$invalid || password.sendingData\" ng-click=\"password.save()\" title=\"{{ \'profile.change_password.save_btn\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right\">{{ \'profile.change_password.save_btn\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/profile/views/profile.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1 class=\"dashboard-title\">{{ \'profile.dashboard.page_title\' | translate }}</h1>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"dashboard-block\">\n        <div class=\"display-table\">\n          <div class=\"table table-mobile-block\">\n            <div class=\"odd tbody profile-info-block\">\n              <div class=\"tr\">\n                <div class=\"td profile-label\">{{ \'profile.dashboard.email\' | translate }}</div>\n                <div class=\"td\">{{ profile.data.email.account || \'-\' }}</div>\n              </div>\n            </div>\n            <div class=\"even tbody profile-info-block\">\n              <div class=\"tr\">\n                <div class=\"td profile-label\">{{ \'profile.dashboard.password\' | translate }}</div>\n                <div class=\"td\">●●●●●●●●</div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <a ui-sref=\"profileEmail\" class=\"btn-primary btn-custom margin\" title=\"{{ \'profile.dashboard.btn_change_email\' | translate }}\">{{ \'profile.dashboard.btn_change_email\' | translate }}</a>\n        <a ui-sref=\"profilePassword\" class=\"btn-primary btn-custom margin\" title=\"{{ \'profile.dashboard.btn_change_password\' | translate }}\">{{ \'profile.dashboard.btn_change_password\' | translate }}</a>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/register/views/register.confirmation.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form rs-text\">\n        <h1>{{\'register.confirmation.page_\'+registerConfirmation.isInFuture+\'title\' | translate}}</h1>\n        <p ng-if=\"!registerConfirmation.isInFuture\">{{\'register.confirmation.confirmation_email\' | translate}}</p>\n        <p ng-if=\"registerConfirmation.isInFuture\" translate=\"register.confirmation.confirmation_future_email\" translate-value-date=\"{{registerConfirmation.moveInDate | date:\'EEEE d MMMM y\'}}\"></p>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/components/register/views/register.correspondence.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n        <form name=\"registerCorrespondence.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <p><strong>{{\'register.correspondence.form_title\' | translate}}</strong></p>\n\n          <div class=\"top-indent\">\n            <div class=\"form-group\">\n              <label for=\"correspondence-country\" class=\"required\">{{\'register.correspondence.country\' | translate}}</label>\n              <select ng-required=\"true\" id=\"correspondence-country\" class=\"form-control\" ng-model=\"registerCorrespondence.data.correspondenceAddress.country\" ng-change=\"registerCorrespondence.changeCountry()\">\n                <option value=\"\">{{\'register.correspondence.select_a_country\' | translate}}</option>\n                <option value=\"NL\">{{\'register.correspondence.option_NL\' | translate}}</option>\n                <option value=\"BE\">{{\'register.correspondence.option_BE\' | translate}}</option>\n                <option value=\"DE\">{{\'register.correspondence.option_DE\' | translate}}</option>\n              </select>\n              <div ng-if=\"\'register.correspondence.hints.select_a_country\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.correspondence.hints.select_a_country\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"radio\" ng-if=\"registerCorrespondence.data.correspondenceAddress.country\" ng-show=\"registerCorrespondence.data.correspondenceAddress.country == \'NL\'\">\n              <label>\n                <input ng-change=\"registerCorrespondence.changeType()\" ng-required=\"registerCorrespondence.data.correspondenceAddress.type\" type=\"radio\" ng-model=\"registerCorrespondence.data.correspondenceAddress.type\" value=\"address\">\n                {{\'register.correspondence.houseno_postal_code\' | translate}}\n              </label>\n            </div>\n            <div class=\"radio\" ng-if=\"registerCorrespondence.data.correspondenceAddress.country == \'NL\'\">\n              <label>\n                <input ng-change=\"registerCorrespondence.changeType()\" ng-required=\"!registerCorrespondence.data.correspondenceAddress.type\" type=\"radio\" ng-model=\"registerCorrespondence.data.correspondenceAddress.type\" value=\"po_box\">\n                {{\'register.correspondence.houseno_po_box\' | translate}}\n              </label>\n            </div>\n\n            <div ng-class=\"{\'left-indent\' :  registerCorrespondence.data.correspondenceAddress.country == \'NL\'}\" ng-if=\"registerCorrespondence.data.correspondenceAddress.type == \'address\' && registerCorrespondence.data.correspondenceAddress.country.length\">\n              <div class=\"form-group\">\n                <div ng-if=\"registerCorrespondence.data.correspondenceAddress.country == \'NL\'\">\n                  <label for=\"correspondence-postal-code\" class=\"required\">{{\'register.correspondence.postal_code\' | translate}}</label>\n                  <input ui-mask=\"9999 AA\" placeholder=\"{{\'register.correspondence.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"registerCorrespondence.data.correspondenceAddress.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-postal-code\" ng-blur=\"registerCorrespondence.autofillHouseNo()\">\n                </div>\n\n                <div ng-if=\"registerCorrespondence.data.correspondenceAddress.country == \'BE\'\">\n                  <label for=\"correspondence-postal-code-be\" class=\"required\">{{\'register.correspondence.postal_code\' | translate}}</label><br>\n                  <input check-number ng-minlength=\"4\" ng-maxlength=\"4\" ng-trim=\"false\" limit-to=\"4\" ng-required=\"true\" ng-model=\"registerCorrespondence.data.correspondenceAddress.postal_code\" placeholder=\"{{\'register.correspondence.postal_code_placeholder_be\' | translate}}\" type=\"text\" class=\"form-control\" id=\"correspondence-postal-code-be\">\n                </div>\n\n                <div ng-if=\"registerCorrespondence.data.correspondenceAddress.country == \'DE\'\">\n                  <label for=\"correspondence-postal-code-de\" class=\"required\">{{\'register.correspondence.postal_code\' | translate}}</label><br>\n                  <input check-number ng-minlength=\"5\" ng-maxlength=\"5\" ng-trim=\"false\" limit-to=\"5\" ng-required=\"true\" ng-model=\"registerCorrespondence.data.correspondenceAddress.postal_code\" placeholder=\"{{\'register.correspondence.postal_code_placeholder_de\' | translate}}\" type=\"text\" class=\"form-control\" id=\"correspondence-postal-code-de\">\n                </div>\n\n                <div ng-if=\"\'register.correspondence.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.correspondence.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"correspondence-housenumber\" class=\"required\">{{\'register.correspondence.houseno_and_addtion\' | translate}}</label><br>\n                <div class=\"correspondence-medium-input\">\n                  <input check-number ng-required=\"true\" ng-model=\"registerCorrespondence.data.correspondenceAddress.house_no\" type=\"text\" class=\"form-control\" id=\"correspondence-housenumber\" placeholder=\"\" ng-blur=\"registerCorrespondence.autofillHouseNo()\">\n                </div>\n                <div class=\"correspondence-small-input\">\n                  <input ng-model=\"registerCorrespondence.data.correspondenceAddress.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-house-number-addition\" placeholder=\"\" ng-blur=\"registerCorrespondence.autofillHouseNo()\">\n                </div>\n                <div ng-if=\"\'register.correspondence.hints.houseno_and_addtion\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.correspondence.hints.houseno_and_addtion\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"form-group\">\n                  <label for=\"correspondence-street\" class=\"required\">{{\'register.correspondence.street\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"registerCorrespondence.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-required=\"true\" ng-model=\"registerCorrespondence.data.correspondenceAddress.street\" type=\"text\" class=\"form-control\" id=\"correspondence-street\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'register.correspondence.hints.street\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.correspondence.hints.street\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n\n                <div class=\"form-group\">\n                  <label for=\"correspondence-city\" class=\"required\">{{\'register.correspondence.city\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"registerCorrespondence.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-required=\"true\" ng-model=\"registerCorrespondence.data.correspondenceAddress.city\" type=\"text\" class=\"form-control\" id=\"correspondence-city\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'register.correspondence.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.correspondence.hints.city\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"left-indent\" ng-if=\"registerCorrespondence.data.correspondenceAddress.type == \'po_box\' && registerCorrespondence.data.correspondenceAddress.country.length\">\n              <div class=\"form-group\">\n                <label for=\"correspondence-postal-code-po\" class=\"required\">{{\'register.correspondence.postal_code\' | translate}}</label>\n                <input ui-mask=\"9999 AA\" placeholder=\"{{\'register.correspondence.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"registerCorrespondence.data.correspondenceAddress.po_box_postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"correspondence-postal-code-po\" ng-blur=\"registerCorrespondence.autofillPoBox()\">\n\n                <div ng-if=\"\'register.correspondence.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.correspondence.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div class=\"form-group clearfix\">\n                <label for=\"correspondence-po\" class=\"required\">{{\'register.correspondence.po_box\' | translate}}</label><br>\n\n                <input ng-required=\"true\" ng-maxlength=\"5\" ng-model=\"registerCorrespondence.data.correspondenceAddress.po_box\" type=\"text\" class=\"form-control\" id=\"correspondence-po\" ng-blur=\"registerCorrespondence.autofillPoBox()\">\n                <div ng-if=\"\'register.correspondence.hints.po_box\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.correspondence.hints.po_box\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n\n              <div>\n                <div class=\"form-group\">\n                  <label for=\"correspondence-city-po\" class=\"required\">{{\'register.correspondence.city\' | translate}}</label>\n                  <div class=\"form-loader-wrap\">\n                    <div ng-if=\"registerCorrespondence.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n                    <input ng-required=\"true\" ng-model=\"registerCorrespondence.data.correspondenceAddress.city\" type=\"text\" class=\"form-control\" id=\"correspondence-city-po\" placeholder=\"\">\n                  </div>\n                  <div ng-if=\"\'register.correspondence.hints.city\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.correspondence.hints.city\' | translate}}\" popover-placement=\"top-right\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <button ng-disabled=\"registerCorrespondence.form.$invalid || registerCorrespondence.sendingData\" ng-click=\"registerCorrespondence.save()\" title=\"{{\'register.correspondence.save\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'register.correspondence.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"registerCorrespondence.previousState()\" title=\"{{ \'register.correspondence.cancel\' | translate}}\">{{ \'register.correspondence.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/components/register/views/register.login.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n        <form name=\"registerLogin.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <div class=\"form-group clearfix\">\n            <label for=\"postal-code\" class=\"required\">{{ \'register.postal_code\' | translate}}</label><br>\n            <input ui-mask=\"9999 AA\" placeholder=\"{{ \'register.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"registerLogin.form.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\">\n            <div ng-if=\"\'register.login.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.login.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"housenumber\" class=\"required\">{{ \'register.houseno_and_addtion\' | translate}}</label><br>\n            <div class=\"medium\">\n              <input check-number ng-required=\"true\" ng-model=\"registerLogin.form.house_no\" type=\"text\" class=\"form-control\" id=\"housenumber\" placeholder=\"{{ \'register.house_number_placeholder\' | translate}}\">\n            </div>\n            <div class=\"small\">\n              <input ng-model=\"registerLogin.form.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"house-number-addition\" placeholder=\"{{ \'register.house_number_addition_placeholder\' | translate}}\">\n            </div>\n            <div ng-if=\"\'register.login.hints.house_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.login.hints.house_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <button ng-disabled=\"registerLogin.form.$invalid || registerLogin.sendingData\" ng-click=\"registerLogin.doLogin()\" title=\"{{ \'register.save\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'register.save\' | translate }}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"registerLogin.cancel()\" title=\"{{ \'register.previous\' | translate}}\">{{ \'register.previous\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/register/views/register.meter-reading.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n        <form name=\"registerMeterReading.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <p><strong>{{\'register.meter_reading.form_title\' | translate}}</strong></p>\n          <div class=\"form-group\">\n            <label for=\"recording-date\" class=\"required\">{{ \'register.meter_reading.date_key_transfer\' | translate }}</label>\n            <div class=\"input-group\">\n              <input ng-keydown=\"$event.preventDefault()\" ng-model=\"registerMeterReading.data.meterReading.date\" ng-click=\"registerMeterReading.openDatepicker()\" uib-datepicker-popup=\"{{registerMeterReading.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"registerMeterReading.datepickerOptions\" is-open=\"registerMeterReading.showDatepicker\" ng-required=\"true\" type=\"text\" class=\"form-control\" id=\"recording-date\">\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"registerMeterReading.openDatepicker()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n              </span>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"registerMeterReading.data.connectionAddress.meter_number\">\n            <label for=\"meter-reading\">{{ \'register.meter_reading.meter_number\' | translate}}</label><br>\n            <input ng-disabled=\"true\" ng-required=\"false\" ng-model=\"registerMeterReading.data.connectionAddress.meter_number\" type=\"text\" class=\"form-control\" id=\"meter-number\">\n            <div ng-if=\"\'register.meter_reading.hints.meter_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'register.meter_reading.hints.meter_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"meter-reading\" class=\"required\">{{ \'register.meter_reading.meter_reading\' | translate}}</label><br>\n            <input ng-required=\"true\" ng-model=\"registerMeterReading.data.meterReading.meter_reading\" type=\"text\" class=\"form-control text-right\" id=\"meter-reading\" ng-maxlength=\"5\" maxlength=\"5\" check-number>\n            <div ng-if=\"\'register.meter_reading.hints.meter_reading\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'register.meter_reading.hints.meter_reading\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"registerMeterReading.data.meterReading.num1\" type=\"text\" class=\"form-control\" id=\"meter-reading-num1\">\n            </div>\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"registerMeterReading.data.meterReading.num2\" type=\"text\" class=\"form-control\" id=\"meter-reading-num2\">\n            </div>\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"registerMeterReading.data.meterReading.num3\" type=\"text\" class=\"form-control\" id=\"meter-reading-num3\">\n            </div>\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"registerMeterReading.data.meterReading.num4\" type=\"text\" class=\"form-control\" id=\"meter-reading-num4\">\n            </div>\n            <div class=\"meter-input\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"registerMeterReading.data.meterReading.num5\" type=\"text\" class=\"form-control\" id=\"meter-reading-num5\">\n            </div>\n            <span class=\"meter-input-comma\">,</span>\n            <div class=\"meter-input\">\n              <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n            </div>\n            <div class=\"meter-input\">\n              <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n            </div>\n            <div class=\"meter-input clear-margin-right\">\n              <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n            </div>\n          </div>\n\n          <div ng-if=\"registerMeterReading.data.forced_meter_reading\" class=\"form-group\">\n            <label for=\"fileUpload\">{{ \'register.meter_reading.file_upload\' | translate}}</label>\n\n            <div class=\"current-file-name\" ng-if=\"registerMeterReading.data.meterReading.file_upload.name\">\n              {{registerMeterReading.data.meterReading.file_upload.name}}\n            </div>\n\n            <div class=\"file-upload-container\">\n              <input ng-value=\"registerMeterReading.fileToUpload.name\" ng-required=\"false\" ngf-resize=\"{width: 1200, height: 1200, quality: .8}\" ng-disabled=\"true\" type=\"text\" class=\"form-control\" id=\"filenameField\" placeholder=\"\">\n              <button class=\"btn-custom btn-file btn-primary button-margin-left\" ngf-max-size=\"20MB\" ngf-select=\"registerMeterReading.fileChange($file, $invalidFiles);\" ng-required=\"false\" ng-model=\"registerMeterReading.data.fileUpload\" id=\"fileUpload\" name=\"fileUpload\" type=\"file\" ngf-accept=\"\'image/jpeg, image/png, image/gif\'\">\n                <label for=\"fileUpload\">{{ \'register.meter_reading.file_upload_btn\' | translate}}</label>\n              </button>\n            </div>\n\n            <div class=\"clearfix\"></div>\n            <div class=\"field-description\">{{ \'register.meter_reading.file_upload_description\' | translate }}</div>\n          </div>\n\n          <button ng-disabled=\"registerMeterReading.form.$invalid || registerMeterReading.sendingData\" ng-click=\"registerMeterReading.save()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'register.meter_reading.next\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"registerMeterReading.cancel()\" title=\"{{ \'register.meter_reading.previous\' | translate}}\">{{ \'register.meter_reading.previous\' | translate}}</button>\n        </form>\n        <meter-images></meter-images>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6 rs-text\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/components/register/views/register.move-in-date.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n        <form name=\"registerMoveInDate.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"recording-date\" class=\"required\">{{ \'register.meter_reading.date_key_transfer\' | translate }}</label>\n            <div class=\"input-group\">\n              <input ng-keydown=\"$event.preventDefault()\" ng-click=\"registerMoveInDate.openDatepicker()\" uib-datepicker-popup=\"{{registerMoveInDate.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"registerMoveInDate.datepickerOptions\" is-open=\"registerMoveInDate.showDatepicker\" ng-required=\"true\" ng-model=\"registerMoveInDate.data.meterReading.date\" type=\"text\" class=\"form-control\" id=\"recording-date\">\n              <span class=\"input-group-btn\">\n                <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"registerMoveInDate.openDatepicker()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n              </span>\n            </div>\n          </div>\n          <button ng-disabled=\"registerMoveInDate.form.$invalid\" ng-click=\"registerMoveInDate.next()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'register.meter_reading.next\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"registerMoveInDate.cancel()\" title=\"{{ \'register.cancel\' | translate}}\">{{ \'register.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/register/views/register.payment-method.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n        <form name=\"registerPaymentMethod.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <p><strong>{{\'register.payment_method.form_title\' | translate}}</strong></p>\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"payment-methods\">{{ \'register.payment_method.payment_method\' | translate}}</label>\n            <select ng-required=\"true\" id=\"payment-methods\" ng-model-options=\"{ updateOn: \'change\'}\" class=\"form-control\" ng-model=\"registerPaymentMethod.data.paymentMethod.payment_method\" ng-options=\"method as \'register.payment_method.\' + method.label | translate for method in registerPaymentMethod.paymentMethods\">\n            </select>\n            <div ng-if=\"\'register.payment_method.hints.payment_method\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'register.payment_method.hints.payment_method\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label class=\"required\" for=\"payment-frequency\">{{ \'register.payment_method.payment_frequency\' | translate}}</label>\n            <select ng-required=\"true\" ng-change=\"registerPaymentMethod.filterPaymentDays()\" id=\"payment-frequency\" class=\"form-control\" ng-model=\"registerPaymentMethod.data.paymentMethod.payment_frequency\" ng-options=\"frequency as \'register.payment_method.\' + frequency.label | translate for frequency in registerPaymentMethod.paymentFrequency\">\n            </select>\n            <div ng-if=\"\'register.payment_method.hints.payment_frequency\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'register.payment_method.hints.payment_frequency\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <div class=\"form-group\" ng-if=\"registerPaymentMethod.data.paymentMethod.payment_method.label == \'automatic_collection\'\">\n            <label for=\"pay-dates\" class=\"required\">{{ \'register.payment_method.pay_date\' | translate}}</label>\n            <select ng-required=\"true\" ng-disabled=\"!registerPaymentMethod.data.paymentMethod.payment_frequency.value\" id=\"pay-dates\" class=\"form-control\" ng-model=\"registerPaymentMethod.data.paymentMethod.payment_date\" ng-options=\"dates as \'register.payment_method.\' + dates.label | translate for dates in registerPaymentMethod.paymentDates\">\n            </select>\n            <div ng-if=\"\'register.payment_method.hints.pay_date\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'register.payment_method.hints.pay_date\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <label for=\"iban\" class=\"required\">{{ \'register.payment_method.iban\' | translate }}</label>\n            <input ng-model-options=\"$root.ngModelOptions\" ng-iban ng-required=\"true\" id=\"iban\" ng-model=\"registerPaymentMethod.data.paymentMethod.iban\" type=\"text\" class=\"form-control\">\n            <div ng-if=\"\'register.payment_method.hints.iban\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'register.payment_method.hints.iban\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n          <button ng-disabled=\"registerPaymentMethod.form.$invalid || registerPaymentMethod.sendingData\" ng-click=\"registerPaymentMethod.save()\" title=\"{{ \'register.payment_method.save_btn\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'register.payment_method.save_btn\' | translate }}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"registerPaymentMethod.cancel()\" title=\"{{ \'register.payment_method.cancel_btn\' | translate}}\">{{ \'register.payment_method.cancel_btn\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6 rs-text\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/register/views/register.personal-info.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n        <form name=\"registerPersonalInfo.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <p><strong>{{\'register.personal_information.form_title\' | translate}}</strong></p>\n\n          <div ng-if=\"registerPersonalInfo.data.connectionAddress.customerType == \'residence\'\" class=\"residence\">\n            <!--<div class=\"form-group\">-->\n              <!--<label for=\"salutation\">{{\'register.personal_information.salutation\' | translate}}</label>-->\n              <!--<select ng-model=\"registerPersonalInfo.data.personalInformation.salutation\" class=\"form-control\" id=\"salutation\" ng-options=\"salutation.label for salutation in registerPersonalInfo.salutations track by salutation.value\">-->\n                <!--<option value=\"\"></option>-->\n              <!--</select>-->\n              <!--<div ng-if=\"\'register.personal_information.hints.salutation\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.salutation\' | translate}}\" popover-placement=\"top-right\">-->\n                <!--<i class=\"fa fa-info\" aria-hidden=\"true\"></i>-->\n              <!--</div>-->\n            <!--</div>-->\n\n            <div class=\"form-group\">\n              <label for=\"initials\" class=\"required\">{{\'register.personal_information.initials\' | translate}}</label>\n              <input ng-model=\"registerPersonalInfo.data.personalInformation.initials\" required type=\"text\" id=\"initials\" class=\"form-control\" ng-disabled=\"registerPersonalInfo.data.credentials.future_move_token\" initials>\n              <div ng-if=\"\'register.personal_information.hints.initials\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.initials\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"insertion\">{{\'register.personal_information.insertion\' | translate}}</label>\n              <select ng-model=\"registerPersonalInfo.data.personalInformation.insertion\" class=\"form-control\" id=\"insertion\" ng-options=\"insertion.label for insertion in registerPersonalInfo.data.insertions track by insertion.value\" ng-disabled=\"registerPersonalInfo.data.credentials.future_move_token\">\n                <option value=\"\"></option>\n              </select>\n              <div ng-if=\"\'register.personal_information.hints.insertion\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.insertion\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"lastname\" class=\"required\">{{\'register.personal_information.last_name\' | translate}}</label>\n              <input ng-model=\"registerPersonalInfo.data.personalInformation.lastName\" required type=\"text\" id=\"lastname\" class=\"form-control\" limit-to=\"40\" ng-disabled=\"registerPersonalInfo.data.credentials.future_move_token\">\n              <div ng-if=\"\'register.personal_information.hints.last_name\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.last_name\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n\n            <div class=\"form-group\">\n              <label for=\"birthday\">{{\'register.personal_information.birthday\' | translate}}</label>\n              <input model-view-value=\"true\" date-format=\"{ minDate: \'01-01-1900\', maxDate: registerPersonalInfo.dateNow}\" ui-mask=\"99-99-9999\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-model=\"registerPersonalInfo.data.personalInformation.birthday\" type=\"text\" class=\"form-control\" id=\"birthday\">\n              <div ng-if=\"\'register.personal_information.hints.birthday\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.birthday\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n          </div>\n\n          <div ng-if=\"registerPersonalInfo.data.connectionAddress.customerType == \'company\'\" class=\"company\">\n            <div class=\"form-group\">\n              <label for=\"companyname\" class=\"required\">{{\'register.personal_information.company_name\' | translate}}</label>\n              <input ng-model=\"registerPersonalInfo.data.personalInformation.companyName\" required type=\"text\" id=\"companyname\" class=\"form-control\" limit-to=\"40\" ng-disabled=\"registerPersonalInfo.data.credentials.future_move_token\">\n              <div ng-if=\"\'register.personal_information.hints.company_name\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.company_name\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"customer-phonenumber\">{{ \'register.personal_information.phonenumber\' | translate}}</label>\n            <input check-number ng-model=\"registerPersonalInfo.data.personalInformation.phone\" ng-minlength=\"10\" limit-to=\"10\" type=\"text\" class=\"form-control\" id=\"customer-phonenumber\" placeholder=\"{{ \'customer.edit.phonenumber\' | translate}}\">\n            <div ng-if=\"\'register.personal_information.hints.phonenumber\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.phonenumber\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"customer-mobile-phonenumber\">{{ \'register.personal_information.mobile_phonenumber\' | translate}}</label>\n            <input check-number ng-model=\"registerPersonalInfo.data.personalInformation.mobile_phone\" ng-minlength=\"10\" limit-to=\"10\" type=\"text\" class=\"form-control\" id=\"customer-mobile-phonenumber\" placeholder=\"{{ \'customer.edit.mobile_phonenumber\' | translate}}\">\n            <div ng-if=\"\'register.personal_information.hints.mobile_phonenumber\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.mobile_phonenumber\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{\'register.personal_information.email\' | translate}}</label>\n            <input check-email required id=\"email\" type=\"text\" ng-model=\"registerPersonalInfo.data.personalInformation.email\" class=\"form-control\">\n            <div ng-if=\"\'register.personal_information.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.personal_information.hints.email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div ng-if=\"!registerPersonalInfo.data.bIsInFuture\" class=\"form-group clearfix\">\n            <input ng-init=\"registerPersonalInfo.data.personalInformation.emailInvoice\" ng-model=\"registerPersonalInfo.data.personalInformation.emailInvoice\" ng-click=\"registerPersonalInfo.toggleEmailInvoices()\" type=\"checkbox\" id=\"email-invoice\">\n            <label for=\"email-invoice\" class=\"label_info\">{{ \'register.personal_information.invoice_email_checkbox\' | translate}}</label>\n          </div>\n\n          <div ng-if=\"!registerPersonalInfo.data.bIsInFuture\" class=\"form-group clearfix\">\n            <input ng-model=\"registerPersonalInfo.data.personalInformation.customerSurvey\" ng-click=\"registerPersonalInfo.toggleCustomerSurvey()\" type=\"checkbox\" id=\"survey\">\n            <label for=\"survey\" class=\"label_info\">{{ \'register.personal_information.customer_survey\' | translate}}</label>\n          </div>\n\n          <button ng-disabled=\"registerPersonalInfo.form.$invalid || registerPersonalInfo.sendingData\" ng-click=\"registerPersonalInfo.save()\" title=\"{{\'register.personal_information.save\' | translate}}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'register.personal_information.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"registerPersonalInfo.previousState()\" title=\"{{ \'register.personal_information.cancel\' | translate}}\">{{ \'register.personal_information.cancel\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/components/register/views/register.portal.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n        <form name=\"registerPortal.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <p><strong>{{\'register.portal.form_title\' | translate}}</strong></p>\n          <p>{{\'register.portal.intro\' | translate}}</p>\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{ \'register.portal.email\' | translate}}</label>\n            <input check-email ng-required=\"true\" ng-model=\"registerPortal.data.portalAccount.email\" type=\"text\" class=\"form-control\" id=\"email\" placeholder=\"{{ \'register.portal.email\' | translate}}\">\n            <div ng-if=\"\'register.portal.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.portal.hints.email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"email-repeat\" class=\"required\">{{ \'register.portal.repeat_email\' | translate}}</label>\n            <input match=\"registerPortal.data.portalAccount.email\" ng-required=\"true\" ng-model=\"registerPortal.data.portalAccount.email_confirmation\" type=\"text\" class=\"form-control\" id=\"email-repeat\" placeholder=\"{{ \'register.portal.repeat_email\' | translate}}\">\n            <div ng-if=\"\'register.portal.hints.repeat_email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.portal.hints.repeat_email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"password\" class=\"required\">{{ \'register.portal.password\' | translate}}</label>\n            <password id=\"password\" ng-model=\"registerPortal.data.portalAccount.password\" validate=\"true\" ng-required=\"true\"></password>\n            <div ng-if=\"\'register.portal.hints.password\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.portal.hints.password\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"password-repeat\" class=\"required\">{{ \'register.portal.repeat_password\' | translate}}</label>\n            <password id=\"password-repeat\" ng-model=\"registerPortal.data.portalAccount.password_confirmation\" equals=\"registerPortal.data.portalAccount.password\" validate=\"false\" placeholder=\"{{ \'register.portal.repeat_password\' | translate}}\" ng-required=\"true\"></password>\n            <div ng-if=\"\'register.portal.hints.repeat_password\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.portal.hints.repeat_password\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"btn-group pull-right\">\n            <button ng-disabled=\"registerPortal.form.$invalid || registerPortal.sendingData\" ng-click=\"registerPortal.save()\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{\'register.portal.next\' | translate}}</button>\n            <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"registerPortal.cancel()\" title=\"{{ \'register.portal.previous\' | translate}}\">{{ \'register.portal.previous\' | translate}}</button>\n          </div>\n\n          <div class=\"btn-group pull-right\">\n            <a class=\"btn-link\" ng-click=\"registerPortal.skipStep()\">{{\'register.portal.skip_step\' | translate}}</a>\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/components/register/views/register.summary.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form register-submit-form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n\n        <div ng-if=\"registerSummary.data.bIsInFuture\" class=\"summary-form-block\">\n          <a ui-sref=\"registerMoveInDate\" title=\"{{\'register.summary.move_in_date_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.meter_reading.date_key_transfer\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.date\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.meterReading.date | date}}</div>\n          </div>\n        </div>\n\n        <div ng-if=\"registerSummary.data.bIsInFuture\" class=\"summary-form-block\">\n          <a ui-sref=\"register\" title=\"{{\'register.summary.future_address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.future_connection_address\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.connectionAddress.street}} {{registerSummary.data.connectionAddress.house_no}} {{registerSummary.data.connectionAddress.house_no_addition}}, {{registerSummary.data.connectionAddress.postal_code|uppercase}} {{registerSummary.data.connectionAddress.city}}</div>\n          </div>\n        </div>\n\n        <div ng-if=\"!registerSummary.data.bIsInFuture\" class=\"summary-form-block\">\n          <a ui-sref=\"register\" title=\"{{\'register.summary.connection_address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.connection_address\' | translate}}</h3>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.connectionAddress.customerType == \'residence\'\">\n            <div class=\"block-inner-label\">{{\'register.summary.number_of_persons\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.connectionAddress.number_of_persons}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.connectionAddress.street}} {{registerSummary.data.connectionAddress.house_no}} {{registerSummary.data.connectionAddress.house_no_addition}}, {{registerSummary.data.connectionAddress.postal_code|uppercase}} {{registerSummary.data.connectionAddress.city}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.meter_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.connectionAddress.meter_number}}</div>\n          </div>\n        </div>\n\n        <div ng-if=\"!registerSummary.data.bIsInFuture && registerSummary.data.connectionAddress.hasDifferentCorrespondence === true && registerSummary.data.correspondenceAddress.type == \'address\'\" class=\"summary-form-block\">\n          <a ui-sref=\"registerCorrespondence\" title=\"{{\'register.summary.correspondence_address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.correspondence_address\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.correspondenceAddress.street}} {{registerSummary.data.correspondenceAddress.house_no}} {{registerSummary.data.correspondenceAddress.house_no_addition}}, {{registerSummary.data.correspondenceAddress.postal_code|uppercase}} {{registerSummary.data.correspondenceAddress.city}}</div>\n          </div>\n        </div>\n\n        <div ng-if=\"!registerSummary.data.bIsInFuture && registerSummary.data.connectionAddress.hasDifferentCorrespondence === true && registerSummary.data.correspondenceAddress.type == \'po_box\'\" class=\"summary-form-block\">\n          <a ui-sref=\"registerCorrespondence\" title=\"{{\'register.summary.correspondence_address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.correspondence_address\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">{{\'register.summary.po_box\' | translate}} {{registerSummary.data.correspondenceAddress.po_box}} , {{registerSummary.data.correspondenceAddress.po_box_postal_code|uppercase}} {{registerSummary.data.correspondenceAddress.city}}</div>\n          </div>\n        </div>\n\n        <div ng-if=\"!registerSummary.data.bIsInFuture && registerSummary.data.connectionAddress.hasDifferentCorrespondence === false\" class=\"summary-form-block\">\n          <a ui-sref=\"register\" title=\"{{\'register.summary.correspondence_address_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.correspondence_address\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.address\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.connectionAddress.street}} {{registerSummary.data.connectionAddress.house_no}} {{registerSummary.data.connectionAddress.house_no_addition}}, {{registerSummary.data.connectionAddress.postal_code|uppercase}} {{registerSummary.data.connectionAddress.city}}</div>\n          </div>\n        </div>\n\n        <div ng-if=\"registerSummary.data.connectionAddress.customerType == \'residence\'\" class=\"summary-form-block\">\n          <a ui-sref=\"registerPersonalInfo\" title=\"{{\'register.summary.personal_information_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.personal_information\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.name\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.salutation.label}} {{registerSummary.data.personalInformation.initials}} {{registerSummary.insertion.label}} {{registerSummary.data.personalInformation.lastName}}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.personalInformation.birthday\">\n            <div class=\"block-inner-label\">{{\'register.summary.birthday\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.birthday | date}}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.personalInformation.phone\">\n            <div class=\"block-inner-label\">{{\'register.summary.phone_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.phone || \'-\'}}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.personalInformation.mobile_phone\">\n            <div class=\"block-inner-label\">{{\'register.summary.mobile_phone_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.mobile_phone || \'-\'}}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.personalInformation.email\">\n            <div class=\"block-inner-label\">{{\'register.summary.email\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.email}}</div>\n          </div>\n          <div ng-if=\"!registerSummary.data.bIsInFuture\" class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.emailInvoice\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <span ng-if=\"registerSummary.data.personalInformation.emailInvoice\">{{\'register.summary.yes\' | translate}}</span>\n              <span ng-if=\"!registerSummary.data.personalInformation.emailInvoice\">{{\'register.summary.no\' | translate}}</span>\n            </div>\n          </div>\n          <div ng-if=\"!registerSummary.data.bIsInFuture\" class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.customerSurvey\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <span ng-if=\"registerSummary.data.personalInformation.customerSurvey\">{{\'register.summary.yes\' | translate}}</span>\n              <span ng-if=\"!registerSummary.data.personalInformation.customerSurvey\">{{\'register.summary.no\' | translate}}</span>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"registerSummary.data.connectionAddress.customerType == \'company\'\" class=\"summary-form-block\">\n          <a ui-sref=\"registerPersonalInfo\" title=\"{{\'register.summary.company_information_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.company_information\' | translate}}</h3>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.personalInformation.companyName\">\n            <div class=\"block-inner-label\">{{\'register.summary.name\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.companyName}}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.personalInformation.phone\">\n            <div class=\"block-inner-label\">{{\'register.summary.phone_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.phone}}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.personalInformation.mobile_phone\">\n            <div class=\"block-inner-label\">{{\'register.summary.mobile_phone_number\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.mobile_phone}}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.personalInformation.email\">\n            <div class=\"block-inner-label\">{{\'register.summary.email\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.personalInformation.email}}</div>\n          </div>\n          <div ng-if=\"!registerSummary.data.bIsInFuture\" class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.emailInvoice\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <span ng-if=\"registerSummary.data.personalInformation.emailInvoice\">{{\'register.summary.yes\' | translate}}</span>\n              <span ng-if=\"!registerSummary.data.personalInformation.emailInvoice\">{{\'register.summary.no\' | translate}}</span>\n            </div>\n          </div>\n          <div ng-if=\"!registerSummary.data.bIsInFuture\" class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.customerSurvey\' | translate}}</div>\n            <div class=\"block-inner-text\">\n              <span ng-if=\"registerSummary.data.personalInformation.customerSurvey\">{{\'register.summary.yes\' | translate}}</span>\n              <span ng-if=\"!registerSummary.data.personalInformation.customerSurvey\">{{\'register.summary.no\' | translate}}</span>\n            </div>\n          </div>\n        </div>\n\n        <div ng-if=\"!registerSummary.data.bIsInFuture\" class=\"summary-form-block\">\n          <a ui-sref=\"registerMeterReading\" title=\"{{\'register.summary.meter_reading_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.meter_reading\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.date\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.meterReading.date | date}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.meter_reading\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.meterReading.meter_reading}}</div>\n          </div>\n        </div>\n\n        <div ng-if=\"!registerSummary.data.bIsInFuture\" class=\"summary-form-block\">\n          <a ui-sref=\"registerPaymentMethod\" title=\"{{\'register.summary.payment_method_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.payment_method\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.payment_method\' | translate}}</div>\n            <div class=\"block-inner-text\">{{\'register.payment_method.\'+registerSummary.data.paymentMethod.payment_method.label | translate}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.frequency\' | translate}}</div>\n            <div class=\"block-inner-text\">{{\'register.payment_method.\'+registerSummary.data.paymentMethod.payment_frequency.label | translate}}</div>\n          </div>\n          <div class=\"block-innner\" ng-if=\"registerSummary.data.paymentMethod.payment_method.value == \'automatic_collection\'\">\n            <div class=\"block-inner-label\">{{\'register.summary.pay_date\' | translate}}</div>\n            <div class=\"block-inner-text\">{{\'register.payment_method.\'+registerSummary.data.paymentMethod.payment_date.label | translate}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.iban\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.paymentMethod.iban | iban}}</div>\n          </div>\n        </div>\n\n        <div ng-if=\"!registerSummary.data.bIsInFuture && registerSummary.data.portalAccount.isSet\" class=\"summary-form-block\">\n          <a ui-sref=\"registerPortal\" title=\"{{\'register.summary.portal_account_edit\' | translate}}\" class=\"edit-icon pull-right\">\n            <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n          </a>\n          <h3>{{\'register.summary.portal_account\' | translate}}</h3>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.email\' | translate}}</div>\n            <div class=\"block-inner-text\">{{registerSummary.data.portalAccount.email}}</div>\n          </div>\n          <div class=\"block-innner\">\n            <div class=\"block-inner-label\">{{\'register.summary.password\' | translate}}</div>\n            <div class=\"block-inner-text\">********</div>\n          </div>\n        </div>\n\n        <div class=\"form-group\">\n          <input type=\"checkbox\" id=\"conditions\" ng-model=\"registerSummary.data.summary.conditionAccepted\">\n          <label for=\"conditions\" class=\"required\" translate=\"register.summary.conditions\"></label>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <button ng-disabled=\"!registerSummary.data.summary.conditionAccepted || registerSummary.sendingData\" ng-click=\"registerSummary.save()\" type=\"submit\" class=\"btn-primary btn-custom pull-right button-margin-left\">{{\'register.summary.confirm\' | translate}}</button>\n            <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"registerSummary.previousState()\" title=\"{{ \'register.previous\' | translate}}\">{{ \'register.previous\' | translate}}</button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/components/register/views/register.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{\'register.page_title\' | translate}}</h1>\n        <form name=\"register.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <p><strong>{{\'register.form_title\' | translate}}</strong></p>\n\n          <div class=\"form-group\">\n            <label for=\"customerType\">{{\'register.customer_type\' | translate}}</label>\n            <select id=\"customerType\" ng-model-options=\"{ updateOn: \'change\'}\" required ng-model=\"register.data.connectionAddress.customerType\" class=\"form-control\">\n              <option value=\"residence\">{{\'register.residence\' | translate}}</option>\n              <option value=\"company\">{{\'register.company\' | translate}}</option>\n            </select>\n            <div ng-if=\"\'register.hints.customer_type\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.hints.customer_type\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"!register.data.bIsInFuture\">\n            <div class=\"form-group\" ng-hide=\"register.data.connectionAddress.customerType == \'company\'\">\n              <label for=\"number-of-persons\" class=\"required\">{{ \'register.number_of_persons\' | translate}}</label>\n              <input ng-required=\"true\" check-number ng-minlength=\"1\" ng-maxlength=\"1\" ng-model=\"register.data.connectionAddress.number_of_persons\" type=\"text\" class=\"form-control\" id=\"number-of-persons\">\n              <div ng-if=\"\'register.hints.number_of_persons\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.hints.number_of_persons\' | translate}}\" popover-placement=\"top-right\">\n                <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"postal-code\" class=\"required\">{{ \'register.postal_code\' | translate}}</label>\n            <input ui-mask=\"9999 AA\" placeholder=\"{{ \'register.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"register.data.connectionAddress.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\" ng-focus=\"register.hideNotification()\" ng-blur=\"register.autofillHouseNo()\" ng-disabled=\"register.data.credentials.future_move_token\">\n            <div ng-if=\"\'register.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"housenumber\" class=\"required\">{{ \'register.houseno_and_addtion\' | translate}}</label><br>\n            <div class=\"medium\">\n              <input check-number ng-required=\"true\" ng-model=\"register.data.connectionAddress.house_no\" type=\"text\" class=\"form-control\" id=\"housenumber\" placeholder=\"{{ \'register.house_number_placeholder\' | translate}}\" ng-focus=\"register.hideNotification()\" ng-blur=\"register.autofillHouseNo()\" ng-disabled=\"register.data.credentials.future_move_token\">\n            </div>\n            <div class=\"small\">\n              <input ng-model=\"register.data.connectionAddress.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"house-number-addition\" placeholder=\"{{ \'register.house_number_addition_placeholder\' | translate}}\" ng-blur=\"register.autofillHouseNo()\" ng-disabled=\"register.data.credentials.future_move_token\">\n            </div>\n            <div ng-if=\"\'register.hints.house_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.hints.house_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"street\" class=\"required\">{{ \'register.street\' | translate}}</label>\n            <div class=\"form-loader-wrap\">\n              <div ng-if=\"register.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n              <input ng-disabled=\"true\" ng-required=\"true\" ng-model=\"register.data.connectionAddress.street\" type=\"text\" class=\"form-control\" id=\"street\">\n            </div>\n            <div ng-if=\"\'register.hints.street\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.hints.street\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"place\" class=\"required\">{{ \'register.place\' | translate}}</label>\n            <div class=\"form-loader-wrap\">\n              <div ng-if=\"register.loading\" class=\"inline-loader\"><img src=\"/app/images/loader.svg\"></div>\n              <input ng-disabled=\"true\" ng-required=\"true\" ng-model=\"register.data.connectionAddress.city\" type=\"text\" class=\"form-control\" id=\"place\">\n            </div>\n            <div ng-if=\"\'register.hints.place\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'register.hints.place\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\" ng-hide=\"register.data.bIsInFuture\">\n            <input ng-model=\"register.data.connectionAddress.hasDifferentCorrespondence\" ng-checked=\"register.data.connectionAddress.hasDifferentCorrespondence\" type=\"checkbox\" id=\"differentcorrespondence\">\n            <label for=\"differentcorrespondence\" class=\"label_info\">{{ \'register.different_correspondence_address\' | translate}}</label>\n          </div>\n\n          <button ng-disabled=\"register.form.$invalid || register.noValidAddress\" ng-click=\"register.save()\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">{{ \'register.save\' | translate}}</button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"register.cancel()\" title=\"{{ \'register.previous\' | translate}}\">{{ \'register.previous\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6 rs-text\">\n      <div ui-view=\"faq\">\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/routes/views/routes.view.html","<!-- ROUTES -->\n{{routes.list|json}}\n<!-- ROUTES -->\n");
$templateCache.put("app/components/search/views/search.view.html","<div class=\"container js-search-container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <h1>{{ \'search.title\' | translate}}</h1>\n\n\n      <div id=\"oi-results\" style=\"display: none\"></div>\n\n      <div class=\"search-snippet\" ng-if=\"!search.searchResults.length\"><p>{{ \'search.no_result\' | translate}}</p></div>\n      <div ng-if=\"search.searchResults.length\">\n        <div class=\"search-snippet\" ng-repeat=\"result in search.searchResults\">\n          <strong ng-bind-html=\"result.title\"></strong>\n          <div ng-bind-html=\"result.snippet\"></div>\n          <span class=\"more\"><a link=\"result.url\" search-result-target>{{ \'search.read_more\' | translate}} <i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></a></span>\n        </div>\n      </div>\n\n      <div class=\"pagination-wrapper clearfix\">\n        <div class=\"pull-left pagination-txt\">\n          <div id=\"oi-header\"></div>\n        </div>\n        <div class=\"pull-right pagination-nav\">\n          <div id=\"oi-pager\"></div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'search.search\' | translate}}</h1>\n        <form name=\"search.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"oi-query\">{{ \'search.what\' | translate}}</label>\n            <input type=\"text\" class=\"form-control search-input\" id=\"oi-query\">\n          </div>\n          <button id=\"oi-submit\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left js-open-search\">{{ \'search.btn\' | translate}}</button>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/side-menu/views/side-menu.view.html","<div class=\"side-nav\">\n  <ul class=\"fa-ul\" ng-repeat=\"mainNavItem in sideMenu.getItems(0)\">\n    <li ng-repeat=\"item in sideMenu.getItems(1, mainNavItem.id) | orderBy:\'sort_value\'\">\n      <i class=\"fa-li fa\" ng-class=\"(item.active && sideMenu.getItems(2, item.id).length) ?\'fa-angle-down\' : \'fa-angle-right\'\"></i>\n      <a ng-if=\"item.type !== \'iLink\'\" title=\"{{item.label}}\" ng-class=\"{ \'active\': item.active}\" ui-sref=\"{{item.name || sideMenu.currentState}}\" ng-click=\"item.active = !item.active\">{{item.label}}</a>\n      <a ng-if=\"item.type === \'iLink\'\" title=\"{{item.label}}\" ng-class=\"{ \'active\': item.active}\" href=\"{{item.url}}\" target=\"_blank\">{{item.label}}</a>\n      <ul class=\"collapse\" uib-collapse=\"!item.active\">\n        <li ng-repeat=\"subItem in sideMenu.getItems(2, item.id) | orderBy:\'sort_value\'\">\n          <a ng-if=\"subItem.type !== \'iLink\'\" title=\"{{subItem.label}}\" ng-class=\"{\'active\' : subItem.active}\" ui-sref=\"{{subItem.name}}\">{{subItem.label}}</a>\n          <a ng-if=\"subItem.type === \'iLink\'\" title=\"{{subItem.label}}\" ng-class=\"{\'active\' : subItem.active}\" href=\"{{subItem.url}}\" target=\"_blank\">{{subItem.label}}</a>\n          <ul class=\"collapse\" uib-collapse=\"!subItem.active\">\n            <li ng-repeat=\"subsubItem in sideMenu.getItems(3, subItem.id) | orderBy:\'sort_value\'\">\n              <a ng-if=\"subsubItem.type !== \'iLink\'\" title=\"{{subsubItem.label}}\" ng-class=\"{\'active\' : subsubItem.active}\" ui-sref=\"{{subsubItem.name}}\">{{subsubItem.label}}</a>\n              <a ng-if=\"subsubItem.type === \'iLink\'\" title=\"{{subsubItem.label}}\" ng-class=\"{\'active\' : subsubItem.active}\" href=\"{{subsubItem.url}}\" target=\"_blank\">{{subsubItem.label}}</a>\n            </li>\n          </ul>\n        </li>\n      </ul>\n    </li>\n  </ul>\n</div>\n");
$templateCache.put("app/components/sign-up/views/sign-up.thank-you.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <div class=\"form rs-text\">\n        <h1>{{ \'signUp.thank_you.page_title\' | translate}}</h1>\n        <p ng-bind-html=\"signUp.text\"></p>\n      </div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/sign-up/views/sign-up.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'signUp.page_title\' | translate}}</h1>\n        <form name=\"signUp.form\" class=\"clearfix\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\">\n          <div class=\"form-group\">\n            <label for=\"customer-number\" class=\"required\">{{ \'signUp.customernumber\' | translate}}</label>\n            <input ng-required=\"true\" check-number ng-minlength=\"8\" ng-maxlength=\"8\" ng-trim=\"false\" limit-to=\"8\" ng-model=\"signUp.data.customer_number\" type=\"text\" class=\"form-control\" id=\"customer-number\" placeholder=\"{{ \'signUp.customernumber_placeholder\' | translate}}\">\n            <div ng-if=\"\'signUp.hints.customernumber\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'signUp.hints.customernumber\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"postal-code\" class=\"required\">{{ \'signUp.postal_code\' | translate}}</label><br>\n            <input ui-mask=\"9999 AA\" placeholder=\"{{ \'signUp.postal_code_placeholder\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"signUp.data.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\">\n\n            <div ng-if=\"\'signUp.hints.postal_code\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'signUp.hints.postal_code\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <label for=\"housenumber\" class=\"required\">{{ \'signUp.house_number\' | translate}} & {{ \'signUp.house_number_addition\' | translate}}</label><br>\n            <div class=\"medium\">\n              <input check-number ng-required=\"true\" ng-model=\"signUp.data.house_no\" type=\"text\" class=\"form-control\" id=\"housenumber\" placeholder=\"{{ \'signUp.house_number_placeholder\' | translate}}\">\n            </div>\n            <div class=\"small\">\n              <input ng-model=\"signUp.data.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"house-number-addition\" placeholder=\"{{ \'signUp.house_number_addition_placeholder\' | translate}}\">\n            </div>\n            <div ng-if=\"\'signUp.hints.house_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'signUp.hints.house_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"email\" class=\"required\">{{ \'signUp.email\' | translate}}</label>\n            <input check-email ng-required=\"true\" ng-model=\"signUp.data.email\" type=\"text\" class=\"form-control\" id=\"email\" placeholder=\"{{ \'signUp.email\' | translate}}\">\n            <div ng-if=\"\'signUp.hints.email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'signUp.hints.email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"email-repeat\" class=\"required\">{{ \'signUp.repeat_email\' | translate}}</label>\n            <input match=\"signUp.data.email\" ng-required=\"true\" ng-model=\"signUp.data.email_confirmation\" type=\"text\" class=\"form-control\" id=\"email-repeat\" placeholder=\"{{ \'signUp.repeat_email\' | translate}}\">\n            <div ng-if=\"\'signUp.hints.repeat_email\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'signUp.hints.repeat_email\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"password\" class=\"required\">{{ \'signUp.password\' | translate}}</label>\n            <password id=\"password\" ng-model=\"signUp.data.password\" validate=\"true\" ng-required=\"true\"></password>\n            <div ng-if=\"\'signUp.hints.password\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'signUp.hints.password\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"password-repeat\" class=\"required\">{{ \'signUp.repeat_password\' | translate}}</label>\n            <password id=\"password-repeat\" ng-model=\"signUp.data.password_confirmation\" equals=\"signUp.data.password\" validate=\"false\" placeholder=\"{{ \'signUp.repeat_password\' | translate}}\" ng-required=\"true\"></password>\n            <div ng-if=\"\'signUp.hints.repeat_password\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{\'signUp.hints.repeat_password\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <button ng-disabled=\"signUp.form.$invalid || signUp.sendingData\" ng-click=\"signUp.signUp()\" type=\"submit\" class=\"btn-custom btn-primary pull-right\">{{ \'signUp.signup_btn\' | translate}}</button>\n        </form>\n      </div>\n\n      <div class=\"formbuttons\">\n        <div class=\"line\">\n          <div class=\"word\">{{ \'general.or\' | translate}}</div>\n        </div>\n\n        <div class=\"extra_button\">\n          <a ui-sref=\"login\" title=\"{{ \'signUp.login_btn\' | translate}}\" class=\"btn-custom btn-secondary sign-up-button\">{{ \'signUp.login_btn\' | translate}}</a>\n        </div>\n        <div class=\"extra_button\">\n          <a ui-sref=\"registerMoveInDate\" title=\"{{ \'signUp.become_customer\' | translate}}\" class=\"btn-link\">{{ \'signUp.become_customer\' | translate}}</a>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/standpipe/views/standpipe.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n      <div ui-view=\"banners\"></div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro rs-text row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"detail.data.Content.title.data\">{{detail.data.Content.title.data}}</h1>\n          <div ng-if=\"detail.data.Content.intro.data\" class=\"intro-text\">{{detail.data.Content.intro.data}}</div>\n          <h2 class=\"page-intro-title\" ng-if=\"detail.data.Content.title_block_1.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_1.data}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.text_block_1.data\" ng-bind-html=\"detail.data.Content.text_block_1.data\"></div>\n        </div>\n      </div>\n      <div class=\"row content\">\n        <div class=\"col-xs-12\">\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_1.bMediaAvailable && detail.data.Content.detail_image_1.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_1.description}}\" ng-src=\"{{detail.data.Content.detail_image_1.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text rs-text\" ng-if=\"detail.data.Content.title_block_2.data || detail.data.Content.text_block_2.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_2.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_2.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_2.data\" ng-bind-html=\"detail.data.Content.text_block_2.data\"></div>\n          </div>\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_2.bMediaAvailable && detail.data.Content.detail_image_2.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_2.description}}\" ng-src=\"{{detail.data.Content.detail_image_2.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-text rs-text\" ng-if=\"detail.data.Content.text_block_2_2.data\">\n            <div ng-bind-html=\"detail.data.Content.text_block_2_2.data\"></div>\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video2.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video2.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video2.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text rs-text\" ng-if=\"detail.data.Content.title_block_3.data || detail.data.Content.text_block_3.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_3.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_3.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_3.data\" ng-bind-html=\"detail.data.Content.text_block_3.data\"></div>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_3_left.data || detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Links\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_3_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"detail.data.Content.text_block_3_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Rechts\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video3.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video3.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video3.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_4_left.data || detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Links\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_4_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"detail.data.Content.text_block_4_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Rechts\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n          </div>\n\n\n          <div class=\"row standpipe-form form-wrapper\" ng-if=\"detail.data.Content.form && detail.bShowForm\">\n            <div class=\"col-md-12\">\n              <div class=\"form\">\n                <form name=\"detail.form\" class=\"clearfix vacancy-form\" novalidate=\"novalidate\">\n                  <fieldset>\n                    <legend>{{\'standpipe.form.title\' | translate}}</legend>\n                    <div class=\"form-group\">\n                      <label for=\"company_name\">{{\'standpipe.form.company_name\' | translate}}</label>\n                      <input id=\"company_name\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.company.company_name\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"client_name\" class=\"required\">{{\'standpipe.form.client_name\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"client_name\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.company.client_name\">\n                    </div>\n                  </fieldset>\n                  <fieldset>\n                    <legend>{{\'standpipe.form.invoice_address\' | translate}}</legend>\n\n                    <div class=\"form-group\">\n                      <label for=\"street\" class=\"required\">{{\'standpipe.form.street\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"street\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.billing.street\">\n                    </div>\n\n                    <div class=\"form-group clearfix\">\n                      <label for=\"house_no\">{{\'standpipe.form.house_no_and_addition\' | translate}}</label><br>\n                      <div class=\"medium\">\n                        <input id=\"house_no\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.billing.house_no\">\n                      </div>\n                      <div class=\"small\">\n                        <input id=\"house_no_addition\" class=\"form-control text-uppercase\" type=\"text\" ng-model=\"detail.formData.billing.house_no_addition\">\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"postal_code\" class=\"required\">{{\'standpipe.form.postal_code\' | translate}}</label>\n                      <input id=\"postal_code\" ng-required=\"true\" aria-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.billing.postal_code\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"city\" class=\"required\">{{\'standpipe.form.city\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"city\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.billing.city\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"phone\" class=\"required\">{{\'standpipe.form.phone\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"phone\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.billing.phone\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"email\" class=\"required\">{{\'standpipe.form.email\' | translate}}</label>\n                      <input check-email ng-required=\"true\" aria-required=\"true\" id=\"email\" class=\"form-control\" type=\"email\" ng-model=\"detail.formData.billing.email\">\n                    </div>\n\n                    <div class=\"form-group\" ng-if=\"detail.formType === \'standpipe\'\">\n                      <div class=\"checkbox\">\n                        <label for=\"invoice_electronic\">\n                          <input ng-checked=\"true\" type=\"checkbox\" id=\"invoice_electronic\" ng-model=\"detail.formData.billing.invoice_electronic\" ng-init=\"detail.formData.billing.invoice_electronic=true\">\n                          {{\'standpipe.form.invoice_electronic\' | translate}}\n                        </label>\n                      </div>\n                    </div>\n                  </fieldset>\n\n                  <fieldset>\n                    <legend>{{\'standpipe.form.standpipe_location\' | translate}}</legend>\n\n                    <div class=\"form-group\">\n                      <label for=\"location_contact_person\" class=\"required\">{{\'standpipe.form.location_contact_person\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"location_contact_person\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.location.contact_person\">\n                    </div>\n                    <div class=\"form-group\">\n                      <label for=\"location_phone\" class=\"required\">{{\'standpipe.form.location_phone\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"location_phone\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.location.phone\">\n                    </div>\n                    <div class=\"form-group\">\n                      <label for=\"location_street\" class=\"required\">{{\'standpipe.form.location_street\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"location_street\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.location.street\">\n                    </div>\n\n                    <div class=\"form-group clearfix\">\n                      <label for=\"location_house_no\" class=\"required\">{{\'standpipe.form.location_house_no\' | translate}}</label><br>\n                      <div class=\"medium\">\n                        <input ng-required=\"true\" aria-required=\"true\" id=\"location_house_no\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.location.house_no\">\n                      </div>\n                      <div class=\"small\">\n                        <input id=\"location_house_no_addition\" class=\"form-control text-uppercase\" type=\"text\" ng-model=\"detail.formData.location.house_no_addition\">\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"location_postal_code\" class=\"required\">{{\'standpipe.form.location_postal_code\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"location_postal_code\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.location.postal_code\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"location_city\" class=\"required\">{{\'standpipe.form.location_city\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"location_city\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.location.city\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"location_hydrant\">{{\'standpipe.form.location_hydrant\' | translate}}</label>\n                      <input id=\"location_hydrant\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.location.hydrant\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label ng-if=\"detail.formType === \'standpipe\'\" for=\"location_message\">{{\'standpipe.form.location_message\' | translate}}</label>\n                      <label ng-if=\"detail.formType === \'standpipe-irrigation\'\" for=\"location_message\">{{\'standpipe.form.location_message_irrigation\' | translate}}</label>\n                      <div ng-if=\"detail.formType === \'standpipe-irrigation\' && \'standpipe.form.hints.location_message\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'standpipe.form.hints.location_message\' | translate}}\" popover-placement=\"top-right\">\n                        <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                      </div>\n                      <textarea rows=\"3\" ng-model=\"detail.formData.location.message\" class=\"form-control\" id=\"location_message\"></textarea>\n                    </div>\n                  </fieldset>\n\n                  <fieldset>\n                    <legend>{{\'standpipe.form.date_time\' | translate}}</legend>\n\n                    <p ng-if=\"detail.formType === \'standpipe\'\" class=\"field-text\"><em>{{\'standpipe.form.date_time_text\' | translate}}</em></p>\n                    <p ng-if=\"detail.formType === \'standpipe-irrigation\'\" class=\"field-text\"><em>{{\'standpipe.form.date_time_text_irrigation\' | translate}}</em></p>\n\n                    <div class=\"form-group\">\n                      <label for=\"start_date\" class=\"required\">{{\'standpipe.form.date_start\' | translate}}</label>\n                      <div class=\"input-group\">\n                        <input ng-keydown=\"$event.preventDefault()\" ng-required=\"true\" aria-required=\"true\" ng-click=\"detail.openDatepickerStart()\" uib-datepicker-popup=\"{{detail.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"detail.datepickerOptions\" is-open=\"detail.showDatepickerStart\" ng-required=\"true\" ng-model=\"detail.formData.duration.start_date\" type=\"text\" class=\"form-control\" id=\"start_date\">\n                        <span class=\"input-group-btn\">\n                          <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"detail.openDatepickerStart()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n                        </span>\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <div class=\"group-label required\">{{\'standpipe.form.time_start\' | translate}}</div>\n                      <div class=\"radio\" ng-repeat=\"startTimeSlot in detail.startTimeslot\">\n                        <label><input ng-required=\"true\" aria-required=\"true\" ng-model=\"detail.formData.duration.start_timeslot\" type=\"radio\" name=\"start_block\" ng-value=\"startTimeSlot.value\">{{\'standpipe.\'+startTimeSlot.label | translate}}</label>\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"end_date\" class=\"required\">{{\'standpipe.form.date_end\' | translate}}</label>\n                      <div class=\"input-group\">\n                        <input ng-keydown=\"$event.preventDefault()\" ng-required=\"true\" aria-required=\"true\" ng-click=\"detail.openDatepickerEnd()\" uib-datepicker-popup=\"{{detail.datepickerFormat}}\" check-date-in-period datepicker-append-to-body=\"true\" show-button-bar=\"false\" datepicker-options=\"detail.datepickerOptions\" is-open=\"detail.showDatepickerEnd\" ng-required=\"true\" ng-model=\"detail.formData.duration.end_date\" type=\"text\" class=\"form-control\" id=\"end_date\">\n                        <span class=\"input-group-btn\">\n                          <button type=\"button\" class=\"btn btn-custom btn-primary\" ng-click=\"detail.openDatepickerEnd()\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></button>\n                        </span>\n                      </div>\n                      <div ng-if=\"detail.formType === \'standpipe\' && \'standpipe.form.hints.date_end\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'standpipe.form.hints.date_end\' | translate}}\" popover-placement=\"top-right\">\n                        <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                      </div>\n                      <div ng-if=\"detail.formType === \'standpipe-irrigation\' && \'standpipe.form.hints.date_end_irrigation\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'standpipe.form.hints.date_end_irrigation\' | translate}}\" popover-placement=\"top-right\">\n                        <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                      </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                      <div class=\"group-label required\">{{\'standpipe.form.time_end\' | translate}}</div>\n                      <div class=\"radio\" ng-repeat=\"endTimeSlot in detail.endTimeslot\">\n                        <label><input ng-required=\"true\" aria-required=\"true\" ng-model=\"detail.formData.duration.end_timeslot\" type=\"radio\" name=\"end_block\" ng-value=\"endTimeSlot.value\">{{\'standpipe.\'+endTimeSlot.label | translate}}</label>\n                      </div>\n                    </div>\n\n                    <p ng-if=\"detail.formType === \'standpipe\'\" class=\"field-text\"><em>{{\'standpipe.form.text_presence_required\' | translate}}</em></p>\n                  </fieldset>\n\n                  <fieldset>\n                    <legend>{{\'standpipe.form.capacity\' | translate}}</legend>\n                    <div class=\"form-group\">\n                      <label for=\"capacity\">{{\'standpipe.form.capacity_standpipe\' | translate}}</label>\n                      <select ng-readonly=\"detail.readOnlyCapacity\" id=\"capacity\" class=\"form-control\" ng-model=\"detail.formData.capacity\" ng-options=\"capacity.value as \'standpipe.\'+capacity.label | translate for capacity in detail.capacity\"></select>\n                    </div>\n\n                    <p class=\"field-text\" ng-if=\"detail.formType === \'standpipe\'\">\n                      <em>{{\'standpipe.form.capacity_text_paragraph1\' | translate}}</em>\n                    </p>\n\n                    <p class=\"field-text\" ng-if=\"detail.formType === \'standpipe\'\">\n                      <em>{{\'standpipe.form.capacity_text_paragraph2\' | translate}}</em>\n                    </p>\n\n                    <p class=\"field-text\" ng-if=\"detail.formType === \'standpipe-irrigation\'\">\n                      <em>{{\'standpipe.form.capacity_text_irrigation\' | translate}}</em>\n                    </p>\n\n                    <div class=\"form-group\" ng-if=\"detail.formType === \'standpipe\'\">\n                      <label for=\"treatment\" class=\"required\">{{\'standpipe.form.treatment\' | translate}}</label>\n                      <select ng-required=\"true\" aria-required=\"true\" id=\"treatment\" class=\"form-control\" ng-model=\"detail.formData.treatment\">\n                        <option value=\"\"></option>\n                        <option ng-value=\"true\">{{\'standpipe.form.treatment_option_yes\' | translate}}</option>\n                        <option ng-value=\"false\">{{\'standpipe.form.treatment_option_no\' | translate}}</option>\n                      </select>\n                    </div>\n                  </fieldset>\n\n                  <fieldset>\n                    <legend>{{\'standpipe.form.quality\' | translate}}</legend>\n\n                    <p class=\"field-text\" ng-if=\"detail.formType === \'standpipe\'\">\n                      <em>{{\'standpipe.form.quality_warn\' | translate}}</em>\n                    </p>\n\n                    <p class=\"field-text\" ng-if=\"detail.formType === \'standpipe-irrigation\'\">\n                      <em>{{\'standpipe.form.quality_warn_irrigation\' | translate}}</em>\n                    </p>\n\n                    <div class=\"form-group\" ng-if=\"detail.formType === \'standpipe\'\">\n                      <label for=\"consumption\">{{\'standpipe.form.consumption\' | translate}}</label>\n                      <select id=\"consumption\" class=\"form-control\" ng-model=\"detail.formData.consumption\">\n                        <option value=\"\"></option>\n                        <option ng-value=\"true\">{{\'standpipe.form.consumption_option_yes\' | translate}}</option>\n                        <option ng-value=\"false\">{{\'standpipe.form.consumption_option_no\' | translate}}</option>\n                      </select>\n                    </div>\n                  </fieldset>\n\n                  <fieldset>\n                    <legend>{{\'standpipe.form.rates\' | translate}}</legend>\n\n                    <div class=\"form-group\" ng-if=\"detail.formType === \'standpipe\'\">\n                      <div class=\"checkbox\">\n                        <label for=\"conditions\" class=\"required\">\n                          <input ng-required=\"true\" aria-required=\"true\" type=\"checkbox\" id=\"conditions\" ng-model=\"detail.formData.accept_rates\">\n                          {{\'standpipe.form.terms_rent\' | translate}}\n                        </label>\n                      </div>\n                    </div>\n\n                    <p class=\"field-text\" ng-if=\"detail.formType === \'standpipe-irrigation\'\">\n                      <em>{{\'standpipe.form.rates_irrigation\' | translate}}</em>\n                    </p>\n\n                  </fieldset>\n\n                  <fieldset>\n                    <legend>{{\'standpipe.form.terms\' | translate}}</legend>\n\n                    <div class=\"form-group\" ng-if=\"detail.formType === \'standpipe\'\">\n                      <div class=\"checkbox\">\n                        <label for=\"accept_conditions_1\" class=\"required\">\n                          <input ng-required=\"true\" aria-required=\"true\" type=\"checkbox\" id=\"accept_conditions_1\" ng-model=\"detail.formData.accept_conditions\">\n                          <span translate=\"standpipe.form.accept_conditions\"></span>\n                        </label>\n                      </div>\n                    </div>\n\n\n                    <div class=\"form-group\" ng-if=\"detail.formType === \'standpipe-irrigation\'\">\n                      <div class=\"checkbox\">\n                        <label for=\"accept_conditions_2\" class=\"required\">\n                          <input ng-required=\"true\" aria-required=\"true\" type=\"checkbox\" id=\"accept_conditions_2\" ng-model=\"detail.formData.accept_conditions\">\n                          <span translate=\"standpipe.form.accept_conditions_irrigation\"></span>\n                        </label>\n                      </div>\n                    </div>\n\n                  </fieldset>\n\n                  <div class=\"btn-group pull-right\">\n                    <button ng-disabled=\"detail.form.$invalid || detail.sendingData\" class=\"btn-primary btn-custom\" ng-click=\"detail.send()\">{{\'standpipe.form.send\' | translate}}</button>\n                  </div>\n                </form>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form detail-form\">\n            <h2>{{detail.bottomBlock.title}}</h2>\n            <p>{{detail.bottomBlock.text}}</p>\n            <button class=\"btn btn-primary btn-custom\" ui-sref=\"dashboard\">{{detail.bottomBlock.button}}</button>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/usage/partials/connection-addresses.modal.partial.html","<div class=\"modal-header\">\n  <button type=\"button\" ng-click=\"usage.usageScanModal.dismiss()\" class=\"close lg-close\">\n    <span class=\"fa fa-times\"></span>\n  </button>\n  <h3 class=\"modal-title\" id=\"modal-title\">{{ \'usage.dashboard.usage_scan_popup_title\' | translate }}</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <table class=\"table table-striped\">\n    <thead>\n      <tr>\n        <th>{{ \'usage.dashboard.connection_meter_number\' | translate }}</th>\n        <th>{{ \'usage.dashboard.connection_address\' | translate }}</th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr role=\"button\" ng-repeat=\"connection in usage.connectionAddresses\" ng-click=\"usage.usageScanModal.close({contract_account_id: connection.contract_account_id, contract_id: connection.contract_id, premise_id: connection.premise_id})\">\n        <td>{{connection.device.serial_number}}</td>\n        <td>{{connection.address.street}} {{connection.address.house_no}}<span ng-if=\"connection.address.house_no_addition\"> {{connection.address.house_no_addition}}</span>, {{connection.address.postal_code}} {{connection.address.city}} <i class=\"pull-right fa fa-arrow-right\" aria-hidden=\"true\"></i></td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n\n");
$templateCache.put("app/components/usage/partials/meter-readings.modal.partial.html","<div class=\"modal-header\">\n  <button type=\"button\" ng-click=\"modal.meterReadingsModal.dismiss()\" class=\"close lg-close\">\n    <span class=\"fa fa-times\"></span>\n  </button>\n  <h1 class=\"modal-title\" id=\"modal-title\">{{ \'usage.dashboard.meter_reading_popup_title\' | translate }}</h1>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <table class=\"table table-striped\">\n    <thead>\n    <tr>\n      <th>{{ \'usage.dashboard.meter_reading_meter_number\' | translate }}</th>\n      <th>{{ \'usage.dashboard.meter_reading_address\' | translate }}</th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr role=\"button\" ng-repeat=\"connection in modal.meterReadings\" ng-click=\"modal.meterReadingsModal.close({assignment_number: connection.assignment_number, postal_code: connection.device.address.postal_code})\">\n      <td>{{connection.device.serial_number}}</td>\n      <td>{{connection.device.address.street}} {{connection.device.address.house_no}}<span ng-if=\"connection.device.address.house_no_addition\"> {{connection.device.address.house_no_addition}}</span>, {{connection.device.address.postal_code}} {{connection.device.address.city}} <i class=\"pull-right fa fa-arrow-right\" aria-hidden=\"true\"></i></td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n");
$templateCache.put("app/components/usage/views/usage.compare.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"usage-compare-wrapper\">\n        <h1>{{ \'usage.compare.page_title\' | translate }}</h1>\n\n        <div class=\"display-table\">\n          <div class=\"table\">\n            <div class=\"thead\">\n              <div class=\"tr\">\n                <div class=\"th\"><div class=\"hidden-xs\">{{ \'usage.compare.recording_date\' | translate }}</div></div>\n                <div class=\"th\">{{ \'usage.compare.meter_reading\' | translate }}</div>\n                <div class=\"th\">{{ \'usage.compare.usage\' | translate }}</div>\n              </div>\n            </div>\n            <div class=\"tbody\">\n              <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-repeat=\"reading in usage.consumption.meter_reading_results\">\n                <div class=\"td\">{{reading.reading_date_time | date: \'dd-MM-yyyy\'}}</div>\n                <div class=\"td\">{{reading.reading_result}}</div>\n                <div class=\"td\">{{reading.consumption}}</div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div ng-if=\"usage.budgetBillingPlan.is_changeable\">\n        <div class=\"info-block\" translate=\"usage.installment_change.limits\" translate-value-lower=\"{{usage.budgetBillingPlan.lower_limit_amount | currency}}\" translate-value-upper=\"{{usage.budgetBillingPlan.upper_limit_amount | currency}}\"></div>\n\n        <div class=\"form clearfix\">\n          <form name=\"usage.form\" class=\"clearfix\" novalidate=\"novalidate\">\n            <div class=\"form-group clearfix\">\n              <div class=\"usage-compare-medium-block block-label\">{{ \'usage.compare.current_installment\' | translate }}</div>\n              <div class=\"usage-compare-small-block extra-padding\">{{ usage.budgetBillingPlan.amount | currency }}</div>\n\n              <div class=\"usage-compare-medium-block\">\n                <label for=\"advised-installment\" class=\"required\">{{ \'usage.compare.advised_installment\' | translate }}</label>\n              </div>\n              <div class=\"usage-compare-small-block\">\n                <div class=\"custom-input-group\">\n                  <div class=\"custom-input-group-addon\">&euro;</div>\n                  <input ng-required=\"true\" ng-blur=\"usage.filterCurrency()\" ng-model=\"usage.data.installment_amount\" type=\"text\" class=\"form-control\" id=\"advised-installment\">\n                </div>\n                <div ng-if=\"\'usage.compare.hints.advised_installment\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'usage.compare.hints.advised_installment\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"usage-form-block checkbox\" ng-if=\"usage.bShowAdvisedCheckbox\">\n              <label>\n                <input type=\"checkbox\" ng-model=\"usage.data.use_advised\" ng-required=\"true\"> {{ \'usage.compare.checkbox\' | translate }}\n                <div ng-if=\"\'usage.compare.hints.checkbox\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'usage.compare.hints.checkbox\' | translate}}\" popover-placement=\"top-right\">\n                  <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                </div>\n              </label>\n            </div>\n\n            <button ng-disabled=\"usage.form.$invalid || usage.sendingData || !usage.data.use_advised\" ng-click=\"usage.save()\" title=\"{{ \'usage.compare.save\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary button-margin-left pull-right\">{{ \'usage.compare.save\' | translate }}</button>\n            <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"usage.cancel()\" title=\"{{ \'usage.compare.cancel\' | translate}}\">{{ \'usage.compare.cancel\' | translate}}</button>\n          </form>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n\n");
$templateCache.put("app/components/usage/views/usage.dashboard.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <h1 class=\"dashboard-title\">{{ \'usage.dashboard.dashboard_title\' | translate}}</h1>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-8\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <div class=\"dashboard-block\" ng-if=\"usage.chartExtraConfig.chartFilterAddresses.length >= 1 && usage.chartExtraConfig.bShowChart\">\n            <h2>{{ \'usage.chart.title\' | translate}}</h2>\n\n            <div class=\"message-wrapper info clearfix\" ng-if=\"usage.chartExtraConfig.chartFilterAddresses.length > 1\">\n              <div class=\"form-group\">\n                <select ng-options=\"address.value as address.label for address in usage.chartExtraConfig.chartFilterAddresses\" class=\"form-control\" ng-model=\"usage.chartExtraConfig.selectedChartAddress\" ng-change=\"usage.changeChart()\">\n                </select>\n              </div>\n            </div>\n\n            <div class=\"row\">\n              <div class=\"col-xs-12\" ng-if=\"usage.chartExtraConfig.smartMeter\">\n                <div class=\"smart_meter\">\n                  <p>{{\'usage.chart.smart_meter_text\' | translate}}</p>\n                  <a href=\"https://wml.energyict.com/wml-portal/\" target=\"_blank\">{{ \'usage.chart.smart_meter_link\' | translate }}</a>\n                </div>\n              </div>\n\n              <div class=\"col-xs-12 col-sm-12\" ng-if=\"usage.chartConfig.series[0].data.length\">\n                <highchart ng-if=\"!usage.chartExtraConfig.smartMeter && !usage.is_company\" id=\"chart1\" config=\"usage.chartConfig\"></highchart>\n              </div>\n\n              <div class=\"col-xs-12 col-sm-12\" ng-if=\"!usage.is_company && !usage.chartExtraConfig.smartMeter\">\n                <p translate=\"usage.chart.text\"></p>\n              </div>\n\n              <div class=\"col-xs-12 col-sm-12\" ng-if=\"!usage.chartConfig.series[0].data.length && !usage.chartExtraConfig.smartMeter\">\n\n                <p ng-if=\"!usage.chartExtraConfig.exchanged || !usage.chartExtraConfig.isExchangeDateRecent\">{{ \'usage.chart.no_history\' | translate}}</p>\n                <p ng-if=\"usage.chartExtraConfig.exchanged && usage.chartExtraConfig.isExchangeDateRecent\" translate=\"usage.chart.no_history_alt\"></p>\n              </div>\n\n              <div class=\"col-xs-12\" ng-if=\"!usage.chartExtraConfig.smartMeter || usage.chartConfig.series[0].data.length\">\n                <div class=\"display-table usage-chart-table\">\n                  <div class=\"table table-custom-width\">\n                    <div class=\"thead hidden-xs hidden-sm\">\n                      <div class=\"tr\">\n                        <div class=\"th xs-td-4\">{{ \'usage.chart.table.recording_period\' | translate }}</div>\n                        <div class=\"th xs-td-3\">{{ \'usage.chart.table.meter_reading\' | translate }}</div>\n                        <div class=\"th xs-td-2\">{{ \'usage.chart.table.usage\' | translate }}</div>\n                        <div ng-if=\"!usage.is_company\" class=\"th xs-td-6 md-td-3\">{{ \'usage.chart.table.reading_type\' | translate }}</div>\n                      </div>\n                    </div>\n                    <div class=\"tbody\" ng-repeat=\"reading in usage.chartExtraConfig.meter_reading_results | orderBy:\'reading_result\':true | limitTo:6\" ng-if=\"reading.previous_reading_date_time && reading.consumption > 0\">\n                      <div class=\"tr\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\">\n                        <div class=\"td xs-td-5 md-td-4\">\n                          <span class=\"visible-xs visible-sm customer-label\">{{ \'usage.chart.table.recording_period\' | translate }}</span>\n                          <span>{{reading.previous_reading_date_time | date: \'dd-MM-yyyy\'}} -<wbr> {{reading.reading_date_time | date: \'dd-MM-yyyy\'}}</span>\n                        </div>\n                        <div class=\"td xs-td-7 md-td-3\">\n                          <span class=\"visible-xs visible-sm customer-label\">{{ \'usage.chart.table.meter_reading\' | translate }}</span>\n                          <span>{{reading.reading_result}}</span>\n                        </div>\n                        <div class=\"td xs-td-5 md-td-2\">\n                          <span class=\"visible-xs visible-sm customer-label\">{{ \'usage.chart.table.usage\' | translate }}</span>\n                          <span>{{reading.consumption}} m<sup>3</sup></span>\n                        </div>\n                        <div ng-if=\"!usage.is_company\" class=\"td xs-td-7 md-td-3\">\n                          <span class=\"visible-xs visible-sm customer-label\">{{ \'usage.chart.table.reading_type\' | translate }}</span>\n                          <span ng-bind-html=\"usage.getDisplayNameMeterReadingCategory(reading.meter_reading_category_id)\"></span>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"row usage-dashboard-faq\">\n        <div class=\"col-xs-12\">\n          <div ui-view=\"faq\"></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-4\">\n      <!-- disabled on clients request -->\n<!--      <div class=\"message-wrapper success disable-border\" ng-if=\"!usage.bShowMeterReadingButton && usage.bShowUsageScan\">-->\n<!--        <div class=\"row\">-->\n<!--          <div class=\"col-xs-12\">-->\n<!--            <h2 class=\"title\">{{ \'usage.dashboard.title_usage_scan\' | translate}}</h2>-->\n<!--          </div>-->\n<!--        </div>-->\n<!--        <div class=\"row\">-->\n<!--          <div class=\"col-xs-12\">-->\n<!--            <p class=\"text-default\">-->\n<!--              {{ \'usage.dashboard.usage_scan_intro\' | translate}}-->\n<!--            </p>-->\n<!--          </div>-->\n<!--          <div class=\"col-xs-12\">-->\n<!--            <button class=\"btn-primary btn-custom btn-success\" type=\"button\" ng-click=\"usage.startUsageScan()\" title=\"{{ \'usage.dashboard.usage_scan_btn\' | translate }}\">{{ \'usage.dashboard.usage_scan_btn\' | translate }}</button>-->\n<!--          </div>-->\n<!--        </div>-->\n<!--      </div>-->\n\n      <div class=\"message-wrapper success disable-border\" ng-if=\"!usage.bShowMeterReadingButton\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <h2 class=\"title\">{{ \'usage.dashboard.title_water_save_check\' | translate}}</h2>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <p class=\"text-default\">\n              {{ \'usage.dashboard.water_save_check_intro\' | translate}}\n            </p>\n          </div>\n          <div class=\"col-xs-12\">\n            <a href=\"https://limburgsdrinkwater.nl/waterbespaarcheck\" class=\"btn-primary btn-custom btn-success\" title=\"{{ \'usage.dashboard.water_save_check_btn\' | translate }}\">{{ \'usage.dashboard.water_save_check_btn\' | translate }}</a>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"message-wrapper info disable-border\" ng-if=\"usage.bShowMeterReadingButton\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <h2 class=\"title\">{{ \'usage.dashboard.title_meter_reading\' | translate}}</h2>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <p class=\"text-default\">\n              {{ \'usage.dashboard.meter_reading_intro\' | translate}}\n            </p>\n          </div>\n          <div class=\"col-xs-12\">\n            <button class=\"btn-primary btn-custom btn-info\" type=\"button\" ng-click=\"usage.openMeterReadingsModal()\" title=\"{{ \'usage.dashboard.meter_reading_btn\' | translate }}\">{{ \'usage.dashboard.meter_reading_btn\' | translate }}</button>\n          </div>\n        </div>\n      </div>\n      <div class=\"message-wrapper success disable-border\" ng-if=\"usage.bShowMeterReadingButton\">\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <h2 class=\"title\">{{ \'usage.dashboard.title_usage_scan\' | translate}}</h2>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <p class=\"text-default\">\n              {{ \'usage.dashboard.usage_scan_intro\' | translate}}\n            </p>\n          </div>\n          <div class=\"col-xs-12\">\n            <button class=\"btn-primary btn-custom btn-success\" type=\"button\" ng-click=\"usage.startUsageScan()\" title=\"{{ \'usage.dashboard.usage_scan_btn\' | translate }}\">{{ \'usage.dashboard.usage_scan_btn\' | translate }}</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/usage/views/usage.installment-amount-change.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\" ng-if=\"usage.visibleForm\">\n      <div class=\"form clearfix\">\n        <h1>{{ \'usage.installment_change.page_title\' | translate }}</h1>\n        <form name=\"usage.form\" class=\"clearfix\" novalidate=\"novalidate\">\n\n          <div class=\"usage-form-block\">\n            <div>{{ \'usage.installment_change.current_installment\' | translate }}</div>\n            <div>\n              <strong>{{ usage.budgetBillingPlan.amount | currency}}</strong>\n              <a ng-if=\"usage.budgetBillingPlan.budget_billing_cycle_id\" ui-sref=\"paymentMethodEdit(usage.stateParams)\" title=\"{{ \'usage.installment_change.frequency_\' + usage.budgetBillingPlan.budget_billing_cycle_id | translate}}\">{{ \'usage.installment_change.frequency_\' + usage.budgetBillingPlan.budget_billing_cycle_id | translate}}</a>\n            </div>\n          </div>\n\n          <div class=\"info-block\" translate=\"usage.installment_change.limits\" translate-value-lower=\"{{usage.budgetBillingPlan.lower_limit_amount | currency}}\" translate-value-upper=\"{{usage.budgetBillingPlan.upper_limit_amount | currency}}\"></div>\n          <div class=\"form-group\">\n            <label for=\"new_installment\" class=\"required\">{{\'usage.installment_change.new_installment\' | translate}}</label>\n            <div class=\"custom-input-group\">\n              <div class=\"custom-input-group-addon\">&euro;</div>\n              <input limit-number-range lower-limit=\"usage.budgetBillingPlan.lower_limit_amount\" upper-limit=\"usage.budgetBillingPlan.upper_limit_amount\" id=\"new_installment\" ng-required=\"true\" ng-blur=\"usage.filterCurrency()\" ng-model=\"usage.data.installment_amount\" type=\"text\" class=\"form-control\" id=\"advised-installment\">\n            </div>\n            <div ng-if=\"\'usage.installment_change.hints.new_installment\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'usage.installment_change.hints.new_installment\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <!-- disabled on clients request -->\n<!--          <div class=\"usage-form-block\">-->\n<!--            <a ui-sref=\"installmentMeterReadings(usage.stateParams)\" title=\"{{\'usage.installment_change.meter_readings\' | translate}}\">{{\'usage.installment_change.meter_readings\' | translate}}</a>-->\n<!--            <div ng-if=\"\'usage.installment_change.hints.meter_readings\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'usage.installment_change.hints.meter_readings\' | translate}}\" popover-placement=\"top-right\">-->\n<!--              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>-->\n<!--            </div>-->\n<!--          </div>-->\n\n          <button ng-disabled=\"usage.form.$invalid || usage.sendingData\" ng-click=\"usage.save()\" title=\"{{ \'usage.installment_change.save\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary button-margin-left pull-right\">{{ \'usage.installment_change.save\' | translate }}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ui-sref=\"invoicesDashboard\" title=\"{{ \'usage.installment_change.cancel\' | translate}}\">{{ \'usage.installment_change.cancel\' | translate}}\n          </button>\n        </form>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/usage/views/usage.installment-amount-changed.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form clearfix\">\n        <h1>{{ \'usage.installment_changed.page_title\' | translate }}</h1>\n        <div class=\"usage-form-block\" translate=\"usage.installment_changed.personalized_text\" translate-value-address=\"{{usage.premise}}\" translate-value-installment=\"{{ usage.budgetBillingPlan.amount | currency}}\"></div>\n\n        <button ui-sref=\"{{usage.cancelLink}}\" title=\"{{ \'usage.installment_changed.btn_finish\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right\">{{\'usage.installment_changed.btn_finish\' | translate }}</button>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/usage/views/usage.meter-readings-usage-scan.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n      <div class=\"form\">\n        <h1>{{ \'usage.meter_readings.page_title\' | translate }}</h1>\n        <form name=\"meterReadings.form\" class=\"clearfix\" novalidate=\"novalidate\">\n          <p ng-if=\"meterReadings.consumption !== null\" translate=\"meter_readings.last_reading\" translate-values=\"{lastReading : meterReadings.consumption.reading_result, readingDate : meterReadings.consumption.reading_date_time}\"></p>\n          <div class=\"form-group\">\n            <label for=\"recording-date\">{{ \'usage.meter_readings.recording_date\' | translate }}</label>\n            <input ng-disabled=\"true\" ng-model=\"meterReadings.data.date\" type=\"text\" class=\"form-control\" id=\"recording-date\">\n            <div ng-if=\"\'usage.meter_readings.hints.recording_date\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'usage.meter_readings.hints.recording_date\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\" ng-if=\"meterReadings.meter_number\">\n            <label for=\"meter-reading\">{{ \'usage.meter_readings.meter_number\' | translate}}</label><br>\n            <input ng-disabled=\"true\" ng-required=\"false\" ng-model=\"meterReadings.meter_number\" type=\"text\" class=\"form-control\" id=\"meter-number\">\n            <div ng-if=\"\'usage.meter_readings.hints.meter_number\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'usage.meter_readings.hints.meter_number\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group\">\n            <label for=\"meter-reading\" class=\"required\">{{ \'usage.meter_readings.meter_reading\' | translate}}</label><br>\n            <input ng-required=\"true\" ng-model=\"meterReadings.data.meter_reading\" type=\"text\" class=\"form-control text-right\" id=\"meter-reading\" ng-maxlength=\"meterReadings.numberOfMeterNumbers\" maxlength=\"{{meterReadings.numberOfMeterNumbers}}\" check-number>\n            <div ng-if=\"\'usage.meter_readings.hints.meter_reading\' | translate\" class=\"popover-wrapper\" popover-append-to-body=\"true\" popover-trigger=\"\'mouseenter outsideClick\'\" uib-popover=\"{{ \'usage.meter_readings.hints.meter_reading\' | translate}}\" popover-placement=\"top-right\">\n              <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n            </div>\n          </div>\n\n          <div class=\"form-group clearfix\">\n            <div class=\"meter-input meter-width-{{meterReadings.numberOfMeterNumbers}}\" ng-class=\"{\'last\': $last}\" ng-repeat=\"number in meterReadings.aNumberOfMeterNumbers\">\n              <input ng-readonly=\"true\" ng-required=\"true\" check-number ng-trim=\"false\" limit-to=\"1\" ng-maxlength=\"1\" ng-model=\"meterReadings.data[\'num\'+number]\" type=\"text\" class=\"form-control\" id=\"meter-reading-num{{number}}\">\n            </div>\n            <div class=\"meter-input-disabled-wrapper meter-input-disabled-wrapper{{meterReadings.numberOfMeterNumbers}}\">\n              <span class=\"meter-input-comma\">,</span>\n              <div class=\"meter-input meter-width-{{meterReadings.numberOfMeterNumbers}}\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n              <div class=\"meter-input meter-width-{{meterReadings.numberOfMeterNumbers}}\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n              <div class=\"meter-input meter-width-{{meterReadings.numberOfMeterNumbers}} clear-margin-right\">\n                <div class=\"meter-input-disabled\" type=\"text\" class=\"form-control\">X</div>\n              </div>\n            </div>\n          </div>\n\n          <button ng-disabled=\"meterReadings.form.$invalid || meterReadings.sendingData\" ng-click=\"meterReadings.save()\" title=\"{{ \'usage.meter_readings.btn_next\' | translate }}\" type=\"submit\" class=\"btn-custom btn-primary pull-right button-margin-left\">\n            {{ \'usage.meter_readings.btn_next\' | translate }}\n          </button>\n          <button type=\"button\" class=\"btn-custom btn-cancel pull-right\" ng-click=\"meterReadings.cancel()\" title=\"{{ \'usage.meter_readings.cancel\' | translate}}\">\n            {{ \'usage.meter_readings.cancel\' | translate}}\n          </button>\n        </form>\n        <meter-images></meter-images>\n      </div>\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n      <div ui-view=\"faq\"></div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/vacancy/views/vacancy-detail.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n      <div ui-view=\"banners\"></div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row rs-text\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"detail.data.Content.vac_name.data\">{{detail.data.Content.vac_name.data}}</h1>\n          <h2 ng-if=\"detail.data.Content.vac_description.data\">{{\'vacancy_page.titles.description\' | translate}}</h2>\n          <div ng-if=\"detail.data.Content.vac_description.data\" class=\"detail-content-text\" ng-bind-html=\"detail.data.Content.vac_description.data\"></div>\n          <h2 ng-if=\"detail.data.Content.vac_core_activities.data\">{{\'vacancy_page.titles.core_activities\' | translate}}</h2>\n          <div ng-if=\"detail.data.Content.vac_core_activities.data\" class=\"detail-content-text\" ng-bind-html=\"detail.data.Content.vac_core_activities.data\"></div>\n        </div>\n      </div>\n      <div class=\"row content\">\n        <div class=\"col-xs-12 rs-text\">\n          <h2 ng-if=\"detail.data.Content.vac_edu_work_exp.data\">{{\'vacancy_page.titles.edu_work_exp\' | translate}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.vac_edu_work_exp.data\" ng-bind-html=\"detail.data.Content.vac_edu_work_exp.data\"></div>\n          <h2 ng-if=\"detail.data.Content.vac_skills.data\">{{\'vacancy_page.titles.skills\' | translate}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.vac_skills.data\" ng-bind-html=\"detail.data.Content.vac_skills.data\"></div>\n          <h2 ng-if=\"detail.data.Content.vac_competences.data\">{{\'vacancy_page.titles.competences\' | translate}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.vac_competences.data\" ng-bind-html=\"detail.data.Content.vac_competences.data\"></div>\n          <h2 ng-if=\"detail.data.Content.vac_other_info.data\">{{\'vacancy_page.titles.other_info\' | translate}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.vac_other_info.data\" ng-bind-html=\"detail.data.Content.vac_other_info.data\"></div>\n          <h2 ng-if=\"detail.data.Content.vac_content_info.data\">{{\'vacancy_page.titles.content_info\' | translate}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.vac_content_info.data\" ng-bind-html=\"detail.data.Content.vac_content_info.data\"></div>\n          <h2 ng-if=\"detail.data.Content.vac_working_conditions_info.data\">{{\'vacancy_page.titles.working_conditions\' | translate}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.vac_working_conditions_info.data\" ng-bind-html=\"detail.data.Content.vac_working_conditions_info.data\"></div>\n          <h2 ng-if=\"detail.data.Content.vac_procedure.data\">{{\'vacancy_page.titles.procedure\' | translate}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.vac_procedure.data\" ng-bind-html=\"detail.data.Content.vac_procedure.data\"></div>\n\n          <p>{{\'vacancyForm.apply_to_vacancy_text\' | translate}}</p>\n        </div>\n      </div>\n\n      <social-sharing></social-sharing>\n\n      <div class=\"row\" ng-if=\"detail.showVacancyForm\">\n        <div class=\"col-md-12\">\n\n          <div class=\"form detail-form\">\n            <form name=\"detail.form\" class=\"clearfix vacancy-form\" novalidate=\"novalidate\">\n              <h2>Reageren</h2>\n              <div class=\"form-group\">\n                <label for=\"vacancy\">{{\'vacancyForm.vacancy\' | translate}}</label>\n                <input id=\"vacancy\" class=\"form-control\" type=\"text\" ng-disabled=\"true\" ng-model=\"detail.data.Content.vac_name.data\">\n              </div>\n\n              <div class=\"form-group\">\n                <div class=\"group-label required\">{{\'vacancyForm.gender\' | translate}}</div>\n                <div class=\"radio\">\n                  <label><input ng-required=\"true\" ng-model=\"detail.candidate.gender\" type=\"radio\" name=\"gender\" value=\"male\"> {{\'gender.male\' | translate}}</label>\n                </div>\n                <div class=\"radio\">\n                  <label><input ng-model=\"detail.candidate.gender\" type=\"radio\" name=\"gender\" value=\"female\"> {{\'gender.female\' | translate}}</label>\n                </div>\n              </div>\n\n              <div class=\"form-group\">\n                <label class=\"required\" for=\"name\">{{\'vacancyForm.name\' | translate}}</label>\n                <input ng-required=\"true\" id=\"name\" class=\"form-control\" type=\"text\" ng-model=\"detail.candidate.name\">\n              </div>\n              <div class=\"form-group\">\n                <label for=\"vacancy_found_at\">{{\'vacancyForm.country\' | translate}}</label>\n                <select class=\"form-control\" id=\"country\" ng-model=\"detail.candidate.country\" ng-options=\"item.label as item.label for item in detail.countries\">\n                </select>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"required\" for=\"street\">{{\'vacancyForm.street\' | translate}}</label>\n                <input ng-required=\"true\" class=\"form-control\" type=\"text\" id=\"street\" ng-model=\"detail.candidate.street\">\n              </div>\n              <div class=\"form-group clearfix\">\n                <label class=\"required\" for=\"houseNumber\">{{\'vacancyForm.house_no_and_addition\' | translate}}</label><br>\n                <div class=\"medium\">\n                  <input ng-required=\"true\" check-number ng-required=\"true\" id=\"houseNumber\" type=\"text\" class=\"form-control\" ng-model=\"detail.candidate.house_no\" placeholder=\"{{\'vacancyForm.house_no_placeholder\' | translate}}\">\n                </div>\n                <div class=\"small\">\n                  <input ng-model=\"detail.candidate.house_no_addition\" type=\"text\" class=\"form-control text-uppercase\" id=\"house-number-addition\" placeholder=\"{{\'vacancyForm.house_no_addition_placeholder\' | translate}}\">\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"required\">{{\'vacancyForm.postal_code\' | translate}}</label><br>\n                <!-- default show NL when not BE or DE just in case -->\n                <input ng-if=\"detail.candidate.country !== \'BE\' && detail.candidate.country !== \'DE\'\" ui-mask=\"9999 AA\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"detail.candidate.postal_code\" placeholder=\"{{\'vacancyForm.postal_code_placeholder\' | translate}}\">\n                <input ng-if=\"detail.candidate.country === \'BE\'\" ui-mask=\"9999\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"detail.candidate.postal_code\" placeholder=\"{{\'vacancyForm.postal_code_placeholder_BE\' | translate}}\">\n                <input ng-if=\"detail.candidate.country === \'DE\'\" ui-mask=\"99999\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" class=\"form-control\" type=\"text\" ng-model=\"detail.candidate.postal_code\" placeholder=\"{{\'vacancyForm.postal_code_placeholder_DE\' | translate}}\">\n              </div>\n              <div class=\"form-group\">\n                <label class=\"required\" for=\"city\">{{\'vacancyForm.city\' | translate}}</label>\n                <input ng-required=\"true\" class=\"form-control\" type=\"text\" id=\"city\" ng-model=\"detail.candidate.city\">\n              </div>\n              <div class=\"form-group\">\n                <label class=\"required\" for=\"email\">{{\'vacancyForm.email\' | translate}}</label>\n                <input ng-required=\"true\" check-email class=\"form-control\" type=\"text\" id=\"email\" ng-model=\"detail.candidate.email\">\n              </div>\n              <div class=\"form-group\">\n                <label class=\"required\" for=\"phone\">{{\'vacancyForm.phone\' | translate}}</label>\n                <input ng-required=\"true\" class=\"form-control\" type=\"text\" id=\"phone\" ng-model=\"detail.candidate.phone\">\n              </div>\n              <div class=\"form-group\">\n                <label for=\"vacancy_found_at\">{{\'vacancyForm.vacancy_found_at\' | translate}}</label>\n                <select class=\"form-control\" id=\"vacancy_found_at\" ng-model=\"detail.candidate.vacancy_found_at\" ng-options=\"item.source as item.source for item in detail.data.Sources\">\n                </select>\n              </div>\n              <div class=\"form-group\">\n                <div ng-required=\"true\" class=\"file-upload btn-custom btn-secondary\" accept=\".pdf,.doc,.docx\" ngf-max-size=\"6MB\" ng-model=\"detail.candidate.motivation_file\" ngf-select=\"detail.readMotivationFile()\">\n                  <i class=\"file-icon fa fa-file-text\"></i> {{\'vacancyForm.add_motivation_btn\' | translate}}\n                </div>\n                <div class=\"error\">{{\'vacancyForm.validation_error.max_size\' | translate}}</div>\n                <span ng-if=\"detail.motivationFileName !== null\">{{detail.motivationFileName | limitTo : 35}}<span ng-if=\"detail.motivationFileName.length > 35\">...</span></span>\n              </div>\n              <div class=\"form-group\">\n                <div ng-required=\"true\" class=\"file-upload btn-custom btn-secondary\" accept=\".pdf,.doc,.docx\" ngf-max-size=\"6MB\" ng-model=\"detail.candidate.resume_file\" ngf-select=\"detail.readResumeFile()\">\n                  <i class=\"file-icon fa fa-file-text\"></i> {{\'vacancyForm.add_cv_btn\' | translate}}\n                </div>\n                <div class=\"error\">{{\'vacancyForm.validation_error.max_size\' | translate}}</div>\n                <span ng-if=\"detail.resumeFileName !== null\"> {{detail.resumeFileName | limitTo : 35}}<span ng-if=\"detail.resumeFileName.length > 35\">...</span></span>\n              </div>\n              <div class=\"form-group\">\n                <label translate=\"vacancyForm.conditions_text\"></label>\n              </div>\n              <div class=\"form-group\">\n                <label for=\"conditions_accepted\"><input ng-required=\"true\" type=\"checkbox\" id=\"conditions_accepted\" ng-model=\"detail.candidate.conditions_accepted\"> {{\'vacancyForm.conditions_accepted\' | translate}}</label>\n              </div>\n              <div class=\"form-group\">\n                <label translate=\"vacancyForm.conditions_revoke\"></label>\n              </div>\n              <div class=\"btn-group pull-right\">\n                <button ng-disabled=\"detail.form.$invalid || detail.sendingData\" class=\"btn-primary btn-custom\" ng-click=\"detail.sendApplicationForm()\">{{\'vacancyForm.send_application_btn\' | translate}}</button>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/vacancy/views/vacancy-list.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"list.data.ListContent.list_title.data\">{{list.data.ListContent.list_title.data}}</h1>\n          <div ng-if=\"list.data.ListContent.list_intro.data\" class=\"intro-text\" ng-bind-html=\"list.data.ListContent.list_intro.data\"></div>\n          <div ng-if=\"list.data.ListContent.list_text.data\" ng-bind-html=\"list.data.ListContent.list_text.data\"></div>\n          <div ng-if=\"list.data.ListContent.list_image.bMediaAvailable && list.data.ListContent.list_image.image.bMediaAvailable\" class=\"list-image\">\n            <img title=\"{{list.data.ListContent.list_image.description}}\" ng-src=\"{{list.data.ListContent.list_image.image.mediaSrc}}\">\n          </div>\n\n          <div class=\"detail-content-video\" ng-if=\"list.data.ListContent.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{list.data.ListContent.video.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{list.data.ListContent.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n        </div>\n      </div>\n      <div class=\"row list-items detail-item\" ng-repeat-start=\"detailItem in list.data.ContentItems\">\n        <div class=\"col-md-12 news-item\">\n          <div ng-if=\"detailItem.block_title.data\" class=\"title\">\n            {{detailItem.block_title.data}}\n          </div>\n          <div class=\"intro\">\n            <span ng-if=\"detailItem.block_date.data\" class=\"date\">{{detailItem.block_date.data}}</span>\n            {{detailItem.block_text.data}}\n          </div>\n          <div class=\"footer\">\n            <span class=\"more\"><a ng-if=\"detailItem.detaillink\" href=\"{{detailItem.detaillink}}\" title=\"{{\'list_page.list_item_read_more\' | translate}}\">{{\'list_page.list_item_read_more\' | translate}}</a></span>\n            <i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>\n          </div>\n        </div>\n      </div>\n      <hr ng-repeat-end>\n    </div>\n  </div>\n</div>\n</div>");
$templateCache.put("app/components/video-list/views/video-list.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"videoList.data.ListContent.list_title.data\">{{videoList.data.ListContent.list_title.data}}</h1>\n          <div ng-if=\"videoList.data.ListContent.list_intro.data\" class=\"intro-text\" ng-bind-html=\"videoList.data.ListContent.list_intro.data\"></div>\n          <div ng-if=\"videoList.data.ListContent.list_text.data\" ng-bind-html=\"videoList.data.ListContent.list_text.data\"></div>\n        </div>\n      </div>\n      <div class=\"row list-items detail-item\" ng-repeat=\"detailItem in videoList.data.ContentItems\">\n        <div class=\"col-md-12 news-item\">\n          <div class=\"detail-content-video\" ng-if=\"detailItem.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detailItem.video.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{detail.data.Content.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <p ng-if=\"detailItem.caption.data\">{{detailItem.caption.data}}</p>\n\n          <p ng-if=\"detailItem.btn_url.data\">\n            <a class=\"btn-custom btn-primary\" href=\"{{detailItem.btn_url.data}}\" target=\"_blank\">\n              <span ng-if=\"detailItem.btn_text.data\">{{detailItem.btn_text.data}}</span>\n              <span ng-if=\"!detailItem.btn_text.data\">{{\'videoList.btnDefaultTxt\' | translate}}</span>\n            </a>\n          </p>\n        </div>\n      </div>\n\n      <div class=\"form detail-form rs-text\">\n        <h2>{{videoList.bottomBlock.title}}</h2>\n        <p>{{videoList.bottomBlock.text}}</p>\n        <button class=\"btn btn-primary btn-custom\" ui-sref=\"dashboard\">{{videoList.bottomBlock.button}}</button>\n      </div>\n\n    </div>\n  </div>\n</div>\n</div>");
$templateCache.put("app/components/water-estafette/views/registration.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n      <div ui-view=\"banners\"></div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"detail.data.Content.title.data\">{{detail.data.Content.title.data}}</h1>\n          <div ng-if=\"detail.data.Content.intro.data\" class=\"intro-text\">{{detail.data.Content.intro.data}}</div>\n          <h2 class=\"page-intro-title\" ng-if=\"detail.data.Content.title_block_1.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_1.data}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.text_block_1.data\" ng-bind-html=\"detail.data.Content.text_block_1.data\"></div>\n        </div>\n      </div>\n      <div class=\"row content\">\n        <div class=\"col-xs-12\">\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_1.bMediaAvailable && detail.data.Content.detail_image_1.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_1.description}}\" ng-src=\"{{detail.data.Content.detail_image_1.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.title_block_2.data || detail.data.Content.text_block_2.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_2.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_2.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_2.data\" ng-bind-html=\"detail.data.Content.text_block_2.data\"></div>\n          </div>\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_2.bMediaAvailable && detail.data.Content.detail_image_2.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_2.description}}\" ng-src=\"{{detail.data.Content.detail_image_2.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.text_block_2_2.data\">\n            <div ng-bind-html=\"detail.data.Content.text_block_2_2.data\"></div>\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video2.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video2.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video2.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.title_block_3.data || detail.data.Content.text_block_3.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_3.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_3.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_3.data\" ng-bind-html=\"detail.data.Content.text_block_3.data\"></div>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_3_left.data || detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Links\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_3_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"detail.data.Content.text_block_3_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Rechts\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video3.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video3.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video3.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_4_left.data || detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Links\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_4_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"detail.data.Content.text_block_4_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Rechts\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n          </div>\n\n\n          <div class=\"row standpipe-form form-wrapper\" ng-if=\"detail.bShowForm\">\n            <div class=\"col-md-12\">\n              <div class=\"form\">\n                <form name=\"detail.form\" class=\"clearfix water-estafette-form\" novalidate=\"novalidate\">\n                  <fieldset>\n                    <legend>{{\'waterEstafette.form.association.title\' | translate}}</legend>\n                    <div class=\"form-group\">\n                      <label for=\"name-association\" class=\"required\">{{\'waterEstafette.form.association.name\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"name-association\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.association.name\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"type\" class=\"required\">{{\'waterEstafette.form.association.type\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"type\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.association.type\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"postal-code\" class=\"required\">{{\'waterEstafette.form.association.postal_code\' | translate}}</label>\n                      <input ui-mask=\"9999 AA\" placeholder=\"{{\'waterEstafette.form.association.placeholder_postal_code\' | translate}}\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder ng-required=\"true\" ng-model=\"detail.formData.association.postal_code\" type=\"text\" class=\"form-control text-uppercase\" id=\"postal-code\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"city\" class=\"required\">{{\'waterEstafette.form.association.city\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"city\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.association.city\">\n                    </div>\n\n                  </fieldset>\n                  <fieldset>\n                    <legend>{{\'waterEstafette.form.contact.title\' | translate}}</legend>\n\n                    <div class=\"form-group\">\n                      <label for=\"name-contact\" class=\"required\">{{\'waterEstafette.form.contact.name\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"name-contact\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.contact.name\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"email\" class=\"required\">{{\'waterEstafette.form.contact.email\' | translate}}</label>\n                      <input check-email ng-required=\"true\" aria-required=\"true\" id=\"email\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.contact.email\">\n                    </div>\n\n                    <div class=\"form-group\">\n                      <label for=\"phone\" class=\"required\">{{\'waterEstafette.form.contact.phone\' | translate}}</label>\n                      <input ng-required=\"true\" aria-required=\"true\" id=\"phone\" class=\"form-control\" type=\"text\" ng-model=\"detail.formData.contact.phone\">\n                    </div>\n\n                    </fieldset>\n                    <fieldset>\n                      <legend>{{\'waterEstafette.form.competitors.title\' | translate}}</legend>\n                      <div class=\"error\" ng-if=\"detail.bShowNumberOfPersonsError\" translate=\"waterEstafette.form.competitors.number_of_persons_error\"></div>\n\n                      <div class=\"form-group competitor-block clearfix\" ng-repeat=\"item in detail.formData.competitors\">\n                        <div class=\"medium\">\n                          <label class=\"required\">{{\'waterEstafette.form.competitors.type\' | translate}}</label>\n                          <select class=\"form-control\" ng-required=\"true\" ng-disabled=\"$index === 0 || $index === 1\" ng-model=\"detail.formData.competitors[$index].type\" ng-options=\"type.value as type.label for type in detail.types\">\n                          </select>\n                        </div>\n                        <div class=\"medium\">\n                          <label class=\"required\">{{\'waterEstafette.form.competitors.count\' | translate}}</label>\n                          <select class=\"form-control\" ng-required=\"true\" ng-model=\"detail.formData.competitors[$index].number_of_persons\" ng-options=\"number for number in detail.personsOptions\">\n                          </select>\n                        </div>\n                        <div class=\"medium last\">\n                          <label class=\"required\">{{\'waterEstafette.form.competitors.distance\' | translate}}</label>\n                          <select class=\"form-control\" ng-required=\"true\" ng-disabled=\"!detail.formData.competitors[$index].type || $index === 0\" ng-model=\"detail.formData.competitors[$index].distance\" ng-options=\"distance for distance in detail.distances[detail.formData.competitors[$index].type]\">\n                          </select>\n\n                        </div>\n                        <i ng-if=\"$index > 1\" class=\"fa fa-times delete-row\" ng-click=\"detail.removeRow($index)\"></i>\n                      </div>\n                      <a class=\"btn-primary btn-custom\" ng-click=\"detail.addCompetitor()\">\n                        {{\'waterEstafette.form.competitors.add_competitor\' | translate}}\n                      </a>\n                  </fieldset>\n                  <div class=\"btn-group pull-right\">\n                    <button ng-disabled=\"detail.form.$invalid || detail.sendingData\" class=\"btn-primary btn-custom\" ng-click=\"detail.send()\">{{\'waterEstafette.form.btn_send\' | translate}}</button>\n                  </div>\n                </form>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form detail-form\">\n            <h2>{{detail.bottomBlock.title}}</h2>\n            <p>{{detail.bottomBlock.text}}</p>\n            <button class=\"btn btn-primary btn-custom\" ui-sref=\"dashboard\">{{detail.bottomBlock.button}}</button>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/water-estafette/views/vote.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n      <div ui-view=\"banners\"></div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"detail.data.Content.title.data\">{{detail.data.Content.title.data}}</h1>\n          <div ng-if=\"detail.data.Content.intro.data\" class=\"intro-text\">{{detail.data.Content.intro.data}}</div>\n          <h2 class=\"page-intro-title\" ng-if=\"detail.data.Content.title_block_1.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_1.data}}</h2>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.text_block_1.data\" ng-bind-html=\"detail.data.Content.text_block_1.data\"></div>\n        </div>\n      </div>\n      <div class=\"row content\">\n        <div class=\"col-xs-12\">\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_1.bMediaAvailable && detail.data.Content.detail_image_1.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_1.description}}\" ng-src=\"{{detail.data.Content.detail_image_1.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.title_block_2.data || detail.data.Content.text_block_2.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_2.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_2.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_2.data\" ng-bind-html=\"detail.data.Content.text_block_2.data\"></div>\n          </div>\n          <div class=\"detail-content-image\" ng-if=\"detail.data.Content.detail_image_2.bMediaAvailable && detail.data.Content.detail_image_2.image.bMediaAvailable\">\n            <img alt=\"{{detail.data.Content.detail_image_2.description}}\" ng-src=\"{{detail.data.Content.detail_image_2.image.mediaSrc}}\">\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.text_block_2_2.data\">\n            <div ng-bind-html=\"detail.data.Content.text_block_2_2.data\"></div>\n          </div>\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video2.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video2.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video2.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"detail-content-text\" ng-if=\"detail.data.Content.title_block_3.data || detail.data.Content.text_block_3.data\">\n            <h2 ng-if=\"detail.data.Content.title_block_3.data\" class=\"paragraph-title\">{{detail.data.Content.title_block_3.data}}</h2>\n            <div ng-if=\"detail.data.Content.text_block_3.data\" ng-bind-html=\"detail.data.Content.text_block_3.data\"></div>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_3_left.data || detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Links\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_3_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"detail.data.Content.text_block_3_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb.index === \'Rechts\' && detail.data.Content.detail_image_3.bMediaAvailable && detail.data.Content.detail_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_3.description}}\" ng-src=\"{{detail.data.Content.detail_image_3.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"detail-content-video\" ng-if=\"detail.data.Content.video3.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{detail.data.Content.video3.data}}\" controls=\"0\"><a ng-href=\"{{detail.data.Content.video3.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <div class=\"detail-content-and-image row\" ng-if=\"detail.data.Content.text_block_4_left.data || detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Links\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.text_block_4_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"detail.data.Content.text_block_4_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"detail.data.Content.pos_afb1.index === \'Rechts\' && detail.data.Content.detail_image_4.bMediaAvailable && detail.data.Content.detail_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{detail.data.Content.detail_image_4.description}}\" ng-src=\"{{detail.data.Content.detail_image_4.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"detail-content-text\" ng-if=\"!detail.bShowForm\">\n            <div><h2 class=\"paragraph-title\">{{\'waterEstafette.vote_form.already_voted\' | translate}}</h2></div>\n          </div>\n\n          <div class=\"row standpipe-form form-wrapper\" ng-if=\"detail.bShowForm\">\n            <div class=\"col-md-12\">\n              <div class=\"form\">\n                <form name=\"detail.form\" class=\"clearfix water-estafette-form\" novalidate=\"novalidate\">\n                  <fieldset>\n                    <legend>{{\'waterEstafette.vote_form.title\' | translate}}</legend>\n                    <div class=\"form-group\">\n                      <label for=\"cities\" class=\"required\">{{\'waterEstafette.vote_form.city\' | translate}}</label>\n                      <select ng-change=\"detail.getRegistrations()\" id=\"cities\" class=\"form-control\" ng-required=\"true\" ng-model=\"detail.selectedCity\" ng-options=\"city for city in detail.cities\"></select>\n                    </div>\n                    <div class=\"form-group\">\n                      <label for=\"registrations\" class=\"required\">{{\'waterEstafette.vote_form.registrations\' | translate}}</label>\n                      <select id=\"registrations\" ng-disabled=\"!detail.registrations.length\" class=\"form-control\" ng-required=\"true\" ng-model=\"detail.formData.id\" ng-options=\"registration.id as registration.association.name for registration in detail.registrations\"></select>\n                    </div>\n                  </fieldset>\n                  <div class=\"btn-group pull-right\">\n                    <button ng-disabled=\"detail.form.$invalid || detail.sendingData\" class=\"btn-primary btn-custom\" ng-click=\"detail.send()\">{{\'waterEstafette.vote_form.btn_send\' | translate}}</button>\n                  </div>\n                </form>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form detail-form\">\n            <h2>{{detail.bottomBlock.title}}</h2>\n            <p>{{detail.bottomBlock.text}}</p>\n            <button class=\"btn btn-primary btn-custom\" ui-sref=\"dashboard\">{{detail.bottomBlock.button}}</button>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/waterhardheid/views/waterhardheid.view.html","<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-3\">\n      <div ui-view=\"sideMenu\">\n      </div>\n      <div ui-view=\"banners\"></div>\n    </div>\n    <div class=\"col-md-8 col-md-offset-1 content\">\n      <div class=\"page-intro row\">\n        <div class=\"col-xs-12\">\n          <h1 ng-if=\"waterhardheid.data.Content.title.data\">{{waterhardheid.data.Content.title.data}}</h1>\n          <div ng-if=\"waterhardheid.data.Content.intro.data\" class=\"intro-text\">{{waterhardheid.data.Content.intro.data}}</div>\n          <h2 class=\"page-intro-title paragraph-title\" ng-if=\"waterhardheid.data.Content.title_block_1.data\">{{waterhardheid.data.Content.title_block_1.data}}</h2>\n          <div class=\"waterhardheid-content-text\" ng-if=\"waterhardheid.data.Content.text_block_1.data\" ng-bind-html=\"waterhardheid.data.Content.text_block_1.data\"></div>\n        </div>\n      </div>\n      <div class=\"row content\">\n        <div class=\"col-xs-12\">\n          <div class=\"waterhardheid-content-image\" ng-if=\"waterhardheid.data.Content.waterhardheid_image_1.bMediaAvailable && waterhardheid.data.Content.waterhardheid_image_1.image.bMediaAvailable\">\n            <img alt=\"{{waterhardheid.data.Content.waterhardheid_image_1.description}}\" ng-src=\"{{waterhardheid.data.Content.waterhardheid_image_1.image.mediaSrc}}\">\n          </div>\n          <div class=\"waterhardheid-content-video\" ng-if=\"waterhardheid.data.Content.video.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{waterhardheid.data.Content.video.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{waterhardheid.data.Content.video.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"waterhardheid-content-text\" ng-if=\"waterhardheid.data.Content.title_block_2.data || waterhardheid.data.Content.text_block_2.data\">\n            <h2 ng-if=\"waterhardheid.data.Content.title_block_2.data\" class=\"paragraph-title\">{{waterhardheid.data.Content.title_block_2.data}}</h2>\n            <div ng-if=\"waterhardheid.data.Content.text_block_2.data\" ng-bind-html=\"waterhardheid.data.Content.text_block_2.data\"></div>\n          </div>\n          <div class=\"waterhardheid-content-image\" ng-if=\"waterhardheid.data.Content.waterhardheid_image_2.bMediaAvailable && waterhardheid.data.Content.waterhardheid_image_2.image.bMediaAvailable\">\n            <img alt=\"{{waterhardheid.data.Content.waterhardheid_image_2.description}}\" ng-src=\"{{waterhardheid.data.Content.waterhardheid_image_2.image.mediaSrc}}\">\n          </div>\n          <div class=\"waterhardheid-content-text\" ng-if=\"waterhardheid.data.Content.text_block_2_2.data\">\n            <div ng-bind-html=\"waterhardheid.data.Content.text_block_2_2.data\"></div>\n          </div>\n          <div class=\"waterhardheid-content-video\" ng-if=\"waterhardheid.data.Content.video2.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{waterhardheid.data.Content.video2.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{waterhardheid.data.Content.video2.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n          <div class=\"waterhardheid-content-text\" ng-if=\"waterhardheid.data.Content.title_block_3.data || waterhardheid.data.Content.text_block_3.data\">\n            <h2 ng-if=\"waterhardheid.data.Content.title_block_3.data\" class=\"paragraph-title\">{{waterhardheid.data.Content.title_block_3.data}}</h2>\n            <div ng-if=\"waterhardheid.data.Content.text_block_3.data\" ng-bind-html=\"waterhardheid.data.Content.text_block_3.data\"></div>\n          </div>\n\n          <div class=\"waterhardheid-content-and-image row\" ng-if=\"waterhardheid.data.Content.text_block_3_left.data || waterhardheid.data.Content.waterhardheid_image_3.bMediaAvailable && waterhardheid.data.Content.waterhardheid_image_3.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"waterhardheid.data.Content.pos_afb.index === \'Links\' && waterhardheid.data.Content.waterhardheid_image_3.bMediaAvailable && waterhardheid.data.Content.waterhardheid_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{waterhardheid.data.Content.waterhardheid_image_3.description}}\" ng-src=\"{{waterhardheid.data.Content.waterhardheid_image_3.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"waterhardheid.data.Content.text_block_3_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"waterhardheid.data.Content.text_block_3_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"waterhardheid.data.Content.pos_afb.index === \'Rechts\' && waterhardheid.data.Content.waterhardheid_image_3.bMediaAvailable && waterhardheid.data.Content.waterhardheid_image_3.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{waterhardheid.data.Content.waterhardheid_image_3.description}}\" ng-src=\"{{waterhardheid.data.Content.waterhardheid_image_3.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"waterhardheid-content-video\" ng-if=\"waterhardheid.data.Content.video3.data\">\n            <embed-video force-protocol=\"https\" data-ng-href=\"{{waterhardheid.data.Content.video3.data}}\" controls=\"0\"><a title=\"{{\'detail_page.view_video\' | translate}}\" ng-href=\"{{waterhardheid.data.Content.video3.data}}\">{{\'detail_page.view_video\' | translate}}</a></embed-video>\n          </div>\n\n          <div class=\"waterhardheid-content-and-image row\" ng-if=\"waterhardheid.data.Content.text_block_4_left.data || waterhardheid.data.Content.waterhardheid_image_4.bMediaAvailable && waterhardheid.data.Content.waterhardheid_image_4.image.bMediaAvailable\">\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"waterhardheid.data.Content.pos_afb1.index === \'Links\' && waterhardheid.data.Content.waterhardheid_image_4.bMediaAvailable && waterhardheid.data.Content.waterhardheid_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{waterhardheid.data.Content.waterhardheid_image_4.description}}\" ng-src=\"{{waterhardheid.data.Content.waterhardheid_image_4.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"waterhardheid.data.Content.text_block_4_left.data\">\n              <div class=\"image-aside-text\" ng-bind-html=\"waterhardheid.data.Content.text_block_4_left.data\"></div>\n            </div>\n            <div class=\"col-md-6 col-sm-6\" ng-if=\"waterhardheid.data.Content.pos_afb1.index === \'Rechts\' && waterhardheid.data.Content.waterhardheid_image_4.bMediaAvailable && waterhardheid.data.Content.waterhardheid_image_4.image.bMediaAvailable\">\n              <img class=\"image-aside\" alt=\"{{waterhardheid.data.Content.waterhardheid_image_4.description}}\" ng-src=\"{{waterhardheid.data.Content.waterhardheid_image_4.image.mediaSrc}}\">\n            </div>\n          </div>\n\n          <div class=\"row list-items news-item\" ng-if=\"waterhardheid.data.naviagtionChilds && waterhardheid.data.naviagtionChilds.length > 0\" ng-repeat-start=\"waterhardheidItem in waterhardheid.data.naviagtionChilds\">\n            <div class=\"col-md-4 col-sm-4 list-image\">\n              <img ng-if=\"waterhardheidItem.Content.intro_image.bMediaAvailable && waterhardheidItem.Content.intro_image.image.bMediaAvailable\" title=\"{{waterhardheidItem.Content.intro_image.description}}\" ng-src=\"{{waterhardheidItem.Content.intro_image.image.mediaSrc}}\">\n            </div>\n            <div class=\"col-md-8 col-sm-8 list-item\">\n              <div ng-if=\"waterhardheidItem.Content.intro_title.data\" class=\"title\">\n                {{waterhardheidItem.Content.intro_title.data}}\n              </div>\n              <div class=\"intro\">\n                {{waterhardheidItem.Content.intro_text.data}}\n              </div>\n              <div class=\"footer\">\n                <span ng-if=\"waterhardheidItem.CurrentUrl\">\n                  <span class=\"more\"><a href=\"{{waterhardheidItem.CurrentUrl}}\" title=\"{{waterhardheidItem.Content.intro_title.data}}\">{{\'detail_page.read_more\' | translate}}</a></span>\n                  <i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>\n                </span>\n              </div>\n            </div>\n          </div>\n          <hr ng-repeat-end>\n\n          <div class=\"form detail-form\">\n            <div class=\"row\">\n              <div class=\"col-md-6\">\n                <form name=\"waterhardheid.form\" ng-submit=\"waterhardheid.getHardness()\">\n                  <div class=\"form-group\">\n                    <label for=\"postal_code\" class=\"required\">{{\'waterhardheid.postal_code\' | translate}}</label><br>\n                    <input ng-required=\"true\" ui-mask=\"9999 AA\" ui-options=\"{clearOnBlur:false}\" ui-mask-placeholder id=\"postal_code\" ng-model=\"waterhardheid.form.postal_code\" class=\"form-control text-uppercase\" type=\"text\" placeholder=\"{{\'waterhardheid.postal_code_placeholder\' | translate}}\">\n                  </div>\n                  <div class=\"form-group clearfix\">\n                    <label for=\"house_no\" class=\"required\">{{\'waterhardheid.house_no\' | translate}}</label><br>\n                    <input ng-required=\"true\" id=\"house_no\" ng-model=\"waterhardheid.form.house_no\" class=\"form-control\" type=\"text\" placeholder=\"{{\'waterhardheid.house_no_placeholder\' | translate}}\">\n                  </div>\n                  <div class=\"form-group\">\n                    <input ng-disabled=\"waterhardheid.form.$invalid\" type=\"submit\" class=\"btn-custom btn-primary\" value=\"{{\'waterhardheid.submit\' | translate}}\">\n                  </div>\n                </form>\n              </div>\n              <div class=\"col-md-6\">\n                <div ng-if=\"waterhardheid.hardness !== null && waterhardheid.hardness !== false\">\n                  <div class=\"water-hardness-number\">\n                    <p ng-if=\"waterhardheid.hardness\">{{waterhardheid.hardness}}</p>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n          </div>\n          <div ng-if=\"waterhardheid.hardness !== null\" class=\"form hardness-message\">\n            <div ng-if=\"waterhardheid.hardness === false\" class=\"message-wrapper error\">\n              <strong ng-if=\"waterhardheid.data.Content.hardness_not_found.data\">{{waterhardheid.data.Content.hardness_not_found.data}}</strong>\n            </div>\n            <div ng-if=\"waterhardheid.data.Content.hardness_info.data\" ng-bind-html=\"waterhardheid.data.Content.hardness_info.data\"></div>\n          </div>\n          <div class=\"form detail-form\">\n            <h2>{{waterhardheid.bottomBlock.title}}</h2>\n            <p>{{waterhardheid.bottomBlock.text}}</p>\n            <button class=\"btn btn-primary btn-custom\" ui-sref=\"dashboard\">{{waterhardheid.bottomBlock.button}}</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/detail-page/views/partials/photo-subnav.view.html","<div ng-if=\"detail.photoSubNav.length > 0\">\n  <div class=\"row\" ng-repeat=\"photoNavItemRow in detail.photoSubNav\">\n    <div class=\"col-xs-12\" ng-class=\"{\'col-md-4\': detail.data.Content.photo_nav_columns.index === \'3\', \'col-md-6\': detail.data.Content.photo_nav_columns.index === \'2\' }\" ng-repeat=\"photoNavItem in photoNavItemRow\">\n      <a class=\"photo-nav-item\" ng-class=\"{ small: detail.data.Content.photo_nav_columns.index === \'3\' }\" ng-href=\"{{photoNavItem.link}}\">\n        <img alt=\"{{photoNavItem.title}}\" ng-src=\"{{photoNavItem.image}}\">\n        <span class=\"photo-nav-item-title\">{{photoNavItem.title}}</span>\n      </a>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/header/views/partials/slide.html","<div class=\"image\" ng-transclude></div>\n");
$templateCache.put("app/components/header/views/partials/slideshow.html","<div class=\"carousel-inner\" ng-transclude></div>\n<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n  <span aria-hidden=\"true\" class=\"slideshow-button button-prev\"><i class=\"fa fa-chevron-left\"></i></span>\n</a>\n<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n  <span aria-hidden=\"true\" class=\"slideshow-button button-next\"><i class=\"fa fa-chevron-right\"></i></span>\n</a>\n");
$templateCache.put("app/components/header/views/partials/topbar.html","<div class=\"topbar\">\n  <div class=\"container\">\n    <div class=\"logo\">\n      <a title=\"{{ \'header.nav.home\' | translate }}\" ui-sref=\"home\"></a>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <nav>\n          <ul class=\"nav navbar-nav user-nav\" ng-if=\"header.bAuthenticated\">\n            <li class=\"dropdown\">\n              <div class=\"dropdown-toggle\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">\n                <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\n                <span>{{header.currentCustomer.name | limitTo : 35}} <span ng-if=\"header.currentCustomer.name.length > 35\">...</span></span>\n              </div>\n              <ul class=\"dropdown-menu\">\n                <li>\n                  <a ui-sref=\"dashboard\">MijnWML</a>\n                </li>\n                <li class=\"divider\"></li>\n                <li ng-if=\"header.customers.length > 1\">\n                  <a ui-sref=\"accountOptions\">{{\'header.nav.account_options\' | translate}}</a>\n                </li>\n                <li ng-if=\"header.customers.length > 1\" class=\"divider\"></li>\n                <li ng-if=\"header.bCorporation\">\n                  <a ui-sref=\"chooseAddress\">{{\'header.nav.choose_address\' | translate}}</a>\n                </li>\n                <li ng-if=\"header.bCorporation\" class=\"divider\"></li>\n                <li>\n                  <a ui-sref=\"profile\">{{\'header.nav.profile\' | translate}}</a>\n                </li>\n\n\n              </ul>\n            </li>\n          </ul>\n          <button ng-if=\"header.bAuthenticated\" ng-click=\"header.logout()\" type=\"button\" class=\"btn-custom btn-cancel btn-logout hidden-xs\" title=\"{{ \'header.nav.logout\' | translate }}\">{{ \'header.nav.logout\' | translate }}</button>\n          <a ng-if=\"!header.bAuthenticated\" class=\"btn-custom btn-primary\" ui-sref=\"login\" title=\"{{ \'header.nav.login\' | translate }}\">{{ \'header.nav.login\' | translate }}</a>\n          <a ng-if=\"!header.bAuthenticated\" ui-sref=\"sign-up\" class=\"btn-link\" title=\"{{ \'header.nav.sign_up\' | translate }}\">{{ \'header.nav.sign_up\' | translate }}</a>\n\n          <!--<span class=\"headerlinks pull-right\">-->\n            <!--<a ui-sref=\"home\">English</a>-->\n            <!--<span class=\"stripe\">|</span>-->\n            <!--<a class=\"fontsize\" ui-sref=\"home\">-->\n              <!--<span class=\"small current\">A</span>-->\n              <!--<span class=\"medium\">A</span>-->\n              <!--<span class=\"large\">A</span>-->\n            <!--</a>-->\n          <!--</span>-->\n        </nav>\n      </div>\n    </div>\n  </div>\n  <div class=\"homepage-nav visible-xs visible-sm\" ng-if=\"!header.bAuthenticated || header.isInsecureState\">\n    <nav role=\"navigation\">\n      <div class=\"container\">\n        <div type=\"button\" class=\"pull-left visible-xs visible-sm\" ng-click=\"header.isNavCollapsed = !header.isNavCollapsed\">\n          <i class=\"fa fa-bars\"></i>\n        </div>\n        <div type=\"button\" class=\"pull-left visible-xs visible-sm mobile-search-icon\" ng-click=\"header.isSearchCollapsed = !header.isSearchCollapsed\">\n          <i class=\"fa fa-search\"></i>\n        </div>\n      </div>\n      <div class=\"mobile-dropdown-menu search-dropdown\" uib-collapse=\"header.isSearchCollapsed\">\n        <div class=\"container\">\n          <div class=\"col-xs-12\">\n            <form name=\"header.searchForm\" ng-model-options=\"$root.ngModelOptions\" novalidate=\"novalidate\" class=\"mobile-search-form search-form clearfix\" ng-submit=\"header.search()\">\n              <div class=\"search-box\">\n                <input ng-model=\"header.searchQuery\" class=\"form-control\" name=\"q\" value=\"\" placeholder=\"{{\'search.placeholder\' | translate}}\">\n                <i class=\"fa fa-search\" role=\"button\" aria-hidden=\"true\" ng-click=\"header.search()\"></i>\n              </div>\n            </form>\n          </div>\n        </div>\n      </div>\n      <div class=\"mobile-dropdown-menu\" uib-collapse=\"header.isNavCollapsed\">\n        <div class=\"container-fluid\">\n          <div class=\"row\">\n            <ul>\n              <li><div class=\"container\"><div class=\"col-xs-12\"><a ui-sref=\"home\" title=\"{{ \'header.nav.home\' | translate }}\">{{ \'header.nav.home\' | translate }}</a></div></div></li>\n              <li ng-repeat=\"item in header.getMenuItems() |orderBy:\'sort_value\'\">\n                <div class=\"container\">\n                  <div class=\"col-xs-12\">\n                    <a ng-if=\"item.type !== \'iLink\'\" ng-class=\"{\'current\': item.active}\" ui-sref=\"{{item.name}}\" title=\"{{item.label}}\">{{item.label}}</a>\n                    <a ng-if=\"item.type === \'iLink\'\" ng-class=\"{\'current\': item.active}\" href=\"{{item.url}}\" target=\"_blank\" title=\"{{item.label}}\">{{item.label}}</a>\n                  </div>\n                </div>\n              </li>\n              <li ng-if=\"header.bAuthenticated\" class=\"logout-menu-item visible-xs\"><div class=\"container\"><div class=\"col-xs-12\"><a ng-click=\"header.logout()\" title=\"{{ \'header.nav.logout\' | translate }}\">{{ \'header.nav.logout\' | translate }}</a></div></div></li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </nav>\n  </div>\n</div>\n");
$templateCache.put("app/components/header/views/partials/video.modal.partial.html","<div class=\"modal-body\" id=\"modal-body\">\n  <div class=\"video-close-wrapper\">\n\n    <button type=\"button\" ng-click=\"modal.videoModal.close()\" class=\"video-close close lg-close\">\n      <span class=\"fa fa-times\"></span>\n    </button>\n  </div>\n  <embed-video width=\"868\" height=\"488\" force-protocol=\"https\" data-ng-href=\"{{videoUrl}}\" controls=\"0\"><a ng-href=\"{{videoUrl}}\">{{\'header.video_modal.view_video\' | translate}}</a></embed-video>\n</div>\n");
$templateCache.put("app/components/meter-readings/directives/views/meter-image.view.html","<div class=\"row\">\n  <div class=\"meter-image-container\">\n    <div class=\"col-xs-12 col-sm-6\">\n      <p class=\"customer-label\">{{ \'usage.meter_readings.meter_vik\' | translate}}</p>\n      <img class=\"img-responsive\" src=\"/app/images/dynamic-meter-images/watermeter_vik_overnemen.png\">\n    </div>\n    <div class=\"col-xs-12 col-sm-6\">\n      <p class=\"customer-label\">{{ \'usage.meter_readings.meter_vi\' | translate}}</p>\n      <img class=\"img-responsive\" src=\"/app/images/dynamic-meter-images/watermeter_vi_overnemen.png\">\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/generic/directives/loader/views/overlay.html","<div ng-show=\"$root.loading\" class=\"block-overlay\">\n  <div class=\"spinner\"></div>\n</div>\n");
$templateCache.put("app/components/generic/directives/readspeaker/views/readspeaker-form.html","<div class=\"formReadSpeaker\">\n  <div class=\"fr_button\" id=\"fr_button\"><a class=\"fr_play_button\" rel=\"nofollow\" href=\"//app-eu.readspeaker.com/enterprise/rsent_wrapper.php?mp3bitrate=32&dict=forms&customerid=10393&lang=nl_nl&url={{currentLocation}}&output=audio&cookieStart=0\" style=\"text-decoration: none\" onclick=\"toggleActive(\'Vul het formulier in\', document.getElementById(\'fr_activator\'),this); return false\"> <img id=\"fr_listenicon\" src=\"//f1-eu.readspeaker.com/graphic/default/buttons/icon_16px.gif\" border=\"0\" align=\"baseline\"> <span id=\"fr_activator\" style=\"font-family: Tahoma; font-size: 14px; color: #039\">Starten</span></a>\n  </div>\n</div>\n<!--<a ng-click=\"toggleReadspeaker()\" title=\"Lees voor\" href=\"\" id=\"readspeak-form\" class=\"dot reader\"><i class=\"fa\" ng-class=\"{\'fa-volume-up\': !isPlaying, \'fa-volume-off\': isPlaying}\" aria-hidden=\"true\"></i></a>-->\n");
$templateCache.put("app/components/generic/directives/readspeaker/views/readspeaker-text.html","<div id=\"readspeaker_button1\" class=\"rs_skip rsbtn rs_preserve\">\n  <a rel=\"nofollow\" class=\"rsbtn_play\" accesskey=\"L\" title=\"Laat de tekst voorlezen met ReadSpeaker webReader\" href=\"//app-eu.readspeaker.com/cgi-bin/rsent?customerid=10393&amp;lang=nl_nl&amp;readclass={{readClass}}&amp;url={{currentLocation}}\">\n    <span class=\"rsbtn_left rsimg rspart\"><span class=\"rsbtn_text\"><span>Lees voor</span></span></span>\n    <span class=\"rsbtn_right rsimg rsplay rspart\"></span>\n  </a>\n</div>\n\n<!--<a ng-click=\"toggleReadspeaker()\" title=\"Lees voor\" href=\"\" id=\"readspeak\" class=\"dot reader\"><i class=\"fa\" ng-class=\"{\'fa-volume-up\': !isPlaying, \'fa-volume-off\': isPlaying}\" aria-hidden=\"true\"></i></a>-->\n");
$templateCache.put("app/components/generic/directives/password/views/password.view.html","<div>\n  <div class=\"password-container\">\n    <input id=\"{{id}}\" ng-model=\"password\" type=\"{{showPassword ? \'text\' : \'password\'}}\" placeholder=\"{{placeholder | translate}}\" ng-focus=\"passwordActive = true\" ng-blur=\"passwordActive = false\">\n\n    <a class=\"toggle-btn\" ng-click=\"toggleVisibility($event)\">\n      <i ng-class=\"{\'fa fa-eye\': !showPassword, \'fa fa-eye-slash\': showPassword }\" aria-hidden=\"true\"></i>\n    </a>\n  </div>\n\n  <password-validation-indicator ng-show=\"validate && passwordActive\" password=\"password\"></password-validation-indicator>\n</div>\n");
$templateCache.put("app/components/generic/directives/unavailable/views/overlay.html","<div ng-show=\"$root.unavailable\" class=\"block-overlay\">\n  <div class=\"unavailable\">\n    <img src=\"/app/images/broken.png\">\n    <h1>{{\'overlay.unavailable.title\' | translate}}</h1>\n    <div translate=\"overlay.unavailable.text\"></div>\n    <a class=\"btn-link\" href=\"https://twitter.com/wmlwater\">{{\'overlay.unavailable.link\' | translate}}</a>\n  </div>\n</div>\n");
$templateCache.put("app/components/generic/directives/password-validator/views/password-validation-indicator.view.html","<div class=\"form-group\">\n  <div><i class=\"fa\" ng-class=\"{\'fa-check icon-success\': validated.minLength, \'fa-times icon-danger\': !validated.minLength}\"></i> {{labels.minLength}}</div>\n  <div><i class=\"fa\" ng-class=\"{\'fa-check icon-success\': validated.minCaps, \'fa-times icon-danger\': !validated.minCaps}\"></i> {{labels.minCaps}}</div>\n  <div><i class=\"fa\" ng-class=\"{\'fa-check icon-success\': validated.minLowercase, \'fa-times icon-danger\': !validated.minLowercase}\"></i> {{labels.minLowercase}}</div>\n  <div><i class=\"fa\" ng-class=\"{\'fa-check icon-success\': validated.minNumbers, \'fa-times icon-danger\': !validated.minNumbers}\"></i> {{labels.minNumbers}}</div>\n  <div><i class=\"fa\" ng-class=\"{\'fa-check icon-success\': validated.minSpecialChars, \'fa-times icon-danger\': !validated.minSpecialChars}\"></i> {{labels.minSpecialChars}}</div>\n</div>\n");
$templateCache.put("app/components/generic/directives/social/views/social-buttons.html","<div class=\"social form detail-form\">\n  <div class=\"social-text\">{{\'social.share_page\' | translate}}</div>\n  <a class=\"social-button\" href=\"#\" socialshare socialshare-provider=\"facebook\" socialshare-url=\"{{currentUrl}}\">\n    <i class=\"fa fa-facebook\" aria-hidden=\"true\"></i>\n  </a>\n  <a class=\"social-button\" href=\"#\" socialshare socialshare-provider=\"twitter\">\n    <i class=\"fa fa-twitter\" aria-hidden=\"true\"></i>\n  </a>\n  <a class=\"social-button\" href=\"#\" socialshare socialshare-provider=\"linkedin\">\n    <i class=\"fa fa-linkedin\" aria-hidden=\"true\"></i>\n  </a>\n</div>\n");}]);